import * as i3 from '@angular/common';
import { CommonModule, DOCUMENT, isPlatformServer, isPlatformBrowser } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Directive, Input, HostBinding, HostListener, EventEmitter, Output, inject, ElementRef, Renderer2, NgModule, Inject, isDevMode, Component, ApplicationRef, Injector, PLATFORM_ID, ComponentFactory, TemplateRef, InjectionToken, APP_INITIALIZER, Optional, ComponentFactoryResolver, SecurityContext, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, Pipe, HostAttributeToken, forwardRef, ContentChild, APP_BOOTSTRAP_LISTENER, DestroyRef, ViewContainerRef, ViewChildren } from '@angular/core';
import * as i1 from '@spartacus/core';
import { WindowRef, Priority, Config, LoggerService, resolveApplicable, useFeatureStyles, isNotNullable, DeferLoadingStrategy, MODULE_INITIALIZER, provideDefaultConfig, FeatureConfigService, ANONYMOUS_CONSENT_STATUS, GlobalMessageType, GlobalMessageService, I18nModule, FeaturesConfigModule, wrapIntoObservable, isNotUndefined, ConfigChunk, DefaultConfigChunk, deepMerge, CxEvent, getLastValueSync, PageType, RouteLoadStrategy, FeatureToggles, provideDefaultConfigFactory, ProtectedRoutesGuard, RoutingModule as RoutingModule$1, LanguageService, ProductScope, provideConfig, ConfigModule, AuthGuard, UrlModule, isObject, SiteThemeService, THEME_CONTEXT_ID, TranslationService, LANGUAGE_CONTEXT_ID, CURRENCY_CONTEXT_ID, SiteContextModule, ContextServiceMap, SiteThemeModule, ContainerBackgroundOptions, CustomerCouponService, RoutingService, PageMetaModule, ProductActions, EMAIL_PATTERN, SECURE_PASSWORD_PATTERN, STRONG_PASSWORD_PATTERN, MIN_ONE_UPPER_CASE_CHARACTER_PATTERN, MIN_ONE_DIGIT_PATTERN, MIN_ONE_SPECIAL_CHARACTER_PATTERN, MIN_SIX_CHARACTERS_PATTERN, MIN_EIGHT_CHARACTERS_PATTERN, MAX_CHARACTERS_PATTERN, CONSECUTIVE_CHARACTERS, ScrollBehavior, ProductSearchByCodeService, ProductSearchByCategoryService, OCC_USER_ID_ANONYMOUS, NotificationType, OAuthFlow, UrlMatcherService, DEFAULT_URL_MATCHER, createFrom, BaseCoreModule } from '@spartacus/core';
import { BehaviorSubject, combineLatest, Subscription, of, Observable, ReplaySubject, Subject, switchMap, distinctUntilChanged as distinctUntilChanged$1, shareReplay, first as first$1, concat, skipWhile, endWith, defer, EMPTY, forkJoin, from, debounceTime, map as map$1, lastValueFrom, tap as tap$1, merge, filter as filter$1, take as take$1, timer, using, asapScheduler, interval, zip } from 'rxjs';
import { filter, tap, map, take, first, mergeMap, distinctUntilChanged, shareReplay as shareReplay$1, switchMap as switchMap$1, share, startWith, finalize, withLatestFrom, skipWhile as skipWhile$1, scan, delayWhen, concatMap, debounceTime as debounceTime$1, catchError, skip, observeOn, pairwise } from 'rxjs/operators';
import { __decorate, __param } from 'tslib';
import * as i1$1 from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import * as i1$2 from '@angular/router';
import { Router, NavigationStart, RouterModule, NavigationEnd, ROUTER_CONFIGURATION, Scroll, EventType } from '@angular/router';
import * as i1$3 from '@angular/service-worker';
import { SwRegistrationOptions, ServiceWorkerModule } from '@angular/service-worker';
import * as i1$4 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR, UntypedFormGroup, UntypedFormControl, Validators, FormGroup, FormControl, UntypedFormArray } from '@angular/forms';
import * as i2 from '@ng-select/ng-select';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i3$1 from 'ngx-infinite-scroll';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import * as i1$5 from '@ngrx/store';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/** The element attribute used to store the focus state */
const FOCUS_ATTR = 'data-cx-focus';
/** The element attribute used to store the focus group state */
const FOCUS_GROUP_ATTR = 'data-cx-focus-group';
var MOVE_FOCUS;
(function (MOVE_FOCUS) {
    MOVE_FOCUS[MOVE_FOCUS["NEXT"] = 1] = "NEXT";
    MOVE_FOCUS[MOVE_FOCUS["PREV"] = -1] = "PREV";
})(MOVE_FOCUS || (MOVE_FOCUS = {}));
var TrapFocus;
(function (TrapFocus) {
    /**
     * Will trap the focus at the start of the focus group.
     */
    TrapFocus["start"] = "start";
    /**
     * Will trap the focus only at the end of the focus group.
     */
    TrapFocus["end"] = "end";
    /**
     * Will not trap the focus in both directions. This is actually not are
     * a great example of focus trap, but it will give the benefit of keyboard
     * tabbing by arrows. Should only be used with `TrapFocusConfig.trap` and not with `TrapFocusConfig.trapTabOnly`
     */
    TrapFocus["both"] = "both";
})(TrapFocus || (TrapFocus = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BaseFocusService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BaseFocusService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BaseFocusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BaseFocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Abstract directive that provides a common interface for all focus directives:
 * - Block Focus
 * - Persist Focus
 * - Escape Focus
 * - Auto Focus
 * - Tab Focus
 * - Trap Focus
 * - Lock Focus
 */
class BaseFocusDirective {
    constructor(elementRef, service) {
        this.elementRef = elementRef;
        this.service = service;
        /**
         * A default config can be provided for each directive if a specific focus directive
         * is used directly. i.e. `<div cxAutoFocus></div>`
         */
        this.defaultConfig = {};
    }
    ngOnInit() {
        this.setDefaultConfiguration();
        this.requiredTabindex = -1;
    }
    // empty, but sub classes might have an implementation
    /* eslint @angular-eslint/no-empty-lifecycle-method: 1 */
    ngOnChanges(_changes) {
        // Intentional empty method
    }
    /**
     * Override the (input) config if it undefined or an empty string, with the
     * `defaultConfig`. The `defaultConfig` might be specified for each directive
     * differently. If a specific directive is used (i.e. `cxAutoFocus`), the
     * specific (inherited) defaultConfig will be used.
     */
    setDefaultConfiguration() {
        if ((!this.config || this.config === '') && this.defaultConfig) {
            this.config = this.defaultConfig;
        }
    }
    /**
     * Helper method to return the host element for the directive
     * given by the `elementRef`.
     */
    get host() {
        return this.elementRef.nativeElement;
    }
    /**
     * Force a tabindex on the host element if it is _required_ to make the element
     * focusable. If the element is focusable by nature or by a given tabindex, the
     * `tabindex` is not applied.
     *
     * Buttons, active links, etc. do no need an explicit tabindex to receive focus.
     */
    set requiredTabindex(tabindex) {
        if (this.requiresExplicitTabIndex) {
            this.tabindex = tabindex;
        }
    }
    /**
     * Returns true if the host element does not have a tabindex defined
     * and it also doesn't get focus by browsers nature (i.e. button or
     * active link).
     */
    get requiresExplicitTabIndex() {
        return (this.tabindex === undefined &&
            ['button', 'input', 'select', 'textarea'].indexOf(this.host.tagName.toLowerCase()) === -1 &&
            !(this.host.tagName === 'A' &&
                (this.host.hasAttribute('href') ||
                    this.host.hasAttribute('routerlink') ||
                    this.host.getAttribute('ng-reflect-router-link'))));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BaseFocusDirective, deps: [{ token: i0.ElementRef }, { token: BaseFocusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: BaseFocusDirective, isStandalone: true, inputs: { tabindex: "tabindex" }, host: { properties: { "attr.tabindex": "this.tabindex" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BaseFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: BaseFocusService }], propDecorators: { tabindex: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.tabindex']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive implementation that adds a CSS class to the host element
 * when the moused is used to focus an element. As soon as the keyboard
 * is used, the class is removed.
 *
 * This feature must be explicitly enabled with the `disableMouseFocus` config.
 *
 * The appearance of the visual focus depends on the CSS implementation to
 * begin with. Spartacus styles add a blue border around each focusable element.
 * This can be considered annoying by keyboard users, as they won't need such a
 * strong indication of the selected element.
 */
class VisibleFocusDirective extends BaseFocusDirective {
    // TODO: (CXSPA-5912) Remove usless constructor next major release
    constructor(elementRef, service) {
        super(elementRef, service);
        this.elementRef = elementRef;
        this.service = service;
        this.defaultConfig = {
            disableMouseFocus: true,
        };
        /** Controls a css class to hide focus visible CSS rules */
        this.mouseFocus = false;
    }
    handleMousedown() {
        if (this.shouldFocusVisible) {
            this.mouseFocus = true;
        }
    }
    handleKeydown(event) {
        if (this.shouldFocusVisible) {
            this.mouseFocus = !this.isNavigating(event);
        }
    }
    /**
     * Indicates whether the configurations setup to disable visual focus.
     */
    get shouldFocusVisible() {
        return this.config?.disableMouseFocus;
    }
    /**
     * Indicates whether the event is used to navigate the storefront. Some keyboard events
     * are used by mouse users to fill a form or interact with the OS or browser.
     */
    isNavigating(event) {
        // when the cmd or ctrl keys are used, the user doesn't navigate the storefront
        if (event.metaKey) {
            return false;
        }
        // when the tab key is used, users are for navigating away from the current (form) element
        if (event.code === 'Tab') {
            return true;
        }
        // If the user fill in a form, we don't considering it part of storefront navigation.
        if (['INPUT', 'TEXTAREA'].includes(event.target.tagName)) {
            return false;
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: VisibleFocusDirective, deps: [{ token: i0.ElementRef }, { token: BaseFocusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: VisibleFocusDirective, isStandalone: true, host: { listeners: { "mousedown": "handleMousedown()", "keydown": "handleKeydown($event)" }, properties: { "class.mouse-focus": "this.mouseFocus" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: VisibleFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: BaseFocusService }], propDecorators: { mouseFocus: [{
                type: HostBinding,
                args: ['class.mouse-focus']
            }], handleMousedown: [{
                type: HostListener,
                args: ['mousedown']
            }], handleKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// { selector: '[cxBlockFocus]' }
class BlockFocusDirective extends VisibleFocusDirective {
    constructor(elementRef, service) {
        super(elementRef, service);
        this.elementRef = elementRef;
        this.service = service;
        this.defaultConfig = { block: true };
        // @Input('cxBlockFocus')
        this.config = {};
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.config.block) {
            this.tabindex = -1;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BlockFocusDirective, deps: [{ token: i0.ElementRef }, { token: BaseFocusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: BlockFocusDirective, isStandalone: true, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BlockFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: BaseFocusService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const GLOBAL_GROUP = '_g_';
/**
 * Shared service to persist the focus for an element or a group
 * of elements. The persisted element focus can be used to persist
 * the focus for a DOM tree, so that the focus remains after a repaint
 * or reoccurs when a DOM tree is "unlocked".
 */
class PersistFocusService extends BaseFocusService {
    constructor() {
        super(...arguments);
        // this is going to fail as we have sub services. They will al have their own map.
        // We must bring this to a singleton map.
        this.focus = new Map();
    }
    get(group) {
        return this.focus.get(group || GLOBAL_GROUP);
    }
    /**
     * Persist the keyboard focus state for the given key. The focus is stored globally
     * or for the given group.
     */
    set(key, group) {
        if (key) {
            this.focus.set(group || GLOBAL_GROUP, key);
        }
    }
    /**
     * Clears the persisted keyboard focus state globally or for the given group.
     */
    clear(group) {
        this.focus.delete(group || GLOBAL_GROUP);
    }
    /**
     * Returns the group for the host element based on the configured group or
     * by the `data-cx-focus-group` attribute stored on the host.
     */
    getPersistenceGroup(host, config) {
        return config?.group ? config.group : host?.getAttribute(FOCUS_GROUP_ATTR);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PersistFocusService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PersistFocusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PersistFocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that provides persistence of the focused state. This is useful
 * when a group of focusable elements got refocused or even recreated. That
 * happens often when the DOM is constructed with an `*ngIf` or `*ngFor`.
 *
 * The focus state is based on a configured _key_, which can be passed in the
 * config input, either by using a string primitive or `PersistFocusConfig.key`:
 *
 * ```html
 * <button cxPersistFocus="myKey"></button>
 * <button cxFocus="myKey"></button>
 * <button [cxFocus]="{{key:'myKey'}"></button>
 * ```
 *
 * The focus state can be part of a focus _group_, so that the state is shared
 * and remember for the given group. In order to detect the persistence for a
 * given element, we store the persistence key as a data attribute (`data-cx-focus`):
 *
 * ```html
 * <button data-cx-focus="myKey"></button>
 * ```
 *
 * Other keyboard focus directives can read the key to understand whether the element
 * should retrieve focus.
 *
 */
class PersistFocusDirective extends BlockFocusDirective {
    handleFocus(event) {
        this.service.set(this.key, this.group);
        event?.preventDefault();
        event?.stopPropagation();
    }
    constructor(elementRef, service) {
        super(elementRef, service);
        this.elementRef = elementRef;
        this.service = service;
        this.defaultConfig = {};
        /**
         * The persistence key can be passed directly or through the `FocusConfig.key`.
         * While this could be considered a global key, the likeliness of conflicts
         * is very small since the key is cleared when the focus is changed.
         */
        // @Input('cxPersistFocus')
        this.config = {};
    }
    ngOnInit() {
        super.ngOnInit();
        this.attr = this.key ? this.key : undefined;
    }
    setDefaultConfiguration() {
        if (typeof this.config === 'string' && this.config !== '') {
            this.config = { key: this.config };
        }
        super.setDefaultConfiguration();
    }
    /**
     * Focus the element explicitly if it was focused before.
     */
    ngAfterViewInit() {
        if (this.isPersisted) {
            this.host.focus({ preventScroll: true });
        }
    }
    get isPersisted() {
        return !!this.key && this.service.get(this.group) === this.key;
    }
    /**
     * Returns the key for the host element, which is used to persist the
     * focus state. This is useful in cases where the DOM is rebuild.
     */
    get key() {
        return this.config?.key;
    }
    /**
     * returns the persistence group (if any) for the focusable elements.
     */
    get group() {
        return this.service.getPersistenceGroup(this.host, this.config);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PersistFocusDirective, deps: [{ token: i0.ElementRef }, { token: PersistFocusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: PersistFocusDirective, isStandalone: true, host: { listeners: { "focus": "handleFocus($event)" }, properties: { "attr.data-cx-focus": "this.attr" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PersistFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: PersistFocusService }], propDecorators: { attr: [{
                type: HostBinding,
                args: [`attr.${FOCUS_ATTR}`]
            }], handleFocus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SelectFocusUtility {
    constructor() {
        /**
         * Query selectors used to query focusable child elements of the host element.
         * The selectors are supplemented with `:not([disabled])` and `:not([hidden])`.
         */
        this.focusableSelectors = [
            'a[href]',
            'button',
            '[tabindex]',
            'input',
            'select',
            'textarea',
        ];
        // like to leave out the following as we don't use it, and make this list exensible.
        //   `[contentEditable=true]`, // very unlikely to suport as we're not a business tool
        //   `iframe`, // we really don't like iframes...
        //   `area[href]`, // very debatable!
        this.focusableSelectorSuffix = ':not([disabled]):not([hidden]):not([aria-hidden])';
    }
    query(host, selector) {
        if (!selector || selector === '') {
            return [];
        }
        return Array.from(host?.querySelectorAll(selector));
    }
    findFirstFocusable(host, config = { autofocus: true }) {
        const selector = typeof config?.autofocus === 'string' ? config.autofocus : '[autofocus]';
        // fallback to first focusable
        return (this.query(host, selector).find((el) => !this.isHidden(el)) ||
            this.findFocusable(host).find((el) => Boolean(el)));
    }
    /**
     * returns all focusable child elements of the host element. The element selectors
     * are build from the `focusableSelectors`.
     *
     * @param host the `HTMLElement` used to query focusable elements
     * @param locked indicates whether inactive (`tabindex="-1"`) focusable elements should be returned
     * @param invisible indicates whether hidden focusable elements should be returned
     */
    findFocusable(host, locked = false, invisible = false) {
        let suffix = this.focusableSelectorSuffix;
        if (!locked) {
            suffix += `:not([tabindex='-1'])`;
        }
        const selector = this.focusableSelectors
            .map((s) => (s += suffix))
            .join(',');
        return this.query(host, selector).filter((el) => !invisible ? !this.isHidden(el) : Boolean(el));
    }
    /**
     * Indicates whether the element is hidden by CSS. There are various CSS rules and
     * HTML structures which can lead to an hidden or invisible element. An `offsetParent`
     * of null indicates that the element or any of it's decendants is hidden (`display:none`).
     *
     * Oother techniques use the visibility (`visibility: hidden`), opacity (`opacity`) or
     * phyisical location on the element itself or any of it's anchestor elements. Those
     * technique require to work with the _computed styles_, which will cause a performance
     * downgrade. We don't do this in the standard implementaton.
     */
    isHidden(el) {
        return el.offsetParent === null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SelectFocusUtility, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SelectFocusUtility, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SelectFocusUtility, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class EscapeFocusService extends PersistFocusService {
    constructor(selectFocusUtil) {
        super();
        this.selectFocusUtil = selectFocusUtil;
    }
    shouldFocus(config) {
        return !!config?.focusOnEscape;
    }
    handleEscape(host, config, event) {
        if (this.shouldFocus(config)) {
            if (host !== event.target) {
                host.focus({ preventScroll: true });
                event.preventDefault();
                event.stopPropagation();
            }
            else {
                if (config?.focusOnDoubleEscape) {
                    this.selectFocusUtil
                        .findFirstFocusable(host, { autofocus: true })
                        ?.focus();
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: EscapeFocusService, deps: [{ token: SelectFocusUtility }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: EscapeFocusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: EscapeFocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: SelectFocusUtility }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to focus the host element whenever the `escape` key is captured.
 * UiEvents bubble up by nature, which is why the `cxEscGroup` can be used
 * on a tree of elements. Each time the escape key is used, the focus will
 * move up in the DOM tree.
 *
 */
class EscapeFocusDirective extends PersistFocusDirective {
    /**
     * Handles the escape key event.
     * @param event the native keyboard event which contains the escape keydown event
     */
    handleEscape(event) {
        if (this.service.shouldFocus(this.config)) {
            this.service.handleEscape(this.host, this.config, event);
        }
        this.esc.emit(this.service.shouldFocus(this.config));
    }
    constructor(elementRef, service) {
        super(elementRef, service);
        this.elementRef = elementRef;
        this.service = service;
        this.defaultConfig = { focusOnEscape: true };
        this.esc = new EventEmitter();
    }
    ngOnInit() {
        if (this.service.shouldFocus(this.config)) {
            this.requiredTabindex = -1;
        }
        super.ngOnInit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: EscapeFocusDirective, deps: [{ token: i0.ElementRef }, { token: EscapeFocusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: EscapeFocusDirective, isStandalone: true, outputs: { esc: "esc" }, host: { listeners: { "keydown.escape": "handleEscape($event)" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: EscapeFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: EscapeFocusService }], propDecorators: { esc: [{
                type: Output
            }], handleEscape: [{
                type: HostListener,
                args: ['keydown.escape', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AutoFocusService extends EscapeFocusService {
    /**
     * Returns the first focusable child element of the host element.
     */
    findFirstFocusable(host, config = { autofocus: true }) {
        if (config?.autofocus === ':host') {
            return host;
        }
        else if (this.hasPersistedFocus(host, config)) {
            return this.getPersisted(host, this.getPersistenceGroup(host, config));
        }
        else {
            return this.selectFocusUtil.findFirstFocusable(host, config) || host;
        }
    }
    /**
     * Indicates whether any of the focusable child elements is focused.
     */
    hasPersistedFocus(host, config) {
        return !!this.getPersisted(host, this.getPersistenceGroup(host, config));
    }
    /**
     * Returns the element that has a persisted focus state.
     *
     * @param host the `HTMLElement` used to query for focusable children
     * @param group the optional group for the persistent state, to separate different focus
     *   groups and remain the persistence
     */
    getPersisted(host, group) {
        if (!this.get(group)) {
            return;
        }
        const focussed = Array.from(host?.querySelectorAll(`[${FOCUS_ATTR}='${this.get(group)}']`));
        return focussed.length > 0 ? focussed[0] : undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AutoFocusService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AutoFocusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AutoFocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that focus the first nested _focusable_ element based on state and configuration:
 *
 * 1. focusable element that was left in a focused state (aka _persisted_ focus)
 * 2. focusable element selected by configured CSS selector (i.e. 'button[type=submit]')
 * 3. focusable element marked with the native HTML5 `autofocus` attribute
 * 4. first focusable element
 * 5. the host element, in case the configured CSS selector is `:host`.
 *
 * Example configurations:
 *
 * `<div cxAutoFocus>[...]</div>`
 *
 * `<div [cxAutoFocus]="{autofocus: false}">[...]</div>`
 *
 * `<div [cxAutoFocus]="{autofocus: 'button.active'}">[...]</div>`
 *
 * `<div [cxAutoFocus]="{autofocus: ':host'}">[...]</div>`
 *
 * When your element is added dynamically (ie. by using an *ngIf or after a DOM change), the
 * focus can be refreshed by using the refreshFocus configuration.
 */
class AutoFocusDirective extends EscapeFocusDirective {
    constructor(elementRef, service) {
        super(elementRef, service);
        this.elementRef = elementRef;
        this.service = service;
        /** The AutoFocusDirective will be using autofocus by default  */
        this.defaultConfig = { autofocus: true };
    }
    /**
     * Focus the element explicitly if it was focussed before.
     */
    ngAfterViewInit() {
        if (this.shouldAutofocus) {
            this.handleFocus();
        }
        if (!this.shouldAutofocus || this.hasPersistedFocus) {
            super.ngAfterViewInit();
        }
    }
    ngOnChanges(changes) {
        // responsible for refresh focus based on the configured refresh property name
        if (!!changes.config?.currentValue?.refreshFocus) {
            // ensure the autofocus when it's to provided initially
            if (!this.config.autofocus) {
                this.config.autofocus = true;
            }
            this.handleFocus();
        }
        super.ngOnChanges(changes);
    }
    /**
     * Mimic the focus without setting the actual focus on the host. The first
     * focusable child element will be focussed.
     */
    handleFocus(event) {
        if (this.shouldAutofocus) {
            if (!event?.target || event.target === this.host) {
                this.firstFocusable?.focus();
            }
            else {
                event.target.focus();
            }
        }
        super.handleFocus(event);
    }
    /**
     * Helper function to get the first focusable child element
     */
    get hasPersistedFocus() {
        return this.service.hasPersistedFocus(this.host, this.config);
    }
    /**
     * Helper function to indicate whether we should use autofocus for the
     * child elements.
     */
    get shouldAutofocus() {
        return !!this.config?.autofocus;
    }
    /**
     * Helper function to get the first focusable child element.
     *
     * We keep this private to not pollute the API.
     */
    get firstFocusable() {
        return this.service.findFirstFocusable(this.host, this.config);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AutoFocusDirective, deps: [{ token: i0.ElementRef }, { token: AutoFocusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: AutoFocusDirective, isStandalone: true, usesInheritance: true, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AutoFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: AutoFocusService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabFocusService extends AutoFocusService {
    /**
     * Moves to the next (or previous) tab.
     */
    moveTab(host, config, increment, event) {
        if (config?.tab) {
            const next = config.tab === 'scroll'
                ? this.findNextScrollable(host, config, increment)
                : this.findNext(host, config, increment);
            next?.focus();
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /**
     * builds out virtual slides out of the full scrollable area, to allow
     * for maximum flexibility for the underlying layout without using hardcoded
     * slide sizes.
     */
    findNextScrollable(host, config, increment) {
        const active = this.getActiveChild(host, config);
        if (!active) {
            return;
        }
        // slide count
        const virtualSlideCount = Math.round(host.scrollWidth / host.clientWidth);
        // find current virtual slide
        const currentVirtualSlide = Math.round(active.offsetLeft / (host.scrollWidth / virtualSlideCount));
        let nextVirtualSlide = currentVirtualSlide + increment;
        if (increment === MOVE_FOCUS.NEXT &&
            nextVirtualSlide >= virtualSlideCount) {
            nextVirtualSlide = 0;
        }
        if (increment === MOVE_FOCUS.PREV && nextVirtualSlide < 0) {
            nextVirtualSlide = virtualSlideCount - 1;
        }
        const firstItemOnNextSlide = this.getChildren(host, config)?.find((tab) => tab.offsetLeft >=
            (host.scrollWidth / virtualSlideCount) * nextVirtualSlide);
        return firstItemOnNextSlide;
    }
    findNext(host, config, increment) {
        const childs = this.getChildren(host, config);
        let activeIndex = childs?.findIndex((c) => c === this.getActiveChild(host, config));
        if (!activeIndex || activeIndex === -1) {
            activeIndex = 0;
        }
        activeIndex += increment;
        if (increment === MOVE_FOCUS.NEXT && activeIndex >= childs?.length) {
            activeIndex = childs.length - 1;
        }
        if (increment === MOVE_FOCUS.PREV && activeIndex < 0) {
            activeIndex = 0;
        }
        return childs ? childs[activeIndex] : undefined;
    }
    /**
     * Returns the active focusable child element. If there's no active
     * focusable child element, the first focusable child is returned.
     */
    getActiveChild(host, config) {
        const persisted = this.getPersisted(host, config?.group);
        if (persisted) {
            return persisted;
        }
        const children = this.getChildren(host, config);
        let index = children.findIndex((tab) => this.isActive(tab));
        if (!index || index === -1) {
            index = 0;
        }
        return children[index];
    }
    getChildren(host, config) {
        if (typeof config.tab === 'string' && config.tab !== 'scroll') {
            return this.selectFocusUtil.query(host, config.tab);
        }
        else {
            return this.findFocusable(host, true);
        }
    }
    /**
     * Returns all focusable child elements of the host element.
     *
     * @param host The host element is used to query child focusable elements.
     * @param locked Indicates if locked elements (tabindex=-1) should be returned, defaults to false.
     * @param invisible Indicates if invisible child elements should be returned, defaults to false.
     */
    findFocusable(host, locked = false, invisible = false) {
        return this.selectFocusUtil.findFocusable(host, locked, invisible);
    }
    isActive(el) {
        const child = document.activeElement;
        const selector = child?.tagName;
        return (el === child ||
            (!!selector &&
                !!Array.from(el.querySelectorAll(selector)).find((e) => e === child)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabFocusService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabFocusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabFocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to move the focus of ("locked") child elements. This is useful
 * for a nested list of tabs, carousel slides or any group of elements that
 * requires horizontal navigation.
 */
class TabFocusDirective extends AutoFocusDirective {
    handleNextTab(event) {
        if (this.config?.tab) {
            this.service.moveTab(this.host, this.config, MOVE_FOCUS.NEXT, event);
        }
    }
    handlePreviousTab(event) {
        if (this.config?.tab) {
            this.service.moveTab(this.host, this.config, MOVE_FOCUS.PREV, event);
        }
    }
    constructor(elementRef, service) {
        super(elementRef, service);
        this.elementRef = elementRef;
        this.service = service;
        /** `tab` defaults to true if the directive `cxTabFocus` is used. */
        this.defaultConfig = { tab: true };
        // @Input('cxTabFocus')
        this.config = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabFocusDirective, deps: [{ token: i0.ElementRef }, { token: TabFocusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: TabFocusDirective, isStandalone: true, host: { listeners: { "keydown.arrowRight": "handleNextTab($event)", "keydown.arrowLeft": "handlePreviousTab($event)" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: TabFocusService }], propDecorators: { handleNextTab: [{
                type: HostListener,
                args: ['keydown.arrowRight', ['$event']]
            }], handlePreviousTab: [{
                type: HostListener,
                args: ['keydown.arrowLeft', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TrapFocusService extends TabFocusService {
    /**
     * Indicates whether any of the child elements of the host are focusable.
     *
     * @param host `HTMLElement` that is used to query the focusable elements.
     */
    hasFocusableChildren(host) {
        return this.findFocusable(host).length > 0;
    }
    /**
     * Focus the next or previous element of all available focusable elements.
     * The focus is _trapped_ in case there's no next or previous available element.
     * The focus will automatically move the start or end of the list.
     */
    moveFocus(host, config, increment, event) {
        const focusable = this.findFocusable(host);
        let index = focusable.findIndex((v) => v === event.target) + increment;
        const trap = config.trap || config.trapTabOnly;
        const shouldMoveFocus = (index >= 0 && index < focusable.length) ||
            (index < 0 && this.getTrapStart(trap)) ||
            (index >= focusable.length && this.getTrapEnd(trap));
        if (shouldMoveFocus) {
            if (index >= focusable.length) {
                index = 0;
            }
            if (index < 0) {
                index = focusable.length - 1;
            }
            event.preventDefault();
            event.stopPropagation();
            const el = focusable[index];
            el.focus();
        }
    }
    getTrapStart(trap) {
        return trap === true || trap === TrapFocus.start;
    }
    getTrapEnd(trap) {
        return trap === true || trap === TrapFocus.end;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TrapFocusService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TrapFocusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TrapFocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that keeps the focus inside the focusable child elements,
 * also known as a _focus trap_.
 */
class TrapFocusDirective extends TabFocusDirective {
    constructor(elementRef, service) {
        super(elementRef, service);
        this.elementRef = elementRef;
        this.service = service;
        this.defaultConfig = { trap: true };
        // @Input('cxTrapFocus')
        this.config = {};
        this.handleTrapDown = (event) => {
            const isTabPressed = event.key === 'Tab';
            if (!!this.config.trap || (this.config.trapTabOnly && isTabPressed)) {
                this.moveFocus(event, MOVE_FOCUS.NEXT);
            }
        };
        this.handleTrapUp = (event) => {
            const isTabPressed = event.key === 'Tab';
            if (!!this.config.trap || (this.config.trapTabOnly && isTabPressed)) {
                this.moveFocus(event, MOVE_FOCUS.PREV);
            }
        };
    }
    /**
     * Moves the focus of the element reference up or down, depending on the increment.
     * The focus of the element is trapped to avoid it from going out of the group.
     *
     * @param event UIEvent that is used to get the target element. The event is blocked
     *   from standard execution and further bubbling.
     * @param increment indicates whether the next or previous is focussed.
     */
    moveFocus(event, increment) {
        if (this.service.hasFocusableChildren(this.host)) {
            this.service.moveFocus(this.host, this.config, increment, event);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TrapFocusDirective, deps: [{ token: i0.ElementRef }, { token: TrapFocusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: TrapFocusDirective, isStandalone: true, host: { listeners: { "keydown.arrowdown": "handleTrapDown($event)", "keydown.tab": "handleTrapDown($event)", "keydown.arrowup": "handleTrapUp($event)", "keydown.shift.tab": "handleTrapUp($event)" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TrapFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: TrapFocusService }], propDecorators: { handleTrapDown: [{
                type: HostListener,
                args: ['keydown.arrowdown', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.tab', ['$event']]
            }], handleTrapUp: [{
                type: HostListener,
                args: ['keydown.arrowup', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.shift.tab', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LockFocusService extends TrapFocusService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LockFocusService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LockFocusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LockFocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Focusable elements exclude hidden elements by default, but this contradicts with
 * unlocking (hidden) elements.
 */
const UNLOCK_HIDDEN_ELEMENTS = true;
/**
 * Directive that adds persistence for focussed element in case
 * the elements are being rebuild. This happens often when change
 * detection kicks in because of new data set from the backend.
 */
class LockFocusDirective extends TrapFocusDirective {
    /**
     * When the user selects enter or space, the focusable childs are
     * unlocked, which means that the tabindex is set to 0.
     */
    handleEnter(event) {
        if (this.shouldLock && this.host === event.target) {
            this.unlockFocus(event);
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /**
     * In case any of the children elements is touched by the mouse,
     * we unlock the group to not break the mouse-experience.
     */
    handleClick(event) {
        if (this.shouldLock && this.isLocked) {
            this.unlockFocus(event);
            event.stopPropagation();
        }
    }
    constructor(elementRef, service, renderer) {
        super(elementRef, service);
        this.elementRef = elementRef;
        this.service = service;
        this.renderer = renderer;
        this.defaultConfig = { lock: true };
        // @Input('cxLockFocus')
        this.config = {};
        /**
         * Emits an event when the host is unlocked.
         */
        this.unlock = new EventEmitter();
    }
    lockFocus() {
        this.addTabindexToChildren(-1);
    }
    unlockFocus(event) {
        this.unlock.emit(true);
        this.addTabindexToChildren(0);
        // we focus the host if the event was triggered from a child
        if (event?.target === this.host) {
            // we wait a few milliseconds, mainly because firefox will otherwise apply
            // the mouse event on the new focused child element
            setTimeout(() => {
                super.handleFocus(event);
            }, 100);
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.shouldLock = this.config?.lock;
        if (this.shouldLock) {
            this.tabindex = 0;
            // Locked elements will be set to `autofocus` by default if it's not
            // been configured. This will ensure that autofocus kicks in upon unlock.
            if (!this.config.hasOwnProperty('autofocus')) {
                this.config.autofocus = true;
            }
            // Locked elements will be set to `focusOnEscape` by default if it's not
            // been configured. This will ensure that  the host gets locked again when
            // `escape` is pressed.
            if (!this.config.hasOwnProperty('focusOnEscape')) {
                this.config.focusOnEscape = !(this.config?.focusOnEscape === false);
            }
        }
    }
    ngAfterViewInit() {
        if (this.shouldLock) {
            /**
             * If the component hosts a group of focusable children elements,
             * we persist the group key to the children, so that they can taken this
             * into account when they persist their focus state.
             */
            if (!!this.group) {
                const group = this.group;
                this.service.findFocusable(this.host).forEach((el) => 
                // we must do this in after view init as
                this.renderer.setAttribute(el, FOCUS_GROUP_ATTR, group));
            }
            if (this.shouldAutofocus) {
                this.handleFocus();
            }
        }
        super.ngAfterViewInit();
    }
    handleFocus(event) {
        if (this.shouldLock) {
            if (this.shouldUnlockAfterAutofocus(event)) {
                // Delay unlocking in case the host is using `ChangeDetectionStrategy.Default`
                setTimeout(() => this.unlockFocus(event));
            }
            else {
                setTimeout(() => this.lockFocus());
                event?.stopPropagation();
                return;
            }
        }
        super.handleFocus(event);
    }
    handleEscape(event) {
        if (this.shouldLock) {
            this.service.clear(this.config.group);
        }
        super.handleEscape(event);
    }
    /**
     * When the handleFocus is called without an actual event, it's coming from Autofocus.
     * In this case we unlock the focusable children in case there's a focusable child that
     * was unlocked before.
     *
     * We keep this private to not polute the API.
     */
    shouldUnlockAfterAutofocus(event) {
        return !event && this.service.hasPersistedFocus(this.host, this.config);
    }
    /**
     * Add the tabindex attribute to the focusable children elements
     */
    addTabindexToChildren(i = 0) {
        if (this.shouldLock) {
            this.isLocked = i === -1;
            if (!(this.hasFocusableChildren && i === 0) || i === 0) {
                this.focusable.forEach((el) => this.renderer.setAttribute(el, 'tabindex', i.toString()));
            }
        }
    }
    /**
     * Utility method, returns all focusable children for the host element.
     *
     * We keep this private to not polute the API.
     */
    get hasFocusableChildren() {
        return this.service.hasFocusableChildren(this.host);
    }
    /**
     * Returns the focusable children of the host element. If the host element
     * is configured to be locked, the query is restricted to child elements
     * with a tabindex !== `-1`.
     *
     * We keep this private to not polute the API.
     */
    get focusable() {
        return this.service.findFocusable(this.host, this.shouldLock, UNLOCK_HIDDEN_ELEMENTS);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LockFocusDirective, deps: [{ token: i0.ElementRef }, { token: LockFocusService }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: LockFocusDirective, isStandalone: true, outputs: { unlock: "unlock" }, host: { listeners: { "keydown.enter": "handleEnter($event)", "keydown.space": "handleEnter($event)", "click": "handleClick($event)" }, properties: { "class.focus-lock": "this.shouldLock", "class.is-locked": "this.isLocked" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LockFocusDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: LockFocusService }, { type: i0.Renderer2 }], propDecorators: { shouldLock: [{
                type: HostBinding,
                args: ['class.focus-lock']
            }], isLocked: [{
                type: HostBinding,
                args: ['class.is-locked']
            }], unlock: [{
                type: Output
            }], handleEnter: [{
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.space', ['$event']]
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class KeyboardFocusService extends LockFocusService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FocusDirective extends LockFocusDirective {
    constructor(elementRef, service, renderer) {
        super(elementRef, service, renderer);
        this.elementRef = elementRef;
        this.service = service;
        this.renderer = renderer;
        this.defaultConfig = {};
        this.config = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FocusDirective, deps: [{ token: i0.ElementRef }, { token: KeyboardFocusService }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: FocusDirective, isStandalone: false, selector: "[cxFocus]", inputs: { config: ["cxFocus", "config"] }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxFocus]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: KeyboardFocusService }, { type: i0.Renderer2 }], propDecorators: { config: [{
                type: Input,
                args: ['cxFocus']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that removes all visible and focusable elements
 * in a host container from `tab` or `shift-tab` navigation
 * except elements in `activeElementSelectors` config.
 */
class SkipFocusDirective {
    constructor() {
        this.config = { isEnabled: false };
        this.elementRef = inject(ElementRef);
        this.winRef = inject(WindowRef);
        this.renderer = inject(Renderer2);
    }
    ngOnChanges() {
        this.excludeFromFocus(this.config.isEnabled, this.config.activeElementSelectors);
    }
    excludeFromFocus(isEnabled, skipSelectors = []) {
        if (!this.winRef.isBrowser()) {
            return;
        }
        const tabindex = isEnabled ? '-1' : '0';
        const focusableElementsSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]';
        const focusableElements = this.elementRef.nativeElement.querySelectorAll(focusableElementsSelector);
        Array.from(focusableElements || []).forEach((el) => {
            const element = el;
            const shouldSkip = skipSelectors.some((selector) => {
                return element.matches(selector);
            });
            if (!shouldSkip && this.isElementVisible(element)) {
                this.renderer.setAttribute(element, 'tabindex', tabindex);
            }
        });
    }
    isElementVisible(element) {
        const style = this.winRef.nativeWindow?.getComputedStyle(element);
        return (style?.visibility !== 'hidden' &&
            style?.display !== 'none' &&
            element.offsetWidth > 0 &&
            element.offsetHeight > 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipFocusDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: SkipFocusDirective, isStandalone: false, selector: "[cxSkipFocus]", inputs: { config: ["cxSkipFocus", "config"] }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipFocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxSkipFocus]',
                    standalone: false,
                }]
        }], propDecorators: { config: [{
                type: Input,
                args: ['cxSkipFocus']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const directives$1 = [
    // PersistFocusDirective,
    // VisibleFocusDirective,
    // BlockFocusDirective,
    // AutoFocusDirective,
    // EscapeFocusDirective,
    // LockFocusDirective,
    // TrapFocusDirective,
    // TabFocusDirective,
    FocusDirective,
    SkipFocusDirective,
];
class KeyboardFocusModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusModule, declarations: [
            // PersistFocusDirective,
            // VisibleFocusDirective,
            // BlockFocusDirective,
            // AutoFocusDirective,
            // EscapeFocusDirective,
            // LockFocusDirective,
            // TrapFocusDirective,
            // TabFocusDirective,
            FocusDirective,
            SkipFocusDirective], imports: [CommonModule], exports: [
            // PersistFocusDirective,
            // VisibleFocusDirective,
            // BlockFocusDirective,
            // AutoFocusDirective,
            // EscapeFocusDirective,
            // LockFocusDirective,
            // TrapFocusDirective,
            // TabFocusDirective,
            FocusDirective,
            SkipFocusDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [...directives$1],
                    exports: [...directives$1],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MockKeyboardFocusDirective {
    constructor() {
        this.config = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MockKeyboardFocusDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: MockKeyboardFocusDirective, isStandalone: false, selector: "[cxFocus]", inputs: { config: ["cxFocus", "config"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MockKeyboardFocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxFocus]',
                    standalone: false,
                }]
        }], propDecorators: { config: [{
                type: Input,
                args: ['cxFocus']
            }] } });
class KeyboardFocusTestingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusTestingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusTestingModule, declarations: [MockKeyboardFocusDirective], exports: [MockKeyboardFocusDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusTestingModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: KeyboardFocusTestingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MockKeyboardFocusDirective],
                    exports: [MockKeyboardFocusDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Temporarily removes elements from the tabbing flow and restores them after a tick.
 *
 * This method sets the `tabIndex` of each element in the provided iterable to `-1`
 * and resets it back to `0` using `requestAnimationFrame`. While using `requestAnimationFrame`
 * may seem like a bad code smell, it is justified here as it ensures a natural tabbing flow
 * in cases where determining the next focusable element is complex, such as when directives
 * like `TrapFocusDirective` modify the DOM's focus behavior.
 *
 * This utility is especially useful for scenarios like menus, lists, or carousels where
 * `Tab` navigation is intentionally disabled, but other keyboard keys (e.g., `Arrow` keys)
 * are used for navigation. It helps prevent these elements from disrupting the tab order
 * while allowing other key-based interactions.
 *
 * @param elements - An iterable of `HTMLElement` objects to temporarily remove from tab navigation.
 */
const disableTabbingForTick = (elements) => {
    for (const element of elements) {
        element.tabIndex = -1;
    }
    requestAnimationFrame(() => {
        for (const element of elements) {
            element.tabIndex = 0;
        }
    });
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// given that we're likely going to refactor the directives, we're
// NOT exposing all it to the public API.
// export * from './autofocus/index';
// export * from './base/index';
// export * from './block/index';
// export * from './escape/index';
// export * from './lock/index';
// export * from './on-navigate/index';
// export * from './persist/index';
// export * from './tab/index';
// export * from './trap/index';
// export * from './visible/index';
// export * from './keyboard-focus.model';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Types of dialog openings supported
 */
var DIALOG_TYPE;
(function (DIALOG_TYPE) {
    DIALOG_TYPE["POPOVER"] = "POPOVER";
    DIALOG_TYPE["POPOVER_CENTER"] = "POPOVER_CENTER";
    DIALOG_TYPE["POPOVER_CENTER_BACKDROP"] = "POPOVER_CENTER_BACKDROP";
    DIALOG_TYPE["DIALOG"] = "DIALOG";
    DIALOG_TYPE["SIDEBAR_START"] = "SIDEBAR_START";
    DIALOG_TYPE["SIDEBAR_END"] = "SIDEBAR_END";
})(DIALOG_TYPE || (DIALOG_TYPE = {}));
/**
 * List of available callers
 */
var LAUNCH_CALLER;
(function (LAUNCH_CALLER) {
    LAUNCH_CALLER["ASM"] = "ASM";
    LAUNCH_CALLER["SKIP_LINKS"] = "SKIP_LINKS";
    LAUNCH_CALLER["ANONYMOUS_CONSENT"] = "ANONYMOUS_CONSENT";
    LAUNCH_CALLER["REPLENISHMENT_ORDER"] = "REPLENISHMENT_ORDER";
    LAUNCH_CALLER["PLACE_ORDER_SPINNER"] = "PLACE_ORDER_SPINNER";
    LAUNCH_CALLER["SUGGESTED_ADDRESSES"] = "SUGGESTED_ADDRESSES";
    LAUNCH_CALLER["COUPON"] = "COUPON";
    LAUNCH_CALLER["CLAIM_DIALOG"] = "CLAIM_DIALOG";
    LAUNCH_CALLER["STOCK_NOTIFICATION"] = "STOCK_NOTIFICATION";
})(LAUNCH_CALLER || (LAUNCH_CALLER = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let LaunchRenderStrategy = class LaunchRenderStrategy {
    constructor(document, rendererFactory) {
        this.document = document;
        this.rendererFactory = rendererFactory;
        // List of called references; only used for rendered elements
        this.renderedCallers = [];
        /**
         * Classes to apply to the component when the dialog is a DIALOG
         */
        this.dialogClasses = ['d-block', 'fade', 'modal', 'show'];
        /**
         * Classes to apply to the component when the dialog is a POPOVER
         */
        this.popoverClasses = ['cx-dialog-popover'];
        /**
         * Classes to apply to the component when the dialog is a POPOVER_CENTER
         */
        this.popoverCenterClasses = ['cx-dialog-popover-center'];
        /**
         * Classes to apply to the component when the dialog is a POPOVER_CENTER with a backdrop
         */
        this.popoverCenterBackdropClasses = [
            'cx-dialog-popover-center-backdrop',
        ];
        /**
         * Classes to apply to the component when the dialog is a SIDEBAR_END
         */
        this.sidebarEndClasses = ['cx-sidebar-end'];
        /**
         * Classes to apply to the component when the dialog is a SIDEBAR_START
         */
        this.sidebarStartClasses = ['cx-sidebar-start'];
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    /**
     * Determines if element should render
     *
     * @param caller
     * @param config
     */
    shouldRender(caller, config) {
        return (Boolean(config.component) &&
            (this.renderedCallers.some((el) => el.caller === caller)
                ? !!config.multi
                : true));
    }
    applyClasses(component, dialogType) {
        let classes = [];
        // TODO: make classes configurable
        switch (dialogType) {
            case DIALOG_TYPE.DIALOG:
                classes = this.dialogClasses;
                this.renderer.addClass(this.document.body, 'modal-open');
                break;
            case DIALOG_TYPE.POPOVER:
                classes = this.popoverClasses;
                break;
            case DIALOG_TYPE.POPOVER_CENTER:
                classes = this.popoverCenterClasses;
                break;
            case DIALOG_TYPE.POPOVER_CENTER_BACKDROP:
                classes = this.popoverCenterBackdropClasses;
                break;
            case DIALOG_TYPE.SIDEBAR_END:
                classes = this.sidebarEndClasses;
                break;
            case DIALOG_TYPE.SIDEBAR_START:
                classes = this.sidebarStartClasses;
                break;
        }
        for (const newClass of classes) {
            this.renderer.addClass(component.location.nativeElement, newClass);
        }
    }
    /**
     * Method to call when rendered element is destroyed
     * The element will be removed from the list of rendered elements
     *
     * @param caller
     * @param _config optional parameters used in children strategies
     */
    remove(caller, config) {
        this.renderedCallers = this.renderedCallers.filter((el) => el.caller !== caller);
        if (config?.dialogType === DIALOG_TYPE.DIALOG) {
            this.renderer.removeClass(this.document.body, 'modal-open');
        }
    }
    getPriority() {
        return Priority.LOW; // low, as it's a default matcher
    }
};
LaunchRenderStrategy = __decorate([
    __param(0, Inject(DOCUMENT))
], LaunchRenderStrategy);

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `BREAKPOINT` typing defaults to five default screen names:
 * xs, sm, md, lg, xl.
 *
 * The type can be extended to allow for custom screens, such as XLL or `tablet`.
 *
 * While the screen names are fully configurable, other features might have
 * pre-configured layout settings per screen. Page layouts or table configurations,
 * for example, are driven by screen size. In case you change the screen size or
 * introduce new screen names, you might loose out on these configurations.
 */
var BREAKPOINT;
(function (BREAKPOINT) {
    BREAKPOINT["xs"] = "xs";
    BREAKPOINT["sm"] = "sm";
    BREAKPOINT["md"] = "md";
    BREAKPOINT["lg"] = "lg";
    BREAKPOINT["xl"] = "xl";
})(BREAKPOINT || (BREAKPOINT = {}));
/**
 * The LayoutConfig supports the configuration of page slots by page templates
 * or page sections, such as headers and footers. The configuration also supports
 * adaptive design per breakpoint (not per device type), so that the DOM is (re)rendered
 * por a given breakpoint.
 */
class LayoutConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LayoutConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LayoutConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LayoutConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LaunchDialogService {
    get data$() {
        return this._dataSubject.asObservable();
    }
    constructor(renderStrategies, layoutConfig) {
        this.renderStrategies = renderStrategies;
        this.layoutConfig = layoutConfig;
        this._dialogClose = new BehaviorSubject(undefined);
        this._dataSubject = new BehaviorSubject(undefined);
        this.logger = inject(LoggerService);
        this.renderStrategies = this.renderStrategies || [];
    }
    /**
     * Open the dialog
     *
     * @param caller LAUNCH_CALLER
     * @param openElement button's Element ref
     * @param vcr View Container Ref of the container for inline rendering
     * @param data optional data which could be passed to dialog
     */
    openDialog(caller, openElement, vcr, data) {
        const component = this.launch(caller, vcr, data);
        if (component) {
            return combineLatest([component, this.dialogClose]).pipe(filter(([, close]) => close !== undefined), tap(([comp]) => {
                openElement?.nativeElement.focus();
                this.clear(caller);
                comp?.destroy();
            }), map(([comp]) => comp));
        }
    }
    /**
     * Render the element based on the strategy from the launch configuration
     *
     * @param caller LAUNCH_CALLER
     * @param vcr View Container Ref of the container for inline rendering
     */
    launch(caller, vcr, data) {
        const config = this.findConfiguration(caller);
        if (config) {
            const renderer = this.getStrategy(config);
            // Render if the strategy exists
            if (renderer) {
                this._dialogClose.next(undefined);
                this._dataSubject.next(data);
                return renderer.render(config, caller, vcr);
            }
        }
        else if (isDevMode()) {
            this.logger.warn('No configuration provided for caller ' + caller);
        }
    }
    /**
     * Opens dialog and subscribe in the service. Should be used if the trigger component might get destroyed while the component is open.
     *
     * @param caller Launch Caller
     * @param openElement Element to open
     * @param data Data to provide to the rendered element
     */
    openDialogAndSubscribe(caller, openElement, data) {
        this.openDialog(caller, openElement, undefined, data)
            ?.pipe(take(1))
            .subscribe();
    }
    /**
     * Util method to remove element from rendered elements list
     *
     * @param caller LAUNCH_CALLER
     */
    clear(caller) {
        const config = this.findConfiguration(caller);
        if (config) {
            const renderer = this.getStrategy(config);
            // Render if the strategy exists
            if (renderer) {
                renderer.remove(caller, config);
            }
        }
    }
    get dialogClose() {
        return this._dialogClose.asObservable();
    }
    closeDialog(reason) {
        this._dialogClose.next(reason);
    }
    /**
     * Returns the configuration for the caller
     *
     * @param caller LAUNCH_CALLER
     */
    findConfiguration(caller) {
        if (this.layoutConfig?.launch) {
            return this.layoutConfig.launch[caller];
        }
        return undefined;
    }
    /**
     * Returns the render strategy based on the configuration
     *
     * @param config Configuration for launch
     */
    getStrategy(config) {
        return resolveApplicable(this.renderStrategies, [config]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LaunchDialogService, deps: [{ token: LaunchRenderStrategy }, { token: LayoutConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LaunchDialogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LaunchDialogService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LaunchRenderStrategy]
                }] }, { type: LayoutConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentManagementBannerComponent {
    constructor(anonymousConsentsService, vcr, launchDialogService) {
        this.anonymousConsentsService = anonymousConsentsService;
        this.vcr = vcr;
        this.launchDialogService = launchDialogService;
        this.subscriptions = new Subscription();
        this.bannerVisible$ = this.anonymousConsentsService.isBannerVisible();
        useFeatureStyles('a11yScrollToTopPositioning');
    }
    viewDetails() {
        this.hideBanner();
        const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.ANONYMOUS_CONSENT, undefined, this.vcr);
        if (dialog) {
            this.subscriptions.add(dialog.subscribe());
        }
    }
    allowAll() {
        this.subscriptions.add(this.anonymousConsentsService
            .giveAllConsents()
            .pipe(tap(() => this.hideBanner()))
            .subscribe());
    }
    hideBanner() {
        this.anonymousConsentsService.toggleBannerDismissed(true);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentManagementBannerComponent, deps: [{ token: i1.AnonymousConsentsService }, { token: i0.ViewContainerRef }, { token: LaunchDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: AnonymousConsentManagementBannerComponent, isStandalone: false, selector: "cx-anonymous-consent-management-banner", ngImport: i0, template: "<ng-container *ngIf=\"bannerVisible$ | async as bannerVisible\">\n  <div\n    [ngClass]=\"{ 'anonymous-consent-banner-hidden': !bannerVisible }\"\n    class=\"anonymous-consent-banner\"\n  >\n    <div class=\"container\">\n      <div class=\"row\" *cxFeature=\"'!a11yHideConsentButtonWhenBannerVisible'\">\n        <div class=\"col-lg-7 col-xs-12\">\n          <div class=\"cx-banner-title\">\n            {{ 'anonymousConsents.banner.title' | cxTranslate }}\n          </div>\n          <div class=\"cx-banner-description\">\n            {{ 'anonymousConsents.banner.description' | cxTranslate }}\n          </div>\n        </div>\n\n        <div class=\"col-lg-5 col-xs-12 cx-banner-buttons\">\n          <button class=\"btn btn-secondary\" (click)=\"viewDetails()\">\n            {{ 'anonymousConsents.banner.viewDetails' | cxTranslate }}\n          </button>\n          <button class=\"btn btn-primary\" (click)=\"allowAll()\">\n            {{ 'anonymousConsents.banner.allowAll' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row\" *cxFeature=\"'a11yHideConsentButtonWhenBannerVisible'\">\n        <div class=\"col-xl-7 col-lg-6 col-xs-12\">\n          <div class=\"cx-banner-title\">\n            {{ 'anonymousConsents.banner.title' | cxTranslate }}\n          </div>\n          <div class=\"cx-banner-description\">\n            {{ 'anonymousConsents.banner.description' | cxTranslate }}\n          </div>\n        </div>\n\n        <div class=\"col-xl-5 col-lg-6 col-xs-12 cx-banner-buttons\">\n          <button class=\"btn btn-secondary\" (click)=\"viewDetails()\">\n            {{ 'anonymousConsents.banner.consentManagement' | cxTranslate }}\n          </button>\n          <button class=\"btn btn-primary\" (click)=\"allowAll()\">\n            {{ 'anonymousConsents.banner.allowAll' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentManagementBannerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-anonymous-consent-management-banner', standalone: false, template: "<ng-container *ngIf=\"bannerVisible$ | async as bannerVisible\">\n  <div\n    [ngClass]=\"{ 'anonymous-consent-banner-hidden': !bannerVisible }\"\n    class=\"anonymous-consent-banner\"\n  >\n    <div class=\"container\">\n      <div class=\"row\" *cxFeature=\"'!a11yHideConsentButtonWhenBannerVisible'\">\n        <div class=\"col-lg-7 col-xs-12\">\n          <div class=\"cx-banner-title\">\n            {{ 'anonymousConsents.banner.title' | cxTranslate }}\n          </div>\n          <div class=\"cx-banner-description\">\n            {{ 'anonymousConsents.banner.description' | cxTranslate }}\n          </div>\n        </div>\n\n        <div class=\"col-lg-5 col-xs-12 cx-banner-buttons\">\n          <button class=\"btn btn-secondary\" (click)=\"viewDetails()\">\n            {{ 'anonymousConsents.banner.viewDetails' | cxTranslate }}\n          </button>\n          <button class=\"btn btn-primary\" (click)=\"allowAll()\">\n            {{ 'anonymousConsents.banner.allowAll' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row\" *cxFeature=\"'a11yHideConsentButtonWhenBannerVisible'\">\n        <div class=\"col-xl-7 col-lg-6 col-xs-12\">\n          <div class=\"cx-banner-title\">\n            {{ 'anonymousConsents.banner.title' | cxTranslate }}\n          </div>\n          <div class=\"cx-banner-description\">\n            {{ 'anonymousConsents.banner.description' | cxTranslate }}\n          </div>\n        </div>\n\n        <div class=\"col-xl-5 col-lg-6 col-xs-12 cx-banner-buttons\">\n          <button class=\"btn btn-secondary\" (click)=\"viewDetails()\">\n            {{ 'anonymousConsents.banner.consentManagement' | cxTranslate }}\n          </button>\n          <button class=\"btn btn-primary\" (click)=\"allowAll()\">\n            {{ 'anonymousConsents.banner.allowAll' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i1.AnonymousConsentsService }, { type: i0.ViewContainerRef }, { type: LaunchDialogService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class InlineRenderStrategy extends LaunchRenderStrategy {
    constructor(document, rendererFactory, componentFactoryResolver) {
        super(document, rendererFactory);
        this.document = document;
        this.rendererFactory = rendererFactory;
        this.componentFactoryResolver = componentFactoryResolver;
        this.logger = inject(LoggerService);
    }
    /**
     * Renders the component from the configuration in the view container ref
     *
     * @param config
     * @param caller
     * @param vcr
     */
    render(config, caller, vcr) {
        // Only render if a ViewContainerRef is provided
        if (vcr && this.shouldRender(caller, config)) {
            const template = this.componentFactoryResolver.resolveComponentFactory(config.component);
            const component = vcr.createComponent(template);
            if (config?.dialogType) {
                this.applyClasses(component, config?.dialogType);
            }
            this.renderedCallers.push({ caller, element: vcr.element, component });
            return of(component);
        }
        else if (isDevMode()) {
            if (!vcr) {
                this.logger.warn(`No view container ref provided for ${caller}`);
            }
            else {
                this.logger.warn(`Element for ${caller} already rendered. To allow multi rendering add property multi: true.`);
            }
        }
    }
    hasMatch(config) {
        return Boolean(config.inline);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: InlineRenderStrategy, deps: [{ token: DOCUMENT }, { token: i0.RendererFactory2 }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: InlineRenderStrategy, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: InlineRenderStrategy, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.RendererFactory2 }, { type: i0.ComponentFactoryResolver }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class InlineRootRenderStrategy extends LaunchRenderStrategy {
    constructor(document, rendererFactory, componentFactoryResolver, injector) {
        super(document, rendererFactory);
        this.document = document;
        this.rendererFactory = rendererFactory;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
    }
    get hostComponent() {
        return this.injector.get(ApplicationRef)?.components?.[0];
    }
    render(config, caller) {
        if (this.shouldRender(caller, config)) {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(config.component);
            const contentInjector = Injector.create({
                providers: [],
            });
            const componentRef = componentFactory.create(contentInjector);
            this.injector.get(ApplicationRef)?.attachView(componentRef.hostView);
            this.renderer.appendChild(this.hostComponent?.location.nativeElement, componentRef.location.nativeElement);
            if (config?.dialogType) {
                this.applyClasses(componentRef, config?.dialogType);
            }
            this.renderedCallers.push({ caller, component: componentRef });
            return of(componentRef);
        }
    }
    hasMatch(config) {
        return Boolean(config.inlineRoot);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: InlineRootRenderStrategy, deps: [{ token: DOCUMENT }, { token: i0.RendererFactory2 }, { token: i0.ComponentFactoryResolver }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: InlineRootRenderStrategy, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: InlineRootRenderStrategy, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.RendererFactory2 }, { type: i0.ComponentFactoryResolver }, { type: i0.Injector }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var OutletPosition;
(function (OutletPosition) {
    OutletPosition["REPLACE"] = "replace";
    OutletPosition["BEFORE"] = "before";
    OutletPosition["AFTER"] = "after";
})(OutletPosition || (OutletPosition = {}));
const AVOID_STACKED_OUTLETS = false;
const USE_STACKED_OUTLETS = true;
/**
 * Token for injecting outlet related context to the component rendered in the outlet
 */
class OutletContextData {
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletService {
    constructor() {
        this.templatesRefs = {
            [OutletPosition.BEFORE]: new Map(),
            [OutletPosition.REPLACE]: new Map(),
            [OutletPosition.AFTER]: new Map(),
        };
    }
    /**
     * @param templateOrFactory A `ComponentFactory` that inserts a component dynamically.
     */
    add(outlet, templateOrFactory, position = OutletPosition.REPLACE) {
        const store = this.templatesRefs[position];
        if (store) {
            const existing = store.get(outlet) || [];
            const newValue = existing.concat([templateOrFactory]);
            store.set(outlet, newValue);
        }
    }
    /**
     *
     * Returns a single object or multiple objects for the given outlet reference,
     * depending on the `stacked` argument.
     *
     * @param outlet The outlet reference
     * @param position the outlet position, `OutletPosition.before`, `OutletPosition.AFTER` or `OutletPosition.REPLACE`
     * @param stacked Indicates whether an array of outlet components is returned
     */
    get(outlet, position = OutletPosition.REPLACE, stacked = AVOID_STACKED_OUTLETS) {
        const store = this.templatesRefs[position] ||
            this.templatesRefs[OutletPosition.REPLACE];
        const templateRef = store.get(outlet);
        if (templateRef && !stacked) {
            return templateRef[0];
        }
        return templateRef;
    }
    remove(outlet, position = OutletPosition.REPLACE, value) {
        const store = this.templatesRefs[position] ||
            this.templatesRefs[OutletPosition.REPLACE];
        this.removeValueOrAll(store, outlet, value);
    }
    removeValueOrAll(store, outlet, value) {
        if (!value && store.has(outlet)) {
            store.delete(outlet);
        }
        else if (value && store.has(outlet)) {
            let existing = store.get(outlet);
            existing = existing?.filter((val) => val !== value);
            if (existing) {
                store.set(outlet, existing);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletRefDirective {
    constructor(tpl, outletService) {
        this.tpl = tpl;
        this.outletService = outletService;
    }
    ngOnInit() {
        this.outletService.add(this.cxOutletRef, this.tpl, this.cxOutletPos);
    }
    ngOnDestroy() {
        this.outletService.remove(this.cxOutletRef, this.cxOutletPos, this.tpl);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRefDirective, deps: [{ token: i0.TemplateRef }, { token: OutletService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: OutletRefDirective, isStandalone: false, selector: "[cxOutletRef]", inputs: { cxOutletRef: "cxOutletRef", cxOutletPos: "cxOutletPos" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxOutletRef]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: OutletService }], propDecorators: { cxOutletRef: [{
                type: Input
            }], cxOutletPos: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletRefModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRefModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: OutletRefModule, declarations: [OutletRefDirective], imports: [CommonModule], exports: [OutletRefDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRefModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRefModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [OutletRefDirective],
                    exports: [OutletRefDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletRendererService {
    constructor() {
        this.outletRefs = new BehaviorSubject(new Map());
    }
    /**
     * Dynamically render the templates in the specified array
     *
     * @param outlet
     */
    render(outlet) {
        if (this.outletRefs.value.size !== 0) {
            this.outletRefs.value.get(outlet)?.render();
        }
    }
    /**
     * Register outlet to be available to render dynamically
     *
     * @param cxOutlet
     * @param context
     */
    register(cxOutlet, context) {
        this.outletRefs.next(this.outletRefs.value.set(cxOutlet, context));
    }
    /**
     * Returns map of outlets
     *
     */
    getOutletRef(outlet) {
        return this.outletRefs.asObservable().pipe(map((val) => val.get(outlet)), filter(isNotNullable));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRendererService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRendererService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRendererService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The IntersectionService uses the native IntersectionObserver (v2), which
 * can be used to implement pre-loading and deferred loading of DOM content.
 *
 */
class IntersectionService {
    constructor(config) {
        this.config = config;
    }
    /**
     * Returns an Observable that emits only once a boolean value whenever
     * the given element has shown in the view port.
     *
     * The returned observable will only emit the first value. The
     * observable must be cleaned up either way, since the value might never emit; it
     * depends on whether the element appears in the view port.
     *
     * @param element - HTML element
     * @param options - Allows to specify an optional root margin, in order to fire before the element shows up in the viewport
     * @param intersectingCondition - Allows to specify an intersecting condition.
     * If this parameter is not set, then the transition state of the element will be verified whenever the element intersects the view port.
     * @returns Element intersects?
     */
    isIntersected(element, options, intersectingCondition) {
        return this.intersects(element, options, intersectingCondition).pipe(first((v) => v === true));
    }
    /**
     * Returns an observable that emits for every change of intersection of a given element.
     *
     * @param element - HTML element
     * @param options - Allows to specify an optional root margin, in order to fire before the element shows up in the viewport
     * @param intersectingCondition - Allows to specify an intersecting condition.
     * If this parameter is not set, then the transition state of the element will be verified whenever the element intersects the view port.
     * @returns Element intersects?
     */
    isIntersecting(element, options, intersectingCondition) {
        return this.intersects(element, options, intersectingCondition);
    }
    /**
     * Indicates whenever the element intersects the view port. An optional margin
     * is used to intersects before the element shows up in the viewport.
     * A value is emitted each time the element intersects.
     */
    intersects(element, options = {}, intersectingCondition) {
        return this.createIntersectionObservable(element, options).pipe(mergeMap((entries) => entries), map((entry) => intersectingCondition
            ? intersectingCondition(entry)
            : entry.isIntersecting), distinctUntilChanged());
    }
    createIntersectionObservable(element, options) {
        return new Observable((observer) => {
            const rootMargin = this.getRootMargin(options);
            const intersectOptions = { rootMargin, threshold: options.threshold };
            const intersectionObserver = new IntersectionObserver((entries) => {
                observer.next(entries);
            }, intersectOptions);
            intersectionObserver.observe(element);
            return () => {
                intersectionObserver.disconnect();
            };
        });
    }
    getRootMargin(options = {}) {
        if (options.rootMargin) {
            return options.rootMargin;
        }
        const layoutConfig = this.config;
        if (layoutConfig.deferredLoading &&
            layoutConfig.deferredLoading.intersectionMargin) {
            return layoutConfig.deferredLoading.intersectionMargin;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IntersectionService, deps: [{ token: LayoutConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IntersectionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IntersectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: LayoutConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The defer loading serivce is used to defer loading of DOM elements
 * until the elements are required for the user experience.
 */
class DeferLoaderService {
    constructor(platformId, config, intersectionService) {
        this.platformId = platformId;
        this.config = config;
        this.intersectionService = intersectionService;
        this.globalLoadStrategy =
            config.deferredLoading?.strategy ?? DeferLoadingStrategy.INSTANT;
    }
    /**
     * Defer loading till the element intersects the viewport.
     *
     * We evaluate whether we instantly load the element for different reasons:
     * - we run in SSR mode
     * - there's no global strategy given
     * - the global loading strategy is set to INSTANT loading,
     *   and the loading strategy in the given is not set to DEFER
     * - the loading strategy in the given options is set to INSTANT
     */
    load(element, options) {
        if (this.shouldLoadInstantly((options || {}).deferLoading)) {
            return of(true);
        }
        else {
            return this.intersectionService.isIntersected(element, options);
        }
    }
    shouldLoadInstantly(elementLoadingStrategy) {
        return (isPlatformServer(this.platformId) ||
            elementLoadingStrategy === DeferLoadingStrategy.INSTANT ||
            (elementLoadingStrategy !== DeferLoadingStrategy.DEFER &&
                this.globalLoadStrategy === DeferLoadingStrategy.INSTANT));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DeferLoaderService, deps: [{ token: PLATFORM_ID }, { token: LayoutConfig }, { token: IntersectionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DeferLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DeferLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: LayoutConfig }, { type: IntersectionService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletDirective {
    constructor(vcr, templateRef, outletService, deferLoaderService, outletRendererService) {
        this.vcr = vcr;
        this.templateRef = templateRef;
        this.outletService = outletService;
        this.deferLoaderService = deferLoaderService;
        this.outletRendererService = outletRendererService;
        this.renderedTemplate = [];
        this.renderedComponents = new Map();
        /**
         * Observable with current outlet context
         */
        this.outletContext$ = new ReplaySubject(1);
        this.loaded = new EventEmitter(true);
        this.cxComponentRefChange = new EventEmitter();
        this.subscription = new Subscription();
    }
    /**
     * Renders view for outlet or defers it, depending on the input `cxOutletDefer`
     */
    render() {
        this.vcr.clear();
        this.renderedTemplate = [];
        this.renderedComponents.clear();
        this.subscription.unsubscribe();
        this.subscription = new Subscription();
        if (this.cxOutletDefer) {
            this.deferLoading();
        }
        else {
            this.build();
        }
    }
    ngOnChanges(changes) {
        if (changes.cxOutlet) {
            this.render();
            this.outletRendererService.register(this.cxOutlet, this);
        }
        if (changes.cxOutletContext) {
            this.outletContext$.next(this.cxOutletContext);
        }
    }
    deferLoading() {
        this.loaded.emit(false);
        const hostElement = this.getHostElement(this.vcr.element.nativeElement);
        // Although the deferLoaderService might emit only once, as long as the hostElement
        // isn't being loaded, there's no value being emitted. Therefore we need to clean up
        // the subscription on destroy.
        this.subscription.add(this.deferLoaderService
            .load(hostElement, this.cxOutletDefer)
            .subscribe(() => {
            this.build();
            this.loaded.emit(true);
        }));
    }
    /**
     * Renders view for outlet
     */
    build() {
        this.buildOutlet(OutletPosition.BEFORE);
        this.buildOutlet(OutletPosition.REPLACE);
        this.buildOutlet(OutletPosition.AFTER);
    }
    /**
     * Renders view in a given position for outlet
     */
    buildOutlet(position) {
        let templates = (this.outletService.get(this.cxOutlet, position, USE_STACKED_OUTLETS));
        templates = templates?.filter((el) => !this.renderedTemplate.includes(el));
        if (!templates && position === OutletPosition.REPLACE) {
            templates = [this.templateRef];
        }
        // Just in case someone extended the `OutletService` and
        // returns a singular object.
        if (!Array.isArray(templates)) {
            templates = [templates];
        }
        const components = [];
        templates.forEach((obj) => {
            const component = this.create(obj, position);
            if (component) {
                components.push(component);
            }
        });
        this.renderedComponents.set(position, components);
    }
    /**
     * Renders view based on the given template or component factory
     */
    create(tmplOrFactory, position) {
        this.renderedTemplate.push(tmplOrFactory);
        if (tmplOrFactory instanceof ComponentFactory) {
            const component = this.vcr.createComponent(tmplOrFactory, undefined, this.getComponentInjector(position));
            this.cxComponentRefChange.emit(component);
            return component;
        }
        else if (tmplOrFactory instanceof TemplateRef) {
            const view = this.vcr.createEmbeddedView(tmplOrFactory, {
                $implicit: this.cxOutletContext,
            });
            // we do not know if content is created dynamically or not
            // so we apply change detection anyway
            view.markForCheck();
            this.cxComponentRefChange.emit(view);
            return view;
        }
    }
    /**
     * Returns injector with OutletContextData that can be injected to the component
     * rendered in the outlet
     */
    getComponentInjector(position) {
        const contextData = {
            reference: this.cxOutlet,
            position,
            context: this.cxOutletContext,
            context$: this.outletContext$.asObservable(),
        };
        return Injector.create({
            providers: [
                {
                    provide: OutletContextData,
                    useValue: contextData,
                },
            ],
            parent: this.vcr.injector,
        });
    }
    /**
     * Returns the closest `HtmlElement`, by iterating over the
     * parent nodes of the given element.
     *
     * We avoid traversing the parent _elements_, as this is blocking
     * ie11 implementations. One of the spare exclusions we make to not
     * supporting ie11.
     *
     * @param element
     */
    getHostElement(element) {
        if (element instanceof HTMLElement) {
            return element;
        }
        return this.getHostElement(element.parentNode);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.outletContext$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: OutletService }, { token: DeferLoaderService }, { token: OutletRendererService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: OutletDirective, isStandalone: false, selector: "[cxOutlet]", inputs: { cxOutlet: "cxOutlet", cxOutletContext: "cxOutletContext", cxOutletDefer: "cxOutletDefer", cxComponentRef: "cxComponentRef" }, outputs: { loaded: "loaded", cxComponentRefChange: "cxComponentRefChange" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxOutlet]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: OutletService }, { type: DeferLoaderService }, { type: OutletRendererService }], propDecorators: { cxOutlet: [{
                type: Input
            }], cxOutletContext: [{
                type: Input
            }], cxOutletDefer: [{
                type: Input
            }], loaded: [{
                type: Output
            }], cxComponentRef: [{
                type: Input
            }], cxComponentRefChange: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @private We plan to drive the outlets by standard configuration
 */
const PROVIDE_OUTLET_OPTIONS = new InjectionToken('PROVIDE_OUTLET_OPTIONS');
/**
 * Helper function to register a component for an outlet.
 *
 * @param options.id unique id of the outlet
 * @param options.component Component to be registered for the outlet
 * @param options.position Component's position in the outlet (default: `OutletPosition.AFTER`)
 */
function provideOutlet(options) {
    return {
        provide: PROVIDE_OUTLET_OPTIONS,
        useValue: options,
        multi: true,
    };
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @private
 */
function registerOutletsFactory(providedOutletOptions, componentFactoryResolver, outletService) {
    const result = () => {
        (providedOutletOptions ?? []).forEach((options) => {
            const factory = componentFactoryResolver.resolveComponentFactory(options.component);
            outletService.add(options.id, factory, options.position ?? OutletPosition.AFTER);
        });
    };
    return result;
}
class OutletModule {
    static forRoot() {
        return {
            ngModule: OutletModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: registerOutletsFactory,
                    deps: [
                        [new Optional(), PROVIDE_OUTLET_OPTIONS],
                        ComponentFactoryResolver,
                        OutletService,
                    ],
                    multi: true,
                },
            ],
        };
    }
    static forChild() {
        return {
            ngModule: OutletModule,
            providers: [
                {
                    provide: MODULE_INITIALIZER,
                    useFactory: registerOutletsFactory,
                    deps: [
                        [new Optional(), PROVIDE_OUTLET_OPTIONS],
                        ComponentFactoryResolver,
                        OutletService,
                    ],
                    multi: true,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: OutletModule, declarations: [OutletDirective], imports: [CommonModule], exports: [OutletDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [OutletDirective],
                    exports: [OutletDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletRenderStrategy extends LaunchRenderStrategy {
    constructor(document, rendererFactory, outletService, componentFactoryResolver, outletRendererService) {
        super(document, rendererFactory);
        this.document = document;
        this.rendererFactory = rendererFactory;
        this.outletService = outletService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.outletRendererService = outletRendererService;
    }
    /**
     * Renders the element in the configured outlet
     *
     * @param config
     * @param caller
     * @param vcr
     */
    render(config, caller) {
        if (this.shouldRender(caller, config)) {
            const template = this.componentFactoryResolver.resolveComponentFactory(config.component);
            this.outletService.add(config.outlet, template, config.position ? config.position : OutletPosition.BEFORE);
            this.outletRendererService.render(config.outlet);
            this.renderedCallers.push({ caller });
            return this.outletRendererService.getOutletRef(config.outlet).pipe(map((outletDirective) => {
                const components = outletDirective.renderedComponents.get(config.position ? config.position : OutletPosition.BEFORE);
                return components
                    .reverse()
                    .find((component) => component.componentType === template.componentType);
            }), tap((component) => {
                if (config?.dialogType && component) {
                    this.applyClasses(component, config?.dialogType);
                }
            }));
        }
    }
    hasMatch(config) {
        return Boolean(config.outlet);
    }
    remove(caller, config) {
        const template = this.componentFactoryResolver.resolveComponentFactory(config.component);
        this.outletService.remove(config.outlet, config.position ? config.position : OutletPosition.BEFORE, template);
        super.remove(caller, config);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRenderStrategy, deps: [{ token: DOCUMENT }, { token: i0.RendererFactory2 }, { token: OutletService }, { token: i0.ComponentFactoryResolver }, { token: OutletRendererService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRenderStrategy, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OutletRenderStrategy, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.RendererFactory2 }, { type: OutletService }, { type: i0.ComponentFactoryResolver }, { type: OutletRendererService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RoutingRenderStrategy extends LaunchRenderStrategy {
    constructor(document, rendererFactory, routingService) {
        super(document, rendererFactory);
        this.document = document;
        this.rendererFactory = rendererFactory;
        this.routingService = routingService;
    }
    /**
     * Navigates to the route configured for the caller
     */
    render(config, _caller) {
        this.routingService.go(config);
    }
    hasMatch(config) {
        return Boolean(config.cxRoute);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingRenderStrategy, deps: [{ token: DOCUMENT }, { token: i0.RendererFactory2 }, { token: i1.RoutingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingRenderStrategy, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingRenderStrategy, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.RendererFactory2 }, { type: i1.RoutingService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LaunchDialogModule {
    static forRoot() {
        return {
            ngModule: LaunchDialogModule,
            providers: [{ provide: LayoutConfig, useExisting: Config }],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LaunchDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: LaunchDialogModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LaunchDialogModule, providers: [
            {
                provide: LaunchRenderStrategy,
                useExisting: OutletRenderStrategy,
                multi: true,
            },
            {
                provide: LaunchRenderStrategy,
                useExisting: InlineRenderStrategy,
                multi: true,
            },
            {
                provide: LaunchRenderStrategy,
                useExisting: RoutingRenderStrategy,
                multi: true,
            },
            {
                provide: LaunchRenderStrategy,
                useExisting: InlineRootRenderStrategy,
                multi: true,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LaunchDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: LaunchRenderStrategy,
                            useExisting: OutletRenderStrategy,
                            multi: true,
                        },
                        {
                            provide: LaunchRenderStrategy,
                            useExisting: InlineRenderStrategy,
                            multi: true,
                        },
                        {
                            provide: LaunchRenderStrategy,
                            useExisting: RoutingRenderStrategy,
                            multi: true,
                        },
                        {
                            provide: LaunchRenderStrategy,
                            useExisting: InlineRootRenderStrategy,
                            multi: true,
                        },
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var ICON_TYPE;
(function (ICON_TYPE) {
    ICON_TYPE["ACTIVE"] = "ACTIVE";
    ICON_TYPE["ADDRESS_BOOK"] = "ADDRESS_BOOK";
    ICON_TYPE["AMEX"] = "AMEX";
    ICON_TYPE["CARET_DOWN"] = "CARET_DOWN";
    ICON_TYPE["CARET_LEFT"] = "CARET_LEFT";
    ICON_TYPE["CARET_RIGHT"] = "CARET_RIGHT";
    ICON_TYPE["CARET_UP"] = "CARET_UP";
    ICON_TYPE["CART"] = "CART";
    ICON_TYPE["CART_PLUS"] = "CART_PLUS";
    ICON_TYPE["CART_ARROW_DOWN"] = "CART_ARROW_DOWN";
    ICON_TYPE["CHECK"] = "CHECK";
    ICON_TYPE["CIRCLE"] = "CIRCLE";
    ICON_TYPE["CLIPBOARD_LIST"] = "CLIPBOARD_LIST";
    ICON_TYPE["CLOCK"] = "CLOCK";
    ICON_TYPE["CLOSE"] = "CLOSE";
    ICON_TYPE["COLLAPSE"] = "COLLAPSE";
    ICON_TYPE["CREDIT_CARD"] = "CREDIT_CARD";
    ICON_TYPE["DINERS_CLUB"] = "DINERS_CLUB";
    ICON_TYPE["DOWNLOAD"] = "DOWNLOAD";
    ICON_TYPE["EMPTY_HEART"] = "EMPTY_HEART";
    ICON_TYPE["ERROR"] = "ERROR";
    ICON_TYPE["EXPAND"] = "EXPAND";
    ICON_TYPE["EXPAND_ARROWS"] = "EXPAND_ARROWS";
    ICON_TYPE["EYE"] = "EYE";
    ICON_TYPE["EYE_SLASH"] = "EYE_SLASH";
    ICON_TYPE["FILE"] = "FILE";
    ICON_TYPE["FILTER"] = "FILTER";
    ICON_TYPE["GRID"] = "GRID";
    ICON_TYPE["HEART"] = "HEART";
    ICON_TYPE["INFO"] = "INFO";
    ICON_TYPE["LINK_OUT"] = "LINK_OUT";
    ICON_TYPE["LIST"] = "LIST";
    ICON_TYPE["MASTER_CARD"] = "MASTER_CARD";
    ICON_TYPE["OFF"] = "OFF";
    ICON_TYPE["ON"] = "ON";
    ICON_TYPE["ORDER"] = "ORDER";
    ICON_TYPE["PENCIL"] = "PENCIL";
    ICON_TYPE["RESET"] = "RESET";
    ICON_TYPE["REPEAT"] = "REPEAT";
    ICON_TYPE["SEARCH"] = "SEARCH";
    ICON_TYPE["SEARCH_PLUS"] = "SEARCH_PLUS";
    ICON_TYPE["SEARCH_MINUS"] = "SEARCH_MINUS";
    ICON_TYPE["SORT"] = "SORT";
    ICON_TYPE["SORT_AMOUNT_DOWN"] = "SORT_AMOUNT_DOWN";
    ICON_TYPE["SORT_AMOUNT_UP"] = "SORT_AMOUNT_UP";
    ICON_TYPE["SORT_DOWN"] = "SORT_DOWN";
    ICON_TYPE["STAR"] = "STAR";
    ICON_TYPE["SUCCESS"] = "SUCCESS";
    ICON_TYPE["TRASH"] = "TRASH";
    ICON_TYPE["USER_FRIENDS"] = "USER_FRIENDS";
    ICON_TYPE["VISA"] = "VISA";
    ICON_TYPE["WARNING"] = "WARNING";
    ICON_TYPE["HEADSET"] = "HEADSET";
    ICON_TYPE["ATTACHMENT"] = "ATTACHMENT";
    ICON_TYPE["UPLOAD"] = "UPLOAD";
    ICON_TYPE["USER"] = "USER";
    ICON_TYPE["USER_PLUS"] = "USER_PLUS";
    ICON_TYPE["ARROW_LEFT"] = "ARROW_LEFT";
    ICON_TYPE["ARROW_RIGHT"] = "ARROW_RIGHT";
    ICON_TYPE["ARROW_DOWN"] = "ARROW_DOWN";
    ICON_TYPE["ARROW_UP"] = "ARROW_UP";
    ICON_TYPE["C360_CIRCLE_USER"] = "C360_CIRCLE_USER";
    ICON_TYPE["C360_INVOICE"] = "C360_INVOICE";
    ICON_TYPE["HELP"] = "HELP";
})(ICON_TYPE || (ICON_TYPE = {}));
class IconConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });
/**
 * Each ICON type can have an companied resource type, such as SVG, LINK (font) or just TEXT.
 * The resources will be automatically loaded in case they're required for the `ICON_TYPE`.
 */
var IconResourceType;
(function (IconResourceType) {
    /**
     * An svg based icon requires an SVG resource that must be loaded,
     * this is typically a sprite svg file.
     */
    IconResourceType["SVG"] = "svg";
    /**
     * A font based ICON might require an additional CSS file to be loaded.
     */
    IconResourceType["LINK"] = "link";
    /**
     * Text based icons will simply add the ICON string to the DOM. Text icons do not need an image
     * or CSS pseudo class (i.e. :before), as the text itself is the icon (i.e. +)
     */
    IconResourceType["TEXT"] = "text";
})(IconResourceType || (IconResourceType = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const fontawesomeIconConfig = {
    icon: {
        symbols: {
            ACTIVE: 'fas fa-check',
            ADDRESS_BOOK: 'far fa-address-book',
            AMEX: 'fab fa-cc-amex',
            CARET_DOWN: 'fas fa-angle-down',
            CARET_LEFT: 'fas fa-angle-left',
            CARET_RIGHT: 'fas fa-angle-right',
            CARET_UP: 'fas fa-angle-up',
            CART: 'fas fa-shopping-cart',
            CART_PLUS: 'fas fa-cart-plus',
            CART_ARROW_DOWN: 'fas fa-cart-arrow-down',
            CHECK: 'fas fa-check',
            CIRCLE: 'fas fa-circle',
            CLIPBOARD_LIST: 'fas fa-clipboard-list',
            CLOCK: 'far fa-clock',
            CLOSE: 'fas fa-times',
            COLLAPSE: 'fas fa-minus',
            CREDIT_CARD: 'fas fa-credit-card',
            DINERS_CLUB: 'fab fa-cc-diners-club',
            DOWNLOAD: 'fas fa-download',
            EMPTY_HEART: 'far fa-heart',
            ERROR: 'fas fa-exclamation-circle',
            EXPAND_ARROWS: 'fas fa-expand',
            EXPAND: 'fas fa-plus',
            EYE_SLASH: 'fas fa-eye-slash',
            EYE: 'fas fa-eye',
            FILE: 'fas fa-file',
            FILTER: 'fas fa-filter',
            GRID: 'fas fa-th-large',
            HEART: 'fas fa-heart',
            INFO: 'fas fa-info-circle',
            LINK_OUT: 'fas fa-external-link-alt',
            LIST: 'fas fa-bars',
            MASTER_CARD: 'fab fa-cc-mastercard',
            OFF: 'fas fa-toggle-off',
            ON: 'fas fa-toggle-on',
            ORDER: 'fas fa-clipboard-list',
            PDF_FILE: 'fas fa-file-pdf',
            PENCIL: 'fas fa-pencil-alt',
            REPEAT: 'fas fa-retweet',
            RESET: 'fas fa-times-circle',
            SEARCH: 'fas fa-search',
            SEARCH_PLUS: 'fas fa-search-plus',
            SEARCH_MINUS: 'fas fa-search-minus',
            SORT_AMOUNT_DOWN: 'fas fa-sort-amount-down',
            SORT_AMOUNT_UP: 'fas fa-sort-amount-up',
            SORT_DOWN: 'fas fa-sort-down',
            SORT: 'fas fa-sort',
            STAR: 'fas fa-star',
            SUCCESS: 'fas fa-check-circle',
            TRASH: 'fas fa-trash',
            USER_FRIENDS: 'fas fa-user-friends',
            VISA: 'fab fa-cc-visa',
            WARNING: 'fas fa-exclamation-triangle',
            HEADSET: 'fas fa-headset',
            ATTACHMENT: 'fas fa-paperclip',
            UPLOAD: 'fas fa-upload',
            USER: 'fas fa-user',
            USER_PLUS: 'fas fa-user-plus',
            ARROW_LEFT: 'fas fa-arrow-left',
            ARROW_RIGHT: 'fas  fa-arrow-right',
            ARROW_DOWN: 'fas  fa-arrow-down',
            ARROW_UP: 'fas  fa-arrow-up',
            C360_INVOICE: 'fas fa-file-invoice',
            C360_CIRCLE_USER: 'fas fa-circle-user',
            HELP: 'far fa-circle-question',
        },
        resources: [
            {
                type: IconResourceType.LINK,
                url: '',
            },
        ],
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class IconLoaderService {
    constructor(winRef, iconConfig, sanitizer) {
        this.winRef = winRef;
        this.iconConfig = iconConfig;
        this.sanitizer = sanitizer;
        this.loadedResources = [];
    }
    /**
     * Returns an html fragment which can be added to the DOM in a safe way.
     */
    getHtml(type) {
        if (this.isResourceType(type, IconResourceType.SVG)) {
            const url = this.sanitizer.sanitize(SecurityContext.URL, this.getSvgPath(type) || null);
            if (url) {
                const useElement = this.winRef.document.createElement('use');
                useElement.setAttribute('xlink:href', url);
                const svgElement = this.winRef.document.createElement('svg');
                svgElement.appendChild(useElement);
                return this.sanitizer.bypassSecurityTrustHtml(svgElement.outerHTML);
            }
        }
        if (this.isResourceType(type, IconResourceType.TEXT)) {
            const symbol = this.getSymbol(type);
            if (symbol) {
                const helperDiv = this.winRef.document.createElement('div');
                helperDiv.textContent = symbol;
                return this.sanitizer.bypassSecurityTrustHtml(helperDiv.innerHTML);
            }
        }
    }
    /**
     * Return the direction for which the icon should mirror (ltr vs rtl). The icon direction
     * is configurable, but optional, as only a few icons should be flipped for rtl direction.
     */
    getFlipDirection(type) {
        return this.config?.flipDirection?.[type];
    }
    /**
     *
     * Returns the symbol class(es) for the icon type.
     */
    getStyleClasses(iconType) {
        return this.getSymbol(iconType) || '';
    }
    /**
     * Indicates whether the given `ICON_TYPE` is configured for
     * the given `IconResourceType`.
     */
    isResourceType(iconType, resourceType) {
        return (this.config?.resources !== undefined &&
            !!this.config.resources.find((res) => res.types && res.type === resourceType && res.types.includes(iconType)));
    }
    /**
     * Returns the path to the svg link. The link supports path names
     * as well, if the config a[[s been setup to support a svg file path.
     * Additionally, the icon prefix will be taken into account to prefix the
     * icon IDs in the SVG.
     */
    getSvgPath(iconType) {
        const svgResource = this.config?.resources?.find((res) => res.type === IconResourceType.SVG &&
            res.types &&
            res.types.includes(iconType));
        if (svgResource) {
            return svgResource.url
                ? `${svgResource.url}#${this.getSymbol(iconType)}`
                : `#${this.getSymbol(iconType)}`;
        }
    }
    /**
     * Loads the resource url (if any) for the given icon.
     * The icon will only be loaded once.
     *
     * NOTE: this is not working when the shadow is used as there's
     * no head element available and the link must be loaded for every
     * web component.
     */
    addLinkResource(iconType) {
        const resource = this.findResource(iconType, IconResourceType.LINK);
        if (resource?.url && !this.loadedResources.includes(resource.url)) {
            this.loadedResources.push(resource.url);
            // using DOM APIs, so need to sanitize our URLs manually
            const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, resource.url);
            if (sanitizedUrl) {
                const head = this.winRef.document.getElementsByTagName('head')[0];
                const link = this.winRef.document.createElement('link');
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = sanitizedUrl;
                head.appendChild(link);
            }
        }
    }
    findResource(iconType, resourceType) {
        if (!this.config?.resources) {
            return;
        }
        let resource = this.config.resources.find((res) => res.type === resourceType && res.types && res.types.includes(iconType));
        // no specific resource found, let's try to find a one-size-fits-all resource
        if (!resource) {
            resource = this.config.resources.find((res) => (res.type === resourceType && !res.types) ||
                (res.types && res.types.length === 0));
        }
        return resource;
    }
    getSymbol(iconType) {
        if (this.config && this.config.symbols && this.config.symbols[iconType]) {
            return this.config.symbols[iconType];
        }
    }
    get config() {
        return this.iconConfig.icon;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconLoaderService, deps: [{ token: i1.WindowRef }, { token: IconConfig }, { token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.WindowRef }, { type: IconConfig }, { type: i1$1.DomSanitizer }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The ltr and rtl directions can be used to configure the storefront for a certain direction, both statically
 * or dynamically.
 *
 * The HTML5 "auto" value is not supported in Spartacus, as it's considered to be too fragile for the global
 * direction.
 */
var DirectionMode;
(function (DirectionMode) {
    /**
     * Indicates Left to Right direction.
     */
    DirectionMode["LTR"] = "ltr";
    /**
     * Indicates Right to Left direction.
     */
    DirectionMode["RTL"] = "rtl";
})(DirectionMode || (DirectionMode = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 *
 * The icon component can be added in different ways:
 *
 * With the component selector:
 * `<cx-icon type="SEARCH"></cx-icon>`
 *
 * With the attribute selector:
 * `<span cxIcon="STAR"></span>`
 *
 * Additionally, content can be projected to the icon:
 *
 * `<button cxIcon="HAPPY">happy label</button>`
 *
 * The above button would become (based on a TEXT resource type):
 * `<button>😊happy label</button>`
 *
 * While the content is projected, the icon itself doesn't require an
 * additional DOM node which is an advantage over the component selector.
 */
class IconComponent {
    /**
     * The cxIcon directive is bound to the icon type. You can feed the `ICON_TYPE` to
     * accomplish a configurable button in the UI.
     */
    set cxIcon(type) {
        this.setIcon(type);
    }
    /**
     * The type input parameter is bound to the icon type. You can feed the `ICON_TYPE` to
     * accomplish a configurable button in the UI.
     */
    set type(type) {
        this.setIcon(type);
    }
    constructor(iconLoader, elementRef, renderer) {
        this.iconLoader = iconLoader;
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    setIcon(type) {
        if (!type || type === '') {
            return;
        }
        this.icon = this.iconLoader.getHtml(type);
        this.addStyleClasses(type);
        this.iconLoader.addLinkResource(type);
        this.flipIcon(type);
    }
    /**
     * The icons supports flipping for some icons to support rtl and ltr directions.
     */
    flipIcon(type) {
        // TODO: this can be dropped with the next major release.
        if (!this.iconLoader.getFlipDirection) {
            return;
        }
        const iconDirection = this.iconLoader.getFlipDirection(type);
        this.flipAtLtr = iconDirection === DirectionMode.LTR;
        this.flipAtRtl = iconDirection === DirectionMode.RTL;
    }
    /**
     * Adds the style classes and the link resource (if available).
     */
    addStyleClasses(type) {
        this.renderer.addClass(this.host, 'cx-icon');
        this.styleClasses?.forEach((cls) => this.renderer.removeClass(this.host, cls));
        this.styleClasses = this.iconLoader.getStyleClasses(type)?.split(' ');
        this.styleClasses?.forEach((cls) => {
            if (cls !== '') {
                this.renderer.addClass(this.host, cls);
            }
        });
    }
    get host() {
        return this.elementRef.nativeElement;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconComponent, deps: [{ token: IconLoaderService }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: IconComponent, isStandalone: false, selector: "cx-icon,[cxIcon]", inputs: { cxIcon: "cxIcon", type: "type" }, host: { properties: { "class.flip-at-rtl": "this.flipAtRtl", "class.flip-at-ltr": "this.flipAtLtr" } }, ngImport: i0, template: "<ng-container *ngIf=\"icon\">\n  <i [outerHTML]=\"icon\"></i>\n</ng-container>\n<ng-content></ng-content>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-icon,[cxIcon]', standalone: false, template: "<ng-container *ngIf=\"icon\">\n  <i [outerHTML]=\"icon\"></i>\n</ng-container>\n<ng-content></ng-content>\n" }]
        }], ctorParameters: () => [{ type: IconLoaderService }, { type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { cxIcon: [{
                type: Input
            }], type: [{
                type: Input
            }], flipAtRtl: [{
                type: HostBinding,
                args: ['class.flip-at-rtl']
            }], flipAtLtr: [{
                type: HostBinding,
                args: ['class.flip-at-ltr']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultIconConfig = {
    icon: {
        flipDirection: {
            CARET_RIGHT: DirectionMode.RTL,
            CARET_LEFT: DirectionMode.RTL,
        },
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class IconModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: IconModule, declarations: [IconComponent], imports: [CommonModule], exports: [IconComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconModule, providers: [
            provideDefaultConfig(defaultIconConfig),
            // TODO: move the opinionated fontawesome config to a recipe
            provideDefaultConfig(fontawesomeIconConfig),
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [IconComponent],
                    imports: [CommonModule],
                    providers: [
                        provideDefaultConfig(defaultIconConfig),
                        // TODO: move the opinionated fontawesome config to a recipe
                        provideDefaultConfig(fontawesomeIconConfig),
                    ],
                    exports: [IconComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// PRIVATE TESTING UTIL
class MockIconComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MockIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MockIconComponent, isStandalone: false, selector: "cx-icon,[cxIcon]", inputs: { cxIcon: "cxIcon", type: "type" }, ngImport: i0, template: `{{ type || cxIcon }}`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MockIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cx-icon,[cxIcon]',
                    template: `{{ type || cxIcon }}`,
                    standalone: false,
                }]
        }], propDecorators: { cxIcon: [{
                type: Input
            }], type: [{
                type: Input
            }] } });
const mockComponents = [MockIconComponent];
class MockIconLoaderService {
    getHtml() {
        // Intentional empty method
    }
    getStyleClasses() {
        // Intentional empty method
    }
    addStyleClasses() {
        // Intentional empty method
    }
    addLinkResource() {
        // Intentional empty method
    }
}
class IconTestingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconTestingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: IconTestingModule, declarations: [MockIconComponent], exports: [MockIconComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconTestingModule, providers: [
            {
                provide: IconLoaderService,
                useClass: MockIconLoaderService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: IconTestingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: mockComponents,
                    exports: mockComponents,
                    providers: [
                        {
                            provide: IconLoaderService,
                            useClass: MockIconLoaderService,
                        },
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// TODO: Improve a11y with better text appropriate to usage (example: loading cart spinner)
class SpinnerComponent {
    constructor() {
        // Intentional empty constructor
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: SpinnerComponent, isStandalone: false, selector: "cx-spinner", ngImport: i0, template: "<div class=\"loader-container\" role=\"status\">\n  <div class=\"loader\">{{ 'spinner.loading' | cxTranslate }}</div>\n</div>\n", dependencies: [{ kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-spinner', standalone: false, template: "<div class=\"loader-container\" role=\"status\">\n  <div class=\"loader\">{{ 'spinner.loading' | cxTranslate }}</div>\n</div>\n" }]
        }], ctorParameters: () => [] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsentManagementFormComponent {
    constructor() {
        this.consentGiven = false;
        this.requiredConsents = [];
        this.disabled = false;
        this.showMandatory = false;
        this.consentChanged = new EventEmitter();
        this.featureConfigService = inject(FeatureConfigService, {
            optional: true,
        });
        // Intentional empty constructor
    }
    ngOnInit() {
        this.updateConsentGiven();
    }
    ngOnChanges(changes) {
        if (this.featureConfigService?.isEnabled('updateConsentGivenInOnChanges') &&
            (changes.consent || changes.consentTemplate)) {
            this.updateConsentGiven();
        }
    }
    onConsentChange() {
        this.consentGiven = !this.consentGiven;
        this.consentChanged.emit({
            given: this.consentGiven,
            template: this.consentTemplate,
        });
    }
    isRequired(templateId) {
        return templateId ? this.requiredConsents.includes(templateId) : false;
    }
    updateConsentGiven() {
        if (this.consent) {
            this.consentGiven = Boolean(this.consent.consentState === ANONYMOUS_CONSENT_STATUS.GIVEN);
        }
        else {
            if (this.consentTemplate && this.consentTemplate.currentConsent) {
                if (this.consentTemplate.currentConsent.consentWithdrawnDate) {
                    this.consentGiven = false;
                }
                else if (this.consentTemplate.currentConsent.consentGivenDate) {
                    this.consentGiven = true;
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ConsentManagementFormComponent, isStandalone: false, selector: "cx-consent-management-form", inputs: { consentTemplate: "consentTemplate", requiredConsents: "requiredConsents", consent: "consent", disabled: "disabled", showMandatory: "showMandatory" }, outputs: { consentChanged: "consentChanged" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"form-check\">\n  <label>\n    <input\n      type=\"checkbox\"\n      class=\"form-check-input\"\n      (change)=\"onConsentChange()\"\n      [checked]=\"consentGiven\"\n      [name]=\"consentTemplate.id\"\n      [disabled]=\"disabled || isRequired(consentTemplate?.id)\"\n    />\n    <span class=\"form-check-label cx-be-bold\">\n      <ng-container *ngIf=\"consentTemplate?.name\">\n        {{ consentTemplate?.name }}\n        <br />\n      </ng-container>\n    </span>\n    <span class=\"form-check-label\">\n      {{ consentTemplate?.description }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n    </span>\n  </label>\n  <span class=\"form-check-label\">\n    {{ consentTemplate?.description }}\n    <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n  </span>\n</div>\n\n<ng-template #requiredAsterisk>\n  <ng-container *ngIf=\"showMandatory\">\n    <abbr\n      aria-hidden=\"true\"\n      class=\"text-decoration-none required-asterisk\"\n      title=\"{{ 'common.required' | cxTranslate }}\"\n      >*</abbr\n    >\n  </ng-container>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-consent-management-form', standalone: false, template: "<div class=\"form-check\">\n  <label>\n    <input\n      type=\"checkbox\"\n      class=\"form-check-input\"\n      (change)=\"onConsentChange()\"\n      [checked]=\"consentGiven\"\n      [name]=\"consentTemplate.id\"\n      [disabled]=\"disabled || isRequired(consentTemplate?.id)\"\n    />\n    <span class=\"form-check-label cx-be-bold\">\n      <ng-container *ngIf=\"consentTemplate?.name\">\n        {{ consentTemplate?.name }}\n        <br />\n      </ng-container>\n    </span>\n    <span class=\"form-check-label\">\n      {{ consentTemplate?.description }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n    </span>\n  </label>\n  <span class=\"form-check-label\">\n    {{ consentTemplate?.description }}\n    <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n  </span>\n</div>\n\n<ng-template #requiredAsterisk>\n  <ng-container *ngIf=\"showMandatory\">\n    <abbr\n      aria-hidden=\"true\"\n      class=\"text-decoration-none required-asterisk\"\n      title=\"{{ 'common.required' | cxTranslate }}\"\n      >*</abbr\n    >\n  </ng-container>\n</ng-template>\n" }]
        }], ctorParameters: () => [], propDecorators: { consentTemplate: [{
                type: Input
            }], requiredConsents: [{
                type: Input
            }], consent: [{
                type: Input
            }], disabled: [{
                type: Input
            }], showMandatory: [{
                type: Input
            }], consentChanged: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AtMessageDirective {
    constructor(elementRef, templateRef, globalMessageService) {
        this.elementRef = elementRef;
        this.templateRef = templateRef;
        this.globalMessageService = globalMessageService;
    }
    get host() {
        return !!this.templateRef
            ? this.templateRef.elementRef.nativeElement.parentElement
            : this.elementRef.nativeElement;
    }
    /**
     * Emit assistive global meesage to improve screen reader vocalization.
     * @param event
     */
    handleClick(event) {
        event?.preventDefault();
        if (event?.target === this.host && this.cxAtMessage) {
            const message = Array.isArray(this.cxAtMessage)
                ? this.cxAtMessage.join('\n')
                : this.cxAtMessage;
            this.globalMessageService
                .get()
                .pipe(take(1))
                .subscribe((globalMessageEntities) => {
                // Override current assitive message.
                if (globalMessageEntities[GlobalMessageType.MSG_TYPE_ASSISTIVE]) {
                    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ASSISTIVE);
                }
                this.globalMessageService.add(message, GlobalMessageType.MSG_TYPE_ASSISTIVE);
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AtMessageDirective, deps: [{ token: i0.ElementRef }, { token: i0.TemplateRef, optional: true }, { token: i1.GlobalMessageService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: AtMessageDirective, isStandalone: false, selector: "[cxAtMessage]", inputs: { cxAtMessage: "cxAtMessage" }, host: { listeners: { "click": "handleClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AtMessageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxAtMessage]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.TemplateRef, decorators: [{
                    type: Optional
                }] }, { type: i1.GlobalMessageService }], propDecorators: { cxAtMessage: [{
                type: Input
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MessageComponent {
    constructor() {
        this.showBody = false;
        this.isVisibleCloseButton = true;
        this.closeMessage = new EventEmitter();
        this.buttonAction = new EventEmitter();
        this.iconTypes = ICON_TYPE;
        // Intentional empty constructor
    }
    get getCssClassesForMessage() {
        return {
            'cx-message-success': this.type === GlobalMessageType.MSG_TYPE_CONFIRMATION,
            'cx-message-info': this.type === GlobalMessageType.MSG_TYPE_INFO,
            'cx-message-warning': this.type === GlobalMessageType.MSG_TYPE_WARNING,
            'cx-message-danger': this.type === GlobalMessageType.MSG_TYPE_ERROR,
        };
    }
    get getIconType() {
        switch (this.type) {
            case GlobalMessageType.MSG_TYPE_WARNING:
                return ICON_TYPE.WARNING;
            case GlobalMessageType.MSG_TYPE_ERROR:
                return ICON_TYPE.ERROR;
            case GlobalMessageType.MSG_TYPE_INFO:
                return ICON_TYPE.INFO;
            default:
                return ICON_TYPE.SUCCESS;
        }
    }
    ngAfterViewInit() {
        if (this.accordionText || this.actionButtonText) {
            this.messageContainer?.nativeElement.focus();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MessageComponent, isStandalone: false, selector: "cx-message", inputs: { text: "text", actionButtonText: "actionButtonText", actionButtonMessage: "actionButtonMessage", accordionText: "accordionText", showBody: "showBody", isVisibleCloseButton: "isVisibleCloseButton", type: "type" }, outputs: { closeMessage: "closeMessage", buttonAction: "buttonAction" }, viewQueries: [{ propertyName: "messageContainer", first: true, predicate: ["messageContainer"], descendants: true }], ngImport: i0, template: "<div\n  #messageContainer\n  [ngClass]=\"getCssClassesForMessage\"\n  class=\"cx-message\"\n  tabindex=\"0\"\n>\n  <div class=\"cx-message-content\">\n    <div role=\"presentation\" class=\"cx-message-header\">\n      <span role=\"presentation\" class=\"cx-message-icon\">\n        <cx-icon role=\"presentation\" [type]=\"getIconType\"></cx-icon>\n      </span>\n\n      <span class=\"cx-message-text\">\n        {{ text }}\n      </span>\n\n      <button\n        *ngIf=\"accordionText\"\n        (click)=\"showBody = !showBody\"\n        [attr.aria-expanded]=\"showBody\"\n        [attr.aria-label]=\"accordionText\"\n        class=\"cx-message-accordion-button link cx-action-link\"\n        type=\"button\"\n      >\n        {{ accordionText }}\n        <cx-icon\n          [type]=\"showBody ? 'CARET_UP' : 'CARET_DOWN'\"\n          class=\"cx-message-accordion-icon\"\n        ></cx-icon>\n      </button>\n\n      <button\n        *ngIf=\"actionButtonText\"\n        (click)=\"buttonAction.emit()\"\n        [cxAtMessage]=\"actionButtonMessage\"\n        class=\"btn btn-link cx-action-link\"\n        type=\"button\"\n      >\n        {{ actionButtonText }}\n      </button>\n\n      <button\n        *ngIf=\"isVisibleCloseButton\"\n        (click)=\"closeMessage.emit()\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        [cxAtMessage]=\"'common.close' | cxTranslate\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        class=\"close\"\n        type=\"button\"\n      >\n        <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n      </button>\n    </div>\n\n    <div *ngIf=\"showBody || !accordionText\" class=\"cx-message-body\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: AtMessageDirective, selector: "[cxAtMessage]", inputs: ["cxAtMessage"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-message', standalone: false, template: "<div\n  #messageContainer\n  [ngClass]=\"getCssClassesForMessage\"\n  class=\"cx-message\"\n  tabindex=\"0\"\n>\n  <div class=\"cx-message-content\">\n    <div role=\"presentation\" class=\"cx-message-header\">\n      <span role=\"presentation\" class=\"cx-message-icon\">\n        <cx-icon role=\"presentation\" [type]=\"getIconType\"></cx-icon>\n      </span>\n\n      <span class=\"cx-message-text\">\n        {{ text }}\n      </span>\n\n      <button\n        *ngIf=\"accordionText\"\n        (click)=\"showBody = !showBody\"\n        [attr.aria-expanded]=\"showBody\"\n        [attr.aria-label]=\"accordionText\"\n        class=\"cx-message-accordion-button link cx-action-link\"\n        type=\"button\"\n      >\n        {{ accordionText }}\n        <cx-icon\n          [type]=\"showBody ? 'CARET_UP' : 'CARET_DOWN'\"\n          class=\"cx-message-accordion-icon\"\n        ></cx-icon>\n      </button>\n\n      <button\n        *ngIf=\"actionButtonText\"\n        (click)=\"buttonAction.emit()\"\n        [cxAtMessage]=\"actionButtonMessage\"\n        class=\"btn btn-link cx-action-link\"\n        type=\"button\"\n      >\n        {{ actionButtonText }}\n      </button>\n\n      <button\n        *ngIf=\"isVisibleCloseButton\"\n        (click)=\"closeMessage.emit()\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        [cxAtMessage]=\"'common.close' | cxTranslate\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        class=\"close\"\n        type=\"button\"\n      >\n        <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n      </button>\n    </div>\n\n    <div *ngIf=\"showBody || !accordionText\" class=\"cx-message-body\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { text: [{
                type: Input
            }], actionButtonText: [{
                type: Input
            }], actionButtonMessage: [{
                type: Input
            }], accordionText: [{
                type: Input
            }], showBody: [{
                type: Input
            }], isVisibleCloseButton: [{
                type: Input
            }], type: [{
                type: Input
            }], closeMessage: [{
                type: Output
            }], buttonAction: [{
                type: Output
            }], messageContainer: [{
                type: ViewChild,
                args: ['messageContainer']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentDialogComponent {
    handleClick(event) {
        // Close on click outside the dialog window
        if (event.target.tagName === this.el.nativeElement.tagName) {
            this.close('Cross click');
        }
    }
    constructor(config, anonymousConsentsService, el, launchDialogService) {
        this.config = config;
        this.anonymousConsentsService = anonymousConsentsService;
        this.el = el;
        this.launchDialogService = launchDialogService;
        this.subscriptions = new Subscription();
        this.featureConfigService = inject(FeatureConfigService);
        this.showLegalDescription = true;
        this.iconTypes = ICON_TYPE;
        this.requiredConsents = [];
        this.focusConfig = {
            trap: true,
            block: true,
            autofocus: 'input[type="checkbox"]',
            focusOnEscape: true,
        };
        this.globalMessageService = inject(GlobalMessageService, {
            optional: true,
        });
        this.globalMessageType = GlobalMessageType;
        this.message$ = new Subject();
        if (this.config.anonymousConsents) {
            this.showLegalDescription =
                this.config.anonymousConsents.showLegalDescriptionInDialog;
            if (this.config.anonymousConsents.requiredConsents) {
                this.requiredConsents = this.config.anonymousConsents.requiredConsents;
            }
        }
        useFeatureStyles('a11yAnonymousConsentMessageInDialog');
    }
    ngOnInit() {
        this.templates$ = this.anonymousConsentsService.getTemplates();
        this.consents$ = this.anonymousConsentsService.getConsents();
        this.loading$ = this.anonymousConsentsService.getLoadTemplatesLoading();
    }
    close(reason) {
        this.launchDialogService.closeDialog(reason);
    }
    rejectAll() {
        this.subscriptions.add(combineLatest([this.templates$, this.consents$])
            .pipe(take(1), distinctUntilChanged(), tap(([templates, consents]) => templates.forEach((template) => {
            const consent = this.getCorrespondingConsent(template, consents);
            if (consent &&
                this.anonymousConsentsService.isConsentGiven(consent)) {
                if (this.isRequiredConsent(template)) {
                    return;
                }
                if (template.id) {
                    this.anonymousConsentsService.withdrawConsent(template.id);
                }
            }
        })))
            .subscribe(() => this.onConsentWithdrawnSuccess()));
        if (!this.featureConfigService.isEnabled('a11yAnonymousConsentMessageInDialog')) {
            this.close('rejectAll');
        }
    }
    allowAll() {
        this.subscriptions.add(combineLatest([this.templates$, this.consents$])
            .pipe(take(1), distinctUntilChanged(), tap(([templates, consents]) => templates.forEach((template) => {
            const consent = this.getCorrespondingConsent(template, consents);
            if (consent &&
                (consent.consentState == null ||
                    this.anonymousConsentsService.isConsentWithdrawn(consent))) {
                if (this.isRequiredConsent(template)) {
                    return;
                }
                if (template.id) {
                    this.anonymousConsentsService.giveConsent(template.id);
                }
            }
        })))
            .subscribe(() => this.onConsentGivenSuccess()));
        if (!this.featureConfigService.isEnabled('a11yAnonymousConsentMessageInDialog')) {
            this.close('allowAll');
        }
    }
    isRequiredConsent(template) {
        return Boolean(template.id &&
            this.config.anonymousConsents?.requiredConsents &&
            this.config.anonymousConsents.requiredConsents.includes(template.id));
    }
    onConsentChange({ given, template, }) {
        if (template.id) {
            if (given) {
                this.anonymousConsentsService.giveConsent(template.id);
                this.onConsentGivenSuccess();
            }
            else {
                this.anonymousConsentsService.withdrawConsent(template.id);
                this.onConsentWithdrawnSuccess();
            }
        }
    }
    getCorrespondingConsent(template, consents = []) {
        for (const consent of consents) {
            if (template.id === consent.templateCode) {
                return consent;
            }
        }
        return null;
    }
    onConsentGivenSuccess() {
        if (this.featureConfigService.isEnabled('a11yAnonymousConsentMessageInDialog')) {
            this.message$.next({
                type: GlobalMessageType.MSG_TYPE_CONFIRMATION,
                key: 'consentManagementForm.message.success.given',
            });
        }
        else {
            this.globalMessageService?.add({ key: 'consentManagementForm.message.success.given' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
        }
    }
    onConsentWithdrawnSuccess() {
        if (this.featureConfigService.isEnabled('a11yAnonymousConsentMessageInDialog')) {
            this.message$.next({
                type: GlobalMessageType.MSG_TYPE_CONFIRMATION,
                key: 'consentManagementForm.message.success.withdrawn',
            });
        }
        else {
            this.globalMessageService?.add({ key: 'consentManagementForm.message.success.withdrawn' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
        }
    }
    closeMessage() {
        this.message$.next(null);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentDialogComponent, deps: [{ token: i1.AnonymousConsentsConfig }, { token: i1.AnonymousConsentsService }, { token: i0.ElementRef }, { token: LaunchDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: AnonymousConsentDialogComponent, isStandalone: false, selector: "cx-anonymous-consent-dialog", host: { listeners: { "click": "handleClick($event)" } }, ngImport: i0, template: "<div\n  class=\"modal-dialog modal-dialog-centered modal-lg cx-anonymous-consent-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content cx-dialog-content\">\n    <div *ngIf=\"loading$ | async; else dialogBody\">\n      <cx-spinner></cx-spinner>\n    </div>\n    <ng-template #dialogBody>\n      <div class=\"modal-header cx-dialog-header\">\n        <h3 id=\"dialogTitle\">\n          {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n        </h3>\n        <button\n          type=\"button\"\n          class=\"close\"\n          title=\"{{ 'common.close' | cxTranslate }}\"\n          [attr.aria-label]=\"'common.close' | cxTranslate\"\n          (click)=\"close('Cross click')\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n      <!-- Separator -->\n      <div class=\"cx-dialog-description\" *ngIf=\"showLegalDescription\">\n        {{ 'anonymousConsents.dialog.legalDescription' | cxTranslate }}\n        <div\n          class=\"cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none\"\n        ></div>\n      </div>\n\n      <ng-container *cxFeature=\"'a11yAnonymousConsentMessageInDialog'\">\n        <div class=\"cx-dialog-message\" aria-live=\"assertive\" aria-atomic=\"true\">\n          <cx-message\n            *ngIf=\"message$ | async as message\"\n            [text]=\"message.key | cxTranslate\"\n            [type]=\"message.type\"\n            [isVisibleCloseButton]=\"true\"\n            (closeMessage)=\"closeMessage()\"\n            [cxFocus]=\"{ autofocus: '.cx-message' }\"\n          ></cx-message>\n        </div>\n      </ng-container>\n      <!-- Actions -->\n      <div class=\"cx-dialog-buttons\">\n        <button class=\"btn btn-link cx-action-link\" (click)=\"rejectAll()\">\n          {{ 'anonymousConsents.dialog.clearAll' | cxTranslate }}\n        </button>\n        <button class=\"btn btn-link cx-action-link\" (click)=\"allowAll()\">\n          {{ 'anonymousConsents.dialog.selectAll' | cxTranslate }}\n        </button>\n      </div>\n      <!-- Modal Body -->\n      <div\n        class=\"modal-body cx-dialog-body\"\n        *ngIf=\"templates$ | async as templates\"\n      >\n        <ng-container *ngIf=\"consents$ | async as consents\">\n          <div\n            class=\"cx-dialog-row col-sm-12 col-md-6\"\n            *ngFor=\"let template of templates\"\n          >\n            <cx-consent-management-form\n              [consentTemplate]=\"template\"\n              [requiredConsents]=\"requiredConsents\"\n              [consent]=\"getCorrespondingConsent(template, consents)\"\n              (consentChanged)=\"onConsentChange($event)\"\n            ></cx-consent-management-form>\n          </div>\n        </ng-container>\n      </div>\n    </ng-template>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "component", type: ConsentManagementFormComponent, selector: "cx-consent-management-form", inputs: ["consentTemplate", "requiredConsents", "consent", "disabled", "showMandatory"], outputs: ["consentChanged"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "component", type: MessageComponent, selector: "cx-message", inputs: ["text", "actionButtonText", "actionButtonMessage", "accordionText", "showBody", "isVisibleCloseButton", "type"], outputs: ["closeMessage", "buttonAction"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-anonymous-consent-dialog', standalone: false, template: "<div\n  class=\"modal-dialog modal-dialog-centered modal-lg cx-anonymous-consent-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content cx-dialog-content\">\n    <div *ngIf=\"loading$ | async; else dialogBody\">\n      <cx-spinner></cx-spinner>\n    </div>\n    <ng-template #dialogBody>\n      <div class=\"modal-header cx-dialog-header\">\n        <h3 id=\"dialogTitle\">\n          {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n        </h3>\n        <button\n          type=\"button\"\n          class=\"close\"\n          title=\"{{ 'common.close' | cxTranslate }}\"\n          [attr.aria-label]=\"'common.close' | cxTranslate\"\n          (click)=\"close('Cross click')\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n      <!-- Separator -->\n      <div class=\"cx-dialog-description\" *ngIf=\"showLegalDescription\">\n        {{ 'anonymousConsents.dialog.legalDescription' | cxTranslate }}\n        <div\n          class=\"cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none\"\n        ></div>\n      </div>\n\n      <ng-container *cxFeature=\"'a11yAnonymousConsentMessageInDialog'\">\n        <div class=\"cx-dialog-message\" aria-live=\"assertive\" aria-atomic=\"true\">\n          <cx-message\n            *ngIf=\"message$ | async as message\"\n            [text]=\"message.key | cxTranslate\"\n            [type]=\"message.type\"\n            [isVisibleCloseButton]=\"true\"\n            (closeMessage)=\"closeMessage()\"\n            [cxFocus]=\"{ autofocus: '.cx-message' }\"\n          ></cx-message>\n        </div>\n      </ng-container>\n      <!-- Actions -->\n      <div class=\"cx-dialog-buttons\">\n        <button class=\"btn btn-link cx-action-link\" (click)=\"rejectAll()\">\n          {{ 'anonymousConsents.dialog.clearAll' | cxTranslate }}\n        </button>\n        <button class=\"btn btn-link cx-action-link\" (click)=\"allowAll()\">\n          {{ 'anonymousConsents.dialog.selectAll' | cxTranslate }}\n        </button>\n      </div>\n      <!-- Modal Body -->\n      <div\n        class=\"modal-body cx-dialog-body\"\n        *ngIf=\"templates$ | async as templates\"\n      >\n        <ng-container *ngIf=\"consents$ | async as consents\">\n          <div\n            class=\"cx-dialog-row col-sm-12 col-md-6\"\n            *ngFor=\"let template of templates\"\n          >\n            <cx-consent-management-form\n              [consentTemplate]=\"template\"\n              [requiredConsents]=\"requiredConsents\"\n              [consent]=\"getCorrespondingConsent(template, consents)\"\n              (consentChanged)=\"onConsentChange($event)\"\n            ></cx-consent-management-form>\n          </div>\n        </ng-container>\n      </div>\n    </ng-template>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.AnonymousConsentsConfig }, { type: i1.AnonymousConsentsService }, { type: i0.ElementRef }, { type: LaunchDialogService }], propDecorators: { globalMessageService: [{
                type: Optional
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultAnonymousConsentLayoutConfig = {
    launch: {
        ANONYMOUS_CONSENT: {
            inlineRoot: true,
            component: AnonymousConsentDialogComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentOpenDialogComponent {
    constructor(vcr, anonymousConsentsService, launchDialogService) {
        this.vcr = vcr;
        this.anonymousConsentsService = anonymousConsentsService;
        this.launchDialogService = launchDialogService;
        this.bannerVisible$ = this.anonymousConsentsService.isBannerVisible();
        useFeatureStyles('a11yHideConsentButtonWhenBannerVisible');
    }
    openDialog() {
        const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.ANONYMOUS_CONSENT, this.openElement, this.vcr);
        if (dialog) {
            dialog.pipe(take(1)).subscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentOpenDialogComponent, deps: [{ token: i0.ViewContainerRef }, { token: i1.AnonymousConsentsService }, { token: LaunchDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: AnonymousConsentOpenDialogComponent, isStandalone: false, selector: "cx-anonymous-consent-open-dialog", viewQueries: [{ propertyName: "openElement", first: true, predicate: ["open"], descendants: true }], ngImport: i0, template: "<ng-container *cxFeature=\"'!a11yHideConsentButtonWhenBannerVisible'\">\n  <button #open class=\"btn btn-link\" (click)=\"openDialog()\">\n    {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n  </button>\n</ng-container>\n\n<ng-container *cxFeature=\"'a11yHideConsentButtonWhenBannerVisible'\">\n  <button\n    *ngIf=\"!(bannerVisible$ | async)\"\n    #open\n    class=\"btn btn-link\"\n    (click)=\"openDialog()\"\n  >\n    {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n  </button>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentOpenDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-anonymous-consent-open-dialog', standalone: false, template: "<ng-container *cxFeature=\"'!a11yHideConsentButtonWhenBannerVisible'\">\n  <button #open class=\"btn btn-link\" (click)=\"openDialog()\">\n    {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n  </button>\n</ng-container>\n\n<ng-container *cxFeature=\"'a11yHideConsentButtonWhenBannerVisible'\">\n  <button\n    *ngIf=\"!(bannerVisible$ | async)\"\n    #open\n    class=\"btn btn-link\"\n    (click)=\"openDialog()\"\n  >\n    {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n  </button>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i1.AnonymousConsentsService }, { type: LaunchDialogService }], propDecorators: { openElement: [{
                type: ViewChild,
                args: ['open']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentManagementBannerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentManagementBannerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentManagementBannerModule, declarations: [AnonymousConsentManagementBannerComponent,
            AnonymousConsentOpenDialogComponent], imports: [CommonModule,
            I18nModule,
            KeyboardFocusModule,
            FeaturesConfigModule], exports: [AnonymousConsentManagementBannerComponent,
            AnonymousConsentOpenDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentManagementBannerModule, providers: [
            provideDefaultConfig(defaultAnonymousConsentLayoutConfig),
            provideDefaultConfig({
                cmsComponents: {
                    AnonymousConsentManagementBannerComponent: {
                        component: AnonymousConsentManagementBannerComponent,
                        deferLoading: DeferLoadingStrategy.INSTANT,
                    },
                    AnonymousConsentOpenDialogComponent: {
                        component: AnonymousConsentOpenDialogComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            I18nModule,
            KeyboardFocusModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentManagementBannerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        I18nModule,
                        KeyboardFocusModule,
                        FeaturesConfigModule,
                    ],
                    providers: [
                        provideDefaultConfig(defaultAnonymousConsentLayoutConfig),
                        provideDefaultConfig({
                            cmsComponents: {
                                AnonymousConsentManagementBannerComponent: {
                                    component: AnonymousConsentManagementBannerComponent,
                                    deferLoading: DeferLoadingStrategy.INSTANT,
                                },
                                AnonymousConsentOpenDialogComponent: {
                                    component: AnonymousConsentOpenDialogComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [
                        AnonymousConsentManagementBannerComponent,
                        AnonymousConsentOpenDialogComponent,
                    ],
                    exports: [
                        AnonymousConsentManagementBannerComponent,
                        AnonymousConsentOpenDialogComponent,
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultLcpCmsComponentsConfig = {
    lcpCmsComponents: {
        idMarker: '__cxLCP__',
        ids: [],
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsLcpModule {
    static forRoot() {
        return {
            ngModule: CmsLcpModule,
            providers: [provideDefaultConfig(defaultLcpCmsComponentsConfig)],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsLcpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: CmsLcpModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsLcpModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsLcpModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Tells whether the component contains LCP (Largest Contentful Paint) element.
 */
var LcpPresence;
(function (LcpPresence) {
    LcpPresence["HAS_LCP"] = "HAS_LCP";
    LcpPresence["NO_LCP"] = "NO_LCP";
})(LcpPresence || (LcpPresence = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Configuration for recognizing which CMS components are containing
 * the LCP (Largest Contentful Paint) element.
 */
class LcpCmsComponentsConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpCmsComponentsConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpCmsComponentsConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpCmsComponentsConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsLcpService {
    constructor() {
        this.config = inject(LcpCmsComponentsConfig);
    }
    /**
     * Tells whether the given CMS component is marked as containing
     * the LCP (Largest Contentful Paint) element.
     *
     * The list of CMS component IDs can be specified in 2 ways:
     * - statically in the Spartacus configuration `config.lcpCmsComponents.ids`
     * - and dynamically configuring a special marker `config.lcpCmsComponentIdMarker`
     *    (i.e. when the CMS component ID contains a specific marker, for example "__cxLCP__").
     *
     * If a certain component is shared across multiple pages, but it's the LCP only on some of them,
     * you can extend this service to implement custom logic. The following is an example of marking
     * a 'SharedBanner` component as LCP only on the homepage, but not on other pages:
     * ```typescript
     * export class CustomCmsLcpService extends CmsLcpService {
     *   routingService = inject(RoutingService);
     *   getLcpPresence(
     *     componentData: ContentSlotComponentData
     *   ): Observable<LcpPresence> {
     *     return this.routingService.getRouterState().pipe(
     *       switchMap((routerState) => {
     *         const semanticRoute = routerState?.state?.semanticRoute;
     *         if (componentData?.uid === 'SharedBanner') {
     *           return of(
     *             semanticRoute === 'home' ? LcpPresence.HAS_LCP : LcpPresence.NO_LCP
     *           );
     *         }
     *         return super.getLcpPresence(componentData);
     *       })
     *     );
     *   }
     * }
     * ```
     */
    getLcpPresence(componentData) {
        const idMarker = this.config?.lcpCmsComponents?.idMarker;
        const ids = this.config?.lcpCmsComponents?.ids || [];
        // Check if ID contains a special marker
        if (idMarker && componentData?.uid?.includes(idMarker)) {
            return of(LcpPresence.HAS_LCP);
        }
        // Check if ID is on the configured list of IDs
        if (ids?.length && componentData?.uid && ids.includes(componentData?.uid)) {
            return of(LcpPresence.HAS_LCP);
        }
        return of(LcpPresence.NO_LCP);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsLcpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsLcpService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsLcpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const DEFAULT_LCP_PRESENCE = of(LcpPresence.NO_LCP);
/**
 * Tells whether the component contains LCP (Largest Contentful Paint) element in its sub-tree.
 *
 * It's provided on DOM level by an ancestor component (likely a CMS component)
 *
 * A descendant component can use this context for possible performance optimizations
 * related to LCP (Largest Contentful Paint) element.
 *
 * Note: It's also provided in root injector with default fallback value of `LcpPresence.NO_LCP`,
 * to avoid errors when no ancestor component provides it.
 */
const LCP_PRESENCE = new InjectionToken('LCP_PRESENCE', {
    providedIn: 'root',
    factory: () => DEFAULT_LCP_PRESENCE,
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsComponentData {
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides the information whether the given CMS component contains the LCP (Largest Contentful Paint) element,
 * based on the `CmsComponentData` injection token.
 *
 * It's used in the `CmsInjectorService` to provide the `LCP_PRESENCE` at the DOM level of each CMS component.
 */
const provideLcpPresenceForCmsComponent = () => {
    return {
        provide: LCP_PRESENCE,
        useFactory: () => {
            const cmsComponentData = inject(CmsComponentData);
            const cmsLcpService = inject(CmsLcpService);
            return cmsComponentData.data$.pipe(switchMap((componentData) => cmsLcpService.getLcpPresence(componentData)), distinctUntilChanged$1(), shareReplay({ bufferSize: 1, refCount: true }));
        },
    };
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Utility service for running multiple guards and composing their results
 * into a single result observable.
 */
class GuardsComposer {
    /**
     * Executes guards, returning an Observable that:
     * - emits `true` if all those guards pass (emit `true`)
     * - emits `false` or `UrlTree` immediately if any those guards fails (returns `false` or `UrlTree`)
     *
     * This is in line with the default Angular behavior.
     */
    canActivate(guards, route, state) {
        if (guards.length) {
            const canActivateObservables = guards.map((guard) => this.canActivateGuard(guard, route, state));
            return this.composeCanActivateObservables(canActivateObservables);
        }
        return of(true);
    }
    /**
     * Executes a guard's `canActivate` method with `route` and `state`,
     * returning its result as an Observable.
     *
     * Converts non-Observable results (Promise or static value) into Observable.
     */
    canActivateGuard(guard, route, state) {
        if (this.isCanActivate(guard)) {
            return wrapIntoObservable(guard.canActivate(route, state)).pipe(first$1());
        }
        else {
            throw new Error('Invalid CanActivate guard');
        }
    }
    /**
     * Composes the given observables into a single observable that emits a boolean or an UrlTree.
     *
     * The returned composed observable:
     * - emits `true` after all the given observables emit `true`.
     * - emits `false` or `UrlTree` as soon as any of the given observables emit such a value (`false` or `UrlTree`).
     */
    composeCanActivateObservables(canActivateObservables) {
        return concat(...canActivateObservables).pipe(skipWhile((canActivate) => canActivate === true), endWith(true), first$1());
    }
    /**
     * Tells whether the given object has a `canActivate` method.
     */
    isCanActivate(guard) {
        return guard && typeof guard.canActivate === 'function';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GuardsComposer, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GuardsComposer, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GuardsComposer, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Guards that run on all CMS-driven routes before executing `{@link CmsPageGuard}`'s main logic.
 *
 *  **CAUTION**: Suitable for global guards ONLY! For route-specific guards, configure them under `cmsComponents`:
 * ```ts
 * provideConfig({
 *   cmsComponents: {
 *     [SomeCmsComponentType]: { guards: [MyGuard] }
 *   }
 * })
 * ```
 */
const BEFORE_CMS_PAGE_GUARD = new InjectionToken('BEFORE_CMS_PAGE_GUARD', { providedIn: 'root', factory: () => [] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service that executes guards provided via the injection token `BEFORE_CMS_PAGE_GUARD`.
 */
class BeforeCmsPageGuardService {
    constructor() {
        this.guards = inject(BEFORE_CMS_PAGE_GUARD);
        this.guardsComposer = inject(GuardsComposer);
    }
    /**
     * Executes guards from `BEFORE_CMS_PAGE_GUARD` token, returning an Observable that:
     * - emits `true` if all those guards pass (emit `true`)
     * - emits `false` or `UrlTree` immediately if any those guards fails (returns `false` or `UrlTree`)
     */
    canActivate(route, state) {
        return this.guardsComposer.canActivate(this.guards, route, state);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BeforeCmsPageGuardService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BeforeCmsPageGuardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BeforeCmsPageGuardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const PAGE_LAYOUT_HANDLER = new InjectionToken('PageLayoutHandler');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `BreakpointService` resolves the various screen sizes that are used in
 * the storefront. The screen sizes are globally configurable based on your
 * layout requirements. You can adjust the screen sizes by setting the minimum
 * and/or maximum size for a breakpoint, as well as extending the configuration
 * with new screens.
 *
 * By default, the `BreakpointService` is based on the breakpoints from the
 * Bootstrap ui library:
 * - `xs`: < 576px
 * - `sm`: 576px - 767px
 * - `md`: 768px - 991px
 * - `lg`: 992px - 1199px
 * - `xl`: >= 1200px
 */
class BreakpointService {
    constructor(winRef, layoutConfig, platform) {
        this.winRef = winRef;
        this.layoutConfig = layoutConfig;
        this.platform = platform;
        this.breakpoint$ = isPlatformBrowser(this.platform)
            ? this.winRef.resize$.pipe(map((event) => this.getBreakpoint(event.target.innerWidth)), distinctUntilChanged(), shareReplay$1({ refCount: true, bufferSize: 1 }))
            : of(this.fallbackBreakpoint);
    }
    /**
     * Returns the breakpoints for the storefront layout.
     *
     * The breakpoints are driven by the `LayoutConfig.breakpoints` and sorted based on
     * the given screen size.
     */
    get breakpoints() {
        if (!this._breakpoints) {
            this._breakpoints = this.resolveBreakpointsFromConfig();
        }
        return this._breakpoints;
    }
    /**
     * Returns the _maximum_ size for the breakpoint, given by the `LayoutConfig.breakpoints`
     * configuration.
     */
    getSize(breakpoint) {
        return (this.getMaxSize(breakpoint) ??
            // if there's no direct max value or explicit max value
            // we must derive the max value from the previous min
            this.getMinSize(this.breakpoints?.[this.breakpoints.indexOf(breakpoint) + 1]));
    }
    /**
     * Indicates whether the current screen size is smaller than the maximum size of the
     * given breakpoint.
     *
     * If the given breakpoint is `BREAKPOINT.md`, the method returns `true` when the
     * window innerWidth is smaller than the configured size of `BREAKPOINT.md`.
     */
    isDown(breakpoint) {
        return this.breakpoint$.pipe(map((br) => this.breakpoints
            .slice(0, this.breakpoints.indexOf(breakpoint) + 1)
            .includes(br)));
    }
    /**
     * Indicates whether the current screen size is larger than the minimum size of the
     * given breakpoint.
     *
     * If the given breakpoint is `BREAKPOINT.md`, the method returns `true` when the
     * window innerWidth is larger than the configured size of `BREAKPOINT.sm`.
     */
    isUp(breakpoint) {
        return this.breakpoint$.pipe(map((br) => this.breakpoints
            .slice(this.breakpoints.indexOf(breakpoint))
            .includes(br)));
    }
    /**
     * Indicates whether the given breakpoint fits in the current screen size.
     */
    isEqual(breakpoint) {
        return this.breakpoint$.pipe(map((br) => br === breakpoint));
    }
    /**
     * Returns the fallback breakpoint in case no breakpoint can be resolved. This is
     * typically the case when we're on SSR without an actual window.
     *
     * Returns the smallest screen size (mobile first).
     */
    get fallbackBreakpoint() {
        return this.breakpoints?.[0];
    }
    /**
     * Resolves the breakpoints and sorts them according to the configured size.
     *
     * The sort order is by small to large screens.
     */
    resolveBreakpointsFromConfig() {
        const sortByScreenSize = (next, prev) => {
            const nextMinSize = this.getMinSize(next);
            const maxNext = Math.max(nextMinSize ? nextMinSize + 1 : 0, this.getMaxSize(next) || 0);
            const preMinSize = this.getMinSize(prev);
            const maxPrev = Math.max(preMinSize ? preMinSize + 1 : 0, this.getMaxSize(prev) || 0);
            return maxNext < maxPrev ? -1 : 0;
        };
        return Object.keys(this.config).sort(sortByScreenSize);
    }
    /**
     * Returns the _maximum_ size for the breakpoint, given by the
     * `LayoutConfig.breakpoints` configuration. We will try to resolve the
     * max size form the current breakpoint, but if this is not available, we
     * resolve it form the next breakpoint
     */
    getMaxSize(breakpoint) {
        const breakpointConfig = this.config[breakpoint];
        if (!breakpointConfig) {
            return null;
        }
        // we treat numbers as the max number by default
        if (typeof breakpointConfig === 'number') {
            return breakpointConfig;
        }
        else if (breakpointConfig.max) {
            return breakpointConfig.max;
        }
        else {
            return null;
        }
    }
    getMinSize(breakpoint) {
        return this.config[breakpoint]?.min ?? null;
    }
    /**
     * Returns a `BREAKPOINT` for the given window size.
     *
     * This method tries to match the closest breakpoint for the given
     * window size. We'll fallback to the `largest` size in case the window
     * is greater than the largest configurable breakpoint.
     *
     * The windowWidth should be smaller than the maximum size of any of the
     * screen sizes defined in the `LayoutConfig.breakpoints`.
     */
    getBreakpoint(windowWidth) {
        return (this.breakpoints.find((br) => {
            const size = this.getSize(br);
            return size !== null && windowWidth < size;
        }) ?? this.breakpoints?.[this.breakpoints.length - 1]);
    }
    /**
     * Helper method to return the breakpoint configuration.
     */
    get config() {
        return this.layoutConfig?.breakpoints || {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreakpointService, deps: [{ token: i1.WindowRef }, { token: LayoutConfig }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreakpointService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreakpointService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.WindowRef }, { type: LayoutConfig }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageLayoutService {
    constructor(cms, config, breakpointService, unifiedInjector) {
        this.cms = cms;
        this.config = config;
        this.breakpointService = breakpointService;
        this.unifiedInjector = unifiedInjector;
        this.subscription = new Subscription();
        this.logger = inject(LoggerService);
        // Prints warn messages for missing layout configs.
        // The warnings are only printed once per config
        // to not pollute the console log.
        this.warnLogMessages = {};
        this.logSlots = {};
        this.subscription.add(this.unifiedInjector
            .getMulti(PAGE_LAYOUT_HANDLER)
            .subscribe((handlers) => (this.handlers = handlers)));
    }
    getSlots(section) {
        return combineLatest([this.page$, this.breakpointService.breakpoint$]).pipe(map(([page, breakpoint]) => {
            const pageTemplate = page.template;
            const slots = this.resolveSlots(page, section, breakpoint);
            return { slots, pageTemplate, breakpoint };
        }), switchMap$1(({ slots, pageTemplate, breakpoint }) => {
            let result = of(slots);
            for (const handler of this.handlers || []) {
                result = handler.handle(result, pageTemplate, section, breakpoint);
            }
            return result;
        }), distinctUntilChanged((a, b) => {
            if (a.length !== b.length) {
                return false;
            }
            for (let i = 0; i < a.length; i++) {
                if (a[i] !== b[i]) {
                    return false;
                }
            }
            return true;
        }));
    }
    /**
     * Returns an observable with the last page slot above-the-fold
     * for the given pageTemplate / breakpoint.
     *
     * The page fold is configurable in the `LayoutConfig` for each page layout.
     */
    getPageFoldSlot(pageTemplate) {
        return this.breakpointService.breakpoint$.pipe(map((breakpoint) => {
            if (!this.config.layoutSlots) {
                // no layout config available
                return undefined;
            }
            const pageTemplateConfig = this.config.layoutSlots[pageTemplate];
            const config = this.getResponsiveSlotConfig(pageTemplateConfig, 'pageFold', breakpoint);
            return config ? config.pageFold : undefined;
        }));
    }
    resolveSlots(page, section, breakpoint) {
        const config = this.getSlotConfig(page.template ?? '', 'slots', section, breakpoint);
        if (config && config.slots) {
            const pageSlots = page.slots ? Object.keys(page.slots) : [];
            return config.slots.filter((slot) => pageSlots.includes(slot));
        }
        else if (!section) {
            this.logMissingLayoutConfig(page);
            return page.slots ? Object.keys(page.slots) : [];
        }
        else {
            this.logMissingLayoutConfig(page, section);
            return [];
        }
    }
    get page$() {
        return this.cms.getCurrentPage().pipe(filter((page) => !!page));
    }
    get templateName$() {
        return this.page$.pipe(map((page) => page.template), filter(isNotUndefined));
    }
    /**
     * load slots from the layout configuration. The breakpoint is used
     * to load a specific configuration for the given breakpoint. If there's
     * no configuration available for the given breakpoint the default slot
     * configuration is returned.
     */
    getSlotConfig(templateUid, configAttribute, section, breakpoint) {
        if (!this.config.layoutSlots) {
            return undefined;
        }
        const pageTemplateConfig = this.config.layoutSlots[templateUid];
        if (section) {
            return this.getSlotConfigForSection(templateUid, configAttribute, section, breakpoint);
        }
        if (pageTemplateConfig) {
            return this.getResponsiveSlotConfig(pageTemplateConfig, configAttribute, breakpoint);
        }
    }
    getSlotConfigForSection(templateUid, configAttribute, section, breakpoint) {
        const pageTemplateConfig = this.config.layoutSlots?.[templateUid];
        if (!pageTemplateConfig || !section) {
            return undefined;
        }
        // if there's no section config on the page layout
        // we fall back to the global section config
        const sectionConfig = pageTemplateConfig[section]
            ? pageTemplateConfig[section]
            : this.config.layoutSlots?.[section];
        if (!sectionConfig) {
            return undefined;
        }
        const responsiveConfig = this.getResponsiveSlotConfig(sectionConfig, configAttribute, breakpoint);
        if (responsiveConfig.hasOwnProperty(configAttribute)) {
            return responsiveConfig;
        }
        else if (pageTemplateConfig[section].hasOwnProperty(configAttribute)) {
            return pageTemplateConfig[section];
        }
        else if (this.config.layoutSlots?.[section]) {
            return this.config.layoutSlots[section];
        }
    }
    /**
     * Returns a list of slots for a breakpoint specific configuration
     * If there's no specific configuration for the breakpoint,
     * the closest available configuration will be returned.
     */
    getResponsiveSlotConfig(layoutSlotConfig, configAttribute, breakpoint) {
        let slotConfig = layoutSlotConfig;
        // fallback to default slot config
        if (!layoutSlotConfig || !breakpoint) {
            return slotConfig;
        }
        // we have a config for the specific breakpoint
        if (layoutSlotConfig[breakpoint] &&
            layoutSlotConfig[breakpoint].hasOwnProperty(configAttribute)) {
            return layoutSlotConfig[breakpoint];
        }
        // find closest config
        const all = this.breakpointService.breakpoints;
        for (const br of all.slice(0, all.indexOf(breakpoint))) {
            if (layoutSlotConfig[br] &&
                layoutSlotConfig[br].hasOwnProperty(configAttribute)) {
                slotConfig = layoutSlotConfig[br];
            }
        }
        return slotConfig;
    }
    /**
     * In order to help developers, we print some detailed log information in
     * case there's no layout configuration available for the given page template
     * or section. Additionally, the slot positions are printed in the console
     * in a format that can be copied / paste to the configuration.
     */
    logMissingLayoutConfig(page, section) {
        if (!isDevMode()) {
            return;
        }
        if (page.template && !this.logSlots[page.template]) {
            // the info log is not printed in production
            this.logger.info(`Available CMS page slots: '${(page.slots
                ? Object.keys(page.slots)
                : []).join(`','`)}'`);
            this.logSlots[page.template] = true;
        }
        const cacheKey = section || page.template;
        if (cacheKey && !this.warnLogMessages[cacheKey]) {
            this.logger.warn(`No layout config found for ${cacheKey}, you can configure a 'LayoutConfig' to control the rendering of page slots.`);
            this.warnLogMessages[cacheKey] = true;
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutService, deps: [{ token: i1.CmsService }, { token: LayoutConfig }, { token: BreakpointService }, { token: i1.UnifiedInjector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.CmsService }, { type: LayoutConfig }, { type: BreakpointService }, { type: i1.UnifiedInjector }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service responsible for resolving cms config based feature modules.
 */
class CmsFeaturesService {
    constructor(configInitializer, featureModules) {
        this.configInitializer = configInitializer;
        this.featureModules = featureModules;
        // maps componentType to feature
        this.componentFeatureMap = new Map();
        /*
         * Contains either FeatureInstance or FeatureInstance resolver for not yet
         * resolved feature modules
         */
        this.featureInstances = new Map();
        this.initFeatureMap();
    }
    initFeatureMap() {
        this.configInitializer
            .getStable('featureModules')
            .subscribe((config) => {
            this.featureModulesConfig = config.featureModules ?? {};
            for (const [featureName, featureConfig] of Object.entries(this.featureModulesConfig)) {
                if (typeof featureConfig !== 'string' &&
                    featureConfig?.module &&
                    featureConfig?.cmsComponents?.length) {
                    for (const component of featureConfig.cmsComponents) {
                        this.componentFeatureMap.set(component, featureName);
                    }
                }
            }
        });
    }
    /**
     * Check if there is feature module configuration that covers specified
     * component type
     */
    hasFeatureFor(componentType) {
        return this.componentFeatureMap.has(componentType);
    }
    /**
     * Return full CmsComponent mapping defined in feature module
     */
    getCmsMapping(componentType) {
        const feature = this.componentFeatureMap.get(componentType);
        if (!feature) {
            return of(undefined);
        }
        return this.resolveFeatureInstance(feature).pipe(map((featureInstance) => featureInstance.componentsMappings?.[componentType]));
    }
    /**
     * Resolves feature module for provided component type
     *
     * @param componentType
     */
    getModule(componentType) {
        const feature = this.componentFeatureMap.get(componentType);
        if (!feature) {
            return undefined;
        }
        let module;
        // we are returning injectors only for already resolved features
        this.featureInstances
            .get(feature)
            ?.subscribe((featureInstance) => {
            module = featureInstance.moduleRef;
        })
            .unsubscribe();
        return module;
    }
    /**
     * Resolve feature based on feature name, if feature was not yet resolved
     *
     * It will first resolve all module dependencies if defined
     */
    resolveFeatureInstance(featureName) {
        return defer(() => {
            if (!this.featureInstances.has(featureName)) {
                this.featureInstances.set(featureName, this.featureModules.resolveFeature(featureName).pipe(map((moduleRef) => this.createFeatureInstance(moduleRef, featureName)), shareReplay$1()));
            }
            return this.featureInstances.get(featureName) ?? EMPTY;
        });
    }
    /**
     * Create feature instance from feature's moduleRef
     */
    createFeatureInstance(moduleRef, feature) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const featureConfig = this.featureModulesConfig[feature];
        const featureInstance = {
            moduleRef,
            componentsMappings: {},
        };
        // resolve configuration for feature module
        const resolvedConfiguration = this.resolveFeatureConfiguration(moduleRef.injector);
        // extract cms components configuration from feature config
        for (const componentType of featureConfig.cmsComponents ?? []) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            featureInstance.componentsMappings[componentType] =
                resolvedConfiguration.cmsComponents?.[componentType] ?? {};
        }
        return featureInstance;
    }
    /**
     * Returns configuration provided in feature module
     */
    resolveFeatureConfiguration(featureInjector) {
        // get config chunks from feature lib
        const featureConfigChunks = featureInjector.get(ConfigChunk, [], {
            self: true,
        });
        // get default config chunks from feature lib
        const featureDefaultConfigChunks = featureInjector.get(DefaultConfigChunk, [], { self: true });
        return deepMerge({}, ...(featureDefaultConfigChunks ?? []), ...(featureConfigChunks ?? []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsFeaturesService, deps: [{ token: i1.ConfigInitializerService }, { token: i1.FeatureModulesService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsFeaturesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsFeaturesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.ConfigInitializerService }, { type: i1.FeatureModulesService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service with logic related to resolving component from cms mapping
 */
class CmsComponentsService {
    constructor(config, platformId, featureModules, configInitializer) {
        this.config = config;
        this.platformId = platformId;
        this.featureModules = featureModules;
        this.configInitializer = configInitializer;
        // Component mappings that were identified as missing
        this.missingComponents = [];
        // Already resolved mappings
        this.mappings = {};
        // Contains already initialized resolvers for specified component typez
        this.mappingResolvers = new Map();
        this.logger = inject(LoggerService);
        this.configInitializer
            .getStable('cmsComponents')
            .subscribe((cmsConfig) => {
            // we want to grab cms configuration available at config initialization phase
            // as lazy-loaded modules can affect global configuration resulting in
            // non-deterministic state
            this.staticCmsConfig = { ...cmsConfig.cmsComponents };
        });
    }
    /**
     * Should be called to make sure all component mappings are determined,
     * especially lazy loaded ones.
     *
     * It's recommended way to make sure all other methods of CmsComponentService
     * will be able to work synchronously for asked component types and avoid risk
     * of potential errors that could be thrown otherwise.
     */
    determineMappings(componentTypes) {
        return defer(() => {
            // we use defer, to be sure the logic below used to compose final observable
            // will be executed at subscription time (with up to date state at the time,
            // when it will be needed)
            const featureResolvers = [];
            for (const componentType of componentTypes) {
                if (!this.mappings[componentType]) {
                    const staticConfig = (this.staticCmsConfig ??
                        this.config.cmsComponents)?.[componentType];
                    // check if this component type is managed by feature module
                    if (this.featureModules.hasFeatureFor(componentType)) {
                        featureResolvers.push(
                        // we delegate populating this.mappings to feature resolver
                        this.getFeatureMappingResolver(componentType, staticConfig));
                    }
                    else {
                        // simply use only static config
                        if (staticConfig) {
                            this.mappings[componentType] = staticConfig;
                        }
                    }
                }
            }
            if (featureResolvers.length) {
                return forkJoin(featureResolvers).pipe(map(() => componentTypes));
            }
            else {
                return of(componentTypes);
            }
        });
    }
    getFeatureMappingResolver(componentType, staticConfig) {
        if (!this.mappingResolvers.has(componentType)) {
            const mappingResolver$ = this.featureModules
                .getCmsMapping(componentType)
                .pipe(filter(isNotUndefined), tap((featureComponentMapping) => {
                // We treat cms mapping configuration from a feature as a default,
                // that can be overridden by app/static configuration
                this.mappings[componentType] = deepMerge({}, featureComponentMapping, staticConfig);
                this.mappingResolvers.delete(componentType);
            }), share());
            this.mappingResolvers.set(componentType, mappingResolver$);
        }
        return this.mappingResolvers.get(componentType);
    }
    /**
     * Returns the feature module for a cms component.
     * It will only work for cms components provided by feature modules.
     *
     * @param componentType
     */
    getModule(componentType) {
        if (this.featureModules.hasFeatureFor(componentType)) {
            return this.featureModules.getModule(componentType);
        }
    }
    /**
     * Return collection of component mapping configuration for specified list of
     * component types.
     *
     * If component mapping can't be determined synchronously, for example, lazy
     * loaded one, it will throw an error.
     *
     * To make sure component mapping is available, determineMappings()
     * should be called and completed first.
     */
    getMapping(componentType) {
        const componentConfig = this.mappings[componentType] ??
            (this.staticCmsConfig ?? this.config.cmsComponents)?.[componentType];
        if (isDevMode() && !componentConfig) {
            if (!this.missingComponents.includes(componentType)) {
                this.missingComponents.push(componentType);
                this.logger.warn(`No component implementation found for the CMS component type '${componentType}'.\n`, `Make sure you implement a component and register it in the mapper.`);
            }
        }
        return componentConfig;
    }
    /**
     * Checks, if component should be rendered as some components
     * could be disabled for server side renderings
     */
    shouldRender(componentType) {
        const isSSR = isPlatformServer(this.platformId);
        return !(isSSR && this.getMapping(componentType)?.disableSSR);
    }
    /**
     * Return DeferLoadingStrategy for component type.
     */
    getDeferLoadingStrategy(componentType) {
        return (this.staticCmsConfig ?? this.config.cmsComponents)?.[componentType]
            ?.deferLoading;
    }
    /**
     * Get cms driven child routes for components
     */
    getChildRoutes(componentTypes) {
        const configs = [];
        for (const componentType of componentTypes) {
            if (this.shouldRender(componentType)) {
                configs.push(this.getMapping(componentType)?.childRoutes ?? []);
            }
        }
        return this.standardizeChildRoutes(configs);
    }
    /**
     * Returns the static data for the component type.
     */
    getStaticData(componentType) {
        return this.getMapping(componentType)?.data;
    }
    /**
     * Standardizes the format of `childRoutes` config.
     *
     * Some `childRoutes` configs are simple arrays of Routes (without the notion of the parent route).
     * But some configs can be an object with children routes and their parent defined in separate property.
     */
    standardizeChildRoutes(childRoutesConfigs) {
        const result = { children: [] };
        (childRoutesConfigs || []).forEach((config) => {
            if (Array.isArray(config)) {
                result.children?.push(...config);
            }
            else {
                result.children?.push(...(config.children || []));
                if (config.parent) {
                    result.parent = config.parent;
                }
            }
        });
        return result;
    }
    /**
     * Get cms driven guards for components
     */
    getGuards(componentTypes) {
        const guards = new Set();
        for (const componentType of componentTypes) {
            this.getMapping(componentType)?.guards?.forEach((guard) => guards.add(guard));
        }
        return Array.from(guards);
    }
    /**
     * Get i18n keys associated with components
     */
    getI18nKeys(componentTypes) {
        const i18nKeys = new Set();
        for (const componentType of componentTypes) {
            if (this.shouldRender(componentType)) {
                this.getMapping(componentType)?.i18nKeys?.forEach((key) => i18nKeys.add(key));
            }
        }
        return Array.from(i18nKeys);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsComponentsService, deps: [{ token: i1.CmsConfig }, { token: PLATFORM_ID }, { token: CmsFeaturesService }, { token: i1.ConfigInitializerService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsComponentsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsComponentsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.CmsConfig }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: CmsFeaturesService }, { type: i1.ConfigInitializerService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageSlotService {
    constructor(cmsComponentsService, platformId, document) {
        this.cmsComponentsService = cmsComponentsService;
        this.platformId = platformId;
        this.document = document;
        this.resolvePrerenderedSlots();
    }
    /**
     * Finds all slots visible in the SSR pre-rendered DOM
     */
    resolvePrerenderedSlots() {
        if (isPlatformBrowser(this.platformId)) {
            this.prerenderedSlots = Array.from(this.document.querySelectorAll('cx-page-slot'))
                .filter((el) => el.getBoundingClientRect().top <
                this.document.documentElement.clientHeight)
                .map((el) => el.getAttribute('position'));
        }
    }
    /**
     * Indicates if certain slot should be rendered instantly.
     *
     * It's especially useful when transitioning from SSR to CSR application,
     * where we don't want to apply deferring logic to slots that are visible
     * to avoid unnecessary flickering.
     */
    shouldNotDefer(slot) {
        if (this.prerenderedSlots?.includes(slot)) {
            this.prerenderedSlots.splice(this.prerenderedSlots.indexOf(slot), 1);
            return true;
        }
        return false;
    }
    /**
     * Returns the defer options for the given component. If the wrapping
     * page slot is prerendered, we would ignore the defer options altogether.
     */
    getComponentDeferOptions(slot, componentType) {
        if (slot && this.shouldNotDefer(slot)) {
            return { deferLoading: DeferLoadingStrategy.INSTANT };
        }
        const deferLoading = this.cmsComponentsService.getDeferLoadingStrategy(componentType);
        return { deferLoading };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageSlotService, deps: [{ token: CmsComponentsService }, { token: PLATFORM_ID }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageSlotService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageSlotService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: CmsComponentsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Lifecycle events for the creation and removal of CMS components.
 *
 * Triggers when the component is added or removed from the DOM, using
 * sub event `ComponentCreateEvent` and `ComponentDestroyEvent`.
 */
class ComponentEvent extends CxEvent {
}
/**
 * Indicates that the component is added to the DOM.
 */
class ComponentCreateEvent extends ComponentEvent {
    /**
     * Event's type
     */
    static { this.type = 'ComponentCreate'; }
}
/**
 * Indicates that the component is removed from the DOM.
 */
class ComponentDestroyEvent extends ComponentEvent {
    /**
     * Event's type
     */
    static { this.type = 'ComponentDestroy'; }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * ComponentHandler implementations can be used for instantiating and launching
 * different types of CMS mapped components
 */
class ComponentHandler {
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Responsible for obtaining component handler for specified component mapping
 */
class ComponentHandlerService {
    constructor(handlers) {
        this.handlers = handlers;
        this.logger = inject(LoggerService);
        this.invalidMappings = new Set();
    }
    /**
     * Get best matching component handler
     *
     * @param componentMapping
     */
    resolve(componentMapping) {
        const handler = resolveApplicable(this.handlers, [componentMapping]);
        if (isDevMode() && !handler) {
            if (!this.invalidMappings.has(componentMapping)) {
                this.invalidMappings.add(componentMapping);
                this.logger.warn("Can't resolve handler for component mapping: ", componentMapping);
            }
        }
        return handler;
    }
    /**
     * Get launcher for specified component mapping
     *
     * @param componentMapping
     * @param viewContainerRef
     * @param elementInjector
     */
    getLauncher(componentMapping, viewContainerRef, elementInjector, module) {
        return this.resolve(componentMapping)?.launcher(componentMapping, viewContainerRef, elementInjector, module);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ComponentHandlerService, deps: [{ token: ComponentHandler, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ComponentHandlerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ComponentHandlerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [ComponentHandler]
                }] }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides data for `CmsComponentData`. This is used while component is injected
 * dynamically, so that the component implementation can access the data.
 *
 * The data is resolved from dynamic data (CMS api) as well as static configured data.
 */
class ComponentDataProvider {
    constructor(componentsService, cmsService) {
        this.componentsService = componentsService;
        this.cmsService = cmsService;
    }
    /**
     * Return the component data for a component given by the `uid`.
     *
     * If the `type` is provided, static component data (if available) is
     * merged into the component data. The static data is complemented and
     * overridden with data retrieved from the cms service.
     */
    get(uid, type) {
        return defer(() => {
            let staticComponentData;
            if (type) {
                staticComponentData = this.componentsService.getStaticData(type);
            }
            if (uid) {
                if (staticComponentData) {
                    return this.cmsService.getComponentData(uid).pipe(map((data) => ({
                        ...staticComponentData,
                        ...data,
                    })), startWith(staticComponentData));
                }
                else {
                    return this.cmsService.getComponentData(uid);
                }
            }
            else {
                return staticComponentData ? of(staticComponentData) : EMPTY;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ComponentDataProvider, deps: [{ token: CmsComponentsService }, { token: i1.CmsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ComponentDataProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ComponentDataProvider, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: CmsComponentsService }, { type: i1.CmsService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Used to prepare injector for CMS components.
 *
 * Injector will take into account configured providers and provides CmsComponentData
 * for specified component's uid
 */
class CmsInjectorService {
    constructor(cmsComponentsService, injector) {
        this.cmsComponentsService = cmsComponentsService;
        this.injector = injector;
    }
    getInjector(type, uid, parentInjector) {
        const configProviders = this.cmsComponentsService.getMapping(type)?.providers ?? [];
        return Injector.create({
            providers: [
                {
                    provide: CmsComponentData,
                    useFactory: (dataProvider) => ({
                        uid,
                        data$: dataProvider.get(uid, type),
                    }),
                    deps: [ComponentDataProvider],
                },
                provideLcpPresenceForCmsComponent(),
                ...configProviders,
            ],
            parent: parentInjector ?? this.injector,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsInjectorService, deps: [{ token: CmsComponentsService }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsInjectorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsInjectorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: CmsComponentsService }, { type: i0.Injector }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive used to facilitate instantiation of CMS driven dynamic components
 */
class ComponentWrapperDirective {
    constructor(vcr, cmsComponentsService, injector, dynamicAttributeService, renderer, componentHandler, cmsInjector, eventService) {
        this.vcr = vcr;
        this.cmsComponentsService = cmsComponentsService;
        this.injector = injector;
        this.dynamicAttributeService = dynamicAttributeService;
        this.renderer = renderer;
        this.componentHandler = componentHandler;
        this.cmsInjector = cmsInjector;
        this.eventService = eventService;
        this.cxComponentRef = new EventEmitter();
    }
    ngOnInit() {
        this.cmsComponentsService
            .determineMappings([this.cxComponentWrapper.flexType ?? ''])
            .subscribe(() => {
            if (this.cmsComponentsService.shouldRender(this.cxComponentWrapper.flexType ?? '')) {
                this.launchComponent();
            }
        });
    }
    launchComponent() {
        const componentMapping = this.cmsComponentsService.getMapping(this.cxComponentWrapper.flexType ?? '');
        if (!componentMapping) {
            return;
        }
        this.launcherResource = this.componentHandler
            .getLauncher(componentMapping, this.vcr, this.cmsInjector.getInjector(this.cxComponentWrapper.flexType ?? '', this.cxComponentWrapper.uid ?? '', this.injector), this.cmsComponentsService.getModule(this.cxComponentWrapper.flexType ?? ''))
            ?.pipe(filter(isNotUndefined), tap(({ elementRef, componentRef }) => {
            this.cmpRef = componentRef;
            this.cxComponentRef.emit(componentRef);
            this.dispatchEvent(ComponentCreateEvent, elementRef);
            this.decorate(elementRef);
            this.injector.get(ChangeDetectorRef).markForCheck();
        }), finalize(() => this.dispatchEvent(ComponentDestroyEvent)))
            .subscribe();
    }
    /**
     * Dispatch the component event.
     *
     * The event is dispatched during creation and removal of the component.
     */
    dispatchEvent(event, elementRef) {
        const payload = {
            typeCode: this.cxComponentWrapper.typeCode,
            id: this.cxComponentWrapper.uid,
        };
        if (event === ComponentCreateEvent) {
            payload.host = elementRef?.nativeElement;
        }
        this.eventService.dispatch(payload, event);
    }
    decorate(elementRef) {
        this.dynamicAttributeService.addAttributesToComponent(elementRef.nativeElement, this.renderer, this.cxComponentWrapper);
    }
    ngOnDestroy() {
        if (this.launcherResource) {
            this.launcherResource.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ComponentWrapperDirective, deps: [{ token: i0.ViewContainerRef }, { token: CmsComponentsService }, { token: i0.Injector }, { token: i1.DynamicAttributeService }, { token: i0.Renderer2 }, { token: ComponentHandlerService }, { token: CmsInjectorService }, { token: i1.EventService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: ComponentWrapperDirective, isStandalone: false, selector: "[cxComponentWrapper]", inputs: { cxComponentWrapper: "cxComponentWrapper" }, outputs: { cxComponentRef: "cxComponentRef" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ComponentWrapperDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxComponentWrapper]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: CmsComponentsService }, { type: i0.Injector }, { type: i1.DynamicAttributeService }, { type: i0.Renderer2 }, { type: ComponentHandlerService }, { type: CmsInjectorService }, { type: i1.EventService }], propDecorators: { cxComponentWrapper: [{
                type: Input
            }], cxComponentRef: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `PageSlotComponent` is used to render the CMS page slot and it's components.
 *
 * The Page slot host element will be supplemented with css classes so that the layout
 * can be fully controlled by customers:
 * - The page slot _position_ is added as a css class by default.
 * - The `cx-pending` is added for as long as the slot hasn't start loading.
 * - The `page-fold` style class is added for the page slot which is configured as the page fold.
 */
class PageSlotComponent {
    /**
     * The position represents the unique key for a page slot on a single page, but can
     * be reused cross pages.
     *
     * The position is used to find the CMS components for the page slot. It is also
     * added as an additional CSS class so that layout can be applied.
     */
    set position(value) {
        this.position$.next(value);
    }
    get position() {
        return this.position$.value;
    }
    constructor(cmsService, dynamicAttributeService, renderer, elementRef, cd, pageSlotService) {
        this.cmsService = cmsService;
        this.dynamicAttributeService = dynamicAttributeService;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.cd = cd;
        this.pageSlotService = pageSlotService;
        /**
         * Indicates that the page slot is the last page slot above the fold.
         */
        this.isPageFold = false;
        /**
         * Indicates that the components of the page slot haven't been loaded as long
         * as the isPending state is true.
         */
        this.isPending = true;
        /**
         * Indicates that the page slot doesn't contain any components. This is no
         * longer used in spartacus, but kept for backwards compatibility.
         */
        this.hasComponents = false;
        this.position$ = new BehaviorSubject(undefined);
        this.slot$ = this.position$.pipe(filter(isNotUndefined), switchMap$1((position) => this.cmsService.getContentSlot(position)), distinctUntilChanged(this.isDistinct));
        /** Observes the components for the given page slot. */
        this.components$ = this.slot$.pipe(map((slot) => slot?.components ?? []));
        this.subscription = new Subscription();
        /** Keeps track of the pending components that must be loaded for the page slot */
        this.pendingComponentCount = 0;
    }
    ngOnInit() {
        this.subscription.add(this.slot$.pipe(tap((slot) => this.decorate(slot))).subscribe((value) => {
            this.components = value?.components || [];
            this.cd.markForCheck();
        }));
    }
    decorate(slot) {
        let cls = this.class || '';
        if (this.lastPosition && cls.indexOf(this.lastPosition) > -1) {
            cls = cls.replace(this.lastPosition, '');
        }
        if (this.position$.value) {
            cls += ` ${this.position$.value}`;
            this.lastPosition = this.position$.value;
        }
        // host bindings
        this.pending = slot?.components?.length || 0;
        this.hasComponents = slot?.components
            ? slot?.components?.length > 0
            : false;
        if (cls && cls !== this.class) {
            this.class = cls;
        }
        if (slot) {
            this.dynamicAttributeService.addAttributesToSlot(this.elementRef.nativeElement, this.renderer, slot);
        }
    }
    /**
     * Sets the pending count for the page slot components. Once all pending components are
     * loaded, the `isPending` flag is updated, so that the associated class can be updated
     */
    set pending(count) {
        this.pendingComponentCount = count;
        this.isPending = this.pendingComponentCount > 0;
    }
    get pending() {
        return this.pendingComponentCount;
    }
    /*
     * Is triggered when a component is added to the view. This is used to
     * update the pending count
     */
    isLoaded(loadState) {
        if (loadState) {
            this.pending--;
            this.cd.markForCheck();
        }
    }
    /**
     * The `DeferLoadingStrategy` indicates whether the component should be
     * rendered instantly or whether it should be deferred.
     */
    getComponentDeferOptions(componentType) {
        return this.pageSlotService.getComponentDeferOptions(this.position, componentType);
    }
    isDistinct(old, current) {
        return Boolean(current.components &&
            old.components &&
            old.components.length === current.components.length &&
            !old.components.find((el, index) => el.uid !== current.components?.[index].uid));
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageSlotComponent, deps: [{ token: i1.CmsService }, { token: i1.DynamicAttributeService }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: PageSlotService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PageSlotComponent, isStandalone: false, selector: "cx-page-slot,[cx-page-slot]", inputs: { position: "position", class: "class", isPageFold: "isPageFold", hasComponents: "hasComponents" }, host: { properties: { "attr.position": "this.position", "class": "this.class", "class.page-fold": "this.isPageFold", "class.cx-pending": "this.isPending", "class.has-components": "this.hasComponents" } }, ngImport: i0, template: "<ng-template\n  *ngIf=\"position\"\n  [cxOutlet]=\"position\"\n  [cxOutletContext]=\"{ components$: components$ }\"\n>\n  <ng-container *ngFor=\"let component of components\">\n    <ng-template\n      *ngIf=\"component.flexType\"\n      [cxOutlet]=\"component.flexType\"\n      [cxOutletContext]=\"{ component: component }\"\n      [cxOutletDefer]=\"getComponentDeferOptions(component.flexType)\"\n      (loaded)=\"isLoaded($event)\"\n    >\n      <ng-container [cxComponentWrapper]=\"component\"></ng-container>\n    </ng-template>\n  </ng-container>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "directive", type: ComponentWrapperDirective, selector: "[cxComponentWrapper]", inputs: ["cxComponentWrapper"], outputs: ["cxComponentRef"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageSlotComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-page-slot,[cx-page-slot]', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-template\n  *ngIf=\"position\"\n  [cxOutlet]=\"position\"\n  [cxOutletContext]=\"{ components$: components$ }\"\n>\n  <ng-container *ngFor=\"let component of components\">\n    <ng-template\n      *ngIf=\"component.flexType\"\n      [cxOutlet]=\"component.flexType\"\n      [cxOutletContext]=\"{ component: component }\"\n      [cxOutletDefer]=\"getComponentDeferOptions(component.flexType)\"\n      (loaded)=\"isLoaded($event)\"\n    >\n      <ng-container [cxComponentWrapper]=\"component\"></ng-container>\n    </ng-template>\n  </ng-container>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i1.CmsService }, { type: i1.DynamicAttributeService }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: PageSlotService }], propDecorators: { position: [{
                type: HostBinding,
                args: ['attr.position']
            }, {
                type: Input
            }], class: [{
                type: Input
            }, {
                type: HostBinding
            }], isPageFold: [{
                type: HostBinding,
                args: ['class.page-fold']
            }, {
                type: Input
            }], isPending: [{
                type: HostBinding,
                args: ['class.cx-pending']
            }], hasComponents: [{
                type: HostBinding,
                args: ['class.has-components']
            }, {
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that Adds a style class to the host element based on the cms page
 * template. The CMS page template is driven by the CMS structure, which is configurable
 * in the backend.
 *
 * The style class is added to the host element of the directive. The host element is resolved
 * from the `elementRef`, or, in case the directive is used in an `ng-template`, by the
 * `TemplateRef`.
 *
 * An example of the usage is given below:
 *
 * ```html
 * <cx-storefront class="LandingPageTemplate">
 *   <ng-template cxPageTemplateStyle>...</ng-template>
 * <cx-storefront>
 * ```
 *
 * The style class can also be provided by an input:
 *
 * ```html
 * <ng-template [cxPageTemplateStyle]="pageTemplateName">
 * ```
 *
 */
class PageTemplateDirective {
    /**
     * Adds a style class to the host element based on the cms page template, unless
     * the class is given as an input.
     *
     * The host element is either the actual host, or the parent element in case this
     * is used inside an `ng-template`.
     */
    set setTemplate(template) {
        if (template && template !== '') {
            this.useTemplateFromInput = true;
            this.addStyleClass(template);
        }
        else if (this.useTemplateFromInput) {
            // we only clear the template if it has been provided by the input before
            this.clear();
        }
    }
    constructor(pageLayoutService, elementRef, templateRef, cd) {
        this.pageLayoutService = pageLayoutService;
        this.elementRef = elementRef;
        this.templateRef = templateRef;
        this.cd = cd;
        // Maintains the page template subscription
        this.subscription = new Subscription();
    }
    ngOnInit() {
        if (!this.useTemplateFromInput) {
            this.subscription.add(this.pageLayoutService.templateName$.subscribe((template) => this.addStyleClass(template)));
        }
    }
    /**
     * Adds the page template as a style class to the given element. If any
     * page template was added before, we clean it up.
     *
     * We'll not use hostBinding for the style class, as it will potential drop
     * an existing class name on the host. This is why we need to work with
     * the lower level change detection api.
     */
    addStyleClass(template, el) {
        this.clear(el);
        if (template) {
            this.currentTemplate = template;
            (el ?? this.host).classList.add(this.currentTemplate);
            this.cd.markForCheck();
        }
    }
    /**
     * Cleans up the class host binding, if a template class was assigned before.
     */
    clear(el) {
        if (this.currentTemplate) {
            (el ?? this.host).classList?.remove(this.currentTemplate);
            this.cd.markForCheck();
        }
    }
    /**
     * Returns the host element (`HTMLElement`).
     *
     * If the directive is used on an `ng-template`, we take the parent element,
     * to ensure that we're not ending up with a comment.
     */
    get host() {
        return !!this.templateRef
            ? this.templateRef.elementRef.nativeElement.parentElement
            : this.elementRef.nativeElement;
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageTemplateDirective, deps: [{ token: PageLayoutService }, { token: i0.ElementRef }, { token: i0.TemplateRef, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: PageTemplateDirective, isStandalone: false, selector: "[cxPageTemplateStyle]", inputs: { setTemplate: ["cxPageTemplateStyle", "setTemplate"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxPageTemplateStyle]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: PageLayoutService }, { type: i0.ElementRef }, { type: i0.TemplateRef, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }], propDecorators: { setTemplate: [{
                type: Input,
                args: ['cxPageTemplateStyle']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageLayoutComponent {
    set section(value) {
        this.section$.next(value);
    }
    constructor(pageLayoutService) {
        this.pageLayoutService = pageLayoutService;
        this.section$ = new BehaviorSubject(undefined);
        this.templateName$ = this.pageLayoutService.templateName$;
        this.layoutName$ = this.section$.pipe(switchMap$1((section) => (section ? of(section) : this.templateName$)));
        this.slots$ = this.section$.pipe(switchMap$1((section) => this.pageLayoutService.getSlots(section)));
        this.pageFoldSlot$ = this.templateName$.pipe(switchMap$1((templateName) => this.pageLayoutService.getPageFoldSlot(templateName)), distinctUntilChanged());
        useFeatureStyles('disableCxPageSlotMarginAnimation');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutComponent, deps: [{ token: PageLayoutService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PageLayoutComponent, isStandalone: false, selector: "cx-page-layout", inputs: { section: "section" }, ngImport: i0, template: "<ng-template\n  *ngIf=\"layoutName$ | async as layoutName\"\n  [cxPageTemplateStyle]=\"layoutName\"\n  [cxOutlet]=\"layoutName\"\n  [cxOutletContext]=\"{\n    templateName$: templateName$,\n    slots$: slots$,\n    section$: section$,\n  }\"\n>\n  <ng-content></ng-content>\n\n  <cx-page-slot\n    *ngFor=\"let slot of slots$ | async\"\n    [position]=\"slot\"\n    [isPageFold]=\"slot === (pageFoldSlot$ | async)\"\n  ></cx-page-slot>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "component", type: PageSlotComponent, selector: "cx-page-slot,[cx-page-slot]", inputs: ["position", "class", "isPageFold", "hasComponents"] }, { kind: "directive", type: PageTemplateDirective, selector: "[cxPageTemplateStyle]", inputs: ["cxPageTemplateStyle"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-page-layout', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-template\n  *ngIf=\"layoutName$ | async as layoutName\"\n  [cxPageTemplateStyle]=\"layoutName\"\n  [cxOutlet]=\"layoutName\"\n  [cxOutletContext]=\"{\n    templateName$: templateName$,\n    slots$: slots$,\n    section$: section$,\n  }\"\n>\n  <ng-content></ng-content>\n\n  <cx-page-slot\n    *ngFor=\"let slot of slots$ | async\"\n    [position]=\"slot\"\n    [isPageFold]=\"slot === (pageFoldSlot$ | async)\"\n  ></cx-page-slot>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: PageLayoutService }], propDecorators: { section: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsGuardsService {
    constructor(cmsComponentsService, 
    // TODO:#checkout - handle breaking changes in schematics
    unifiedInjector) {
        this.cmsComponentsService = cmsComponentsService;
        this.unifiedInjector = unifiedInjector;
        /**
         * @deprecated since 2211.41 - not needed anymore
         */
        this.featureConfigService = inject(FeatureConfigService);
        this.guardsComposer = inject(GuardsComposer);
    }
    /**
     * Executes all guards for the given `componentTypes` and returns an Observable that:
     * - emits `true` if all those guards pass (emit `true`)
     * - emits `false` or `UrlTree` immediately if any those guards fails (returns `false` or `UrlTree`)
     */
    cmsPageCanActivate(componentTypes, route, state) {
        const guards = this.cmsComponentsService.getGuards(componentTypes);
        const guardsInstances = guards
            .map((guardClass) => getLastValueSync(this.unifiedInjector.get(guardClass)))
            .filter(isCanActivate);
        return this.guardsComposer.canActivate(guardsInstances, route, state);
    }
    /**
     * Executes a guard's `canActivate` method with `route` and `state`,
     * returning its result as an Observable.
     *
     * Converts non-Observable results (Promise or static value) into Observable.
     *
     * NOTE: It injects the guard on demand from the {@link UnifiedInjector}
     *
     * @deprecated since 2211.24 - instead use the util {@link GuardsComposer}
     */
    canActivateGuard(guardClass, route, state) {
        const guard = getLastValueSync(this.unifiedInjector.get(guardClass));
        if (isCanActivate(guard)) {
            return wrapIntoObservable(guard.canActivate(route, state)).pipe(first());
        }
        else {
            throw new Error('Invalid CanActivate guard in cmsMapping');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsGuardsService, deps: [{ token: CmsComponentsService }, { token: i1.UnifiedInjector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsGuardsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsGuardsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: CmsComponentsService }, { type: i1.UnifiedInjector }] });
function isCanActivate(guard) {
    return guard && typeof guard.canActivate === 'function';
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// This service should be exposed in public API only after the refactor planned in https://github.com/SAP/spartacus/issues/7070
class CmsRoutesImplService {
    constructor(router, cmsComponentsService, cmsGuardsService) {
        this.router = router;
        this.cmsComponentsService = cmsComponentsService;
        this.cmsGuardsService = cmsGuardsService;
    }
    cmsRouteExists(url) {
        const isCmsDrivenRoute = url.startsWith('/');
        if (!isCmsDrivenRoute) {
            return false;
        }
        const routePath = url.substring(1);
        return (isCmsDrivenRoute &&
            !!this.router.config.find((route) => route.data && route.data.cxCmsRouteContext && route.path === routePath));
    }
    /**
     * Contains Cms driven routing logic intended for use use in guards, especially in canActivate method.
     *
     * Will return true, when logic wont have to modify routing (so canActivate could be easily resolved to true)
     * or will return false, when routing configuration was updated and redirection to newly generated route was initiated.
     *
     * @param pageContext
     * @param currentUrl
     */
    handleCmsRoutesInGuard(pageContext, componentTypes, currentUrl, currentPageLabel) {
        if (this.cmsRouteExists(currentPageLabel)) {
            return true;
        }
        const childRoutesConfig = this.cmsComponentsService.getChildRoutes(componentTypes);
        if (childRoutesConfig?.children?.length) {
            if (this.updateRouting(pageContext, currentPageLabel, childRoutesConfig)) {
                this.router.navigateByUrl(currentUrl);
                return false;
            }
        }
        return true;
    }
    updateRouting(pageContext, pageLabel, childRoutesConfig) {
        if (pageContext.type === PageType.CONTENT_PAGE &&
            pageLabel.startsWith('/') &&
            pageLabel.length > 1) {
            const children = this.wrapCmsGuardsRecursively(childRoutesConfig.children ?? []);
            const newRoute = {
                path: pageLabel.substring(1),
                component: PageLayoutComponent,
                children: children,
                data: deepMerge({}, childRoutesConfig?.parent?.data ?? {}, {
                    cxCmsRouteContext: {
                        type: pageContext.type,
                        id: pageLabel,
                    },
                }),
            };
            this.router.resetConfig([newRoute, ...this.router.config]);
            return true;
        }
        return false;
    }
    /**
     * Traverses recursively the given Routes and wraps each `canActivate`
     * guard of each Route with a special `CanActivateFn` function.
     *
     * This special wrapper function allows for resolving
     * those guards by the Angular Router using the `UnifiedInjector`
     * instead of only root injector.
     *
     * This allows Angular Router to inject the guards (and their dependencies)
     * even when they are provided only in a child injector of a lazy-loaded module.
     */
    wrapCmsGuardsRecursively(routes) {
        return routes.map((route) => {
            if (route.children) {
                route.children = this.wrapCmsGuardsRecursively(route.children);
            }
            if (route?.canActivate?.length) {
                const canActivate = route.canActivate.map((guard) => this.wrapCmsGuard(guard));
                return {
                    ...route,
                    canActivate,
                };
            }
            return route;
        });
    }
    /**
     * Returns a wrapper function `CanActivateFn` (https://angular.io/api/router/CanActivateFn)
     * that injects the given guard instance and runs its method `.canActivate()`.
     *
     * It allows to inject the guard's instance (and it's dependencies)
     * even if it's 'provided only in a child injector of a lazy-loaded module.
     */
    wrapCmsGuard(guardClass) {
        return (route, state) => {
            return this.cmsGuardsService.canActivateGuard(guardClass, route, state);
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRoutesImplService, deps: [{ token: i1$2.Router }, { token: CmsComponentsService }, { token: CmsGuardsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRoutesImplService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRoutesImplService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: CmsComponentsService }, { type: CmsGuardsService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// Public injection token for the private implementation of the service `CmsRoutesImplService`.
// After #7070, this class should be replaced with a real implementation.
class CmsRoutesService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRoutesService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRoutesService, providedIn: 'root', useExisting: CmsRoutesImplService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRoutesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: CmsRoutesImplService,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsI18nService {
    constructor(cmsComponentsService, translation, translationChunk) {
        this.cmsComponentsService = cmsComponentsService;
        this.translation = translation;
        this.translationChunk = translationChunk;
    }
    loadForComponents(componentTypes) {
        const i18nKeys = this.cmsComponentsService.getI18nKeys(componentTypes);
        const i18nChunks = new Set();
        for (const key of i18nKeys) {
            i18nChunks.add(this.translationChunk.getChunkNameForKey(key));
        }
        this.translation.loadChunks(Array.from(i18nChunks));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsI18nService, deps: [{ token: CmsComponentsService }, { token: i1.TranslationService }, { token: i1.TranslationChunkService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsI18nService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsI18nService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: CmsComponentsService }, { type: i1.TranslationService }, { type: i1.TranslationChunkService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Helper service for `CmsPageGuard`
 */
class CmsPageGuardService {
    constructor(semanticPathService, cmsService, cmsRoutes, cmsI18n, cmsGuards, cmsComponentsService, routing) {
        this.semanticPathService = semanticPathService;
        this.cmsService = cmsService;
        this.cmsRoutes = cmsRoutes;
        this.cmsI18n = cmsI18n;
        this.cmsGuards = cmsGuards;
        this.cmsComponentsService = cmsComponentsService;
        this.routing = routing;
    }
    /**
     * Takes CMS components types in the current CMS page, triggers (configurable) side effects and returns a boolean - whether the route can be activated.
     *
     * Based on `cmsComponents` config for the components in the page:
     * - Evaluates components' guards; if one of them emits false or UrlTree - the route cannot be activated or redirects to the given UrlTree, respectively.
     * - If all components' guards emitted true, then the route can be activated
     * - Then we trigger loading of configured i18n chunks in parallel
     * - And we register the configured children routes of cms components
     *
     * @param pageContext current cms page context
     * @param pageData cms page data
     * @param route activated route snapshot
     * @param state router state snapshot
     *
     * @returns boolean observable - whether the route can be activated
     */
    canActivatePage(pageContext, pageData, route, state) {
        return this.cmsService.getPageComponentTypes(pageContext).pipe(take(1), switchMap$1((componentTypes) => this.cmsComponentsService.determineMappings(componentTypes)), switchMap$1((componentTypes) => this.cmsGuards
            .cmsPageCanActivate(componentTypes, route, state)
            .pipe(withLatestFrom(of(componentTypes)))), tap(([canActivate, componentTypes]) => {
            if (canActivate === true) {
                this.cmsI18n.loadForComponents(componentTypes);
            }
        }), map(([canActivate, componentTypes]) => {
            const pageLabel = pageData.label || pageContext.id; // for content pages the page label returned from backend can be different than ID initially assumed from route
            if (canActivate === true && !route?.data?.cxCmsRouteContext) {
                return this.cmsRoutes.handleCmsRoutesInGuard(pageContext, componentTypes, state.url, pageLabel);
            }
            return canActivate;
        }));
    }
    /**
     * Activates the "NOT FOUND" cms page.
     *
     * It loads cms page data for the "NOT FOUND" page and puts it in the state of the the requested page label.
     * Then it processes its CMS components with the method `canActivatePage()` of this service. For more, see its docs.
     */
    canActivateNotFoundPage(pageContext, route, state) {
        const notFoundLabel = this.semanticPathService.get('notFound');
        if (!notFoundLabel) {
            return of(false);
        }
        const notFoundCmsPageContext = {
            type: PageType.CONTENT_PAGE,
            id: notFoundLabel,
        };
        return this.cmsService.getPage(notFoundCmsPageContext).pipe(switchMap$1((notFoundPage) => {
            if (notFoundPage) {
                return this.cmsService.getPageIndex(notFoundCmsPageContext).pipe(tap((notFoundIndex) => {
                    this.cmsService.setPageFailIndex(pageContext, notFoundIndex);
                    this.routing.changeNextPageContext(notFoundCmsPageContext);
                }), switchMap$1((notFoundIndex) => this.cmsService.getPageIndex(pageContext).pipe(
                // we have to wait for page index update
                filter((index) => index === notFoundIndex))), switchMap$1(() => this.canActivatePage(pageContext, notFoundPage, route, state)));
            }
            return of(false);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsPageGuardService, deps: [{ token: i1.SemanticPathService }, { token: i1.CmsService }, { token: CmsRoutesService }, { token: CmsI18nService }, { token: CmsGuardsService }, { token: CmsComponentsService }, { token: i1.RoutingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsPageGuardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsPageGuardService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.SemanticPathService }, { type: i1.CmsService }, { type: CmsRoutesService }, { type: CmsI18nService }, { type: CmsGuardsService }, { type: CmsComponentsService }, { type: i1.RoutingService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsPageGuard {
    static { this.guardName = 'CmsPageGuard'; }
    constructor(routingService, cmsService, 
    /** since 2211.24 not used anymore, but called indirectly via {@link BeforeCmsPageGuardService} */
    protectedRoutesGuard, service, routingConfig) {
        this.routingService = routingService;
        this.cmsService = cmsService;
        this.protectedRoutesGuard = protectedRoutesGuard;
        this.service = service;
        this.routingConfig = routingConfig;
        this.beforeCmsPageGuardService = inject(BeforeCmsPageGuardService);
    }
    /**
     * Tries to load the CMS page data for the anticipated route and returns:
     * - `true` - if it can be activated
     * - `false` - if it cannot be activated
     * - `UrlTree` - if user should be redirected to a given `UrlTree`
     *
     * If the route can be activated, it fires additional calculations on the CMS components present on this CMS page,
     * based on their configuration (`cmsComponents` config).
     *
     * For more, see docs of the `CmsPageGuardService.canActivatePage`.
     */
    canActivate(route, state) {
        return this.beforeCmsPageGuardService.canActivate(route, state).pipe(switchMap$1((canActivate) => canActivate === true
            ? this.routingService.getNextPageContext().pipe(filter(isNotUndefined), take(1), switchMap$1((pageContext) => this.cmsService.getPage(pageContext, this.shouldReload()).pipe(first(), switchMap$1((pageData) => pageData
                ? this.service.canActivatePage(pageContext, pageData, route, state)
                : this.service.canActivateNotFoundPage(pageContext, route, state)))))
            : of(canActivate)));
    }
    /**
     * Returns whether we should reload the CMS page data, even when it was loaded before.
     */
    shouldReload() {
        return this.routingConfig.getLoadStrategy() !== RouteLoadStrategy.ONCE;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsPageGuard, deps: [{ token: i1.RoutingService }, { token: i1.CmsService }, { token: i1.ProtectedRoutesGuard }, { token: CmsPageGuardService }, { token: i1.RoutingConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsPageGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsPageGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RoutingService }, { type: i1.CmsService }, { type: i1.ProtectedRoutesGuard }, { type: CmsPageGuardService }, { type: i1.RoutingConfigService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Default component handler used for dynamically launching cms components implemented
 * as native Angular components.
 */
class DefaultComponentHandler {
    hasMatch(componentMapping) {
        return typeof componentMapping.component === 'function';
    }
    getPriority() {
        return Priority.FALLBACK;
    }
    launcher(componentMapping, viewContainerRef, elementInjector, module) {
        return new Observable((subscriber) => {
            let componentRef;
            const injector = elementInjector ?? viewContainerRef.injector;
            const dispose = () => {
                if (componentRef) {
                    componentRef.destroy();
                }
            };
            const factory = this.getComponentFactory(injector, componentMapping.component);
            if (factory) {
                componentRef = viewContainerRef.createComponent(factory, undefined, injector, undefined, module);
                subscriber.next({ elementRef: componentRef.location, componentRef });
            }
            return dispose;
        });
    }
    getComponentFactory(injector, component) {
        if (!component) {
            return null;
        }
        const factory = injector
            .get(ComponentFactoryResolver)
            .resolveComponentFactory(component);
        return factory;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DefaultComponentHandler, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DefaultComponentHandler, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DefaultComponentHandler, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Lazy component handler used for launching lazy loaded cms components implemented
 * as native Angular components.
 */
class LazyComponentHandler {
    constructor(defaultHandler) {
        this.defaultHandler = defaultHandler;
    }
    /**
     * We want to mach dynamic import signature () => import('')
     */
    hasMatch(componentMapping) {
        return (typeof componentMapping.component === 'function' &&
            this.isNotClass(componentMapping.component));
    }
    isNotClass(symbol) {
        const signature = symbol.toString().substring(0, 20).replace(' ', '');
        return signature.startsWith('function()') || signature.startsWith('()=>');
    }
    getPriority() {
        return Priority.LOW;
    }
    launcher(componentMapping, viewContainerRef, elementInjector, module) {
        return from(componentMapping.component()).pipe(switchMap$1((component) => this.defaultHandler.launcher({ ...componentMapping, component }, viewContainerRef, elementInjector, module)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LazyComponentHandler, deps: [{ token: DefaultComponentHandler }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LazyComponentHandler, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LazyComponentHandler, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: DefaultComponentHandler }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class InnerComponentsHostDirective {
    constructor(data, vcr, 
    // dependencies required for ComponentWrapper directive
    cmsComponentsService, injector, dynamicAttributeService, renderer, componentHandler, cmsInjector, eventService) {
        this.data = data;
        this.vcr = vcr;
        this.cmsComponentsService = cmsComponentsService;
        this.injector = injector;
        this.dynamicAttributeService = dynamicAttributeService;
        this.renderer = renderer;
        this.componentHandler = componentHandler;
        this.cmsInjector = cmsInjector;
        this.eventService = eventService;
        this.innerComponents$ = this.data.data$.pipe(map((data) => data?.composition?.inner ?? []), distinctUntilChanged());
        this.componentWrappers = [];
    }
    ngOnInit() {
        this.subscription = this.innerComponents$.subscribe((x) => {
            this.renderComponents(x);
        });
    }
    renderComponents(components) {
        this.clearComponents();
        components.forEach((component) => this.renderComponent(component));
    }
    renderComponent(component) {
        const componentWrapper = new ComponentWrapperDirective(this.vcr, this.cmsComponentsService, this.injector, this.dynamicAttributeService, this.renderer, this.componentHandler, this.cmsInjector, this.eventService);
        componentWrapper.cxComponentWrapper = { flexType: component, uid: '' };
        componentWrapper.ngOnInit();
        this.componentWrappers.push(componentWrapper);
    }
    clearComponents() {
        this.componentWrappers.forEach((wrapper) => wrapper.ngOnDestroy());
        this.componentWrappers = [];
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
        this.clearComponents();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: InnerComponentsHostDirective, deps: [{ token: CmsComponentData }, { token: i0.ViewContainerRef }, { token: CmsComponentsService }, { token: i0.Injector }, { token: i1.DynamicAttributeService }, { token: i0.Renderer2 }, { token: ComponentHandlerService }, { token: CmsInjectorService }, { token: i1.EventService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: InnerComponentsHostDirective, isStandalone: false, selector: "[cxInnerComponentsHost]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: InnerComponentsHostDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxInnerComponentsHost]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: i0.ViewContainerRef }, { type: CmsComponentsService }, { type: i0.Injector }, { type: i1.DynamicAttributeService }, { type: i0.Renderer2 }, { type: ComponentHandlerService }, { type: CmsInjectorService }, { type: i1.EventService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageComponentModule {
    static forRoot() {
        return {
            ngModule: PageComponentModule,
            providers: [
                {
                    provide: ComponentHandler,
                    useExisting: DefaultComponentHandler,
                    multi: true,
                },
                {
                    provide: ComponentHandler,
                    useExisting: LazyComponentHandler,
                    multi: true,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PageComponentModule, declarations: [ComponentWrapperDirective, InnerComponentsHostDirective], imports: [CommonModule], exports: [ComponentWrapperDirective, InnerComponentsHostDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageComponentModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ComponentWrapperDirective, InnerComponentsHostDirective],
                    exports: [ComponentWrapperDirective, InnerComponentsHostDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageSlotModule {
    // instantiate PageSlotService ASAP, so it can examine SSR pre-rendered DOM
    constructor(_pageSlot) {
        // Intentional empty constructor
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageSlotModule, deps: [{ token: PageSlotService }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PageSlotModule, declarations: [PageSlotComponent], imports: [CommonModule, OutletModule, PageComponentModule], exports: [PageSlotComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageSlotModule, imports: [CommonModule, OutletModule, PageComponentModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageSlotModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, OutletModule, PageComponentModule],
                    declarations: [PageSlotComponent],
                    exports: [PageSlotComponent],
                }]
        }], ctorParameters: () => [{ type: PageSlotService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageLayoutModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutModule, declarations: [PageLayoutComponent, PageTemplateDirective], imports: [CommonModule, OutletModule, PageSlotModule], exports: [PageLayoutComponent, PageTemplateDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutModule, imports: [CommonModule, OutletModule, PageSlotModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, OutletModule, PageSlotModule],
                    declarations: [PageLayoutComponent, PageTemplateDirective],
                    exports: [PageLayoutComponent, PageTemplateDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PWAModuleConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PWAModuleConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PWAModuleConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PWAModuleConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });
const defaultPWAModuleConfig = {
    pwa: {
        enabled: false,
        addToHomeScreen: false,
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToHomeScreenService {
    constructor(config, globalMessageService, winRef) {
        this.config = config;
        this.globalMessageService = globalMessageService;
        this.winRef = winRef;
        this.canPrompt = new BehaviorSubject(false);
        this.canPrompt$ = this.canPrompt.asObservable();
        if (this.config.pwa?.addToHomeScreen) {
            this.init();
        }
    }
    init() {
        if (this.winRef.nativeWindow) {
            this.winRef.nativeWindow.addEventListener('beforeinstallprompt', (event) => {
                event.preventDefault();
                this.deferredEvent = event;
                this.enableAddToHomeScreen();
            });
            this.winRef.nativeWindow.addEventListener('appinstalled', () => {
                this.globalMessageService.add({ key: 'pwa.addedToHomeScreen' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
                this.disableAddToHomeScreen();
                this.deferredEvent = null;
            });
        }
    }
    enableAddToHomeScreen() {
        this.canPrompt.next(true);
    }
    disableAddToHomeScreen() {
        this.canPrompt.next(false);
    }
    firePrompt() {
        if (this.deferredEvent) {
            this.deferredEvent.prompt();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenService, deps: [{ token: PWAModuleConfig }, { token: i1.GlobalMessageService }, { token: i1.WindowRef }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: PWAModuleConfig }, { type: i1.GlobalMessageService }, { type: i1.WindowRef }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class AddToHomeScreenComponent {
    constructor(addToHomeScreenService) {
        this.addToHomeScreenService = addToHomeScreenService;
    }
    ngOnInit() {
        this.canPrompt$ = this.addToHomeScreenService.canPrompt$;
    }
    prompt() {
        this.addToHomeScreenService.firePrompt();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenComponent, deps: [{ token: AddToHomeScreenService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: AddToHomeScreenComponent, isStandalone: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenComponent, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: AddToHomeScreenService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToHomeScreenBannerComponent extends AddToHomeScreenComponent {
    constructor(addToHomeScreenService) {
        super(addToHomeScreenService);
        this.addToHomeScreenService = addToHomeScreenService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenBannerComponent, deps: [{ token: AddToHomeScreenService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: AddToHomeScreenBannerComponent, isStandalone: false, selector: "cx-add-to-home-screen-banner", usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"canPrompt$ | async\">\n  <div class=\"cx-add-to-home-screen-banner\">\n    <div class=\"cx-add-to-home-screen-banner-inner\">\n      <p>\n        {{ 'pwa.addToHomeScreenDescription' | cxTranslate }}\n      </p>\n      <ul>\n        <li>{{ 'pwa.noInstallationNeeded' | cxTranslate }}</li>\n        <li>{{ 'pwa.fastAccessToApplication' | cxTranslate }}</li>\n      </ul>\n      <button (click)=\"prompt()\" class=\"btn btn-primary\">\n        {{ 'pwa.addToHomeScreen' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenBannerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-add-to-home-screen-banner', standalone: false, template: "<div *ngIf=\"canPrompt$ | async\">\n  <div class=\"cx-add-to-home-screen-banner\">\n    <div class=\"cx-add-to-home-screen-banner-inner\">\n      <p>\n        {{ 'pwa.addToHomeScreenDescription' | cxTranslate }}\n      </p>\n      <ul>\n        <li>{{ 'pwa.noInstallationNeeded' | cxTranslate }}</li>\n        <li>{{ 'pwa.fastAccessToApplication' | cxTranslate }}</li>\n      </ul>\n      <button (click)=\"prompt()\" class=\"btn btn-primary\">\n        {{ 'pwa.addToHomeScreen' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: AddToHomeScreenService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToHomeScreenBtnComponent extends AddToHomeScreenComponent {
    constructor(addToHomeScreenService) {
        super(addToHomeScreenService);
        this.addToHomeScreenService = addToHomeScreenService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenBtnComponent, deps: [{ token: AddToHomeScreenService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: AddToHomeScreenBtnComponent, isStandalone: false, selector: "cx-add-to-home-screen-btn", usesInheritance: true, ngImport: i0, template: "<span (click)=\"prompt()\">\n  <ng-content *ngIf=\"canPrompt$ | async\"></ng-content>\n</span>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AddToHomeScreenBtnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-add-to-home-screen-btn', standalone: false, template: "<span (click)=\"prompt()\">\n  <ng-content *ngIf=\"canPrompt$ | async\"></ng-content>\n</span>\n" }]
        }], ctorParameters: () => [{ type: AddToHomeScreenService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function pwaConfigurationFactory(pwaConfig) {
    return { enabled: (!isDevMode() && pwaConfig.pwa?.enabled) || false };
}
function pwaFactory(addToHomeScreenService) {
    const result = () => addToHomeScreenService;
    return result;
}
class PwaModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PwaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PwaModule, declarations: [AddToHomeScreenBtnComponent, AddToHomeScreenBannerComponent], imports: [CommonModule, i1$3.ServiceWorkerModule, I18nModule], exports: [AddToHomeScreenBtnComponent, AddToHomeScreenBannerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PwaModule, providers: [
            provideDefaultConfig(defaultPWAModuleConfig),
            {
                provide: SwRegistrationOptions,
                useFactory: pwaConfigurationFactory,
                deps: [Config],
            },
            {
                provide: APP_INITIALIZER,
                useFactory: pwaFactory,
                deps: [AddToHomeScreenService],
                multi: true,
            },
        ], imports: [CommonModule,
            ServiceWorkerModule.register('ngsw-worker.js'),
            I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PwaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ServiceWorkerModule.register('ngsw-worker.js'),
                        I18nModule,
                    ],
                    providers: [
                        provideDefaultConfig(defaultPWAModuleConfig),
                        {
                            provide: SwRegistrationOptions,
                            useFactory: pwaConfigurationFactory,
                            deps: [Config],
                        },
                        {
                            provide: APP_INITIALIZER,
                            useFactory: pwaFactory,
                            deps: [AddToHomeScreenService],
                            multi: true,
                        },
                    ],
                    declarations: [AddToHomeScreenBtnComponent, AddToHomeScreenBannerComponent],
                    exports: [AddToHomeScreenBtnComponent, AddToHomeScreenBannerComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const cmsRoute = {
    path: '**',
    canActivate: [CmsPageGuard],
    component: PageLayoutComponent,
};
function addCmsRoute(injector) {
    const result = () => {
        // Router could not be injected via `deps[]` due to a cyclic dependency with APP_INITIALIZER:
        const router = injector.get(Router);
        router.config.push(cmsRoute);
    };
    return result;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsRouteModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRouteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: CmsRouteModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRouteModule, providers: [
            {
                provide: APP_INITIALIZER,
                multi: true,
                deps: [Injector],
                useFactory: addCmsRoute,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsRouteModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APP_INITIALIZER,
                            multi: true,
                            deps: [Injector],
                            useFactory: addCmsRoute,
                        },
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultRoutesConfigFactory = () => {
    const featureToggles = inject(FeatureToggles);
    const enableProductPageRouteAllowsNoProductName = featureToggles.defaultProductPageRouteAllowsNoProductName;
    const routingConfig = {
        routing: {
            routes: {
                home: { paths: [''] },
                notFound: { paths: ['not-found'] },
                // semantic links for login related pages
                login: {
                    /*
                     * New auth flow requires 2 paths for login trigger and login form
                     * where we are redirected from oauth server.
                     * Legacy path will stay, new one is updated.           *
                     */
                    paths: [
                        featureToggles.authorizationCodeFlowByDefault ? 'sign-in' : 'login',
                    ],
                    protected: false,
                    authFlow: true,
                },
                verifyToken: {
                    paths: ['login/verify-token'],
                    protected: false,
                    authFlow: true,
                },
                verifyTokenForRegistration: {
                    paths: ['register/verify-token'],
                    protected: false,
                    authFlow: true,
                },
                register: {
                    paths: ['login/register'],
                    protected: false,
                    authFlow: true,
                },
                forgotPassword: {
                    paths: ['login/forgot-password'],
                    protected: false,
                    authFlow: true,
                },
                resetPassword: {
                    paths: ['login/pw/change'],
                    protected: false,
                    authFlow: true,
                },
                logout: { paths: ['logout'], protected: false, authFlow: true },
                // plp routes
                search: { paths: ['search/:query'] },
                category: {
                    paths: ['category/:categoryCode'],
                    paramsMapping: { categoryCode: 'code' },
                },
                brand: { paths: ['Brands/:brandName/c/:brandCode'] },
                // pdp routes
                product: {
                    paths: enableProductPageRouteAllowsNoProductName
                        ? ['product/:productCode/:name', 'product/:productCode']
                        : ['product/:productCode/:name'],
                    paramsMapping: { productCode: 'code' },
                },
                termsAndConditions: { paths: ['terms-and-conditions'] },
                coupons: { paths: ['my-account/coupons'] },
                couponClaim: {
                    paths: ['my-account/coupon/claim/:couponCode'],
                    paramsMapping: { couponCode: 'code' },
                },
                myInterests: {
                    paths: ['my-account/my-interests'],
                },
                notificationPreference: {
                    paths: ['my-account/notification-preference'],
                },
            },
        },
    };
    /*
     * Configuration necessary to allow customization of login form path,
     * which have to be the same as configured in oauth client
     */
    if (featureToggles.authorizationCodeFlowByDefault) {
        routingConfig.routing.routes['loginForm'] = {
            paths: ['login'],
            protected: false,
            authFlow: true,
        };
    }
    return routingConfig;
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RoutingModule {
    static forRoot() {
        return {
            ngModule: RoutingModule,
            providers: [
                provideDefaultConfigFactory(defaultRoutesConfigFactory),
                {
                    provide: BEFORE_CMS_PAGE_GUARD,
                    useExisting: ProtectedRoutesGuard,
                    multi: true,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: RoutingModule, imports: [i1.RoutingModule, CmsRouteModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingModule, imports: [RoutingModule$1.forRoot(), CmsRouteModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RoutingModule$1.forRoot(), CmsRouteModule],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Matches the pattern '[ ** / ] marker / :paramName'
 *
 * @param marker phrase that indicates the start of the match
 * @param paramName name of the parameter present after the marker
 * @param precedingParamName name of the parameter for every preceding url segment
 *        i.e. `param` will result in `param0`, `param1`, ...
 */
function getSuffixUrlMatcher({ marker, paramName, precedingParamName, }) {
    precedingParamName = precedingParamName || 'param';
    const matcher = function suffixUrlMatcher(segments) {
        const markerIndex = findLastIndex(segments, ({ path }) => path === marker);
        const isMarkerLastSegment = markerIndex === segments.length - 1;
        if (markerIndex === -1 || isMarkerLastSegment) {
            return null;
        }
        const paramIndex = markerIndex + 1;
        const posParams = {
            [paramName]: segments[paramIndex],
        };
        for (let i = 0; i < markerIndex; i++) {
            posParams[`${precedingParamName}${i}`] = segments[i];
        }
        return { consumed: segments.slice(0, paramIndex + 1), posParams };
    };
    if (isDevMode()) {
        matcher['_suffixRouteConfig'] = { marker, paramName, precedingParamName }; // property added for easier debugging of routes
    }
    return matcher;
}
function findLastIndex(elements, predicate) {
    for (let index = elements.length - 1; index >= 0; index--) {
        if (predicate(elements[index])) {
            return index;
        }
    }
    return -1;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageMetaLinkService {
    constructor(winRef, rendererFactory) {
        this.winRef = winRef;
        this.rendererFactory = rendererFactory;
        this.document = inject(DOCUMENT);
    }
    /**
     * Adds a canonical link element to the document head.
     *
     * If an id is provided, the link will be updated.
     * If no url is provided, the link element will be deleted.
     */
    setCanonicalLink(url) {
        let link = this.winRef.document.querySelector('link[rel="canonical"]');
        if (!url) {
            // Removing the link is an edge case, but useful if the canonical url
            // is created in CSR while developing/testing.
            link?.remove();
            return;
        }
        if (!link) {
            link = this.renderer.createElement('link');
            link.rel = 'canonical';
            link.href = url;
            this.renderer.appendChild(this.winRef.document.head, link);
        }
        else {
            link?.setAttribute('href', url);
        }
    }
    addPreconnectLink(url) {
        // Check if a preconnect link with the same href already exists
        const existing = this.document.head.querySelector(`link[rel="preconnect"][href="${url}"]`);
        if (existing) {
            return; // Preconnect link already exists, do nothing
        }
        const preconnect = this.renderer.createElement('link');
        this.renderer.setAttribute(preconnect, 'rel', 'preconnect');
        this.renderer.setAttribute(preconnect, 'href', url);
        this.document.head.insertBefore(preconnect, this.document.head.firstChild); // we want the preconnect-link to be at the top of the <head> section
    }
    get renderer() {
        return this.rendererFactory.createRenderer(null, null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageMetaLinkService, deps: [{ token: i1.WindowRef }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageMetaLinkService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageMetaLinkService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.WindowRef }, { type: i0.RendererFactory2 }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SeoMetaService {
    constructor(ngTitle, ngMeta, pageMetaService, pageMetaLinkService) {
        this.ngTitle = ngTitle;
        this.ngMeta = ngMeta;
        this.pageMetaService = pageMetaService;
        this.pageMetaLinkService = pageMetaLinkService;
    }
    init() {
        this.subscription = this.pageMetaService
            .getMeta()
            .pipe(filter(isNotNullable))
            .subscribe((meta) => (this.meta = meta));
    }
    set meta(meta) {
        this.title = meta.title;
        this.description = meta.description;
        this.image = meta.image;
        this.robots = meta.robots;
        this.canonicalUrl = meta.canonicalUrl;
    }
    set title(title) {
        this.ngTitle.setTitle(title || '');
    }
    set description(value) {
        if (value) {
            this.addTag({ name: 'description', content: value || '' });
        }
        else {
            this.ngMeta.removeTag('name="description"');
        }
    }
    set image(imageUrl) {
        if (imageUrl) {
            this.addTag({ name: 'og:image', content: imageUrl });
        }
        else {
            this.ngMeta.removeTag('name="og:image"');
        }
    }
    set robots(value) {
        if (value && value.length > 0) {
            this.addTag({ name: 'robots', content: value.join(', ') });
        }
    }
    /**
     * Add the canonical Url to the head of the page.
     *
     * If the canonical url already exists the link is removed. This is quite
     * unlikely though, since canonical links are (typically) only added in SSR.
     */
    set canonicalUrl(url) {
        this.pageMetaLinkService?.setCanonicalLink(url);
    }
    addTag(meta) {
        if (meta.content) {
            this.ngMeta.updateTag(meta);
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoMetaService, deps: [{ token: i1$1.Title }, { token: i1$1.Meta }, { token: i1.PageMetaService }, { token: PageMetaLinkService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoMetaService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoMetaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$1.Title }, { type: i1$1.Meta }, { type: i1.PageMetaService }, { type: PageMetaLinkService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates how the browser should load the image.
 *
 * While this might not add too much value in some scenarios, as we have other
 * optimizations to defer loading of larger pieces of the DOM, there might be
 * components who haven't implemented other lazy loading techniques. Moreover,
 * a server sides rendered page that lands directly in the browser could benefit
 * enormously from the lazy loading of images.
 */
var ImageLoadingStrategy;
(function (ImageLoadingStrategy) {
    /**
     * Loads the image immediately, regardless of whether or not the image
     * is currently within the visible viewport (this is the default value).
     */
    ImageLoadingStrategy["EAGER"] = "eager";
    /**
     * Defers loading the image until it reaches a calculated distance from the viewport,
     * as defined by the browser. The intent is to avoid the network and storage bandwidth
     * needed to handle the image until it's reasonably certain that it will be needed.
     * This generally improves the performance of the content in most typical use cases.
     */
    ImageLoadingStrategy["LAZY"] = "lazy";
})(ImageLoadingStrategy || (ImageLoadingStrategy = {}));
/**
 * Indicates the priority of the image fetching.
 * This is used to inform the browser about the relative priority of the image
 * fetching. It can be used to optimize the loading of images based on their
 * importance in the layout or user interaction.
 */
var ImageFetchPriority;
(function (ImageFetchPriority) {
    /**
     * Fetch the image at a high priority relative to other images with the same internal prioritization.
     */
    ImageFetchPriority["HIGH"] = "high";
    /**
     * Fetch the image at a low priority relative to other images with the same internal prioritization.
     */
    ImageFetchPriority["LOW"] = "low";
    /**
     * The browser will decide the priority of the image based on its own heuristics.
     */
    ImageFetchPriority["AUTO"] = "auto";
})(ImageFetchPriority || (ImageFetchPriority = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service which generates media URLs. It leverage the MediaContainer and MediaFormats so
 * that URLs and sizes are generated for the same media. This helps to improve performance
 * across difference devices and layouts.
 *
 * Media formats are optional, but highly recommended. The format will help the browser to
 * identify the right media for the right experience.
 *
 * The MediaService will generate absolute URLs in case relative URLs are provided for the Media.
 * The baseUrl is read from the `occConfig.backend.media.baseUrl` or
 * `occConfig.backend.occ.baseUrl`.
 */
class MediaService {
    constructor(config) {
        this.config = config;
        this.featureConfigService = inject(FeatureConfigService);
    }
    getMediaBasedOnHTMLElementType(elementType, mediaContainer, format, alt, role) {
        const shouldGetMediaForPictureElement = this.featureConfigService.isEnabled('useExtendedMediaComponentConfiguration') && elementType !== 'img';
        return shouldGetMediaForPictureElement
            ? this.getMediaForPictureElement(mediaContainer, format, alt, role)
            : this.getMedia(mediaContainer, format, alt, role);
    }
    /**
     * Returns a `Media` object with the main media (`src`) and various media (`src`)
     * for specific formats.
     *
     * This method is used for creating `Media` object that is used in `img` HTML element
     */
    getMedia(mediaContainer, format, alt, role) {
        if (!mediaContainer) {
            return;
        }
        const commonMediaProperties = this.getCommonMediaObject(mediaContainer, format, alt, role);
        return {
            ...commonMediaProperties,
            srcset: this.resolveSrcSet(mediaContainer, format),
        };
    }
    /**
     * Returns a `Media` object with the main media (`src`) and various sources
     * for specific formats for HTML `<picture>` element.
     */
    getMediaForPictureElement(mediaContainer, format, alt, role) {
        if (!mediaContainer) {
            return;
        }
        const commonMediaProperties = this.getCommonMediaObject(mediaContainer, format, alt, role);
        return {
            ...commonMediaProperties,
            sources: this.resolveSources(mediaContainer, format),
        };
    }
    /**
     * Generates attributes common for `<img>` ang `<picture>`.
     */
    getCommonMediaObject(mediaContainer, format, alt, role) {
        const mainMedia = mediaContainer.url
            ? mediaContainer
            : this.resolveMedia(mediaContainer, format);
        return {
            src: this.resolveAbsoluteUrl(mainMedia?.url ?? ''),
            alt: alt ?? mainMedia?.altText,
            role: role ?? mainMedia?.role,
            ...this.getWidthAndHeight(mediaContainer, format),
        };
    }
    /**
     * Returns width and height for Image.
     *
     * Width and height are not coming from CMS so it should be
     * manually added to the Container | Image object
     */
    getWidthAndHeight(mediaContainer, format) {
        const mainMedia = mediaContainer.url
            ? mediaContainer
            : this.resolveMedia(mediaContainer, format);
        return {
            width: mainMedia?.width,
            height: mainMedia?.height,
        };
    }
    /**
     * Reads the loading strategy from the `MediaConfig`.
     *
     * Defaults to `ImageLoadingStrategy.EAGER`.
     */
    get loadingStrategy() {
        const fallbackStrategy = this.featureConfigService.isEnabled('lazyLoadImagesByDefault')
            ? ImageLoadingStrategy.LAZY
            : ImageLoadingStrategy.EAGER;
        return (this.config?.imageLoadingStrategy ?? fallbackStrategy);
    }
    /**
     * Creates the media formats in a logical sorted order. The map contains the
     * format key and the format size information. We do this only once for performance
     * benefits.
     */
    get sortedFormats() {
        const mediaFormats = this.config?.mediaFormats;
        if (!this._sortedFormats && mediaFormats) {
            this._sortedFormats = Object.keys(mediaFormats)
                .map((key) => ({
                code: key,
                size: mediaFormats[key],
            }))
                .sort((a, b) => a.size.width && b.size.width && a.size.width > b.size.width ? 1 : -1);
        }
        return this._sortedFormats ?? [];
    }
    /**
     * Creates the media formats in a logical sorted order. The map contains the
     * format key and the format media query information. We do this only once for performance
     * benefits.
     */
    get sortedPictureFormats() {
        const pictureElementMediaFormats = this.config?.media?.pictureElementFormats;
        const pictureFormatsOrder = this.config?.media?.pictureFormatsOrder;
        if (!pictureElementMediaFormats) {
            return [];
        }
        if (!this._sortedPictureFormats && pictureElementMediaFormats) {
            this._sortedPictureFormats = Object.keys(pictureElementMediaFormats).map((key) => ({
                code: key,
                mediaQuery: pictureElementMediaFormats[key]?.mediaQueries || '',
            }));
            if (pictureFormatsOrder) {
                this._sortedPictureFormats.sort((a, b) => {
                    const orderA = pictureFormatsOrder.indexOf(a.code);
                    const orderB = pictureFormatsOrder.indexOf(b.code);
                    return ((orderA !== -1 ? orderA : Infinity) -
                        (orderB !== -1 ? orderB : Infinity));
                });
            }
        }
        return this._sortedPictureFormats ?? [];
    }
    /**
     * Creates the media formats in a reversed sorted order.
     */
    get reversedFormats() {
        if (!this._reversedFormats) {
            this._reversedFormats = this.sortedFormats.slice().reverse();
        }
        return this._reversedFormats;
    }
    /**
     * Resolves the right media for the given format. The fo
     */
    resolveMedia(media, format) {
        return media[this.resolveFormat(media, format)];
    }
    /**
     * Validates the format against the given mediaContainer. If there is no format available,
     * or if the mediaContainer doesn't contain a media for the given media, the most optimal
     * format is resolved. If even that is not possible, the first format is returned.
     */
    resolveFormat(mediaContainer, format) {
        if (format && mediaContainer[format]) {
            return format;
        }
        return (this.resolveBestFormat(mediaContainer) || Object.keys(mediaContainer)[0]);
    }
    /**
     * Returns the media format code with the best size.
     */
    resolveBestFormat(media) {
        return this.reversedFormats.find((format) => media.hasOwnProperty(format.code))?.code;
    }
    /**
     * Returns a set of media for the available media formats. Additionally, the configured media
     * format width is added to the srcset, so that browsers can select the appropriate media.
     *
     * The optional maxFormat indicates that only sources till a certain format should be added
     * to the srcset.
     */
    resolveSrcSet(media, maxFormat) {
        if (!media) {
            return undefined;
        }
        const formats = this.getFormatsUpToMaxFormat(this.sortedFormats, maxFormat);
        const srcset = formats.reduce((set, format) => {
            const image = media[format.code];
            if (!!image) {
                if (set) {
                    set += ', ';
                }
                set += `${this.resolveAbsoluteUrl(image.url ?? '')} ${format.size.width}w`;
            }
            return set;
        }, '');
        return srcset === '' ? undefined : srcset;
    }
    /**
     * Resolves the sources for a picture element based on the provided media container and maximum format.
     *
     * This method generates an array of picture element attributes (`srcset` and `media`) by filtering
     * the sorted picture formats up to the specified maximum format. It then maps the corresponding
     * media sources from the provided media container.
     *
     * The method will return an array of picture element attributes suitable for use
     * in a `<picture>` element, or `undefined` if no media is provided.
     */
    resolveSources(media, maxFormat) {
        if (!media) {
            return undefined;
        }
        const pictureFormats = this.getFormatsUpToMaxFormat(this.sortedPictureFormats, maxFormat);
        return pictureFormats.reduce((sources, format) => {
            const image = media[format.code];
            if (image?.url) {
                sources.push({
                    srcset: this.resolveAbsoluteUrl(image.url),
                    media: format.mediaQuery,
                    ...this.getWidthAndHeight(image, maxFormat),
                });
            }
            return sources;
        }, []);
    }
    /**
     * Retrieves a list of formats up to and including the specified max format.
     *
     * @template T - A type that extends an object containing a `code` property of type `string`.
     * @param {T[]} formats - An array of format objects, each containing at least a `code` property.
     * @param {string} [maxFormat] - The maximum format code to include in the returned list.
     * @returns {T[]} An array of formats up to and including the specified max format. If `maxFormat` is not found, returns the entire list.
     *
     * This method filters the provided list of formats to include only those up to and including
     * the specified max format. If the `maxFormat` is not found, the entire list of formats is returned.
     */
    getFormatsUpToMaxFormat(formats, maxFormat) {
        let pictureFormats = formats;
        const maxIndex = pictureFormats.findIndex((f) => f.code === maxFormat);
        if (maxIndex > -1) {
            pictureFormats = pictureFormats.slice(0, maxIndex + 1);
        }
        return pictureFormats;
    }
    /**
     * Resolves the absolute URL for the given url. In most cases, this URL represents
     * the relative URL on the backend. In that case, we prefix the url with the baseUrl.
     *
     * When we have receive an absolute URL, we return the URL as-is. An absolute URL might also
     * start with double slash, which is used to resolve media cross from http and https.
     */
    resolveAbsoluteUrl(url) {
        return !url || url.startsWith('http') || url.startsWith('//')
            ? url
            : this.getBaseUrl() + url;
    }
    /**
     * The base URL is either driven by a specific `backend.media.baseUrl`, or by the
     * `backend.occ.baseUrl`.
     *
     * The `backend.media.baseUrl` can be used to load media from a different location.
     *
     * In Commerce Cloud, a different location could mean a different "aspect".
     *
     * Defaults to empty string in case no config is provided.
     */
    getBaseUrl() {
        return (this.config.backend?.media?.baseUrl ??
            this.config.backend?.occ?.baseUrl ??
            '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaService, deps: [{ token: i1.Config }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.Config }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MediaPreconnectService {
    constructor() {
        this.pageMetaLinkService = inject(PageMetaLinkService);
        this.mediaService = inject(MediaService);
        this.featureToggles = inject(FeatureToggles);
        this.windowRef = inject(WindowRef);
    }
    addPreconnectLink() {
        if (!this.featureToggles.createMediaPreconnectLink) {
            return;
        }
        const url = this.mediaService.getBaseUrl();
        let domain;
        try {
            domain = new URL(url).origin;
        }
        catch {
            domain = undefined;
        }
        // Preconnecting is not needed (and won't be performed) if the domain of the media base url
        // is the same as the storefront's domain
        if (domain && domain !== this.windowRef.location.origin) {
            this.pageMetaLinkService.addPreconnectLink(url);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaPreconnectService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaPreconnectService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaPreconnectService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSeoConfig = {
    seo: {
        structuredData: {
            disableInDevMode: true,
        },
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SeoConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const htmlLangProvider = {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: setHtmlLangAttribute,
    deps: [WindowRef, LanguageService],
};
/**
 * Sets active language in <html lang="">
 */
function setHtmlLangAttribute(winRef, languageService) {
    const result = () => {
        languageService.getActive().subscribe((lang) => {
            winRef.document.documentElement.lang = lang.replace(/_/g, '-');
        });
    };
    return result;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class JsonLdScriptFactory {
    constructor(platformId, winRef, rendererFactory, config) {
        this.platformId = platformId;
        this.winRef = winRef;
        this.rendererFactory = rendererFactory;
        this.config = config;
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    build(schema) {
        if (schema && this.isJsonLdRequired()) {
            this.getJsonLdScriptElement().textContent = this.escapeHtml(schema);
        }
    }
    /**
     * Indicates whether json ld data should be generated.
     *
     * This is only required on the server, but can be enabled in dev mode.
     */
    isJsonLdRequired() {
        return (!isPlatformBrowser(this.platformId) ||
            (isDevMode() && !this.config.seo?.structuredData?.disableInDevMode));
    }
    /**
     * Creates a json-ld script element. The element is created one, and appended
     * to the html body element.
     *
     * ```html
     * <script id="json-ld" type="application/ld+json">
     * </script>
     * ```
     */
    getJsonLdScriptElement() {
        const id = 'json-ld';
        let scriptElement = (this.winRef.document.getElementById(id));
        if (!scriptElement) {
            const script = this.renderer.createElement('script');
            script.id = id;
            script.type = 'application/ld+json';
            this.renderer.appendChild(this.winRef.document.body, script);
            scriptElement = script;
        }
        return scriptElement;
    }
    /**
     * Secure the given json-ld schema by encoding html characters (aka escaping), eg: <script> becomes &lt;script&gt;
     *
     * The given schema is not trusted, as malicious code could be injected (XSS)
     * into the json-ld script.
     */
    escapeHtml(schema) {
        const div = this.renderer.createElement('div');
        div.textContent = JSON.stringify(schema);
        return div.innerHTML;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdScriptFactory, deps: [{ token: PLATFORM_ID }, { token: i1.WindowRef }, { token: i0.RendererFactory2 }, { token: SeoConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdScriptFactory, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdScriptFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i1.WindowRef }, { type: i0.RendererFactory2 }, { type: SeoConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Low level directive that adds a json-ld script tag to the component.
 * This code bypasses the strict XSS security, as otherwise we're not able
 * to append a script tag with JS inside.
 *
 * This helper directive is actually not used in Spartacus, as Spartacus
 * appends json-ld the data to the document body.
 *
 * This directive can however be used by merchants to write static schema data
 * to the DOM in a save way.
 */
class JsonLdDirective {
    /**
     * Writes the schema data to a json-ld script element.
     */
    set cxJsonLd(schema) {
        this.generateJsonLdScript(schema);
    }
    constructor(renderer, jsonLdScriptFactory, element) {
        this.renderer = renderer;
        this.jsonLdScriptFactory = jsonLdScriptFactory;
        this.element = element;
    }
    /**
     * attach the json-ld script tag to DOM with the schema data secured by encoding html tags (aka escaping)
     */
    generateJsonLdScript(schema) {
        if (schema && this.jsonLdScriptFactory.isJsonLdRequired()) {
            const script = this.renderer.createElement('script');
            script.type = 'application/ld+json';
            script.textContent = this.jsonLdScriptFactory.escapeHtml(schema);
            this.renderer.appendChild(this.element.nativeElement, script);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdDirective, deps: [{ token: i0.Renderer2 }, { token: JsonLdScriptFactory }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: JsonLdDirective, isStandalone: false, selector: "[cxJsonLd]", inputs: { cxJsonLd: "cxJsonLd" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxJsonLd]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: JsonLdScriptFactory }, { type: i0.ElementRef }], propDecorators: { cxJsonLd: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Injection token to extend schema builders for adding structural data (json-ld).
 *
 * Some builders (i.e. `JSONLD_PRODUCT_BUILDER`) might have additional
 * lower level builder to further extend the schema.
 */
const SCHEMA_BUILDER = new InjectionToken('SchemaBuilderToken');
/**
 * Injection token to add specific json-ld builders for product related schemas.
 * See see https://schema.org/product for more information.
 */
const JSONLD_PRODUCT_BUILDER = new InjectionToken('JsonLdProductBuilderToken');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Factory service that is used to build the structured data for
 * all configured schema builders.
 */
class StructuredDataFactory {
    constructor(scriptBuilder, builders) {
        this.scriptBuilder = scriptBuilder;
        this.builders = builders;
        this.subscription = new Subscription();
    }
    /**
     * Initiates the build of structured data by collecting all schema
     * builders.
     */
    build() {
        if (this.scriptBuilder.isJsonLdRequired() && this.builders) {
            this.subscription.add(this.collectSchemas().subscribe((schema) => {
                this.scriptBuilder.build(schema);
            }));
        }
    }
    /**
     * Collects all schema builders and observe their structured data.
     */
    collectSchemas() {
        return combineLatest(this.builders.map((builder) => builder.build()));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StructuredDataFactory, deps: [{ token: JsonLdScriptFactory }, { token: SCHEMA_BUILDER, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StructuredDataFactory, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StructuredDataFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: JsonLdScriptFactory }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [SCHEMA_BUILDER]
                }] }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Factory to build the structure data
 * without any interaction with the UI.
 */
function getStructuredDataFactory(injector) {
    const result = () => {
        const factory = injector.get(StructuredDataFactory);
        factory.build();
    };
    return result;
}
class StructuredDataModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StructuredDataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: StructuredDataModule, declarations: [JsonLdDirective], imports: [CommonModule], exports: [JsonLdDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StructuredDataModule, providers: [
            {
                provide: APP_INITIALIZER,
                useFactory: getStructuredDataFactory,
                deps: [Injector],
                multi: true,
            },
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StructuredDataModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [JsonLdDirective],
                    exports: [JsonLdDirective],
                    providers: [
                        {
                            provide: APP_INITIALIZER,
                            useFactory: getStructuredDataFactory,
                            deps: [Injector],
                            multi: true,
                        },
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function initSeoService(injector) {
    const result = () => {
        const service = injector.get(SeoMetaService);
        service.init();
    };
    return result;
}
class SeoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SeoModule, imports: [StructuredDataModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoModule, providers: [
            provideDefaultConfig(defaultSeoConfig),
            {
                provide: APP_INITIALIZER,
                useFactory: initSeoService,
                deps: [Injector],
                multi: true,
            },
            htmlLangProvider,
        ], imports: [StructuredDataModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SeoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [StructuredDataModule],
                    providers: [
                        provideDefaultConfig(defaultSeoConfig),
                        {
                            provide: APP_INITIALIZER,
                            useFactory: initSeoService,
                            deps: [Injector],
                            multi: true,
                        },
                        htmlLangProvider,
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BreadcrumbSchemaBuilder {
    constructor(pageMetaService) {
        this.pageMetaService = pageMetaService;
    }
    build() {
        return this.pageMetaService
            .getMeta()
            .pipe(map((pageMeta) => this.collect(pageMeta)));
    }
    collect(pageMeta) {
        if (!pageMeta?.breadcrumbs) {
            return;
        }
        const crumbs = pageMeta.breadcrumbs.map((crumb, index) => {
            return {
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@id': crumb.link,
                    name: crumb.label,
                },
            };
        });
        if (pageMeta.title) {
            crumbs.push({
                '@type': 'ListItem',
                position: crumbs.length + 1,
                item: {
                    '@id': pageMeta.title,
                    name: pageMeta.title,
                },
            });
        }
        return {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: crumbs,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbSchemaBuilder, deps: [{ token: i1.PageMetaService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbSchemaBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbSchemaBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.PageMetaService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Builds the basic structured data for the product, see https://schema.org/product.
 * This builder includes data for sku number, name, description, brand and main image.
 */
class JsonLdBaseProductBuilder {
    build(product) {
        return of({
            ...this.getProductBase(product),
            ...this.getProductBrand(product),
            ...this.getProductImage(product),
        });
    }
    /**
     * Returns the product sku, name and description.
     */
    getProductBase(product) {
        const result = { sku: product.code };
        if (product.name) {
            result.name = product.name;
        }
        if (product.summary) {
            result.description = product.summary;
        }
        return result;
    }
    /**
     * Returns the image object with the main product image url.
     *
     * If the image is not available, an empty object is returned.
     */
    getProductImage(product) {
        const image = product.images?.PRIMARY?.zoom?.url;
        return image ? { image } : {};
    }
    /**
     * Returns the brand object with the product manufacturer.
     *
     * If the brand is not available, an empty object is returned.
     */
    getProductBrand(product) {
        const brand = product.manufacturer;
        return brand ? { brand } : {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdBaseProductBuilder, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdBaseProductBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdBaseProductBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Builds the structured data for the product offer, see https://schema.org/offers.
 * The data includes the price, currency and availability level.
 */
class JsonLdProductOfferBuilder {
    build(product) {
        const schema = { '@type': 'Offer' };
        if (product.price?.value) {
            schema.price = product.price.value;
            if (product.price.currencyIso) {
                schema.priceCurrency = product.price.currencyIso;
            }
        }
        if (product.stock && product.stock.stockLevelStatus) {
            schema.availability =
                product.stock.stockLevelStatus === 'inStock' ? 'InStock' : 'OutOfStock';
        }
        return of({ offers: schema });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdProductOfferBuilder, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdProductOfferBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdProductOfferBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Builds the structured data for the product reviews, see https://schema.org/Review.
 * The data includes the aggregated product rating and the individual reviews.
 */
class JsonLdProductReviewBuilder {
    constructor(reviewService, config) {
        this.reviewService = reviewService;
        this.config = config;
    }
    build(product) {
        return this.reviewService.getByProductCode(product.code ?? '').pipe(map((reviews) => reviews?.length > 0
            ? {
                aggregateRating: this.buildAggregatedReviews(product, reviews),
                review: reviews.map((review) => this.buildReviews(review)),
            }
            : {}));
    }
    buildAggregatedReviews(product, reviews) {
        const aggregated = {
            '@type': 'AggregateRating',
        };
        if (product.averageRating) {
            aggregated.ratingValue = product.averageRating;
        }
        if (reviews) {
            aggregated.ratingCount = reviews.filter((rev) => !!rev.rating).length;
            aggregated.reviewCount = reviews.filter((rev) => !!rev.comment).length;
        }
        return aggregated;
    }
    buildReviews(review) {
        const reviewSchema = {
            '@type': 'review',
        };
        if (review.principal && review.principal.name) {
            reviewSchema.author = review.principal.name;
        }
        if (review.date) {
            const date = new Date(review.date);
            reviewSchema.datePublished = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        }
        if (review.headline) {
            reviewSchema.name = review.headline;
        }
        if (review.comment) {
            reviewSchema.description = review.comment;
        }
        if (review.rating) {
            reviewSchema.reviewRating = {
                '@type': 'Rating',
                ratingValue: review.rating.toString(),
            };
        }
        return reviewSchema;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdProductReviewBuilder, deps: [{ token: i1.ProductReviewService }, { token: SeoConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdProductReviewBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdProductReviewBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.ProductReviewService }, { type: SeoConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CurrentProductService {
    constructor(routingService, productService) {
        this.routingService = routingService;
        this.productService = productService;
        this.DEFAULT_PRODUCT_SCOPE = ProductScope.DETAILS;
    }
    /**
     * Returns an observable for the current product
     * @returns Product
     * @returns null if product can't be found
     *
     * @param scopes
     */
    getProduct(scopes) {
        return this.getCode().pipe(distinctUntilChanged(), switchMap$1((productCode) => {
            return productCode
                ? this.productService.get(productCode, scopes || this.DEFAULT_PRODUCT_SCOPE)
                : of(null);
        }), filter(isNotUndefined));
    }
    getCode() {
        return this.routingService
            .getRouterState()
            .pipe(map((state) => state.state.params['productCode']));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CurrentProductService, deps: [{ token: i1.RoutingService }, { token: i1.ProductService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CurrentProductService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CurrentProductService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RoutingService }, { type: i1.ProductService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Adds the minimal structured data for the product, see https://schema.org/product.
 * The actual data collection is delegated to `JsonLdBuilder`s, which can be injected
 * using the `JSONLD_PRODUCT_BUILDER` token.
 */
class ProductSchemaBuilder {
    constructor(currentProduct, builders) {
        this.currentProduct = currentProduct;
        this.builders = builders;
    }
    build() {
        return this.currentProduct.getProduct().pipe(switchMap$1((product) => {
            if (product) {
                return combineLatest(this.collect(product)).pipe(map((res) => Object.assign({}, ...res)));
            }
            return of({});
        }));
    }
    collect(product) {
        if (!product || !product.code) {
            return [];
        }
        const builders = this.builders
            ? this.builders.map((builder) => builder.build(product))
            : [];
        return [
            of({
                '@context': 'http://schema.org',
                '@type': 'Product',
            }),
            ...builders,
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductSchemaBuilder, deps: [{ token: CurrentProductService }, { token: JSONLD_PRODUCT_BUILDER, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductSchemaBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductSchemaBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: CurrentProductService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [JSONLD_PRODUCT_BUILDER]
                }] }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides several standard json-ld builders that contribute
 * to collecting and building json-ld data.
 */
class JsonLdBuilderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdBuilderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: JsonLdBuilderModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdBuilderModule, providers: [
            {
                provide: SCHEMA_BUILDER,
                useExisting: ProductSchemaBuilder,
                multi: true,
            },
            {
                provide: SCHEMA_BUILDER,
                useExisting: BreadcrumbSchemaBuilder,
                multi: true,
            },
            // lower level json-ld builder classes offering fine-grained control
            // for product related schemas
            {
                provide: JSONLD_PRODUCT_BUILDER,
                useExisting: JsonLdBaseProductBuilder,
                multi: true,
            },
            {
                provide: JSONLD_PRODUCT_BUILDER,
                useExisting: JsonLdProductOfferBuilder,
                multi: true,
            },
            {
                provide: JSONLD_PRODUCT_BUILDER,
                useExisting: JsonLdProductReviewBuilder,
                multi: true,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: JsonLdBuilderModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: SCHEMA_BUILDER,
                            useExisting: ProductSchemaBuilder,
                            multi: true,
                        },
                        {
                            provide: SCHEMA_BUILDER,
                            useExisting: BreadcrumbSchemaBuilder,
                            multi: true,
                        },
                        // lower level json-ld builder classes offering fine-grained control
                        // for product related schemas
                        {
                            provide: JSONLD_PRODUCT_BUILDER,
                            useExisting: JsonLdBaseProductBuilder,
                            multi: true,
                        },
                        {
                            provide: JSONLD_PRODUCT_BUILDER,
                            useExisting: JsonLdProductOfferBuilder,
                            multi: true,
                        },
                        {
                            provide: JSONLD_PRODUCT_BUILDER,
                            useExisting: JsonLdProductReviewBuilder,
                            multi: true,
                        },
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var PageSection;
(function (PageSection) {
    PageSection["HEADER"] = "header";
    PageSection["FOOTER"] = "footer";
    PageSection["NAVIGATION"] = "navigation";
})(PageSection || (PageSection = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Helper function to simplify the creation of static CMS structure (`CmsStructureConfig`).
 * The helper function leverage the `provideConfig`, and is only providing an easy way to
 * generate the cms structure. The function creates a configuration structure for components,
 * page slot and page template. The following example adds a component to a page slot:
 *
 * ```ts
 * provideCmsStructure({
 *   componentId: 'LoginComponent',
 *   pageSlotPosition: 'SiteLogin'
 * })
 * ```
 *
 * @param options.componentId component identifier is used to provide component structure
 * @param options.pageSlotPosition page slot position is used to provide the slot configuration
 * @param options.pageTemplate the page template is used to provide the page slot to the given page template
 * @param options.section the section is used to provide the page slot to the given section
 * @param options.breakpoint the breakpoint is used to provide the page slot for a specific breakpoint
 */
function provideCmsStructure(options) {
    return provideConfig({
        ...buildCmsStructure(options),
        ...buildLayoutConfig(options),
    });
}
/**
 * @private
 */
function buildCmsStructure({ componentId, pageSlotPosition, } = {}) {
    const config = { cmsStructure: {} };
    if (componentId) {
        config.cmsStructure = {
            components: {
                [componentId]: {
                    typeCode: componentId,
                    flexType: componentId,
                },
            },
        };
    }
    if (componentId && pageSlotPosition && config.cmsStructure) {
        config.cmsStructure.slots = {
            [pageSlotPosition]: { componentIds: [componentId] },
        };
    }
    return config;
}
/**
 * @private
 */
function buildLayoutConfig({ pageTemplate, pageSlotPosition, breakpoint, section, } = {}) {
    const layoutConfig = {};
    if (pageTemplate && pageSlotPosition) {
        const pageTemplateSlots = {};
        if (breakpoint) {
            pageTemplateSlots[breakpoint] = {
                slots: [pageSlotPosition],
            };
        }
        else {
            pageTemplateSlots.slots = [pageSlotPosition];
        }
        layoutConfig.layoutSlots = {
            [pageTemplate]: pageTemplateSlots,
        };
    }
    if (section && pageSlotPosition) {
        const sectionSlots = {};
        if (breakpoint) {
            sectionSlots[breakpoint] = { slots: [pageSlotPosition] };
        }
        else {
            sectionSlots.slots = [pageSlotPosition];
        }
        if (layoutConfig.layoutSlots) {
            layoutConfig.layoutSlots[section] = sectionSlots;
        }
        else {
            layoutConfig.layoutSlots = {
                [section]: sectionSlots,
            };
        }
    }
    return layoutConfig;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });
class SkipLink {
}
var SkipLinkScrollPosition;
(function (SkipLinkScrollPosition) {
    SkipLinkScrollPosition["BEFORE"] = "BEFORE";
    SkipLinkScrollPosition["AFTER"] = "AFTER";
})(SkipLinkScrollPosition || (SkipLinkScrollPosition = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkService {
    constructor(config, keyboardFocusService) {
        this.config = config;
        this.keyboardFocusService = keyboardFocusService;
        this.skipLinks$ = new BehaviorSubject([]);
    }
    getSkipLinks() {
        return this.skipLinks$;
    }
    add(key, target) {
        const found = this.config.skipLinks?.find((skipLink) => skipLink.key === key);
        if (found) {
            const existing = this.skipLinks$.value;
            existing.splice(this.getSkipLinkIndexInArray(key), 0, {
                target,
                i18nKey: found.i18nKey,
                position: found.position,
                key,
            });
            this.skipLinks$.next(existing);
        }
    }
    remove(key) {
        const found = this.config.skipLinks?.find((skipLink) => skipLink.key === key);
        if (found) {
            let existing = this.skipLinks$.value;
            existing = existing.filter((skipLink) => skipLink.key !== key);
            this.skipLinks$.next(existing);
        }
    }
    scrollToTarget(scrollTo) {
        const skipLink = typeof scrollTo === 'string'
            ? this.findSkipLinkByKey(scrollTo)
            : scrollTo;
        if (!skipLink) {
            return;
        }
        const target = skipLink.target instanceof HTMLElement
            ? skipLink.target
            : skipLink.target?.parentElement;
        // focus first focusable element in the
        const firstFocusable = this.keyboardFocusService.findFirstFocusable(target) || target;
        // we force a tabindex if not available, to ensure we can focus into the element
        const hasTabindex = firstFocusable?.hasAttribute('tabindex');
        if (!hasTabindex) {
            firstFocusable?.setAttribute('tabindex', '-1');
        }
        firstFocusable?.focus();
        // drop the tmp tabindex
        if (!hasTabindex) {
            firstFocusable?.removeAttribute('tabindex');
        }
    }
    findSkipLinkByKey(key) {
        return this.skipLinks$.value.find((skipLink) => skipLink.key === key);
    }
    getSkipLinkIndexInArray(key) {
        let index = this.config.skipLinks?.findIndex((skipLink) => skipLink.key === key) ?? 0;
        while (index > 0) {
            index--;
            const previous = this.config.skipLinks?.[index];
            if (previous) {
                const existing = this.skipLinks$.value;
                const found = existing.findIndex((skipLink) => skipLink.key === previous.key);
                if (found > -1) {
                    return found + 1;
                }
            }
        }
        return 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkService, deps: [{ token: SkipLinkConfig }, { token: KeyboardFocusService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: SkipLinkConfig }, { type: KeyboardFocusService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkComponent {
    constructor(skipLinkService) {
        this.skipLinkService = skipLinkService;
        this.skipLinks$ = this.skipLinkService.getSkipLinks();
    }
    scrollToTarget(skipLink) {
        this.skipLinkService.scrollToTarget(skipLink);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkComponent, deps: [{ token: SkipLinkService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: SkipLinkComponent, isStandalone: false, selector: "cx-skip-link", ngImport: i0, template: "<div [cxFocus]=\"{ tab: true }\" *ngIf=\"skipLinks$ | async as links\">\n  <button *ngFor=\"let link of links\" (click)=\"scrollToTarget(link)\">\n    {{ 'skipLink.skipTo' | cxTranslate }}\n    {{ link.i18nKey | cxTranslate }}\n  </button>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-skip-link', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div [cxFocus]=\"{ tab: true }\" *ngIf=\"skipLinks$ | async as links\">\n  <button *ngFor=\"let link of links\" (click)=\"scrollToTarget(link)\">\n    {{ 'skipLink.skipTo' | cxTranslate }}\n    {{ link.i18nKey | cxTranslate }}\n  </button>\n</div>\n" }]
        }], ctorParameters: () => [{ type: SkipLinkService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSkipLinkConfig = {
    skipLinks: [
        {
            key: 'cx-header',
            i18nKey: 'skipLink.labels.header',
        },
        {
            key: 'cx-main',
            i18nKey: 'skipLink.labels.main',
        },
        { key: 'cx-footer', i18nKey: 'skipLink.labels.footer' },
    ],
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkDirective {
    constructor(elementRef, skipLinkService) {
        this.elementRef = elementRef;
        this.skipLinkService = skipLinkService;
    }
    ngOnInit() {
        this.skipLinkService.add(this.cxSkipLink, this.elementRef.nativeElement);
    }
    ngOnDestroy() {
        this.skipLinkService.remove(this.cxSkipLink);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkDirective, deps: [{ token: i0.ElementRef }, { token: SkipLinkService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: SkipLinkDirective, isStandalone: false, selector: "[cxSkipLink]", inputs: { cxSkipLink: "cxSkipLink" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxSkipLink]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: SkipLinkService }], propDecorators: { cxSkipLink: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkModule, declarations: [SkipLinkComponent, SkipLinkDirective], imports: [CommonModule,
            I18nModule, i1.ConfigModule, KeyboardFocusModule], exports: [SkipLinkDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkModule, providers: [
            provideDefaultConfig(defaultSkipLinkConfig),
            {
                provide: APP_INITIALIZER,
                useFactory: skipLinkFactory,
                deps: [ComponentFactoryResolver, OutletService],
                multi: true,
            },
        ], imports: [CommonModule,
            I18nModule,
            ConfigModule.withConfig(defaultSkipLinkConfig),
            KeyboardFocusModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SkipLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        I18nModule,
                        ConfigModule.withConfig(defaultSkipLinkConfig),
                        KeyboardFocusModule,
                    ],
                    declarations: [SkipLinkComponent, SkipLinkDirective],
                    exports: [SkipLinkDirective],
                    providers: [
                        provideDefaultConfig(defaultSkipLinkConfig),
                        {
                            provide: APP_INITIALIZER,
                            useFactory: skipLinkFactory,
                            deps: [ComponentFactoryResolver, OutletService],
                            multi: true,
                        },
                    ],
                }]
        }] });
/**
 * Adds the skip link component before the cx-storefront.
 */
function skipLinkFactory(componentFactoryResolver, outletService) {
    const isReady = () => {
        const factory = componentFactoryResolver.resolveComponentFactory(SkipLinkComponent);
        outletService.add('cx-storefront', factory, OutletPosition.BEFORE);
    };
    return isReady;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive used for making links styled as a buttons (using .btn class)
 * act as a real buttons a11y wise (meaning making them reactive to both
 * enter and spacebar clicks).
 *
 * Note: This is done as a11y optimization for old button like link compoennts
 * and shouldn't be used other than for those. Whenever you find yourself in a need
 * to be using this consider it as a good 'code smell' for using BUttons instead of links.
 */
class BtnLikeLinkDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BtnLikeLinkDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: BtnLikeLinkDirective, isStandalone: false, selector: "a[cxBtnLikeLink].btn", host: { attributes: { "tabindex": "0", "role": "button" }, listeners: { "keydown.enter": "$event.preventDefault() ; $event.target.click() ;", "keydown.space": "$event.preventDefault() ; $event.target.click() ;" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BtnLikeLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'a[cxBtnLikeLink].btn', // 'a.btn'
                    host: {
                        // Adding [tabindex] allows tab-based access to this element.
                        tabindex: '0',
                        // Adding [role] tells screen reatders that this "link" is really a "button"
                        role: 'button',
                        // Add Enter keydown click mimic native Button's behaviour
                        '(keydown.enter)': '$event.preventDefault() ; $event.target.click() ;',
                        // Add Space keydown click mimic native Button's behaviour
                        '(keydown.space)': '$event.preventDefault() ; $event.target.click() ;',
                    },
                    standalone: false,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const directives = [BtnLikeLinkDirective];
class BtnLikeLinkModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BtnLikeLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: BtnLikeLinkModule, declarations: [BtnLikeLinkDirective], imports: [CommonModule], exports: [BtnLikeLinkDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BtnLikeLinkModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BtnLikeLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [...directives],
                    exports: [...directives],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Custom Directive used to enable clients to track (react to) Host's Element DOM changes.
 *
 * Whenever the mutation (Host's element DOM subthree change) is detected it will trigger the
 * _cxDomChange_ Output allowing clients to react to the Host's element DOM changes.
 *
 * Optional _cxDomChangeTargetSelector_ Input enables clients to be more specifixc when reacting to
 * the Host's element DOM changes by allowing them to specify css selector (relative to Host Element)
 * that narrows down the number of _cxDomChange_ Output executions to be triggered only when
 * _cxDomChangeTargetSelector_ Input relevant elements changes are detected.
 */
class DomChangeDirective {
    constructor() {
        this.cxDomChange = new EventEmitter();
        this.elementRef = inject(ElementRef);
        this.changes = new MutationObserver((mutations) => {
            const affectedMutations = this.cxDomChangeTargetSelector
                ? mutations.filter((mutation) => mutation.target ===
                    this.elementRef.nativeElement.querySelector(this.cxDomChangeTargetSelector))
                : mutations;
            affectedMutations.forEach((mutation) => this.cxDomChange.emit(mutation));
        });
        this.changes.observe(this.elementRef.nativeElement, {
            subtree: true,
            childList: true,
        });
    }
    ngOnDestroy() {
        this.changes.disconnect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DomChangeDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: DomChangeDirective, isStandalone: false, selector: "[cxDomChange]", inputs: { cxDomChangeTargetSelector: "cxDomChangeTargetSelector" }, outputs: { cxDomChange: "cxDomChange" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DomChangeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxDomChange]',
                    standalone: false,
                }]
        }], ctorParameters: () => [], propDecorators: { cxDomChangeTargetSelector: [{
                type: Input
            }], cxDomChange: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class DomChangeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DomChangeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: DomChangeModule, declarations: [DomChangeDirective], imports: [CommonModule], exports: [DomChangeDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DomChangeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DomChangeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [DomChangeDirective],
                    exports: [DomChangeDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CarouselService {
    constructor(winRef) {
        this.winRef = winRef;
    }
    /**
     * The number of items per slide is calculated by the help of
     * the item width and the available width of the host element.
     * This appoach makes it possible to place the carousel in different
     * layouts. Instead of using the page breakpoints, the host size is
     * taken into account.
     *
     * Since there's no element resize API available, we use the
     * window `resize` event, so that we can adjust the number of items
     * whenever the window got resized.
     */
    getItemsPerSlide(nativeElement, itemWidth) {
        return this.winRef.resize$.pipe(map(() => nativeElement.clientWidth), map((totalWidth) => this.calculateItems(totalWidth, itemWidth)));
    }
    /**
     * Calculates the number of items per given hostSize.  calculated based on the given
     * intended size in pixels or percentages. The
     *
     * @param availableWidth The available width in pixels for the carousel items.
     * @param itemWidth The width per carousel item, in px or percentage.
     */
    calculateItems(availableWidth, itemWidth) {
        let calculatedItems = 0;
        if (itemWidth.endsWith('px')) {
            const num = itemWidth.substring(0, itemWidth.length - 2);
            calculatedItems = availableWidth / num;
        }
        if (itemWidth.endsWith('%')) {
            const perc = itemWidth.substring(0, itemWidth.length - 1);
            calculatedItems =
                availableWidth / (availableWidth * (perc / 100));
        }
        return Math.floor(calculatedItems) || 1;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselService, deps: [{ token: i1.WindowRef }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.WindowRef }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Generic carousel component that can be used to render any carousel items,
 * such as products, images, banners, or any component. Carousel items are
 * rendered in so-called carousel slides, and the previous/next buttons as well as
 * the indicator-buttons can used to navigate the slides.
 *
 * The component uses an array of Observables (`items$`) as an input, to allow
 * for lazy loading of items.
 *
 * The number of items per slide is calculated with the `itemWidth`, which can given
 * in pixels or percentage.
 *
 * To allow for flexible rendering of items, the rendering is delegated to the
 * given `template`. This allows for maximum flexibility.
 *
 * Hydration is disabled for this component (`ngSkipHydration: 'true'`) due to inconsistencies between
 * client-side rendering (CSR) and server-side rendering (SSR). The differences in rendered output
 * can cause issues during the hydration process, so this component is excluded from Angular hydration.
 */
class CarouselComponent {
    set setItems(inputItems) {
        this.items = inputItems;
        //Reset slider when changing products
        this.activeSlide = 0;
    }
    constructor(el, service) {
        this.el = el;
        this.service = service;
        this.keybordEvent = new BehaviorSubject(null);
        /**
         * Specifies the minimum size of the carousel item, either in px or %.
         * This value is used for the calculation of numbers per carousel, so that
         * the number of carousel items is dynamic. The calculation uses the `itemWidth`
         * and the host element `clientWidth`, so that the carousel is reusable in
         * different layouts (for example in a 50% grid).
         */
        this.itemWidth = '300px';
        /**
         * Indicates whether the visual indicators are used.
         */
        this.hideIndicators = false;
        this.indicatorIcon = ICON_TYPE.CIRCLE;
        this.previousIcon = ICON_TYPE.CARET_LEFT;
        this.nextIcon = ICON_TYPE.CARET_RIGHT;
        /**
         * Angular's trackBy function for iterating over carousel items.
         *
         * For a given item it should return an unique identifier.
         * If not provided, it will fallback to returning the item directly
         * (like Angular's naive default trackBy).
         *
         * If the returned value is not unique, it may lead to unexpected behavior,
         * such as unwanted destroying and re-creating child templates on items array changes.
         */
        this.trackByFn = (_index, item) => item;
        this.logger = inject(LoggerService);
        useFeatureStyles('a11yAddPaddingToCarouselPanel');
    }
    ngOnInit() {
        if (!this.template && isDevMode()) {
            this.logger.error('No template reference provided to render the carousel items for the `cx-carousel`');
        }
    }
    ngOnChanges() {
        this.size$ = this.service
            .getItemsPerSlide(this.el.nativeElement, this.itemWidth)
            .pipe(tap(() => (this.activeSlide = 0)));
    }
    onItemKeydown(event, size) {
        switch (event.key) {
            case 'ArrowRight':
            case 'ArrowLeft':
                event.preventDefault();
                this.focusNextPrevItem(event.target, event.key === 'ArrowRight' ? 1 : -1, size);
                break;
            case 'Tab':
                this.skipTabForCarouselItems();
                break;
        }
    }
    /**
     * Handles Tab key on carousel items. If the carousel items have `ArrowRight`/`ArrowLeft`
     * navigation enabled, it temporarily disables tab navigation for these items.
     * The `cxFocusableCarouselItem` selector is used because it identifies carousel
     * items that have `ArrowRight`/`ArrowLeft` navigation enabled. These items should not
     * use tab navigation according to a11y requirements.
     */
    skipTabForCarouselItems() {
        const carouselElements = Array.from(this.el.nativeElement.querySelectorAll('[cxFocusableCarouselItem]'));
        if (!carouselElements.length) {
            return;
        }
        disableTabbingForTick(carouselElements);
    }
    /**
     * Focuses the next or previous item in the carousel based on keyboard navigation.
     *
     * This method determines the next focusable carousel item, identified by the
     * `cxFocusableCarouselItem` directive, based on the current focus and the direction
     * given. It adjusts the carousel's active slide if the next focusable item is
     * outside the currently visible items.
     *
     * @param currentItem - The currently focused carousel item.
     * @param direction - The navigation direction (1 for right, -1 for left).
     * @param size - The number of items per slide, used to determine slide change is needed
     */
    focusNextPrevItem(currentItem, direction, size) {
        const focusableElements = this.el.nativeElement.querySelectorAll('[cxFocusableCarouselItem]');
        const currentIndex = Array.from(focusableElements).indexOf(currentItem);
        const nextIndex = currentIndex + direction;
        if (nextIndex < 0 || nextIndex >= focusableElements.length) {
            return;
        }
        const targetElement = focusableElements[nextIndex];
        const shouldChangeSlide = nextIndex < this.activeSlide || nextIndex >= this.activeSlide + size;
        if (shouldChangeSlide) {
            this.activeSlide = nextIndex - (nextIndex % size);
            // After changing slides carousel items has CSS transition,
            // which prevents them from being focused
            targetElement.addEventListener('transitionend', () => {
                targetElement.focus();
            }, { once: true });
        }
        else {
            targetElement.focus();
        }
    }
    getSlideNumber(size, currentIndex) {
        const normalizedCurrentIndex = currentIndex + 1;
        return Math.ceil(normalizedCurrentIndex / size);
    }
    shareEvent(event) {
        if (!event) {
            throw new Error('Missing Event');
        }
        this.keybordEvent.next(event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselComponent, deps: [{ token: i0.ElementRef }, { token: CarouselService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: CarouselComponent, isStandalone: false, selector: "cx-carousel", inputs: { title: "title", setItems: ["items", "setItems"], template: "template", itemWidth: "itemWidth", hideIndicators: "hideIndicators", indicatorIcon: "indicatorIcon", previousIcon: "previousIcon", nextIcon: "nextIcon", trackByFn: "trackByFn" }, outputs: { keybordEvent: "keybordEvent" }, host: { attributes: { "ngSkipHydration": "true" } }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"items && items.length > 0 && (size$ | async) as size\">\n  <h2 *ngIf=\"title\">{{ title }}</h2>\n\n  <div class=\"carousel-panel\" [ngClass]=\"'size-' + size\">\n    <button\n      *ngIf=\"size < items.length\"\n      class=\"previous\"\n      (click)=\"\n        $event.stopPropagation();\n        activeSlide === 0 ? null : (activeSlide = activeSlide - size)\n      \"\n      [attr.aria-disabled]=\"activeSlide === 0\"\n      [attr.aria-label]=\"'carousel.previousSlide' | cxTranslate\"\n      [attr.title]=\"'carousel.previousSlide' | cxTranslate\"\n      (keydown.arrowleft)=\"shareEvent($any($event))\"\n      (keydown.arrowright)=\"shareEvent($any($event))\"\n      (keydown.arrowup)=\"shareEvent($any($event))\"\n      (keydown.arrowdown)=\"shareEvent($any($event))\"\n    >\n      <cx-icon [type]=\"previousIcon\"></cx-icon>\n    </button>\n    <div class=\"slides\">\n      <ng-container *ngFor=\"let _ of items; let i = index; trackBy: trackByFn\">\n        <div\n          class=\"slide\"\n          *ngIf=\"i % size === 0\"\n          [class.active]=\"i === activeSlide\"\n        >\n          <ng-container\n            *ngFor=\"\n              let item of items | slice: i : i + size;\n              let j = index;\n              trackBy: trackByFn\n            \"\n          >\n            <div\n              *ngIf=\"item | async as data\"\n              class=\"item\"\n              [class.active]=\"i === activeSlide\"\n              (keydown)=\"onItemKeydown($event, size)\"\n            >\n              <ng-container\n                *ngTemplateOutlet=\"\n                  template;\n                  context: {\n                    item: data,\n                    itemIndex: i + j,\n                  }\n                \"\n              ></ng-container>\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n\n    <button\n      *ngIf=\"size < items.length\"\n      class=\"next\"\n      (click)=\"\n        $event.stopPropagation();\n        activeSlide > items.length - size - 1\n          ? null\n          : (activeSlide = activeSlide + size)\n      \"\n      [attr.aria-disabled]=\"activeSlide > items.length - size - 1\"\n      [attr.aria-label]=\"'carousel.nextSlide' | cxTranslate\"\n      [attr.title]=\"'carousel.nextSlide' | cxTranslate\"\n      (keydown.arrowleft)=\"shareEvent($any($event))\"\n      (keydown.arrowright)=\"shareEvent($any($event))\"\n      (keydown.arrowup)=\"shareEvent($any($event))\"\n      (keydown.arrowdown)=\"shareEvent($any($event))\"\n    >\n      <cx-icon [type]=\"nextIcon\"></cx-icon>\n    </button>\n  </div>\n\n  <div *ngIf=\"!hideIndicators && size < items.length\" class=\"indicators\">\n    <ng-container *ngFor=\"let _ of items; let i = index\">\n      <button\n        *ngIf=\"i % size === 0\"\n        (click)=\"$event.stopPropagation(); activeSlide = i\"\n        [attr.aria-current]=\"i === activeSlide\"\n        [attr.aria-disabled]=\"i === activeSlide\"\n        [attr.aria-label]=\"\n          'carousel.slideNumber'\n            | cxTranslate\n              : {\n                  currentSlideNumber: getSlideNumber(size, i),\n                  numberOfSlides: size,\n                }\n        \"\n        [attr.title]=\"\n          'carousel.slideNumber'\n            | cxTranslate\n              : {\n                  currentSlideNumber: getSlideNumber(size, i),\n                  numberOfSlides: size,\n                }\n        \"\n      >\n        <cx-icon [type]=\"indicatorIcon\" aria-hidden=\"true\"></cx-icon>\n      </button>\n    </ng-container>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.SlicePipe, name: "slice" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-carousel', changeDetection: ChangeDetectionStrategy.OnPush, host: { ngSkipHydration: 'true' }, standalone: false, template: "<ng-container *ngIf=\"items && items.length > 0 && (size$ | async) as size\">\n  <h2 *ngIf=\"title\">{{ title }}</h2>\n\n  <div class=\"carousel-panel\" [ngClass]=\"'size-' + size\">\n    <button\n      *ngIf=\"size < items.length\"\n      class=\"previous\"\n      (click)=\"\n        $event.stopPropagation();\n        activeSlide === 0 ? null : (activeSlide = activeSlide - size)\n      \"\n      [attr.aria-disabled]=\"activeSlide === 0\"\n      [attr.aria-label]=\"'carousel.previousSlide' | cxTranslate\"\n      [attr.title]=\"'carousel.previousSlide' | cxTranslate\"\n      (keydown.arrowleft)=\"shareEvent($any($event))\"\n      (keydown.arrowright)=\"shareEvent($any($event))\"\n      (keydown.arrowup)=\"shareEvent($any($event))\"\n      (keydown.arrowdown)=\"shareEvent($any($event))\"\n    >\n      <cx-icon [type]=\"previousIcon\"></cx-icon>\n    </button>\n    <div class=\"slides\">\n      <ng-container *ngFor=\"let _ of items; let i = index; trackBy: trackByFn\">\n        <div\n          class=\"slide\"\n          *ngIf=\"i % size === 0\"\n          [class.active]=\"i === activeSlide\"\n        >\n          <ng-container\n            *ngFor=\"\n              let item of items | slice: i : i + size;\n              let j = index;\n              trackBy: trackByFn\n            \"\n          >\n            <div\n              *ngIf=\"item | async as data\"\n              class=\"item\"\n              [class.active]=\"i === activeSlide\"\n              (keydown)=\"onItemKeydown($event, size)\"\n            >\n              <ng-container\n                *ngTemplateOutlet=\"\n                  template;\n                  context: {\n                    item: data,\n                    itemIndex: i + j,\n                  }\n                \"\n              ></ng-container>\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n\n    <button\n      *ngIf=\"size < items.length\"\n      class=\"next\"\n      (click)=\"\n        $event.stopPropagation();\n        activeSlide > items.length - size - 1\n          ? null\n          : (activeSlide = activeSlide + size)\n      \"\n      [attr.aria-disabled]=\"activeSlide > items.length - size - 1\"\n      [attr.aria-label]=\"'carousel.nextSlide' | cxTranslate\"\n      [attr.title]=\"'carousel.nextSlide' | cxTranslate\"\n      (keydown.arrowleft)=\"shareEvent($any($event))\"\n      (keydown.arrowright)=\"shareEvent($any($event))\"\n      (keydown.arrowup)=\"shareEvent($any($event))\"\n      (keydown.arrowdown)=\"shareEvent($any($event))\"\n    >\n      <cx-icon [type]=\"nextIcon\"></cx-icon>\n    </button>\n  </div>\n\n  <div *ngIf=\"!hideIndicators && size < items.length\" class=\"indicators\">\n    <ng-container *ngFor=\"let _ of items; let i = index\">\n      <button\n        *ngIf=\"i % size === 0\"\n        (click)=\"$event.stopPropagation(); activeSlide = i\"\n        [attr.aria-current]=\"i === activeSlide\"\n        [attr.aria-disabled]=\"i === activeSlide\"\n        [attr.aria-label]=\"\n          'carousel.slideNumber'\n            | cxTranslate\n              : {\n                  currentSlideNumber: getSlideNumber(size, i),\n                  numberOfSlides: size,\n                }\n        \"\n        [attr.title]=\"\n          'carousel.slideNumber'\n            | cxTranslate\n              : {\n                  currentSlideNumber: getSlideNumber(size, i),\n                  numberOfSlides: size,\n                }\n        \"\n      >\n        <cx-icon [type]=\"indicatorIcon\" aria-hidden=\"true\"></cx-icon>\n      </button>\n    </ng-container>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CarouselService }], propDecorators: { keybordEvent: [{
                type: Output
            }], title: [{
                type: Input
            }], setItems: [{
                type: Input,
                args: ['items']
            }], template: [{
                type: Input
            }], itemWidth: [{
                type: Input
            }], hideIndicators: [{
                type: Input
            }], indicatorIcon: [{
                type: Input
            }], previousIcon: [{
                type: Input
            }], nextIcon: [{
                type: Input
            }], trackByFn: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Generic carousel that renders CMS Components.
 */
class BannerCarouselComponent {
    constructor(componentData, cmsService) {
        this.componentData = componentData;
        this.cmsService = cmsService;
        this.componentData$ = this.componentData.data$.pipe(filter((data) => Boolean(data)), tap((d) => (this.theme = `${d.effect}-theme`)));
        this.items$ = this.componentData$.pipe(map((data) => data.banners?.trim().split(' ') ?? []), map((codes) => codes.map((code) => this.cmsService.getComponentData(code))));
        /**
         * Adds a specific theme for the carousel. The effect can be
         * used in CSS customisations.
         */
        this.theme = '';
    }
    /**
     * Returns an Obervable with an Array of Observables. This is done, so that
     * the component UI could consider to lazy load the UI components when they're
     * in the viewpoint.
     */
    getItems() {
        return this.items$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerCarouselComponent, deps: [{ token: CmsComponentData }, { token: i1.CmsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: BannerCarouselComponent, isStandalone: false, selector: "cx-banner-carousel", host: { properties: { "class": "this.theme" } }, ngImport: i0, template: "<cx-carousel\n  *ngIf=\"getItems() | async as items\"\n  [items]=\"items\"\n  [template]=\"template\"\n  itemWidth=\"100%\"\n  class=\"inline-navigation\"\n></cx-carousel>\n\n<ng-template #template let-item=\"item\">\n  <ng-container\n    [cxComponentWrapper]=\"{\n      flexType: item.typeCode,\n      typeCode: item.typeCode,\n      uid: item?.uid,\n    }\"\n  >\n  </ng-container>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ComponentWrapperDirective, selector: "[cxComponentWrapper]", inputs: ["cxComponentWrapper"], outputs: ["cxComponentRef"] }, { kind: "component", type: CarouselComponent, selector: "cx-carousel", inputs: ["title", "items", "template", "itemWidth", "hideIndicators", "indicatorIcon", "previousIcon", "nextIcon", "trackByFn"], outputs: ["keybordEvent"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerCarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-banner-carousel', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<cx-carousel\n  *ngIf=\"getItems() | async as items\"\n  [items]=\"items\"\n  [template]=\"template\"\n  itemWidth=\"100%\"\n  class=\"inline-navigation\"\n></cx-carousel>\n\n<ng-template #template let-item=\"item\">\n  <ng-container\n    [cxComponentWrapper]=\"{\n      flexType: item.typeCode,\n      typeCode: item.typeCode,\n      uid: item?.uid,\n    }\"\n  >\n  </ng-container>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: i1.CmsService }], propDecorators: { theme: [{
                type: HostBinding,
                args: ['class']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SpinnerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SpinnerModule, declarations: [SpinnerComponent], imports: [CommonModule, I18nModule], exports: [SpinnerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SpinnerModule, imports: [CommonModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule],
                    declarations: [SpinnerComponent],
                    exports: [SpinnerComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsentManagementComponentService {
    constructor(anonymousConsentsConfig) {
        this.anonymousConsentsConfig = anonymousConsentsConfig;
    }
    /**
     * Returns the list of mandatory consents
     * @param _templateList - list of all active consents. This parameter is not needed in core
     * implementation. But is needed in CDC implementation to fetch only the required consents
     * from this list
     * @returns array of consent IDs
     */
    getRequiredConsents(_templateList) {
        return (this.anonymousConsentsConfig?.anonymousConsents?.requiredConsents || []);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementComponentService, deps: [{ token: i1.AnonymousConsentsConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementComponentService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementComponentService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.AnonymousConsentsConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsentManagementComponent {
    get allConsentsLoading$() {
        return this.allConsentsLoading.asObservable();
    }
    constructor(userConsentService, globalMessageService, anonymousConsentsConfig, anonymousConsentsService, authService, consentManagementComponentService) {
        this.userConsentService = userConsentService;
        this.globalMessageService = globalMessageService;
        this.anonymousConsentsConfig = anonymousConsentsConfig;
        this.anonymousConsentsService = anonymousConsentsService;
        this.authService = authService;
        this.consentManagementComponentService = consentManagementComponentService;
        this.subscriptions = new Subscription();
        this.allConsentsLoading = new BehaviorSubject(false);
        this.requiredConsents = [];
    }
    ngOnInit() {
        this.loading$ = combineLatest([
            this.userConsentService.getConsentsResultLoading(),
            this.userConsentService.getGiveConsentResultLoading(),
            this.userConsentService.getWithdrawConsentResultLoading(),
            this.authService.isUserLoggedIn(),
            this.allConsentsLoading,
        ]).pipe(map(([consentLoading, giveConsentLoading, withdrawConsentLoading, isUserLoggedIn, allConsentsLoading,]) => consentLoading ||
            giveConsentLoading ||
            withdrawConsentLoading ||
            !isUserLoggedIn ||
            allConsentsLoading));
        this.consentListInit();
        this.giveConsentInit();
        this.withdrawConsentInit();
    }
    consentListInit() {
        this.templateList$ = this.userConsentService.getConsents().pipe(withLatestFrom(this.anonymousConsentsService.getTemplates(), this.authService.isUserLoggedIn()), filter(([_templateList, _anonymousTemplates, isUserLoggedIn]) => isUserLoggedIn), tap(([templateList, _anonymousTemplates]) => {
            if (!this.consentsExists(templateList)) {
                this.userConsentService.loadConsents();
            }
        }), map(([templateList, anonymousTemplates]) => {
            this.requiredConsents = this.consentManagementComponentService
                ? this.consentManagementComponentService.getRequiredConsents(templateList)
                : [];
            if (this.anonymousConsentsConfig.anonymousConsents) {
                if (this.anonymousConsentsConfig.anonymousConsents.consentManagementPage) {
                    return this.hideAnonymousConsents(templateList, anonymousTemplates);
                }
            }
            return templateList;
        }));
    }
    hideAnonymousConsents(templateList, anonymousTemplates = []) {
        let hideTemplateIds = [];
        if (!this.anonymousConsentsConfig.anonymousConsents?.consentManagementPage
            ?.showAnonymousConsents) {
            hideTemplateIds = anonymousTemplates.map((template) => template.id ?? '');
            return this.userConsentService.filterConsentTemplates(templateList, hideTemplateIds);
        }
        if (this.anonymousConsentsConfig.anonymousConsents.consentManagementPage
            .hideConsents &&
            this.anonymousConsentsConfig.anonymousConsents.consentManagementPage
                .hideConsents.length > 0) {
            hideTemplateIds =
                this.anonymousConsentsConfig.anonymousConsents.consentManagementPage
                    .hideConsents;
        }
        return this.userConsentService.filterConsentTemplates(templateList, hideTemplateIds);
    }
    giveConsentInit() {
        this.userConsentService.resetGiveConsentProcessState();
        this.subscriptions.add(this.userConsentService
            .getGiveConsentResultSuccess()
            .subscribe((success) => this.onConsentGivenSuccess(success)));
    }
    withdrawConsentInit() {
        this.userConsentService.resetWithdrawConsentProcessState();
        this.subscriptions.add(this.userConsentService
            .getWithdrawConsentResultLoading()
            .pipe(skipWhile$1(Boolean), withLatestFrom(this.userConsentService.getWithdrawConsentResultSuccess()), map(([, withdrawalSuccess]) => withdrawalSuccess), tap((withdrawalSuccess) => {
            if (withdrawalSuccess) {
                this.userConsentService.loadConsents();
            }
        }))
            .subscribe((withdrawalSuccess) => this.onConsentWithdrawnSuccess(withdrawalSuccess)));
    }
    consentsExists(templateList) {
        return Boolean(templateList) && templateList.length > 0;
    }
    onConsentChange({ given, template, }) {
        if (given && template.id && template.version !== undefined) {
            this.userConsentService.giveConsent(template.id, template.version);
        }
        else if (template.currentConsent?.code) {
            this.userConsentService.withdrawConsent(template.currentConsent.code, template?.id);
        }
    }
    onConsentGivenSuccess(success) {
        if (success) {
            this.userConsentService.resetGiveConsentProcessState();
            this.globalMessageService.add({ key: 'consentManagementForm.message.success.given' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
        }
    }
    onConsentWithdrawnSuccess(success) {
        if (success) {
            this.userConsentService.resetWithdrawConsentProcessState();
            this.globalMessageService.add({ key: 'consentManagementForm.message.success.withdrawn' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
        }
    }
    rejectAll(templates = []) {
        const consentsToWithdraw = [];
        templates.forEach((template) => {
            if (template.currentConsent &&
                this.userConsentService.isConsentGiven(template.currentConsent)) {
                if (this.isRequiredConsent(template)) {
                    return;
                }
                consentsToWithdraw.push(template);
            }
        });
        this.allConsentsLoading.next(true);
        this.subscriptions.add(this.setupWithdrawalStream(consentsToWithdraw)
            .pipe(tap((_timesLoaded) => this.allConsentsLoading.next(false)))
            .subscribe());
    }
    setupWithdrawalStream(consentsToWithdraw = []) {
        const loading$ = concat(this.userConsentService.getWithdrawConsentResultLoading()).pipe(distinctUntilChanged(), filter((loading) => !loading));
        const count$ = loading$.pipe(scan((acc, _value) => acc + 1, -1));
        const withdraw$ = count$.pipe(tap((i) => {
            if (i < consentsToWithdraw.length) {
                const code = consentsToWithdraw[i].currentConsent?.code;
                const id = consentsToWithdraw[i]?.id;
                if (code) {
                    this.userConsentService.withdrawConsent(code, id);
                }
            }
        }));
        const checkTimesLoaded$ = withdraw$.pipe(filter((timesLoaded) => timesLoaded === consentsToWithdraw.length));
        return checkTimesLoaded$;
    }
    allowAll(templates = []) {
        const consentsToGive = [];
        templates.forEach((template) => {
            const givenDate = template.currentConsent?.consentGivenDate;
            const withdrawnDate = template.currentConsent?.consentWithdrawnDate;
            const isConsentGiven = (givenDate && !withdrawnDate) ||
                (givenDate && withdrawnDate && givenDate > withdrawnDate);
            if (isConsentGiven) {
                return;
            }
            if (template.currentConsent &&
                this.userConsentService.isConsentWithdrawn(template.currentConsent)) {
                if (this.isRequiredConsent(template)) {
                    return;
                }
            }
            consentsToGive.push(template);
        });
        this.allConsentsLoading.next(true);
        this.subscriptions.add(this.setupGiveStream(consentsToGive)
            .pipe(tap((_timesLoaded) => this.allConsentsLoading.next(false)))
            .subscribe());
    }
    setupGiveStream(consentsToGive = []) {
        const loading$ = concat(this.userConsentService.getGiveConsentResultLoading()).pipe(distinctUntilChanged(), filter((loading) => !loading));
        const count$ = loading$.pipe(scan((acc, _value) => acc + 1, -1));
        const giveConsent$ = count$.pipe(tap((i) => {
            if (i < consentsToGive.length) {
                const consent = consentsToGive[i];
                if (consent.id && consent.version !== undefined) {
                    this.userConsentService.giveConsent(consent.id, consent.version);
                }
            }
        }));
        const checkTimesLoaded$ = giveConsent$.pipe(filter((timesLoaded) => timesLoaded === consentsToGive.length));
        return checkTimesLoaded$;
    }
    isRequiredConsent(template) {
        return Boolean(template.id &&
            this.anonymousConsentsConfig.anonymousConsents &&
            this.anonymousConsentsConfig.anonymousConsents?.requiredConsents &&
            this.anonymousConsentsConfig.anonymousConsents.requiredConsents.includes(template.id));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.allConsentsLoading.unsubscribe();
        this.userConsentService.resetGiveConsentProcessState();
        this.userConsentService.resetWithdrawConsentProcessState();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementComponent, deps: [{ token: i1.UserConsentService }, { token: i1.GlobalMessageService }, { token: i1.AnonymousConsentsConfig }, { token: i1.AnonymousConsentsService }, { token: i1.AuthService }, { token: ConsentManagementComponentService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ConsentManagementComponent, isStandalone: false, selector: "cx-consent-management", ngImport: i0, template: "<ng-container\n  *ngIf=\"{\n    loading: loading$ | async,\n    templateList: templateList$ | async,\n    allConsentsLoading: allConsentsLoading$ | async,\n  } as data\"\n>\n  <ng-container *ngIf=\"data.templateList as templateList\">\n    <div class=\"cx-consent-action-links\">\n      <div class=\"col-sm-12 col-md-8 col-lg-6\">\n        <button\n          class=\"btn btn-link cx-action-link\"\n          [disabled]=\"data.loading\"\n          (click)=\"rejectAll(templateList)\"\n        >\n          {{ 'consentManagementForm.clearAll' | cxTranslate }}\n        </button>\n        <button\n          class=\"btn btn-link cx-action-link\"\n          [disabled]=\"data.loading\"\n          (click)=\"allowAll(templateList)\"\n        >\n          {{ 'consentManagementForm.selectAll' | cxTranslate }}\n        </button>\n      </div>\n    </div>\n    <div\n      class=\"cx-spinner\"\n      *ngIf=\"data.allConsentsLoading || (data.loading && !templateList?.length)\"\n    >\n      <cx-spinner></cx-spinner>\n    </div>\n\n    <ng-container *ngIf=\"!data.allConsentsLoading\">\n      <div class=\"cx-consent-toggles\">\n        <div class=\"col-sm-12 col-md-8 col-lg-6\">\n          <cx-consent-management-form\n            *ngFor=\"let consentTemplate of templateList\"\n            [consentTemplate]=\"consentTemplate\"\n            [requiredConsents]=\"requiredConsents\"\n            [disabled]=\"!!data.loading\"\n            (consentChanged)=\"onConsentChange($event)\"\n          ></cx-consent-management-form>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "component", type: ConsentManagementFormComponent, selector: "cx-consent-management-form", inputs: ["consentTemplate", "requiredConsents", "consent", "disabled", "showMandatory"], outputs: ["consentChanged"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-consent-management', standalone: false, template: "<ng-container\n  *ngIf=\"{\n    loading: loading$ | async,\n    templateList: templateList$ | async,\n    allConsentsLoading: allConsentsLoading$ | async,\n  } as data\"\n>\n  <ng-container *ngIf=\"data.templateList as templateList\">\n    <div class=\"cx-consent-action-links\">\n      <div class=\"col-sm-12 col-md-8 col-lg-6\">\n        <button\n          class=\"btn btn-link cx-action-link\"\n          [disabled]=\"data.loading\"\n          (click)=\"rejectAll(templateList)\"\n        >\n          {{ 'consentManagementForm.clearAll' | cxTranslate }}\n        </button>\n        <button\n          class=\"btn btn-link cx-action-link\"\n          [disabled]=\"data.loading\"\n          (click)=\"allowAll(templateList)\"\n        >\n          {{ 'consentManagementForm.selectAll' | cxTranslate }}\n        </button>\n      </div>\n    </div>\n    <div\n      class=\"cx-spinner\"\n      *ngIf=\"data.allConsentsLoading || (data.loading && !templateList?.length)\"\n    >\n      <cx-spinner></cx-spinner>\n    </div>\n\n    <ng-container *ngIf=\"!data.allConsentsLoading\">\n      <div class=\"cx-consent-toggles\">\n        <div class=\"col-sm-12 col-md-8 col-lg-6\">\n          <cx-consent-management-form\n            *ngFor=\"let consentTemplate of templateList\"\n            [consentTemplate]=\"consentTemplate\"\n            [requiredConsents]=\"requiredConsents\"\n            [disabled]=\"!!data.loading\"\n            (consentChanged)=\"onConsentChange($event)\"\n          ></cx-consent-management-form>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i1.UserConsentService }, { type: i1.GlobalMessageService }, { type: i1.AnonymousConsentsConfig }, { type: i1.AnonymousConsentsService }, { type: i1.AuthService }, { type: ConsentManagementComponentService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USE_MY_ACCOUNT_V2_NOTIFICATION_PREFERENCE = new InjectionToken('feature flag to enable enhanced UI for notification preference pages under My-Account', { providedIn: 'root', factory: () => false });
const USE_MY_ACCOUNT_V2_CONSENT = new InjectionToken('feature flag to enable enhanced UI for Consent Management pages under My-Account', { providedIn: 'root', factory: () => false });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ConsentManagementFormComponent extends ConsentManagementFormComponent {
    ngOnInit() {
        if (this.consent) {
            this.consentGiven = Boolean(this.consent.consentState === ANONYMOUS_CONSENT_STATUS.GIVEN);
        }
        else {
            if (this.consentTemplate && this.consentTemplate.currentConsent) {
                if (this.consentTemplate.currentConsent.consentWithdrawnDate) {
                    this.consentGiven = false;
                }
                else if (this.consentTemplate.currentConsent.consentGivenDate) {
                    this.consentGiven = true;
                    const date = new Date(this.consentTemplate.currentConsent.consentGivenDate);
                    this.consentApprovedTime = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2ConsentManagementFormComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MyAccountV2ConsentManagementFormComponent, isStandalone: false, selector: "cx-my-account-v2-consent-management-form", usesInheritance: true, ngImport: i0, template: "<div class=\"form-check consent-container\">\n  <div class=\"\">\n    <label>\n      <input\n        type=\"checkbox\"\n        class=\"checkbox-input\"\n        [id]=\"consentTemplate.id\"\n        [name]=\"consentTemplate.id\"\n        [checked]=\"consentGiven\"\n        (change)=\"onConsentChange()\"\n        [disabled]=\"isRequired(consentTemplate?.id)\"\n      />\n      <label [for]=\"consentTemplate.id\"></label>\n      <span class=\"name\">\n        <ng-container *ngIf=\"consentTemplate?.name\">\n          {{ consentTemplate?.name }}\n        </ng-container>\n      </span>\n      <span class=\"description\">\n        {{ consentTemplate?.description }}\n      </span>\n      <span class=\"description\" *ngIf=\"consentGiven\">\n        {{ 'myAccountV2Consent.dateDescription' | cxTranslate\n        }}{{ consentApprovedTime }}\n      </span>\n    </label>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2ConsentManagementFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-my-account-v2-consent-management-form', standalone: false, template: "<div class=\"form-check consent-container\">\n  <div class=\"\">\n    <label>\n      <input\n        type=\"checkbox\"\n        class=\"checkbox-input\"\n        [id]=\"consentTemplate.id\"\n        [name]=\"consentTemplate.id\"\n        [checked]=\"consentGiven\"\n        (change)=\"onConsentChange()\"\n        [disabled]=\"isRequired(consentTemplate?.id)\"\n      />\n      <label [for]=\"consentTemplate.id\"></label>\n      <span class=\"name\">\n        <ng-container *ngIf=\"consentTemplate?.name\">\n          {{ consentTemplate?.name }}\n        </ng-container>\n      </span>\n      <span class=\"description\">\n        {{ consentTemplate?.description }}\n      </span>\n      <span class=\"description\" *ngIf=\"consentGiven\">\n        {{ 'myAccountV2Consent.dateDescription' | cxTranslate\n        }}{{ consentApprovedTime }}\n      </span>\n    </label>\n  </div>\n</div>\n" }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ConsentManagementComponent extends ConsentManagementComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2ConsentManagementComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MyAccountV2ConsentManagementComponent, isStandalone: false, selector: "cx-my-account-v2-consent-management", usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"loading$ | async; else consentManagementForm\">\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</div>\n<ng-template #consentManagementForm>\n  <ng-container *ngIf=\"templateList$ | async as templateList\">\n    <div class=\"cx-consent-toggles\">\n      <div class=\"consent-form-container\">\n        <div class=\"header\">\n          {{ 'myAccountV2Consent.header' | cxTranslate }}\n        </div>\n        <div class=\"cx-consent-action-links\">\n          <button\n            tabindex=\"0\"\n            class=\"btn btn-link cx-action-link\"\n            (click)=\"rejectAll(templateList)\"\n          >\n            {{ 'myAccountV2Consent.clearAll' | cxTranslate }}\n          </button>\n          <button\n            tabindex=\"0\"\n            class=\"btn btn-link cx-action-link\"\n            (click)=\"allowAll(templateList)\"\n          >\n            {{ 'myAccountV2Consent.selectAll' | cxTranslate }}\n          </button>\n        </div>\n        <cx-my-account-v2-consent-management-form\n          *ngFor=\"let consentTemplate of templateList\"\n          [consentTemplate]=\"consentTemplate\"\n          [requiredConsents]=\"requiredConsents\"\n          (consentChanged)=\"onConsentChange($event)\"\n        ></cx-my-account-v2-consent-management-form>\n      </div>\n    </div>\n  </ng-container>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "component", type: MyAccountV2ConsentManagementFormComponent, selector: "cx-my-account-v2-consent-management-form" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2ConsentManagementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-my-account-v2-consent-management', standalone: false, template: "<div *ngIf=\"loading$ | async; else consentManagementForm\">\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</div>\n<ng-template #consentManagementForm>\n  <ng-container *ngIf=\"templateList$ | async as templateList\">\n    <div class=\"cx-consent-toggles\">\n      <div class=\"consent-form-container\">\n        <div class=\"header\">\n          {{ 'myAccountV2Consent.header' | cxTranslate }}\n        </div>\n        <div class=\"cx-consent-action-links\">\n          <button\n            tabindex=\"0\"\n            class=\"btn btn-link cx-action-link\"\n            (click)=\"rejectAll(templateList)\"\n          >\n            {{ 'myAccountV2Consent.clearAll' | cxTranslate }}\n          </button>\n          <button\n            tabindex=\"0\"\n            class=\"btn btn-link cx-action-link\"\n            (click)=\"allowAll(templateList)\"\n          >\n            {{ 'myAccountV2Consent.selectAll' | cxTranslate }}\n          </button>\n        </div>\n        <cx-my-account-v2-consent-management-form\n          *ngFor=\"let consentTemplate of templateList\"\n          [consentTemplate]=\"consentTemplate\"\n          [requiredConsents]=\"requiredConsents\"\n          (consentChanged)=\"onConsentChange($event)\"\n        ></cx-my-account-v2-consent-management-form>\n      </div>\n    </div>\n  </ng-container>\n</ng-template>\n" }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ConsentManagementModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2ConsentManagementModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2ConsentManagementModule, declarations: [MyAccountV2ConsentManagementComponent,
            MyAccountV2ConsentManagementFormComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            SpinnerModule,
            I18nModule,
            IconModule,
            FeaturesConfigModule], exports: [MyAccountV2ConsentManagementComponent,
            MyAccountV2ConsentManagementFormComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2ConsentManagementModule, providers: [ConsentManagementComponentService], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            SpinnerModule,
            I18nModule,
            IconModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2ConsentManagementModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        SpinnerModule,
                        I18nModule,
                        IconModule,
                        FeaturesConfigModule,
                    ],
                    providers: [ConsentManagementComponentService],
                    declarations: [
                        MyAccountV2ConsentManagementComponent,
                        MyAccountV2ConsentManagementFormComponent,
                    ],
                    exports: [
                        MyAccountV2ConsentManagementComponent,
                        MyAccountV2ConsentManagementFormComponent,
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2CmsMapping$1 = {
    cmsComponents: {
        ConsentManagementComponent: {
            component: MyAccountV2ConsentManagementComponent,
            //guards: inherited from standard config,
        },
    },
};
class ConsentManagementModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementModule, declarations: [ConsentManagementComponent, ConsentManagementFormComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            SpinnerModule,
            I18nModule,
            IconModule,
            FeaturesConfigModule], exports: [ConsentManagementComponent, ConsentManagementFormComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementModule, providers: [
            ConsentManagementComponentService,
            provideDefaultConfig({
                cmsComponents: {
                    ConsentManagementComponent: {
                        component: ConsentManagementComponent,
                        guards: [AuthGuard],
                    },
                },
            }),
            provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_CONSENT) ? myAccountV2CmsMapping$1 : {}),
        ], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            SpinnerModule,
            I18nModule,
            IconModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ConsentManagementModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        SpinnerModule,
                        I18nModule,
                        IconModule,
                        FeaturesConfigModule,
                    ],
                    providers: [
                        ConsentManagementComponentService,
                        provideDefaultConfig({
                            cmsComponents: {
                                ConsentManagementComponent: {
                                    component: ConsentManagementComponent,
                                    guards: [AuthGuard],
                                },
                            },
                        }),
                        provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_CONSENT) ? myAccountV2CmsMapping$1 : {}),
                    ],
                    declarations: [ConsentManagementComponent, ConsentManagementFormComponent],
                    exports: [ConsentManagementComponent, ConsentManagementFormComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AtMessageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AtMessageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: AtMessageModule, declarations: [AtMessageDirective], exports: [AtMessageDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AtMessageModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AtMessageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AtMessageDirective],
                    exports: [AtMessageDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MessageComponentModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MessageComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MessageComponentModule, declarations: [MessageComponent], imports: [AtMessageModule,
            CommonModule,
            I18nModule,
            IconModule,
            FeaturesConfigModule], exports: [MessageComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MessageComponentModule, imports: [AtMessageModule,
            CommonModule,
            I18nModule,
            IconModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MessageComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        AtMessageModule,
                        CommonModule,
                        I18nModule,
                        IconModule,
                        FeaturesConfigModule,
                    ],
                    declarations: [MessageComponent],
                    exports: [MessageComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentsDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentsDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentsDialogModule, declarations: [AnonymousConsentDialogComponent], imports: [CommonModule,
            I18nModule,
            IconModule,
            SpinnerModule,
            ConsentManagementModule,
            KeyboardFocusModule,
            FeaturesConfigModule,
            MessageComponentModule], exports: [AnonymousConsentDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentsDialogModule, imports: [CommonModule,
            I18nModule,
            IconModule,
            SpinnerModule,
            ConsentManagementModule,
            KeyboardFocusModule,
            FeaturesConfigModule,
            MessageComponentModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AnonymousConsentsDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        I18nModule,
                        IconModule,
                        SpinnerModule,
                        ConsentManagementModule,
                        KeyboardFocusModule,
                        FeaturesConfigModule,
                        MessageComponentModule,
                    ],
                    declarations: [AnonymousConsentDialogComponent],
                    exports: [AnonymousConsentDialogComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var PopoverEvent;
(function (PopoverEvent) {
    PopoverEvent["INSIDE_CLICK"] = "insideClick";
    PopoverEvent["OUTSIDE_CLICK"] = "outsideClick";
    PopoverEvent["ESCAPE_KEYDOWN"] = "escapeKeydown";
    PopoverEvent["CLOSE_BUTTON_CLICK"] = "closeButtonClick";
    PopoverEvent["CLOSE_BUTTON_KEYDOWN"] = "closeButtonKeydown";
    PopoverEvent["ROUTE_CHANGE"] = "routeChange";
    PopoverEvent["OPEN"] = "open";
    PopoverEvent["OPEN_BY_KEYBOARD"] = "openByKeyboard";
})(PopoverEvent || (PopoverEvent = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PositioningService {
    constructor(winRef) {
        this.winRef = winRef;
    }
    get allowedPlacements() {
        return [
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
            'left-top',
            'left-bottom',
            'right-top',
            'right-bottom',
        ];
    }
    get placementSeparator() {
        return /\s+/;
    }
    get window() {
        return this.winRef.nativeWindow;
    }
    get document() {
        return this.winRef.document;
    }
    getAllStyles(element) {
        return this.window?.getComputedStyle(element);
    }
    getPositionStyleProperty(element) {
        const styles = this.getAllStyles(element);
        if (styles) {
            return styles['position'] || undefined;
        }
    }
    isStaticPositioned(element) {
        return (this.getPositionStyleProperty(element) || 'static') === 'static';
    }
    offsetParent(element) {
        let offsetParentEl = element.offsetParent || this.document.documentElement;
        while (offsetParentEl &&
            offsetParentEl !== this.document.documentElement &&
            this.isStaticPositioned(offsetParentEl)) {
            offsetParentEl = offsetParentEl.offsetParent;
        }
        return offsetParentEl || this.document.documentElement;
    }
    position(element, round = true) {
        let elPosition;
        let parentOffset = {
            width: 0,
            height: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        };
        if (this.getPositionStyleProperty(element) === 'fixed') {
            elPosition = element.getBoundingClientRect();
            elPosition = {
                top: elPosition.top,
                bottom: elPosition.bottom,
                left: elPosition.left,
                right: elPosition.right,
                height: elPosition.height,
                width: elPosition.width,
            };
        }
        else {
            const offsetParentEl = this.offsetParent(element);
            elPosition = this.offset(element, false);
            if (offsetParentEl !== this.document.documentElement) {
                parentOffset = this.offset(offsetParentEl, false);
            }
            parentOffset.top += offsetParentEl.clientTop;
            parentOffset.left += offsetParentEl.clientLeft;
        }
        elPosition.top -= parentOffset.top;
        elPosition.bottom -= parentOffset.top;
        elPosition.left -= parentOffset.left;
        elPosition.right -= parentOffset.left;
        if (round) {
            elPosition.top = Math.round(elPosition.top);
            elPosition.bottom = Math.round(elPosition.bottom);
            elPosition.left = Math.round(elPosition.left);
            elPosition.right = Math.round(elPosition.right);
        }
        return elPosition;
    }
    offset(element, round = true) {
        const elBcr = element.getBoundingClientRect();
        const viewportOffset = {
            top: (this.window &&
                this.window.pageYOffset - this.document.documentElement.clientTop) ||
                0,
            left: (this.window &&
                this.window.pageXOffset - this.document.documentElement.clientLeft) ||
                0,
        };
        const elOffset = {
            height: elBcr.height || element.offsetHeight,
            width: elBcr.width || element.offsetWidth,
            top: elBcr.top + viewportOffset.top,
            bottom: elBcr.bottom + viewportOffset.top,
            left: elBcr.left + viewportOffset.left,
            right: elBcr.right + viewportOffset.left,
        };
        if (round) {
            elOffset.height = Math.round(elOffset.height);
            elOffset.width = Math.round(elOffset.width);
            elOffset.top = Math.round(elOffset.top);
            elOffset.bottom = Math.round(elOffset.bottom);
            elOffset.left = Math.round(elOffset.left);
            elOffset.right = Math.round(elOffset.right);
        }
        return elOffset;
    }
    /*
      Return false if the element to position is outside the viewport.
    */
    _positionElements(hostElement, targetElement, placement, appendToBody) {
        const [placementPrimary = 'top', placementSecondary = 'center'] = placement.split('-');
        const hostElPosition = appendToBody
            ? this.offset(hostElement, false)
            : this.position(hostElement, false);
        const targetElStyles = this.getAllStyles(targetElement);
        if (targetElStyles) {
            const marginTop = parseFloat(targetElStyles.marginTop);
            const marginBottom = parseFloat(targetElStyles.marginBottom);
            const marginLeft = parseFloat(targetElStyles.marginLeft);
            const marginRight = parseFloat(targetElStyles.marginRight);
            let topPosition = 0;
            let leftPosition = 0;
            switch (placementPrimary) {
                case 'top':
                    topPosition =
                        hostElPosition.top -
                            (targetElement.offsetHeight + marginTop + marginBottom);
                    break;
                case 'bottom':
                    topPosition = hostElPosition.top + hostElPosition.height;
                    break;
                case 'left':
                    leftPosition =
                        hostElPosition.left -
                            (targetElement.offsetWidth + marginLeft + marginRight);
                    break;
                case 'right':
                    leftPosition = hostElPosition.left + hostElPosition.width;
                    break;
            }
            switch (placementSecondary) {
                case 'top':
                    topPosition = hostElPosition.top;
                    break;
                case 'bottom':
                    topPosition =
                        hostElPosition.top +
                            hostElPosition.height -
                            targetElement.offsetHeight;
                    break;
                case 'left':
                    leftPosition = hostElPosition.left;
                    break;
                case 'right':
                    leftPosition =
                        hostElPosition.left +
                            hostElPosition.width -
                            targetElement.offsetWidth;
                    break;
                case 'center':
                    if (placementPrimary === 'top' || placementPrimary === 'bottom') {
                        leftPosition =
                            hostElPosition.left +
                                hostElPosition.width / 2 -
                                targetElement.offsetWidth / 2;
                    }
                    else {
                        topPosition =
                            hostElPosition.top +
                                hostElPosition.height / 2 -
                                targetElement.offsetHeight / 2;
                    }
                    break;
            }
            targetElement.style.transform = `translate(${Math.round(leftPosition)}px, ${Math.round(topPosition)}px)`;
            // Check if the targetElement is inside the viewport
            const targetElBCR = targetElement.getBoundingClientRect();
            const html = this.document.documentElement;
            const windowHeight = this.window?.innerHeight || html.clientHeight;
            const windowWidth = this.window?.innerWidth || html.clientWidth;
            return (targetElBCR.left >= 0 &&
                targetElBCR.top >= 0 &&
                targetElBCR.right <= windowWidth &&
                targetElBCR.bottom <= windowHeight);
        }
        return false;
    }
    /*
     * Accept the placement array and applies the appropriate placement dependent on the viewport.
     * Returns the applied placement.
     * In case of auto placement, placements are selected in order
     *   'top', 'bottom', 'left', 'right',
     *   'top-left', 'top-right',
     *   'bottom-left', 'bottom-right',
     *   'left-top', 'left-bottom',
     *   'right-top', 'right-bottom'.
     * */
    positionElements(hostElement, targetElement, placement, appendToBody) {
        const placementVals = Array.isArray(placement)
            ? placement
            : placement.split(this.placementSeparator);
        let hasAuto = placementVals.findIndex((val) => val === 'auto');
        if (hasAuto >= 0) {
            this.allowedPlacements.forEach((obj) => {
                if (placementVals.find((val) => val.search('^' + obj) !== -1) == null) {
                    placementVals.splice(hasAuto++, 1, obj);
                }
            });
        }
        const style = targetElement.style;
        style.position = 'absolute';
        style.top = '0';
        style.left = '0';
        let testPlacement = 'auto';
        let isInViewport = false;
        for (testPlacement of placementVals) {
            if (this._positionElements(hostElement, targetElement, testPlacement, appendToBody)) {
                isInViewport = true;
                break;
            }
        }
        if (!isInViewport) {
            this._positionElements(hostElement, targetElement, testPlacement, appendToBody);
        }
        return testPlacement;
    }
    getPositioningClass(position, autoPositioning) {
        let positionClass = `${position || 'top'}`;
        if (autoPositioning && positionClass !== 'auto') {
            positionClass = `${positionClass} auto`;
        }
        return positionClass;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PositioningService, deps: [{ token: i1.WindowRef }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PositioningService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PositioningService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.WindowRef }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PopoverComponent {
    /**
     * Listens for click inside popover component wrapper.
     */
    insideClick() {
        this.eventSubject.next(PopoverEvent.INSIDE_CLICK);
    }
    /**
     * Listens for every document click and ignores clicks
     * inside component.
     */
    outsideClick(event) {
        if (!this.isClickedOnPopover(event) && !this.isClickedOnDirective(event)) {
            this.eventSubject.next(PopoverEvent.OUTSIDE_CLICK);
        }
    }
    /**
     * Listens for `escape` keydown event.
     */
    escapeKeydown() {
        this.eventSubject.next(PopoverEvent.ESCAPE_KEYDOWN);
    }
    isClickedOnPopover(event) {
        return this.popoverInstance.location.nativeElement.contains(event.target);
    }
    isClickedOnDirective(event) {
        return this.triggerElement.nativeElement.contains(event.target);
    }
    /**
     * Emits close event trigger.
     */
    close(event) {
        event.preventDefault();
        if (event instanceof MouseEvent) {
            this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_CLICK);
        }
        else {
            this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_KEYDOWN);
        }
    }
    /**
     * Method uses `Renderer2` service to listen window scroll event.
     *
     * Registered only if property `positionOnScroll` is set to `true`.
     */
    triggerScrollEvent() {
        this.scrollEventUnlistener = this.renderer.listen(this.winRef.nativeWindow, 'scroll', () => this.positionPopover());
    }
    /**
     * Method uses positioning service calculation and based on that
     * updates class name for popover component instance.
     */
    positionPopover() {
        this.popoverClass = this.positioningService.positionElements(this.triggerElement.nativeElement, this.popoverInstance.location.nativeElement, this.positioningService.getPositioningClass(this.position, this.autoPositioning), this.appendToBody);
        this.changeDetectionRef.markForCheck();
        this.baseClass = `${this.customClass} ${this.popoverClass} opened`;
    }
    ngOnInit() {
        if (!this.customClass) {
            this.customClass = 'cx-popover';
        }
        if (!this.position) {
            this.position = 'top';
        }
        if (this.autoPositioning === undefined) {
            this.autoPositioning = true;
        }
        this.baseClass = `${this.customClass}`;
        this.resizeSub = this.winRef.resize$.subscribe(() => {
            this.positionPopover();
        });
        this.routeChangeSub = this.router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe(() => {
            this.eventSubject.next(PopoverEvent.ROUTE_CHANGE);
        });
        if (this.positionOnScroll) {
            this.triggerScrollEvent();
        }
    }
    /**
     * indicates if passed content is a TemplateRef or string.
     */
    isTemplate(content) {
        return content instanceof TemplateRef;
    }
    isString(content) {
        return !(content instanceof TemplateRef);
    }
    ngAfterViewChecked() {
        this.positionPopover();
    }
    ngOnDestroy() {
        if (this.resizeSub) {
            this.resizeSub.unsubscribe();
        }
        if (this.routeChangeSub) {
            this.routeChangeSub.unsubscribe();
        }
        if (this.scrollEventUnlistener) {
            this.scrollEventUnlistener();
        }
    }
    constructor(positioningService, winRef, changeDetectionRef, renderer, router) {
        this.positioningService = positioningService;
        this.winRef = winRef;
        this.changeDetectionRef = changeDetectionRef;
        this.renderer = renderer;
        this.router = router;
        /**
         * Icon types for close button icon.
         */
        this.iconTypes = ICON_TYPE;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverComponent, deps: [{ token: PositioningService }, { token: i1.WindowRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PopoverComponent, isStandalone: false, selector: "cx-popover", host: { listeners: { "click": "insideClick()", "document:click": "outsideClick($event)", "keydown.escape": "escapeKeydown()" }, properties: { "className": "this.baseClass" } }, ngImport: i0, template: "<div class=\"arrow\"></div>\n<div class=\"popover-body\" [cxFocus]=\"focusConfig\">\n  <div class=\"cx-close-row\">\n    <button\n      *ngIf=\"displayCloseButton\"\n      type=\"button\"\n      class=\"close\"\n      attr.aria-label=\"{{ 'common.close' | cxTranslate }}\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (keydown.enter)=\"close($event)\"\n      (keydown.space)=\"close($event)\"\n      (click)=\"close($event)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <ng-container *ngIf=\"isTemplate(content)\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </ng-container>\n  <span *ngIf=\"isString(content)\">{{ content }}</span>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-popover', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div class=\"arrow\"></div>\n<div class=\"popover-body\" [cxFocus]=\"focusConfig\">\n  <div class=\"cx-close-row\">\n    <button\n      *ngIf=\"displayCloseButton\"\n      type=\"button\"\n      class=\"close\"\n      attr.aria-label=\"{{ 'common.close' | cxTranslate }}\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (keydown.enter)=\"close($event)\"\n      (keydown.space)=\"close($event)\"\n      (click)=\"close($event)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <ng-container *ngIf=\"isTemplate(content)\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </ng-container>\n  <span *ngIf=\"isString(content)\">{{ content }}</span>\n</div>\n" }]
        }], ctorParameters: () => [{ type: PositioningService }, { type: i1.WindowRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i1$2.Router }], propDecorators: { baseClass: [{
                type: HostBinding,
                args: ['className']
            }], insideClick: [{
                type: HostListener,
                args: ['click']
            }], outsideClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }], escapeKeydown: [{
                type: HostListener,
                args: ['keydown.escape']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PopoverService {
    /**
     * For a11y improvements method returns different `FocusConfig`
     * based on which event popover was triggered.
     */
    getFocusConfig(event, appendToBody) {
        let config = {};
        if (event === PopoverEvent.OPEN_BY_KEYBOARD && appendToBody) {
            config = {
                trap: true,
                block: true,
                focusOnEscape: false,
                autofocus: true,
            };
        }
        return config;
    }
    setFocusOnElement(element) {
        setTimeout(() => {
            element.nativeElement.focus();
        }, 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to bind popover with any DOM element.
 */
class PopoverDirective {
    /**
     * Listen events fired on element binded to popover directive.
     *
     * Based on event type some a11y improvements can be made.
     * For example if popover was opened by `space` or `enter` key
     * dedicated `FocusConfig` can be set to autofocus first
     * focusable element in popover container.
     */
    handlePress(event) {
        event?.preventDefault();
        if (event?.target === this.element.nativeElement && !this.isOpen) {
            this.eventSubject.next(PopoverEvent.OPEN_BY_KEYBOARD);
        }
        else if (this.isOpen) {
            this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_KEYDOWN);
        }
    }
    handleTab() {
        if (!this.focusConfig?.trap && this.isOpen) {
            this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_KEYDOWN);
        }
    }
    handleEscape() {
        this.eventSubject.next(PopoverEvent.ESCAPE_KEYDOWN);
    }
    handleClick(event) {
        event?.preventDefault();
        if (event?.target === this.element.nativeElement && !this.isOpen) {
            this.eventSubject.next(PopoverEvent.OPEN);
        }
        else if (this.isOpen) {
            this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_CLICK);
        }
    }
    /**
     * Method performs open action for popover component.
     */
    open(event) {
        if (!this.cxPopoverOptions?.disable) {
            this.isOpen = true;
            this.focusConfig = this.popoverService.getFocusConfig(event, this.cxPopoverOptions?.appendToBody || false);
            this.renderPopover();
            this.openPopover.emit();
        }
    }
    /**
     * Method performs close action for popover component.
     */
    close() {
        this.isOpen = false;
        this.viewContainer.clear();
        this.closePopover.emit();
    }
    /**
     * Method subscribes for events emitted by popover component
     * and based on event performs specific action.
     */
    handlePopoverEvents() {
        this.eventSubject.subscribe((event) => {
            if (this.openTriggerEvents.includes(event)) {
                this.open(event);
            }
            if (this.focusPopoverTriggerEvents.includes(event)) {
                this.popoverContainer.location.nativeElement.focus();
            }
            if (this.closeTriggerEvents.includes(event)) {
                this.close();
            }
            if (this.focusDirectiveTriggerEvents.includes(event)) {
                this.popoverService.setFocusOnElement(this.element);
            }
        });
    }
    /**
     * Method creates instance and pass parameters to popover component.
     */
    renderPopover() {
        const containerFactory = this.componentFactoryResolver.resolveComponentFactory(PopoverComponent);
        this.popoverContainer =
            this.viewContainer.createComponent(containerFactory);
        const componentInstance = this.popoverContainer.instance;
        if (componentInstance) {
            componentInstance.content = this.cxPopover;
            componentInstance.triggerElement = this.element;
            componentInstance.popoverInstance = this.popoverContainer;
            componentInstance.focusConfig = this.focusConfig;
            componentInstance.eventSubject = this.eventSubject;
            componentInstance.position = this.cxPopoverOptions?.placement;
            componentInstance.customClass = this.cxPopoverOptions?.class;
            componentInstance.appendToBody = this.cxPopoverOptions?.appendToBody;
            componentInstance.positionOnScroll =
                this.cxPopoverOptions?.positionOnScroll;
            componentInstance.displayCloseButton =
                this.cxPopoverOptions?.displayCloseButton;
            componentInstance.autoPositioning =
                this.cxPopoverOptions?.autoPositioning;
            if (this.cxPopoverOptions?.appendToBody) {
                const body = this.winRef.document.body;
                const element = this.featureConfigService?.isEnabled('a11yPopoverHighContrast')
                    ? // we need to select first child element if exists,
                        // otherwise HCT theming in popover will not be picked up.
                        (body.firstElementChild ?? body)
                    : body;
                this.renderer.appendChild(element, this.popoverContainer.location.nativeElement);
            }
            this.popoverContainer.changeDetectorRef.detectChanges();
        }
    }
    ngOnInit() {
        this.handlePopoverEvents();
    }
    constructor(element, viewContainer, componentFactoryResolver, renderer, changeDetectorRef, popoverService, winRef) {
        this.element = element;
        this.viewContainer = viewContainer;
        this.componentFactoryResolver = componentFactoryResolver;
        this.renderer = renderer;
        this.changeDetectorRef = changeDetectorRef;
        this.popoverService = popoverService;
        this.winRef = winRef;
        /**
         * An event emitted when the popover is opened.
         */
        this.openPopover = new EventEmitter();
        /**
         * An event emitted when the popover is closed.
         */
        this.closePopover = new EventEmitter();
        /**
         * Subject which emits specific type of `PopoverEvent`.
         */
        this.eventSubject = new Subject();
        this.featureConfigService = inject(FeatureConfigService, {
            optional: true,
        });
        this.openTriggerEvents = [
            PopoverEvent.OPEN,
            PopoverEvent.OPEN_BY_KEYBOARD,
        ];
        this.focusPopoverTriggerEvents = [
            PopoverEvent.OPEN_BY_KEYBOARD,
        ];
        this.closeTriggerEvents = [
            PopoverEvent.ROUTE_CHANGE,
            PopoverEvent.ESCAPE_KEYDOWN,
            PopoverEvent.OUTSIDE_CLICK,
            PopoverEvent.CLOSE_BUTTON_KEYDOWN,
            PopoverEvent.CLOSE_BUTTON_CLICK,
        ];
        this.focusDirectiveTriggerEvents = [
            PopoverEvent.ESCAPE_KEYDOWN,
            PopoverEvent.CLOSE_BUTTON_KEYDOWN,
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: PopoverService }, { token: i1.WindowRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: PopoverDirective, isStandalone: false, selector: "[cxPopover]", inputs: { cxPopover: "cxPopover", cxPopoverOptions: "cxPopoverOptions" }, outputs: { openPopover: "openPopover", closePopover: "closePopover" }, host: { listeners: { "keydown.enter": "handlePress($event)", "keydown.space": "handlePress($event)", "keydown.tab": "handleTab()", "keydown.shift.tab": "handleTab()", "keydown.escape": "handleEscape()", "click": "handleClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxPopover]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: PopoverService }, { type: i1.WindowRef }], propDecorators: { cxPopover: [{
                type: Input
            }], cxPopoverOptions: [{
                type: Input
            }], openPopover: [{
                type: Output
            }], closePopover: [{
                type: Output
            }], handlePress: [{
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.space', ['$event']]
            }], handleTab: [{
                type: HostListener,
                args: ['keydown.tab']
            }, {
                type: HostListener,
                args: ['keydown.shift.tab']
            }], handleEscape: [{
                type: HostListener,
                args: ['keydown.escape']
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], featureConfigService: [{
                type: Optional
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultLimit = 20;
class TruncatePipe {
    /**
     * example usage {{ exampleString | cxTruncate: [1, ''] }}
     */
    transform(value, args) {
        if (!args) {
            return value;
        }
        let trail = '...';
        const limit = args.length > 0 && args[0] && Number.isInteger(+args[0])
            ? args[0]
            : defaultLimit;
        if (args.length > 1 && args[1] !== undefined) {
            trail = args[1];
        }
        return value.length > limit ? value.substring(0, limit) + trail : value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TruncatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TruncatePipe, isStandalone: false, name: "cxTruncate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TruncatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cxTruncate',
                    standalone: false,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TruncateTextPopoverComponent {
    constructor() {
        /**
         * The maximum length of the characters after which the text will be truncated
         */
        this.charactersLimit = 100;
    }
    get isTruncated() {
        return this.content.length > +this.charactersLimit;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TruncateTextPopoverComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: TruncateTextPopoverComponent, isStandalone: false, selector: "cx-truncate-text-popover", inputs: { content: "content", charactersLimit: "charactersLimit", customClass: "customClass" }, ngImport: i0, template: "<ng-container>\n  <ng-container>\n    <span class=\"truncated-text\" [ngClass]=\"customClass\">\n      {{ content | cxTruncate: [charactersLimit] }}\n    </span>\n  </ng-container>\n\n  <ng-template #fullText>\n    {{ content }}\n  </ng-template>\n\n  <button\n    *ngIf=\"isTruncated\"\n    [cxPopover]=\"fullText\"\n    [cxPopoverOptions]=\"{\n      placement: 'auto',\n      appendToBody: true,\n      displayCloseButton: true,\n    }\"\n    class=\"ml-1 link cx-action-link\"\n  >\n    {{ 'common.more' | cxTranslate }}\n  </button>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: PopoverDirective, selector: "[cxPopover]", inputs: ["cxPopover", "cxPopoverOptions"], outputs: ["openPopover", "closePopover"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: TruncatePipe, name: "cxTruncate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TruncateTextPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-truncate-text-popover', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container>\n  <ng-container>\n    <span class=\"truncated-text\" [ngClass]=\"customClass\">\n      {{ content | cxTruncate: [charactersLimit] }}\n    </span>\n  </ng-container>\n\n  <ng-template #fullText>\n    {{ content }}\n  </ng-template>\n\n  <button\n    *ngIf=\"isTruncated\"\n    [cxPopover]=\"fullText\"\n    [cxPopoverOptions]=\"{\n      placement: 'auto',\n      appendToBody: true,\n      displayCloseButton: true,\n    }\"\n    class=\"ml-1 link cx-action-link\"\n  >\n    {{ 'common.more' | cxTranslate }}\n  </button>\n</ng-container>\n" }]
        }], propDecorators: { content: [{
                type: Input
            }], charactersLimit: [{
                type: Input
            }], customClass: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class GenericLinkComponentService {
    constructor() {
        /**
         * Pattern matching string starting with `http://` or `https://`.
         */
        this.HTTP_PROTOCOL_REGEX = /^https?:\/\//i;
        /**
         * Pattern matching string starting with `mailto:`.
         */
        this.MAILTO_PROTOCOL_REGEX = /^mailto:/i;
        /**
         * Pattern matching string starting with `tel:`.
         */
        this.TEL_PROTOCOL_REGEX = /^tel:/i;
    }
    /**
     * Returns true when the @Input `url` is a string starting with `http://`, `https://`, `mailto:`, `tel:`.
     */
    isExternalUrl(url) {
        return (typeof url === 'string' &&
            (this.HTTP_PROTOCOL_REGEX.test(url) ||
                this.MAILTO_PROTOCOL_REGEX.test(url) ||
                this.TEL_PROTOCOL_REGEX.test(url)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkComponentService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkComponentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkComponentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * This component navigates using [routerLink] attribute when input 'url' is a relative url. Otherwise (when it's absolute), [href] is used.
 */
class GenericLinkComponent {
    constructor(router, service) {
        this.router = router;
        this.service = service;
        /**
         * Used to split url into 2 parts:
         * 1. the path
         * 2. query params + hash fragment
         */
        this.URL_SPLIT = /(^[^#?]*)(.*)/;
        /**
         * Parsed parts of the @Input `url`, when it's a local URL.
         * It should not be used when the `url` is external.
         * @see `url`
         */
        this.routeParts = {};
        this.tabindex = 0;
    }
    isExternalUrl() {
        return this.service.isExternalUrl(this.url);
    }
    get rel() {
        return this.target === '_blank' ? 'noopener' : null;
    }
    ngOnChanges(changes) {
        if (changes['url']) {
            this.setUrlParts(changes['url'].currentValue);
        }
    }
    /**
     * The part with the path of the local url.
     */
    get routerUrl() {
        return this.routeParts.path;
    }
    /**
     * The part with the query params of the local url.
     */
    get queryParams() {
        return this.routeParts.queryParams;
    }
    /**
     * The part with the hash fragment of the local url.
     */
    get fragment() {
        return this.routeParts.fragment ?? undefined;
    }
    /**
     * Parses the given url and sets the property `urlParts` accordingly.
     */
    setUrlParts(url) {
        if (typeof url === 'string') {
            url = this.getAbsoluteUrl(url); // string links in CMS sometimes don't have the leading slash, so fix it here
            this.routeParts = this.splitUrl(url);
        }
        else {
            this.routeParts = { path: url };
        }
    }
    /**
     * Parses the given string into 3 parts:
     * - string path (wrapped in an array to be compatible with Angular syntax for the `routerLink`)
     * - query params (as an object)
     * - hash fragment (string)
     */
    splitUrl(url = '') {
        const { queryParams, fragment } = this.router.parseUrl(url);
        const [, path] = url.match(this.URL_SPLIT) ?? [, ''];
        // wrap path in an array, to have the Angular-like path format
        return { path: [path ?? ''], queryParams, fragment };
    }
    /**
     * Prepends a leading slash to the given URL string, in case it doesn't have it.
     */
    getAbsoluteUrl(url) {
        return url.startsWith('/') ? url : '/' + url;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkComponent, deps: [{ token: i1$2.Router }, { token: GenericLinkComponentService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: GenericLinkComponent, isStandalone: false, selector: "cx-generic-link", inputs: { url: "url", target: "target", id: "id", class: "class", style: "style", title: "title", ariaLabel: "ariaLabel", tabindex: "tabindex" }, usesOnChanges: true, ngImport: i0, template: "<!-- https://github.com/angular/angular/issues/24567 -->\n\n<ng-container *ngIf=\"isExternalUrl(); else isLocalUrl\">\n  <a\n    [href]=\"url\"\n    [attr.target]=\"target\"\n    [attr.rel]=\"rel\"\n    [attr.id]=\"id\"\n    [attr.class]=\"class\"\n    [attr.style]=\"style\"\n    [attr.title]=\"title\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [tabindex]=\"tabindex\"\n  >\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </a>\n</ng-container>\n\n<ng-template #isLocalUrl>\n  <a\n    [routerLink]=\"routerUrl\"\n    [queryParams]=\"queryParams\"\n    [fragment]=\"fragment\"\n    [target]=\"target || undefined\"\n    [attr.id]=\"id\"\n    [attr.class]=\"class\"\n    [attr.style]=\"style\"\n    [attr.title]=\"title\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [tabindex]=\"tabindex\"\n  >\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </a>\n</ng-template>\n\n<ng-template #content>\n  <ng-content></ng-content>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-generic-link', standalone: false, template: "<!-- https://github.com/angular/angular/issues/24567 -->\n\n<ng-container *ngIf=\"isExternalUrl(); else isLocalUrl\">\n  <a\n    [href]=\"url\"\n    [attr.target]=\"target\"\n    [attr.rel]=\"rel\"\n    [attr.id]=\"id\"\n    [attr.class]=\"class\"\n    [attr.style]=\"style\"\n    [attr.title]=\"title\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [tabindex]=\"tabindex\"\n  >\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </a>\n</ng-container>\n\n<ng-template #isLocalUrl>\n  <a\n    [routerLink]=\"routerUrl\"\n    [queryParams]=\"queryParams\"\n    [fragment]=\"fragment\"\n    [target]=\"target || undefined\"\n    [attr.id]=\"id\"\n    [attr.class]=\"class\"\n    [attr.style]=\"style\"\n    [attr.title]=\"title\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [tabindex]=\"tabindex\"\n  >\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </a>\n</ng-template>\n\n<ng-template #content>\n  <ng-content></ng-content>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: GenericLinkComponentService }], propDecorators: { url: [{
                type: Input
            }], target: [{
                type: Input
            }], id: [{
                type: Input
            }], class: [{
                type: Input
            }], style: [{
                type: Input
            }], title: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], tabindex: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CardComponent {
    // ACTIONS
    setEditMode() {
        this.editMode = true;
    }
    cancelEdit() {
        this.editMode = false;
        this.cancelCard.emit(5);
    }
    delete() {
        this.deleteCard.emit(1);
    }
    setDefault() {
        this.isDefault = true;
        this.setDefaultCard.emit(2);
    }
    send() {
        this.sendCard.emit(3);
    }
    edit() {
        this.editCard.emit(4);
    }
    isCardAction(action) {
        return action.event !== undefined;
    }
    isCardLinkAction(action) {
        return action.link !== undefined;
    }
    trackByIndex(index) {
        return index;
    }
    constructor() {
        this.iconTypes = ICON_TYPE;
        this.deleteCard = new EventEmitter();
        this.setDefaultCard = new EventEmitter();
        this.sendCard = new EventEmitter();
        this.editCard = new EventEmitter();
        this.cancelCard = new EventEmitter();
        this.border = false;
        this.editMode = false;
        this.isDefault = false;
        this.fitToContainer = false;
        this.truncateText = false;
        this.truncateParagraphText = false;
        this.charactersLimit = 100;
        // Intentional empty constructor
    }
    /* eslint @angular-eslint/no-empty-lifecycle-method: 1 */
    ngOnInit() {
        // Intentional empty method
    }
    get isHeaderVisible() {
        return !!this.content?.header && !this.editMode;
    }
    /**
     * ariaDescribedBy: Computes the value for the 'aria-describedby' attribute.
     * If `content` has a `title`, it returns a string including the title and container IDs, with index if available.
     * If no title, it returns only the container ID with the index if available.
     *
     * @returns {string} The 'aria-describedby' value.
     */
    get ariaDescribedBy() {
        if (this.content && this.content.title) {
            return `${this.getLabel('content-title')} ${this.getLabel('cx-card-container')}`;
        }
        return `${this.getLabel('cx-card-container')}`;
    }
    /**
     * getLabel: Computes a label string by concatenating the provided prefix with the index.
     * If the index is greater than or equal to 0, it appends the index to the prefix; otherwise, it just returns the prefix.
     *
     * @param {string} prefix - The string to prefix to the label.
     * @returns {string} The computed label, including the index if it's available.
     */
    getLabel(prefix) {
        return prefix + (this.index >= 0 ? '-' + this.index : '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: CardComponent, isStandalone: false, selector: "cx-card", inputs: { border: "border", editMode: "editMode", isDefault: "isDefault", content: "content", fitToContainer: "fitToContainer", truncateText: "truncateText", truncateParagraphText: "truncateParagraphText", charactersLimit: "charactersLimit", index: "index", role: "role" }, outputs: { deleteCard: "deleteCard", setDefaultCard: "setDefaultCard", sendCard: "sendCard", editCard: "editCard", cancelCard: "cancelCard" }, ngImport: i0, template: "<div\n  *ngIf=\"content\"\n  class=\"cx-card\"\n  [tabindex]=\"border ? 0 : -1\"\n  [attr.role]=\"role\"\n  [attr.aria-labelledby]=\"isHeaderVisible ? getLabel('content-header') : null\"\n  [attr.aria-describedby]=\"ariaDescribedBy\"\n  [class.cx-card-border]=\"border\"\n  [class.cx-card-fit-to-container]=\"fitToContainer\"\n>\n  <!-- Card Header -->\n  <div\n    *ngIf=\"isHeaderVisible\"\n    class=\"card-header\"\n    [id]=\"getLabel('content-header')\"\n  >\n    {{ content.header }}\n  </div>\n  <!-- Card Body -->\n  <div class=\"card-body cx-card-body\" [class.cx-card-delete]=\"editMode\">\n    <!-- Edit message -->\n    <div *ngIf=\"editMode\" role=\"alert\" class=\"cx-card-delete-msg\">\n      {{ content.deleteMsg }}\n    </div>\n    <!-- Card title -->\n    <span\n      *ngIf=\"content.title\"\n      class=\"cx-card-title\"\n      [id]=\"getLabel('content-title')\"\n    >\n      {{ content.title }}\n    </span>\n    <!-- Card Content -->\n    <div class=\"cx-card-container\" [id]=\"getLabel('cx-card-container')\">\n      <!-- Card Label -->\n      <div class=\"cx-card-label-container\">\n        <div *ngIf=\"content.textBold\" class=\"cx-card-label-bold\">\n          {{ content.textBold }}\n        </div>\n        <div *ngFor=\"let line of content.text\">\n          <ng-container\n            *ngTemplateOutlet=\"\n              showText;\n              context: {\n                content: content,\n                truncateText: truncateText,\n                charactersLimit: charactersLimit,\n                class: 'cx-card-label',\n                text: line,\n              }\n            \"\n          >\n          </ng-container>\n        </div>\n        <div\n          class=\"cx-card-paragraph\"\n          *ngFor=\"let item of content.paragraphs; trackBy: trackByIndex\"\n        >\n          <div class=\"cx-card-paragraph-title\">{{ item.title }}</div>\n          <div *ngFor=\"let text of item.text\">\n            <ng-container\n              *ngTemplateOutlet=\"\n                showText;\n                context: {\n                  content: content,\n                  truncateText: truncateParagraphText,\n                  charactersLimit: charactersLimit,\n                  class: 'cx-card-paragraph-text',\n                  text: text,\n                }\n              \"\n            >\n            </ng-container>\n          </div>\n        </div>\n        <ng-content select=\"[label_container_bottom]\"></ng-content>\n      </div>\n      <!-- Image -->\n      <div\n        *ngIf=\"content.img\"\n        class=\"cx-card-img-container\"\n        [attr.aria-label]=\"\n          content.imgLabel ?? 'paymentCard.credit' | cxTranslate\n        \"\n        role=\"img\"\n        [attr.title]=\"content.imgLabel ?? 'paymentCard.credit' | cxTranslate\"\n      >\n        <cx-icon [type]=\"content.img\"></cx-icon>\n      </div>\n    </div>\n    <!-- Edit Mode Actions -->\n    <div *ngIf=\"editMode\" class=\"row cx-card-body-delete\">\n      <div class=\"row col-md-12\" *cxFeature=\"'a11yDeleteButton2First'\">\n        <div class=\"col-md-6\" [cxFocus]=\"{ autofocus: true }\">\n          <button class=\"btn btn-block btn-primary\" (click)=\"delete()\">\n            {{ 'common.delete' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-md-6\">\n          <button\n            [cxAtMessage]=\"'assistiveMessage.actionCancelled' | cxTranslate\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelEdit()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row col-md-12\" *cxFeature=\"'!a11yDeleteButton2First'\">\n        <div class=\"col-md-6\">\n          <button\n            [cxAtMessage]=\"'assistiveMessage.actionCancelled' | cxTranslate\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelEdit()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-md-6\" [cxFocus]=\"{ autofocus: true }\">\n          <button class=\"btn btn-block btn-primary\" (click)=\"delete()\">\n            {{ 'common.delete' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n    <!-- Actions -->\n    <div *ngIf=\"content.actions && !editMode\" class=\"cx-card-actions\">\n      <ng-container *cxFeature=\"'!a11yImproveButtonsInCardComponent'\">\n        <div *ngFor=\"let action of content.actions\">\n          <div>\n            <ng-container\n              *ngIf=\"isCardAction(action)\"\n              [ngSwitch]=\"action.event\"\n            >\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'delete'\"\n                class=\"link cx-action-link\"\n                (click)=\"delete()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'default'\"\n                class=\"link cx-action-link\"\n                (click)=\"setDefault()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'send'\"\n                class=\"link cx-action-link\"\n                (click)=\"send()\"\n                [attr.aria-describedby]=\"\n                  index >= 0 && content.header && !editMode\n                    ? 'content-header-' + index\n                    : null\n                \"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'edit'\"\n                class=\"link cx-action-link\"\n                (click)=\"edit()\"\n              >\n                {{ action.name }}\n              </button>\n            </ng-container>\n            <a\n              *ngIf=\"isCardLinkAction(action)\"\n              href=\"{{ action.link }}\"\n              class=\"link cx-action-link\"\n            >\n              {{ action.name }}\n            </a>\n          </div>\n        </div>\n      </ng-container>\n      <ng-container *cxFeature=\"'a11yImproveButtonsInCardComponent'\">\n        <div *ngFor=\"let action of content.actions\" class=\"cx-card-action-item\">\n          <div>\n            <ng-container\n              *ngIf=\"isCardAction(action)\"\n              [ngSwitch]=\"action.event\"\n            >\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'delete'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"delete()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'default'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"setDefault()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'send'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"send()\"\n                [attr.aria-describedby]=\"\n                  index >= 0 && content.header && !editMode\n                    ? 'content-header-' + index\n                    : null\n                \"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'edit'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"edit()\"\n              >\n                {{ action.name }}\n              </button>\n            </ng-container>\n            <cx-generic-link\n              *ngIf=\"isCardLinkAction(action)\"\n              [url]=\"action.link\"\n              [ariaLabel]=\"\n                action.ariaLabel ? (action.ariaLabel | cxTranslate) : undefined\n              \"\n              [target]=\"action.target ?? null\"\n              >{{ action.name }}</cx-generic-link\n            >\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n\n<ng-template\n  #showText\n  let-content=\"content\"\n  let-truncateText=\"truncateText\"\n  let-charactersLimit=\"charactersLimit\"\n  let-class=\"class\"\n  let-text=\"text\"\n>\n  <div *ngIf=\"!truncateText\" [class]=\"class\" [ngClass]=\"content.customClass\">\n    {{ text }}\n  </div>\n\n  <cx-truncate-text-popover\n    *ngIf=\"truncateText\"\n    [charactersLimit]=\"charactersLimit\"\n    [content]=\"text\"\n    [customClass]=\"content.customClass || class\"\n  ></cx-truncate-text-popover>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i3.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i3.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: AtMessageDirective, selector: "[cxAtMessage]", inputs: ["cxAtMessage"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "component", type: TruncateTextPopoverComponent, selector: "cx-truncate-text-popover", inputs: ["content", "charactersLimit", "customClass"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "component", type: GenericLinkComponent, selector: "cx-generic-link", inputs: ["url", "target", "id", "class", "style", "title", "ariaLabel", "tabindex"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-card', standalone: false, template: "<div\n  *ngIf=\"content\"\n  class=\"cx-card\"\n  [tabindex]=\"border ? 0 : -1\"\n  [attr.role]=\"role\"\n  [attr.aria-labelledby]=\"isHeaderVisible ? getLabel('content-header') : null\"\n  [attr.aria-describedby]=\"ariaDescribedBy\"\n  [class.cx-card-border]=\"border\"\n  [class.cx-card-fit-to-container]=\"fitToContainer\"\n>\n  <!-- Card Header -->\n  <div\n    *ngIf=\"isHeaderVisible\"\n    class=\"card-header\"\n    [id]=\"getLabel('content-header')\"\n  >\n    {{ content.header }}\n  </div>\n  <!-- Card Body -->\n  <div class=\"card-body cx-card-body\" [class.cx-card-delete]=\"editMode\">\n    <!-- Edit message -->\n    <div *ngIf=\"editMode\" role=\"alert\" class=\"cx-card-delete-msg\">\n      {{ content.deleteMsg }}\n    </div>\n    <!-- Card title -->\n    <span\n      *ngIf=\"content.title\"\n      class=\"cx-card-title\"\n      [id]=\"getLabel('content-title')\"\n    >\n      {{ content.title }}\n    </span>\n    <!-- Card Content -->\n    <div class=\"cx-card-container\" [id]=\"getLabel('cx-card-container')\">\n      <!-- Card Label -->\n      <div class=\"cx-card-label-container\">\n        <div *ngIf=\"content.textBold\" class=\"cx-card-label-bold\">\n          {{ content.textBold }}\n        </div>\n        <div *ngFor=\"let line of content.text\">\n          <ng-container\n            *ngTemplateOutlet=\"\n              showText;\n              context: {\n                content: content,\n                truncateText: truncateText,\n                charactersLimit: charactersLimit,\n                class: 'cx-card-label',\n                text: line,\n              }\n            \"\n          >\n          </ng-container>\n        </div>\n        <div\n          class=\"cx-card-paragraph\"\n          *ngFor=\"let item of content.paragraphs; trackBy: trackByIndex\"\n        >\n          <div class=\"cx-card-paragraph-title\">{{ item.title }}</div>\n          <div *ngFor=\"let text of item.text\">\n            <ng-container\n              *ngTemplateOutlet=\"\n                showText;\n                context: {\n                  content: content,\n                  truncateText: truncateParagraphText,\n                  charactersLimit: charactersLimit,\n                  class: 'cx-card-paragraph-text',\n                  text: text,\n                }\n              \"\n            >\n            </ng-container>\n          </div>\n        </div>\n        <ng-content select=\"[label_container_bottom]\"></ng-content>\n      </div>\n      <!-- Image -->\n      <div\n        *ngIf=\"content.img\"\n        class=\"cx-card-img-container\"\n        [attr.aria-label]=\"\n          content.imgLabel ?? 'paymentCard.credit' | cxTranslate\n        \"\n        role=\"img\"\n        [attr.title]=\"content.imgLabel ?? 'paymentCard.credit' | cxTranslate\"\n      >\n        <cx-icon [type]=\"content.img\"></cx-icon>\n      </div>\n    </div>\n    <!-- Edit Mode Actions -->\n    <div *ngIf=\"editMode\" class=\"row cx-card-body-delete\">\n      <div class=\"row col-md-12\" *cxFeature=\"'a11yDeleteButton2First'\">\n        <div class=\"col-md-6\" [cxFocus]=\"{ autofocus: true }\">\n          <button class=\"btn btn-block btn-primary\" (click)=\"delete()\">\n            {{ 'common.delete' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-md-6\">\n          <button\n            [cxAtMessage]=\"'assistiveMessage.actionCancelled' | cxTranslate\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelEdit()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row col-md-12\" *cxFeature=\"'!a11yDeleteButton2First'\">\n        <div class=\"col-md-6\">\n          <button\n            [cxAtMessage]=\"'assistiveMessage.actionCancelled' | cxTranslate\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelEdit()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-md-6\" [cxFocus]=\"{ autofocus: true }\">\n          <button class=\"btn btn-block btn-primary\" (click)=\"delete()\">\n            {{ 'common.delete' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n    <!-- Actions -->\n    <div *ngIf=\"content.actions && !editMode\" class=\"cx-card-actions\">\n      <ng-container *cxFeature=\"'!a11yImproveButtonsInCardComponent'\">\n        <div *ngFor=\"let action of content.actions\">\n          <div>\n            <ng-container\n              *ngIf=\"isCardAction(action)\"\n              [ngSwitch]=\"action.event\"\n            >\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'delete'\"\n                class=\"link cx-action-link\"\n                (click)=\"delete()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'default'\"\n                class=\"link cx-action-link\"\n                (click)=\"setDefault()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'send'\"\n                class=\"link cx-action-link\"\n                (click)=\"send()\"\n                [attr.aria-describedby]=\"\n                  index >= 0 && content.header && !editMode\n                    ? 'content-header-' + index\n                    : null\n                \"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'edit'\"\n                class=\"link cx-action-link\"\n                (click)=\"edit()\"\n              >\n                {{ action.name }}\n              </button>\n            </ng-container>\n            <a\n              *ngIf=\"isCardLinkAction(action)\"\n              href=\"{{ action.link }}\"\n              class=\"link cx-action-link\"\n            >\n              {{ action.name }}\n            </a>\n          </div>\n        </div>\n      </ng-container>\n      <ng-container *cxFeature=\"'a11yImproveButtonsInCardComponent'\">\n        <div *ngFor=\"let action of content.actions\" class=\"cx-card-action-item\">\n          <div>\n            <ng-container\n              *ngIf=\"isCardAction(action)\"\n              [ngSwitch]=\"action.event\"\n            >\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'delete'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"delete()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'default'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"setDefault()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'send'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"send()\"\n                [attr.aria-describedby]=\"\n                  index >= 0 && content.header && !editMode\n                    ? 'content-header-' + index\n                    : null\n                \"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'edit'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"edit()\"\n              >\n                {{ action.name }}\n              </button>\n            </ng-container>\n            <cx-generic-link\n              *ngIf=\"isCardLinkAction(action)\"\n              [url]=\"action.link\"\n              [ariaLabel]=\"\n                action.ariaLabel ? (action.ariaLabel | cxTranslate) : undefined\n              \"\n              [target]=\"action.target ?? null\"\n              >{{ action.name }}</cx-generic-link\n            >\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n\n<ng-template\n  #showText\n  let-content=\"content\"\n  let-truncateText=\"truncateText\"\n  let-charactersLimit=\"charactersLimit\"\n  let-class=\"class\"\n  let-text=\"text\"\n>\n  <div *ngIf=\"!truncateText\" [class]=\"class\" [ngClass]=\"content.customClass\">\n    {{ text }}\n  </div>\n\n  <cx-truncate-text-popover\n    *ngIf=\"truncateText\"\n    [charactersLimit]=\"charactersLimit\"\n    [content]=\"text\"\n    [customClass]=\"content.customClass || class\"\n  ></cx-truncate-text-popover>\n</ng-template>\n" }]
        }], ctorParameters: () => [], propDecorators: { deleteCard: [{
                type: Output
            }], setDefaultCard: [{
                type: Output
            }], sendCard: [{
                type: Output
            }], editCard: [{
                type: Output
            }], cancelCard: [{
                type: Output
            }], border: [{
                type: Input
            }], editMode: [{
                type: Input
            }], isDefault: [{
                type: Input
            }], content: [{
                type: Input
            }], fitToContainer: [{
                type: Input
            }], truncateText: [{
                type: Input
            }], truncateParagraphText: [{
                type: Input
            }], charactersLimit: [{
                type: Input
            }], index: [{
                type: Input
            }], role: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PopoverModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PopoverModule, declarations: [PopoverDirective, PopoverComponent], imports: [CommonModule,
            RouterModule,
            KeyboardFocusModule,
            IconModule,
            I18nModule], exports: [PopoverDirective, PopoverComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverModule, imports: [CommonModule,
            RouterModule,
            KeyboardFocusModule,
            IconModule,
            I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        KeyboardFocusModule,
                        IconModule,
                        I18nModule,
                    ],
                    declarations: [PopoverDirective, PopoverComponent],
                    exports: [PopoverDirective, PopoverComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TruncateTextPopoverModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TruncateTextPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TruncateTextPopoverModule, declarations: [TruncateTextPopoverComponent, TruncatePipe], imports: [CommonModule, I18nModule, PopoverModule], exports: [TruncateTextPopoverComponent, TruncatePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TruncateTextPopoverModule, imports: [CommonModule, I18nModule, PopoverModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TruncateTextPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule, PopoverModule],
                    declarations: [TruncateTextPopoverComponent, TruncatePipe],
                    exports: [TruncateTextPopoverComponent, TruncatePipe],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class GenericLinkModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkModule, declarations: [GenericLinkComponent], imports: [CommonModule, RouterModule], exports: [GenericLinkComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkModule, imports: [CommonModule, RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GenericLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule],
                    declarations: [GenericLinkComponent],
                    exports: [GenericLinkComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CardModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: CardModule, declarations: [CardComponent], imports: [CommonModule,
            AtMessageModule,
            I18nModule,
            IconModule,
            TruncateTextPopoverModule,
            KeyboardFocusModule,
            FeaturesConfigModule,
            GenericLinkModule], exports: [CardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CardModule, imports: [CommonModule,
            AtMessageModule,
            I18nModule,
            IconModule,
            TruncateTextPopoverModule,
            KeyboardFocusModule,
            FeaturesConfigModule,
            GenericLinkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        AtMessageModule,
                        I18nModule,
                        IconModule,
                        TruncateTextPopoverModule,
                        KeyboardFocusModule,
                        FeaturesConfigModule,
                        GenericLinkModule,
                    ],
                    declarations: [CardComponent],
                    exports: [CardComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MediaSourcesPipe {
    transform(sizes) {
        const sources = [];
        return sizes.split(/,\s*/).reduceRight((acc, set) => {
            let [srcset, media] = set.split(' ');
            if (!srcset || !media) {
                return acc;
            }
            media = `(min-width: ${media.replace('w', 'px')})`;
            acc.push({ srcset, media });
            return acc;
        }, sources);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaSourcesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MediaSourcesPipe, isStandalone: false, name: "cxMediaSources" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaSourcesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cxMediaSources',
                    standalone: false,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @deprecated since 2211.31. It will be eventually removed in the future
 */
const USE_LEGACY_MEDIA_COMPONENT = new InjectionToken('USE_LEGACY_MEDIA_COMPONENT');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The HTML element rendered in the template can be either `<img>` or `<picture>`,
 * depending on the input value of `elementType`, which defaults to `'img'`.
 *
 * In the case of a `<picture>` element, each `<source>` element will contain `srcset` attribute with exactly one URL.
 *
 * If you need multiple URLs per `<source>` (e.g. for different pixel densities),
 * split it into multiple media queries (e.g. with `min-device-pixel-ratio`). See the following example:
 *
 * Instead of:
 *
 * ```html
 * <source media="(min-width: 960px)" srcset="image-1400.jpg 1x, image-2800.jpg 2x">
 * ```
 *
 * Use additional formats and additional media queries, such as:
 *
 * ```html
 * <source media="(min-width: 960px) and (-webkit-min-device-pixel-ratio: 2)" srcset="image-2800.jpg">
 * <source media="(min-width: 960px)" srcset="image-1400.jpg">
 * ```
 */
class MediaComponent {
    constructor(mediaService) {
        this.mediaService = mediaService;
        /**
         * Set the loading strategy of the media. Defaults to global loading strategy.
         * Use 'lazy' or 'eager' strategies.
         */
        this.loading = this.loadingStrategy;
        /**
         * Works only when `useExtendedMediaComponentConfiguration` toggle is true
         *
         * @default img
         */
        this.elementType = 'img';
        /**
         * Once the media is loaded, we emit an event.
         */
        this.loaded = new EventEmitter();
        /**
         * The `cx-media` component has an `is-initialized` class as long as the
         * media is being initialized.
         */
        this.isInitialized = false;
        /**
         * The `cx-media` component has a `is-loading` class as long as the
         * media is loaded. Wehn the media is loaded, the `is-initialized` class
         * is added.
         */
        this.isLoading = true;
        /**
         * When there's no media provided for the content, or in case an error
         * happened during loading, we add the `is-missing` class. Visual effects
         * can be controlled by CSS.
         */
        this.isMissing = false;
        this.trackByMedia = (_, item) => item.media;
        /**
         * @deprecated since 2211.31. It will be eventually removed in the future
         *
         * To use `img` HTML element instead of `picture`
         * use `useExtendedMediaComponentConfiguration` feature flag
         * and pass `[elementType]="'img'"` input to the component
         */
        this.isLegacy = inject(USE_LEGACY_MEDIA_COMPONENT, { optional: true }) ||
            inject(Config)['useLegacyMediaComponent'] ||
            false;
    }
    ngOnChanges() {
        this.create();
    }
    /**
     * Creates the `Media` object
     */
    create() {
        this.media = this.mediaService.getMediaBasedOnHTMLElementType(this.elementType, this.container instanceof Array ? this.container[0] : this.container, this.format, this.alt, this.role);
        if (!this.media?.src) {
            this.handleMissing();
        }
    }
    /**
     * This handler is called from the UI when the image is loaded.
     */
    loadHandler() {
        this.isLoading = false;
        this.isInitialized = true;
        this.isMissing = false;
        this.loaded.emit(true);
    }
    /**
     * Indicates whether the browser should lazy load the image.
     */
    get loadingStrategy() {
        return this.mediaService.loadingStrategy === ImageLoadingStrategy.LAZY
            ? ImageLoadingStrategy.LAZY
            : null;
    }
    /**
     * Whenever an error happens during load, we mark the component
     * with css classes to have a missing media.
     */
    errorHandler() {
        this.handleMissing();
    }
    handleMissing() {
        this.isLoading = false;
        this.isInitialized = true;
        this.isMissing = true;
        this.loaded.emit(false);
    }
    /**
     * If the media has a high fetch priority, we load the image eagerly,
     * no matter what the explicit loading strategy is.
     *
     * It's for convenience to not set explicitly `loading="eager"`,
     * when we already know that the image has a high fetch priority.
     */
    get effectiveLoadingStrategy() {
        if (this.fetchPriority === ImageFetchPriority.HIGH) {
            return ImageLoadingStrategy.EAGER;
        }
        return this.loading ?? this.loadingStrategy;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaComponent, deps: [{ token: MediaService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MediaComponent, isStandalone: false, selector: "cx-media", inputs: { container: "container", format: "format", alt: "alt", role: "role", loading: "loading", fetchPriority: "fetchPriority", elementType: "elementType", sizesForImgElement: "sizesForImgElement" }, outputs: { loaded: "loaded" }, host: { properties: { "class.is-initialized": "this.isInitialized", "class.is-loading": "this.isLoading", "class.is-missing": "this.isMissing" } }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"!!media\">\n  <ng-container *cxFeature=\"'useExtendedMediaComponentConfiguration'\">\n    <picture\n      *ngIf=\"\n        !!media?.sources?.length && elementType !== 'img';\n        else imageElementTmp\n      \"\n    >\n      <source\n        *ngFor=\"let source of media.sources; trackBy: trackByMedia\"\n        [media]=\"source.media\"\n        [srcset]=\"source.srcset\"\n        [attr.width]=\"source.width\"\n        [attr.height]=\"source.height\"\n      />\n\n      <img\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [attr.role]=\"media.role\"\n        [attr.width]=\"media.width\"\n        [attr.height]=\"media.height\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </picture>\n\n    <ng-template #imageElementTmp>\n      <img\n        *ngIf=\"media.src\"\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [srcset]=\"media.srcset || media.src\"\n        [attr.role]=\"media.role\"\n        [attr.width]=\"media.width\"\n        [attr.height]=\"media.height\"\n        [attr.sizes]=\"sizesForImgElement\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </ng-template>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!useExtendedMediaComponentConfiguration'\">\n    <picture *ngIf=\"media.srcset && !isLegacy; else legacyImgTmp\">\n      <source\n        *ngFor=\"\n          let source of media!.srcset! | cxMediaSources;\n          trackBy: trackByMedia\n        \"\n        [srcset]=\"source.srcset\"\n        [media]=\"source.media\"\n      />\n      <img\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [attr.role]=\"media.role\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </picture>\n\n    <ng-template #legacyImgTmp>\n      <img\n        *ngIf=\"media.src\"\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [srcset]=\"media?.srcset || media.src\"\n        [attr.role]=\"media.role\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </ng-template>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: MediaSourcesPipe, name: "cxMediaSources" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-media', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"!!media\">\n  <ng-container *cxFeature=\"'useExtendedMediaComponentConfiguration'\">\n    <picture\n      *ngIf=\"\n        !!media?.sources?.length && elementType !== 'img';\n        else imageElementTmp\n      \"\n    >\n      <source\n        *ngFor=\"let source of media.sources; trackBy: trackByMedia\"\n        [media]=\"source.media\"\n        [srcset]=\"source.srcset\"\n        [attr.width]=\"source.width\"\n        [attr.height]=\"source.height\"\n      />\n\n      <img\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [attr.role]=\"media.role\"\n        [attr.width]=\"media.width\"\n        [attr.height]=\"media.height\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </picture>\n\n    <ng-template #imageElementTmp>\n      <img\n        *ngIf=\"media.src\"\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [srcset]=\"media.srcset || media.src\"\n        [attr.role]=\"media.role\"\n        [attr.width]=\"media.width\"\n        [attr.height]=\"media.height\"\n        [attr.sizes]=\"sizesForImgElement\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </ng-template>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!useExtendedMediaComponentConfiguration'\">\n    <picture *ngIf=\"media.srcset && !isLegacy; else legacyImgTmp\">\n      <source\n        *ngFor=\"\n          let source of media!.srcset! | cxMediaSources;\n          trackBy: trackByMedia\n        \"\n        [srcset]=\"source.srcset\"\n        [media]=\"source.media\"\n      />\n      <img\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [attr.role]=\"media.role\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </picture>\n\n    <ng-template #legacyImgTmp>\n      <img\n        *ngIf=\"media.src\"\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [srcset]=\"media?.srcset || media.src\"\n        [attr.role]=\"media.role\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </ng-template>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: MediaService }], propDecorators: { container: [{
                type: Input
            }], format: [{
                type: Input
            }], alt: [{
                type: Input
            }], role: [{
                type: Input
            }], loading: [{
                type: Input
            }], fetchPriority: [{
                type: Input
            }], elementType: [{
                type: Input
            }], sizesForImgElement: [{
                type: Input
            }], loaded: [{
                type: Output
            }], isInitialized: [{
                type: HostBinding,
                args: ['class.is-initialized']
            }], isLoading: [{
                type: HostBinding,
                args: ['class.is-loading']
            }], isMissing: [{
                type: HostBinding,
                args: ['class.is-missing']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function mediaPreconnectInitializer(mediaPreconnectService) {
    return () => mediaPreconnectService.addPreconnectLink();
}
class MediaModule {
    static forRoot() {
        return {
            ngModule: MediaModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: mediaPreconnectInitializer,
                    deps: [MediaPreconnectService],
                    multi: true,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MediaModule, declarations: [MediaComponent, MediaSourcesPipe], imports: [CommonModule, FeaturesConfigModule], exports: [MediaComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaModule, imports: [CommonModule, FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FeaturesConfigModule],
                    declarations: [MediaComponent, MediaSourcesPipe],
                    exports: [MediaComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to enhance carousel item accessibility by ensuring they can receive focus,
 * enabling keyboard navigation using Arrow keys between carousel items.
 *
 * Upon initialization, the directive verifies if the host element is inherently focusable
 * or if it has an appropriately set tabindex. If an element cannot receive focus and the
 * application is running in development mode, a warning is logged to help identify and
 * correct accessibility issues during development.
 *
 * Usage example:
 * ```
 * <ng-container>
 *   <cx-carousel [template]="thumb">
 *     ...
 *   </cx-carousel>
 * </ng-container>
 *
 * <ng-template #thumb let-item="item">
 *   <cx-media cxFocusableCarouselItem tabindex="0">
 *     ...
 *   </cx-media>
 * </ng-template>
 * ```
 */
class FocusableCarouselItemDirective {
    constructor(logger, el) {
        this.logger = logger;
        this.el = el;
        if (isDevMode() && !this.canElementReceiveFocus()) {
            this.logger.warn(`cxFocusableCarouselItem: Element cannot receive focus: ${this.el.nativeElement.tagName}. Either use one of the focusable elements, or add a non-negative tabindex.`);
        }
    }
    canElementReceiveFocus() {
        const focusableTags = ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'A'];
        const element = this.el.nativeElement;
        const hasTabIndex = element.hasAttribute('tabindex') &&
            element.getAttribute('tabindex') !== '-1';
        const isFocusableTag = focusableTags.includes(element.tagName);
        const isDisabled = element.hasAttribute('disabled');
        return (hasTabIndex || isFocusableTag) && !isDisabled;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FocusableCarouselItemDirective, deps: [{ token: i1.LoggerService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: FocusableCarouselItemDirective, isStandalone: false, selector: "[cxFocusableCarouselItem]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FocusableCarouselItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxFocusableCarouselItem]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i1.LoggerService }, { type: i0.ElementRef }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CarouselModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: CarouselModule, declarations: [CarouselComponent, FocusableCarouselItemDirective], imports: [CommonModule,
            RouterModule,
            IconModule,
            MediaModule,
            UrlModule,
            I18nModule], exports: [CarouselComponent, FocusableCarouselItemDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselModule, imports: [CommonModule,
            RouterModule,
            IconModule,
            MediaModule,
            UrlModule,
            I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        IconModule,
                        MediaModule,
                        UrlModule,
                        I18nModule,
                    ],
                    declarations: [CarouselComponent, FocusableCarouselItemDirective],
                    exports: [CarouselComponent, FocusableCarouselItemDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Allows for observing the events of user reaching the horizontal scroll position
 * start or end.
 * Moreover, it exposes methods for scrolling left and right programmatically.
 *
 * @usage
 * ```html
 * <ng-container
 *   cxHorizontalScrollingPosition
 *   #cxHorizontalScrollingPosition="cxHorizontalScrollingPosition"
 *   [scrollingArea]="scrollingArea"
 *   [scrollingAreaStart]="scrollingAreaStart"
 *   [scrollingAreaEnd]="scrollingAreaEnd">
 *
 *   <button
 *     (click)="cxHorizontalScrollingPosition.scrollBackward()"
 *     [disabled]="cxHorizontalScrollingPosition._isScrollStart$ | async">
 *     (Icon arrow backward)
 *   </button>
 *
 *   <div #scrollingArea>
 *     <div #scrollingAreaStart></div>
 *     <div *ngFor="let item of items" class="item">{{ item }}</div>
 *     <div #scrollingAreaEnd></div>
 *   </div>
 *
 *   <button
 *     (click)="cxHorizontalScrollingPosition.scrollForward()"
 *     [disabled]="cxHorizontalScrollingPosition._isScrollEnd$ | async">
 *     (Icon arrow forward)
 *   </button>
 * </ng-container>
 */
class HorizontalScrollingPositionDirective {
    constructor() {
        this.logger = inject(LoggerService);
        this.windowRef = inject(WindowRef);
        this._scrollingAreaWidth$ = new BehaviorSubject(0);
        /**
         * Width of the scrolling area, debounced every 300ms in case of continuous resizing.
         */
        this.scrollingAreaWidth$ = this._scrollingAreaWidth$.pipe(debounceTime(300), distinctUntilChanged$1());
        this._isScrollStart$ = new BehaviorSubject(true);
        /**
         * Tells whether the start of the scrolling area is visible.
         */
        this.isScrollStart$ = this._isScrollStart$.asObservable();
        this._isScrollEnd$ = new BehaviorSubject(false);
        /**
         * Tells whether the end of the scrolling area is visible.
         */
        this.isScrollEnd$ = this._isScrollEnd$.asObservable();
        /**
         * Tells whether the carousel needs scrolling
         * (i.e. whether the all items are visible in the scrollable area).
         */
        this.isScrollNeeded$ = combineLatest([
            this._isScrollStart$,
            this._isScrollEnd$,
        ]).pipe(map$1(([isScrollStart, isScrollEnd]) => !isScrollStart || !isScrollEnd), distinctUntilChanged$1());
    }
    /**
     * When the scrolling area is appearing (or disappearing),
     * it subscribes (or unsubscribes) to the scrolling position.
     */
    ngOnChanges() {
        if (!this.windowRef.isBrowser()) {
            return;
        }
        this.unsubscribeScrollingArea();
        if (this.scrollingArea &&
            this.scrollingAreaStart &&
            this.scrollingAreaEnd) {
            this.subscribeScrollingArea();
        }
    }
    ngOnDestroy() {
        this.unsubscribeScrollingArea();
        this._isScrollStart$.complete();
        this._isScrollEnd$.complete();
        this._scrollingAreaWidth$.complete();
    }
    /**
     * Scrolls the carousel forward by a width of the carousel's visible area.
     */
    scrollForward(options) {
        if (this._isScrollEnd$.value === true) {
            return;
        }
        const distance = options?.distance ?? this._scrollingAreaWidth$.value;
        const behavior = options?.behavior ?? 'smooth';
        this.scrollingArea?.scrollBy({
            left: distance,
            behavior,
        });
    }
    /**
     * Scrolls the carousel backward by a width of the carousel's visible area.
     */
    scrollBackward(options) {
        if (this._isScrollStart$.value === true) {
            return;
        }
        const distance = options?.distance ?? this._scrollingAreaWidth$.value;
        const behavior = options?.behavior ?? 'smooth';
        this.scrollingArea?.scrollBy({
            left: -distance,
            behavior,
        });
    }
    /**
     * Starts observing the width of the scrolling area and
     * whether the user has scrolled to the start or end of the carousel.
     */
    subscribeScrollingArea() {
        if (this.scrollingArea) {
            this.scrollingAreaResizeObserver = new ResizeObserver(() => {
                if (this.scrollingArea) {
                    this._scrollingAreaWidth$.next(this.scrollingArea.clientWidth);
                }
            });
            this.scrollingAreaResizeObserver.observe(this.scrollingArea);
            this._scrollingAreaWidth$.next(this.scrollingArea.clientWidth);
        }
        // Observe when user scrolls to the start or end of the carousel
        // and then enable/disable the backward or forward scroll buttons accordingly.
        this.scrollingAreaIntersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.target === this.scrollingAreaStart) {
                    this._isScrollStart$.next(entry.isIntersecting);
                }
                else if (entry.target === this.scrollingAreaEnd) {
                    this._isScrollEnd$.next(entry.isIntersecting);
                }
            });
        }, {
            root: this.scrollingArea,
            threshold: 0,
            // In highly zoomed-out viewports (e.g., 25% zoom), the `scrollingAreaStart`
            // and `scrollingAreaEnd` elements that have 0px width might not be detected
            // by the IntersectionObserver. To workaround this, we add an arbitrary 2px
            // margin to improve the detection in such cases.
            rootMargin: '2px',
        });
        if (!this.scrollingAreaStart || !this.scrollingAreaEnd) {
            this.logger.error('scrollingAreaStart/End element is not available in the <cx-scrolling-carousel>.');
            return;
        }
        this.scrollingAreaIntersectionObserver.observe(this.scrollingAreaStart);
        this.scrollingAreaIntersectionObserver.observe(this.scrollingAreaEnd);
    }
    /**
     * Stops observing the width of the scrolling area and
     * whether the user has scrolled to the start or end of the carousel.
     */
    unsubscribeScrollingArea() {
        this.windowResizeSubscription?.unsubscribe();
        this.windowResizeSubscription = undefined;
        this.scrollingAreaResizeObserver?.disconnect();
        this.scrollingAreaResizeObserver = undefined;
        this.scrollingAreaIntersectionObserver?.disconnect();
        this.scrollingAreaIntersectionObserver = undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HorizontalScrollingPositionDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: HorizontalScrollingPositionDirective, isStandalone: false, selector: "[cxHorizontalScrollingPosition]", inputs: { scrollingArea: "scrollingArea", scrollingAreaStart: "scrollingAreaStart", scrollingAreaEnd: "scrollingAreaEnd" }, exportAs: ["cxHorizontalScrollingPosition"], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HorizontalScrollingPositionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxHorizontalScrollingPosition]',
                    exportAs: 'cxHorizontalScrollingPosition',
                    standalone: false,
                }]
        }], propDecorators: { scrollingArea: [{
                type: Input
            }], scrollingAreaStart: [{
                type: Input
            }], scrollingAreaEnd: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var KeyboardEventKeys;
(function (KeyboardEventKeys) {
    KeyboardEventKeys["ARROW_LEFT"] = "ArrowLeft";
    KeyboardEventKeys["ARROW_RIGHT"] = "ArrowRight";
    KeyboardEventKeys["TAB"] = "Tab";
})(KeyboardEventKeys || (KeyboardEventKeys = {}));
/**
 * Generic carousel component that can be used to render any carousel items,
 * such as products, images, banners, or any component. Carousel items are
 * rendered in a horizontal list which can be scrolled horizontally with
 * a touch screen or touch pad or the forward/backward buttons a the edges
 * of the carousel.
 *
 * The component uses an array of Observables (`items$`) as an input, to allow
 * for lazy loading of items.
 *
 * To allow for flexible rendering of items, the rendering is delegated to the
 * given `template`. This allows for maximum flexibility.
 */
class CarouselScrollingComponent {
    constructor() {
        this.logger = inject(LoggerService);
        this.el = inject(ElementRef);
        this.previousIcon = ICON_TYPE.CARET_LEFT;
        this.nextIcon = ICON_TYPE.CARET_RIGHT;
        /**
         * Angular's trackBy function for iterating over carousel items.
         *
         * For a given item it should return an unique identifier.
         * If not provided, it will fallback to returning the item directly
         * (like Angular's naive default trackBy).
         *
         * If the returned value is not unique, it may lead to unexpected behavior,
         * such as unwanted destroying and re-creating child templates on items array changes.
         */
        this.trackByFn = (_index, item) => item;
    }
    ngOnInit() {
        if (!this.template && isDevMode()) {
            this.logger.error('No template reference provided to render the carousel items for the `cx-carousel-scrolling`');
        }
    }
    onItemKeydown(event) {
        switch (event.key) {
            case KeyboardEventKeys.ARROW_RIGHT:
            case KeyboardEventKeys.ARROW_LEFT:
                event.preventDefault();
                this.focusNextPrevItem(event.target, event.key === KeyboardEventKeys.ARROW_RIGHT ? 1 : -1);
                break;
            case KeyboardEventKeys.TAB:
                this.skipTabForCarouselItems();
                break;
        }
    }
    /**
     * Handles Tab key on carousel items. If the carousel items have `ArrowRight`/`ArrowLeft`
     * navigation enabled, it temporarily disables tab navigation for these items.
     * The `cxFocusableCarouselItem` selector is used because it identifies carousel
     * items that have `ArrowRight`/`ArrowLeft` navigation enabled. These items should not
     * use tab navigation according to a11y requirements.
     */
    skipTabForCarouselItems() {
        const carouselElements = Array.from(this.el.nativeElement.querySelectorAll('[cxFocusableCarouselItem]'));
        if (!carouselElements.length) {
            return;
        }
        disableTabbingForTick(carouselElements);
    }
    /**
     * Focuses the next or previous item in the carousel based on keyboard navigation.
     *
     * This method determines the next focusable carousel item, identified by the
     * `cxFocusableCarouselItem` directive, based on the current focus and the direction
     * given. It adjusts the carousel's active slide if the next focusable item is
     * outside the currently visible items.
     *
     * @param currentItem - The currently focused carousel item.
     * @param direction - The navigation direction (1 for right, -1 for left).
     * @param size - The number of items per slide, used to determine slide change is needed
     */
    focusNextPrevItem(currentItem, direction) {
        const focusableElements = this.el.nativeElement.querySelectorAll('[cxFocusableCarouselItem]');
        const currentIndex = Array.from(focusableElements).indexOf(currentItem);
        const nextIndex = currentIndex + direction;
        if (nextIndex < 0 || nextIndex >= focusableElements.length) {
            return;
        }
        const targetElement = focusableElements[nextIndex];
        targetElement.focus();
    }
    /**
     * When a carousel item receives focus (e.g. via keyboard navigation),
     * but it's only partially visible in the viewport (not fully scrolled into),
     * this method ensures the item is scrolled into view.
     */
    onItemFocusIn(event) {
        const target = event.target;
        try {
            if (target && typeof target.scrollIntoView === 'function') {
                target.scrollIntoView({
                    block: 'nearest',
                    inline: 'nearest',
                    behavior: 'instant',
                });
            }
        }
        catch (error) {
            this.logger.error('Failed to scroll carousel item into view', error);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselScrollingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: CarouselScrollingComponent, isStandalone: false, selector: "cx-carousel-scrolling", inputs: { title: "title", items: "items", template: "template", previousIcon: "previousIcon", nextIcon: "nextIcon", trackByFn: "trackByFn" }, ngImport: i0, template: "<ng-container\n  *ngIf=\"items && items.length > 0\"\n  cxHorizontalScrollingPosition\n  #cxHorizontalScrollingPosition=\"cxHorizontalScrollingPosition\"\n  [scrollingArea]=\"scrollingArea\"\n  [scrollingAreaStart]=\"scrollingAreaStart\"\n  [scrollingAreaEnd]=\"scrollingAreaEnd\"\n>\n  <h2 *ngIf=\"title\">{{ title }}</h2>\n\n  <div class=\"carousel-panel\">\n    <button\n      tabindex=\"-1\"\n      class=\"previous\"\n      (click)=\"\n        $event.stopPropagation(); cxHorizontalScrollingPosition.scrollBackward()\n      \"\n      [attr.aria-disabled]=\"\n        cxHorizontalScrollingPosition.isScrollStart$ | async\n      \"\n      [attr.aria-label]=\"'carousel.scrollBackward' | cxTranslate\"\n      [attr.title]=\"'carousel.scrollBackward' | cxTranslate\"\n      [class.scroll-possible]=\"\n        cxHorizontalScrollingPosition.isScrollNeeded$ | async\n      \"\n    >\n      <cx-icon [type]=\"previousIcon\"></cx-icon>\n    </button>\n    <div class=\"carousel-items\" #scrollingArea>\n      <span #scrollingAreaStart class=\"carousel-items-start\"></span>\n\n      <ng-container\n        *ngFor=\"let item of items; let i = index; trackBy: trackByFn\"\n      >\n        <div\n          *ngIf=\"item | async as data\"\n          class=\"item\"\n          (keydown)=\"onItemKeydown($event)\"\n          (focusin)=\"onItemFocusIn($event)\"\n        >\n          <ng-container\n            *ngTemplateOutlet=\"template; context: { item: data, itemIndex: i }\"\n          ></ng-container>\n        </div>\n      </ng-container>\n\n      <span #scrollingAreaEnd class=\"carousel-items-end\"></span>\n    </div>\n    <button\n      tabindex=\"-1\"\n      class=\"next\"\n      (click)=\"\n        $event.stopPropagation(); cxHorizontalScrollingPosition.scrollForward()\n      \"\n      [attr.aria-disabled]=\"cxHorizontalScrollingPosition.isScrollEnd$ | async\"\n      [attr.aria-label]=\"'carousel.scrollForward' | cxTranslate\"\n      [attr.title]=\"'carousel.scrollForward' | cxTranslate\"\n      [class.scroll-possible]=\"\n        cxHorizontalScrollingPosition.isScrollNeeded$ | async\n      \"\n    >\n      <cx-icon [type]=\"nextIcon\"></cx-icon>\n    </button>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "directive", type: HorizontalScrollingPositionDirective, selector: "[cxHorizontalScrollingPosition]", inputs: ["scrollingArea", "scrollingAreaStart", "scrollingAreaEnd"], exportAs: ["cxHorizontalScrollingPosition"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselScrollingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-carousel-scrolling', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container\n  *ngIf=\"items && items.length > 0\"\n  cxHorizontalScrollingPosition\n  #cxHorizontalScrollingPosition=\"cxHorizontalScrollingPosition\"\n  [scrollingArea]=\"scrollingArea\"\n  [scrollingAreaStart]=\"scrollingAreaStart\"\n  [scrollingAreaEnd]=\"scrollingAreaEnd\"\n>\n  <h2 *ngIf=\"title\">{{ title }}</h2>\n\n  <div class=\"carousel-panel\">\n    <button\n      tabindex=\"-1\"\n      class=\"previous\"\n      (click)=\"\n        $event.stopPropagation(); cxHorizontalScrollingPosition.scrollBackward()\n      \"\n      [attr.aria-disabled]=\"\n        cxHorizontalScrollingPosition.isScrollStart$ | async\n      \"\n      [attr.aria-label]=\"'carousel.scrollBackward' | cxTranslate\"\n      [attr.title]=\"'carousel.scrollBackward' | cxTranslate\"\n      [class.scroll-possible]=\"\n        cxHorizontalScrollingPosition.isScrollNeeded$ | async\n      \"\n    >\n      <cx-icon [type]=\"previousIcon\"></cx-icon>\n    </button>\n    <div class=\"carousel-items\" #scrollingArea>\n      <span #scrollingAreaStart class=\"carousel-items-start\"></span>\n\n      <ng-container\n        *ngFor=\"let item of items; let i = index; trackBy: trackByFn\"\n      >\n        <div\n          *ngIf=\"item | async as data\"\n          class=\"item\"\n          (keydown)=\"onItemKeydown($event)\"\n          (focusin)=\"onItemFocusIn($event)\"\n        >\n          <ng-container\n            *ngTemplateOutlet=\"template; context: { item: data, itemIndex: i }\"\n          ></ng-container>\n        </div>\n      </ng-container>\n\n      <span #scrollingAreaEnd class=\"carousel-items-end\"></span>\n    </div>\n    <button\n      tabindex=\"-1\"\n      class=\"next\"\n      (click)=\"\n        $event.stopPropagation(); cxHorizontalScrollingPosition.scrollForward()\n      \"\n      [attr.aria-disabled]=\"cxHorizontalScrollingPosition.isScrollEnd$ | async\"\n      [attr.aria-label]=\"'carousel.scrollForward' | cxTranslate\"\n      [attr.title]=\"'carousel.scrollForward' | cxTranslate\"\n      [class.scroll-possible]=\"\n        cxHorizontalScrollingPosition.isScrollNeeded$ | async\n      \"\n    >\n      <cx-icon [type]=\"nextIcon\"></cx-icon>\n    </button>\n  </div>\n</ng-container>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], items: [{
                type: Input
            }], template: [{
                type: Input
            }], previousIcon: [{
                type: Input
            }], nextIcon: [{
                type: Input
            }], trackByFn: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HorizontalScrollingPositionDirectiveModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HorizontalScrollingPositionDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: HorizontalScrollingPositionDirectiveModule, declarations: [HorizontalScrollingPositionDirective], exports: [HorizontalScrollingPositionDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HorizontalScrollingPositionDirectiveModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HorizontalScrollingPositionDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HorizontalScrollingPositionDirective],
                    exports: [HorizontalScrollingPositionDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CarouselScrollingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselScrollingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: CarouselScrollingModule, declarations: [CarouselScrollingComponent], imports: [CommonModule,
            RouterModule,
            IconModule,
            MediaModule,
            UrlModule,
            I18nModule,
            HorizontalScrollingPositionDirectiveModule], exports: [CarouselScrollingComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselScrollingModule, imports: [CommonModule,
            RouterModule,
            IconModule,
            MediaModule,
            UrlModule,
            I18nModule,
            HorizontalScrollingPositionDirectiveModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CarouselScrollingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        IconModule,
                        MediaModule,
                        UrlModule,
                        I18nModule,
                        HorizontalScrollingPositionDirectiveModule,
                    ],
                    declarations: [CarouselScrollingComponent],
                    exports: [CarouselScrollingComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service that provides the placeholder and input pattern for date pickers. This is
 * used in Spartacus to support browser that won't support the native html5 date picker
 * using `<input type="date">`.
 *
 * While the placeholder is configurable, you should be aware that the placeholder format
 * defaults to `yyyy-mm-dd` to align with Safaris limited support of ISO 8601.
 * Another consideration is the support of date formats in the backend. In case you change
 * this format, you might need to serialize the date to the supported date format in the
 * backend.
 *
 */
class DatePickerService {
    get placeholder() {
        return 'yyyy-mm-dd';
    }
    /**
     * The default date pattern is based on the placeholder string;
     */
    get pattern() {
        return this.placeholder
            .replace('yyyy', '\\d{4}')
            .replace('mm', '\\d{1,2}')
            .replace('dd', '\\d{1,2}');
    }
    /**
     * Validates if the string based date value is a valid date.
     */
    isValidFormat(date, pattern) {
        const patternRegex = new RegExp(`^${pattern ?? this.pattern}$`);
        return patternRegex.test(date);
    }
    /**
     * Since Safari doesn't support proper date formats (ISO 8601), we need to do this
     * ourselves. We cannot rely on `new Date('2020-1-1')`. This will fail, only
     * `new Date('2020-01-01')` works.
     */
    getDate(value) {
        if (!value) {
            return;
        }
        const delimiter = this.placeholder
            .replace('yyyy', '')
            .replace('mm', '')
            .replace('dd', '')
            .substring(0, 1);
        const dateParts = value.split(delimiter);
        const placeholderParts = this.placeholder.split(delimiter);
        const y = placeholderParts.indexOf('yyyy');
        const m = placeholderParts.indexOf('mm');
        const d = placeholderParts.indexOf('dd');
        return new Date(Number(dateParts[y]), Number(dateParts[m]) - 1, Number(dateParts[d]));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DatePickerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DatePickerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DatePickerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Renders translated form errors for a given form control, based on its `errors` property.
 *
 * The translation key consists of the optional input `prefix`
 * concatenated with the error key.
 *
 * And the translation params object consist of the error details
 * (if only it's an object) merged with the optional input object `translationParams`.
 */
class FormErrorsComponent {
    constructor(ChangeDetectionRef) {
        this.ChangeDetectionRef = ChangeDetectionRef;
        this.featureConfigService = inject(FeatureConfigService);
        this.elementRef = inject(ElementRef, { optional: true });
        this.ariaLiveToken = inject(new HostAttributeToken('aria-live'), {
            optional: true,
        });
        /**
         * Prefix prepended to the translation key.
         */
        this.prefix = 'formErrors.labeled';
        /**
         * Fallback prefix prepended to the translation key.
         */
        this.fallbackPrefix = 'formErrors';
        this.previousTouchedState = false;
        this.role = this.featureConfigService.isEnabled('a11yImprovedErrorMessage')
            ? null
            : 'alert';
        this.ariaLive = !this.featureConfigService.isEnabled('a11yImprovedErrorMessage')
            ? this.ariaLiveToken
            : // If no aria-live value is set add 'polite' as a default. This is preferred over setting
                // role='alert' so that screen readers do not interrupt the current task to read this aloud.
                (this.ariaLiveToken ?? 'polite');
        this.atomic = true;
    }
    set control(control) {
        if (!control) {
            return;
        }
        this._control = control;
        this.errorsDetails$ = control?.statusChanges.pipe(startWith({}), map(() => control.errors || {}), map((errors) => Object.entries(errors).filter(([_key, details]) => details)));
    }
    get control() {
        return this._control;
    }
    ngDoCheck() {
        if (this.control.touched !== this.previousTouchedState) {
            if (this.featureConfigService.isEnabled('a11yImprovedErrorMessage') &&
                this.elementRef?.nativeElement?.getAttribute('aria-live') === 'polite') {
                // due to the way we detect changes here, JAWS doesn't always respect
                // aria live `polite`, so we need to move this in the next event-loop queue
                setTimeout(() => {
                    this.previousTouchedState = this.control.touched;
                    this.ChangeDetectionRef.markForCheck();
                });
            }
            else {
                this.previousTouchedState = this.control.touched;
                this.ChangeDetectionRef.markForCheck();
            }
        }
    }
    /**
     * Returns translation params composed of
     * the argument `errorDetails` (if only is an object) merged with
     * the component input object `translationParams`.
     *
     * In case of a conflicting object key, the value from
     * `translationParams` takes precedence.
     */
    getTranslationParams(errorDetails) {
        errorDetails = isObject(errorDetails) ? errorDetails : {};
        return { ...errorDetails, ...this.translationParams };
    }
    get invalid() {
        return this.control?.invalid;
    }
    get dirty() {
        return this.control?.dirty;
    }
    get touched() {
        return this.control?.touched;
    }
    get hidden() {
        return !(this.invalid && (this.touched || this.dirty));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormErrorsComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: FormErrorsComponent, isStandalone: false, selector: "cx-form-errors", inputs: { prefix: "prefix", fallbackPrefix: "fallbackPrefix", translationParams: "translationParams", control: "control" }, host: { properties: { "class.control-invalid": "this.invalid", "class.control-dirty": "this.dirty", "class.control-touched": "this.touched", "class.cx-visually-hidden": "this.hidden", "attr.role": "this.role", "attr.aria-live": "this.ariaLive", "attr.aria-atomic": "this.atomic" } }, ngImport: i0, template: "<ng-container *ngIf=\"errorsDetails$ | async as errorDetails\">\n  <ng-container *ngIf=\"!hidden\">\n    <p *ngFor=\"let error of errorDetails\">\n      {{\n        [prefix + '.' + error[0], fallbackPrefix + '.' + error[0]]\n          | cxTranslate: getTranslationParams(error[1])\n      }}\n    </p>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormErrorsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-form-errors', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"errorsDetails$ | async as errorDetails\">\n  <ng-container *ngIf=\"!hidden\">\n    <p *ngFor=\"let error of errorDetails\">\n      {{\n        [prefix + '.' + error[0], fallbackPrefix + '.' + error[0]]\n          | cxTranslate: getTranslationParams(error[1])\n      }}\n    </p>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { prefix: [{
                type: Input
            }], fallbackPrefix: [{
                type: Input
            }], translationParams: [{
                type: Input
            }], control: [{
                type: Input
            }], invalid: [{
                type: HostBinding,
                args: ['class.control-invalid']
            }], dirty: [{
                type: HostBinding,
                args: ['class.control-dirty']
            }], touched: [{
                type: HostBinding,
                args: ['class.control-touched']
            }], hidden: [{
                type: HostBinding,
                args: ['class.cx-visually-hidden']
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], ariaLive: [{
                type: HostBinding,
                args: ['attr.aria-live']
            }], atomic: [{
                type: HostBinding,
                args: ['attr.aria-atomic']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Component that adds a date control. While the native date picker works in most
 * modern browsers, some browsers need more guidance (placeholder), validation and
 * date conversion.
 *
 * The data picker supports (optional) min and max form controls, so that you can
 * limit the start and/or end date.
 *
 * Most of the implementation is done in the `DatePickerFallbackDirective`.
 */
class DatePickerComponent {
    constructor(service) {
        this.service = service;
        this.label = 'Date';
        this.update = new EventEmitter();
    }
    change() {
        this.update.emit();
    }
    get placeholder() {
        return this.service.placeholder;
    }
    get pattern() {
        return this.service.pattern;
    }
    /**
     * Only returns the date if we have a valid format. We do this to avoid
     * loads of console errors coming from the datePipe while the user is typing
     * (in those browsers where the date picker isn't supported).
     */
    getDate(date) {
        return date && this.service.isValidFormat(date) ? date : undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DatePickerComponent, deps: [{ token: DatePickerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: DatePickerComponent, isStandalone: false, selector: "cx-date-picker", inputs: { control: "control", min: "min", max: "max", required: "required", label: "label" }, outputs: { update: "update" }, ngImport: i0, template: "<input\n  class=\"form-control\"\n  type=\"date\"\n  [formControl]=\"control\"\n  [attr.min]=\"min\"\n  [attr.max]=\"max\"\n  [attr.required]=\"required === false ? undefined : required\"\n  (change)=\"change()\"\n  [placeholder]=\"placeholder\"\n  [pattern]=\"pattern\"\n  [attr.aria-invalid]=\"!control.untouched && control.invalid\"\n  [attr.aria-errormessage]=\"'controlError'\"\n/>\n\n<cx-form-errors\n  id=\"controlError\"\n  [control]=\"control\"\n  prefix=\"formErrors.labeled.date\"\n  fallbackPrefix=\"formErrors.date\"\n  [translationParams]=\"{\n    label: label ?? '' | cxTranslate,\n    max: getDate(max) | cxDate,\n    min: getDate(min) | cxDate,\n  }\"\n></cx-form-errors>\n", dependencies: [{ kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FormErrorsComponent, selector: "cx-form-errors", inputs: ["prefix", "fallbackPrefix", "translationParams", "control"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.CxDatePipe, name: "cxDate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-date-picker', standalone: false, template: "<input\n  class=\"form-control\"\n  type=\"date\"\n  [formControl]=\"control\"\n  [attr.min]=\"min\"\n  [attr.max]=\"max\"\n  [attr.required]=\"required === false ? undefined : required\"\n  (change)=\"change()\"\n  [placeholder]=\"placeholder\"\n  [pattern]=\"pattern\"\n  [attr.aria-invalid]=\"!control.untouched && control.invalid\"\n  [attr.aria-errormessage]=\"'controlError'\"\n/>\n\n<cx-form-errors\n  id=\"controlError\"\n  [control]=\"control\"\n  prefix=\"formErrors.labeled.date\"\n  fallbackPrefix=\"formErrors.date\"\n  [translationParams]=\"{\n    label: label ?? '' | cxTranslate,\n    max: getDate(max) | cxDate,\n    min: getDate(min) | cxDate,\n  }\"\n></cx-form-errors>\n" }]
        }], ctorParameters: () => [{ type: DatePickerService }], propDecorators: { control: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], required: [{
                type: Input
            }], label: [{
                type: Input
            }], update: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FormErrorsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormErrorsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: FormErrorsModule, declarations: [FormErrorsComponent], imports: [CommonModule, I18nModule, FeaturesConfigModule], exports: [FormErrorsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormErrorsModule, imports: [CommonModule, I18nModule, FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormErrorsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule, FeaturesConfigModule],
                    declarations: [FormErrorsComponent],
                    exports: [FormErrorsComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class DatePickerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: DatePickerModule, declarations: [DatePickerComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormErrorsModule,
            I18nModule,
            FeaturesConfigModule], exports: [DatePickerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DatePickerModule, imports: [CommonModule,
            ReactiveFormsModule,
            FormErrorsModule,
            I18nModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormErrorsModule,
                        I18nModule,
                        FeaturesConfigModule,
                    ],
                    declarations: [DatePickerComponent],
                    exports: [DatePickerComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Component that adds a file upload control.
 */
class FileUploadComponent {
    constructor() {
        /**
         * Allowed file types. It's setting attribute used for OS window for choosing files.
         */
        this.accept = '*';
        /**
         * Allows selecting multiple files.
         */
        this.multiple = false;
        // TODO: remove this event. Now it's used only to trigger some logic in the parent component.
        // Prerequisites (changes in the parent component):
        // - use an async validator that "opens file" using the value of the form control
        // - "open file" on form submit, but not on the form control change
        this.update = new EventEmitter();
        // ControlValueAccessor START
        this.onChangeCallback = () => {
            // Intentional empty arrow function
        };
        this.onTouchedCallback = () => {
            // Intentional empty arrow function
        };
    }
    selectFile($event) {
        const files = $event.target?.files;
        this.onChangeCallback(files);
        this.update.emit(files);
    }
    removeFile() {
        this.fileInput.nativeElement.value = '';
    }
    get selectedFiles() {
        if (this.fileInput.nativeElement.files) {
            return Array.from(this.fileInput.nativeElement.files);
        }
        return undefined;
    }
    registerOnChange(callback) {
        this.onChangeCallback = callback;
    }
    registerOnTouched(callback) {
        this.onTouchedCallback = callback;
    }
    setDisabledState(disabled) {
        this.fileInput.nativeElement.disabled = disabled;
    }
    writeValue(value) {
        if (value instanceof FileList) {
            this.fileInput.nativeElement.files = value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileUploadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: FileUploadComponent, isStandalone: false, selector: "cx-file-upload", inputs: { accept: "accept", multiple: "multiple" }, outputs: { update: "update" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => FileUploadComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "customButton", first: true, predicate: TemplateRef, descendants: true }], viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true, static: true }], ngImport: i0, template: "<input\n  type=\"file\"\n  aria-hidden=\"true\"\n  [accept]=\"accept\"\n  [multiple]=\"multiple\"\n  (change)=\"selectFile($event)\"\n  #fileInput\n/>\n<button\n  *ngIf=\"!customButton\"\n  [attr.aria-label]=\"'common.selectFile' | cxTranslate\"\n  class=\"btn btn-secondary\"\n  type=\"button\"\n  (click)=\"fileInput.click()\"\n>\n  <ng-content></ng-content>\n</button>\n<!-- TODO(Brian-Parth): CXEC-17196 -->\n<button\n  class=\"link cx-action-link\"\n  *ngIf=\"customButton\"\n  (click)=\"fileInput.click()\"\n>\n  <ng-container *ngTemplateOutlet=\"customButton\"> </ng-container>\n</button>\n<p *ngFor=\"let file of selectedFiles\">\n  {{ file?.name }}\n</p>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-file-upload', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FileUploadComponent),
                            multi: true,
                        },
                    ], standalone: false, template: "<input\n  type=\"file\"\n  aria-hidden=\"true\"\n  [accept]=\"accept\"\n  [multiple]=\"multiple\"\n  (change)=\"selectFile($event)\"\n  #fileInput\n/>\n<button\n  *ngIf=\"!customButton\"\n  [attr.aria-label]=\"'common.selectFile' | cxTranslate\"\n  class=\"btn btn-secondary\"\n  type=\"button\"\n  (click)=\"fileInput.click()\"\n>\n  <ng-content></ng-content>\n</button>\n<!-- TODO(Brian-Parth): CXEC-17196 -->\n<button\n  class=\"link cx-action-link\"\n  *ngIf=\"customButton\"\n  (click)=\"fileInput.click()\"\n>\n  <ng-container *ngTemplateOutlet=\"customButton\"> </ng-container>\n</button>\n<p *ngFor=\"let file of selectedFiles\">\n  {{ file?.name }}\n</p>\n" }]
        }], propDecorators: { accept: [{
                type: Input
            }], multiple: [{
                type: Input
            }], customButton: [{
                type: ContentChild,
                args: [TemplateRef]
            }], update: [{
                type: Output
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput', { static: true }]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FileUploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: FileUploadModule, declarations: [FileUploadComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormErrorsModule,
            I18nModule,
            KeyboardFocusModule], exports: [FileUploadComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileUploadModule, imports: [CommonModule,
            ReactiveFormsModule,
            FormErrorsModule,
            I18nModule,
            KeyboardFocusModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormErrorsModule,
                        I18nModule,
                        KeyboardFocusModule,
                    ],
                    declarations: [FileUploadComponent],
                    exports: [FileUploadComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PasswordVisibilityToggleComponent {
    constructor() {
        this.showState = {
            icon: ICON_TYPE.EYE_SLASH,
            inputType: 'text',
            ariaLabel: 'passwordVisibility.hidePassword',
        };
        this.hideState = {
            icon: ICON_TYPE.EYE,
            inputType: 'password',
            ariaLabel: 'passwordVisibility.showPassword',
        };
        this.state = this.hideState;
    }
    /**
     * Toggle the visibility of the text of the input field.
     */
    toggle() {
        this.state =
            this.state === this.hideState ? this.showState : this.hideState;
        this.inputElement.setAttribute('type', this.state.inputType);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PasswordVisibilityToggleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PasswordVisibilityToggleComponent, isStandalone: false, selector: "cx-password-visibility-toggle", inputs: { inputElement: "inputElement" }, ngImport: i0, template: "<button\n  type=\"button\"\n  (click)=\"toggle()\"\n  [attr.aria-label]=\"state.ariaLabel | cxTranslate\"\n  [attr.title]=\"state.ariaLabel | cxTranslate\"\n  [attr.aria-pressed]=\"state.inputType === showState.inputType\"\n>\n  <span aria-hidden=\"true\">\n    <cx-icon [type]=\"state.icon\"></cx-icon>\n  </span>\n</button>\n", dependencies: [{ kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PasswordVisibilityToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-password-visibility-toggle', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<button\n  type=\"button\"\n  (click)=\"toggle()\"\n  [attr.aria-label]=\"state.ariaLabel | cxTranslate\"\n  [attr.title]=\"state.ariaLabel | cxTranslate\"\n  [attr.aria-pressed]=\"state.inputType === showState.inputType\"\n>\n  <span aria-hidden=\"true\">\n    <cx-icon [type]=\"state.icon\"></cx-icon>\n  </span>\n</button>\n" }]
        }], propDecorators: { inputElement: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FormConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to bind a PasswordVisibilityToggleDirective to a password input field. This
 * toggle while alternate the appearance of the input between dots and plain text.
 */
class PasswordVisibilityToggleDirective {
    constructor(winRef, config, elementRef, viewContainerRef, changeDetectorRef) {
        this.winRef = winRef;
        this.config = config;
        this.elementRef = elementRef;
        this.viewContainerRef = viewContainerRef;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngAfterViewInit() {
        if (this.config.form?.passwordVisibilityToggle) {
            this.wrapInput();
            this.insertComponent();
            this.changeDetectorRef.detectChanges();
        }
    }
    insertComponent() {
        const component = this.viewContainerRef.createComponent(PasswordVisibilityToggleComponent);
        component.instance.inputElement = this.elementRef.nativeElement;
        this.inputWrapper?.appendChild(component.location.nativeElement);
    }
    /**
     * We need to wrap the input element in a div to be able to position the toggle button in the right place.
     */
    wrapInput() {
        const input = this.elementRef.nativeElement;
        const parent = input.parentNode;
        this.inputWrapper = this.winRef.document.createElement('div');
        this.inputWrapper.setAttribute('class', 'cx-password-input-wrapper');
        // set the wrapper as child (instead of the element)
        parent.replaceChild(this.inputWrapper, input);
        this.inputWrapper.appendChild(input);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PasswordVisibilityToggleDirective, deps: [{ token: i1.WindowRef }, { token: FormConfig }, { token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: PasswordVisibilityToggleDirective, isStandalone: false, selector: "[cxPasswordVisibilitySwitch][type=\"password\"]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PasswordVisibilityToggleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxPasswordVisibilitySwitch][type="password"]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i1.WindowRef }, { type: FormConfig }, { type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i0.ChangeDetectorRef }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultFormConfig = {
    form: {
        passwordVisibilityToggle: true,
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PasswordVisibilityToggleModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PasswordVisibilityToggleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PasswordVisibilityToggleModule, declarations: [PasswordVisibilityToggleDirective,
            PasswordVisibilityToggleComponent], imports: [CommonModule, IconModule, I18nModule], exports: [PasswordVisibilityToggleDirective,
            PasswordVisibilityToggleComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PasswordVisibilityToggleModule, providers: [provideDefaultConfig(defaultFormConfig)], imports: [CommonModule, IconModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PasswordVisibilityToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule, I18nModule],
                    providers: [provideDefaultConfig(defaultFormConfig)],
                    declarations: [
                        PasswordVisibilityToggleDirective,
                        PasswordVisibilityToggleComponent,
                    ],
                    exports: [
                        PasswordVisibilityToggleDirective,
                        PasswordVisibilityToggleComponent,
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Renders translated form required asteriks component.
 */
class FormRequiredAsterisksComponent {
    constructor() {
        /**
         * Component Title translation (defaulted to common.required)
         */
        this.titleTranslation = 'common.required';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormRequiredAsterisksComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: FormRequiredAsterisksComponent, isStandalone: true, selector: "cx-form-required-asterisks", inputs: { titleTranslation: "titleTranslation" }, ngImport: i0, template: "<abbr\n  class=\"text-decoration-none required-asterisk\"\n  aria-hidden=\"true\"\n  title=\"{{ titleTranslation! | cxTranslate }}\"\n  >*</abbr\n>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: I18nModule }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormRequiredAsterisksComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-form-required-asterisks', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [CommonModule, I18nModule], template: "<abbr\n  class=\"text-decoration-none required-asterisk\"\n  aria-hidden=\"true\"\n  title=\"{{ titleTranslation! | cxTranslate }}\"\n  >*</abbr\n>\n" }]
        }], propDecorators: { titleTranslation: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Renders translated form required asteriks component.
 */
class FormRequiredLegendComponent {
    constructor() {
        /**
         * Form Legend translation (defaulted to 'formLegend.required')
         */
        this.formLegendTranslation = 'formLegend.required';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormRequiredLegendComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: FormRequiredLegendComponent, isStandalone: true, selector: "cx-form-required-legend", inputs: { formLegendTranslation: "formLegendTranslation" }, ngImport: i0, template: "<p class=\"form-legend\">\n  {{ formLegendTranslation! | cxTranslate }}\n</p>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: I18nModule }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FormRequiredLegendComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-form-required-legend', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [CommonModule, I18nModule], template: "<p class=\"form-legend\">\n  {{ formLegendTranslation! | cxTranslate }}\n</p>\n" }]
        }], propDecorators: { formLegendTranslation: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides a UI to manage the count of the quantity, typically by using
 * increase and decrease functionality. The item counter expects an input `FormControl`
 * so that the state of the control can be managed outside of this component.
 */
class ItemCounterComponent {
    constructor() {
        /**
         * This can be used in case an item has a minmum order quantity.
         * @default 1
         */
        this.min = 1;
        /**
         * The step is used to increment the count. It is supposed to be a
         * positive integer or float.
         * @default 1
         */
        this.step = 1;
        /**
         * Indicates that the input can be manually set to zero,
         * despite the fact that the input controls will be limited to
         * the minimum. The zero value can be used to remove an item.
         */
        this.allowZero = false;
        /**
         * ID of the element associated with the number input,
         * so it gets narrated by a screen reader
         */
        this.ariaDescribedById = '';
        /**
         * In readonly mode the item counter will only be shown as a label,
         * the form controls are not rendered.
         * Please not that readonly is different from the `disabled` form state.
         * @default false
         */
        this.readonly = false;
        useFeatureStyles('a11yItemCounterFocus');
    }
    ngOnInit() {
        this.sub = this.control.valueChanges
            .pipe(startWith(this.control.value))
            .subscribe((value) => this.control.setValue(this.getValidCount(value), { emitEvent: false }));
    }
    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
    /**
     * Updates the form control value with the input value.
     * It is used to improve keyboard controls of the component.
     */
    updateValue() {
        // Convert string value to number(prevents us from having '1' + 1 = '11' on increment)
        this.control.setValue(+this.input.nativeElement.value);
        this.control.markAsDirty();
    }
    increment() {
        // it's too early to use the `stepUp` and `stepDown` API...
        // let's wait for FF: https://caniuse.com/#search=stepUp
        this.control.setValue(this.control.value + this.step);
        this.control.markAsDirty();
    }
    decrement() {
        this.control.setValue(this.control.value - this.step);
        this.control.markAsDirty();
    }
    /**
     * Validate that the given value is in between
     * the `min` and `max` value. If the value is out
     * of  the min/max range, it will be altered.
     * If `allowZero` is set to true, the 0 value is ignored.
     *
     */
    getValidCount(value) {
        if (value < this.min && !(value === 0 && this.allowZero)) {
            value = this.min;
        }
        if (this.max && value > this.max) {
            value = this.max;
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ItemCounterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ItemCounterComponent, isStandalone: false, selector: "cx-item-counter", inputs: { control: "control", min: "min", max: "max", step: "step", allowZero: "allowZero", ariaDescribedById: "ariaDescribedById", readonly: "readonly" }, host: { properties: { "class.readonly": "this.readonly" } }, viewQueries: [{ propertyName: "input", first: true, predicate: ["qty"], descendants: true }], ngImport: i0, template: "<button\n  *cxFeature=\"'a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"decrement()\"\n  [attr.aria-disabled]=\"control.disabled || control.value <= min\"\n  [tabindex]=\"control.disabled || control.value <= min ? -1 : 0\"\n  [cxFocus]=\"{ key: 'decrement' }\"\n  attr.aria-label=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n>\n  -\n</button>\n<button\n  *cxFeature=\"'!a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"decrement()\"\n  [disabled]=\"control.disabled || control.value <= min\"\n  [tabindex]=\"control.disabled || control.value <= min ? -1 : 0\"\n  [cxFocus]=\"{ key: 'decrement' }\"\n  attr.aria-label=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n>\n  -\n</button>\n<input\n  #qty\n  type=\"number\"\n  [min]=\"min\"\n  [max]=\"max\"\n  [step]=\"step\"\n  [readonly]=\"readonly\"\n  [tabindex]=\"readonly ? -1 : 0\"\n  [formControl]=\"control\"\n  (keyup.enter)=\"updateValue()\"\n  [cxFocus]=\"{ key: 'qty' }\"\n  attr.aria-label=\"{{ 'itemCounter.quantity' | cxTranslate }}\"\n  [attr.aria-describedby]=\"ariaDescribedById\"\n/>\n<button\n  *cxFeature=\"'a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"increment()\"\n  [attr.aria-disabled]=\"control.disabled || control.value >= max\"\n  [cxFocus]=\"{ key: 'increment' }\"\n  attr.aria-label=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n>\n  +\n</button>\n<button\n  *cxFeature=\"'!a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"increment()\"\n  [disabled]=\"control.disabled || control.value >= max\"\n  [cxFocus]=\"{ key: 'increment' }\"\n  attr.aria-label=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n>\n  +\n</button>\n", dependencies: [{ kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { kind: "directive", type: i1$4.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ItemCounterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-item-counter', standalone: false, template: "<button\n  *cxFeature=\"'a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"decrement()\"\n  [attr.aria-disabled]=\"control.disabled || control.value <= min\"\n  [tabindex]=\"control.disabled || control.value <= min ? -1 : 0\"\n  [cxFocus]=\"{ key: 'decrement' }\"\n  attr.aria-label=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n>\n  -\n</button>\n<button\n  *cxFeature=\"'!a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"decrement()\"\n  [disabled]=\"control.disabled || control.value <= min\"\n  [tabindex]=\"control.disabled || control.value <= min ? -1 : 0\"\n  [cxFocus]=\"{ key: 'decrement' }\"\n  attr.aria-label=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n>\n  -\n</button>\n<input\n  #qty\n  type=\"number\"\n  [min]=\"min\"\n  [max]=\"max\"\n  [step]=\"step\"\n  [readonly]=\"readonly\"\n  [tabindex]=\"readonly ? -1 : 0\"\n  [formControl]=\"control\"\n  (keyup.enter)=\"updateValue()\"\n  [cxFocus]=\"{ key: 'qty' }\"\n  attr.aria-label=\"{{ 'itemCounter.quantity' | cxTranslate }}\"\n  [attr.aria-describedby]=\"ariaDescribedById\"\n/>\n<button\n  *cxFeature=\"'a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"increment()\"\n  [attr.aria-disabled]=\"control.disabled || control.value >= max\"\n  [cxFocus]=\"{ key: 'increment' }\"\n  attr.aria-label=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n>\n  +\n</button>\n<button\n  *cxFeature=\"'!a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"increment()\"\n  [disabled]=\"control.disabled || control.value >= max\"\n  [cxFocus]=\"{ key: 'increment' }\"\n  attr.aria-label=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n>\n  +\n</button>\n" }]
        }], ctorParameters: () => [], propDecorators: { control: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], step: [{
                type: Input
            }], allowZero: [{
                type: Input
            }], ariaDescribedById: [{
                type: Input
            }], readonly: [{
                type: HostBinding,
                args: ['class.readonly']
            }, {
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['qty']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ItemCounterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ItemCounterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ItemCounterModule, declarations: [ItemCounterComponent], imports: [CommonModule,
            ReactiveFormsModule,
            I18nModule,
            KeyboardFocusModule,
            FeaturesConfigModule], exports: [ItemCounterComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ItemCounterModule, imports: [CommonModule,
            ReactiveFormsModule,
            I18nModule,
            KeyboardFocusModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ItemCounterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        I18nModule,
                        KeyboardFocusModule,
                        FeaturesConfigModule,
                    ],
                    declarations: [ItemCounterComponent],
                    exports: [ItemCounterComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultLayoutConfig = {
    breakpoints: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: {
            min: 1200,
        },
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The direction config provides an easy way to configure "ltr" versus "rtl" direction
 * for the storefront. The direction can be configured to detect the direction by language.
 *
 * The following configuration detects rtl languages by isoCode for Arabic and Hebrew:
 *
 * ```typescript
 * direction: {
 *   detect: true,
 *   default: DirectionMode.LTR,
 *   rtlLanguages: ['ar', 'he']
 * }
 * ```
 */
class DirectionConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultDirectionConfig = {
    direction: {
        detect: true,
        default: DirectionMode.LTR,
        // we're not polluting the system with all defaults for ltr, but add 2 common used
        // languages (hebrew and arabic) to easily demo directionality
        // see https://meta.wikimedia.org/wiki/Template:List_of_language_names_ordered_by_code
        rtlLanguages: ['he', 'ar'],
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `DirectionService` can be used to add the direction to the overall storefront or individual elements.
 * By default, the direction is added to the `html` element (i.e. `<html dir="ltr">`). The API of this service
 * does however provide methods to add direction to individual elements if needed.
 *
 * The direction is configurable and allows for language driven direction configuration.
 *
 * To react to the active language, the service subscribes to the active language in the initialize method. This
 * is called from an APP_INITIALIZER method and should only happen once.
 */
class DirectionService {
    constructor(configInit, languageService, winRef) {
        this.configInit = configInit;
        this.languageService = languageService;
        this.winRef = winRef;
        this.startsDetecting = false;
        this.subscription = new Subscription();
    }
    /**
     * Initializes the layout direction for the storefront.
     */
    initialize() {
        return lastValueFrom(this.configInit.getStable('direction').pipe(tap((config) => {
            this.config = config?.direction;
            if (this.config?.detect) {
                this.detect();
            }
            else {
                this.setDirection(this.winRef.document.documentElement, this.config?.default);
            }
        })));
    }
    /**
     * Observes the _active_ language and set the required direction for the given language.
     * The method is guarded to ensure that the active language is observed only once.
     */
    detect() {
        if (this.startsDetecting) {
            return;
        }
        this.subscription.add(this.languageService
            .getActive()
            .subscribe((isoCode) => this.setDirection(this.winRef.document.documentElement, this.getDirection(isoCode))));
        this.startsDetecting = true;
    }
    /**
     * Sets the direction attribute for the given element. If the direction is undefined, the `dir`
     * attribute is removed.
     */
    setDirection(el, direction) {
        if (direction) {
            el.setAttribute('dir', direction);
        }
        else {
            el.removeAttribute('dir');
        }
    }
    /**
     * Gets the `DirectionMode` for the given language isoCode. The language isoCode is compared
     * to the configured list of languages(`direction.rtlLanguages` vs `direction.ltrLanguages`).
     *
     * If no language is given, or no language mapping could be found, we fallback to the default
     * `direction.mode`.
     */
    getDirection(language) {
        if (language && this.config?.rtlLanguages?.includes(language)) {
            return DirectionMode.RTL;
        }
        if (language && this.config?.ltrLanguages?.includes(language)) {
            return DirectionMode.LTR;
        }
        return this.config?.default;
    }
    ngOnDestroy() {
        // Cleans up the subscription, to avoid memory leaks in SSR.
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionService, deps: [{ token: i1.ConfigInitializerService }, { token: i1.LanguageService }, { token: i1.WindowRef }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.ConfigInitializerService }, { type: i1.LanguageService }, { type: i1.WindowRef }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function initHtmlDirAttribute(directionService) {
    const result = () => {
        return directionService.initialize();
    };
    return result;
}
/**
 * Provides a configuration and APP_INITIALIZER to add the correct (language drive) html direction.
 */
class DirectionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: DirectionModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionModule, providers: [
            {
                provide: APP_INITIALIZER,
                multi: true,
                useFactory: initHtmlDirAttribute,
                deps: [DirectionService],
            },
            provideDefaultConfig(defaultDirectionConfig),
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: DirectionModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APP_INITIALIZER,
                            multi: true,
                            useFactory: initHtmlDirAttribute,
                            deps: [DirectionService],
                        },
                        provideDefaultConfig(defaultDirectionConfig),
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HamburgerMenuService {
    constructor(router) {
        this.isExpanded = new BehaviorSubject(false);
        router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe(() => {
            this.toggle(true);
        });
    }
    /**
     * toggles the expand state of the hamburger menu
     */
    toggle(forceCollapse) {
        if (forceCollapse) {
            this.isExpanded.next(false);
        }
        else {
            this.isExpanded.next(!this.isExpanded.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuService, deps: [{ token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$2.Router }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HamburgerMenuComponent {
    constructor(hamburgerMenuService) {
        this.hamburgerMenuService = hamburgerMenuService;
    }
    toggle() {
        this.hamburgerMenuService.toggle();
    }
    get isExpanded() {
        return this.hamburgerMenuService.isExpanded;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuComponent, deps: [{ token: HamburgerMenuService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: HamburgerMenuComponent, isStandalone: false, selector: "cx-hamburger-menu", ngImport: i0, template: "<button\n  class=\"cx-hamburger\"\n  type=\"button\"\n  (click)=\"toggle()\"\n  [class.is-active]=\"isExpanded | async\"\n  [attr.aria-expanded]=\"isExpanded | async\"\n  [attr.aria-label]=\"\n    (isExpanded | async)\n      ? ('common.close' | cxTranslate)\n      : ('common.menu' | cxTranslate)\n  \"\n  [attr.title]=\"\n    (isExpanded | async)\n      ? ('common.close' | cxTranslate)\n      : ('common.menu' | cxTranslate)\n  \"\n  aria-controls=\"cx-header\"\n>\n  <span class=\"hamburger-box\">\n    <span class=\"hamburger-inner\"></span>\n  </span>\n</button>\n", dependencies: [{ kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-hamburger-menu', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<button\n  class=\"cx-hamburger\"\n  type=\"button\"\n  (click)=\"toggle()\"\n  [class.is-active]=\"isExpanded | async\"\n  [attr.aria-expanded]=\"isExpanded | async\"\n  [attr.aria-label]=\"\n    (isExpanded | async)\n      ? ('common.close' | cxTranslate)\n      : ('common.menu' | cxTranslate)\n  \"\n  [attr.title]=\"\n    (isExpanded | async)\n      ? ('common.close' | cxTranslate)\n      : ('common.menu' | cxTranslate)\n  \"\n  aria-controls=\"cx-header\"\n>\n  <span class=\"hamburger-box\">\n    <span class=\"hamburger-inner\"></span>\n  </span>\n</button>\n" }]
        }], ctorParameters: () => [{ type: HamburgerMenuService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HamburgerMenuModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuModule, declarations: [HamburgerMenuComponent], imports: [CommonModule, I18nModule], exports: [HamburgerMenuComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    HamburgerMenuComponent: {
                        component: HamburgerMenuComponent,
                    },
                },
            }),
        ], imports: [CommonModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HamburgerMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                HamburgerMenuComponent: {
                                    component: HamburgerMenuComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [HamburgerMenuComponent],
                    exports: [HamburgerMenuComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ThemeService {
    constructor(config, rendererFactory) {
        this.config = config;
        this.rendererFactory = rendererFactory;
        this.siteThemeService = inject(SiteThemeService);
        this.featureConfigService = inject(FeatureConfigService);
        this.subscription = new Subscription();
    }
    /**
     * This function is to be called for the root component that is
     * bootstrapped.
     */
    init(rootComponent) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
        this.rootComponent = rootComponent;
        // Theme value is a string. It is put in the generic multi-value
        // property of the SiteContextConfig. So the array's first item
        // is the theme value.
        if (this.featureConfigService.isEnabled('useSiteThemeService')) {
            this.subscription.add(this.siteThemeService
                .getActive()
                .subscribe((activeTheme) => this.setTheme(activeTheme)));
        }
        else {
            this.setTheme(this.config.context?.[THEME_CONTEXT_ID]?.[0]);
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    setTheme(theme) {
        const element = this.rootComponent.location.nativeElement;
        if (this.featureConfigService.isEnabled('useSiteThemeService')) {
            if (this.existingTheme) {
                this.renderer.removeClass(element, this.existingTheme);
            }
            if (theme) {
                this.renderer.addClass(element, theme);
                this.existingTheme = theme;
            }
        }
        else {
            if (theme) {
                this.renderer.removeClass(element, this.existingTheme);
                this.renderer.addClass(element, theme);
                this.existingTheme = theme;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ThemeService, deps: [{ token: i1.SiteContextConfig }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ThemeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ThemeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.SiteContextConfig }, { type: i0.RendererFactory2 }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function initTheme(themeService) {
    const result = (component) => themeService.init(component);
    return result;
}
class ThemeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ThemeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ThemeModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ThemeModule, providers: [
            {
                provide: APP_BOOTSTRAP_LISTENER,
                multi: true,
                useFactory: initTheme,
                deps: [ThemeService],
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ThemeModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APP_BOOTSTRAP_LISTENER,
                            multi: true,
                            useFactory: initTheme,
                            deps: [ThemeService],
                        },
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LayoutModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: LayoutModule, imports: [OutletRefModule, LaunchDialogModule, DirectionModule,
            ThemeModule], exports: [OutletRefModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LayoutModule, providers: [provideDefaultConfig(defaultLayoutConfig)], imports: [OutletRefModule,
            LaunchDialogModule.forRoot(),
            DirectionModule,
            ThemeModule, OutletRefModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        OutletRefModule,
                        LaunchDialogModule.forRoot(),
                        DirectionModule,
                        ThemeModule,
                    ],
                    providers: [provideDefaultConfig(defaultLayoutConfig)],
                    exports: [OutletRefModule],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var StorefrontOutlets;
(function (StorefrontOutlets) {
    StorefrontOutlets["STOREFRONT"] = "cx-storefront";
})(StorefrontOutlets || (StorefrontOutlets = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class GlobalMessageComponent {
    constructor(globalMessageService) {
        this.globalMessageService = globalMessageService;
        this.iconTypes = ICON_TYPE;
        this.messageType = GlobalMessageType;
    }
    ngOnInit() {
        this.messages$ = this.globalMessageService.get();
    }
    clear(type, index) {
        this.globalMessageService.remove(type, index);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GlobalMessageComponent, deps: [{ token: i1.GlobalMessageService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: GlobalMessageComponent, isStandalone: false, selector: "cx-global-message", ngImport: i0, template: "<div *ngIf=\"messages$ | async as messages\">\n  <div\n    class=\"cx-visually-hidden\"\n    *ngFor=\"let assistiveMsg of messages[messageType.MSG_TYPE_ASSISTIVE]\"\n  >\n    <span>{{ assistiveMsg | cxTranslate }}</span>\n  </div>\n  <div\n    class=\"alert alert-success\"\n    *ngFor=\"\n      let confMsg of messages[messageType.MSG_TYPE_CONFIRMATION];\n      let i = index\n    \"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.SUCCESS\"></cx-icon>\n    </span>\n    <span>{{ confMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_CONFIRMATION, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-info\"\n    *ngFor=\"let infoMsg of messages[messageType.MSG_TYPE_INFO]; let i = index\"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.INFO\"></cx-icon>\n    </span>\n    <span>{{ infoMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_INFO, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-warning\"\n    *ngFor=\"\n      let infoMsg of messages[messageType.MSG_TYPE_WARNING];\n      let i = index\n    \"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.WARNING\"></cx-icon>\n    </span>\n    <span>{{ infoMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_WARNING, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-danger\"\n    *ngFor=\"let errorMsg of messages[messageType.MSG_TYPE_ERROR]; let i = index\"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.ERROR\"></cx-icon>\n    </span>\n    <span>{{ errorMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_ERROR, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GlobalMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-global-message', standalone: false, template: "<div *ngIf=\"messages$ | async as messages\">\n  <div\n    class=\"cx-visually-hidden\"\n    *ngFor=\"let assistiveMsg of messages[messageType.MSG_TYPE_ASSISTIVE]\"\n  >\n    <span>{{ assistiveMsg | cxTranslate }}</span>\n  </div>\n  <div\n    class=\"alert alert-success\"\n    *ngFor=\"\n      let confMsg of messages[messageType.MSG_TYPE_CONFIRMATION];\n      let i = index\n    \"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.SUCCESS\"></cx-icon>\n    </span>\n    <span>{{ confMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_CONFIRMATION, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-info\"\n    *ngFor=\"let infoMsg of messages[messageType.MSG_TYPE_INFO]; let i = index\"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.INFO\"></cx-icon>\n    </span>\n    <span>{{ infoMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_INFO, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-warning\"\n    *ngFor=\"\n      let infoMsg of messages[messageType.MSG_TYPE_WARNING];\n      let i = index\n    \"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.WARNING\"></cx-icon>\n    </span>\n    <span>{{ infoMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_WARNING, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-danger\"\n    *ngFor=\"let errorMsg of messages[messageType.MSG_TYPE_ERROR]; let i = index\"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.ERROR\"></cx-icon>\n    </span>\n    <span>{{ errorMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_ERROR, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.GlobalMessageService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StorefrontComponent {
    handleEscape(event) {
        this.keyboardFocusService.handleEscape(this.elementRef.nativeElement, this.keyboardFocusConfig, event);
    }
    constructor(hamburgerMenuService, routingService, elementRef, keyboardFocusService) {
        this.hamburgerMenuService = hamburgerMenuService;
        this.routingService = routingService;
        this.elementRef = elementRef;
        this.keyboardFocusService = keyboardFocusService;
        this.focusConfig = { disableMouseFocus: true, trap: false };
        this.skipFocusConfig = {
            isEnabled: false,
            activeElementSelectors: ['button.cx-hamburger'],
        };
        this.isExpanded$ = this.hamburgerMenuService.isExpanded;
        this.StorefrontOutlets = StorefrontOutlets;
        this.featureConfigService = inject(FeatureConfigService);
        this.destroyRef = inject(DestroyRef);
        this.document = inject(DOCUMENT, {
            optional: true,
        });
        this.skipLinkService = inject(SkipLinkService, {
            optional: true,
        });
        // required by esc focus
        this.tabindex = '-1';
        this.keyboardFocusConfig = {
            focusOnEscape: true,
            focusOnDoubleEscape: true,
        };
        useFeatureStyles('headerLayoutForSmallerViewports');
        useFeatureStyles('a11yPdpGridArrangement');
        useFeatureStyles('a11yKeyboardFocusInSearchBox');
        useFeatureStyles('a11yNgSelectLayering');
        useFeatureStyles('topProgressBarUseTransformAnimation');
        useFeatureStyles('unifiedDefaultHeaderSlotsAcrossBreakpoints');
    }
    ngOnInit() {
        this.navigateSubscription = this.routingService
            .isNavigating()
            .subscribe((val) => this.onNavigation(val));
        if (this.featureConfigService.isEnabled('a11yMobileFocusOnFirstNavigationItem')) {
            this.isExpanded$ = this.hamburgerMenuService.isExpanded.pipe(tap$1((isExpanded) => {
                if (isExpanded) {
                    this.focusOnFirstNavigationItem();
                }
            }));
        }
        if (this.featureConfigService.isEnabled('a11yHamburgerMenuTrapFocus')) {
            this.trapFocusOnMenuIfExpanded();
        }
    }
    collapseMenuIfClickOutside(event) {
        const element = event.target;
        if (element.nodeName.toLowerCase() === 'header' &&
            element.className.includes('is-expanded')) {
            this.collapseMenu();
        }
    }
    collapseMenu() {
        this.hamburgerMenuService.toggle(true);
    }
    trapFocusOnMenuIfExpanded() {
        this.isExpanded$
            .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe((isExpanded) => {
            this.focusConfig = { ...this.focusConfig, trap: isExpanded };
            this.skipFocusConfig = {
                ...this.skipFocusConfig,
                isEnabled: isExpanded,
            };
        });
    }
    focusOnFirstNavigationItem() {
        const closestNavigationUi = this.elementRef.nativeElement.querySelector('header cx-navigation-ui');
        const focusable = closestNavigationUi?.querySelector('li:not(.back) button, [tabindex="0"]');
        if (focusable) {
            setTimeout(() => focusable.focus());
        }
    }
    ngOnDestroy() {
        if (this.navigateSubscription) {
            this.navigateSubscription.unsubscribe();
        }
    }
    onNavigation(isNavigating) {
        this.startNavigating = isNavigating === true;
        this.stopNavigating = isNavigating === false;
        // After clicking a link the focus should move to the first available item in the main content area.
        if (this.featureConfigService.isEnabled('a11yResetFocusAfterNavigating') &&
            this.stopNavigating &&
            this.document?.activeElement !== this.document?.body) {
            this.skipLinkService?.scrollToTarget('cx-main');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StorefrontComponent, deps: [{ token: HamburgerMenuService }, { token: i1.RoutingService }, { token: i0.ElementRef }, { token: KeyboardFocusService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: StorefrontComponent, isStandalone: false, selector: "cx-storefront", host: { listeners: { "keydown.escape": "handleEscape($event)" }, properties: { "class.start-navigating": "this.startNavigating", "class.stop-navigating": "this.stopNavigating", "tabindex": "this.tabindex" } }, viewQueries: [{ propertyName: "child", first: true, predicate: SkipLinkComponent, descendants: true }], ngImport: i0, template: "<ng-template [cxOutlet]=\"StorefrontOutlets.STOREFRONT\" cxPageTemplateStyle>\n  <ng-template cxOutlet=\"cx-header\">\n    <header\n      id=\"cx-header\"\n      cxSkipLink=\"cx-header\"\n      [cxFocus]=\"focusConfig\"\n      [class.is-expanded]=\"isExpanded$ | async\"\n      (keydown.escape)=\"collapseMenu()\"\n      (click)=\"collapseMenuIfClickOutside($event)\"\n    >\n      <cx-page-layout\n        section=\"header\"\n        [cxSkipFocus]=\"skipFocusConfig\"\n      ></cx-page-layout>\n\n      <cx-page-layout section=\"navigation\"></cx-page-layout>\n    </header>\n    <cx-page-slot\n      position=\"BottomHeaderSlot\"\n      class=\"cx-bottom-header-slot\"\n    ></cx-page-slot>\n    <cx-global-message\n      aria-atomic=\"true\"\n      aria-live=\"assertive\"\n    ></cx-global-message>\n  </ng-template>\n\n  <main cxSkipLink=\"cx-main\" [cxFocus]=\"{ disableMouseFocus: true }\">\n    <router-outlet></router-outlet>\n  </main>\n\n  <ng-template cxOutlet=\"cx-footer\">\n    <footer cxSkipLink=\"cx-footer\" [cxFocus]=\"{ disableMouseFocus: true }\">\n      <cx-page-layout section=\"footer\"></cx-page-layout>\n    </footer>\n  </ng-template>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1$2.RouterOutlet, selector: "router-outlet", inputs: ["name", "routerOutletData"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }, { kind: "component", type: GlobalMessageComponent, selector: "cx-global-message" }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "component", type: PageLayoutComponent, selector: "cx-page-layout", inputs: ["section"] }, { kind: "directive", type: PageTemplateDirective, selector: "[cxPageTemplateStyle]", inputs: ["cxPageTemplateStyle"] }, { kind: "component", type: PageSlotComponent, selector: "cx-page-slot,[cx-page-slot]", inputs: ["position", "class", "isPageFold", "hasComponents"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "directive", type: SkipFocusDirective, selector: "[cxSkipFocus]", inputs: ["cxSkipFocus"] }, { kind: "directive", type: SkipLinkDirective, selector: "[cxSkipLink]", inputs: ["cxSkipLink"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StorefrontComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-storefront', standalone: false, template: "<ng-template [cxOutlet]=\"StorefrontOutlets.STOREFRONT\" cxPageTemplateStyle>\n  <ng-template cxOutlet=\"cx-header\">\n    <header\n      id=\"cx-header\"\n      cxSkipLink=\"cx-header\"\n      [cxFocus]=\"focusConfig\"\n      [class.is-expanded]=\"isExpanded$ | async\"\n      (keydown.escape)=\"collapseMenu()\"\n      (click)=\"collapseMenuIfClickOutside($event)\"\n    >\n      <cx-page-layout\n        section=\"header\"\n        [cxSkipFocus]=\"skipFocusConfig\"\n      ></cx-page-layout>\n\n      <cx-page-layout section=\"navigation\"></cx-page-layout>\n    </header>\n    <cx-page-slot\n      position=\"BottomHeaderSlot\"\n      class=\"cx-bottom-header-slot\"\n    ></cx-page-slot>\n    <cx-global-message\n      aria-atomic=\"true\"\n      aria-live=\"assertive\"\n    ></cx-global-message>\n  </ng-template>\n\n  <main cxSkipLink=\"cx-main\" [cxFocus]=\"{ disableMouseFocus: true }\">\n    <router-outlet></router-outlet>\n  </main>\n\n  <ng-template cxOutlet=\"cx-footer\">\n    <footer cxSkipLink=\"cx-footer\" [cxFocus]=\"{ disableMouseFocus: true }\">\n      <cx-page-layout section=\"footer\"></cx-page-layout>\n    </footer>\n  </ng-template>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: HamburgerMenuService }, { type: i1.RoutingService }, { type: i0.ElementRef }, { type: KeyboardFocusService }], propDecorators: { document: [{
                type: Optional
            }], skipLinkService: [{
                type: Optional
            }], startNavigating: [{
                type: HostBinding,
                args: ['class.start-navigating']
            }], stopNavigating: [{
                type: HostBinding,
                args: ['class.stop-navigating']
            }], tabindex: [{
                type: HostBinding,
                args: ['tabindex']
            }], child: [{
                type: ViewChild,
                args: [SkipLinkComponent]
            }], handleEscape: [{
                type: HostListener,
                args: ['keydown.escape', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class GlobalMessageComponentModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GlobalMessageComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: GlobalMessageComponentModule, declarations: [GlobalMessageComponent], imports: [CommonModule, IconModule, I18nModule], exports: [GlobalMessageComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GlobalMessageComponentModule, imports: [CommonModule, IconModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: GlobalMessageComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule, I18nModule],
                    declarations: [GlobalMessageComponent],
                    exports: [GlobalMessageComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StorefrontComponentModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StorefrontComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: StorefrontComponentModule, declarations: [StorefrontComponent], imports: [CommonModule,
            RouterModule,
            GlobalMessageComponentModule,
            OutletModule,
            OutletRefModule,
            PageLayoutModule,
            PageSlotModule,
            KeyboardFocusModule,
            SkipLinkModule], exports: [StorefrontComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StorefrontComponentModule, imports: [CommonModule,
            RouterModule,
            GlobalMessageComponentModule,
            OutletModule,
            OutletRefModule,
            PageLayoutModule,
            PageSlotModule,
            KeyboardFocusModule,
            SkipLinkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StorefrontComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        GlobalMessageComponentModule,
                        OutletModule,
                        OutletRefModule,
                        PageLayoutModule,
                        PageSlotModule,
                        KeyboardFocusModule,
                        SkipLinkModule,
                    ],
                    declarations: [StorefrontComponent],
                    exports: [StorefrontComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ARIA_LABEL = 'aria-label';
class NgSelectA11yDirective {
    //TODO: CXSPA-9005: Remove this method in next major release
    /**
     * @deprecated since 2211.33
     */
    onOpen() {
        const observer = new MutationObserver((changes, observerInstance) => this.appendAriaLabelToOptions(changes, observerInstance));
        observer.observe(this.elementRef.nativeElement, { childList: true });
    }
    /**
     * When we inside a combo box using JAWS screen reader and press escape key
     * an escape keyboard event doesn't get fired, instead an AltLeft is fired.
     */
    onKeyUp(event) {
        if (!this.featureConfigService?.isEnabled('a11yNgSelectCloseDropdownOnEscape')) {
            return;
        }
        const jawsEscapeCode = 'AltLeft';
        if (event.code === jawsEscapeCode) {
            this.selectComponent.close();
        }
    }
    onEscape() {
        setTimeout(() => {
            this.elementRef.nativeElement.querySelector('input').focus();
        });
    }
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.translationService = inject(TranslationService);
        this.domSanitizer = inject(DomSanitizer);
        this.selectComponent = inject(NgSelectComponent);
        this.destroyRef = inject(DestroyRef);
        this.featureConfigService = inject(FeatureConfigService);
        this.breakpointService = inject(BreakpointService, { optional: true });
    }
    ngAfterViewInit() {
        const inputCombobox = this.elementRef.nativeElement.querySelector('[role="combobox"]');
        this.renderer.setAttribute(inputCombobox, 'role', 'combobox');
        this.renderer.setAttribute(inputCombobox, 'aria-expanded', 'false');
        if (this.featureConfigService?.isEnabled('a11yNgSelectAriaLabelDropdownCustomized')) {
            this.customizeNgSelectAriaLabelDropdown();
        }
        const isOpened$ = this.selectComponent.openEvent.pipe(map(() => 'true'));
        const isClosed$ = this.selectComponent.closeEvent.pipe(map(() => 'false'));
        merge(isOpened$, isClosed$)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((state) => {
            this.renderer.setAttribute(inputCombobox, 'aria-expanded', state);
            if (ariaControls &&
                this.featureConfigService.isEnabled('a11yNgSelectAriaControls')) {
                // Delay execution to come after the ng-select's own 'aria-controls' logic
                setTimeout(() => {
                    this.renderer.setAttribute(inputCombobox, 'aria-controls', ariaControls);
                });
            }
        });
        const ariaLabel = this.cxNgSelectA11y.ariaLabel;
        const elementId = this.elementRef.nativeElement.id;
        const ariaControls = this.cxNgSelectA11y.ariaControls ?? elementId;
        if (ariaLabel) {
            this.renderer.setAttribute(inputCombobox, ARIA_LABEL, ariaLabel);
        }
        if (ariaControls) {
            this.renderer.setAttribute(inputCombobox, 'aria-controls', ariaControls);
        }
        if (inputCombobox.readOnly && isPlatformBrowser(this.platformId)) {
            this.breakpointService
                ?.isDown(BREAKPOINT.md)
                .pipe(filter$1(Boolean), take$1(1))
                .subscribe(() => {
                const selectObserver = new MutationObserver((changes, observer) => {
                    this.appendValueToAriaLabel(changes, observer, inputCombobox);
                });
                selectObserver.observe(this.elementRef.nativeElement, {
                    subtree: true,
                    characterData: true,
                });
            });
        }
    }
    //TODO: CXSPA-9005: Remove this method in next major release
    /**
     * @deprecated since 2211.33
     */
    appendAriaLabelToOptions(_changes, observerInstance) {
        const options = this.elementRef?.nativeElement.querySelectorAll('.ng-option');
        if (options?.length) {
            this.translationService
                .translate('common.of')
                .pipe(take$1(1))
                .subscribe((translation) => {
                options.forEach((option, index) => {
                    const sanitizedOptionText = this.domSanitizer.sanitize(SecurityContext.HTML, option.innerText);
                    const ariaLabel = `${sanitizedOptionText}, ${+index + 1} ${translation} ${options.length}`;
                    this.renderer.setAttribute(option, ARIA_LABEL, ariaLabel);
                });
            });
        }
        observerInstance.disconnect();
    }
    /**
     * Hides the input value from the screen reader and provides it as part of the aria-label instead.
     * This improves the screen reader output on mobile devices.
     */
    appendValueToAriaLabel(_changes, observer, divCombobox) {
        const sanitizedValueLabel = this.domSanitizer.sanitize(SecurityContext.HTML, this.elementRef.nativeElement.querySelector('.ng-value-label')?.innerText);
        if (sanitizedValueLabel) {
            const comboboxAriaLabel = divCombobox?.getAttribute(ARIA_LABEL) || '';
            const valueElement = this.elementRef.nativeElement.querySelector('.ng-value');
            this.renderer.setAttribute(valueElement, 'aria-hidden', 'true');
            this.renderer.setAttribute(divCombobox, ARIA_LABEL, comboboxAriaLabel + ', ' + sanitizedValueLabel);
        }
        observer.disconnect();
    }
    customizeNgSelectAriaLabelDropdown() {
        this.translationService
            .translate('common.ngSelectDropdownOptionsList')
            .pipe(take$1(1))
            .subscribe((translation) => {
            this.selectComponent.ariaLabelDropdown = translation;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NgSelectA11yDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: NgSelectA11yDirective, isStandalone: false, selector: "[cxNgSelectA11y]", inputs: { cxNgSelectA11y: "cxNgSelectA11y" }, host: { listeners: { "open": "onOpen()", "keyup": "onKeyUp($event)", "keydown.escape": "onEscape()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NgSelectA11yDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxNgSelectA11y]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { cxNgSelectA11y: [{
                type: Input
            }], 
        //TODO: CXSPA-9005: Remove this method in next major release
        /**
         * @deprecated since 2211.33
         */
        onOpen: [{
                type: HostListener,
                args: ['open']
            }], onKeyUp: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }], onEscape: [{
                type: HostListener,
                args: ['keydown.escape']
            }], breakpointService: [{
                type: Optional
            }], platformId: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SortingComponent {
    constructor() {
        this.sortListEvent = new EventEmitter();
    }
    sortList(sortCode) {
        this.sortListEvent.emit(sortCode);
    }
    get selectedLabel() {
        if (this.selectedOption) {
            return (this.sortOptions?.find((sort) => sort.code === this.selectedOption)
                ?.name ?? this.sortLabels?.[this.selectedOption]);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SortingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: SortingComponent, isStandalone: false, selector: "cx-sorting", inputs: { sortOptions: "sortOptions", ariaControls: "ariaControls", ariaLabel: "ariaLabel", selectedOption: "selectedOption", placeholder: "placeholder", sortLabels: "sortLabels" }, outputs: { sortListEvent: "sortListEvent" }, ngImport: i0, template: "<ng-select\n  [searchable]=\"false\"\n  [clearable]=\"false\"\n  placeholder=\"{{ placeholder }}\"\n  (change)=\"sortList($event)\"\n  [ngModel]=\"selectedOption\"\n  [cxNgSelectA11y]=\"{\n    ariaLabel: ariaLabel || ('productList.sortResults' | cxTranslate),\n    ariaControls: ariaControls,\n  }\"\n>\n  <ng-option *ngFor=\"let sort of sortOptions\" [value]=\"sort.code\">{{\n    sort.name ? sort.name : sortLabels && sort.code ? sortLabels[sort.code] : ''\n  }}</ng-option>\n</ng-select>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2.NgSelectComponent, selector: "ng-select", inputs: ["ariaLabelDropdown", "bindLabel", "bindValue", "ariaLabel", "markFirst", "placeholder", "fixedPlaceholder", "notFoundText", "typeToSearchText", "preventToggleOnRightClick", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "ngClass", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick", "keyDownFn"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "component", type: i2.NgOptionComponent, selector: "ng-option", inputs: ["value", "disabled"] }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: NgSelectA11yDirective, selector: "[cxNgSelectA11y]", inputs: ["cxNgSelectA11y"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SortingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-sorting', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-select\n  [searchable]=\"false\"\n  [clearable]=\"false\"\n  placeholder=\"{{ placeholder }}\"\n  (change)=\"sortList($event)\"\n  [ngModel]=\"selectedOption\"\n  [cxNgSelectA11y]=\"{\n    ariaLabel: ariaLabel || ('productList.sortResults' | cxTranslate),\n    ariaControls: ariaControls,\n  }\"\n>\n  <ng-option *ngFor=\"let sort of sortOptions\" [value]=\"sort.code\">{{\n    sort.name ? sort.name : sortLabels && sort.code ? sortLabels[sort.code] : ''\n  }}</ng-option>\n</ng-select>\n" }]
        }], ctorParameters: () => [], propDecorators: { sortOptions: [{
                type: Input
            }], ariaControls: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], selectedOption: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], sortLabels: [{
                type: Input
            }], sortListEvent: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NgSelectA11yModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NgSelectA11yModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: NgSelectA11yModule, declarations: [NgSelectA11yDirective], exports: [NgSelectA11yDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NgSelectA11yModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NgSelectA11yModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NgSelectA11yDirective],
                    exports: [NgSelectA11yDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SortingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SortingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SortingModule, declarations: [SortingComponent], imports: [CommonModule,
            NgSelectModule,
            FormsModule,
            NgSelectA11yModule,
            I18nModule], exports: [SortingComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SortingModule, imports: [CommonModule,
            NgSelectModule,
            FormsModule,
            NgSelectA11yModule,
            I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SortingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        NgSelectModule,
                        FormsModule,
                        NgSelectA11yModule,
                        I18nModule,
                    ],
                    declarations: [SortingComponent],
                    exports: [SortingComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultPaginationConfig = {
    pagination: {
        addStart: true,
        addEnd: true,
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PaginationConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The item type is used to add semantic structure to the
 * PaginationItem, so that the UI understands the usage.
 */
var PaginationItemType;
(function (PaginationItemType) {
    PaginationItemType["GAP"] = "gap";
    PaginationItemType["FIRST"] = "first";
    PaginationItemType["LAST"] = "last";
    PaginationItemType["PREVIOUS"] = "previous";
    PaginationItemType["NEXT"] = "next";
    PaginationItemType["START"] = "start";
    PaginationItemType["END"] = "end";
    PaginationItemType["PAGE"] = "page";
})(PaginationItemType || (PaginationItemType = {}));
var PaginationNavigationPosition;
(function (PaginationNavigationPosition) {
    PaginationNavigationPosition["ASIDE"] = "aside";
    PaginationNavigationPosition["BEFORE"] = "before";
    PaginationNavigationPosition["AFTER"] = "after";
})(PaginationNavigationPosition || (PaginationNavigationPosition = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const FALLBACK_PAGINATION_OPTIONS = {
    rangeCount: 3,
    dotsLabel: '...',
    startLabel: '«',
    previousLabel: '‹',
    nextLabel: '›',
    endLabel: '»',
};
/**
 * Builds a pagination structures based on a pageCount and current page number.
 * There are various {@link PaginationConfig} options which can be used to configure
 * the behavior of the build. Alternatively, CSS can be used to further customize
 * the pagination.
 *
 * Examples:
 * The full blown pagination items contain the follow elements:
 *
 * `« ‹ 1 ... 4 (5) 6 ... 9 › »`
 *
 * This includes pagination items to the following pages:
 * - start page
 * - previous page
 * - first page
 * - page range
 * - last page
 * - next page
 * - end page
 *
 * All of those links are configurable, including the size of the page range.
 * The current page will always be centered in the page range to provide direct access
 * to the previous and next page.
 */
class PaginationBuilder {
    constructor(paginationConfig) {
        this.paginationConfig = paginationConfig;
    }
    /**
     * Builds a list of `PaginationItem`. The give pageCount and current are used
     * to build out the full pagination. There are various {@link PaginationConfig} options
     * which can be used to configure the behavior of the build. Alternatively, CSS
     * can be used to further specialize visibility of the pagination.
     *
     * @param pageCount The total number of pages
     * @param current The current page number, 0-index based
     * @returns An array of `PaginationItem`
     */
    paginate(pageCount, current) {
        const pages = [];
        if (!pageCount || pageCount < 2) {
            return pages;
        }
        this.addPages(pages, pageCount, current);
        this.addDots(pages, pageCount);
        this.addFirstLast(pages, pageCount);
        this.addNavigation(pages, pageCount, current);
        return pages;
    }
    /**
     * Returns the current page with surrounding pages (based on the `config.rangeCount`).
     * The current page is always centered to provide direct access to the previous and next page.
     *
     * @param pages The list of page items that is used to amend
     * @param pageCount The total number of pages
     * @param current The current page number, 0-index based
     */
    addPages(pages, pageCount, current) {
        const start = this.getStartOfRange(pageCount, current);
        if (this.config.rangeCount !== undefined && start !== null) {
            const max = Math.min(this.config.rangeCount, pageCount);
            Array.from(Array(max)).forEach((_, i) => {
                pages.push({
                    number: i + start,
                    label: String(i + start + 1),
                    type: PaginationItemType.PAGE,
                });
            });
        }
    }
    /**
     * Adds dots before and after the given pages, if configured (defaults to true).
     * If the dots only represent a single page, the page number is added instead of
     * the dots, unless the configuration requires dots always.
     *
     * @param pages The list of page items that is used to amend
     * @param pageCount The total number of pages
     */
    addDots(pages, pageCount) {
        if (!this.config.addDots) {
            return;
        }
        pages.unshift(...this.addFirstGapToDots(pages));
        pages.push(...this.addLastGapToDots(pages, pageCount));
    }
    /**
     * Helper method for addDots() whether to add the first gap.
     */
    addFirstGapToDots(pages) {
        const firstItemNumber = pages[0].number;
        const gapNumber = Number(this.config.addFirst);
        if (firstItemNumber !== undefined && firstItemNumber > gapNumber) {
            const isGap = !this.config.substituteDotsForSingularPage ||
                firstItemNumber !== gapNumber + 1;
            const isSubstituted = this.config.addFirst &&
                this.config.substituteDotsForSingularPage &&
                gapNumber === 0;
            const type = isGap
                ? PaginationItemType.GAP
                : isSubstituted
                    ? PaginationItemType.FIRST
                    : PaginationItemType.PAGE;
            return [
                Object.assign({
                    label: isGap ? this.config.dotsLabel : String(gapNumber + 1),
                    type,
                }, isGap ? null : { number: gapNumber }),
            ];
        }
        else {
            return [];
        }
    }
    /**
     * Helper method for addDots() whether to add the last gap.
     */
    addLastGapToDots(pages, pageCount) {
        const pageNumber = pages[pages.length - 1].number;
        const nextPageNumber = pageNumber ? pageNumber + 1 : undefined;
        const last = pageCount - (Number(this.config.addLast) + 1);
        if (nextPageNumber && nextPageNumber <= last) {
            const isSubstituted = this.config.addLast &&
                this.config.substituteDotsForSingularPage &&
                nextPageNumber === last;
            const isGap = nextPageNumber <
                pageCount -
                    Number(this.config.substituteDotsForSingularPage) -
                    Number(this.config.addLast);
            const type = isGap
                ? PaginationItemType.GAP
                : isSubstituted
                    ? PaginationItemType.LAST
                    : PaginationItemType.PAGE;
            return [
                Object.assign({
                    label: isGap ? this.config.dotsLabel : String(nextPageNumber + 1),
                    type,
                }, isGap ? null : { number: nextPageNumber }),
            ];
        }
        else {
            return [];
        }
    }
    /**
     * Add links to the first and last page, if configured to do so.
     *
     * @param pages The list of page items that is used to amend
     * @param pageCount The total number of pages
     *
     */
    addFirstLast(pages, pageCount) {
        if (this.config.addFirst && pages[0].number !== 0) {
            pages.unshift({
                number: 0,
                label: '1',
                type: PaginationItemType.FIRST,
            });
        }
        if (this.config.addLast &&
            pages[pages.length - 1].number !== pageCount - 1) {
            pages.push({
                number: pageCount - 1,
                label: String(pageCount),
                type: PaginationItemType.LAST,
            });
        }
    }
    /**
     * Add links to the start, previous, next and last page, if configured to do so.
     * The order of the links can be configured by using the {@link PaginationConfig},
     * using the `PaginationNavigationPosition` (`BEFORE` or `AFTER`).
     * The `PaginationNavigationPosition` allows for 3 flavours:
     *
     * - by default the pagination starts with start and previous and ends with the next and end links
     * - BEFORE – all navigation links are added in the front of the pagination list
     * - AFTER – all navigation links are pushed to the end of the pagination list
     *
     * @param pages The list of page items that is used to amend
     * @param pageCount The total number of pages
     * @param current The current page number, 0-index based
     *
     */
    addNavigation(pages, pageCount, current) {
        const before = this.getBeforeLinks(current);
        const after = this.getAfterLinks(pageCount, current);
        const pos = this.config.navigationPosition;
        if (!pos || pos === PaginationNavigationPosition.ASIDE) {
            pages.unshift(...before);
            pages.push(...after);
        }
        else {
            if (pos === PaginationNavigationPosition.BEFORE) {
                pages.unshift(...before, ...after);
            }
            if (pos === PaginationNavigationPosition.AFTER) {
                pages.push(...before, ...after);
            }
        }
    }
    /**
     * Returns the start and previous links, if applicable.
     */
    getBeforeLinks(current) {
        const list = [];
        if (this.config.addStart) {
            const start = () => {
                return Object.assign({
                    label: this.config.startLabel,
                    type: PaginationItemType.START,
                }, current > 0 ? { number: 0 } : null);
            };
            list.push(start());
        }
        if (this.config.addPrevious) {
            const previous = () => {
                return Object.assign({
                    label: this.config.previousLabel,
                    type: PaginationItemType.PREVIOUS,
                }, current > 0 ? { number: current - 1 } : null);
            };
            list.push(previous());
        }
        return list;
    }
    /**
     * Returns the next and end links, if applicable.
     */
    getAfterLinks(pageCount, current) {
        const list = [];
        if (this.config.addNext) {
            const next = () => {
                return Object.assign({
                    label: this.config.nextLabel,
                    type: PaginationItemType.NEXT,
                }, current < pageCount - 1 ? { number: current + 1 } : null);
            };
            list.push(next());
        }
        if (this.config.addEnd) {
            const end = () => {
                return Object.assign({
                    label: this.config.endLabel,
                    type: PaginationItemType.END,
                }, current < pageCount - 1 ? { number: pageCount - 1 } : null);
            };
            list.push(end());
        }
        return list;
    }
    /**
     * Resolves the first page of the range we need to build.
     * This is the page that is leading up to the range of the
     * current page.
     *
     * @param pageCount The total number of pages.
     * @param current The current page number, 0-index based.
     */
    getStartOfRange(pageCount, current) {
        if (this.config.rangeCount !== undefined) {
            const count = this.config.rangeCount - 1;
            // the least number of pages before and after the current
            const delta = Math.round(count / 2);
            // ensure that we start with at least the first page
            const minStart = Math.max(0, current - delta);
            // ensures that we start with at least 1 and do not pass the last range
            const maxStart = Math.max(0, pageCount - count - 1);
            // ensure that we get at least a full range at the end
            return Math.min(maxStart, minStart);
        }
        return null;
    }
    /**
     * Returns the pagination configuration. The configuration is driven by the
     * (default) application configuration.
     *
     * The default application is limited to adding the start and end link:
     * ```ts
     *   addStart: true,
     *   addEnd: true
     * ```
     *
     * The application configuration is however merged into the following static configuration:
     * ```ts
     * {
     *   rangeCount: 3,
     *   dotsLabel: '...',
     *   startLabel: '«',
     *   previousLabel: '‹',
     *   nextLabel: '›',
     *   endLabel: '»'
     * }
     * ```
     */
    get config() {
        return Object.assign(FALLBACK_PAGINATION_OPTIONS, this.paginationConfig.pagination);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationBuilder, deps: [{ token: PaginationConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: PaginationConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `PaginationComponent` is a generic component that is used for
 * all lists in Spartacus that require pagination. The component supports
 * all common features, which can be configured or hidden by CSS.
 */
class PaginationComponent {
    get pagination() {
        return this._pagination;
    }
    set pagination(value) {
        if (value) {
            this._pagination = value;
            this.render(value);
        }
    }
    constructor(paginationBuilder, activatedRoute) {
        this.paginationBuilder = paginationBuilder;
        this.activatedRoute = activatedRoute;
        /** The (optional) pageRoute used for the anchor links created in the pagination   */
        this.pageRoute = '.';
        /**
         * If more than one pagination is present on a page, a unique id should be set for each instance.
         * This ensures the focus can be preserved after navigating to a different page.
         */
        this.paginationID = 'pagination';
        this.viewPageEvent = new EventEmitter();
        this.pages = [];
        this.translationService = inject(TranslationService);
    }
    render(pagination) {
        if (!pagination) {
            return;
        }
        this.pages = this.paginationBuilder.paginate(pagination.totalPages ?? 0, pagination.currentPage ?? 0);
    }
    /**
     * Format aria-label based on pagination item type.
     *
     * @param item PaginationItem
     * @returns Observable
     */
    getAriaLabel$(item) {
        // Convert 'Start' to First, and 'End' to Last for a more natural screen read.
        let type = item.type;
        type = type === PaginationItemType.START ? PaginationItemType.FIRST : type;
        type = type === PaginationItemType.END ? PaginationItemType.LAST : type;
        const initialLabel = type === PaginationItemType.PAGE
            ? `${type} ${item.label}`
            : `${type} ${PaginationItemType.PAGE}`;
        if (!this.translationService) {
            return of(initialLabel);
        }
        return combineLatest([
            this.translationService?.translate('navigation.goTo', {
                location: initialLabel,
            }),
            this.translationService?.translate('common.selected'),
        ]).pipe(map$1(([goToTranslation, selectedTranslation]) => {
            return this.isCurrent(item)
                ? `${goToTranslation}, ${selectedTranslation}`
                : goToTranslation;
        }));
    }
    /**
     * Indicates whether the given item is the current item.
     *
     * @param item PaginationItem
     * @returns boolean
     */
    isCurrent(item) {
        return (item.type === PaginationItemType.PAGE &&
            item.number === this.pagination.currentPage);
    }
    /**
     * Indicates whether the pagination item is inactive. This is used
     * to disabled a link or set the tabindex to `-1`.
     *
     * Defaults to true
     *
     * @param item PaginationItem
     * @returns returns -1 in case of a disabled
     */
    isInactive(item) {
        return (!item.hasOwnProperty('number') ||
            item.number === this.pagination.currentPage);
    }
    getQueryParams(item) {
        const queryParams = Object.assign({}, this.activatedRoute.snapshot.queryParams);
        if (this.queryParam &&
            item.number !== undefined &&
            this.pagination.totalPages !== undefined &&
            item.number < this.pagination.totalPages &&
            !this.isCurrent(item)) {
            queryParams[this.queryParam] = item.number;
        }
        // omit the page number from the query parameters in case it's the default
        // to clean up the experience and avoid unnecessary polluting of the URL
        if (queryParams[this.queryParam] === this.defaultPage) {
            delete queryParams[this.queryParam];
        }
        return queryParams;
    }
    pageChange(page) {
        this.viewPageEvent.emit(page.number);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationComponent, deps: [{ token: PaginationBuilder }, { token: i1$2.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PaginationComponent, isStandalone: false, selector: "cx-pagination", inputs: { pageRoute: "pageRoute", queryParam: "queryParam", defaultPage: "defaultPage", pagination: "pagination", paginationID: "paginationID" }, outputs: { viewPageEvent: "viewPageEvent" }, ngImport: i0, template: "<a\n  *ngFor=\"let item of pages; let i = index\"\n  [class]=\"item.type\"\n  [class.disabled]=\"isInactive(item)\"\n  [class.current]=\"isCurrent(item)\"\n  [routerLink]=\"pageRoute\"\n  [queryParams]=\"getQueryParams(item)\"\n  [tabIndex]=\"isInactive(item) ? -1 : 0\"\n  [attr.aria-current]=\"isCurrent(item)\"\n  [attr.aria-disabled]=\"isInactive(item)\"\n  (click)=\"pageChange(item)\"\n  [attr.aria-label]=\"getAriaLabel$(item) | async\"\n  [attr.title]=\"getAriaLabel$(item) | async\"\n  [cxFocus]=\"{ key: paginationID + i.toString() }\"\n>\n  {{ item.label }}\n</a>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-pagination', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<a\n  *ngFor=\"let item of pages; let i = index\"\n  [class]=\"item.type\"\n  [class.disabled]=\"isInactive(item)\"\n  [class.current]=\"isCurrent(item)\"\n  [routerLink]=\"pageRoute\"\n  [queryParams]=\"getQueryParams(item)\"\n  [tabIndex]=\"isInactive(item) ? -1 : 0\"\n  [attr.aria-current]=\"isCurrent(item)\"\n  [attr.aria-disabled]=\"isInactive(item)\"\n  (click)=\"pageChange(item)\"\n  [attr.aria-label]=\"getAriaLabel$(item) | async\"\n  [attr.title]=\"getAriaLabel$(item) | async\"\n  [cxFocus]=\"{ key: paginationID + i.toString() }\"\n>\n  {{ item.label }}\n</a>\n" }]
        }], ctorParameters: () => [{ type: PaginationBuilder }, { type: i1$2.ActivatedRoute }], propDecorators: { pageRoute: [{
                type: Input
            }], queryParam: [{
                type: Input
            }], defaultPage: [{
                type: Input
            }], pagination: [{
                type: Input
            }], paginationID: [{
                type: Input
            }], viewPageEvent: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PaginationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PaginationModule, declarations: [PaginationComponent], imports: [CommonModule,
            RouterModule,
            I18nModule,
            FeaturesConfigModule,
            KeyboardFocusModule], exports: [PaginationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationModule, providers: [provideDefaultConfig(defaultPaginationConfig)], imports: [CommonModule,
            RouterModule,
            I18nModule,
            FeaturesConfigModule,
            KeyboardFocusModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        I18nModule,
                        FeaturesConfigModule,
                        KeyboardFocusModule,
                    ],
                    providers: [provideDefaultConfig(defaultPaginationConfig)],
                    declarations: [PaginationComponent],
                    exports: [PaginationComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TotalComponent {
    get pagination() {
        return this._pagination;
    }
    set pagination(paginationModel) {
        this._pagination = paginationModel ?? { totalResults: 0 };
    }
    /**
     * Current page, starting form page 0
     * */
    get currentPage() {
        return this.pagination?.currentPage ?? 0;
    }
    get pageSize() {
        return this.pagination?.pageSize ?? 0;
    }
    get totalResults() {
        return this.pagination?.totalResults ?? 0;
    }
    get fromItem() {
        return this.currentPage * this.pageSize + 1;
    }
    get toItem() {
        const lastItem = (this.currentPage + 1) * this.pageSize;
        return lastItem > this.totalResults ? this.totalResults : lastItem;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TotalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: TotalComponent, isStandalone: false, selector: "cx-total", inputs: { pagination: "pagination" }, ngImport: i0, template: "<ng-container *ngIf=\"totalResults > 0\">\n  <div>{{ totalResults }} {{ 'common.results' | cxTranslate }}</div>\n  <div class=\"cx-vertical-line-separator\"></div>\n  <div>\n    {{ fromItem }}-{{ toItem }} {{ 'common.of' | cxTranslate }}\n    {{ totalResults }}\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TotalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-total', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"totalResults > 0\">\n  <div>{{ totalResults }} {{ 'common.results' | cxTranslate }}</div>\n  <div class=\"cx-vertical-line-separator\"></div>\n  <div>\n    {{ fromItem }}-{{ toItem }} {{ 'common.of' | cxTranslate }}\n    {{ totalResults }}\n  </div>\n</ng-container>\n" }]
        }], propDecorators: { pagination: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TotalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TotalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TotalModule, declarations: [TotalComponent], imports: [CommonModule, FormsModule, I18nModule], exports: [TotalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TotalModule, imports: [CommonModule, FormsModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TotalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, I18nModule],
                    declarations: [TotalComponent],
                    exports: [TotalComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ListNavigationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ListNavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ListNavigationModule, imports: [CommonModule,
            NgSelectModule,
            FormsModule,
            ReactiveFormsModule,
            IconModule,
            PaginationModule,
            SortingModule,
            TotalModule], exports: [SortingComponent, PaginationComponent, TotalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ListNavigationModule, imports: [CommonModule,
            NgSelectModule,
            FormsModule,
            ReactiveFormsModule,
            IconModule,
            PaginationModule,
            SortingModule,
            TotalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ListNavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        NgSelectModule,
                        FormsModule,
                        ReactiveFormsModule,
                        IconModule,
                        PaginationModule,
                        SortingModule,
                        TotalModule,
                    ],
                    exports: [SortingComponent, PaginationComponent, TotalComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides configuration specific to Media, such as images. This is used to optimize
 * rendering of the media, SEO and performance.
 */
class MediaConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MediaConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProgressButtonComponent {
    constructor() {
        this.ariaLabel = '';
        this.class = '';
        this.disabled = false;
        this.loading = false;
        this.clickEvent = new EventEmitter();
        // Intentional empty constructor
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProgressButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProgressButtonComponent, isStandalone: false, selector: "cx-progress-button", inputs: { ariaLabel: "ariaLabel", class: "class", disabled: "disabled", loading: "loading" }, outputs: { clickEvent: "clickEvent" }, ngImport: i0, template: "<button\n  (click)=\"clickEvent.emit()\"\n  [attr.aria-label]=\"ariaLabel\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"class\"\n  class=\"btn btn-primary\"\n>\n  <div class=\"cx-progress-button-container\">\n    <div *ngIf=\"loading\" class=\"loader-container\">\n      <div class=\"loader\">{{ 'spinner.loading' | cxTranslate }}</div>\n    </div>\n    <ng-content></ng-content>\n  </div>\n</button>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProgressButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-progress-button', standalone: false, template: "<button\n  (click)=\"clickEvent.emit()\"\n  [attr.aria-label]=\"ariaLabel\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"class\"\n  class=\"btn btn-primary\"\n>\n  <div class=\"cx-progress-button-container\">\n    <div *ngIf=\"loading\" class=\"loader-container\">\n      <div class=\"loader\">{{ 'spinner.loading' | cxTranslate }}</div>\n    </div>\n    <ng-content></ng-content>\n  </div>\n</button>\n" }]
        }], ctorParameters: () => [], propDecorators: { ariaLabel: [{
                type: Input
            }], class: [{
                type: Input
            }], disabled: [{
                type: Input
            }], loading: [{
                type: Input
            }], clickEvent: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProgressButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProgressButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProgressButtonModule, declarations: [ProgressButtonComponent], imports: [CommonModule, I18nModule], exports: [ProgressButtonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProgressButtonModule, imports: [CommonModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProgressButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule],
                    declarations: [ProgressButtonComponent],
                    exports: [ProgressButtonComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Supposed to be injected in the split view component, so that the split view state
 * is maintained for a single split view.
 */
class SplitViewService {
    constructor() {
        /**
         * Newly added views are hidden by default, unless it is the first view of the split view.
         * The default hide mode can be overridden.
         */
        this.defaultHideMode = true;
        this.splitViewCount = 1;
        this._views$ = new BehaviorSubject([]);
    }
    /**
     * Adds a view to the list of views. The view is initialized with the `SplitViewState`
     * state. If no state is provided, the state is created with the hidden property. The hidden
     * property is provided by the `defaultHideMode`, unless it's the first view (position: 0).
     */
    add(position, initialState) {
        const state = {
            ...{ hidden: position === 0 ? false : this.defaultHideMode },
            ...initialState,
        };
        if (!this.views[position]) {
            this.views[position] = state;
            this.updateState(position, state.hidden);
            this._views$.next(this.views);
        }
    }
    /**
     * The split view is based on a number of views that can be used next to each other.
     * When the number changes (i.e. if the screen goes from wide to small), the visibility state
     * of the views should be updated.
     */
    updateSplitView(splitViewCount) {
        if (splitViewCount !== this.splitViewCount) {
            this.splitViewCount = splitViewCount;
            this.updateState();
        }
    }
    /**
     * Returns an observable with the active view number. The active view number
     * represents the last visible view.
     */
    getActiveView() {
        return this._views$.pipe(map((views) => this.getActive(views)), distinctUntilChanged());
    }
    /**
     * Returns an observable with the SplitViewState for the given view position.
     */
    getViewState(position) {
        return this._views$.pipe(map((views) => views[position]), 
        // we must filter here, since outlet driven views will destroyed the view
        filter((view) => Boolean(view)));
    }
    /**
     * Removes a view from the list of views.
     *
     * Removing a view is different from hiding a view. Removing a view is typically done
     * when a component is destroyed.
     *
     * When the view is removed, the SplitViewState is updated to reflect that new organization
     * of views.
     */
    remove(position) {
        const activePosition = this.getActive(this.views);
        this._views$.next(this.views.splice(0, position));
        if (activePosition >= position) {
            this.updateState(position);
        }
    }
    /**
     * Returns the next view position. This is useful for views that do not want to be bothered
     * with controlling view numbers.
     */
    get nextPosition() {
        return this.views.length || 0;
    }
    /**
     * Toggles the visibility of the views based on the given view position. If the view
     * is already visible, we close the view and active the former view. Unless the hide flag
     * is used, to force the view.
     *
     * The view state of other views in the split view are updated as well.
     *
     * @param position The zero-based position number of the view.
     * @param forceHide The (optional) hide state for the view position.
     */
    toggle(position, forceHide) {
        // add the view if it hasn't been added before.
        if (!this.views[position]) {
            this.add(position, { hidden: forceHide ?? false });
        }
        // If the position is already visible, we move to a previous position. Only if the hide
        // state is forced, we keep the current position.
        if (this.views[position] &&
            forceHide === undefined &&
            !this.views[position].hidden) {
            position--;
        }
        this.updateState(position, forceHide === true);
    }
    /**
     * Updates the hidden state of all the views.
     */
    updateState(position, hide) {
        const views = [...this.views];
        if (hide !== undefined && position && views[position]) {
            views[position].hidden = hide;
        }
        let lastVisible = views.length - [...views].reverse().findIndex((view) => !view.hidden) - 1;
        if (lastVisible === views.length) {
            if (position) {
                // When there's only 1 view (mobile), we might not find any active
                // if the user navigates back.
                lastVisible = position - 1;
            }
            else {
                lastVisible = views.length - 1;
            }
        }
        views.forEach((view, pos) => {
            if (view && pos !== position) {
                // hide other views that are outside the split view
                view.hidden =
                    pos > lastVisible || pos < lastVisible - (this.splitViewCount - 1);
            }
        });
        this._views$.next(views);
    }
    /**
     * Returns the active view count for the list of views.
     */
    getActive(views) {
        // we reverse the list to find the last visible view
        const l = [...views]
            .reverse()
            .findIndex((view) => !view.hidden);
        const last = l === -1 ? 0 : views.length - l - 1;
        return last;
    }
    /**
     * Utility method that resolves all views from the subject.
     */
    get views() {
        return this._views$.value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SplitViewService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SplitViewService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SplitViewService, decorators: [{
            type: Injectable
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The split-view component supports an unlimited number of nested views. The component
 * is a host to those view components and doesn't add any restrictions to it's content;
 * content is projected as-is.
 *
 * ```html
 * <cx-split-view>
 *   <cx-view></cx-view>
 *   <cx-view></cx-view>
 *   <any-wrapper>
 *     <cx-view></cx-view>
 *   </any-wrapper>
 * </cx-split-view>
 * ```
 *
 * The split view component is only concerned with tracking the underlying _visible_
 * view components, so that the `lastVisibleView` can be updated accordingly. The actual
 * visibility of views is controlled by CSS. To allow for maximum flexibility, the CSS
 * implementation is using CSS variables. The `lastVisibleView` is bind to the
 * `--cx-active-view` on the host, so that all descendants views will inherit the
 * property conveniently.
 */
class SplitViewComponent {
    /**
     * Sets the default hide mode for views. This mode is useful in case views are dynamically being created,
     * for example when they are created by router components.
     *
     * The mode defaults to true, unless this is the first view; the first view is never hidden.
     */
    set hideMode(mode) {
        this.splitService.defaultHideMode = mode;
    }
    constructor(splitService, breakpointService, elementRef) {
        this.splitService = splitService;
        this.breakpointService = breakpointService;
        this.elementRef = elementRef;
        this.subscription = new Subscription();
        /**
         * Indicates the last visible view in the range of views that is visible. This
         * is bind to a css variable `--cx-active-view` so that the experience
         * can be fully controlled by css.
         */
        this.lastVisibleView = 1;
    }
    ngOnInit() {
        this.subscription.add(this.splitService
            .getActiveView()
            .subscribe((lastVisible) => (this.lastVisibleView = lastVisible + 1)));
        this.subscription.add(this.breakpointService.breakpoint$.subscribe(() => {
            this.splitService.updateSplitView(this.splitViewCount);
        }));
    }
    /**
     * Returns the maximum number of views per split-view. The number is based on the
     * CSS custom property `--cx-max-views`.
     */
    get splitViewCount() {
        return Number(getComputedStyle(this.elementRef.nativeElement).getPropertyValue('--cx-max-views'));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SplitViewComponent, deps: [{ token: SplitViewService }, { token: BreakpointService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: SplitViewComponent, isStandalone: false, selector: "cx-split-view", inputs: { hideMode: "hideMode" }, host: { properties: { "style.--cx-active-view": "this.lastVisibleView", "attr.active-view": "this.lastVisibleView" } }, providers: [SplitViewService], ngImport: i0, template: "<ng-content></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SplitViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-split-view', changeDetection: ChangeDetectionStrategy.OnPush, providers: [SplitViewService], standalone: false, template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: () => [{ type: SplitViewService }, { type: BreakpointService }, { type: i0.ElementRef }], propDecorators: { hideMode: [{
                type: Input
            }], lastVisibleView: [{
                type: HostBinding,
                args: ['style.--cx-active-view']
            }, {
                type: HostBinding,
                args: ['attr.active-view']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The view component is part of the `SplitViewComponent`. The view
 * contains the navigable content that should be split up. It maintains
 * a view position and allows to show or hide the view.
 *
 * The ViewComponent interacts with the `SplitViewService` for handing over the
 * view state, so that the overarching `SplitViewComponent` can manage the
 * overall experience.
 */
class ViewComponent {
    /**
     * The hidden input is used to set the initial visible state of the view.
     * The hidden state defaults to false.
     *
     * The hidden input supports 2-way binding, see `hiddenChange` property.
     */
    set hidden(hidden) {
        this._hidden = hidden;
        this.splitService.toggle(this.viewPosition, hidden);
    }
    constructor(splitService, elementRef, cd) {
        this.splitService = splitService;
        this.elementRef = elementRef;
        this.cd = cd;
        /**
         * The disappeared flag is added to the
         */
        this.disappeared = true;
        /**
         * An update of the view visibility is emitted to the hiddenChange output.
         */
        this.hiddenChange = new EventEmitter();
        this.globalMessageService = inject(GlobalMessageService);
    }
    ngOnInit() {
        const hidden = this._hidden ? { hidden: this._hidden } : {};
        this.splitService.add(this.viewPosition, hidden);
        this.subscription = this.splitService
            .getViewState(this.viewPosition)
            // delay the disappeared state, so that the (CSS driven) animation has time to finish
            .pipe(delayWhen((view) => timer(view.hidden ? this.duration * 1.25 : 0)))
            .subscribe((view) => {
            this.hiddenChange.emit(view.hidden);
            this._hidden = view.hidden;
            this.disappeared = view.hidden;
            this.cd.markForCheck();
        });
        this.onViewChangeShowAssistiveMessage();
    }
    /**
     * Toggles the visibility of the view.
     *
     * An optional force flag can be used to explicitly show or hide view component.
     */
    toggle(force) {
        this.splitService.toggle(this.viewPosition, force);
    }
    /**
     * Returns the position for the view.
     *
     * The position is either taken from the input `position` or generated by the `SplitService`.
     */
    get viewPosition() {
        if (!(Number(this.position) >= 0)) {
            this.position = this.splitService.nextPosition.toString();
        }
        return Number(this.position);
    }
    /**
     * Returns the duration in milliseconds. The duration is based on the CSS custom property
     * `--cx-transition-duration`. Defaults to 300 milliseconds.
     */
    get duration() {
        const duration = getComputedStyle(this.elementRef.nativeElement)
            .getPropertyValue('--cx-transition-duration')
            .trim();
        if (duration.indexOf('ms') > -1) {
            return Number(duration.split('ms')[0]);
        }
        else if (duration.indexOf('s') > -1) {
            return Number(duration.split('s')[0]) * 1000;
        }
        else {
            return 300;
        }
    }
    onViewChangeShowAssistiveMessage() {
        this.subscription.add(this.splitService
            .getActiveView()
            .pipe(distinctUntilChanged())
            .subscribe((activeView) => {
            if (this.viewPosition !== activeView || !this.viewTitle) {
                return;
            }
            this.globalMessageService?.add(this.viewTitle, GlobalMessageType.MSG_TYPE_ASSISTIVE, 500);
        }));
    }
    /**
     * The view is removed from the `SplitService` so that the view no longer
     * plays a role in the overall split view.
     */
    ngOnDestroy() {
        this.splitService.remove(this.viewPosition);
        this.subscription?.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ViewComponent, deps: [{ token: SplitViewService }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ViewComponent, isStandalone: false, selector: "cx-view", inputs: { position: "position", hidden: "hidden", viewTitle: "viewTitle" }, outputs: { hiddenChange: "hiddenChange" }, host: { properties: { "attr.position": "this.position", "style.--cx-view-position": "this.position", "attr.disappeared": "this.disappeared" } }, ngImport: i0, template: "<ng-content></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-view', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: () => [{ type: SplitViewService }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { position: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.position']
            }, {
                type: HostBinding,
                args: ['style.--cx-view-position']
            }], disappeared: [{
                type: HostBinding,
                args: ['attr.disappeared']
            }], hidden: [{
                type: Input
            }], hiddenChange: [{
                type: Output
            }], viewTitle: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The split-view component supports an unlimited number of nested views. Nested views are rendered
 * next to each other. The views can be rendered next to each other, but the max number of visible
 * views can be limisted as well. This is configurable in the CSS layer, so that the max number of views
 * per split-view can be different for each component.
 *
 * The basic structure of the split-view component is shown below:
 *
 *
 * ```
 * <cx-split-view>
 * </cx-split-view>
 * ```
 *
 * The UX pattern used for the split-view is driven by an initial view, which gets splitted into
 * more views as soon as the user starts interacting with the initial and subsequantial views.
 * The views can be driven by routes, which means that you can navigate through the splitted views
 * by using the browser history as well as share or bookmark splitted views.
 *
 * The UI is implemented in the style layer, with only a few generic style rules. Most of the split
 * view style is driven by CSS properties, so that alternative split-view styles can be introduced
 * per page or component.
 *
 * The max number of views per split-view on mobile is limited to 1 by default, where as on tablet
 * (and higher) it is set to 2. Spartacus has a pretty narrow layout, which is why 2 is maximum,
 * but customers could alter the layout to bring in more views in the same split-view at the time.
 *
 */
class SplitViewModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SplitViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SplitViewModule, declarations: [SplitViewComponent, ViewComponent], imports: [CommonModule, RouterModule], exports: [SplitViewComponent, ViewComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SplitViewModule, imports: [CommonModule, RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SplitViewModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SplitViewComponent, ViewComponent],
                    imports: [CommonModule, RouterModule],
                    exports: [SplitViewComponent, ViewComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PromotionsComponent {
    constructor() {
        // Intentional empty constructor
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PromotionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PromotionsComponent, isStandalone: false, selector: "cx-promotions", inputs: { promotions: "promotions" }, ngImport: i0, template: "<div class=\"cx-promotions\" *ngIf=\"promotions\">\n  <ng-container *ngIf=\"promotions.length === 1\">\n    <p>{{ promotions[0].description }}</p>\n  </ng-container>\n  <ng-container *ngIf=\"promotions.length > 1\">\n    <ul>\n      <li *ngFor=\"let promotion of promotions\">\n        {{ promotion.description }}\n      </li>\n    </ul>\n  </ng-container>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PromotionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-promotions', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div class=\"cx-promotions\" *ngIf=\"promotions\">\n  <ng-container *ngIf=\"promotions.length === 1\">\n    <p>{{ promotions[0].description }}</p>\n  </ng-container>\n  <ng-container *ngIf=\"promotions.length > 1\">\n    <ul>\n      <li *ngFor=\"let promotion of promotions\">\n        {{ promotion.description }}\n      </li>\n    </ul>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { promotions: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PromotionsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PromotionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PromotionsModule, declarations: [PromotionsComponent], imports: [CommonModule], exports: [PromotionsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PromotionsModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PromotionsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [PromotionsComponent],
                    exports: [PromotionsComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SiteContextType;
(function (SiteContextType) {
    SiteContextType["LANGUAGE"] = "LANGUAGE";
    SiteContextType["CURRENCY"] = "CURRENCY";
})(SiteContextType || (SiteContextType = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LABELS = {
    [LANGUAGE_CONTEXT_ID]: 'Language',
    [CURRENCY_CONTEXT_ID]: 'Currency',
};
class SiteContextComponentService {
    constructor(componentData, contextServiceMap, injector) {
        this.componentData = componentData;
        this.contextServiceMap = contextServiceMap;
        this.injector = injector;
    }
    getItems(context) {
        return this.getService(context).pipe(switchMap$1((service) => service.getAll()), switchMap$1((items) => this.getContext(context).pipe(switchMap$1((ctx) => {
            const itemsCopy = [];
            for (const item of items) {
                itemsCopy.push({
                    ...item,
                    label: this.getOptionLabel(item, ctx),
                });
            }
            return of(itemsCopy);
        }))));
    }
    getActiveItem(context) {
        return this.getService(context).pipe(switchMap$1((service) => service.getActive()));
    }
    getLabel(context) {
        return this.getContext(context).pipe(map((ctx) => {
            if (ctx) {
                return LABELS[ctx];
            }
        }));
    }
    setActive(value, context) {
        this.getService(context)
            .pipe(take(1))
            .subscribe((service) => {
            service.setActive(value);
        });
    }
    getService(context) {
        return this.getContext(context).pipe(map((ctx) => ctx ? this.getInjectedService(ctx) : undefined), filter(isNotUndefined));
    }
    getContext(context) {
        if (context) {
            if (context === SiteContextType.CURRENCY) {
                return of(CURRENCY_CONTEXT_ID);
            }
            else if (context === SiteContextType.LANGUAGE) {
                return of(LANGUAGE_CONTEXT_ID);
            }
            else {
                return of(context);
            }
        }
        else if (this.componentData) {
            return this.componentData.data$.pipe(map((data) => data.context), map((ctx) => {
                switch (ctx) {
                    case 'LANGUAGE':
                        return LANGUAGE_CONTEXT_ID;
                    case 'CURRENCY':
                        return CURRENCY_CONTEXT_ID;
                    default:
                        return ctx;
                }
            }));
        }
        return of(undefined);
    }
    getInjectedService(context) {
        return this.injector.get(this.contextServiceMap[context], undefined);
    }
    getOptionLabel(item, context) {
        switch (context) {
            case LANGUAGE_CONTEXT_ID:
                return item.nativeName;
            case CURRENCY_CONTEXT_ID:
                return item.symbol + ' ' + item.isocode;
            default:
                return item.isocode;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteContextComponentService, deps: [{ token: CmsComponentData, optional: true }, { token: i1.ContextServiceMap }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteContextComponentService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteContextComponentService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: CmsComponentData, decorators: [{
                    type: Optional
                }] }, { type: i1.ContextServiceMap }, { type: i0.Injector }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SiteContextSelectorComponent {
    constructor(componentService) {
        this.componentService = componentService;
        this.iconTypes = ICON_TYPE;
        this.translationService = inject(TranslationService);
        useFeatureStyles('a11yShowDownArrowOnFocusedSelectMenu');
    }
    get items$() {
        return this.componentService.getItems(this.context);
    }
    get activeItem$() {
        return this.componentService.getActiveItem(this.context);
    }
    set active(value) {
        this.componentService.setActive(value, this.context);
    }
    get label$() {
        return this.componentService.getLabel(this.context);
    }
    ariaLabel$(label, index, length) {
        return this.translationService.translate('common.of').pipe(map$1((translation) => {
            return `${label}, ${index + 1} ${translation} ${length}`;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteContextSelectorComponent, deps: [{ token: SiteContextComponentService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: SiteContextSelectorComponent, isStandalone: false, selector: "cx-site-context-selector", inputs: { context: "context" }, ngImport: i0, template: "<label *ngIf=\"(items$ | async)?.length > 1 && (items$ | async) as items\">\n  <span>{{ label$ | async }}:</span>\n  <select (change)=\"active = $any($event).target.value\">\n    <option\n      [attr.aria-label]=\"ariaLabel$(item.label, i, items.length) | async\"\n      *ngFor=\"let item of items; index as i\"\n      value=\"{{ item.isocode }}\"\n      [selected]=\"(activeItem$ | async) === item.isocode\"\n    >\n      {{ item.label }}\n    </option>\n  </select>\n  <cx-icon\n    aria-hidden=\"true\"\n    [type]=\"iconTypes.CARET_DOWN\"\n    class=\"small\"\n  ></cx-icon>\n</label>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteContextSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-site-context-selector', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<label *ngIf=\"(items$ | async)?.length > 1 && (items$ | async) as items\">\n  <span>{{ label$ | async }}:</span>\n  <select (change)=\"active = $any($event).target.value\">\n    <option\n      [attr.aria-label]=\"ariaLabel$(item.label, i, items.length) | async\"\n      *ngFor=\"let item of items; index as i\"\n      value=\"{{ item.isocode }}\"\n      [selected]=\"(activeItem$ | async) === item.isocode\"\n    >\n      {{ item.label }}\n    </option>\n  </select>\n  <cx-icon\n    aria-hidden=\"true\"\n    [type]=\"iconTypes.CARET_DOWN\"\n    class=\"small\"\n  ></cx-icon>\n</label>\n" }]
        }], ctorParameters: () => [{ type: SiteContextComponentService }], propDecorators: { context: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LanguageCurrencyComponent {
    constructor() {
        this.siteContextType = SiteContextType;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LanguageCurrencyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: LanguageCurrencyComponent, isStandalone: false, selector: "cx-language-currency-selector", ngImport: i0, template: `
    <cx-site-context-selector
      [context]="siteContextType.LANGUAGE"
    ></cx-site-context-selector>
    <cx-site-context-selector
      [context]="siteContextType.CURRENCY"
    ></cx-site-context-selector>
  `, isInline: true, dependencies: [{ kind: "component", type: SiteContextSelectorComponent, selector: "cx-site-context-selector", inputs: ["context"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LanguageCurrencyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cx-language-currency-selector',
                    template: `
    <cx-site-context-selector
      [context]="siteContextType.LANGUAGE"
    ></cx-site-context-selector>
    <cx-site-context-selector
      [context]="siteContextType.CURRENCY"
    ></cx-site-context-selector>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: false,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SiteContextSelectorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteContextSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SiteContextSelectorModule, declarations: [SiteContextSelectorComponent, LanguageCurrencyComponent], imports: [CommonModule, RouterModule, SiteContextModule, IconModule], exports: [SiteContextSelectorComponent, LanguageCurrencyComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteContextSelectorModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    CMSSiteContextComponent: {
                        component: SiteContextSelectorComponent,
                        providers: [
                            {
                                provide: SiteContextComponentService,
                                useClass: SiteContextComponentService,
                                deps: [CmsComponentData, ContextServiceMap, Injector],
                            },
                        ],
                    },
                    LanguageCurrencyComponent: {
                        component: LanguageCurrencyComponent,
                    },
                },
            }),
            SiteContextComponentService,
        ], imports: [CommonModule, RouterModule, SiteContextModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteContextSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule, SiteContextModule, IconModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                CMSSiteContextComponent: {
                                    component: SiteContextSelectorComponent,
                                    providers: [
                                        {
                                            provide: SiteContextComponentService,
                                            useClass: SiteContextComponentService,
                                            deps: [CmsComponentData, ContextServiceMap, Injector],
                                        },
                                    ],
                                },
                                LanguageCurrencyComponent: {
                                    component: LanguageCurrencyComponent,
                                },
                            },
                        }),
                        SiteContextComponentService,
                    ],
                    declarations: [SiteContextSelectorComponent, LanguageCurrencyComponent],
                    exports: [SiteContextSelectorComponent, LanguageCurrencyComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SiteThemeSwitcherComponentService {
    constructor() {
        this.siteThemeService = inject(SiteThemeService);
    }
    getItems() {
        return this.siteThemeService.getAll();
    }
    getActiveItem() {
        return this.siteThemeService.getActive();
    }
    setActive(value) {
        this.siteThemeService.setActive(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherComponentService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherComponentService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherComponentService, decorators: [{
            type: Injectable
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Component for switching themes.
 */
class SiteThemeSwitcherComponent {
    constructor() {
        this.translationService = inject(TranslationService);
        this.iconTypes = ICON_TYPE;
        this.themeSwitcherComponentService = inject(SiteThemeSwitcherComponentService);
        useFeatureStyles('a11yShowDownArrowOnFocusedSelectMenu');
    }
    get items$() {
        return this.themeSwitcherComponentService.getItems();
    }
    get activeItem$() {
        return this.themeSwitcherComponentService.getActiveItem();
    }
    set activeItem(value) {
        this.themeSwitcherComponentService.setActive(value);
    }
    ariaLabel$(theme, index, length) {
        const themeTranslation$ = theme.i18nNameKey
            ? this.translationService.translate(theme.i18nNameKey)
            : of(theme.className);
        const ofTranslation$ = this.translationService.translate('common.of');
        return combineLatest([themeTranslation$, ofTranslation$]).pipe(take(1), map(([themeTranslation, ofTranslation]) => {
            return `${themeTranslation}, ${index + 1} ${ofTranslation} ${length}`;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: SiteThemeSwitcherComponent, isStandalone: false, selector: "cx-site-theme-switcher", ngImport: i0, template: "<label *ngIf=\"items$ | async as themes\">\n  <span> {{ 'siteThemeSwitcher.theme' | cxTranslate }}:</span>\n  <select (change)=\"activeItem = $any($event).target.value\">\n    <option\n      [attr.aria-label]=\"ariaLabel$(theme, i, themes.length) | async\"\n      *ngFor=\"let theme of themes; index as i\"\n      value=\"{{ theme.className }}\"\n      [selected]=\"(activeItem$ | async) === theme.className\"\n    >\n      {{\n        theme.i18nNameKey ? (theme.i18nNameKey | cxTranslate) : theme.className\n      }}\n    </option>\n  </select>\n  <cx-icon aria-hidden=\"true\" [type]=\"iconTypes.CARET_DOWN\" class=\"small\" />\n</label>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-site-theme-switcher', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<label *ngIf=\"items$ | async as themes\">\n  <span> {{ 'siteThemeSwitcher.theme' | cxTranslate }}:</span>\n  <select (change)=\"activeItem = $any($event).target.value\">\n    <option\n      [attr.aria-label]=\"ariaLabel$(theme, i, themes.length) | async\"\n      *ngFor=\"let theme of themes; index as i\"\n      value=\"{{ theme.className }}\"\n      [selected]=\"(activeItem$ | async) === theme.className\"\n    >\n      {{\n        theme.i18nNameKey ? (theme.i18nNameKey | cxTranslate) : theme.className\n      }}\n    </option>\n  </select>\n  <cx-icon aria-hidden=\"true\" [type]=\"iconTypes.CARET_DOWN\" class=\"small\" />\n</label>\n" }]
        }], ctorParameters: () => [] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SiteThemeSwitcherModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherModule, declarations: [SiteThemeSwitcherComponent], imports: [CommonModule, I18nModule, IconModule, SiteThemeModule], exports: [SiteThemeSwitcherComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    SiteThemeSwitcherComponent: {
                        component: SiteThemeSwitcherComponent,
                    },
                },
            }),
            SiteThemeSwitcherComponentService,
        ], imports: [CommonModule, I18nModule, IconModule, SiteThemeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SiteThemeSwitcherModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule, IconModule, SiteThemeModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                SiteThemeSwitcherComponent: {
                                    component: SiteThemeSwitcherComponent,
                                },
                            },
                        }),
                        SiteThemeSwitcherComponentService,
                    ],
                    declarations: [SiteThemeSwitcherComponent],
                    exports: [SiteThemeSwitcherComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Star rating component can be used to view existing ratings as well
 * as create new ratings. The component can be used for any ratings.
 */
class StarRatingComponent {
    constructor() {
        this.initialRate = 0;
        this.icon = ICON_TYPE.STAR;
        /**
         * The rating component can be used in disabled mode,
         * so that the interaction is not provided.
         *
         * Defaults to true.
         */
        this.disabled = true;
        /**
         * The rating is used to color the rating stars. It can have a
         * precise number. The rating number is used for a CSS custom property
         * (AKA css variable) value. The actually coloring is done in CSS.
         */
        this.rating = this.initialRate;
        /**
         * Emits the given rating when the user clicks on a star.
         */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        useFeatureStyles('reserveHorizontalSpaceStarRating');
    }
    setRate(value) {
        if (this.disabled) {
            return;
        }
        this.rating = value;
    }
    reset() {
        if (this.disabled) {
            return;
        }
        this.rating = this.initialRate ?? 0;
    }
    saveRate(rating) {
        if (this.disabled) {
            return;
        }
        this.initialRate = rating;
        this.setRate(rating);
        this.change.emit(rating);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StarRatingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: StarRatingComponent, isStandalone: false, selector: "cx-star-rating", inputs: { disabled: "disabled", rating: "rating" }, outputs: { change: "change" }, host: { listeners: { "mouseout": "reset()" }, properties: { "attr.disabled": "this.disabled", "style.--star-fill": "this.rating" } }, ngImport: i0, template: "<div\n  *ngIf=\"disabled; else starRating\"\n  role=\"img\"\n  [title]=\"\n    'productReview.ratedOutOf' | cxTranslate: { rating: rating.toFixed(1) }\n  \"\n  [attr.aria-label]=\"\n    'productReview.ratedOutOf' | cxTranslate: { rating: rating.toFixed(1) }\n  \"\n>\n  <ng-container *ngTemplateOutlet=\"starRating\"></ng-container>\n</div>\n\n<ng-template #starRating>\n  <cx-icon\n    *ngFor=\"let i of [1, 2, 3, 4, 5]\"\n    [type]=\"icon\"\n    class=\"star\"\n    (mouseover)=\"setRate(i)\"\n    (click)=\"saveRate(i)\"\n    (keydown.space)=\"saveRate(i)\"\n    [attr.aria-current]=\"!disabled && i === rating\"\n    [attr.tabindex]=\"disabled ? null : 0\"\n    [attr.role]=\"disabled ? null : 'button'\"\n    [attr.aria-label]=\"\n      !disabled ? ('productReview.addRate' | cxTranslate: { count: i }) : null\n    \"\n    [attr.aria-hidden]=\"disabled\"\n  ></cx-icon>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StarRatingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-star-rating', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div\n  *ngIf=\"disabled; else starRating\"\n  role=\"img\"\n  [title]=\"\n    'productReview.ratedOutOf' | cxTranslate: { rating: rating.toFixed(1) }\n  \"\n  [attr.aria-label]=\"\n    'productReview.ratedOutOf' | cxTranslate: { rating: rating.toFixed(1) }\n  \"\n>\n  <ng-container *ngTemplateOutlet=\"starRating\"></ng-container>\n</div>\n\n<ng-template #starRating>\n  <cx-icon\n    *ngFor=\"let i of [1, 2, 3, 4, 5]\"\n    [type]=\"icon\"\n    class=\"star\"\n    (mouseover)=\"setRate(i)\"\n    (click)=\"saveRate(i)\"\n    (keydown.space)=\"saveRate(i)\"\n    [attr.aria-current]=\"!disabled && i === rating\"\n    [attr.tabindex]=\"disabled ? null : 0\"\n    [attr.role]=\"disabled ? null : 'button'\"\n    [attr.aria-label]=\"\n      !disabled ? ('productReview.addRate' | cxTranslate: { count: i }) : null\n    \"\n    [attr.aria-hidden]=\"disabled\"\n  ></cx-icon>\n</ng-template>\n" }]
        }], ctorParameters: () => [], propDecorators: { disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.disabled']
            }], rating: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['style.--star-fill']
            }], change: [{
                type: Output
            }], reset: [{
                type: HostListener,
                args: ['mouseout']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StarRatingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StarRatingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: StarRatingModule, declarations: [StarRatingComponent], imports: [CommonModule, IconModule, I18nModule], exports: [StarRatingComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StarRatingModule, imports: [CommonModule, IconModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StarRatingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule, I18nModule],
                    declarations: [StarRatingComponent],
                    exports: [StarRatingComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TableDataCellComponent {
    constructor(outlet) {
        this.outlet = outlet;
    }
    get value() {
        return this.model[this.field];
    }
    get model() {
        return this.outlet?.context;
    }
    get field() {
        return this.outlet?.context?._field;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableDataCellComponent, deps: [{ token: OutletContextData }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: TableDataCellComponent, isStandalone: false, selector: "cx-table-data-cell", host: { properties: { "attr.title": "this.value" } }, ngImport: i0, template: `{{ value }}`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableDataCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cx-table-data-cell',
                    template: `{{ value }}`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: OutletContextData }], propDecorators: { value: [{
                type: HostBinding,
                args: ['attr.title']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TableHeaderCellComponent {
    constructor(outlet) {
        this.outlet = outlet;
    }
    /**
     * Returns the static label for the given field, if available.
     */
    get header() {
        if (typeof this.fieldOptions?.label === 'string') {
            return this.fieldOptions.label;
        }
    }
    /**
     * Returns the localized label for the given field.
     *
     * The localized label is either driven by the configured `label.i18nKey`
     * or concatenated by the table `type` and field `key`:
     *
     * `[tableType].[fieldKey]`
     *
     * The localized header can be translated with the `cxTranslate` pipe or `TranslationService`.
     */
    get localizedHeader() {
        return (this.fieldOptions?.label?.i18nKey ||
            `${this.i18nRoot}.${this.field}`);
    }
    get fieldOptions() {
        return this.outlet?.context._options?.cells?.[this.field];
    }
    get field() {
        return this.outlet?.context?._field;
    }
    get type() {
        return this.outlet?.context?._type;
    }
    get i18nRoot() {
        return this.outlet?.context?._i18nRoot;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableHeaderCellComponent, deps: [{ token: OutletContextData }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: TableHeaderCellComponent, isStandalone: false, selector: "cx-table-header-cell", ngImport: i0, template: `{{ header || (localizedHeader | cxTranslate) }}`, isInline: true, dependencies: [{ kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableHeaderCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cx-table-header-cell',
                    template: `{{ header || (localizedHeader | cxTranslate) }}`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: OutletContextData }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultTableConfig = {
    tableOptions: {
        headerComponent: TableHeaderCellComponent,
        dataComponent: TableDataCellComponent,
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `TableConfig` provides a table configurations for specific table types. You can define
 * an all-screen table structure as well as a breakpoint specific table structure. The various
 * table structures are merged from small to large screen configurations, depending on the users
 * screen size.
 *
 * The `table.type` is used as a key to distinguish the various table configurations in the application.
 */
class TableConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TableDataCellModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableDataCellModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TableDataCellModule, declarations: [TableDataCellComponent], imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableDataCellModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableDataCellModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [TableDataCellComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TableHeaderCellModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableHeaderCellModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TableHeaderCellModule, declarations: [TableHeaderCellComponent], imports: [CommonModule, I18nModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableHeaderCellModule, imports: [CommonModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableHeaderCellModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule],
                    declarations: [TableHeaderCellComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The table renderer service adds a component for each table cells (th and td)
 * based on a fine grained configuration. Each table type can configure both global
 * components for headers and cells as well as individual components for field
 * specific cells.
 *
 * The components are added to the outlet slots for the corresponding cells. The table
 * structure and data is added to the outlet context.
 */
class TableRendererService {
    constructor(outletService, componentFactoryResolver, config) {
        this.outletService = outletService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.config = config;
        // keep a list of outletRefs to avoid recreation
        this.outletRefs = new Map();
    }
    /**
     * Adds the configured table component for the header and data.
     */
    add(structure) {
        structure?.cells?.forEach((field) => {
            const thRenderer = this.getHeaderRenderer(structure, field);
            if (thRenderer) {
                const ref = this.getHeaderOutletRef(structure.type, field);
                this.render(ref, thRenderer);
            }
            const tdRenderer = this.getDataRenderer(structure, field);
            if (tdRenderer) {
                const ref = this.getDataOutletRef(structure.type, field);
                this.render(ref, tdRenderer);
            }
        });
    }
    render(outletRef, renderer) {
        if (this.outletRefs.has(outletRef)) {
            return;
        }
        this.outletRefs.set(outletRef, true);
        const template = this.componentFactoryResolver.resolveComponentFactory(renderer);
        this.outletService.add(outletRef, template);
    }
    /**
     * Returns the header render component for the given field.
     */
    getHeaderRenderer(structure, field) {
        return (structure.options?.cells?.[field]?.headerComponent ||
            structure.options?.headerComponent ||
            this.config.tableOptions?.headerComponent);
    }
    /**
     * Returns the data render component for the given field.
     */
    getDataRenderer(structure, field) {
        return (structure.options?.cells?.[field]?.dataComponent ||
            structure.options?.dataComponent ||
            this.config.tableOptions?.dataComponent);
    }
    /**
     * Returns the header (th) outlet reference for the given field.
     *
     * The outlet reference is generated as:
     * `table.[tableType].header.[field]`
     */
    getHeaderOutletRef(type, field) {
        return `table.${type}.header.${field}`;
    }
    /**
     * Returns the header (th) outlet context for the given field.
     */
    getHeaderOutletContext(type, options, i18nRoot, field) {
        return {
            _type: type,
            _options: options,
            _field: field,
            _i18nRoot: i18nRoot,
        };
    }
    /**
     * Returns the data (td) outlet reference for the given field.
     *
     * The field is generated as:
     * `table.[tableType].data.[tableField]`
     */
    getDataOutletRef(type, field) {
        return `table.${type}.data.${field}`;
    }
    /**
     * Returns the data (td) outlet context for the given field.
     */
    getDataOutletContext(type, options, i18nRoot, field, data) {
        return {
            ...data,
            _type: type,
            _options: options,
            _field: field,
            _i18nRoot: i18nRoot,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableRendererService, deps: [{ token: OutletService }, { token: i0.ComponentFactoryResolver }, { token: TableConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableRendererService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableRendererService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: OutletService }, { type: i0.ComponentFactoryResolver }, { type: TableConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Layout orientation for the table configuration.
 */
var TableLayout;
(function (TableLayout) {
    /**
     * Renders the table vertically, with a heading on top of the table.
     *
     * Vertical layout is most common and the default layout.
     */
    TableLayout[TableLayout["VERTICAL"] = 1] = "VERTICAL";
    /**
     * Stacks items in a tables by generating a `tbody` for each item.
     */
    TableLayout[TableLayout["VERTICAL_STACKED"] = 2] = "VERTICAL_STACKED";
    /**
     * Horizontal oriented table layout renders the table headers in the first column of the table.
     */
    TableLayout[TableLayout["HORIZONTAL"] = 3] = "HORIZONTAL";
})(TableLayout || (TableLayout = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The table component provides a generic table DOM structure, with 3 layout types:
 * horizontal, vertical and _stacked vertical_ layout. The layout is driven by the
 * table structure.
 *
 * The implementation is fairly "dumb" and only renders string based content for TH
 * and TD elements. The actual cell rendering is delegated to a (configurable) cell
 * component. Additionally, each cell is registered as an outlet, so that customizations
 * can be done by both outlet templates and components.
 *
 * The outlet references are concatenated from the table `type` and header `key`. The
 * following snippet shows an outlet generated for a table header, for the table type
 * "cost-center" with a header key "name":
 *
 * ```
 * <th>
 *   <template cxOutlet="table.cost-center.header.name">
 *   </template>
 * </th>
 * ```
 *
 * Similarly, the data cells (`<td>`) are generated with the outlet template reference
 * `table.cost-center.data.name`.
 */
class TableComponent {
    set structure(structure) {
        this._structure = structure;
        this.init();
    }
    get structure() {
        return this._structure;
    }
    constructor(rendererService) {
        this.rendererService = rendererService;
        this.launch = new EventEmitter();
    }
    init() {
        this.verticalLayout = !this.layout || this.layout === TableLayout.VERTICAL;
        this.verticalStackedLayout = this.layout === TableLayout.VERTICAL_STACKED;
        this.horizontalLayout = this.layout === TableLayout.HORIZONTAL;
        this.rendererService.add(this.structure);
        this.addTableDebugInfo();
    }
    launchItem(item) {
        this.launch.emit(item);
    }
    /**
     * Indicates whether the given item is the current item.
     *
     * The current item is driven by the `currentItem`, that holds a
     * property and value to compare.
     */
    isCurrentItem(item) {
        if (!this.currentItem || !this.currentItem.value) {
            return false;
        }
        return this.currentItem?.value === item?.[this.currentItem?.property];
    }
    /**
     * Returns the header (th) outlet reference for the given field.
     */
    getHeaderOutletRef(field) {
        return this.rendererService.getHeaderOutletRef(this.type, field);
    }
    /**
     * Returns the header (th) outlet context for the given field.
     */
    getHeaderOutletContext(field) {
        return this.rendererService.getHeaderOutletContext(this.type, this.options, this.i18nRoot, field);
    }
    /**
     * Returns the data (td) outlet reference for the given field.
     */
    getDataOutletRef(field) {
        return this.rendererService.getDataOutletRef(this.type, field);
    }
    /**
     * Returns the data (td) outlet context for the given field.
     */
    getDataOutletContext(field, data) {
        return this.rendererService.getDataOutletContext(this.type, this.options, this.i18nRoot, field, data);
    }
    trackData(_i, item) {
        return JSON.stringify(item);
    }
    /**
     * Generates the table type into the UI in devMode, so that developers
     * can easily get the notion of the table type.
     */
    addTableDebugInfo() {
        if (isDevMode() && this.type) {
            this.tableType = this.type;
        }
    }
    /**
     * Helper method to return the deeply nested orientation configuration.
     */
    get layout() {
        return this.structure?.options?.layout;
    }
    /**
     * Helper method to return the deeply nested type.
     */
    get type() {
        return this.structure?.type;
    }
    get options() {
        return this.structure?.options;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableComponent, deps: [{ token: TableRendererService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: TableComponent, isStandalone: false, selector: "cx-table", inputs: { structure: "structure", data: "data", i18nRoot: "i18nRoot", currentItem: "currentItem" }, outputs: { launch: "launch" }, host: { properties: { "attr.__cx-table-type": "this.tableType", "class.horizontal": "this.horizontalLayout", "class.vertical": "this.verticalLayout", "class.vertical-stacked": "this.verticalStackedLayout" } }, ngImport: i0, template: "<table *ngIf=\"structure\">\n  <ng-container *ngIf=\"verticalStackedLayout\">\n    <tbody\n      *ngFor=\"let item of data; trackBy: trackData\"\n      (click)=\"launchItem(item)\"\n      [class.is-current]=\"isCurrentItem(item)\"\n    >\n      <tr *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n        <th>\n          <ng-template\n            [cxOutlet]=\"getHeaderOutletRef(cell)\"\n            [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n          >\n            {{ cell }}\n          </ng-template>\n        </th>\n        <td>\n          <ng-template\n            [cxOutlet]=\"getDataOutletRef(cell)\"\n            [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n          >\n            {{ $any(item)[cell] }}\n          </ng-template>\n        </td>\n      </tr>\n    </tbody>\n  </ng-container>\n\n  <!-- vertical tables render the item  -->\n  <ng-container *ngIf=\"verticalLayout\">\n    <thead>\n      <tr>\n        <th scope=\"col\" *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n          <ng-template\n            [cxOutlet]=\"getHeaderOutletRef(cell)\"\n            [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n          >\n            {{ cell }}\n          </ng-template>\n        </th>\n      </tr>\n    </thead>\n\n    <tr\n      *ngFor=\"let item of data; trackBy: trackData\"\n      [class.is-current]=\"isCurrentItem(item)\"\n      (click)=\"launchItem(item)\"\n    >\n      <td *ngFor=\"let cell of structure.cells; let i = index\" [class]=\"cell\">\n        <ng-template\n          [cxOutlet]=\"getDataOutletRef(cell)\"\n          [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n        >\n          {{ $any(item)[cell] }}\n        </ng-template>\n      </td>\n    </tr>\n  </ng-container>\n\n  <ng-container *ngIf=\"horizontalLayout\">\n    <tr *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n      <th scope=\"col\">\n        <ng-template\n          [cxOutlet]=\"getHeaderOutletRef(cell)\"\n          [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n        >\n          {{ cell }}\n        </ng-template>\n      </th>\n      <td\n        *ngFor=\"let item of data; trackBy: trackData\"\n        [class.is-current]=\"isCurrentItem(item)\"\n        (click)=\"launchItem(item)\"\n      >\n        <ng-template\n          [cxOutlet]=\"getDataOutletRef(cell)\"\n          [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n        >\n          {{ $any(item)[cell] }}\n        </ng-template>\n      </td>\n    </tr>\n  </ng-container>\n</table>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<table *ngIf=\"structure\">\n  <ng-container *ngIf=\"verticalStackedLayout\">\n    <tbody\n      *ngFor=\"let item of data; trackBy: trackData\"\n      (click)=\"launchItem(item)\"\n      [class.is-current]=\"isCurrentItem(item)\"\n    >\n      <tr *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n        <th>\n          <ng-template\n            [cxOutlet]=\"getHeaderOutletRef(cell)\"\n            [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n          >\n            {{ cell }}\n          </ng-template>\n        </th>\n        <td>\n          <ng-template\n            [cxOutlet]=\"getDataOutletRef(cell)\"\n            [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n          >\n            {{ $any(item)[cell] }}\n          </ng-template>\n        </td>\n      </tr>\n    </tbody>\n  </ng-container>\n\n  <!-- vertical tables render the item  -->\n  <ng-container *ngIf=\"verticalLayout\">\n    <thead>\n      <tr>\n        <th scope=\"col\" *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n          <ng-template\n            [cxOutlet]=\"getHeaderOutletRef(cell)\"\n            [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n          >\n            {{ cell }}\n          </ng-template>\n        </th>\n      </tr>\n    </thead>\n\n    <tr\n      *ngFor=\"let item of data; trackBy: trackData\"\n      [class.is-current]=\"isCurrentItem(item)\"\n      (click)=\"launchItem(item)\"\n    >\n      <td *ngFor=\"let cell of structure.cells; let i = index\" [class]=\"cell\">\n        <ng-template\n          [cxOutlet]=\"getDataOutletRef(cell)\"\n          [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n        >\n          {{ $any(item)[cell] }}\n        </ng-template>\n      </td>\n    </tr>\n  </ng-container>\n\n  <ng-container *ngIf=\"horizontalLayout\">\n    <tr *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n      <th scope=\"col\">\n        <ng-template\n          [cxOutlet]=\"getHeaderOutletRef(cell)\"\n          [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n        >\n          {{ cell }}\n        </ng-template>\n      </th>\n      <td\n        *ngFor=\"let item of data; trackBy: trackData\"\n        [class.is-current]=\"isCurrentItem(item)\"\n        (click)=\"launchItem(item)\"\n      >\n        <ng-template\n          [cxOutlet]=\"getDataOutletRef(cell)\"\n          [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n        >\n          {{ $any(item)[cell] }}\n        </ng-template>\n      </td>\n    </tr>\n  </ng-container>\n</table>\n" }]
        }], ctorParameters: () => [{ type: TableRendererService }], propDecorators: { tableType: [{
                type: HostBinding,
                args: ['attr.__cx-table-type']
            }], horizontalLayout: [{
                type: HostBinding,
                args: ['class.horizontal']
            }], verticalLayout: [{
                type: HostBinding,
                args: ['class.vertical']
            }], verticalStackedLayout: [{
                type: HostBinding,
                args: ['class.vertical-stacked']
            }], structure: [{
                type: Input
            }], data: [{
                type: Input
            }], i18nRoot: [{
                type: Input
            }], currentItem: [{
                type: Input
            }], launch: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The TableModule provides a table component that is driven by (responsible) configuration.
 */
class TableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TableModule, declarations: [TableComponent], imports: [CommonModule,
            OutletModule,
            TableHeaderCellModule,
            TableDataCellModule], exports: [TableComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableModule, providers: [provideDefaultConfig(defaultTableConfig)], imports: [CommonModule,
            OutletModule,
            TableHeaderCellModule,
            TableDataCellModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        OutletModule,
                        TableHeaderCellModule,
                        TableDataCellModule,
                    ],
                    declarations: [TableComponent],
                    exports: [TableComponent],
                    providers: [provideDefaultConfig(defaultTableConfig)],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Responsive table service.
 *
 * The `TableService` is used to build a `TableStructure` by configuration. The configuration
 * allows for breakpoint specific configuration, so that the table can differentiate for
 * various screen sizes.
 *
 * While there are some global options, the configuration is mainly driven by the table _type_.
 *
 * If there is no table configuration for the given type found, a table header structure
 * is generated based on the actual data (if available) or randomly by generating 5 random headers.
 */
class TableService {
    constructor(breakpointService, config) {
        this.breakpointService = breakpointService;
        this.config = config;
        this.logger = inject(LoggerService);
    }
    /**
     * Builds the table structure.
     *
     * @param tableType The table type is used  to find the specific table configuration.
     * @param defaultStructure (optional) Default table structure that contains fallback options. More specific options are merged with the default structure.
     * @param data$ (optional) The actual data can be passed in to generate the table structure based on actual data.
     */
    buildStructure(tableType, defaultStructure) {
        if (this.hasTableConfig(tableType)) {
            return this.buildStructureFromConfig(tableType, defaultStructure);
        }
        else {
            return this.buildRandomStructure(tableType);
        }
    }
    /**
     * Returns the table structure by configuration. The configuration can be
     * breakpoint-driven, which means that an alternative header structure can
     * be created per screen size.
     *
     * The breakpoint is resolved by teh `BreakpointService`.
     */
    buildStructureFromConfig(type, defaultStructure) {
        return this.breakpointService.breakpoint$.pipe(map((breakpoint) => ({
            ...this.getTableConfig(type, breakpoint, defaultStructure),
            type,
        })));
    }
    /**
     * Finds all applicable table configuration for the given type and breakpoint.
     * The default table configuration is merged with all relevant breakpoint
     * configurations.
     *
     * This allows to have some default configurations that apply to all screens, and
     * add configuration options for some screens.
     */
    getTableConfig(type, breakpoint, defaultStructure) {
        if (!this.config.table?.[type]) {
            return null;
        }
        const relevant = this.findRelevantBreakpoints(breakpoint);
        const closestBreakpoint = [...relevant]
            .reverse()
            .find((br) => !!this.config.table?.[type][br]?.cells);
        const cells = (closestBreakpoint &&
            this.config.table[type][closestBreakpoint]?.cells) ||
            this.config.table[type].cells ||
            defaultStructure?.cells;
        // add all default table configurations
        let options = {
            ...defaultStructure?.options,
            ...this.config.table[type].options,
        };
        // We merge all table options for smaller breakpoints into the global
        // options, so we inherit options.
        relevant.forEach((br) => {
            options = {
                ...options,
                ...defaultStructure?.[br]?.options,
                ...this.config.table?.[type]?.[br]?.options,
            };
        });
        return { cells, options };
    }
    /**
     * Generates the table structure by the help of the first data row.
     */
    buildStructureFromData(type, data$) {
        this.logWarning(`No table configuration found to render table with type "${type}". The table header for "${type}" is generated by the help of the first data item`);
        return data$.pipe(map((data) => {
            const cells = Object.keys(data?.[0]).map((key) => key);
            return { type, cells };
        }));
    }
    /**
     * As a last resort, the table structure is randomly created. The random structure
     * contains 5 headers, so that some of the unknown data is visualized.
     */
    buildRandomStructure(type) {
        this.logWarning(`No data available for "${type}", a random structure is generated (with hidden table headers).`);
        return of({
            type,
            cells: ['unknown', 'unknown', 'unknown', 'unknown', 'unknown'],
        });
    }
    /**
     * Finds all the breakpoints can contribute to the table configuration, from small
     * to current.
     *
     * For example, if the current breakpoint is `MD`, this returns `[XS, SM, MD]`.
     */
    findRelevantBreakpoints(breakpoint) {
        const current = this.breakpointService.breakpoints.indexOf(breakpoint);
        return this.breakpointService.breakpoints.slice(0, current + 1);
    }
    /**
     * Indicates if the there is a configuration for the table available.
     */
    hasTableConfig(tableType) {
        return !!this.config.table?.[tableType];
    }
    /**
     * Logs a message in the console to increase developer experience.
     *
     * The message is only logged in dev mode.
     */
    logWarning(message) {
        if (isDevMode()) {
            this.logger.warn(message);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableService, deps: [{ token: BreakpointService }, { token: TableConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TableService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: BreakpointService }, { type: TableConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Configuration for the frontend: This class defines how to render the captcha component
 * and obtain the appropriate token.
 *
 * @property {Type<CaptchaRenderer>} - An implementation of the CaptchaRenderer
 * interface that renders the UI and interacts with the user.
 * @property {string} [apiUrl] - An optional parameter specifying the API endpoint for captcha validation.
 * @property {Object} [fields] - An optional parameter that holds additional fields needed for the captcha configuration.
 */
class CaptchaApiConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaApiConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaApiConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaApiConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CaptchaComponent {
    constructor(config, injector) {
        this.config = config;
        this.injector = injector;
        // Emits true if user confirms captcha
        this.confirmed = new EventEmitter();
        this.subscription = new Subscription();
    }
    /**
     * Add fields from CaptchaApiConfig. Call backend to get captcha
     * config.
     */
    ngAfterViewInit() {
        if (this.config?.captchaRenderer) {
            const captchaRenderer = this.injector.get(this.config.captchaRenderer);
            this.subscription.add(captchaRenderer
                .getCaptchaConfig()
                .pipe(concatMap((captchaConfig) => {
                if (captchaConfig?.enabled) {
                    return captchaRenderer.renderCaptcha({
                        element: this.captchaRef.nativeElement,
                    });
                }
                else {
                    return of(null);
                }
            }))
                .subscribe(() => {
                this.confirmed.emit(true);
            }));
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaComponent, deps: [{ token: CaptchaApiConfig }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: CaptchaComponent, isStandalone: false, selector: "cx-captcha", outputs: { confirmed: "confirmed" }, viewQueries: [{ propertyName: "captchaRef", first: true, predicate: ["captcha"], descendants: true }], ngImport: i0, template: "<div #captcha></div>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-captcha', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div #captcha></div>\n" }]
        }], ctorParameters: () => [{ type: CaptchaApiConfig }, { type: i0.Injector }], propDecorators: { confirmed: [{
                type: Output
            }], captchaRef: [{
                type: ViewChild,
                args: ['captcha', { static: false }]
            }] } });

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CaptchaService {
    constructor(adapter, apiConfig, languageService, scriptLoader, baseSiteService) {
        this.adapter = adapter;
        this.apiConfig = apiConfig;
        this.languageService = languageService;
        this.scriptLoader = scriptLoader;
        this.baseSiteService = baseSiteService;
        this.subscription = new Subscription();
        this.captchaConfigSubject$ = new ReplaySubject(1);
        this.initialize();
    }
    /**
     * Retrieve captcha configuration from the backend, and if enabled
     * call @function loadScript with active language
     */
    initialize() {
        this.subscription.add(this.fetchCaptchaConfigFromServer().subscribe((config) => {
            if (config?.enabled) {
                this.captchaConfig = config;
                this.loadResource();
            }
            else {
                this.captchaConfigSubject$.next({ enabled: false });
            }
        }));
    }
    fetchCaptchaConfigFromServer() {
        return forkJoin([
            this.languageService.getActive().pipe(take(1)),
            this.baseSiteService.getActive().pipe(concatMap((value) => this.adapter.loadBaseSite(value)), take(1)),
        ]).pipe(map$1((result) => result[1]?.captchaConfig));
    }
    getCaptchaConfig() {
        return this.captchaConfigSubject$.asObservable();
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    getToken() {
        return this.token;
    }
    /**
     * Load external resource if needed with dependencies to be added to <head>.
     * @param - Language and configuration read from server
     */
    loadResource() {
        this.captchaConfigSubject$.next(this.captchaConfig);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaService, deps: [{ token: i1.SiteAdapter }, { token: CaptchaApiConfig }, { token: i1.LanguageService }, { token: i1.ScriptLoader }, { token: i1.BaseSiteService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.SiteAdapter }, { type: CaptchaApiConfig }, { type: i1.LanguageService }, { type: i1.ScriptLoader }, { type: i1.BaseSiteService }] });

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MockCaptchaService extends CaptchaService {
    initialize() {
        super.initialize();
        // creating mock elements for captcha.
        this.container = document.createElement('div');
        this.container.className = 'form-check';
        this.checkbox = document.createElement('input');
        this.checkbox.type = 'checkbox';
        this.checkbox.className = 'mock-captcha';
        this.label = document.createElement('label');
        this.label.textContent = "I'm not a robot";
        this.container.appendChild(this.checkbox);
        this.container.appendChild(this.label);
        this.spinner = document.createElement('icon');
        this.spinner.className = 'fa-solid fa-spinner';
        this.checkbox.addEventListener('change', this.onCheckBoxClicked.bind(this));
    }
    onCheckBoxClicked() {
        this.label.textContent = '';
        this.container.appendChild(this.spinner);
        this.checkbox.disabled = true;
        this.checkbox.checked = true;
        setTimeout(() => {
            this.container.removeChild(this.spinner);
            this.retVal.next('succeed');
            this.retVal.complete();
            this.token = 'myToken';
            this.label.textContent = 'Verified';
        }, 500);
    }
    /**
     * Add element to page.
     * @param {HTMLElement} element - HTML element to render captcha widget within.
     */
    renderCaptcha(renderParams) {
        if (renderParams.element instanceof HTMLElement) {
            // Reset checkbox state before rendering
            this.checkbox.disabled = false;
            this.checkbox.checked = false;
            this.label.textContent = "I'm not a robot";
            this.token = '';
            this.retVal = new Subject();
            renderParams.element.appendChild(this.container);
        }
        return this.retVal.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MockCaptchaService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MockCaptchaService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MockCaptchaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const MockCaptchaApiConfig = {
    captchaRenderer: MockCaptchaService,
};

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CaptchaModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: CaptchaModule, declarations: [CaptchaComponent], imports: [CommonModule, ReactiveFormsModule, FormErrorsModule], exports: [CaptchaComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaModule, providers: [provideDefaultConfig(MockCaptchaApiConfig)], imports: [CommonModule, ReactiveFormsModule, FormErrorsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CaptchaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ReactiveFormsModule, FormErrorsModule],
                    declarations: [CaptchaComponent],
                    providers: [provideDefaultConfig(MockCaptchaApiConfig)],
                    exports: [CaptchaComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FilesFormValidators {
    constructor() {
        this.CONVERT_TO_MB = 1000000;
        this.extenstionRegEx = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    }
    /**
     * Checks max size of file
     *
     * @param {number} maxSize Max size [MB]
     * @returns Uses 'tooLarge' validator error with maxSize property
     * @memberOf FilesFormValidators
     */
    maxSize(maxSize) {
        return (control) => {
            const errors = {};
            if (maxSize && control.value) {
                const files = Array.from(control.value);
                files.forEach(({ size, name }) => {
                    if (size > maxSize * this.CONVERT_TO_MB) {
                        const invalidFiles = errors.tooLarge?.invalidFiles ?? [];
                        errors.tooLarge = {
                            maxSize,
                            invalidFiles: [...invalidFiles, name],
                        };
                    }
                });
            }
            return Object.keys(errors).length === 0 ? null : errors;
        };
    }
    /**
     * Checks maximum entries
     *
     * @param {number} maxEntries Max number of entries
     * @returns Uses 'tooManyEntries' validator error with maxEntries property
     * @memberOf FilesFormValidators
     */
    maxEntries(maxEntries) {
        return (control) => {
            const errors = {};
            if (maxEntries && control.value) {
                const files = Array.from(control.value);
                if (files.length > maxEntries) {
                    errors.tooManyEntries = { maxEntries };
                }
            }
            return Object.keys(errors).length === 0 ? null : errors;
        };
    }
    /**
     * Checks allowed types
     *
     * @param {Array<string>} allowedTypes Allowed types of files
     * @returns Uses 'notParsable' validator error with allowedTypes property
     * @memberOf FilesFormValidators
     */
    allowedTypes(allowedTypes) {
        return (control) => {
            const errors = {};
            if (allowedTypes && control.value) {
                const files = Array.from(control.value);
                errors.fileNotAllowed = files.some(({ name }) => !allowedTypes.includes(this.getExtension(name)));
            }
            return errors[Object.keys(errors)?.[0]] ? errors : null;
        };
    }
    getExtension(filename) {
        return (filename?.match(this.extenstionRegEx) || [])[0] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FilesFormValidators, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FilesFormValidators, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FilesFormValidators, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AvatarComponent {
    constructor() {
        this.iconTypes = ICON_TYPE;
    }
    getInitials(author) {
        return author
            .split(' ')
            .map((string) => string[0])
            .join('');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: AvatarComponent, isStandalone: false, selector: "cx-avatar", inputs: { message: "message" }, ngImport: i0, template: "<div\n  *ngIf=\"message\"\n  class=\"cx-avatar\"\n  [ngClass]=\"{ 'right-align': message.rightAlign }\"\n>\n  <span *ngIf=\"!message.rightAlign && message?.author\">\n    {{ getInitials(message?.author || '') }}\n  </span>\n\n  <cx-icon\n    *ngIf=\"!message.rightAlign && !message?.author\"\n    [type]=\"iconTypes.USER\"\n  ></cx-icon>\n\n  <cx-icon *ngIf=\"message.rightAlign\" [type]=\"iconTypes.HEADSET\"></cx-icon>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-avatar', standalone: false, template: "<div\n  *ngIf=\"message\"\n  class=\"cx-avatar\"\n  [ngClass]=\"{ 'right-align': message.rightAlign }\"\n>\n  <span *ngIf=\"!message.rightAlign && message?.author\">\n    {{ getInitials(message?.author || '') }}\n  </span>\n\n  <cx-icon\n    *ngIf=\"!message.rightAlign && !message?.author\"\n    [type]=\"iconTypes.USER\"\n  ></cx-icon>\n\n  <cx-icon *ngIf=\"message.rightAlign\" [type]=\"iconTypes.HEADSET\"></cx-icon>\n</div>\n" }]
        }], propDecorators: { message: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MessagingComponent {
    get inputCharacterLeft() {
        return ((this.messagingConfigs?.charactersLimit || this.MAX_INPUT_CHARACTERS) -
            (this.form.get('message')?.value?.length || 0));
    }
    get maxSize() {
        return (this.messagingConfigs?.attachmentRestrictions?.maxSize || this.MAX_SIZE);
    }
    get maxEntries() {
        return (this.messagingConfigs?.attachmentRestrictions?.maxEntries ||
            this.MAX_ENTRIES);
    }
    get allowedTypes() {
        return this.messagingConfigs?.attachmentRestrictions?.allowedTypes || [];
    }
    constructor(windowRef, filesFormValidators) {
        this.windowRef = windowRef;
        this.filesFormValidators = filesFormValidators;
        this.scrollToInput = true;
        this.send = new EventEmitter();
        this.itemClicked = new EventEmitter();
        this.downloadAttachment = new EventEmitter();
        this.iconTypes = ICON_TYPE;
        this.MAX_INPUT_CHARACTERS = 2000;
        this.MAX_SIZE = 10;
        this.MAX_ENTRIES = 1;
        this.dateFormat = 'MMMM d, YYYY h:mm aa';
        this.scrollOnceOnLoad = true;
        useFeatureStyles('a11yCroppedFocusRing');
    }
    ngOnInit() {
        this.buildForm();
    }
    ngAfterViewChecked() {
        if (this.scrollToInput) {
            this.observeScroll();
            if (this.scrollOnceOnLoad) {
                this.scrollOnLoad();
            }
        }
    }
    onSend() {
        if (this.form.valid) {
            const event = {
                files: this.form.get('file')?.value,
                message: this.form.get('message')?.value,
            };
            const itemId = this.form.get('item')?.value;
            if (itemId) {
                event.itemId = itemId;
            }
            this.send.emit(event);
        }
    }
    resetForm() {
        this.form.reset({ item: this.messagingConfigs?.defaultItemId });
        this.fileUploadComponent?.removeFile();
    }
    triggerDownload(messageCode, attachmentId, fileName) {
        this.downloadAttachment.emit({
            messageCode: messageCode,
            attachmentId: attachmentId,
            fileName: fileName,
        });
    }
    buildForm() {
        const form = new UntypedFormGroup({});
        form.setControl('message', new UntypedFormControl('', [
            Validators.required,
            Validators.maxLength(this.messagingConfigs?.charactersLimit || this.MAX_INPUT_CHARACTERS),
        ]));
        form.setControl('file', new UntypedFormControl('', [
            this.filesFormValidators.maxSize(this.maxSize),
            this.filesFormValidators.maxEntries(this.maxEntries),
            this.filesFormValidators.allowedTypes(this.allowedTypes),
        ]));
        form.setControl('item', new UntypedFormControl(this.messagingConfigs?.defaultItemId));
        this.form = form;
    }
    focusNextChild(event) {
        event.preventDefault();
        const [results, focusedIndex] = [
            this.getResultElements(),
            this.getFocusedIndex(),
        ];
        if (results.length) {
            if (focusedIndex >= results.length - 1) {
                results[0].focus();
            }
            else {
                results[focusedIndex + 1].focus();
            }
        }
    }
    focusPreviousChild(event) {
        if (!this.windowRef.isBrowser()) {
            return;
        }
        event.preventDefault();
        const [results, focusedIndex] = [
            this.getResultElements(),
            this.getFocusedIndex(),
        ];
        if (results.length) {
            if (focusedIndex < 1) {
                results[results.length - 1].focus();
            }
            else {
                results[focusedIndex - 1].focus();
            }
        }
    }
    /**
     * A message can be linked to an item. In this case the item name will be prefixed to the message text.
     *
     * @param {MessageEvent} message message
     * @returns {string | undefined} message text prefixed with item name, in case its given.
     */
    getMessageText(message) {
        return message.item
            ? message.item.name + ': ' + message.text
            : message.text;
    }
    onItemClicked(item) {
        this.itemClicked.emit({
            item: item,
        });
    }
    observeScroll() {
        const element = this.windowRef.document.querySelector('.cx-messages');
        if (element) {
            const resizeObserver = new ResizeObserver((entries) => {
                this.scrollToBottom(element, entries[0].target.scrollHeight);
                this.updatedScrollHeight = entries[0].target.scrollHeight;
            });
            resizeObserver.observe(element);
        }
    }
    scrollToBottom(element, previousScrollHeight) {
        if (this.heightChanged(previousScrollHeight)) {
            element?.scroll({
                top: element?.scrollHeight,
                behavior: 'auto',
            });
        }
    }
    heightChanged(previousScrollHeight) {
        return this.updatedScrollHeight !== previousScrollHeight;
    }
    scrollOnLoad() {
        const element = this.windowRef.document.getElementById('cx-message-footer');
        const resizeObserver = new ResizeObserver(() => {
            element?.scrollIntoView({ behavior: 'auto', block: 'end' });
            this.scrollOnceOnLoad = false;
        });
        if (element) {
            resizeObserver.observe(element);
        }
    }
    getResultElements() {
        return Array.from(this.windowRef.document.querySelectorAll('[role="listitem"]'));
    }
    getFocusedIndex() {
        return this.getResultElements().indexOf(this.getFocusedElement());
    }
    getFocusedElement() {
        return this.windowRef.document.activeElement;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MessagingComponent, deps: [{ token: i1.WindowRef }, { token: FilesFormValidators }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MessagingComponent, isStandalone: false, selector: "cx-messaging", inputs: { messageEvents$: "messageEvents$", scrollToInput: "scrollToInput", messagingConfigs: "messagingConfigs" }, outputs: { send: "send", itemClicked: "itemClicked", downloadAttachment: "downloadAttachment" }, viewQueries: [{ propertyName: "fileUploadComponent", first: true, predicate: FileUploadComponent, descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"messageEvents$ | async as messageEvents\">\n  <div class=\"container\">\n    <div class=\"cx-avatar-line\"></div>\n    <div\n      role=\"list\"\n      class=\"cx-messages\"\n      id=\"cx-messages\"\n      (keydown.arrowdown)=\"focusNextChild($any($event))\"\n      (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n      [attr.aria-label]=\"'chatMessaging.messages' | cxTranslate\"\n    >\n      <ng-container *ngFor=\"let message of messageEvents; let i = index\">\n        <div\n          class=\"cx-message-card\"\n          role=\"listitem\"\n          [ngClass]=\"{ 'cx-message-display': message.rightAlign ?? false }\"\n        >\n          <cx-avatar [message]=\"message\"> </cx-avatar>\n\n          <div>\n            <label>{{\n              (message.createdAt | cxDate: messagingConfigs?.dateFormat) ??\n                dateFormat\n            }}</label>\n            <div\n              [ngClass]=\"\n                (message.rightAlign ?? false)\n                  ? 'cx-message-right-align-text'\n                  : 'cx-message-left-align-text'\n              \"\n              [tabindex]=\"i ? -1 : 0\"\n              [attr.aria-label]=\"\n                'chatMessaging.informationLabel'\n                  | cxTranslate\n                    : {\n                        author: message.author,\n                        text: getMessageText(message),\n                        date:\n                          (message.createdAt\n                            | cxDate: messagingConfigs?.dateFormat) ??\n                          dateFormat,\n                      }\n              \"\n            >\n              <a\n                *ngIf=\"message.item\"\n                class=\"cx-message-item-link\"\n                (click)=\"onItemClicked(message.item)\"\n                >{{ message.item.name }}:</a\n              >\n              {{ message.text }}\n            </div>\n            <a\n              *ngFor=\"let attachment of message.attachments ?? []\"\n              class=\"cx-attachment\"\n              (click)=\"\n                triggerDownload(\n                  message.code,\n                  attachment.id,\n                  attachment.filename\n                )\n              \"\n              target=\"_blank\"\n              rel=\"noopener noreferrer\"\n            >\n              <cx-icon [type]=\"iconTypes.ATTACHMENT\"></cx-icon>\n              {{ attachment.filename }}\n            </a>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n\n  <div\n    [formGroup]=\"form\"\n    class=\"cx-message-footer\"\n    *ngIf=\"messagingConfigs?.displayAddMessageSection | async\"\n  >\n    <div class=\"cx-message-box\">\n      <label class=\"cx-footer-label\" id=\"cx-messaging-footer-label\">\n        <span>\n          {{ 'chatMessaging.addNewMessage' | cxTranslate }}\n          <select\n            [attr.aria-label]=\"\n              'chatMessaging.a11y.itemListBoxLabel' | cxTranslate\n            \"\n            *ngIf=\"messagingConfigs?.itemList$ | async as itemList\"\n            class=\"cx-message-item-selection\"\n            formControlName=\"item\"\n          >\n            <option *ngFor=\"let item of itemList\" value=\"{{ item.id }}\">\n              {{ item.name }}\n            </option>\n          </select>\n        </span>\n        <div class=\"cx-message-input\">\n          <input\n            aria-labelledby=\"cx-messaging-footer-label\"\n            formControlName=\"message\"\n            type=\"text\"\n            class=\"form-control\"\n            (keydown.enter)=\"onSend()\"\n            [maxLength]=\"\n              messagingConfigs?.charactersLimit || MAX_INPUT_CHARACTERS\n            \"\n            placeholder=\"{{\n              messagingConfigs?.newMessagePlaceHolder ||\n                ('chatMessaging.addMessagePlaceHolder' | cxTranslate)\n            }}\"\n          />\n          <span\n            class=\"cx-visually-hidden\"\n            *ngIf=\"inputCharacterLeft === 0\"\n            role=\"alert\"\n          >\n            {{ 'chatMessaging.characterLimitAlert' | cxTranslate }}\n          </span>\n          <button\n            aria-labelledby=\"cx-messaging-footer-label\"\n            class=\"btn btn-block cx-send\"\n            [ngClass]=\"\n              !!messagingConfigs?.sendBtnIsNotPrimary\n                ? 'btn-secondary'\n                : 'btn-primary'\n            \"\n            (click)=\"onSend()\"\n          >\n            {{ 'chatMessaging.send' | cxTranslate }}\n          </button>\n        </div>\n      </label>\n      <div class=\"cx-message-footer-info\" id=\"cx-message-footer\">\n        <cx-file-upload\n          [formControl]=\"$any(form.get('file'))\"\n          [accept]=\"allowedTypes\"\n          *ngIf=\"messagingConfigs?.enableFileUploadOption\"\n        >\n          <ng-template>\n            <cx-icon [type]=\"iconTypes.UPLOAD\"></cx-icon>\n            <span class=\"cx-message-footer-text\"\n              >{{ 'chatMessaging.uploadFile' | cxTranslate }}\n            </span>\n          </ng-template>\n        </cx-file-upload>\n\n        <p class=\"cx-message-footer-info-text\">\n          {{\n            'chatMessaging.charactersLeft'\n              | cxTranslate: { count: inputCharacterLeft }\n          }}\n        </p>\n      </div>\n      <cx-form-errors\n        [control]=\"form.get('file')\"\n        prefix=\"formErrors.file\"\n      ></cx-form-errors>\n    </div>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "directive", type: i1$4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: FileUploadComponent, selector: "cx-file-upload", inputs: ["accept", "multiple"], outputs: ["update"] }, { kind: "component", type: FormErrorsComponent, selector: "cx-form-errors", inputs: ["prefix", "fallbackPrefix", "translationParams", "control"] }, { kind: "component", type: AvatarComponent, selector: "cx-avatar", inputs: ["message"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.CxDatePipe, name: "cxDate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MessagingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-messaging', standalone: false, template: "<ng-container *ngIf=\"messageEvents$ | async as messageEvents\">\n  <div class=\"container\">\n    <div class=\"cx-avatar-line\"></div>\n    <div\n      role=\"list\"\n      class=\"cx-messages\"\n      id=\"cx-messages\"\n      (keydown.arrowdown)=\"focusNextChild($any($event))\"\n      (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n      [attr.aria-label]=\"'chatMessaging.messages' | cxTranslate\"\n    >\n      <ng-container *ngFor=\"let message of messageEvents; let i = index\">\n        <div\n          class=\"cx-message-card\"\n          role=\"listitem\"\n          [ngClass]=\"{ 'cx-message-display': message.rightAlign ?? false }\"\n        >\n          <cx-avatar [message]=\"message\"> </cx-avatar>\n\n          <div>\n            <label>{{\n              (message.createdAt | cxDate: messagingConfigs?.dateFormat) ??\n                dateFormat\n            }}</label>\n            <div\n              [ngClass]=\"\n                (message.rightAlign ?? false)\n                  ? 'cx-message-right-align-text'\n                  : 'cx-message-left-align-text'\n              \"\n              [tabindex]=\"i ? -1 : 0\"\n              [attr.aria-label]=\"\n                'chatMessaging.informationLabel'\n                  | cxTranslate\n                    : {\n                        author: message.author,\n                        text: getMessageText(message),\n                        date:\n                          (message.createdAt\n                            | cxDate: messagingConfigs?.dateFormat) ??\n                          dateFormat,\n                      }\n              \"\n            >\n              <a\n                *ngIf=\"message.item\"\n                class=\"cx-message-item-link\"\n                (click)=\"onItemClicked(message.item)\"\n                >{{ message.item.name }}:</a\n              >\n              {{ message.text }}\n            </div>\n            <a\n              *ngFor=\"let attachment of message.attachments ?? []\"\n              class=\"cx-attachment\"\n              (click)=\"\n                triggerDownload(\n                  message.code,\n                  attachment.id,\n                  attachment.filename\n                )\n              \"\n              target=\"_blank\"\n              rel=\"noopener noreferrer\"\n            >\n              <cx-icon [type]=\"iconTypes.ATTACHMENT\"></cx-icon>\n              {{ attachment.filename }}\n            </a>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n\n  <div\n    [formGroup]=\"form\"\n    class=\"cx-message-footer\"\n    *ngIf=\"messagingConfigs?.displayAddMessageSection | async\"\n  >\n    <div class=\"cx-message-box\">\n      <label class=\"cx-footer-label\" id=\"cx-messaging-footer-label\">\n        <span>\n          {{ 'chatMessaging.addNewMessage' | cxTranslate }}\n          <select\n            [attr.aria-label]=\"\n              'chatMessaging.a11y.itemListBoxLabel' | cxTranslate\n            \"\n            *ngIf=\"messagingConfigs?.itemList$ | async as itemList\"\n            class=\"cx-message-item-selection\"\n            formControlName=\"item\"\n          >\n            <option *ngFor=\"let item of itemList\" value=\"{{ item.id }}\">\n              {{ item.name }}\n            </option>\n          </select>\n        </span>\n        <div class=\"cx-message-input\">\n          <input\n            aria-labelledby=\"cx-messaging-footer-label\"\n            formControlName=\"message\"\n            type=\"text\"\n            class=\"form-control\"\n            (keydown.enter)=\"onSend()\"\n            [maxLength]=\"\n              messagingConfigs?.charactersLimit || MAX_INPUT_CHARACTERS\n            \"\n            placeholder=\"{{\n              messagingConfigs?.newMessagePlaceHolder ||\n                ('chatMessaging.addMessagePlaceHolder' | cxTranslate)\n            }}\"\n          />\n          <span\n            class=\"cx-visually-hidden\"\n            *ngIf=\"inputCharacterLeft === 0\"\n            role=\"alert\"\n          >\n            {{ 'chatMessaging.characterLimitAlert' | cxTranslate }}\n          </span>\n          <button\n            aria-labelledby=\"cx-messaging-footer-label\"\n            class=\"btn btn-block cx-send\"\n            [ngClass]=\"\n              !!messagingConfigs?.sendBtnIsNotPrimary\n                ? 'btn-secondary'\n                : 'btn-primary'\n            \"\n            (click)=\"onSend()\"\n          >\n            {{ 'chatMessaging.send' | cxTranslate }}\n          </button>\n        </div>\n      </label>\n      <div class=\"cx-message-footer-info\" id=\"cx-message-footer\">\n        <cx-file-upload\n          [formControl]=\"$any(form.get('file'))\"\n          [accept]=\"allowedTypes\"\n          *ngIf=\"messagingConfigs?.enableFileUploadOption\"\n        >\n          <ng-template>\n            <cx-icon [type]=\"iconTypes.UPLOAD\"></cx-icon>\n            <span class=\"cx-message-footer-text\"\n              >{{ 'chatMessaging.uploadFile' | cxTranslate }}\n            </span>\n          </ng-template>\n        </cx-file-upload>\n\n        <p class=\"cx-message-footer-info-text\">\n          {{\n            'chatMessaging.charactersLeft'\n              | cxTranslate: { count: inputCharacterLeft }\n          }}\n        </p>\n      </div>\n      <cx-form-errors\n        [control]=\"form.get('file')\"\n        prefix=\"formErrors.file\"\n      ></cx-form-errors>\n    </div>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i1.WindowRef }, { type: FilesFormValidators }], propDecorators: { fileUploadComponent: [{
                type: ViewChild,
                args: [FileUploadComponent]
            }], messageEvents$: [{
                type: Input
            }], scrollToInput: [{
                type: Input
            }], messagingConfigs: [{
                type: Input
            }], send: [{
                type: Output
            }], itemClicked: [{
                type: Output
            }], downloadAttachment: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ChatMessagingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ChatMessagingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ChatMessagingModule, declarations: [AvatarComponent, MessagingComponent], imports: [CommonModule,
            I18nModule,
            IconModule,
            FormsModule,
            ReactiveFormsModule,
            FileUploadModule,
            FormErrorsModule], exports: [AvatarComponent, MessagingComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ChatMessagingModule, imports: [CommonModule,
            I18nModule,
            IconModule,
            FormsModule,
            ReactiveFormsModule,
            FileUploadModule,
            FormErrorsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ChatMessagingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        I18nModule,
                        IconModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FileUploadModule,
                        FormErrorsModule,
                    ],
                    declarations: [AvatarComponent, MessagingComponent],
                    exports: [AvatarComponent, MessagingComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Wraps the provided input text in a Read More / Read Less component, truncating input to maxLength
 * and adding "Read More" link. Clicking "Read More" reveals full text with a "Read Less"
 * option to collapse it back.
 */
class ReadMoreComponent {
    constructor() {
        // Read More label translation key
        this.readMoreI18nKey = 'common.readMore';
        // Read Less label translation key
        this.readLessI18nKey = 'common.readLess';
        // Text length that, when exceeded, triggers truncation and adds a Read More link.
        this.maxLength = 300;
        // Text to be rendered (decorated with Read More/Read Less links)
        this.text = '';
        this.showReadMore = false;
        this.isCollapsed = true;
    }
    ngOnChanges(changes) {
        if (changes['text'].currentValue.length > this.maxLength) {
            this.showReadMore = true;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ReadMoreComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ReadMoreComponent, isStandalone: true, selector: "cx-read-more", inputs: { readMoreI18nKey: "readMoreI18nKey", readLessI18nKey: "readLessI18nKey", maxLength: "maxLength", text: "text" }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"isCollapsed\">\n  {{ text.slice(0, maxLength) }}\n</ng-container>\n<ng-container *ngIf=\"!isCollapsed\">\n  {{ text }}\n</ng-container>\n\n<button\n  class=\"btn-link\"\n  *ngIf=\"showReadMore\"\n  (click)=\"isCollapsed = !isCollapsed\"\n>\n  {{ (isCollapsed ? readMoreI18nKey! : readLessI18nKey!) | cxTranslate }}\n</button>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: I18nModule }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ReadMoreComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-read-more', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [CommonModule, I18nModule], template: "<ng-container *ngIf=\"isCollapsed\">\n  {{ text.slice(0, maxLength) }}\n</ng-container>\n<ng-container *ngIf=\"!isCollapsed\">\n  {{ text }}\n</ng-container>\n\n<button\n  class=\"btn-link\"\n  *ngIf=\"showReadMore\"\n  (click)=\"isCollapsed = !isCollapsed\"\n>\n  {{ (isCollapsed ? readMoreI18nKey! : readLessI18nKey!) | cxTranslate }}\n</button>\n" }]
        }], propDecorators: { readMoreI18nKey: [{
                type: Input
            }], readLessI18nKey: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], text: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BannerCarouselModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerCarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: BannerCarouselModule, declarations: [BannerCarouselComponent], imports: [CommonModule, PageComponentModule, CarouselModule, MediaModule], exports: [BannerCarouselComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerCarouselModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    RotatingImagesComponent: {
                        component: BannerCarouselComponent,
                    },
                },
            }),
        ], imports: [CommonModule, PageComponentModule, CarouselModule, MediaModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerCarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PageComponentModule, CarouselModule, MediaModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                RotatingImagesComponent: {
                                    component: BannerCarouselComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [BannerCarouselComponent],
                    exports: [BannerCarouselComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Maps the information about the LCP (Largest Contentful Paint) presence to fetch priority.
 */
class LcpPresenceMappingService {
    getFetchPriority(lcpContext) {
        if (lcpContext === LcpPresence.HAS_LCP) {
            return ImageFetchPriority.HIGH;
        }
        return undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpPresenceMappingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpPresenceMappingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpPresenceMappingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that allows reading the LCP (Largest Contentful Paint) context
 * provided via the `LCP_PRESENCE` injection token by the ancestor component.
 *
 * The knowledge about the containing the LCP (Largest Contentful Paint) element
 * can be used for performance optimizations in some descendant component.
 *
 * @usage
 * ```html
 * <ng-container *cxLcpContext="let lcpContext">
 *   LCP Presence: {{ lcpContext.lcpPresence$ }}
 *
 *   <cx-media [fetchPriority]="lcpContext.fetchPriority$ | async">
 * </ng-container>
 */
class LcpContextDirective {
    constructor() {
        this.lcpPresence$ = inject(LCP_PRESENCE);
        this.lcpPresenceMappingService = inject(LcpPresenceMappingService);
        /**
         * Convenience observable that maps the LCP presence to the fetch priority
         * for the image element, which can be used directly e.g. in the `<cx-media>` component.
         */
        this.fetchPriority$ = this.lcpPresence$.pipe(map$1((lcpElementInfo) => this.lcpPresenceMappingService.getFetchPriority(lcpElementInfo)), distinctUntilChanged$1(), shareReplay({ bufferSize: 1, refCount: true }));
        this.templateRef = inject((TemplateRef));
        this.viewContainer = inject(ViewContainerRef);
    }
    ngOnInit() {
        this.viewContainer.createEmbeddedView(this.templateRef, {
            $implicit: {
                lcpPresence$: this.lcpPresence$,
                fetchPriority$: this.fetchPriority$,
            },
        });
    }
    static ngTemplateContextGuard(_dir, _ctx) {
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpContextDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: LcpContextDirective, isStandalone: false, selector: "[cxLcpContext]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpContextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxLcpContext]',
                    standalone: false,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BannerComponent {
    constructor(component, urlService, cmsService) {
        this.component = component;
        this.urlService = urlService;
        this.cmsService = cmsService;
        this.data$ = this.component.data$.pipe(tap((data) => {
            this.setRouterLink(data);
            this.styleClasses = data.styleClasses;
        }));
    }
    /**
     * Returns `_blank` to force opening the link in a new window whenever the
     * `data.external` flag is set to true.
     */
    getTarget(data) {
        return data.external === 'true' || data.external === true ? '_blank' : null;
    }
    setRouterLink(data) {
        if (data.urlLink) {
            this.routerLink = data.urlLink;
        }
        else if (data.contentPage) {
            this.cmsService
                .getPage({
                id: data.contentPage,
                type: PageType.CONTENT_PAGE,
            })
                .pipe(take(1))
                .subscribe((page) => {
                this.routerLink = page?.label;
            });
        }
        else if (data.product) {
            this.routerLink = this.urlService.transform({
                cxRoute: 'product',
                params: { code: data.product },
            });
        }
        else if (data.category) {
            this.routerLink = this.urlService.transform({
                cxRoute: 'category',
                params: { code: data.category },
            });
        }
    }
    getImage(data) {
        if (data.media) {
            if ('url' in data.media) {
                return data.media;
            }
            else {
                return data.media;
            }
        }
    }
    getImageAltText(data) {
        const img = this.getImage(data);
        if (!img) {
            return;
        }
        // assuming all media formats share the same alt text
        return 'url' in img ? img.altText : Object.values(img)[0]?.altText;
    }
    getLinkAriaLabel(data) {
        const imgAltText = this.getImageAltText(data);
        return data.headline ?? imgAltText;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerComponent, deps: [{ token: CmsComponentData }, { token: i1.SemanticPathService }, { token: i1.CmsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: BannerComponent, isStandalone: false, selector: "cx-banner", host: { properties: { "class": "this.styleClasses" } }, ngImport: i0, template: "<ng-container *cxLcpContext=\"let lcpContext\">\n  <ng-container *ngIf=\"data$ | async as data\">\n    <ng-container *ngIf=\"routerLink\">\n      <cx-generic-link\n        [url]=\"routerLink\"\n        [target]=\"getTarget(data)\"\n        [ariaLabel]=\"getLinkAriaLabel(data)\"\n        [attr.title]=\"!data.headline ? getImageAltText(data) : null\"\n      >\n      </cx-generic-link>\n      <p class=\"headline\" *ngIf=\"data.headline\" [innerHTML]=\"data.headline\"></p>\n      <cx-media\n        *cxFeature=\"'useExtendedMediaComponentConfiguration'\"\n        [container]=\"getImage(data)\"\n        [elementType]=\"'picture'\"\n        [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n      ></cx-media>\n      <cx-media\n        *cxFeature=\"'!useExtendedMediaComponentConfiguration'\"\n        [container]=\"getImage(data)\"\n        [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n      ></cx-media>\n      <p class=\"content\" *ngIf=\"data.content\" [innerHTML]=\"data.content\"></p>\n    </ng-container>\n\n    <ng-container *ngIf=\"!routerLink\">\n      <div class=\"no-link\">\n        <p\n          class=\"headline\"\n          *ngIf=\"data.headline\"\n          [innerHTML]=\"data.headline\"\n        ></p>\n        <cx-media\n          *cxFeature=\"'useExtendedMediaComponentConfiguration'\"\n          [container]=\"getImage(data)\"\n          [elementType]=\"'picture'\"\n          [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n        ></cx-media>\n        <cx-media\n          *cxFeature=\"'!useExtendedMediaComponentConfiguration'\"\n          [container]=\"getImage(data)\"\n          [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n        ></cx-media>\n        <p class=\"content\" *ngIf=\"data.content\" [innerHTML]=\"data.content\"></p>\n      </div>\n    </ng-container>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: GenericLinkComponent, selector: "cx-generic-link", inputs: ["url", "target", "id", "class", "style", "title", "ariaLabel", "tabindex"] }, { kind: "component", type: MediaComponent, selector: "cx-media", inputs: ["container", "format", "alt", "role", "loading", "fetchPriority", "elementType", "sizesForImgElement"], outputs: ["loaded"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "directive", type: LcpContextDirective, selector: "[cxLcpContext]" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-banner', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *cxLcpContext=\"let lcpContext\">\n  <ng-container *ngIf=\"data$ | async as data\">\n    <ng-container *ngIf=\"routerLink\">\n      <cx-generic-link\n        [url]=\"routerLink\"\n        [target]=\"getTarget(data)\"\n        [ariaLabel]=\"getLinkAriaLabel(data)\"\n        [attr.title]=\"!data.headline ? getImageAltText(data) : null\"\n      >\n      </cx-generic-link>\n      <p class=\"headline\" *ngIf=\"data.headline\" [innerHTML]=\"data.headline\"></p>\n      <cx-media\n        *cxFeature=\"'useExtendedMediaComponentConfiguration'\"\n        [container]=\"getImage(data)\"\n        [elementType]=\"'picture'\"\n        [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n      ></cx-media>\n      <cx-media\n        *cxFeature=\"'!useExtendedMediaComponentConfiguration'\"\n        [container]=\"getImage(data)\"\n        [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n      ></cx-media>\n      <p class=\"content\" *ngIf=\"data.content\" [innerHTML]=\"data.content\"></p>\n    </ng-container>\n\n    <ng-container *ngIf=\"!routerLink\">\n      <div class=\"no-link\">\n        <p\n          class=\"headline\"\n          *ngIf=\"data.headline\"\n          [innerHTML]=\"data.headline\"\n        ></p>\n        <cx-media\n          *cxFeature=\"'useExtendedMediaComponentConfiguration'\"\n          [container]=\"getImage(data)\"\n          [elementType]=\"'picture'\"\n          [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n        ></cx-media>\n        <cx-media\n          *cxFeature=\"'!useExtendedMediaComponentConfiguration'\"\n          [container]=\"getImage(data)\"\n          [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n        ></cx-media>\n        <p class=\"content\" *ngIf=\"data.content\" [innerHTML]=\"data.content\"></p>\n      </div>\n    </ng-container>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: i1.SemanticPathService }, { type: i1.CmsService }], propDecorators: { styleClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LcpContextDirectiveModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpContextDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: LcpContextDirectiveModule, declarations: [LcpContextDirective], exports: [LcpContextDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpContextDirectiveModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LcpContextDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LcpContextDirective],
                    exports: [LcpContextDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BannerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: BannerModule, declarations: [BannerComponent], imports: [CommonModule,
            RouterModule,
            GenericLinkModule,
            MediaModule,
            FeaturesConfigModule,
            LcpContextDirectiveModule], exports: [BannerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    SimpleResponsiveBannerComponent: {
                        component: BannerComponent,
                    },
                    BannerComponent: {
                        component: BannerComponent,
                    },
                    SimpleBannerComponent: {
                        component: BannerComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            RouterModule,
            GenericLinkModule,
            MediaModule,
            FeaturesConfigModule,
            LcpContextDirectiveModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BannerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        GenericLinkModule,
                        MediaModule,
                        FeaturesConfigModule,
                        LcpContextDirectiveModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                SimpleResponsiveBannerComponent: {
                                    component: BannerComponent,
                                },
                                BannerComponent: {
                                    component: BannerComponent,
                                },
                                SimpleBannerComponent: {
                                    component: BannerComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [BannerComponent],
                    exports: [BannerComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LinkComponent {
    constructor(component) {
        this.component = component;
        this.data$ = this.component.data$;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.data$.subscribe((data) => {
            this.styleClasses = data?.styleClasses;
        }));
    }
    /**
     * Returns `_blank` to force opening the link in a new window whenever the
     * `data.target` flag is set to `true`.
     */
    getTarget(data) {
        return data.target === 'true' || data.target === true ? '_blank' : null;
    }
    ngOnDestroy() {
        this.subscriptions?.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LinkComponent, deps: [{ token: CmsComponentData }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: LinkComponent, isStandalone: false, selector: "cx-link", host: { properties: { "class": "this.styleClasses" } }, ngImport: i0, template: "<cx-generic-link\n  *ngIf=\"data$ | async as data\"\n  [url]=\"data.url ?? ''\"\n  [style]=\"data.styleAttributes\"\n  [target]=\"getTarget(data)\"\n  >{{ data.linkName }}</cx-generic-link\n>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: GenericLinkComponent, selector: "cx-generic-link", inputs: ["url", "target", "id", "class", "style", "title", "ariaLabel", "tabindex"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-link', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<cx-generic-link\n  *ngIf=\"data$ | async as data\"\n  [url]=\"data.url ?? ''\"\n  [style]=\"data.styleAttributes\"\n  [target]=\"getTarget(data)\"\n  >{{ data.linkName }}</cx-generic-link\n>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }], propDecorators: { styleClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LinkModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: LinkModule, declarations: [LinkComponent], imports: [CommonModule, RouterModule, GenericLinkModule], exports: [LinkComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LinkModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    CMSLinkComponent: { component: LinkComponent },
                },
            }),
        ], imports: [CommonModule, RouterModule, GenericLinkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule, GenericLinkModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                CMSLinkComponent: { component: LinkComponent },
                            },
                        }),
                    ],
                    declarations: [LinkComponent],
                    exports: [LinkComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Supplements the anchor links that contain only the hash fragment in the `href` attribute,
 * (e.g. `<a href="#someId">`), by prepending the current location (path and query params),
 * so it becomes a link to a full url
 * e.g. `<a href="https://domain.com/current/path?and=query-params#someId">`.
 *
 * This helps to avoid the undesirable navigation to the homepage URL (`/#someId`)
 * when clicking the original link.
 *
 * It's useful for example for cms-provided content passed to the [innerHTML] directive.
 */
class SupplementHashAnchorsPipe {
    constructor(renderer, winRef) {
        this.renderer = renderer;
        this.winRef = winRef;
    }
    getPath(anchorId) {
        const currentUrlWithoutFragment = this.winRef.location.href?.replace(/#.*$/, '');
        return `${currentUrlWithoutFragment}${anchorId}`;
    }
    transform(html = '') {
        const template = this.renderer.createElement('template');
        template.innerHTML = html.trim();
        const linkNodes = template.content.querySelectorAll('a');
        Array.from(linkNodes).forEach((link) => {
            const href = link.getAttribute('href');
            if (href?.indexOf('#') === 0) {
                this.renderer.setProperty(link, 'href', this.getPath(href));
            }
        });
        return template.innerHTML;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SupplementHashAnchorsPipe, deps: [{ token: i0.Renderer2 }, { token: i1.WindowRef }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SupplementHashAnchorsPipe, isStandalone: false, name: "cxSupplementHashAnchors" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SupplementHashAnchorsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cxSupplementHashAnchors',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i1.WindowRef }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ParagraphComponent {
    handleClick(event) {
        if (event.target instanceof HTMLAnchorElement) {
            const element = event.target;
            const href = element?.getAttribute('href');
            const documentUrlObject = new URL(element.ownerDocument.URL);
            // Use router for internal link navigation
            if (href && documentUrlObject.host === element.host) {
                event.preventDefault();
                this.router.navigateByUrl(href.replace(documentUrlObject.origin, ''));
            }
        }
    }
    constructor(component, router) {
        this.component = component;
        this.router = router;
        this.sanitizer = inject(DomSanitizer);
    }
    bypassSecurityTrustHtml(html = '') {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ParagraphComponent, deps: [{ token: CmsComponentData }, { token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ParagraphComponent, isStandalone: false, selector: "cx-paragraph", host: { listeners: { "click": "handleClick($event)" } }, ngImport: i0, template: "<div\n  *ngIf=\"component.data$ | async as data\"\n  [innerHTML]=\"bypassSecurityTrustHtml(data.content | cxSupplementHashAnchors)\"\n></div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: SupplementHashAnchorsPipe, name: "cxSupplementHashAnchors" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ParagraphComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-paragraph', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div\n  *ngIf=\"component.data$ | async as data\"\n  [innerHTML]=\"bypassSecurityTrustHtml(data.content | cxSupplementHashAnchors)\"\n></div>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: i1$2.Router }], propDecorators: { handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SupplementHashAnchorsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SupplementHashAnchorsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SupplementHashAnchorsModule, declarations: [SupplementHashAnchorsPipe], exports: [SupplementHashAnchorsPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SupplementHashAnchorsModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SupplementHashAnchorsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SupplementHashAnchorsPipe],
                    exports: [SupplementHashAnchorsPipe],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsParagraphModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsParagraphModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: CmsParagraphModule, declarations: [ParagraphComponent], imports: [CommonModule, RouterModule, SupplementHashAnchorsModule], exports: [ParagraphComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsParagraphModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    CMSParagraphComponent: {
                        component: ParagraphComponent,
                    },
                    CMSTabParagraphComponent: {
                        component: ParagraphComponent,
                    },
                },
            }),
        ], imports: [CommonModule, RouterModule, SupplementHashAnchorsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CmsParagraphModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule, SupplementHashAnchorsModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                CMSParagraphComponent: {
                                    component: ParagraphComponent,
                                },
                                CMSTabParagraphComponent: {
                                    component: ParagraphComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ParagraphComponent],
                    exports: [ParagraphComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PDFComponent {
    constructor(component, mediaService) {
        this.component = component;
        this.mediaService = mediaService;
        this.data$ = this.component.data$.pipe(tap((data) => {
            if (data?.pdfFile?.url) {
                this.url = this.mediaService.getMedia(data.pdfFile)?.src;
            }
        }));
    }
    addPdfExtension(title) {
        if (!title) {
            return '';
        }
        const trimTitle = title.trim();
        return trimTitle.endsWith('.pdf') ? trimTitle : `${trimTitle}.pdf`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PDFComponent, deps: [{ token: CmsComponentData }, { token: MediaService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PDFComponent, isStandalone: false, selector: "cx-pdf", ngImport: i0, template: "<ng-container *ngIf=\"data$ | async as data\">\n  <div class=\"pdf-container\">\n    <a [href]=\"url\" target=\"_blank\" rel=\"noopener noreferrer\">\n      <span>{{\n        addPdfExtension(\n          data?.title ||\n            data?.pdfFile?.altText ||\n            ('pdf.defaultTitle' | cxTranslate)\n        )\n      }}</span>\n      <span aria-hidden=\"true\">\n        <cx-icon [type]=\"'PDF_FILE'\"></cx-icon>\n      </span>\n    </a>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PDFComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-pdf', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"data$ | async as data\">\n  <div class=\"pdf-container\">\n    <a [href]=\"url\" target=\"_blank\" rel=\"noopener noreferrer\">\n      <span>{{\n        addPdfExtension(\n          data?.title ||\n            data?.pdfFile?.altText ||\n            ('pdf.defaultTitle' | cxTranslate)\n        )\n      }}</span>\n      <span aria-hidden=\"true\">\n        <cx-icon [type]=\"'PDF_FILE'\"></cx-icon>\n      </span>\n    </a>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: MediaService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PDFModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PDFModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PDFModule, declarations: [PDFComponent], imports: [CommonModule, IconModule, I18nModule], exports: [PDFComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PDFModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    PDFDocumentComponent: {
                        component: PDFComponent,
                    },
                },
            }),
        ], imports: [CommonModule, IconModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PDFModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule, I18nModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                PDFDocumentComponent: {
                                    component: PDFComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [PDFComponent],
                    exports: [PDFComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var TAB_MODE;
(function (TAB_MODE) {
    TAB_MODE["TAB"] = "TAB";
    TAB_MODE["ACCORDIAN"] = "ACCORDIAN";
})(TAB_MODE || (TAB_MODE = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * If the passed index its outside of the min and max boundaries,
 * wrap the index exceeding the max boundary to the min boundary or vice versa.
 * Return the index if it does not exceed any boundary.
 */
function wrapIntoBounds(index, max, min = 0) {
    if (index < min) {
        return max;
    }
    else if (index > max) {
        return min;
    }
    return index;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabPanelComponent {
    constructor() {
        this.TAB_MODE = TAB_MODE;
        /**
         * In which layout to set the component (ie. Tab or Accordian).
         * Defaults to "Tab" mode.
         */
        this.mode = TAB_MODE.TAB;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: TabPanelComponent, isStandalone: false, selector: "cx-tab-panel", inputs: { tab: "tab", mode: "mode" }, ngImport: i0, template: "<div\n  [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? 'region' : 'tabpanel'\"\n  [tabindex]=\"tab.disableBorderFocus ? -1 : 0\"\n  [attr.aria-labelledby]=\"tab.id ?? null\"\n  [attr.id]=\"\n    tab.id !== null && tab.id !== undefined ? 'section-' + tab.id : null\n  \"\n  class=\"active\"\n  [cxFocus]=\"{ focusOnEscape: !tab.disableBorderFocus }\"\n>\n  <ng-container\n    *ngIf=\"tab.content\"\n    [ngTemplateOutlet]=\"tab.content\"\n  ></ng-container>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-tab-panel', standalone: false, template: "<div\n  [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? 'region' : 'tabpanel'\"\n  [tabindex]=\"tab.disableBorderFocus ? -1 : 0\"\n  [attr.aria-labelledby]=\"tab.id ?? null\"\n  [attr.id]=\"\n    tab.id !== null && tab.id !== undefined ? 'section-' + tab.id : null\n  \"\n  class=\"active\"\n  [cxFocus]=\"{ focusOnEscape: !tab.disableBorderFocus }\"\n>\n  <ng-container\n    *ngIf=\"tab.content\"\n    [ngTemplateOutlet]=\"tab.content\"\n  ></ng-container>\n</div>\n" }]
        }], propDecorators: { tab: [{
                type: Input
            }], mode: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabComponent {
    constructor() {
        this.disabled = false;
        this.TAB_MODE = TAB_MODE;
        this.breakpointService = inject(BreakpointService);
        this.translationService = inject(TranslationService);
        this.cd = inject(ChangeDetectorRef);
        this.featureConfigService = inject(FeatureConfigService, {
            optional: true,
        });
        this.subscriptions = new Subscription();
        useFeatureStyles('a11yCroppedFocusRing');
    }
    ngOnInit() {
        this.openTabs$ = new BehaviorSubject(this.config?.openTabs ?? []);
        this.mode$ = this.getMode();
    }
    ngAfterViewInit() {
        /**
         * We subscribe to the tabs observable if added and use this to set
         * the `tabs` property. The input `tabs` property should not be
         * initialized. It will be overwritten by this otherwise.
         */
        this.subscriptions.add(this.tabs$?.subscribe((tabs) => {
            this.tabs = tabs;
            this.cd.detectChanges();
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * Tab selection works differently depending on the given mode.
     *
     * Modes:
     * - Tab: Closes all other tabs and opens the given tab.
     * - Accordian: Toggles the given tab open or closed.
     */
    select(tabNum, mode) {
        this.focus(tabNum);
        switch (mode) {
            case TAB_MODE.TAB:
                return this.openTabs$.next([tabNum]);
            case TAB_MODE.ACCORDIAN:
                return this.toggleTab(tabNum);
        }
    }
    /**
     * Focuses the given tab according to the number.
     */
    focus(tabNum) {
        this.tabHeaders.toArray()[tabNum].nativeElement.focus();
    }
    /**
     * Calls select or focus methods depending on the tab mode.
     */
    selectOrFocus(tabNum, mode, event) {
        event.preventDefault();
        if (this.featureConfigService?.isEnabled('a11yTabsManualActivation')) {
            switch (mode) {
                case TAB_MODE.TAB:
                case TAB_MODE.ACCORDIAN:
                    return this.focus(tabNum);
            }
        }
        else {
            switch (mode) {
                case TAB_MODE.TAB:
                    return this.select(tabNum, mode);
                case TAB_MODE.ACCORDIAN:
                    return this.focus(tabNum);
            }
        }
    }
    /**
     * Handles keydown events made on tabs.
     *
     * Keys:
     * - ArrowUp / ArrowLeft: Select or focus the previous tab.
     * - ArrowRight / ArrowDown: Select or focus the next tab.
     * - Home: Select or focus the first tab.
     * - End: Select or focus the last tab.
     */
    handleKeydownEvent(tabNum, tabs, mode, event) {
        const FIRST_TAB = 0;
        const LAST_TAB = tabs.length - 1;
        const PREVIOUS_TAB = wrapIntoBounds(tabNum - 1, LAST_TAB);
        const NEXT_TAB = wrapIntoBounds(tabNum + 1, LAST_TAB);
        // Disable some keys is `restrictDirectionKeys` is enabled.
        if (this.config.restrictDirectionKeys &&
            this.shouldRestrictKeys(mode, event)) {
            return;
        }
        switch (event.key) {
            case 'ArrowLeft':
            case 'ArrowUp':
                return this.selectOrFocus(PREVIOUS_TAB, mode, event);
            case 'ArrowRight':
            case 'ArrowDown':
                return this.selectOrFocus(NEXT_TAB, mode, event);
            case 'Home':
                return this.selectOrFocus(FIRST_TAB, mode, event);
            case 'End':
                return this.selectOrFocus(LAST_TAB, mode, event);
        }
    }
    shouldRestrictKeys(mode, event) {
        if (mode === TAB_MODE.TAB && ['ArrowUp', 'ArrowDown'].includes(event.key)) {
            return true;
        }
        if (mode === TAB_MODE.ACCORDIAN &&
            ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
            return true;
        }
        return false;
    }
    /**
     * Indicates whether a tab is open (in the open tabs array).
     */
    isOpen(tabNum) {
        return (this.getOpenTabs().find((open) => open === tabNum) !== undefined);
    }
    /**
     * Inverts the state of the given tab between open and closed.
     */
    toggleTab(tabNum) {
        const openTabs = this.getOpenTabs();
        const openTabIndex = openTabs.indexOf(tabNum);
        openTabIndex > -1
            ? openTabs.splice(openTabIndex, 1)
            : openTabs.push(tabNum);
        this.openTabs$.next(openTabs);
    }
    /**
     * Returns index 0 if the tab is already open,
     * no tabs are open and its the first tab (ie. 0),
     * or in 'ACCORDIAN' mode.
     * Otherwise returns -1.
     */
    getTabIndex(tabNum, mode) {
        return this.isOpen(tabNum) ||
            (tabNum === 0 && this.getOpenTabs().length === 0) ||
            mode === 'ACCORDIAN'
            ? 0
            : -1;
    }
    getTitle(mode, index) {
        const tab = this.tabs[index];
        // Not required in Tab mode.
        if (mode === TAB_MODE.TAB) {
            return null;
        }
        let header = tab.header;
        if (tab.headerKey) {
            this.translationService
                .translate(tab.headerKey)
                .pipe(take(1))
                .subscribe((val) => {
                header = val;
            });
        }
        return (
        // Show expanded or collapsed.
        (this.isOpen(index) ? 'Collapse' : 'Expand') + ' ' + header);
    }
    getOpenTabs() {
        return this.openTabs$.value;
    }
    /**
     * Returns the mode specified by the config.
     * If unspecified mode, return 'TAB' or 'ACCORDIAN' modes responsively using the specified breakpoint in the config.
     * If unspecified breakpoint, return 'TAB' mode by default.
     */
    getMode() {
        if (this.config.mode) {
            return of(this.config.mode);
        }
        if (this.config.breakpoint) {
            return this.breakpointService
                .isUp(this.config.breakpoint)
                .pipe(map((isUp) => (isUp ? TAB_MODE.TAB : TAB_MODE.ACCORDIAN)));
        }
        return of(TAB_MODE.TAB);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: TabComponent, isStandalone: false, selector: "cx-tab", inputs: { tabs$: "tabs$", tabs: "tabs", config: "config", disabled: "disabled" }, viewQueries: [{ propertyName: "tabHeaders", predicate: ["tabHeader"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"mode$ | async as mode\">\n  <!-- Tab List is the list of buttons to open tabs -->\n  <div\n    [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? null : 'tablist'\"\n    [attr.aria-label]=\"config.label | cxTranslate\"\n    [class]=\"mode.toLowerCase()\"\n  >\n    <ng-container *ngFor=\"let tab of tabs; let i = index\">\n      <button\n        type=\"button\"\n        class=\"tab-btn\"\n        [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? 'button' : 'tab'\"\n        (click)=\"select(i, mode)\"\n        (keydown)=\"handleKeydownEvent(i, tabs, mode, $event)\"\n        [attr.aria-selected]=\"mode === TAB_MODE.ACCORDIAN ? null : isOpen(i)\"\n        [attr.aria-expanded]=\"mode === TAB_MODE.TAB ? null : isOpen(i)\"\n        [attr.aria-controls]=\"isOpen(i) ? 'section-' + i : null\"\n        [attr.tabindex]=\"getTabIndex(i, mode)\"\n        [attr.id]=\"tab.id\"\n        [attr.title]=\"getTitle(mode, i)\"\n        [class.active]=\"isOpen(i)\"\n        [disabled]=\"disabled\"\n        #tabHeader\n      >\n        {{\n          tab.headerKey\n            ? (tab.headerKey | cxTranslate: tab.headerParams || {})\n            : tab.header\n        }}\n        <span\n          *ngIf=\"mode === TAB_MODE.ACCORDIAN\"\n          class=\"tab-icon\"\n          aria-hidden=\"true\"\n        >\n          {{ isOpen(i) ? '\u2013' : '+' }}\n        </span>\n      </button>\n\n      <!-- Show tab panels under selected button in Accordian mode -->\n      <ng-container\n        *ngIf=\"mode === TAB_MODE.ACCORDIAN\"\n        [ngTemplateOutlet]=\"tabPanel\"\n        [ngTemplateOutletContext]=\"{ tabNum: i }\"\n      ></ng-container>\n    </ng-container>\n  </div>\n\n  <!-- Show selected tab panel under all buttons in Tab mode -->\n  <ng-container *ngIf=\"mode === TAB_MODE.TAB\">\n    <ng-container\n      *ngFor=\"let tab of tabs; let i = index\"\n      [ngTemplateOutlet]=\"tabPanel\"\n      [ngTemplateOutletContext]=\"{ tabNum: i }\"\n    >\n    </ng-container>\n  </ng-container>\n\n  <!-- Tab Panel shows the content of the given tab -->\n  <ng-template #tabPanel let-tabNum=\"tabNum\">\n    <cx-tab-panel\n      [tab]=\"tabs[tabNum]\"\n      [mode]=\"mode\"\n      *ngIf=\"isOpen(tabNum)\"\n    ></cx-tab-panel>\n  </ng-template>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: TabPanelComponent, selector: "cx-tab-panel", inputs: ["tab", "mode"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-tab', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"mode$ | async as mode\">\n  <!-- Tab List is the list of buttons to open tabs -->\n  <div\n    [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? null : 'tablist'\"\n    [attr.aria-label]=\"config.label | cxTranslate\"\n    [class]=\"mode.toLowerCase()\"\n  >\n    <ng-container *ngFor=\"let tab of tabs; let i = index\">\n      <button\n        type=\"button\"\n        class=\"tab-btn\"\n        [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? 'button' : 'tab'\"\n        (click)=\"select(i, mode)\"\n        (keydown)=\"handleKeydownEvent(i, tabs, mode, $event)\"\n        [attr.aria-selected]=\"mode === TAB_MODE.ACCORDIAN ? null : isOpen(i)\"\n        [attr.aria-expanded]=\"mode === TAB_MODE.TAB ? null : isOpen(i)\"\n        [attr.aria-controls]=\"isOpen(i) ? 'section-' + i : null\"\n        [attr.tabindex]=\"getTabIndex(i, mode)\"\n        [attr.id]=\"tab.id\"\n        [attr.title]=\"getTitle(mode, i)\"\n        [class.active]=\"isOpen(i)\"\n        [disabled]=\"disabled\"\n        #tabHeader\n      >\n        {{\n          tab.headerKey\n            ? (tab.headerKey | cxTranslate: tab.headerParams || {})\n            : tab.header\n        }}\n        <span\n          *ngIf=\"mode === TAB_MODE.ACCORDIAN\"\n          class=\"tab-icon\"\n          aria-hidden=\"true\"\n        >\n          {{ isOpen(i) ? '\u2013' : '+' }}\n        </span>\n      </button>\n\n      <!-- Show tab panels under selected button in Accordian mode -->\n      <ng-container\n        *ngIf=\"mode === TAB_MODE.ACCORDIAN\"\n        [ngTemplateOutlet]=\"tabPanel\"\n        [ngTemplateOutletContext]=\"{ tabNum: i }\"\n      ></ng-container>\n    </ng-container>\n  </div>\n\n  <!-- Show selected tab panel under all buttons in Tab mode -->\n  <ng-container *ngIf=\"mode === TAB_MODE.TAB\">\n    <ng-container\n      *ngFor=\"let tab of tabs; let i = index\"\n      [ngTemplateOutlet]=\"tabPanel\"\n      [ngTemplateOutletContext]=\"{ tabNum: i }\"\n    >\n    </ng-container>\n  </ng-container>\n\n  <!-- Tab Panel shows the content of the given tab -->\n  <ng-template #tabPanel let-tabNum=\"tabNum\">\n    <cx-tab-panel\n      [tab]=\"tabs[tabNum]\"\n      [mode]=\"mode\"\n      *ngIf=\"isOpen(tabNum)\"\n    ></cx-tab-panel>\n  </ng-template>\n</ng-container>\n" }]
        }], ctorParameters: () => [], propDecorators: { tabs$: [{
                type: Input
            }], tabs: [{
                type: Input
            }], config: [{
                type: Input
            }], disabled: [{
                type: Input
            }], tabHeaders: [{
                type: ViewChildren,
                args: ['tabHeader']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultTabConfig = {
    openTabs: [0],
    breakpoint: BREAKPOINT.md,
};
class TabParagraphContainerComponent {
    constructor(componentData, cmsService, winRef) {
        this.componentData = componentData;
        this.cmsService = cmsService;
        this.winRef = winRef;
        this.cdr = inject(ChangeDetectorRef);
        /**
         * @deprecated This method will be removed.
         */
        this.activeTabNum = 0;
        /**
         * @deprecated This method will be removed.
         */
        this.tabTitleParams = [];
        this.tabConfig$ = new BehaviorSubject(defaultTabConfig);
        /**
         * Map with key as the component uid and value as the observable of the title parameters.
         */
        this.tabTitleParams$ = new BehaviorSubject(new Map());
        this.components$ = this.componentData.data$.pipe(distinctUntilChanged((x, y) => x?.components === y?.components), tap((data) => {
            this.ariaLabel = `${data?.uid}.tabPanelContainerRegion`;
        }), switchMap$1((data) => combineLatest((data?.components ?? '').split(' ').map((component) => this.cmsService.getComponentData(component).pipe(distinctUntilChanged(), map((tab) => {
            if (!tab) {
                return undefined;
            }
            if (!tab.flexType) {
                tab = {
                    ...tab,
                    flexType: tab.typeCode,
                };
            }
            return {
                ...tab,
                title: `${data.uid}.tabs.${tab.uid}`,
            };
        })))).pipe(
        // Update tablist label with name from CMS
        tap(() => {
            this.tabConfig$.next({
                label: `${data?.uid}.tabPanelContainerRegionGroup`,
                ...defaultTabConfig,
            });
        }))));
    }
    /**
     * @deprecated This method will be removed.
     */
    select(tabNum, event) {
        this.activeTabNum = this.activeTabNum === tabNum ? -1 : tabNum;
        if (event && event?.target) {
            const target = event.target;
            const parentNode = target.parentNode;
            this.winRef?.nativeWindow?.scrollTo({
                left: 0,
                top: parentNode.offsetTop,
                behavior: 'smooth',
            });
        }
    }
    /**
     * @deprecated This method will be removed.
     */
    ngOnInit() {
        this.cdr.markForCheck();
        this.activeTabNum =
            this.winRef?.nativeWindow?.history?.state?.activeTab ?? this.activeTabNum;
    }
    ngAfterViewInit() {
        // If the sub cms components data exist, the components created before ngAfterViewInit are called.
        // In this case, the title parameters are directly pulled from them.
        if (this.children.length > 0) {
            this.getTitleParams(this.children);
        }
        // Render the tabs after the templates have completed loading in the view.
        this.tabs$ = combineLatest([
            this.components$,
            this.tabRefs.changes.pipe(startWith(this.tabRefs)),
            this.tabTitleParams$,
        ]).pipe(switchMap$1(([components, refs, params]) => {
            const paramObservables = components.map((component) => params.get(component.uid) || of(null));
            return combineLatest(paramObservables).pipe(map((resolvedParams) => components.map((component, index) => ({
                headerKey: component.title,
                content: refs.get(index),
                id: index,
                headerParams: { param: resolvedParams[index] },
            }))));
        }));
        this.cdr.detectChanges();
    }
    tabCompLoaded(componentRef, componentId) {
        this.tabTitleParams.push(componentRef.instance.tabTitleParam$);
        if (componentId) {
            const currentParams = this.tabTitleParams$.getValue();
            // We need to check if the componentId is already in the map
            // to avoid infinite loop(tabs$ emit -> component load -> tabTitleParams$ emit -> tabs$ emit)
            if (!currentParams.has(componentId)) {
                currentParams.set(componentId, componentRef.instance.tabTitleParam$);
                this.tabTitleParams$.next(currentParams);
            }
        }
    }
    getTitleParams(children) {
        children.forEach((comp) => {
            this.tabTitleParams.push(comp['cmpRef']?.instance.tabTitleParam$ ?? null);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabParagraphContainerComponent, deps: [{ token: CmsComponentData }, { token: i1.CmsService }, { token: i1.WindowRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: TabParagraphContainerComponent, isStandalone: false, selector: "cx-tab-paragraph-container", viewQueries: [{ propertyName: "children", predicate: ComponentWrapperDirective, descendants: true }, { propertyName: "tabRefs", predicate: ["tabRef"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"components$ | async as components\">\n  <div\n    *cxFeature=\"'!a11yTabComponent'\"\n    role=\"region\"\n    tabindex=\"-1\"\n    [attr.aria-label]=\"ariaLabel | cxTranslate\"\n    class=\"container\"\n  >\n    <ng-container *ngFor=\"let component of components; let i = index\">\n      <ng-container *ngIf=\"component\">\n        <button\n          [class.active]=\"i === activeTabNum\"\n          (click)=\"select(i, $event)\"\n          [attr.aria-expanded]=\"i === activeTabNum\"\n        >\n          {{\n            component.title | cxTranslate: { param: tabTitleParams[i] | async }\n          }}\n\n          <span\n            title=\"{{\n              i === activeTabNum\n                ? ('common.collapse' | cxTranslate)\n                : ('common.expand' | cxTranslate)\n            }}\"\n            class=\"accordion-icon\"\n            aria-hidden=\"true\"\n          ></span>\n        </button>\n\n        <div\n          [class.active]=\"i === activeTabNum\"\n          class=\"cx-tab-paragraph-content\"\n          tabindex=\"0\"\n          role=\"presentation\"\n        >\n          <ng-template [cxOutlet]=\"component.flexType\" [cxOutletContext]=\"{}\">\n            <ng-container\n              [cxComponentWrapper]=\"component\"\n              (cxComponentRef)=\"tabCompLoaded($event)\"\n            ></ng-container>\n          </ng-template>\n        </div>\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <ng-container *cxFeature=\"'a11yTabComponent'\">\n    <cx-tab [tabs]=\"tabs$ | async\" [config]=\"tabConfig$ | async\">\n      <ng-template\n        *ngFor=\"let component of components; let i = index\"\n        [cxOutlet]=\"component.flexType\"\n        #tabRef\n      >\n        <ng-container\n          [cxComponentWrapper]=\"component\"\n          (cxComponentRef)=\"tabCompLoaded($event, component.uid)\"\n        ></ng-container>\n      </ng-template>\n    </cx-tab>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ComponentWrapperDirective, selector: "[cxComponentWrapper]", inputs: ["cxComponentWrapper"], outputs: ["cxComponentRef"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "component", type: TabComponent, selector: "cx-tab", inputs: ["tabs$", "tabs", "config", "disabled"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabParagraphContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-tab-paragraph-container', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"components$ | async as components\">\n  <div\n    *cxFeature=\"'!a11yTabComponent'\"\n    role=\"region\"\n    tabindex=\"-1\"\n    [attr.aria-label]=\"ariaLabel | cxTranslate\"\n    class=\"container\"\n  >\n    <ng-container *ngFor=\"let component of components; let i = index\">\n      <ng-container *ngIf=\"component\">\n        <button\n          [class.active]=\"i === activeTabNum\"\n          (click)=\"select(i, $event)\"\n          [attr.aria-expanded]=\"i === activeTabNum\"\n        >\n          {{\n            component.title | cxTranslate: { param: tabTitleParams[i] | async }\n          }}\n\n          <span\n            title=\"{{\n              i === activeTabNum\n                ? ('common.collapse' | cxTranslate)\n                : ('common.expand' | cxTranslate)\n            }}\"\n            class=\"accordion-icon\"\n            aria-hidden=\"true\"\n          ></span>\n        </button>\n\n        <div\n          [class.active]=\"i === activeTabNum\"\n          class=\"cx-tab-paragraph-content\"\n          tabindex=\"0\"\n          role=\"presentation\"\n        >\n          <ng-template [cxOutlet]=\"component.flexType\" [cxOutletContext]=\"{}\">\n            <ng-container\n              [cxComponentWrapper]=\"component\"\n              (cxComponentRef)=\"tabCompLoaded($event)\"\n            ></ng-container>\n          </ng-template>\n        </div>\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <ng-container *cxFeature=\"'a11yTabComponent'\">\n    <cx-tab [tabs]=\"tabs$ | async\" [config]=\"tabConfig$ | async\">\n      <ng-template\n        *ngFor=\"let component of components; let i = index\"\n        [cxOutlet]=\"component.flexType\"\n        #tabRef\n      >\n        <ng-container\n          [cxComponentWrapper]=\"component\"\n          (cxComponentRef)=\"tabCompLoaded($event, component.uid)\"\n        ></ng-container>\n      </ng-template>\n    </cx-tab>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: i1.CmsService }, { type: i1.WindowRef }], propDecorators: { children: [{
                type: ViewChildren,
                args: [ComponentWrapperDirective]
            }], tabRefs: [{
                type: ViewChildren,
                args: ['tabRef']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabPanelModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TabPanelModule, declarations: [TabPanelComponent], imports: [CommonModule,
            PageComponentModule,
            OutletModule,
            I18nModule,
            KeyboardFocusModule], exports: [TabPanelComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabPanelModule, imports: [CommonModule,
            PageComponentModule,
            OutletModule,
            I18nModule,
            KeyboardFocusModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PageComponentModule,
                        OutletModule,
                        I18nModule,
                        KeyboardFocusModule,
                    ],
                    declarations: [TabPanelComponent],
                    exports: [TabPanelComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TabModule, declarations: [TabComponent], imports: [CommonModule, I18nModule, TabPanelModule], exports: [TabComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabModule, imports: [CommonModule, I18nModule, TabPanelModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule, TabPanelModule],
                    declarations: [TabComponent],
                    exports: [TabComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabParagraphContainerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabParagraphContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: TabParagraphContainerModule, declarations: [TabParagraphContainerComponent], imports: [CommonModule,
            PageComponentModule,
            OutletModule,
            I18nModule,
            TabModule,
            FeaturesConfigModule], exports: [TabParagraphContainerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabParagraphContainerModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    CMSTabParagraphContainer: {
                        component: TabParagraphContainerComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            PageComponentModule,
            OutletModule,
            I18nModule,
            TabModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: TabParagraphContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PageComponentModule,
                        OutletModule,
                        I18nModule,
                        TabModule,
                        FeaturesConfigModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                CMSTabParagraphContainer: {
                                    component: TabParagraphContainerComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [TabParagraphContainerComponent],
                    exports: [TabParagraphContainerComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class VideoComponent {
    constructor(component, mediaService, urlService, cmsService, cd) {
        this.component = component;
        this.mediaService = mediaService;
        this.urlService = urlService;
        this.cmsService = cmsService;
        this.cd = cd;
        this.data$ = this.component.data$.pipe(distinctUntilChanged(), tap((data) => {
            this.styleClasses = data.styleClasses;
            this.setMedia(data);
            this.setControls(data);
            this.setRouting(data);
        }));
    }
    setMedia(data) {
        if (data.video) {
            this.source = this.mediaService.getMedia(data.video)?.src;
        }
        if (data?.containerBackground ===
            ContainerBackgroundOptions.UPLOAD_RESPONSIVE_IMAGE &&
            data?.videoMedia) {
            this.thumbnail = this.mediaService.getMedia(data.videoMedia);
        }
        else if (data?.thumbnailSelector === ContainerBackgroundOptions.UPLOAD_THUMBNAIL &&
            data?.thumbnail) {
            this.thumbnail = this.mediaService.getMedia(data.thumbnail);
        }
        else {
            this.thumbnail = undefined;
        }
    }
    setControls(data) {
        this.autoPlay = data.autoPlay === 'true';
        this.loop = data.loop === 'true';
        this.mute = data.mute === 'true' ? 'muted' : undefined;
    }
    setRouting(data) {
        if (data.url) {
            this.routerLink = data.url;
        }
        else if (data.contentPage) {
            this.cmsService
                .getPage({
                id: data.contentPage,
                type: PageType.CONTENT_PAGE,
            })
                .pipe(take(1))
                .subscribe((page) => {
                this.routerLink = page?.label;
                this.cd.markForCheck();
            });
        }
        else if (data.product) {
            this.routerLink = this.urlService.transform({
                cxRoute: 'product',
                params: { code: data.product },
            });
        }
        else if (data.category) {
            this.routerLink = this.urlService.transform({
                cxRoute: 'category',
                params: { code: data.category },
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: VideoComponent, deps: [{ token: CmsComponentData }, { token: MediaService }, { token: i1.SemanticPathService }, { token: i1.CmsService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: VideoComponent, isStandalone: false, selector: "cx-video", host: { properties: { "class": "this.styleClasses" } }, ngImport: i0, template: "<div\n  *ngIf=\"data$ | async as data; else loading\"\n  class=\"video-container\"\n  tabindex=\"-1\"\n>\n  <a *ngIf=\"data.overlayTitle\" [routerLink]=\"routerLink\">{{\n    data.overlayTitle\n  }}</a>\n  <video\n    *ngIf=\"source\"\n    [style.height.px]=\"data.videoContainerHeight\"\n    controls\n    [poster]=\"thumbnail?.src\"\n    [loop]=\"loop\"\n    [autoplay]=\"autoPlay\"\n    [muted]=\"mute\"\n    [attr.aria-label]=\"'player.label' | cxTranslate\"\n    [src]=\"source\"\n  ></video>\n</div>\n\n<ng-template #loading>\n  <div class=\"cx-spinner\"><cx-spinner></cx-spinner></div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: VideoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-video', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div\n  *ngIf=\"data$ | async as data; else loading\"\n  class=\"video-container\"\n  tabindex=\"-1\"\n>\n  <a *ngIf=\"data.overlayTitle\" [routerLink]=\"routerLink\">{{\n    data.overlayTitle\n  }}</a>\n  <video\n    *ngIf=\"source\"\n    [style.height.px]=\"data.videoContainerHeight\"\n    controls\n    [poster]=\"thumbnail?.src\"\n    [loop]=\"loop\"\n    [autoplay]=\"autoPlay\"\n    [muted]=\"mute\"\n    [attr.aria-label]=\"'player.label' | cxTranslate\"\n    [src]=\"source\"\n  ></video>\n</div>\n\n<ng-template #loading>\n  <div class=\"cx-spinner\"><cx-spinner></cx-spinner></div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: MediaService }, { type: i1.SemanticPathService }, { type: i1.CmsService }, { type: i0.ChangeDetectorRef }], propDecorators: { styleClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class VideoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: VideoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: VideoModule, declarations: [VideoComponent], imports: [CommonModule,
            RouterModule,
            GenericLinkModule,
            MediaModule,
            I18nModule,
            SpinnerModule], exports: [VideoComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: VideoModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    VideoComponent: {
                        component: VideoComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            RouterModule,
            GenericLinkModule,
            MediaModule,
            I18nModule,
            SpinnerModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: VideoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        GenericLinkModule,
                        MediaModule,
                        I18nModule,
                        SpinnerModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                VideoComponent: {
                                    component: VideoComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [VideoComponent],
                    exports: [VideoComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyCouponsComponentService {
    constructor(routingService, translation) {
        this.routingService = routingService;
        this.translation = translation;
        this.RELEVANCE = ':relevance';
        this.CUSTOMER_COUPON_CODE = ':customerCouponCode:';
    }
    launchSearchPage(coupon) {
        this.routingService.go({
            cxRoute: 'search',
            params: { query: this.buildSearchParam(coupon) },
        }, {
            queryParams: {
                couponcode: coupon.couponId,
            },
        });
    }
    buildSearchParam(coupon) {
        return coupon.allProductsApplicable
            ? this.RELEVANCE
            : this.RELEVANCE + this.CUSTOMER_COUPON_CODE + coupon.couponId;
    }
    getSortLabels() {
        return combineLatest([
            this.translation.translate('myCoupons.startDateAsc'),
            this.translation.translate('myCoupons.startDateDesc'),
            this.translation.translate('myCoupons.endDateAsc'),
            this.translation.translate('myCoupons.endDateDesc'),
        ]).pipe(map(([textByStartDateAsc, textByStartDateDesc, textByEndDateAsc, textByEndDateDesc,]) => {
            return {
                byStartDateAsc: textByStartDateAsc,
                byStartDateDesc: textByStartDateDesc,
                byEndDateAsc: textByEndDateAsc,
                byEndDateDesc: textByEndDateDesc,
            };
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsComponentService, deps: [{ token: i1.RoutingService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsComponentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsComponentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RoutingService }, { type: i1.TranslationService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CouponCardComponent {
    constructor(myCouponsComponentService, launchDialogService, vcr) {
        this.myCouponsComponentService = myCouponsComponentService;
        this.launchDialogService = launchDialogService;
        this.vcr = vcr;
        this.notificationChanged = new EventEmitter();
    }
    onSubscriptionChange() {
        this.notificationChanged.emit({
            couponId: this.coupon.couponId ?? '',
            notification: !this.coupon.notificationOn,
        });
    }
    readMore() {
        const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.COUPON, this.element, this.vcr, { coupon: this.coupon });
        if (dialog) {
            dialog.pipe(take(1)).subscribe();
        }
    }
    findProducts() {
        this.myCouponsComponentService.launchSearchPage(this.coupon);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CouponCardComponent, deps: [{ token: MyCouponsComponentService }, { token: LaunchDialogService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: CouponCardComponent, isStandalone: false, selector: "cx-coupon-card", inputs: { coupon: "coupon", couponSubscriptionLoading$: "couponSubscriptionLoading$" }, outputs: { notificationChanged: "notificationChanged" }, viewQueries: [{ propertyName: "element", first: true, predicate: ["element"], descendants: true }], ngImport: i0, template: "<div class=\"card\">\n  <div class=\"card-body cx-card-body\">\n    <div class=\"cx-coupon-data\">\n      <div class=\"cx-coupon-card-row top\">\n        <div class=\"cx-coupon-card-head\">\n          <span class=\"card-label-bold cx-coupon-card-id\">{{\n            coupon?.couponId\n          }}</span>\n          <span>: {{ coupon?.name }}</span>\n        </div>\n\n        <div class=\"cx-coupon-status {{ coupon?.status | lowercase }}\">\n          {{ 'myCoupons.' + coupon?.status | cxTranslate }}\n        </div>\n      </div>\n\n      <div class=\"cx-coupon-card-date\">\n        <p>{{ 'myCoupons.effectiveTitle' | cxTranslate }}</p>\n        <div class=\"cx-coupon-date\">\n          <div class=\"cx-coupon-date-start\">\n            {{ coupon?.startDate | cxDate: 'medium' }} -&nbsp;\n          </div>\n          <div class=\"cx-coupon-date-end\">\n            {{ coupon?.endDate | cxDate: 'medium' }}\n          </div>\n        </div>\n      </div>\n      <button\n        class=\"cx-card-read-more link cx-action-link\"\n        (click)=\"readMore()\"\n      >\n        {{ 'myCoupons.readMore' | cxTranslate }}\n      </button>\n      <div class=\"cx-coupon-card-row bottom\">\n        <div class=\"cx-coupon-notification form-check\">\n          <label>\n            <input\n              type=\"checkbox\"\n              class=\"form-check-input\"\n              [checked]=\"coupon?.notificationOn\"\n              [class.disabled]=\"couponSubscriptionLoading$ | async\"\n              [disabled]=\"couponSubscriptionLoading$ | async\"\n              (change)=\"onSubscriptionChange()\"\n            />\n            <span class=\"form-check-label\">\n              {{ 'myCoupons.notification' | cxTranslate }}\n            </span>\n          </label>\n        </div>\n\n        <div class=\"cx-coupon-find-product col-lg-6 col-md-12 col-sm-6\">\n          <button class=\"btn btn-block btn-secondary\" (click)=\"findProducts()\">\n            {{ 'myCoupons.findProducts' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.LowerCasePipe, name: "lowercase" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.CxDatePipe, name: "cxDate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CouponCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-coupon-card', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div class=\"card\">\n  <div class=\"card-body cx-card-body\">\n    <div class=\"cx-coupon-data\">\n      <div class=\"cx-coupon-card-row top\">\n        <div class=\"cx-coupon-card-head\">\n          <span class=\"card-label-bold cx-coupon-card-id\">{{\n            coupon?.couponId\n          }}</span>\n          <span>: {{ coupon?.name }}</span>\n        </div>\n\n        <div class=\"cx-coupon-status {{ coupon?.status | lowercase }}\">\n          {{ 'myCoupons.' + coupon?.status | cxTranslate }}\n        </div>\n      </div>\n\n      <div class=\"cx-coupon-card-date\">\n        <p>{{ 'myCoupons.effectiveTitle' | cxTranslate }}</p>\n        <div class=\"cx-coupon-date\">\n          <div class=\"cx-coupon-date-start\">\n            {{ coupon?.startDate | cxDate: 'medium' }} -&nbsp;\n          </div>\n          <div class=\"cx-coupon-date-end\">\n            {{ coupon?.endDate | cxDate: 'medium' }}\n          </div>\n        </div>\n      </div>\n      <button\n        class=\"cx-card-read-more link cx-action-link\"\n        (click)=\"readMore()\"\n      >\n        {{ 'myCoupons.readMore' | cxTranslate }}\n      </button>\n      <div class=\"cx-coupon-card-row bottom\">\n        <div class=\"cx-coupon-notification form-check\">\n          <label>\n            <input\n              type=\"checkbox\"\n              class=\"form-check-input\"\n              [checked]=\"coupon?.notificationOn\"\n              [class.disabled]=\"couponSubscriptionLoading$ | async\"\n              [disabled]=\"couponSubscriptionLoading$ | async\"\n              (change)=\"onSubscriptionChange()\"\n            />\n            <span class=\"form-check-label\">\n              {{ 'myCoupons.notification' | cxTranslate }}\n            </span>\n          </label>\n        </div>\n\n        <div class=\"cx-coupon-find-product col-lg-6 col-md-12 col-sm-6\">\n          <button class=\"btn btn-block btn-secondary\" (click)=\"findProducts()\">\n            {{ 'myCoupons.findProducts' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: MyCouponsComponentService }, { type: LaunchDialogService }, { type: i0.ViewContainerRef }], propDecorators: { coupon: [{
                type: Input
            }], couponSubscriptionLoading$: [{
                type: Input
            }], notificationChanged: [{
                type: Output
            }], element: [{
                type: ViewChild,
                args: ['element']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyCouponsComponent {
    constructor(couponService, myCouponsComponentService) {
        this.couponService = couponService;
        this.myCouponsComponentService = myCouponsComponentService;
        this.iconTypes = ICON_TYPE;
        this.subscriptions = new Subscription();
        this.PAGE_SIZE = 10;
        this.sortMapping = {
            byStartDateAsc: 'startDate:asc',
            byStartDateDesc: 'startDate:desc',
            byEndDateAsc: 'endDate:asc',
            byEndDateDesc: 'endDate:desc',
        };
        this.sort = 'byStartDateAsc';
        this.sortOptions = [
            {
                code: 'byStartDateAsc',
                selected: false,
            },
            {
                code: 'byStartDateDesc',
                selected: false,
            },
            {
                code: 'byEndDateAsc',
                selected: false,
            },
            {
                code: 'byEndDateDesc',
                selected: false,
            },
        ];
        this.launchDialogService = inject(LaunchDialogService);
    }
    ngOnInit() {
        this.couponResult$ = this.couponService
            .getCustomerCoupons(this.PAGE_SIZE)
            .pipe(tap((coupons) => (this.pagination = {
            currentPage: coupons.pagination?.page,
            pageSize: coupons.pagination?.count,
            totalPages: coupons.pagination?.totalPages,
            totalResults: coupons.pagination?.totalCount,
            sort: this.sort,
        })));
        this.couponsLoading$ = this.couponService.getCustomerCouponsLoading();
        this.couponSubscriptionLoading$ = combineLatest([
            this.couponService.getSubscribeCustomerCouponResultLoading(),
            this.couponService.getUnsubscribeCustomerCouponResultLoading(),
        ]).pipe(map(([subscribing, unsubscribing]) => subscribing || unsubscribing));
        this.sortLabels = this.myCouponsComponentService.getSortLabels();
        this.subscriptions.add(this.couponService
            .getSubscribeCustomerCouponResultError()
            .subscribe((error) => {
            this.subscriptionFail(error);
        }));
        this.subscriptions.add(this.couponService
            .getUnsubscribeCustomerCouponResultError()
            .subscribe((error) => {
            this.subscriptionFail(error);
        }));
        const resultStr = decodeURIComponent(this.getHashStr());
        const index = resultStr.indexOf('#');
        if (index !== -1) {
            const couponCode = resultStr.substring(index + 1);
            if (couponCode !== undefined && couponCode.length > 0) {
                this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.CLAIM_DIALOG, undefined, { coupon: couponCode, pageSize: this.PAGE_SIZE });
            }
        }
    }
    getHashStr() {
        return location.hash;
    }
    subscriptionFail(error) {
        if (error) {
            this.couponService.loadCustomerCoupons(this.PAGE_SIZE);
        }
    }
    sortChange(sort) {
        this.sort = sort;
        this.couponService.loadCustomerCoupons(this.PAGE_SIZE, this.pagination.currentPage, this.sortMapping[sort]);
    }
    pageChange(page) {
        this.couponService.loadCustomerCoupons(this.PAGE_SIZE, page, this.sortMapping[this.sort]);
    }
    notificationChange({ couponId, notification, }) {
        if (notification) {
            this.couponService.subscribeCustomerCoupon(couponId);
        }
        else {
            this.couponService.unsubscribeCustomerCoupon(couponId);
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsComponent, deps: [{ token: i1.CustomerCouponService }, { token: MyCouponsComponentService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MyCouponsComponent, isStandalone: false, selector: "cx-my-coupons", ngImport: i0, template: "<div class=\"cx-section\">\n  <ng-container *ngIf=\"!(couponsLoading$ | async); else loading\">\n    <ng-container *ngIf=\"couponResult$ | async as couponResult\">\n      <div class=\"cx-my-coupons-header\">\n        <h2>\n          {{ 'myCoupons.myCoupons' | cxTranslate }}\n        </h2>\n      </div>\n      <ng-container\n        *ngIf=\"\n          couponResult.pagination &&\n            couponResult.pagination.totalCount &&\n            couponResult.pagination.totalCount > 0;\n          else noCoupons\n        \"\n      >\n        <div class=\"cx-my-coupons-sort top row\">\n          <label\n            class=\"cx-my-coupons-form-group form-group col-sm-12 col-md-4 col-lg-4\"\n          >\n            <span>{{ 'myCoupons.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"sortOptions\"\n              [sortLabels]=\"sortLabels | async\"\n              (sortListEvent)=\"sortChange($event)\"\n              [selectedOption]=\"sort\"\n              [ariaLabel]=\"'myCoupons.sortCoupons' | cxTranslate\"\n              ariaControls=\"coupon-deck\"\n            >\n            </cx-sorting>\n          </label>\n          <div class=\"cx-my-coupons-pagination cx-mycoupon-thead-mobile\">\n            <cx-pagination\n              [pagination]=\"pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-top\"\n            ></cx-pagination>\n          </div>\n        </div>\n\n        <div id=\"coupon-deck\" class=\"row cx-coupon-deck\">\n          <div\n            *ngFor=\"let coupon of couponResult.coupons\"\n            class=\"col-md-6 cx-coupon-card\"\n          >\n            <cx-coupon-card\n              [coupon]=\"coupon\"\n              [couponSubscriptionLoading$]=\"couponSubscriptionLoading$\"\n              (notificationChanged)=\"notificationChange($event)\"\n            ></cx-coupon-card>\n          </div>\n        </div>\n\n        <div class=\"cx-my-coupons-sort bottom row\">\n          <label\n            class=\"cx-my-coupons-form-group form-group cx-mycoupon-thead-mobile col-sm-12 col-md-4 col-lg-4\"\n          >\n            <span>{{ 'myCoupons.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"sortOptions\"\n              [sortLabels]=\"sortLabels | async\"\n              (sortListEvent)=\"sortChange($event)\"\n              [selectedOption]=\"sort\"\n              placeholder=\"{{ 'myCoupons.sortBy' | cxTranslate }}\"\n              [ariaLabel]=\"'myCoupons.sortCoupons' | cxTranslate\"\n              ariaControls=\"coupon-deck\"\n            >\n            </cx-sorting>\n          </label>\n          <div class=\"cx-my-coupons-pagination\">\n            <cx-pagination\n              [pagination]=\"pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-bottom\"\n            ></cx-pagination>\n          </div>\n        </div>\n        <div class=\"cx-my-coupons-notes\">\n          <span>\n            <cx-icon [type]=\"iconTypes.INFO\"></cx-icon>\n            {{ 'myCoupons.notesPreffix' | cxTranslate\n            }}<a [routerLink]=\"['/my-account/notification-preference']\">{{\n              'myCoupons.notesLink' | cxTranslate\n            }}</a\n            >{{ 'myCoupons.notesSuffix' | cxTranslate }}</span\n          >\n        </div>\n      </ng-container>\n    </ng-container>\n\n    <ng-template #noCoupons>\n      <section>\n        <p class=\"cx-section-msg\">\n          {{ 'myCoupons.noCouponsMessage' | cxTranslate }}\n        </p>\n      </section>\n    </ng-template>\n  </ng-container>\n\n  <ng-template #loading>\n    <div class=\"col-md-12 cx-coupon-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "component", type: SortingComponent, selector: "cx-sorting", inputs: ["sortOptions", "ariaControls", "ariaLabel", "selectedOption", "placeholder", "sortLabels"], outputs: ["sortListEvent"] }, { kind: "component", type: PaginationComponent, selector: "cx-pagination", inputs: ["pageRoute", "queryParam", "defaultPage", "pagination", "paginationID"], outputs: ["viewPageEvent"] }, { kind: "component", type: CouponCardComponent, selector: "cx-coupon-card", inputs: ["coupon", "couponSubscriptionLoading$"], outputs: ["notificationChanged"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-my-coupons', standalone: false, template: "<div class=\"cx-section\">\n  <ng-container *ngIf=\"!(couponsLoading$ | async); else loading\">\n    <ng-container *ngIf=\"couponResult$ | async as couponResult\">\n      <div class=\"cx-my-coupons-header\">\n        <h2>\n          {{ 'myCoupons.myCoupons' | cxTranslate }}\n        </h2>\n      </div>\n      <ng-container\n        *ngIf=\"\n          couponResult.pagination &&\n            couponResult.pagination.totalCount &&\n            couponResult.pagination.totalCount > 0;\n          else noCoupons\n        \"\n      >\n        <div class=\"cx-my-coupons-sort top row\">\n          <label\n            class=\"cx-my-coupons-form-group form-group col-sm-12 col-md-4 col-lg-4\"\n          >\n            <span>{{ 'myCoupons.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"sortOptions\"\n              [sortLabels]=\"sortLabels | async\"\n              (sortListEvent)=\"sortChange($event)\"\n              [selectedOption]=\"sort\"\n              [ariaLabel]=\"'myCoupons.sortCoupons' | cxTranslate\"\n              ariaControls=\"coupon-deck\"\n            >\n            </cx-sorting>\n          </label>\n          <div class=\"cx-my-coupons-pagination cx-mycoupon-thead-mobile\">\n            <cx-pagination\n              [pagination]=\"pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-top\"\n            ></cx-pagination>\n          </div>\n        </div>\n\n        <div id=\"coupon-deck\" class=\"row cx-coupon-deck\">\n          <div\n            *ngFor=\"let coupon of couponResult.coupons\"\n            class=\"col-md-6 cx-coupon-card\"\n          >\n            <cx-coupon-card\n              [coupon]=\"coupon\"\n              [couponSubscriptionLoading$]=\"couponSubscriptionLoading$\"\n              (notificationChanged)=\"notificationChange($event)\"\n            ></cx-coupon-card>\n          </div>\n        </div>\n\n        <div class=\"cx-my-coupons-sort bottom row\">\n          <label\n            class=\"cx-my-coupons-form-group form-group cx-mycoupon-thead-mobile col-sm-12 col-md-4 col-lg-4\"\n          >\n            <span>{{ 'myCoupons.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"sortOptions\"\n              [sortLabels]=\"sortLabels | async\"\n              (sortListEvent)=\"sortChange($event)\"\n              [selectedOption]=\"sort\"\n              placeholder=\"{{ 'myCoupons.sortBy' | cxTranslate }}\"\n              [ariaLabel]=\"'myCoupons.sortCoupons' | cxTranslate\"\n              ariaControls=\"coupon-deck\"\n            >\n            </cx-sorting>\n          </label>\n          <div class=\"cx-my-coupons-pagination\">\n            <cx-pagination\n              [pagination]=\"pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-bottom\"\n            ></cx-pagination>\n          </div>\n        </div>\n        <div class=\"cx-my-coupons-notes\">\n          <span>\n            <cx-icon [type]=\"iconTypes.INFO\"></cx-icon>\n            {{ 'myCoupons.notesPreffix' | cxTranslate\n            }}<a [routerLink]=\"['/my-account/notification-preference']\">{{\n              'myCoupons.notesLink' | cxTranslate\n            }}</a\n            >{{ 'myCoupons.notesSuffix' | cxTranslate }}</span\n          >\n        </div>\n      </ng-container>\n    </ng-container>\n\n    <ng-template #noCoupons>\n      <section>\n        <p class=\"cx-section-msg\">\n          {{ 'myCoupons.noCouponsMessage' | cxTranslate }}\n        </p>\n      </section>\n    </ng-template>\n  </ng-container>\n\n  <ng-template #loading>\n    <div class=\"col-md-12 cx-coupon-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.CustomerCouponService }, { type: MyCouponsComponentService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CouponDialogComponent {
    handleClick(event) {
        if (event.target.tagName === this.el.nativeElement.tagName) {
            this.close('Cross click');
        }
    }
    constructor(launchDialogService, el) {
        this.launchDialogService = launchDialogService;
        this.el = el;
        this.subscription = new Subscription();
        this.iconTypes = ICON_TYPE;
        this.focusConfig = {
            trap: true,
            block: true,
            autofocus: 'button',
            focusOnEscape: true,
        };
    }
    ngOnInit() {
        this.subscription.add(this.launchDialogService.data$.subscribe((data) => {
            if (data) {
                this.coupon = data.coupon;
            }
        }));
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
    close(reason) {
        this.launchDialogService.closeDialog(reason);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CouponDialogComponent, deps: [{ token: LaunchDialogService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: CouponDialogComponent, isStandalone: false, selector: "cx-coupon-dialog", host: { listeners: { "click": "handleClick($event)" } }, ngImport: i0, template: "<div\n  class=\"modal-dialog modal-dialog-centered cx-coupon-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content cx-coupon-container\">\n    <!-- Modal Header -->\n\n    <div class=\"cx-dialog-header modal-header\">\n      <h3 id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n        {{ 'myCoupons.dialogTitle' | cxTranslate }}\n      </h3>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        (click)=\"close('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <div class=\"cx-dialog-row\">\n        <div class=\"cx-dialog-item col-sm-12 col-md-12\">\n          <div class=\"cx-coupon-card-head\">\n            <span class=\"card-label-bold cx-coupon-card-id\">{{\n              coupon?.couponId\n            }}</span>\n            <span>: {{ coupon?.name }}</span>\n          </div>\n          <div class=\"cx-coupon-description\">{{ coupon?.description }}</div>\n\n          <div class=\"cx-coupon-dialog-date\">\n            <p>{{ 'myCoupons.effectiveTitle' | cxTranslate }}</p>\n            <div class=\"cx-coupon-date\">\n              {{ coupon?.startDate | cxDate: 'medium' }} -\n              {{ coupon?.endDate | cxDate: 'medium' }}\n            </div>\n          </div>\n\n          <div class=\"cx-coupon-dialog-status\">\n            <p>{{ 'myCoupons.status' | cxTranslate }}</p>\n            <div class=\"cx-coupon-status {{ coupon?.status | lowercase }}\">\n              {{ 'myCoupons.' + coupon?.status | cxTranslate }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "pipe", type: i3.LowerCasePipe, name: "lowercase" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.CxDatePipe, name: "cxDate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CouponDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-coupon-dialog', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div\n  class=\"modal-dialog modal-dialog-centered cx-coupon-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content cx-coupon-container\">\n    <!-- Modal Header -->\n\n    <div class=\"cx-dialog-header modal-header\">\n      <h3 id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n        {{ 'myCoupons.dialogTitle' | cxTranslate }}\n      </h3>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        (click)=\"close('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <div class=\"cx-dialog-row\">\n        <div class=\"cx-dialog-item col-sm-12 col-md-12\">\n          <div class=\"cx-coupon-card-head\">\n            <span class=\"card-label-bold cx-coupon-card-id\">{{\n              coupon?.couponId\n            }}</span>\n            <span>: {{ coupon?.name }}</span>\n          </div>\n          <div class=\"cx-coupon-description\">{{ coupon?.description }}</div>\n\n          <div class=\"cx-coupon-dialog-date\">\n            <p>{{ 'myCoupons.effectiveTitle' | cxTranslate }}</p>\n            <div class=\"cx-coupon-date\">\n              {{ coupon?.startDate | cxDate: 'medium' }} -\n              {{ coupon?.endDate | cxDate: 'medium' }}\n            </div>\n          </div>\n\n          <div class=\"cx-coupon-dialog-status\">\n            <p>{{ 'myCoupons.status' | cxTranslate }}</p>\n            <div class=\"cx-coupon-status {{ coupon?.status | lowercase }}\">\n              {{ 'myCoupons.' + coupon?.status | cxTranslate }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: LaunchDialogService }, { type: i0.ElementRef }], propDecorators: { handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CouponClaimComponent {
    constructor(couponService, routingService, messageService) {
        this.couponService = couponService;
        this.routingService = routingService;
        this.messageService = messageService;
    }
    ngOnInit() {
        this.routingService
            .getRouterState()
            .subscribe((k) => {
            const couponCode = k.state.params.couponCode;
            if (couponCode) {
                this.couponService.claimCustomerCoupon(couponCode);
                this.subscription = this.couponService
                    .getClaimCustomerCouponResultSuccess()
                    .subscribe((success) => {
                    if (success) {
                        this.messageService.add({ key: 'myCoupons.claimCustomerCoupon' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
                    }
                    this.routingService.go({ cxRoute: 'coupons' });
                });
            }
            else {
                this.routingService.go({ cxRoute: 'notFound' });
            }
        })
            .unsubscribe();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CouponClaimComponent, deps: [{ token: i1.CustomerCouponService }, { token: i1.RoutingService }, { token: i1.GlobalMessageService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: CouponClaimComponent, isStandalone: false, selector: "cx-coupon-claim", ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CouponClaimComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'cx-coupon-claim',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i1.CustomerCouponService }, { type: i1.RoutingService }, { type: i1.GlobalMessageService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ClaimDialogComponent {
    constructor() {
        this.subscription = new Subscription();
        this.iconTypes = ICON_TYPE;
        this.pageSize = 10;
        this.focusConfig = {
            trap: true,
            block: true,
            autofocus: 'button',
            focusOnEscape: true,
        };
        this.form = new FormGroup({
            couponCode: new FormControl('', [Validators.required]),
        });
        this.couponService = inject(CustomerCouponService);
        this.routingService = inject(RoutingService);
        this.messageService = inject(GlobalMessageService);
        this.launchDialogService = inject(LaunchDialogService);
    }
    ngOnInit() {
        this.subscription.add(this.launchDialogService.data$.subscribe((data) => {
            if (data) {
                this.couponCode = data.coupon;
                this.pageSize = data.pageSize;
                this.form.get('couponCode').setValue(this.couponCode);
            }
        }));
    }
    onSubmit() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        const couponVal = this.form.get('couponCode').value;
        if (couponVal) {
            this.couponService.claimCustomerCoupon(couponVal);
            this.subscription = this.couponService
                .getClaimCustomerCouponResultSuccess()
                .subscribe((success) => {
                if (success) {
                    this.messageService.add({ key: 'myCoupons.claimCustomerCoupon' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
                }
                this.routingService.go({ cxRoute: 'coupons' });
                this.couponService.loadCustomerCoupons(this.pageSize);
                this.close('Cross click');
            });
        }
        else {
            this.routingService.go({ cxRoute: 'notFound' });
        }
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
    close(reason) {
        this.launchDialogService.closeDialog(reason);
    }
    cancelEdit() {
        this.form.get('couponCode').setValue(this.couponCode);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ClaimDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ClaimDialogComponent, isStandalone: false, selector: "cx-claim-dialog", ngImport: i0, template: "<div\n  class=\"cx-coupon-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"cx-coupon-container\">\n    <!-- Modal Header -->\n\n    <div class=\"cx-dialog-header modal-header\">\n      <h3 id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n        {{ 'myCoupons.claimCoupondialogTitle' | cxTranslate }}\n      </h3>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        (click)=\"close('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\" class=\"cx-dialog-item\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'myCoupons.claimCouponCode.label' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            type=\"text\"\n            name=\"couponCode\"\n            formControlName=\"couponCode\"\n            placeholder=\"{{\n              'myCoupons.claimCouponCode.placeholder' | cxTranslate\n            }}\"\n            class=\"form-control\"\n            [attr.aria-invalid]=\"\n              form.get('couponCode')?.touched && form.get('couponCode')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'couponCodeError'\"\n          />\n          <cx-form-errors\n            id=\"couponCodeError\"\n            [translationParams]=\"{\n              label: 'myCoupons.claimCouponCode.label' | cxTranslate,\n            }\"\n            [control]=\"form.get('couponCode')\"\n          ></cx-form-errors>\n        </label>\n        <div class=\"cx-dialog-row\">\n          <div class=\"col-md-6 cx-dialog-row--reset-button\">\n            <a\n              role=\"button\"\n              class=\"btn btn-block btn-secondary\"\n              (click)=\"cancelEdit()\"\n            >\n              {{ 'myCoupons.reset' | cxTranslate }}\n            </a>\n          </div>\n          <div class=\"col-md-6 cx-dialog-row-submit-button\">\n            <button\n              class=\"btn btn-block btn-primary\"\n              [disabled]=\"form.disabled\"\n            >\n              {{ 'myCoupons.claim' | cxTranslate }}\n            </button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: FormErrorsComponent, selector: "cx-form-errors", inputs: ["prefix", "fallbackPrefix", "translationParams", "control"] }, { kind: "component", type: FormRequiredAsterisksComponent, selector: "cx-form-required-asterisks", inputs: ["titleTranslation"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ClaimDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-claim-dialog', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div\n  class=\"cx-coupon-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"cx-coupon-container\">\n    <!-- Modal Header -->\n\n    <div class=\"cx-dialog-header modal-header\">\n      <h3 id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n        {{ 'myCoupons.claimCoupondialogTitle' | cxTranslate }}\n      </h3>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        (click)=\"close('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\" class=\"cx-dialog-item\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'myCoupons.claimCouponCode.label' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            type=\"text\"\n            name=\"couponCode\"\n            formControlName=\"couponCode\"\n            placeholder=\"{{\n              'myCoupons.claimCouponCode.placeholder' | cxTranslate\n            }}\"\n            class=\"form-control\"\n            [attr.aria-invalid]=\"\n              form.get('couponCode')?.touched && form.get('couponCode')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'couponCodeError'\"\n          />\n          <cx-form-errors\n            id=\"couponCodeError\"\n            [translationParams]=\"{\n              label: 'myCoupons.claimCouponCode.label' | cxTranslate,\n            }\"\n            [control]=\"form.get('couponCode')\"\n          ></cx-form-errors>\n        </label>\n        <div class=\"cx-dialog-row\">\n          <div class=\"col-md-6 cx-dialog-row--reset-button\">\n            <a\n              role=\"button\"\n              class=\"btn btn-block btn-secondary\"\n              (click)=\"cancelEdit()\"\n            >\n              {{ 'myCoupons.reset' | cxTranslate }}\n            </a>\n          </div>\n          <div class=\"col-md-6 cx-dialog-row-submit-button\">\n            <button\n              class=\"btn btn-block btn-primary\"\n              [disabled]=\"form.disabled\"\n            >\n              {{ 'myCoupons.claim' | cxTranslate }}\n            </button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n" }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCouponLayoutConfig = {
    launch: {
        COUPON: {
            inlineRoot: true,
            component: CouponDialogComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
        CLAIM_DIALOG: {
            inlineRoot: true,
            component: ClaimDialogComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyCouponsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsModule, declarations: [MyCouponsComponent,
            CouponCardComponent,
            CouponDialogComponent,
            CouponClaimComponent,
            ClaimDialogComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormErrorsModule,
            FormRequiredAsterisksComponent,
            CardModule,
            SpinnerModule,
            I18nModule,
            RouterModule,
            UrlModule,
            IconModule,
            ListNavigationModule, i1$2.RouterModule, KeyboardFocusModule,
            FeaturesConfigModule], exports: [MyCouponsComponent, CouponClaimComponent, ClaimDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    MyCouponsComponent: {
                        component: MyCouponsComponent,
                        guards: [AuthGuard],
                    },
                    CouponClaimComponent: {
                        component: CouponClaimComponent,
                        guards: [AuthGuard],
                    },
                    ClaimDialogComponent: {
                        component: ClaimDialogComponent,
                        guards: [AuthGuard],
                    },
                },
            }),
            provideDefaultConfig(defaultCouponLayoutConfig),
        ], imports: [CommonModule,
            ReactiveFormsModule,
            FormErrorsModule,
            FormRequiredAsterisksComponent,
            CardModule,
            SpinnerModule,
            I18nModule,
            RouterModule,
            UrlModule,
            IconModule,
            ListNavigationModule,
            RouterModule.forChild([
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [AuthGuard, CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'couponClaim' },
                },
            ]),
            KeyboardFocusModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyCouponsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormErrorsModule,
                        FormRequiredAsterisksComponent,
                        CardModule,
                        SpinnerModule,
                        I18nModule,
                        RouterModule,
                        UrlModule,
                        IconModule,
                        ListNavigationModule,
                        RouterModule.forChild([
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [AuthGuard, CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'couponClaim' },
                            },
                        ]),
                        KeyboardFocusModule,
                        FeaturesConfigModule,
                    ],
                    declarations: [
                        MyCouponsComponent,
                        CouponCardComponent,
                        CouponDialogComponent,
                        CouponClaimComponent,
                        ClaimDialogComponent,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                MyCouponsComponent: {
                                    component: MyCouponsComponent,
                                    guards: [AuthGuard],
                                },
                                CouponClaimComponent: {
                                    component: CouponClaimComponent,
                                    guards: [AuthGuard],
                                },
                                ClaimDialogComponent: {
                                    component: ClaimDialogComponent,
                                    guards: [AuthGuard],
                                },
                            },
                        }),
                        provideDefaultConfig(defaultCouponLayoutConfig),
                    ],
                    exports: [MyCouponsComponent, CouponClaimComponent, ClaimDialogComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyInterestsComponent {
    constructor(productInterestService, translationService, productService, globalMessageService) {
        this.productInterestService = productInterestService;
        this.translationService = translationService;
        this.productService = productService;
        this.globalMessageService = globalMessageService;
        this.DEFAULT_PAGE_SIZE = 10;
        this.sortMapping = {
            byNameAsc: 'name:asc',
            byNameDesc: 'name:desc',
        };
        this.sortChanged = false;
        this.sort = 'byNameAsc';
        this.sortOptions = [
            {
                code: 'byNameAsc',
                selected: false,
            },
            {
                code: 'byNameDesc',
                selected: false,
            },
        ];
    }
    ngOnInit() {
        this.interests$ = this.productInterestService
            .getAndLoadProductInterests(this.DEFAULT_PAGE_SIZE)
            .pipe(tap((interests) => (this.pagination = {
            currentPage: interests.pagination?.page,
            pageSize: interests.pagination?.count,
            totalPages: interests.pagination?.totalPages,
            totalResults: interests.pagination?.totalCount,
            sort: 'byNameAsc',
        })), tap(() => {
            if (this.sortChanged) {
                this.sortChanged = false;
                this.globalMessageService?.add({ key: 'sorting.pageViewUpdated' }, GlobalMessageType.MSG_TYPE_ASSISTIVE, 500);
            }
        }), map((interest) => ({
            ...interest,
            results: interest.results
                ? interest.results.map((result) => ({
                    ...result,
                    product$: this.getProduct(result),
                }))
                : interest.results,
        })));
        this.getInterestsloading$ =
            this.productInterestService.getProdutInterestsLoading();
        this.isRemoveDisabled$ = combineLatest([
            this.getInterestsloading$,
            this.productInterestService.getRemoveProdutInterestLoading(),
        ]).pipe(map(([getLoading, removeLoading]) => getLoading || removeLoading));
        this.sortLabels = this.getSortLabels();
    }
    getSortLabels() {
        return combineLatest([
            this.translationService.translate('myInterests.sorting.byNameAsc'),
            this.translationService.translate('myInterests.sorting.byNameDesc'),
        ]).pipe(map(([asc, desc]) => {
            return {
                byNameAsc: asc,
                byNameDesc: desc,
            };
        }));
    }
    getProduct(interest) {
        return this.productService.get(interest.product?.code ?? '', ProductScope.DETAILS);
    }
    removeInterest(relation) {
        this.productInterestService.removeProdutInterest({
            product: relation.product,
            productInterestEntry: relation.productInterestEntry,
        });
    }
    sortChange(sort) {
        this.sort = sort;
        this.sortChanged = true;
        this.productInterestService.loadProductInterests(this.DEFAULT_PAGE_SIZE, 0, this.sortMapping[sort]);
    }
    pageChange(page) {
        this.productInterestService.loadProductInterests(this.DEFAULT_PAGE_SIZE, page, this.sortMapping[this.sort]);
    }
    ngOnDestroy() {
        this.productInterestService.clearProductInterests();
        this.productInterestService.resetRemoveInterestState();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyInterestsComponent, deps: [{ token: i1.UserInterestsService }, { token: i1.TranslationService }, { token: i1.ProductService }, { token: i1.GlobalMessageService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MyInterestsComponent, isStandalone: false, selector: "cx-my-interests", ngImport: i0, template: "<div *ngIf=\"interests$ | async as interests\" class=\"container\">\n  <div class=\"cx-product-interests-title\">\n    <h2>{{ 'myInterests.header' | cxTranslate }}</h2>\n  </div>\n  <div\n    class=\"cx-product-interests-body\"\n    *ngIf=\"!(getInterestsloading$ | async); else loading\"\n  >\n    <ng-container\n      *ngIf=\"\n        interests.pagination &&\n          interests.pagination.totalCount &&\n          interests.pagination.totalCount > 0;\n        else noInterest\n      \"\n    >\n      <div class=\"cx-product-interests-sort top row\">\n        <label\n          class=\"cx-product-interests-form-group form-group col-sm-12 col-md-4 col-lg-4\"\n          ><span>{{ 'myInterests.sortBy' | cxTranslate }}</span>\n          <cx-sorting\n            [sortOptions]=\"sortOptions\"\n            [sortLabels]=\"sortLabels | async\"\n            (sortListEvent)=\"sortChange($event)\"\n            [selectedOption]=\"sort\"\n            placeholder=\"{{ 'myInterests.sortBy' | cxTranslate }}\"\n            [ariaLabel]=\"'myInterests.sortInterests' | cxTranslate\"\n            ariaControls=\"product-interests-table\"\n          >\n          </cx-sorting>\n        </label>\n        <div\n          class=\"cx-product-interests-pagination cx-product-interests-thead-mobile\"\n        >\n          <cx-pagination\n            [pagination]=\"pagination\"\n            (viewPageEvent)=\"pageChange($event)\"\n            paginationID=\"pagination-top\"\n          ></cx-pagination>\n        </div>\n      </div>\n\n      <table\n        id=\"product-interests-table\"\n        class=\"table cx-product-interests-table cx-product-interests-table-list\"\n      >\n        <caption class=\"cx-visually-hidden\">\n          {{\n            'myInterests.caption' | cxTranslate\n          }}\n        </caption>\n        <thead\n          *cxFeature=\"'!a11yTableHeaderReadout'\"\n          class=\"cx-product-interests-thead-mobile cx-product-interests-header\"\n        >\n          <th role=\"columnheader\">\n            {{ 'myInterests.item' | cxTranslate }}\n          </th>\n          <th role=\"columnheader\">\n            {{ 'myInterests.price' | cxTranslate }}\n          </th>\n          <th role=\"columnheader\">\n            {{ 'myInterests.notifications' | cxTranslate }}\n          </th>\n          <th srole=\"columnheader\">\n            {{ 'myInterests.actions' | cxTranslate }}\n          </th>\n        </thead>\n        <thead\n          *cxFeature=\"'a11yTableHeaderReadout'\"\n          class=\"cx-product-interests-thead-mobile cx-product-interests-header\"\n        >\n          <tr>\n            <th>\n              {{ 'myInterests.item' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.price' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.notifications' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.actions' | cxTranslate }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr\n            *ngFor=\"let interest of interests.results\"\n            class=\"cx-product-interests-product-item\"\n            role=\"row\"\n          >\n            <ng-container *ngIf=\"interest.product$ | async as product\">\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-cell-wrapper\">\n                  <div class=\"cx-product-interests-label\">\n                    <a\n                      class=\"cx-product-interests-product-image-link\"\n                      tabindex=\"-1\"\n                      [routerLink]=\"\n                        { cxRoute: 'product', params: product } | cxUrl\n                      \"\n                    >\n                      <cx-media\n                        [container]=\"product.images?.PRIMARY\"\n                        format=\"thumbnail\"\n                      ></cx-media>\n                    </a>\n                  </div>\n\n                  <div class=\"cx-info col-10\">\n                    <div class=\"cx-info-container row\">\n                      <div>\n                        <div *ngIf=\"product.name\" class=\"cx-name\">\n                          <a\n                            class=\"cx-link cx-product-interests-product-code-link\"\n                            [routerLink]=\"\n                              { cxRoute: 'product', params: product } | cxUrl\n                            \"\n                          >\n                            {{ product.name }}\n                          </a>\n                        </div>\n                        <div *ngIf=\"product.code\" class=\"cx-code\">\n                          <span>{{\n                            'myInterests.productId'\n                              | cxTranslate: { code: product.code }\n                          }}</span>\n                        </div>\n\n                        <ng-container\n                          *ngFor=\"let baseOptions of product.baseOptions\"\n                        >\n                          <div\n                            *ngFor=\"\n                              let variant of baseOptions.selected\n                                ?.variantOptionQualifiers\n                            \"\n                            class=\"cx-property\"\n                          >\n                            <div\n                              class=\"cx-label cx-product-interests-variant-name\"\n                            >\n                              {{ variant.name }}\n                            </div>\n                            <div\n                              class=\"cx-value cx-product-interests-variant-value\"\n                            >\n                              {{ variant.value }}\n                            </div>\n                          </div>\n                        </ng-container>\n                        <div\n                          class=\"cx-property\"\n                          *ngIf=\"\n                            product.stock?.stockLevelStatus === 'outOfStock'\n                          \"\n                        >\n                          <div\n                            class=\"cx-label cx-product-interests-product-stock\"\n                          >\n                            {{ 'myInterests.outOfStock' | cxTranslate }}\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-product-price\">\n                  <div class=\"d-md-none cx-product-interests-label\">\n                    {{ 'myInterests.price' | cxTranslate }}\n                  </div>\n                  <span>{{ product.price?.formattedValue }}</span>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-subscriptions\">\n                  <div class=\"d-md-none cx-product-interests-label\">\n                    {{ 'myInterests.notifications' | cxTranslate }}\n                  </div>\n                  <div\n                    class=\"cx-product-interests-notification\"\n                    *ngFor=\"let interestEntry of interest.productInterestEntry\"\n                  >\n                    <span class=\"cx-product-interests-type\">\n                      {{\n                        'myInterests.' + interestEntry.interestType\n                          | cxTranslate\n                      }}\n                    </span>\n                    <span class=\"cx-product-interests-expiration-date\">\n                      {{\n                        'myInterests.expirationDate'\n                          | cxTranslate\n                            : {\n                                expirationDate:\n                                  interestEntry.expirationDate | cxDate,\n                              }\n                      }}\n                    </span>\n                  </div>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-actions cx-product-interests-remove-button\">\n                  <button\n                    type=\"button\"\n                    class=\"cx-product-interests-remove-btn link cx-action-link cx-remove-btn\"\n                    [cxAtMessage]=\"'myInterests.itemRemoved' | cxTranslate\"\n                    [disabled]=\"isRemoveDisabled$ | async\"\n                    (click)=\"removeInterest(interest)\"\n                  >\n                    {{ 'myInterests.remove' | cxTranslate }}\n                  </button>\n                </div>\n              </td>\n            </ng-container>\n          </tr>\n        </tbody>\n      </table>\n\n      <div class=\"cx-product-interests-sort bottom row\">\n        <label\n          class=\"cx-product-interests-form-group cx-product-interests-thead-mobile form-group col-sm-12 col-md-4 col-lg-4\"\n          ><span>{{ 'myInterests.sortBy' | cxTranslate }}</span>\n          <cx-sorting\n            [sortOptions]=\"sortOptions\"\n            [sortLabels]=\"sortLabels | async\"\n            (sortListEvent)=\"sortChange($event)\"\n            [selectedOption]=\"sort\"\n            placeholder=\"{{ 'myInterests.sortBy' | cxTranslate }}\"\n            [ariaLabel]=\"'myInterests.sortInterests' | cxTranslate\"\n            ariaControls=\"product-interests-table\"\n          >\n          </cx-sorting>\n        </label>\n        <div class=\"cx-product-interests-pagination\">\n          <cx-pagination\n            [pagination]=\"pagination\"\n            (viewPageEvent)=\"pageChange($event)\"\n            paginationID=\"pagination-bottom\"\n          ></cx-pagination>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n</div>\n<ng-template #noInterest>\n  <div class=\"cx-product-interests-message\">\n    {{ 'myInterests.noInterests' | cxTranslate }}\n  </div>\n</ng-template>\n<ng-template #loading>\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: AtMessageDirective, selector: "[cxAtMessage]", inputs: ["cxAtMessage"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SortingComponent, selector: "cx-sorting", inputs: ["sortOptions", "ariaControls", "ariaLabel", "selectedOption", "placeholder", "sortLabels"], outputs: ["sortListEvent"] }, { kind: "component", type: PaginationComponent, selector: "cx-pagination", inputs: ["pageRoute", "queryParam", "defaultPage", "pagination", "paginationID"], outputs: ["viewPageEvent"] }, { kind: "component", type: MediaComponent, selector: "cx-media", inputs: ["container", "format", "alt", "role", "loading", "fetchPriority", "elementType", "sizesForImgElement"], outputs: ["loaded"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.CxDatePipe, name: "cxDate" }, { kind: "pipe", type: i1.UrlPipe, name: "cxUrl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyInterestsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-my-interests', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div *ngIf=\"interests$ | async as interests\" class=\"container\">\n  <div class=\"cx-product-interests-title\">\n    <h2>{{ 'myInterests.header' | cxTranslate }}</h2>\n  </div>\n  <div\n    class=\"cx-product-interests-body\"\n    *ngIf=\"!(getInterestsloading$ | async); else loading\"\n  >\n    <ng-container\n      *ngIf=\"\n        interests.pagination &&\n          interests.pagination.totalCount &&\n          interests.pagination.totalCount > 0;\n        else noInterest\n      \"\n    >\n      <div class=\"cx-product-interests-sort top row\">\n        <label\n          class=\"cx-product-interests-form-group form-group col-sm-12 col-md-4 col-lg-4\"\n          ><span>{{ 'myInterests.sortBy' | cxTranslate }}</span>\n          <cx-sorting\n            [sortOptions]=\"sortOptions\"\n            [sortLabels]=\"sortLabels | async\"\n            (sortListEvent)=\"sortChange($event)\"\n            [selectedOption]=\"sort\"\n            placeholder=\"{{ 'myInterests.sortBy' | cxTranslate }}\"\n            [ariaLabel]=\"'myInterests.sortInterests' | cxTranslate\"\n            ariaControls=\"product-interests-table\"\n          >\n          </cx-sorting>\n        </label>\n        <div\n          class=\"cx-product-interests-pagination cx-product-interests-thead-mobile\"\n        >\n          <cx-pagination\n            [pagination]=\"pagination\"\n            (viewPageEvent)=\"pageChange($event)\"\n            paginationID=\"pagination-top\"\n          ></cx-pagination>\n        </div>\n      </div>\n\n      <table\n        id=\"product-interests-table\"\n        class=\"table cx-product-interests-table cx-product-interests-table-list\"\n      >\n        <caption class=\"cx-visually-hidden\">\n          {{\n            'myInterests.caption' | cxTranslate\n          }}\n        </caption>\n        <thead\n          *cxFeature=\"'!a11yTableHeaderReadout'\"\n          class=\"cx-product-interests-thead-mobile cx-product-interests-header\"\n        >\n          <th role=\"columnheader\">\n            {{ 'myInterests.item' | cxTranslate }}\n          </th>\n          <th role=\"columnheader\">\n            {{ 'myInterests.price' | cxTranslate }}\n          </th>\n          <th role=\"columnheader\">\n            {{ 'myInterests.notifications' | cxTranslate }}\n          </th>\n          <th srole=\"columnheader\">\n            {{ 'myInterests.actions' | cxTranslate }}\n          </th>\n        </thead>\n        <thead\n          *cxFeature=\"'a11yTableHeaderReadout'\"\n          class=\"cx-product-interests-thead-mobile cx-product-interests-header\"\n        >\n          <tr>\n            <th>\n              {{ 'myInterests.item' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.price' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.notifications' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.actions' | cxTranslate }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr\n            *ngFor=\"let interest of interests.results\"\n            class=\"cx-product-interests-product-item\"\n            role=\"row\"\n          >\n            <ng-container *ngIf=\"interest.product$ | async as product\">\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-cell-wrapper\">\n                  <div class=\"cx-product-interests-label\">\n                    <a\n                      class=\"cx-product-interests-product-image-link\"\n                      tabindex=\"-1\"\n                      [routerLink]=\"\n                        { cxRoute: 'product', params: product } | cxUrl\n                      \"\n                    >\n                      <cx-media\n                        [container]=\"product.images?.PRIMARY\"\n                        format=\"thumbnail\"\n                      ></cx-media>\n                    </a>\n                  </div>\n\n                  <div class=\"cx-info col-10\">\n                    <div class=\"cx-info-container row\">\n                      <div>\n                        <div *ngIf=\"product.name\" class=\"cx-name\">\n                          <a\n                            class=\"cx-link cx-product-interests-product-code-link\"\n                            [routerLink]=\"\n                              { cxRoute: 'product', params: product } | cxUrl\n                            \"\n                          >\n                            {{ product.name }}\n                          </a>\n                        </div>\n                        <div *ngIf=\"product.code\" class=\"cx-code\">\n                          <span>{{\n                            'myInterests.productId'\n                              | cxTranslate: { code: product.code }\n                          }}</span>\n                        </div>\n\n                        <ng-container\n                          *ngFor=\"let baseOptions of product.baseOptions\"\n                        >\n                          <div\n                            *ngFor=\"\n                              let variant of baseOptions.selected\n                                ?.variantOptionQualifiers\n                            \"\n                            class=\"cx-property\"\n                          >\n                            <div\n                              class=\"cx-label cx-product-interests-variant-name\"\n                            >\n                              {{ variant.name }}\n                            </div>\n                            <div\n                              class=\"cx-value cx-product-interests-variant-value\"\n                            >\n                              {{ variant.value }}\n                            </div>\n                          </div>\n                        </ng-container>\n                        <div\n                          class=\"cx-property\"\n                          *ngIf=\"\n                            product.stock?.stockLevelStatus === 'outOfStock'\n                          \"\n                        >\n                          <div\n                            class=\"cx-label cx-product-interests-product-stock\"\n                          >\n                            {{ 'myInterests.outOfStock' | cxTranslate }}\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-product-price\">\n                  <div class=\"d-md-none cx-product-interests-label\">\n                    {{ 'myInterests.price' | cxTranslate }}\n                  </div>\n                  <span>{{ product.price?.formattedValue }}</span>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-subscriptions\">\n                  <div class=\"d-md-none cx-product-interests-label\">\n                    {{ 'myInterests.notifications' | cxTranslate }}\n                  </div>\n                  <div\n                    class=\"cx-product-interests-notification\"\n                    *ngFor=\"let interestEntry of interest.productInterestEntry\"\n                  >\n                    <span class=\"cx-product-interests-type\">\n                      {{\n                        'myInterests.' + interestEntry.interestType\n                          | cxTranslate\n                      }}\n                    </span>\n                    <span class=\"cx-product-interests-expiration-date\">\n                      {{\n                        'myInterests.expirationDate'\n                          | cxTranslate\n                            : {\n                                expirationDate:\n                                  interestEntry.expirationDate | cxDate,\n                              }\n                      }}\n                    </span>\n                  </div>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-actions cx-product-interests-remove-button\">\n                  <button\n                    type=\"button\"\n                    class=\"cx-product-interests-remove-btn link cx-action-link cx-remove-btn\"\n                    [cxAtMessage]=\"'myInterests.itemRemoved' | cxTranslate\"\n                    [disabled]=\"isRemoveDisabled$ | async\"\n                    (click)=\"removeInterest(interest)\"\n                  >\n                    {{ 'myInterests.remove' | cxTranslate }}\n                  </button>\n                </div>\n              </td>\n            </ng-container>\n          </tr>\n        </tbody>\n      </table>\n\n      <div class=\"cx-product-interests-sort bottom row\">\n        <label\n          class=\"cx-product-interests-form-group cx-product-interests-thead-mobile form-group col-sm-12 col-md-4 col-lg-4\"\n          ><span>{{ 'myInterests.sortBy' | cxTranslate }}</span>\n          <cx-sorting\n            [sortOptions]=\"sortOptions\"\n            [sortLabels]=\"sortLabels | async\"\n            (sortListEvent)=\"sortChange($event)\"\n            [selectedOption]=\"sort\"\n            placeholder=\"{{ 'myInterests.sortBy' | cxTranslate }}\"\n            [ariaLabel]=\"'myInterests.sortInterests' | cxTranslate\"\n            ariaControls=\"product-interests-table\"\n          >\n          </cx-sorting>\n        </label>\n        <div class=\"cx-product-interests-pagination\">\n          <cx-pagination\n            [pagination]=\"pagination\"\n            (viewPageEvent)=\"pageChange($event)\"\n            paginationID=\"pagination-bottom\"\n          ></cx-pagination>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n</div>\n<ng-template #noInterest>\n  <div class=\"cx-product-interests-message\">\n    {{ 'myInterests.noInterests' | cxTranslate }}\n  </div>\n</ng-template>\n<ng-template #loading>\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i1.UserInterestsService }, { type: i1.TranslationService }, { type: i1.ProductService }, { type: i1.GlobalMessageService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyInterestsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyInterestsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MyInterestsModule, declarations: [MyInterestsComponent], imports: [AtMessageModule,
            CommonModule,
            I18nModule,
            ListNavigationModule,
            I18nModule,
            UrlModule,
            MediaModule,
            SpinnerModule, i1$2.RouterModule, FeaturesConfigModule], exports: [MyInterestsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyInterestsModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    MyInterestsComponent: {
                        component: MyInterestsComponent,
                        guards: [AuthGuard],
                    },
                },
            }),
        ], imports: [AtMessageModule,
            CommonModule,
            I18nModule,
            ListNavigationModule,
            I18nModule,
            UrlModule,
            MediaModule,
            SpinnerModule,
            RouterModule.forChild([
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [AuthGuard, CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'myInterests' },
                },
            ]),
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyInterestsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MyInterestsComponent],
                    imports: [
                        AtMessageModule,
                        CommonModule,
                        I18nModule,
                        ListNavigationModule,
                        I18nModule,
                        UrlModule,
                        MediaModule,
                        SpinnerModule,
                        RouterModule.forChild([
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [AuthGuard, CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'myInterests' },
                            },
                        ]),
                        FeaturesConfigModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                MyInterestsComponent: {
                                    component: MyInterestsComponent,
                                    guards: [AuthGuard],
                                },
                            },
                        }),
                    ],
                    exports: [MyInterestsComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NotificationPreferenceComponent {
    constructor(notificationPreferenceService) {
        this.notificationPreferenceService = notificationPreferenceService;
        this.preferences = [];
    }
    ngOnInit() {
        this.notificationPreferenceService.resetNotificationPreferences();
        this.preferences$ = this.notificationPreferenceService
            .getPreferences()
            .pipe(tap((preferences) => (this.preferences = preferences)));
        this.notificationPreferenceService.loadPreferences();
        this.isLoading$ = combineLatest([
            this.notificationPreferenceService.getPreferencesLoading(),
            this.notificationPreferenceService.getUpdatePreferencesResultLoading(),
        ]).pipe(map(([prefsLoading, updateLoading]) => prefsLoading || updateLoading));
    }
    updatePreference(preference) {
        const updatedPreferences = [];
        this.preferences.forEach((p) => {
            if (p.channel === preference.channel) {
                updatedPreferences.push({
                    ...p,
                    enabled: !p.enabled,
                });
            }
            else {
                updatedPreferences.push(p);
            }
        });
        this.notificationPreferenceService.updatePreferences(updatedPreferences);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NotificationPreferenceComponent, deps: [{ token: i1.UserNotificationPreferenceService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: NotificationPreferenceComponent, isStandalone: false, selector: "cx-notification-preference", ngImport: i0, template: "<ng-container *ngIf=\"preferences$ | async as preferences\">\n  <div *ngIf=\"preferences.length > 0; else loading\">\n    <div class=\"row d-flex justify-content-center\">\n      <div class=\"col-md-8\">\n        <fieldset>\n          <legend class=\"pref-header\">\n            {{ 'notificationPreference.message' | cxTranslate }}\n          </legend>\n          <ng-container *ngFor=\"let preference of preferences\">\n            <div *ngIf=\"preference.visible\" class=\"form-check pref-channel\">\n              <input\n                class=\"form-check-input cx-np-checkbox\"\n                role=\"checkbox\"\n                type=\"checkbox\"\n                id=\"{{ preference.channel }}\"\n                [checked]=\"preference.enabled\"\n                (change)=\"updatePreference(preference)\"\n                [disabled]=\"isLoading$ | async\"\n              />\n              <label for=\"{{ preference.channel }}\" class=\"form-check-label\">\n                {{\n                  'notificationPreference.' + preference.channel | cxTranslate\n                }}\n                {{ preference.value }}\n              </label>\n            </div>\n          </ng-container>\n        </fieldset>\n        <p class=\"pref-note\">\n          <strong>{{ 'notificationPreference.note' | cxTranslate }}</strong\n          >{{ 'notificationPreference.noteMessage' | cxTranslate }}\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NotificationPreferenceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-notification-preference', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"preferences$ | async as preferences\">\n  <div *ngIf=\"preferences.length > 0; else loading\">\n    <div class=\"row d-flex justify-content-center\">\n      <div class=\"col-md-8\">\n        <fieldset>\n          <legend class=\"pref-header\">\n            {{ 'notificationPreference.message' | cxTranslate }}\n          </legend>\n          <ng-container *ngFor=\"let preference of preferences\">\n            <div *ngIf=\"preference.visible\" class=\"form-check pref-channel\">\n              <input\n                class=\"form-check-input cx-np-checkbox\"\n                role=\"checkbox\"\n                type=\"checkbox\"\n                id=\"{{ preference.channel }}\"\n                [checked]=\"preference.enabled\"\n                (change)=\"updatePreference(preference)\"\n                [disabled]=\"isLoading$ | async\"\n              />\n              <label for=\"{{ preference.channel }}\" class=\"form-check-label\">\n                {{\n                  'notificationPreference.' + preference.channel | cxTranslate\n                }}\n                {{ preference.value }}\n              </label>\n            </div>\n          </ng-container>\n        </fieldset>\n        <p class=\"pref-note\">\n          <strong>{{ 'notificationPreference.note' | cxTranslate }}</strong\n          >{{ 'notificationPreference.noteMessage' | cxTranslate }}\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i1.UserNotificationPreferenceService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageTitleComponent {
    constructor(component, pageMetaService) {
        this.component = component;
        this.pageMetaService = pageMetaService;
    }
    ngOnInit() {
        this.setTitle();
    }
    ngAfterViewInit() {
        this.lastestTitle$ = this.title$;
    }
    setTitle() {
        this.title$ = this.pageMetaService.getMeta().pipe(filter(isNotNullable), map((meta) => (meta.heading || meta.title) ?? ''));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageTitleComponent, deps: [{ token: CmsComponentData }, { token: i1.PageMetaService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PageTitleComponent, isStandalone: false, selector: "cx-page-title", ngImport: i0, template: "<h1 class=\"cx-visually-hidden\">{{ title$ | async }}</h1>\n", dependencies: [{ kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageTitleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-page-title', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<h1 class=\"cx-visually-hidden\">{{ title$ | async }}</h1>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: i1.PageMetaService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BreadcrumbComponent extends PageTitleComponent {
    constructor(component, pageMetaService, translation) {
        super(component, pageMetaService);
        this.component = component;
        this.pageMetaService = pageMetaService;
        this.translation = translation;
        this.router = inject(Router);
        this.ariaLive$ = this.router.events.pipe(filter((e) => e instanceof NavigationEnd), map(() => {
            return document.activeElement !== document.body;
        }));
    }
    ngOnInit() {
        super.ngOnInit();
        this.setCrumbs();
    }
    setCrumbs() {
        this.crumbs$ = combineLatest([
            this.pageMetaService.getMeta(),
            this.translation.translate('common.home'),
        ]).pipe(map(([meta, textHome]) => meta?.breadcrumbs ? meta.breadcrumbs : [{ label: textHome, link: '/' }]));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: CmsComponentData }, { token: i1.PageMetaService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: BreadcrumbComponent, isStandalone: false, selector: "cx-breadcrumb", usesInheritance: true, ngImport: i0, template: "<nav [attr.aria-label]=\"'common.breadcrumbs' | cxTranslate\" tabindex=\"-1\">\n  <ol [attr.aria-label]=\"'common.breadcrumbs' | cxTranslate\">\n    <li\n      *ngFor=\"\n        let crumb of crumbs$ | async as crumbList;\n        let i = index;\n        let last = last\n      \"\n    >\n      <a\n        [routerLink]=\"crumb.link\"\n        [innerHTML]=\"crumb.label\"\n        [attr.aria-label]=\"\n          last\n            ? ('common.breadcrumbsCurrentPage' | cxTranslate) +\n              ' ' +\n              crumb.label +\n              (i + 1) +\n              ('common.of' | cxTranslate) +\n              crumbList.length\n            : crumb.label +\n              (i + 1) +\n              ('common.of' | cxTranslate) +\n              crumbList.length\n        \"\n      ></a>\n    </li>\n  </ol>\n</nav>\n\n<h1 [attr.aria-live]=\"(ariaLive$ | async) ? 'polite' : null\">\n  {{ title$ | async }}\n</h1>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-breadcrumb', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<nav [attr.aria-label]=\"'common.breadcrumbs' | cxTranslate\" tabindex=\"-1\">\n  <ol [attr.aria-label]=\"'common.breadcrumbs' | cxTranslate\">\n    <li\n      *ngFor=\"\n        let crumb of crumbs$ | async as crumbList;\n        let i = index;\n        let last = last\n      \"\n    >\n      <a\n        [routerLink]=\"crumb.link\"\n        [innerHTML]=\"crumb.label\"\n        [attr.aria-label]=\"\n          last\n            ? ('common.breadcrumbsCurrentPage' | cxTranslate) +\n              ' ' +\n              crumb.label +\n              (i + 1) +\n              ('common.of' | cxTranslate) +\n              crumbList.length\n            : crumb.label +\n              (i + 1) +\n              ('common.of' | cxTranslate) +\n              crumbList.length\n        \"\n      ></a>\n    </li>\n  </ol>\n</nav>\n\n<h1 [attr.aria-live]=\"(ariaLive$ | async) ? 'polite' : null\">\n  {{ title$ | async }}\n</h1>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: i1.PageMetaService }, { type: i1.TranslationService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BreadcrumbModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbModule, declarations: [BreadcrumbComponent], imports: [CommonModule,
            RouterModule,
            PageMetaModule,
            I18nModule,
            FeaturesConfigModule], exports: [BreadcrumbComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    BreadcrumbComponent: {
                        component: BreadcrumbComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            RouterModule,
            PageMetaModule,
            I18nModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        PageMetaModule,
                        I18nModule,
                        FeaturesConfigModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                BreadcrumbComponent: {
                                    component: BreadcrumbComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [BreadcrumbComponent],
                    exports: [BreadcrumbComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NavigationService {
    constructor(cmsService, semanticPathService) {
        this.cmsService = cmsService;
        this.semanticPathService = semanticPathService;
    }
    createNavigation(data$) {
        return combineLatest([data$, this.getNavigationNode(data$)]).pipe(map(([data, nav]) => {
            return {
                title: data.name,
                children: [nav],
            };
        }));
    }
    /**
     * returns an observable with the `NavigationNode` for the given `CmsNavigationComponent`.
     * This function will load the navigation underlying entries and children if they haven't been
     * loaded so far.
     */
    getNavigationNode(data$) {
        if (!data$) {
            return EMPTY;
        }
        return data$.pipe(filter((data) => !!data), switchMap$1((data) => {
            const navigation = data.navigationNode ? data.navigationNode : data;
            return this.cmsService
                .getNavigationEntryItems(navigation.uid ?? '')
                .pipe(tap((items) => {
                if (items === undefined) {
                    this.loadNavigationEntryItems(navigation, true);
                    return;
                }
                // we should check whether the existing node items are what expected
                const expectedItems = [];
                this.loadNavigationEntryItems(navigation, false, expectedItems);
                const existingItems = Object.keys(items).map((key) => items[key].uid ?? '');
                const missingItems = expectedItems.filter((it) => it.id && !existingItems.includes(it.id));
                if (missingItems.length > 0) {
                    this.cmsService.loadNavigationItems(navigation.uid ?? '', missingItems);
                }
            }), filter(Boolean), map((items) => this.populateNavigationNode(navigation, items) ?? {}));
        }));
    }
    /**
     * Loads all navigation entry items' type and id. Dispatch action to load all these items
     * @param nodeData
     * @param root
     * @param itemsList
     */
    loadNavigationEntryItems(nodeData, root, itemsList = []) {
        if (nodeData.entries && nodeData.entries.length > 0) {
            nodeData.entries.forEach((entry) => {
                itemsList.push({
                    superType: entry.itemSuperType,
                    id: entry.itemId,
                });
            });
        }
        if (nodeData.children && nodeData.children.length > 0) {
            nodeData.children.forEach((child) => this.loadNavigationEntryItems(child, false, itemsList));
        }
        if (root && nodeData.uid) {
            this.cmsService.loadNavigationItems(nodeData.uid, itemsList);
        }
    }
    /**
     * Create a new node tree for the view
     * @param nodeData
     * @param items
     */
    populateNavigationNode(nodeData, items) {
        const node = {};
        if (nodeData.title) {
            // the node title will be populated by the first entry (if any)
            // if there's no nodeData.title available
            node.title = nodeData.title;
        }
        // populate style classes to apply CMS driven styling
        if (nodeData.styleClasses) {
            node.styleClasses = nodeData.styleClasses;
        }
        // populate style attributes to apply CMS driven styling
        if (nodeData.styleAttributes) {
            node.styleAttributes = nodeData.styleAttributes;
        }
        if (nodeData.entries && nodeData.entries.length > 0) {
            this.populateLink(node, nodeData.entries[0], items);
        }
        if (nodeData.children?.length > 0) {
            const children = nodeData.children
                .map((child) => this.populateNavigationNode(child, items))
                .filter(Boolean);
            if (children.length > 0) {
                node.children = children;
            }
        }
        // return null in case there are no children
        return Object.keys(node).length === 0 ? null : node;
    }
    /**
     * The node link is driven by the first entry.
     */
    populateLink(node, entry, items) {
        const item = items[`${entry.itemId}_${entry.itemSuperType}`];
        // now we only consider CMSLinkComponent
        if (item && entry.itemType === 'CMSLinkComponent') {
            if (!node.title) {
                node.title = item.linkName;
            }
            const url = this.getLink(item);
            // only populate the node link if we have a visible node
            if (node.title && url) {
                node.url = url;
                // the backend provide boolean value for the target
                // in case the link should be opened in a new window
                if (item.target === 'true' || item.target === true) {
                    node.target = '_blank';
                }
            }
            // populate style classes to apply CMS driven styling
            if (item.styleClasses) {
                node.styleClasses = item.styleClasses;
            }
            // populate style attributes to apply CMS driven styling
            if (item.styleAttributes) {
                node.styleAttributes = item.styleAttributes;
            }
        }
    }
    /**
     *
     * Gets the URL or link to a related item (category),
     * also taking into account content pages (contentPageLabelOrId)
     * and product pages (productCode)
     */
    getLink(item) {
        if (item.url) {
            return item.url;
        }
        else if (item.contentPageLabelOrId) {
            return item.contentPageLabelOrId;
        }
        else if (item.categoryCode) {
            return this.semanticPathService.transform({
                cxRoute: 'category',
                params: {
                    code: item.categoryCode,
                    name: item.name,
                },
            });
        }
        else if (item.productCode) {
            return this.semanticPathService.transform({
                cxRoute: 'product',
                params: {
                    code: item.productCode,
                    name: item.name,
                },
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationService, deps: [{ token: i1.CmsService }, { token: i1.SemanticPathService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.CmsService }, { type: i1.SemanticPathService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ARIA_EXPANDED_ATTR = 'aria-expanded';
class NavigationUIComponent {
    onResize() {
        this.resize.next(undefined);
    }
    onArrow(e) {
        this.arrowControls.next(e);
    }
    constructor(router, renderer, elemRef, hamburgerMenuService, winRef, featureConfigService) {
        this.router = router;
        this.renderer = renderer;
        this.elemRef = elemRef;
        this.hamburgerMenuService = hamburgerMenuService;
        this.winRef = winRef;
        this.featureConfigService = featureConfigService;
        /**
         * Include non intractable node titles within the tabbing order.
         */
        this.focusableNodeTitles = false;
        /**
         * the icon type that will be used for navigation nodes
         * with children.
         */
        this.iconType = ICON_TYPE;
        /**
         * Indicates whether the navigation should support flyout.
         * If flyout is set to true, the
         * nested child navigation nodes will only appear on hover or focus.
         */
        this.flyout = true;
        this.isOpen = false;
        this.openNodes = [];
        this.subscriptions = new Subscription();
        this.resize = new EventEmitter();
        this.arrowControls = new Subject();
        this.breakpointService = inject(BreakpointService);
        this.isDesktop$ = this.breakpointService.isUp(BREAKPOINT.lg);
        this.subscriptions.add(this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => this.clear()));
        this.subscriptions.add(this.resize.pipe(debounceTime$1(50)).subscribe(() => {
            this.alignWrappersToRightIfStickOut();
        }));
        useFeatureStyles('a11yOptimizedMenuSpacing');
        useFeatureStyles('a11yNavigationButtonsAriaFixes');
    }
    /**
     * During initialization of this component, we will check the resetMenuOnClose flag and attach a menu reset listener if needed.
     */
    ngOnInit() {
        if (this.resetMenuOnClose) {
            this.resetOnMenuCollapse();
        }
    }
    /**
     * This method performs the action of resetting the menu (close all sub menus and return to main options)
     * when the menu is closed.
     */
    resetOnMenuCollapse() {
        this.subscriptions.add(this.hamburgerMenuService?.isExpanded
            .pipe(distinctUntilChanged(), filter(Boolean))
            .subscribe(() => {
            this.reinitializeMenu();
        }));
    }
    closeIfClickedTheSameLink(navNode) {
        if (typeof navNode.url === 'string' &&
            this.winRef.nativeWindow?.location.href.includes(navNode.url)) {
            this.reinitializeMenu();
            this.hamburgerMenuService.toggle();
        }
    }
    /**
     * This method performs the actions required to reset the state of the menu and reset any visual components.
     */
    reinitializeMenu() {
        const listItems = this.elemRef.nativeElement.querySelectorAll('li.is-open:not(.back), li.is-opened');
        listItems.forEach((el) => {
            Array.from(el.children)
                .filter((childNode) => childNode?.tagName === 'BUTTON')
                .forEach((childNode) => {
                this.renderer.setAttribute(childNode, ARIA_EXPANDED_ATTR, 'false');
            });
        });
        listItems.forEach((el) => {
            this.renderer.removeClass(el, 'is-open');
            this.renderer.removeClass(el, 'is-opened');
        });
        this.clear();
        this.renderer.removeClass(this.elemRef.nativeElement, 'is-open');
        this.updateClasses();
    }
    ariaCollapseNodes() {
        this.openNodes.forEach((parentNode) => {
            Array.from(parentNode.children)
                .filter((childNode) => childNode?.tagName === 'BUTTON')
                .forEach((childNode) => {
                this.renderer.setAttribute(childNode, ARIA_EXPANDED_ATTR, 'false');
            });
        });
    }
    toggleOpen(event) {
        if (event.type === 'keydown') {
            event.preventDefault();
        }
        this.ariaCollapseNodes();
        const node = event.currentTarget;
        const parentNode = node.parentNode;
        if (this.openNodes.includes(parentNode)) {
            if (event.type === 'keydown') {
                this.back();
            }
            else {
                this.openNodes = this.openNodes.filter((n) => n !== parentNode);
                this.renderer.removeClass(parentNode, 'is-open');
            }
        }
        else {
            this.openNodes.push(parentNode);
            this.renderer.setAttribute(node, ARIA_EXPANDED_ATTR, 'true');
        }
        this.updateClasses();
        event.stopImmediatePropagation();
        event.stopPropagation();
    }
    /**
     * Opens dropdown and starts keyboard navigation
     */
    onSpace(event) {
        this.hamburgerMenuService.isExpanded
            .pipe(take(1))
            .subscribe((isExpanded) => {
            if (isExpanded) {
                this.toggleOpen(event);
                return;
            }
            if (!this.openNodes.length) {
                this.toggleOpen(event);
                return;
            }
            event.preventDefault();
        });
        this.focusOnNode(event);
        this.setupArrowControls();
    }
    /**
     * Subscribes to arrow keys and enables navigation between dropdown items
     */
    setupArrowControls() {
        this.subscriptions.add(this.arrowControls.subscribe((e) => {
            e.preventDefault();
            const parentElement = e.target.parentElement
                ?.parentElement;
            const nextLink = parentElement?.nextElementSibling?.querySelector('a');
            const previousLink = parentElement?.previousElementSibling?.querySelector('a');
            e.code === 'ArrowDown' ? nextLink?.focus() : previousLink?.focus();
        }));
    }
    /**
     * Focuses on the first focusable element in the dropdown
     */
    focusOnNode(event) {
        if (this.featureConfigService?.isEnabled('a11yNavigationButtonsAriaFixes')) {
            const firstFocusableNode = (event.target)?.nextElementSibling?.querySelector('button, h4, a');
            firstFocusableNode?.focus();
        }
        else {
            const firstFocusableElement = event.target.nextElementSibling?.querySelector('button') || event.target.nextElementSibling?.querySelector('a');
            firstFocusableElement?.focus();
        }
    }
    back() {
        if (this.openNodes[this.openNodes.length - 1]) {
            this.renderer.removeClass(this.openNodes[this.openNodes.length - 1], 'is-open');
            const removedNode = this.openNodes.pop();
            setTimeout(() => {
                (removedNode?.querySelector('[aria-haspopup="true"]')).focus();
            }, 0);
            this.updateClasses();
        }
    }
    clear() {
        this.openNodes = [];
        this.updateClasses();
    }
    onMouseEnter(event) {
        this.alignWrapperToRightIfStickOut(event.currentTarget);
        this.focusAfterPreviousClicked(event);
    }
    getTotalDepth(node, depth = 0) {
        if (node.children && node.children.length > 0) {
            return Math.max(...node.children.map((n) => this.getTotalDepth(n, depth + 1)));
        }
        else {
            return depth;
        }
    }
    getColumnCount(length) {
        if (!this.wrapAfter || length <= 0) {
            return 1;
        }
        let subSectionColumns = Math.floor(length / this.wrapAfter);
        if (subSectionColumns >= 1 && length % this.wrapAfter > 0) {
            subSectionColumns += 1;
        }
        return subSectionColumns;
    }
    focusAfterPreviousClicked(event) {
        const target = ((event.target || event.relatedTarget));
        if (target.ownerDocument.activeElement?.matches('nav[tabindex]') &&
            target.parentElement?.matches('.flyout')) {
            target.focus();
        }
        return target.ownerDocument;
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }
    alignWrapperToRightIfStickOut(node) {
        const wrapper = node.querySelector('.wrapper');
        const body = node.closest('body');
        if (wrapper) {
            this.renderer.removeStyle(wrapper, 'margin-left');
            if (wrapper.offsetLeft + wrapper.offsetWidth >
                body.offsetLeft + body.offsetWidth) {
                this.renderer.setStyle(wrapper, 'margin-left', `${node.offsetWidth - wrapper.offsetWidth}px`);
            }
        }
    }
    alignWrappersToRightIfStickOut() {
        const navs = this.elemRef.nativeElement.childNodes;
        Array.from(navs)
            .filter((node) => node.tagName === 'LI')
            .forEach((nav) => this.alignWrapperToRightIfStickOut(nav));
    }
    updateClasses() {
        this.openNodes.forEach((node, i) => {
            if (i + 1 < this.openNodes.length) {
                this.renderer.addClass(node, 'is-opened');
                this.renderer.removeClass(node, 'is-open');
            }
            else {
                this.renderer.removeClass(node, 'is-opened');
                this.renderer.addClass(node, 'is-open');
            }
        });
        this.isOpen = this.openNodes.length > 0;
    }
    /**
     * Restores default tabbing order for non flyout navigation.
     */
    getTabIndex(node, depth) {
        if (!this.flyout) {
            return 0;
        }
        return depth > 0 && !node?.children ? -1 : 0;
    }
    // TODO: Delete deprecated methods once `a11yNavigationButtonsAriaFixes` feature flag is removed.
    /**
     * Replace spaces with hyphens and convert to lowercase
     * @deprecated
     */
    getSanitizedTitle(title) {
        return title ? title.replace(/\s+/g, '-').toLowerCase() : null;
    }
    /**
     * Returns the value for the `aria-control` and the `aria-label` attribute of a button.
     * @deprecated
     */
    getAriaLabelAndControl(node) {
        return this.getSanitizedTitle(node.title) || null;
    }
    transformIntoValidID(string) {
        return string?.replace(/[^a-zA-Z0-9-_]/g, '-') || null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationUIComponent, deps: [{ token: i1$2.Router }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: HamburgerMenuService }, { token: i1.WindowRef }, { token: i1.FeatureConfigService, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: NavigationUIComponent, isStandalone: false, selector: "cx-navigation-ui", inputs: { node: "node", wrapAfter: "wrapAfter", resetMenuOnClose: "resetMenuOnClose", focusableNodeTitles: "focusableNodeTitles", navAriaLabel: "navAriaLabel", flyout: "flyout", isOpen: "isOpen" }, host: { listeners: { "window:resize": "onResize()", "document:keyDown.arrowUp": "onArrow($event)", "document:keyDown.arrowDown": "onArrow($event)" }, properties: { "class.flyout": "this.flyout", "class.is-open": "this.isOpen" } }, ngImport: i0, template: "<nav [attr.aria-label]=\"navAriaLabel\">\n  <ul\n    [attr.role]=\"\n      flyout && (node?.children?.length ?? 0) > 1 ? 'list' : 'presentation'\n    \"\n  >\n    <li\n      *ngIf=\"flyout && (node?.children?.length ?? 0) > 1\"\n      class=\"back is-open\"\n    >\n      <button (click)=\"back()\">\n        <cx-icon [type]=\"iconType.CARET_LEFT\"></cx-icon>\n        {{ 'common.back' | cxTranslate }}\n      </button>\n    </li>\n\n    <ng-container *ngFor=\"let child of node?.children\">\n      <ng-container *ngTemplateOutlet=\"nav; context: { node: child, depth: 0 }\">\n      </ng-container>\n    </ng-container>\n  </ul>\n</nav>\n<!-- we generate links in a recursive manner -->\n\n<ng-template\n  #nav\n  let-node=\"node\"\n  let-depth=\"depth\"\n  let-listLength=\"listLength\"\n  let-position=\"position\"\n>\n  <li [attr.role]=\"!flyout && !depth ? 'presentation' : 'listitem'\">\n    <cx-generic-link\n      *ngIf=\"\n        node.url && (!node.children || node.children?.length === 0);\n        else heading\n      \"\n      [ariaLabel]=\"\n        'navigation.linkItemInList'\n          | cxTranslate\n            : {\n                title: node.title,\n                position,\n                listLength,\n              }\n      \"\n      [url]=\"node.url\"\n      [target]=\"node.target\"\n      [style]=\"node.styleAttributes\"\n      [class]=\"node.styleClasses\"\n      (click)=\"closeIfClickedTheSameLink(node)\"\n      [tabindex]=\"getTabIndex(node, depth)\"\n      (focus)=\"depth || reinitializeMenu()\"\n      (keydown.space)=\"toggleOpen($any($event))\"\n      (keydown.esc)=\"back()\"\n    >\n      {{ node.title }}\n    </cx-generic-link>\n\n    <ng-template #heading>\n      <ng-container *ngIf=\"flyout && node.children?.length > 0; else title\">\n        <cx-generic-link\n          *ngIf=\"node.url\"\n          [url]=\"node.url\"\n          [target]=\"node.target\"\n          (click)=\"closeIfClickedTheSameLink(node)\"\n        >\n          {{ node.title }}\n        </cx-generic-link>\n        <ng-container *cxFeature=\"'!a11yNavigationButtonsAriaFixes'\">\n          <button\n            aria-level=\"4\"\n            [attr.role]=\"(isDesktop$ | async) && depth ? 'heading' : 'button'\"\n            [attr.aria-haspopup]=\"true\"\n            [attr.aria-expanded]=\"false\"\n            [attr.aria-controls]=\"node.title\"\n            [attr.aria-describedby]=\"'greeting'\"\n            (click)=\"toggleOpen($any($event))\"\n            (mouseenter)=\"onMouseEnter($event)\"\n            (keydown.space)=\"onSpace($any($event))\"\n            (keydown.enter)=\"onSpace($any($event))\"\n            (keydown.esc)=\"back()\"\n            (keydown.arrowDown)=\"focusOnNode($any($event))\"\n            (focus)=\"depth || reinitializeMenu()\"\n          >\n            <ng-container *ngIf=\"!node.url\">\n              {{ node.title }}\n            </ng-container>\n            <cx-icon [type]=\"iconType.CARET_DOWN\"></cx-icon>\n          </button>\n        </ng-container>\n        <ng-container *cxFeature=\"'a11yNavigationButtonsAriaFixes'\">\n          <h4\n            *ngIf=\"(isDesktop$ | async) && depth; else dropdownHeader\"\n            (keydown.arrowDown)=\"focusOnNode($any($event))\"\n            (keydown.space)=\"onSpace($any($event))\"\n            tabindex=\"0\"\n          >\n            {{ node.title }}\n          </h4>\n          <ng-template #dropdownHeader>\n            <button\n              [attr.aria-haspopup]=\"true\"\n              [attr.aria-expanded]=\"false\"\n              [attr.aria-label]=\"node.url ? node.title : null\"\n              [attr.aria-controls]=\"transformIntoValidID(node.title)\"\n              [attr.title]=\"\n                'navigation.menuButonTitle' | cxTranslate: { title: node.title }\n              \"\n              (click)=\"toggleOpen($any($event))\"\n              (mouseenter)=\"onMouseEnter($event)\"\n              (keydown.space)=\"onSpace($any($event))\"\n              (keydown.enter)=\"onSpace($any($event))\"\n              (keydown.esc)=\"back()\"\n              (keydown.arrowDown)=\"focusOnNode($any($event))\"\n              (focus)=\"depth || reinitializeMenu()\"\n            >\n              <ng-container *ngIf=\"!node.url\">\n                {{ node.title }}\n              </ng-container>\n              <cx-icon [type]=\"iconType.CARET_DOWN\"></cx-icon>\n            </button>\n          </ng-template>\n        </ng-container>\n      </ng-container>\n      <ng-template #title>\n        <span\n          role=\"heading\"\n          aria-level=\"4\"\n          *ngIf=\"node.title\"\n          [attr.tabindex]=\"focusableNodeTitles ? 0 : -1\"\n        >\n          {{ node.title }}\n        </span>\n      </ng-template>\n    </ng-template>\n\n    <!-- we add a wrapper to allow for better layout handling in CSS -->\n    <div\n      [id]=\"transformIntoValidID(node.title)\"\n      class=\"wrapper\"\n      *ngIf=\"node.children && node.children.length > 0\"\n    >\n      <ul\n        class=\"childs\"\n        [attr.depth]=\"getTotalDepth(node)\"\n        [attr.wrap-after]=\"node.children.length > wrapAfter ? wrapAfter : null\"\n        [attr.columns]=\"getColumnCount(node.children.length)\"\n        [attr.aria-label]=\"node.title\"\n      >\n        <ng-container *ngFor=\"let child of node.children; index as i\">\n          <ng-container\n            *ngTemplateOutlet=\"\n              nav;\n              context: {\n                node: child,\n                depth: depth + 1,\n                listLength: node.children.length,\n                position: i + 1,\n              }\n            \"\n          >\n          </ng-container>\n        </ng-container>\n      </ul>\n    </div>\n  </li>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "component", type: GenericLinkComponent, selector: "cx-generic-link", inputs: ["url", "target", "id", "class", "style", "title", "ariaLabel", "tabindex"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationUIComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-navigation-ui', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<nav [attr.aria-label]=\"navAriaLabel\">\n  <ul\n    [attr.role]=\"\n      flyout && (node?.children?.length ?? 0) > 1 ? 'list' : 'presentation'\n    \"\n  >\n    <li\n      *ngIf=\"flyout && (node?.children?.length ?? 0) > 1\"\n      class=\"back is-open\"\n    >\n      <button (click)=\"back()\">\n        <cx-icon [type]=\"iconType.CARET_LEFT\"></cx-icon>\n        {{ 'common.back' | cxTranslate }}\n      </button>\n    </li>\n\n    <ng-container *ngFor=\"let child of node?.children\">\n      <ng-container *ngTemplateOutlet=\"nav; context: { node: child, depth: 0 }\">\n      </ng-container>\n    </ng-container>\n  </ul>\n</nav>\n<!-- we generate links in a recursive manner -->\n\n<ng-template\n  #nav\n  let-node=\"node\"\n  let-depth=\"depth\"\n  let-listLength=\"listLength\"\n  let-position=\"position\"\n>\n  <li [attr.role]=\"!flyout && !depth ? 'presentation' : 'listitem'\">\n    <cx-generic-link\n      *ngIf=\"\n        node.url && (!node.children || node.children?.length === 0);\n        else heading\n      \"\n      [ariaLabel]=\"\n        'navigation.linkItemInList'\n          | cxTranslate\n            : {\n                title: node.title,\n                position,\n                listLength,\n              }\n      \"\n      [url]=\"node.url\"\n      [target]=\"node.target\"\n      [style]=\"node.styleAttributes\"\n      [class]=\"node.styleClasses\"\n      (click)=\"closeIfClickedTheSameLink(node)\"\n      [tabindex]=\"getTabIndex(node, depth)\"\n      (focus)=\"depth || reinitializeMenu()\"\n      (keydown.space)=\"toggleOpen($any($event))\"\n      (keydown.esc)=\"back()\"\n    >\n      {{ node.title }}\n    </cx-generic-link>\n\n    <ng-template #heading>\n      <ng-container *ngIf=\"flyout && node.children?.length > 0; else title\">\n        <cx-generic-link\n          *ngIf=\"node.url\"\n          [url]=\"node.url\"\n          [target]=\"node.target\"\n          (click)=\"closeIfClickedTheSameLink(node)\"\n        >\n          {{ node.title }}\n        </cx-generic-link>\n        <ng-container *cxFeature=\"'!a11yNavigationButtonsAriaFixes'\">\n          <button\n            aria-level=\"4\"\n            [attr.role]=\"(isDesktop$ | async) && depth ? 'heading' : 'button'\"\n            [attr.aria-haspopup]=\"true\"\n            [attr.aria-expanded]=\"false\"\n            [attr.aria-controls]=\"node.title\"\n            [attr.aria-describedby]=\"'greeting'\"\n            (click)=\"toggleOpen($any($event))\"\n            (mouseenter)=\"onMouseEnter($event)\"\n            (keydown.space)=\"onSpace($any($event))\"\n            (keydown.enter)=\"onSpace($any($event))\"\n            (keydown.esc)=\"back()\"\n            (keydown.arrowDown)=\"focusOnNode($any($event))\"\n            (focus)=\"depth || reinitializeMenu()\"\n          >\n            <ng-container *ngIf=\"!node.url\">\n              {{ node.title }}\n            </ng-container>\n            <cx-icon [type]=\"iconType.CARET_DOWN\"></cx-icon>\n          </button>\n        </ng-container>\n        <ng-container *cxFeature=\"'a11yNavigationButtonsAriaFixes'\">\n          <h4\n            *ngIf=\"(isDesktop$ | async) && depth; else dropdownHeader\"\n            (keydown.arrowDown)=\"focusOnNode($any($event))\"\n            (keydown.space)=\"onSpace($any($event))\"\n            tabindex=\"0\"\n          >\n            {{ node.title }}\n          </h4>\n          <ng-template #dropdownHeader>\n            <button\n              [attr.aria-haspopup]=\"true\"\n              [attr.aria-expanded]=\"false\"\n              [attr.aria-label]=\"node.url ? node.title : null\"\n              [attr.aria-controls]=\"transformIntoValidID(node.title)\"\n              [attr.title]=\"\n                'navigation.menuButonTitle' | cxTranslate: { title: node.title }\n              \"\n              (click)=\"toggleOpen($any($event))\"\n              (mouseenter)=\"onMouseEnter($event)\"\n              (keydown.space)=\"onSpace($any($event))\"\n              (keydown.enter)=\"onSpace($any($event))\"\n              (keydown.esc)=\"back()\"\n              (keydown.arrowDown)=\"focusOnNode($any($event))\"\n              (focus)=\"depth || reinitializeMenu()\"\n            >\n              <ng-container *ngIf=\"!node.url\">\n                {{ node.title }}\n              </ng-container>\n              <cx-icon [type]=\"iconType.CARET_DOWN\"></cx-icon>\n            </button>\n          </ng-template>\n        </ng-container>\n      </ng-container>\n      <ng-template #title>\n        <span\n          role=\"heading\"\n          aria-level=\"4\"\n          *ngIf=\"node.title\"\n          [attr.tabindex]=\"focusableNodeTitles ? 0 : -1\"\n        >\n          {{ node.title }}\n        </span>\n      </ng-template>\n    </ng-template>\n\n    <!-- we add a wrapper to allow for better layout handling in CSS -->\n    <div\n      [id]=\"transformIntoValidID(node.title)\"\n      class=\"wrapper\"\n      *ngIf=\"node.children && node.children.length > 0\"\n    >\n      <ul\n        class=\"childs\"\n        [attr.depth]=\"getTotalDepth(node)\"\n        [attr.wrap-after]=\"node.children.length > wrapAfter ? wrapAfter : null\"\n        [attr.columns]=\"getColumnCount(node.children.length)\"\n        [attr.aria-label]=\"node.title\"\n      >\n        <ng-container *ngFor=\"let child of node.children; index as i\">\n          <ng-container\n            *ngTemplateOutlet=\"\n              nav;\n              context: {\n                node: child,\n                depth: depth + 1,\n                listLength: node.children.length,\n                position: i + 1,\n              }\n            \"\n          >\n          </ng-container>\n        </ng-container>\n      </ul>\n    </div>\n  </li>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: HamburgerMenuService }, { type: i1.WindowRef }, { type: i1.FeatureConfigService, decorators: [{
                    type: Optional
                }] }], propDecorators: { node: [{
                type: Input
            }], wrapAfter: [{
                type: Input
            }], resetMenuOnClose: [{
                type: Input
            }], focusableNodeTitles: [{
                type: Input
            }], navAriaLabel: [{
                type: Input
            }], flyout: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.flyout']
            }], isOpen: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.is-open']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }], onArrow: [{
                type: HostListener,
                args: ['document:keyDown.arrowUp', ['$event']]
            }, {
                type: HostListener,
                args: ['document:keyDown.arrowDown', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CategoryNavigationComponent {
    constructor(componentData, service) {
        this.componentData = componentData;
        this.service = service;
        this.node$ = this.service.getNavigationNode(this.componentData.data$);
        this.data$ = this.componentData.data$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CategoryNavigationComponent, deps: [{ token: CmsComponentData }, { token: NavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: CategoryNavigationComponent, isStandalone: false, selector: "cx-category-navigation", ngImport: i0, template: "<cx-navigation-ui\n  *ngIf=\"data$ | async as data\"\n  [node]=\"node$ | async\"\n  [ngClass]=\"data.styleClass ?? ''\"\n  [wrapAfter]=\"+(data.wrapAfter ?? '')\"\n  [resetMenuOnClose]=\"data.resetMenuOnClose\"\n  [navAriaLabel]=\"'navigation.categoryNavLabel' | cxTranslate\"\n></cx-navigation-ui>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: NavigationUIComponent, selector: "cx-navigation-ui", inputs: ["node", "wrapAfter", "resetMenuOnClose", "focusableNodeTitles", "navAriaLabel", "flyout", "isOpen"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CategoryNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-category-navigation', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<cx-navigation-ui\n  *ngIf=\"data$ | async as data\"\n  [node]=\"node$ | async\"\n  [ngClass]=\"data.styleClass ?? ''\"\n  [wrapAfter]=\"+(data.wrapAfter ?? '')\"\n  [resetMenuOnClose]=\"data.resetMenuOnClose\"\n  [navAriaLabel]=\"'navigation.categoryNavLabel' | cxTranslate\"\n></cx-navigation-ui>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: NavigationService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NavigationComponent {
    constructor(componentData, service) {
        this.componentData = componentData;
        this.service = service;
        this.node$ = this.service.createNavigation(this.componentData.data$);
        this.name$ = this.componentData.data$.pipe(map((d) => d?.navigationNode?.title));
        this.styleClass$ = this.componentData.data$.pipe(map((d) => d?.styleClass));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationComponent, deps: [{ token: CmsComponentData }, { token: NavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: NavigationComponent, isStandalone: false, selector: "cx-navigation", ngImport: i0, template: "<cx-navigation-ui\n  [node]=\"node$ | async\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"name$ | async\"\n>\n</cx-navigation-ui>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: NavigationUIComponent, selector: "cx-navigation-ui", inputs: ["node", "wrapAfter", "resetMenuOnClose", "focusableNodeTitles", "navAriaLabel", "flyout", "isOpen"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-navigation', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<cx-navigation-ui\n  [node]=\"node$ | async\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"name$ | async\"\n>\n</cx-navigation-ui>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: NavigationService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NavigationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: NavigationModule, declarations: [NavigationComponent, NavigationUIComponent], imports: [CommonModule,
            RouterModule,
            IconModule,
            GenericLinkModule,
            I18nModule,
            FeaturesConfigModule], exports: [NavigationComponent, NavigationUIComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    NavigationComponent: {
                        component: NavigationComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            RouterModule,
            IconModule,
            GenericLinkModule,
            I18nModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        IconModule,
                        GenericLinkModule,
                        I18nModule,
                        FeaturesConfigModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                NavigationComponent: {
                                    component: NavigationComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [NavigationComponent, NavigationUIComponent],
                    exports: [NavigationComponent, NavigationUIComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CategoryNavigationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CategoryNavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: CategoryNavigationModule, declarations: [CategoryNavigationComponent], imports: [CommonModule, NavigationModule, I18nModule], exports: [CategoryNavigationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CategoryNavigationModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    CategoryNavigationComponent: {
                        component: CategoryNavigationComponent,
                        data: {
                            resetMenuOnClose: true,
                        },
                    },
                },
            }),
        ], imports: [CommonModule, NavigationModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: CategoryNavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, NavigationModule, I18nModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                CategoryNavigationComponent: {
                                    component: CategoryNavigationComponent,
                                    data: {
                                        resetMenuOnClose: true,
                                    },
                                },
                            },
                        }),
                    ],
                    declarations: [CategoryNavigationComponent],
                    exports: [CategoryNavigationComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FooterNavigationComponent {
    constructor(componentData, service) {
        this.componentData = componentData;
        this.service = service;
        this.node$ = this.service.getNavigationNode(this.componentData.data$);
        this.styleClass$ = this.componentData.data$.pipe(map((d) => d?.styleClass));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FooterNavigationComponent, deps: [{ token: CmsComponentData }, { token: NavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: FooterNavigationComponent, isStandalone: false, selector: "cx-footer-navigation", ngImport: i0, template: "<cx-navigation-ui\n  *ngIf=\"node$ | async as node\"\n  [node]=\"node\"\n  [flyout]=\"false\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"'navigation.footerNavLabel' | cxTranslate\"\n></cx-navigation-ui>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: NavigationUIComponent, selector: "cx-navigation-ui", inputs: ["node", "wrapAfter", "resetMenuOnClose", "focusableNodeTitles", "navAriaLabel", "flyout", "isOpen"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FooterNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-footer-navigation', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<cx-navigation-ui\n  *ngIf=\"node$ | async as node\"\n  [node]=\"node\"\n  [flyout]=\"false\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"'navigation.footerNavLabel' | cxTranslate\"\n></cx-navigation-ui>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: NavigationService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FooterNavigationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FooterNavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: FooterNavigationModule, declarations: [FooterNavigationComponent], imports: [CommonModule,
            RouterModule,
            NavigationModule,
            GenericLinkModule,
            I18nModule], exports: [FooterNavigationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FooterNavigationModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    FooterNavigationComponent: {
                        component: FooterNavigationComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            RouterModule,
            NavigationModule,
            GenericLinkModule,
            I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FooterNavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        NavigationModule,
                        GenericLinkModule,
                        I18nModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                FooterNavigationComponent: {
                                    component: FooterNavigationComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [FooterNavigationComponent],
                    exports: [FooterNavigationComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageTitleModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageTitleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PageTitleModule, declarations: [PageTitleComponent], imports: [CommonModule, RouterModule, PageMetaModule], exports: [PageTitleComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageTitleModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    PageTitleComponent: {
                        component: PageTitleComponent,
                    },
                },
            }),
        ], imports: [CommonModule, RouterModule, PageMetaModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PageTitleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule, PageMetaModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                PageTitleComponent: {
                                    component: PageTitleComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [PageTitleComponent],
                    exports: [PageTitleComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HighlightPipe {
    transform(text, match, caseSensitive = true) {
        if (!match) {
            return text;
        }
        if (!caseSensitive) {
            const textStartIndex = text.toLowerCase().indexOf(match.toLowerCase());
            const matchLength = match.length;
            return text.replaceAll(text.substring(textStartIndex, textStartIndex + matchLength), `<span class="highlight">${text.substring(textStartIndex, textStartIndex + matchLength)}</span>`);
        }
        return text.replace(match.trim(), `<span class="highlight">${match.trim()}</span>`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HighlightPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: HighlightPipe, isStandalone: false, name: "cxHighlight" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HighlightPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cxHighlight',
                    standalone: false,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that the user chose a suggestion
 */
class SearchBoxSuggestionSelectedEvent extends CxEvent {
    /**
     * Event's type
     */
    static { this.type = 'SearchBoxSuggestionSelectedEvent'; }
}
/**
 * Indicates that the user chose a product suggestion
 */
class SearchBoxProductSelectedEvent extends CxEvent {
    /**
     * Event's type
     */
    static { this.type = 'SearchBoxProductSelectedEvent'; }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const HAS_SEARCH_RESULT_CLASS = 'has-searchbox-results';
class SearchBoxComponentService {
    constructor(searchService, routingService, translationService, winRef, eventService) {
        this.searchService = searchService;
        this.routingService = routingService;
        this.translationService = translationService;
        this.winRef = winRef;
        this.eventService = eventService;
        this.chosenWord = new ReplaySubject();
        this.sharedEvent = new ReplaySubject();
        this.searchCompleted = new BehaviorSubject(false);
        this.enableRecentSearches = false;
        this.enableTrendingSearches = false;
        this.currentQueryLength = 0;
        this.hasKeywordRedirect = false;
    }
    /**
     * Executes the search for products and suggestions,
     * unless the configuration is setup to not search for
     * products or suggestions.
     */
    search(query, config) {
        this.hasKeywordRedirect = false;
        this.currentQueryLength = query ? query.length : 0;
        this.searchCompleted.next(false);
        if (!this.enableRecentSearches &&
            !this.enableTrendingSearches &&
            (!query || query === '')) {
            this.clearResults();
            return;
        }
        if (config.minCharactersBeforeRequest &&
            query.length < config.minCharactersBeforeRequest) {
            return;
        }
        let productsComplete = !config.displayProducts;
        let suggestionsComplete = !config.displaySuggestions;
        if (config.displayProducts) {
            this.searchService
                .searchWithCompletion(query, {
                pageSize: config.maxProducts,
            })
                .subscribe((result) => {
                if (result?.type === ProductActions.SEARCH_PRODUCTS_SUCCESS &&
                    result?.payload?.keywordRedirectUrl) {
                    this.hasKeywordRedirect = true;
                }
                productsComplete = true;
                this.checkSearchCompletion(productsComplete, suggestionsComplete);
            });
        }
        if (config.displaySuggestions) {
            this.searchService
                .searchSuggestionsWithCompletion(query, {
                pageSize: config.maxSuggestions,
            })
                .subscribe((result) => {
                if (result?.type === ProductActions.GET_PRODUCT_SUGGESTIONS_SUCCESS &&
                    result?.payload?.keywordRedirectUrl) {
                    this.hasKeywordRedirect = true;
                }
                suggestionsComplete = true;
                this.checkSearchCompletion(productsComplete, suggestionsComplete);
            });
        }
    }
    /**
     * Check if search operations are complete based on actual completion flags
     */
    checkSearchCompletion(productsComplete, suggestionsComplete) {
        if (productsComplete &&
            suggestionsComplete &&
            this.currentQueryLength > 0) {
            this.searchCompleted.next(true);
        }
    }
    /**
     * Returns an observable with the SearchResults. When there's any
     * result, the body tag will get a classname, so that specific style
     * rules can be applied.
     */
    getResults(config) {
        return combineLatest([
            this.getProductResults(config),
            this.getProductSuggestions(config),
            this.getSearchMessage(config),
        ]).pipe(map(([productResults, suggestions, message]) => {
            return {
                products: productResults ? productResults.products : undefined,
                suggestions,
                message,
            };
        }), tap((results) => this.toggleBodyClass(HAS_SEARCH_RESULT_CLASS, this.hasResults(results))));
    }
    /**
     * Clears the searchbox results, so that old values are
     * no longer emited upon next search.
     */
    clearResults() {
        this.searchService.clearResults();
        this.toggleBodyClass(HAS_SEARCH_RESULT_CLASS, false);
        // Reset search completion state
        this.hasKeywordRedirect = false;
        this.currentQueryLength = 0;
    }
    hasBodyClass(className) {
        return this.winRef.document.body.classList.contains(className);
    }
    toggleBodyClass(className, add) {
        if (add === undefined) {
            this.winRef.document.body.classList.toggle(className);
        }
        else {
            add
                ? this.winRef.document.body.classList.add(className)
                : this.winRef.document.body.classList.remove(className);
        }
    }
    /**
     * Dispatches a searchbox event for product selected
     *
     * @param eventData data for the "SearchBoxProductSelectedEvent"
     */
    dispatchProductSelectedEvent(eventData) {
        this.eventService.dispatch({
            freeText: eventData.freeText,
            productCode: eventData.productCode,
        }, SearchBoxProductSelectedEvent);
    }
    /**
     * Dispatches a searchbox event for suggestion selected
     *
     * @param eventData data for the "SearchBoxSuggestionSelectedEvent"
     */
    dispatchSuggestionSelectedEvent(eventData) {
        this.eventService.dispatch({
            freeText: eventData.freeText,
            selectedSuggestion: eventData.selectedSuggestion,
            searchSuggestions: eventData.searchSuggestions,
        }, SearchBoxSuggestionSelectedEvent);
    }
    /**
     * For search results model, it returns true when:
     * * there is any product OR
     * * the is any search suggestion OR
     * * there is a message.
     *
     * Otherwise it returns false.
     */
    hasResults(results) {
        return ((!!results.products && results.products.length > 0) ||
            (!!results.suggestions && results.suggestions.length > 0) ||
            !!results.message ||
            !!results.recentSearches);
    }
    /**
     * Emits product search results in case when the config property `displayProducts` is true.
     * Otherwise it emits an empty object.
     */
    getProductResults(config) {
        if (config.displayProducts) {
            return this.searchService.getResults();
        }
        else {
            return of({});
        }
    }
    /**
     * Loads suggestions from the backend. In case there's no suggestion
     * available, we try to get an exact match suggestion.
     */
    getProductSuggestions(config) {
        if (!config.displaySuggestions) {
            return of([]);
        }
        else {
            return this.searchService.getSuggestionResults().pipe(map((res) => res.map((suggestion) => suggestion.value).filter(isNotUndefined)), switchMap$1((suggestions) => {
                if (suggestions.length === 0) {
                    return this.getExactSuggestion(config).pipe(map((match) => (match ? [match] : [])));
                }
                else {
                    return of(suggestions);
                }
            }));
        }
    }
    /**
     * Whenever there is at least 1 product, we simulate
     * a suggestion to provide easy access to the search result page
     */
    getExactSuggestion(config) {
        return this.getProductResults(config).pipe(switchMap$1((productResult) => {
            return productResult.products && productResult.products.length > 0
                ? this.fetchTranslation('searchBox.help.exactMatch', {
                    term: productResult.freeTextSearch,
                })
                : of(undefined);
        }));
    }
    /**
     * Emits a 'no match' message, in case the product search results and search suggestions are empty.
     * Otherwise it emits null.
     */
    getSearchMessage(config) {
        return combineLatest([
            this.getProductResults(config),
            this.getProductSuggestions(config),
        ]).pipe(switchMap$1(([productResult, suggestions]) => {
            if (productResult &&
                productResult.products &&
                productResult.products.length === 0 &&
                suggestions &&
                suggestions.length === 0) {
                return this.fetchTranslation('searchBox.help.noMatch');
            }
            else {
                return of(undefined);
            }
        }));
    }
    /**
     * Navigates to the search result page with a given query
     * after waiting for all search operations to complete
     */
    launchSearchPage(query) {
        // Reset the completed state before starting new search
        this.searchCompleted
            .pipe(filter((complete) => complete), // Only proceed when true
        take(1) // Take only the first completion
        )
            .subscribe(() => {
            if (!this.hasKeywordRedirect) {
                this.routingService.go({
                    cxRoute: 'search',
                    params: { query },
                });
            }
        });
    }
    fetchTranslation(translationKey, options) {
        return this.translationService.translate(translationKey, options);
    }
    changeSelectedWord(selectedWord) {
        this.chosenWord.next(selectedWord);
    }
    shareEvent($event) {
        this.sharedEvent.next($event);
    }
    setTrendingSearches(enabled = false) {
        this.enableTrendingSearches = enabled;
    }
    setRecentSearches(enabled = false) {
        this.enableRecentSearches = enabled;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxComponentService, deps: [{ token: i1.SearchboxService }, { token: i1.RoutingService }, { token: i1.TranslationService }, { token: i1.WindowRef }, { token: i1.EventService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxComponentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxComponentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.SearchboxService }, { type: i1.RoutingService }, { type: i1.TranslationService }, { type: i1.WindowRef }, { type: i1.EventService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SearchBoxOutlets;
(function (SearchBoxOutlets) {
    SearchBoxOutlets["RECENT_SEARCHES"] = "SearchBoxOutlets.RECENT_SEARCHES";
    SearchBoxOutlets["TRENDING_SEARCHES"] = "SearchBoxOutlets.TRENDING_SEARCHES";
})(SearchBoxOutlets || (SearchBoxOutlets = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SearchBoxFeatures;
(function (SearchBoxFeatures) {
    SearchBoxFeatures["SEARCH_BOX_V2"] = "searchBoxV2";
    SearchBoxFeatures["TRENDING_SEARCHES_FEATURE"] = "trendingSearches";
})(SearchBoxFeatures || (SearchBoxFeatures = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const DEFAULT_SEARCH_BOX_CONFIG = {
    minCharactersBeforeRequest: 1,
    displayProducts: true,
    displaySuggestions: true,
    maxProducts: 5,
    maxSuggestions: 5,
    displayProductImages: true,
    recentSearches: true,
    maxRecentSearches: 5,
    trendingSearches: true,
    maxTrendingSearches: 5,
};
const SEARCHBOX_IS_ACTIVE = 'searchbox-is-active';
class SearchBoxComponent {
    /**
     * Sets the search box input field
     */
    set queryText(value) {
        if (value) {
            this.updateChosenWord(value);
            this.search(value);
        }
    }
    get searchBoxV2() {
        return this.isEnabledFeature(SearchBoxFeatures.SEARCH_BOX_V2);
    }
    get hasSearchBoxV2() {
        const hostElement = this.elementRef.nativeElement;
        return hostElement.classList.contains('search-box-v2');
    }
    /**
     * Listener for clickout out of searchInput and searchPanel
     * */
    clickout(event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.softClose();
        }
    }
    onEscape() {
        if ((this.featureConfigService?.isEnabled('a11ySearchBoxFocusOnEscape') &&
            this.winRef.document.activeElement !==
                this.searchInputEl?.nativeElement) ||
            this.searchBoxActive) {
            setTimeout(() => {
                this.searchInputEl.nativeElement.focus();
            });
        }
    }
    get isMobile() {
        return this.breakpointService?.isDown(BREAKPOINT.sm);
    }
    constructor(searchBoxComponentService, componentData, winRef, routingService) {
        this.searchBoxComponentService = searchBoxComponentService;
        this.componentData = componentData;
        this.winRef = winRef;
        this.routingService = routingService;
        this.elementRef = inject(ElementRef);
        this.renderer = inject(Renderer2);
        this.searchBoxOutlets = SearchBoxOutlets;
        this.searchBoxFeatures = SearchBoxFeatures;
        this.iconTypes = ICON_TYPE;
        this.searchBoxActive = false;
        /**
         * In some occasions we need to ignore the close event,
         * for example when we click inside the search result section.
         */
        this.ignoreCloseEvent = false;
        this.chosenWord = '';
        this.subscriptions = new Subscription();
        // TODO: (CXSPA-6929) - Make dependencies no longer optional next major release
        this.changeDetecorRef = inject(ChangeDetectorRef, { optional: true });
        this.breakpointService = inject(BreakpointService, { optional: true });
        this.featureConfigService = inject(FeatureConfigService, {
            optional: true,
        });
        /**
         * Returns the SearchBox configuration. The configuration is driven by multiple
         * layers: default configuration, (optional) backend configuration and (optional)
         * input configuration.
         */
        this.config$ = (this.componentData?.data$ || of({})).pipe(map((config) => {
            const isBool = (obj, prop) => obj[prop] !== 'false' &&
                obj[prop] !== false;
            return {
                ...DEFAULT_SEARCH_BOX_CONFIG,
                ...config,
                displayProducts: isBool(config, 'displayProducts'),
                displayProductImages: isBool(config, 'displayProductImages'),
                displaySuggestions: isBool(config, 'displaySuggestions'),
                // we're merging the (optional) input of this component, but write the merged
                // result back to the input property, as the view logic depends on it.
                ...this.config,
            };
        }), tap((config) => (this.config = config)));
        this.results$ = this.config$.pipe(switchMap$1((config) => this.searchBoxComponentService.getResults(config)));
        this.items$ = this.results$.pipe(map((result) => result.products?.map((prod) => of(prod))));
        useFeatureStyles('a11ySearchboxLabel');
        useFeatureStyles('a11yKeyboardFocusInSearchBox');
    }
    ngOnInit() {
        const routeStateSubscription = this.routingService
            .getRouterState()
            .pipe(filter((data) => !data.nextState))
            .subscribe((data) => {
            if (!(data.state.context?.id === 'search' &&
                data.state.context?.type === PageType.CONTENT_PAGE)) {
                this.updateChosenWord('');
            }
        });
        this.subscriptions.add(routeStateSubscription);
        const chosenWordSubscription = this.searchBoxComponentService.chosenWord.subscribe((chosenWord) => {
            this.updateChosenWord(chosenWord);
        });
        this.subscriptions.add(chosenWordSubscription);
        const UIEventSubscription = this.searchBoxComponentService.sharedEvent.subscribe((event) => {
            this.propagateEvent(event);
        });
        this.subscriptions.add(UIEventSubscription);
    }
    /**
     * The Searchbox should not be focusable while not visible.
     */
    getTabIndex(isMobile) {
        if (isMobile) {
            return this.searchBoxActive ? 0 : -1;
        }
        return 0;
    }
    /**
     * Closes the searchBox and opens the search result page.
     */
    search(query) {
        this.searchBoxComponentService.search(query, this.config);
        this.checkOuterResults();
        // force the searchBox to open
        this.open();
    }
    /**
     * Opens the type-ahead searchBox
     */
    open() {
        if (!this.searchBoxActive) {
            this.searchBoxComponentService.toggleBodyClass(SEARCHBOX_IS_ACTIVE, true);
            this.searchBoxActive = true;
            this.searchInputEl?.nativeElement.focus();
        }
    }
    /**
     * Dispatch UI events for Suggestion selected
     *
     * @param eventData the data for the event
     */
    dispatchSuggestionEvent(eventData) {
        this.searchBoxComponentService.dispatchSuggestionSelectedEvent(eventData);
    }
    /**
     * Dispatch UI events for Product selected
     *
     * @param eventData the data for the event
     */
    dispatchProductEvent(eventData) {
        this.searchBoxComponentService.dispatchProductSelectedEvent(eventData);
    }
    /**
     * Closes the type-ahead searchBox.
     */
    close(force = false) {
        // Use timeout to detect changes
        setTimeout(() => {
            if ((!this.ignoreCloseEvent && !this.isSearchBoxFocused()) || force) {
                this.blurSearchBox();
            }
        });
    }
    softClose() {
        this.searchBoxComponentService.toggleBodyClass(SEARCHBOX_IS_ACTIVE, false);
        this.searchBoxActive = false;
    }
    blurSearchBox() {
        this.softClose();
        this.searchBoxComponentService.toggleBodyClass(SEARCHBOX_IS_ACTIVE, false);
        this.searchBoxActive = false;
        this.changeDetecorRef?.detectChanges();
        this.searchButton?.nativeElement.focus();
    }
    // Check if focus is on searchbox or result list elements
    isSearchBoxFocused() {
        return (this.getResultElements().includes(this.getFocusedElement()) ||
            this.winRef.document.querySelector('input[aria-label="Search"]') ===
                this.getFocusedElement());
    }
    checkOuterResults() {
        const recentSearches = this.elementRef.nativeElement.querySelector('cx-recent-searches .recent-searches');
        const trendingSearches = this.elementRef.nativeElement.querySelector('cx-trending-searches .trending-searches');
        const results = this.elementRef.nativeElement.querySelector('.results');
        if (recentSearches || trendingSearches) {
            this.renderer.addClass(results, 'has-outer-results');
        }
    }
    /**
     * Especially in mobile we do not want the search icon
     * to focus the input again when it's already open.
     * */
    avoidReopen(event) {
        if (this.searchBoxComponentService.hasBodyClass(SEARCHBOX_IS_ACTIVE)) {
            this.close();
            event.preventDefault();
        }
    }
    // Return result list as HTMLElement array
    getResultElements() {
        return Array.from(this.winRef.document.querySelectorAll('.products ul:not(.hidden) > li a, .suggestions ul  > li a, .recent-searches ul > li a,.trending-searches ul > li a, .carousel-panel .item.active > a, .products .carousel-panel > button:not([disabled])'));
    }
    // Return group list as HTMLElement array
    getGroupElements() {
        const groups = [];
        groups.push(Array.from(this.winRef.document.querySelectorAll('.products ul:not(.hidden) > li a')));
        groups.push(Array.from(this.winRef.document.querySelectorAll('.suggestions ul  > li a')));
        groups.push(Array.from(this.winRef.document.querySelectorAll('.trending-searches-container.d-block .trending-searches ul > li a')));
        groups.push(Array.from(this.winRef.document.querySelectorAll('.recent-searches ul > li a')));
        groups.push(Array.from(this.winRef.document.querySelectorAll('.carousel-panel .item.active > a, .carousel-panel > button:not([disabled])')));
        groups.push(Array.from(this.winRef.document.querySelectorAll('.search-panel-close-btn')));
        return groups.filter((group) => group.length);
    }
    // Return focused element as HTMLElement
    getFocusedElement() {
        return this.winRef.document.activeElement;
    }
    updateChosenWord(chosenWord) {
        this.chosenWord = chosenWord;
        if (this.searchInputEl) {
            this.searchInputEl.nativeElement.value = this.chosenWord;
        }
    }
    getFocusedIndex() {
        return this.getResultElements().indexOf(this.getFocusedElement());
    }
    getFocusedGroupIndex() {
        return (this.getGroupElements().findIndex((group) => group.indexOf(this.getFocusedElement()) !== -1) ?? 0);
    }
    propagateEvent(event) {
        if (event.code) {
            switch (event.code) {
                case 'Escape':
                case 'Enter':
                    this.close(true);
                    return;
                case 'ArrowUp':
                    this.focusPreviousChild(event);
                    return;
                case 'ArrowDown':
                    this.focusNextChild(event);
                    return;
                case 'ArrowLeft':
                    this.focusPreviousGroup(event);
                    return;
                case 'ArrowRight':
                    this.focusNextGroup(event);
                    return;
                default:
                    return;
            }
        }
        else if (event.type === 'blur') {
            this.close();
        }
    }
    // Focus on previous item in results list
    focusPreviousChild(event) {
        event.preventDefault(); // Negate normal keyscroll
        const [results, focusedIndex] = [
            this.getResultElements(),
            this.getFocusedIndex(),
        ];
        // Focus on last index moving to first
        if (results.length) {
            if (focusedIndex < 1) {
                results[results.length - 1].focus();
            }
            else {
                results[focusedIndex - 1].focus();
            }
        }
    }
    // Focus on next item in results list
    focusNextChild(event) {
        this.open();
        event.preventDefault(); // Negate normal keyscroll
        const [results, focusedIndex] = [
            this.getResultElements(),
            this.getFocusedIndex(),
        ];
        // Focus on first index moving to last
        if (results.length) {
            if (this.featureConfigService?.isEnabled('a11ySearchableDropdownFirstElementFocus')) {
                this.winRef.document
                    .querySelector('header')
                    ?.classList.remove('mouse-focus');
            }
            if (focusedIndex >= results.length - 1) {
                results[0].focus();
            }
            else {
                results[focusedIndex + 1].focus();
            }
        }
    }
    // Focus on previous item in results list
    focusPreviousGroup(event) {
        event.preventDefault(); // Prevent default key scrolling behavior
        const results = this.getGroupElements(); // Get all group elements
        const focusedGroupIndex = this.getFocusedGroupIndex(); // Get the currently focused group index
        // Check if there are any groups and if the focused index is valid
        if (!results.length ||
            focusedGroupIndex < 0 ||
            focusedGroupIndex >= results.length) {
            return; // Exit if no groups or invalid focused index
        }
        // Check if the current group contains any elements
        const currentGroup = results[focusedGroupIndex];
        if (currentGroup.length === 0) {
            return; // If the current group is empty, exit the function
        }
        // Set focus on the appropriate group
        const previousGroupIndex = focusedGroupIndex > 0 ? focusedGroupIndex - 1 : 0;
        const previousGroup = results[previousGroupIndex];
        // Check if the previous group contains any elements
        if (previousGroup.length > 0) {
            previousGroup[0].focus(); // Focus on the first element of the previous group
        }
    }
    // Focus on next item in results list
    focusNextGroup(event) {
        this.open(); // Ensure the dropdown or UI is open before navigating
        event.preventDefault(); // Prevent default key scrolling behavior
        const results = this.getGroupElements(); // Get all group elements
        const focusedGroupIndex = this.getFocusedGroupIndex(); // Get the current focused group index
        // Check if there are any groups and if the focused index is valid
        if (!results.length ||
            focusedGroupIndex < 0 ||
            focusedGroupIndex >= results.length) {
            return; // Exit if no groups or invalid focused index
        }
        // Find the next group that contains elements
        let nextGroupIndex = focusedGroupIndex + 1;
        // Loop forward through groups until a non-empty group is found
        while (nextGroupIndex < results.length &&
            results[nextGroupIndex].length === 0) {
            nextGroupIndex++; // Keep moving to the next group if current one is empty
        }
        // If no next group with elements was found, wrap around to the first group
        if (nextGroupIndex >= results.length) {
            nextGroupIndex = 0; // Move focus to the first group
            if (results[nextGroupIndex].length === 0) {
                return; // Exit if the first group is also empty
            }
        }
        // Set focus on the first element of the next (or first) non-empty group
        results[nextGroupIndex][0].focus();
    }
    carouselEventPropagator(event) {
        if (!event || !event?.code) {
            return;
        }
        switch (event.code) {
            case 'ArrowRight':
                this.focusNextChild(event);
                return;
            case 'ArrowLeft': {
                this.getGroupElements().forEach((group) => {
                    if (group.indexOf(this.getFocusedElement()) !== -1) {
                        if (group.indexOf(this.getFocusedElement()) === 0) {
                            this.focusPreviousGroup(event);
                        }
                        else {
                            this.focusPreviousChild(event);
                        }
                    }
                });
                return;
            }
            case 'ArrowUp':
                this.focusNextGroup(event);
                return;
            default:
                return;
        }
    }
    /**
     * Opens the PLP with the given query.
     *
     * TODO: if there's a single product match, we could open the PDP.
     */
    launchSearchResult(query) {
        if (!query || query.trim().length === 0) {
            return;
        }
        this.close();
        this.searchBoxComponentService.launchSearchPage(query);
    }
    /**
     * Disables closing the search result list.
     */
    disableClose() {
        this.ignoreCloseEvent = true;
    }
    preventDefault(ev) {
        ev.preventDefault();
    }
    /**
     * Clears the search box input field
     */
    clear(el) {
        this.disableClose();
        el.value = '';
        this.searchBoxComponentService.clearResults();
        // Use Timeout to run after blur event to prevent the searchbox from closing on mobile
        setTimeout(() => {
            // Retain focus on input lost by clicking on icon
            el.focus();
            this.ignoreCloseEvent = false;
        });
    }
    isEnabledFeature(feature) {
        return this.featureConfigService?.isEnabled(feature);
    }
    ngOnDestroy() {
        this.subscriptions?.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxComponent, deps: [{ token: SearchBoxComponentService }, { token: CmsComponentData, optional: true }, { token: i1.WindowRef }, { token: i1.RoutingService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: SearchBoxComponent, isStandalone: false, selector: "cx-searchbox", inputs: { config: "config", queryText: "queryText" }, host: { listeners: { "document:click": "clickout($event)", "keydown.escape": "onEscape()" }, properties: { "class.search-box-v2": "this.searchBoxV2" } }, viewQueries: [{ propertyName: "searchInputEl", first: true, predicate: ["searchInput"], descendants: true }, { propertyName: "searchButton", first: true, predicate: ["searchButton"], descendants: true }], ngImport: i0, template: "<div\n  *cxFeature=\"'!a11ySearchboxLabel'\"\n  [attr.aria-label]=\"'searchBox.productSearch' | cxTranslate\"\n  role=\"search\"\n>\n  <label class=\"searchbox\" [class.dirty]=\"!!searchInput.value\">\n    <input\n      #searchInput\n      [placeholder]=\"'searchBox.placeholder' | cxTranslate\"\n      autocomplete=\"off\"\n      aria-describedby=\"initialDescription\"\n      aria-controls=\"results\"\n      [attr.tabindex]=\"getTabIndex(isMobile | async)\"\n      [attr.aria-label]=\"'searchBox.placeholder' | cxTranslate\"\n      (click)=\"search(searchInput.value)\"\n      (input)=\"search(searchInput.value)\"\n      (blur)=\"close()\"\n      (keydown.tab)=\"close()\"\n      (keydown.escape)=\"close()\"\n      (keydown.enter)=\"\n        close(true);\n        launchSearchResult(searchInput.value);\n        updateChosenWord(searchInput.value)\n      \"\n      (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n      (keydown.arrowdown)=\"focusNextChild($any($event))\"\n      value=\"{{ chosenWord }}\"\n    />\n\n    <button\n      [attr.aria-label]=\"'common.reset' | cxTranslate\"\n      [title]=\"'common.reset' | cxTranslate\"\n      (click)=\"clear(searchInput)\"\n      class=\"reset\"\n    >\n      <cx-icon [type]=\"iconTypes.RESET\"></cx-icon>\n    </button>\n\n    <div\n      role=\"presentation\"\n      class=\"search-icon\"\n      [title]=\"'common.search' | cxTranslate\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </div>\n\n    <button\n      #searchButton\n      [attr.aria-label]=\"'common.search' | cxTranslate\"\n      [title]=\"'common.search' | cxTranslate\"\n      class=\"search\"\n      (click)=\"open()\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </button>\n  </label>\n</div>\n<div\n  *cxFeature=\"'a11ySearchboxLabel'\"\n  [attr.aria-label]=\"'searchBox.productSearch' | cxTranslate\"\n  role=\"search\"\n  class=\"cx-searchbox-container\"\n>\n  <label\n    class=\"searchbox cxFeat_a11ySearchboxLabel\"\n    [class.dirty]=\"!!searchInput?.value\"\n  >\n    <span class=\"cx-input-label\">{{ 'common.search' | cxTranslate }}</span>\n    <div class=\"cx-label-inner-container\">\n      <input\n        #searchInput\n        [placeholder]=\"'searchBox.placeholder' | cxTranslate\"\n        autocomplete=\"off\"\n        aria-describedby=\"initialDescription\"\n        aria-controls=\"results\"\n        [attr.tabindex]=\"getTabIndex(isMobile | async)\"\n        (click)=\"open()\"\n        (input)=\"search(searchInput.value)\"\n        (blur)=\"close()\"\n        (keydown.tab)=\"close()\"\n        (keydown.escape)=\"close()\"\n        (keydown.enter)=\"\n          close(true);\n          launchSearchResult(searchInput.value);\n          updateChosenWord(searchInput.value)\n        \"\n        (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n        (keydown.arrowdown)=\"focusNextChild($any($event))\"\n        value=\"{{ chosenWord }}\"\n      />\n\n      <button\n        [attr.aria-label]=\"'common.reset' | cxTranslate\"\n        [title]=\"'common.reset' | cxTranslate\"\n        (click)=\"clear(searchInput)\"\n        class=\"reset\"\n      >\n        <cx-icon [type]=\"iconTypes.RESET\"></cx-icon>\n      </button>\n\n      <div\n        role=\"presentation\"\n        class=\"search-icon\"\n        [title]=\"'common.search' | cxTranslate\"\n      >\n        <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n      </div>\n    </div>\n    <button\n      #searchButton\n      [attr.aria-label]=\"'common.search' | cxTranslate\"\n      [title]=\"'common.search' | cxTranslate\"\n      class=\"search\"\n      (click)=\"open()\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </button>\n  </label>\n</div>\n\n<div\n  *ngIf=\"results$ | async as result\"\n  class=\"results\"\n  id=\"results\"\n  (click)=\"close(true)\"\n  [class.no-headers]=\"\n    !isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) &&\n    !isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n  \"\n>\n  <button\n    *ngIf=\"isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\"\n    class=\"btn btn-tertiary search-panel-close-btn\"\n    (keydown.arrowdown)=\"focusPreviousGroup($any($event))\"\n    (click)=\"close()\"\n  >\n    {{ 'searchBox.closeSearchPanel' | cxTranslate }}\n  </button>\n  <h3 *ngIf=\"result.message\" [innerHTML]=\"result.message\"></h3>\n  <!--RESULT SUGGESTIONS-->\n  <div\n    class=\"suggestions\"\n    *ngIf=\"(searchInputEl?.nativeElement?.value ?? '').length > 0\"\n  >\n    <ng-container\n      *ngIf=\"\n        isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) ||\n        isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <h3>\n        {{ 'searchBox.suggestions' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <ul\n      tabindex=\"0\"\n      attr.aria-label=\"{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}\"\n      role=\"listbox\"\n      [class.no-headers]=\"\n        !isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) &&\n        !isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <li *ngFor=\"let suggestion of result.suggestions\" role=\"option\">\n        <a\n          role=\"option\"\n          [innerHTML]=\"\n            suggestion | cxHighlight: searchInputEl?.nativeElement?.value\n          \"\n          [routerLink]=\"\n            {\n              cxRoute: 'search',\n              params: { query: suggestion },\n            } | cxUrl\n          \"\n          (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n          (keydown.arrowdown)=\"focusNextChild($any($event))\"\n          (keydown.arrowleft)=\"focusPreviousGroup($any($event))\"\n          (keydown.arrowright)=\"focusNextGroup($any($event))\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (blur)=\"close()\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchSuggestionEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              selectedSuggestion: suggestion,\n              searchSuggestions: result.suggestions ?? [],\n            });\n            updateChosenWord(suggestion)\n          \"\n        >\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <!--  TRENDING SEARCHES-->\n  <div\n    class=\"trending-searches-container\"\n    [class.d-block]=\"searchInputEl?.nativeElement?.value?.length === 0\"\n  >\n    <ng-container *ngIf=\"searchBoxFeatures.TRENDING_SEARCHES_FEATURE\">\n      <ng-container *cxFeature=\"searchBoxFeatures.TRENDING_SEARCHES_FEATURE\">\n        <ng-template\n          [cxOutlet]=\"searchBoxOutlets.TRENDING_SEARCHES\"\n          [cxOutletContext]=\"{\n            maxTrendingSearches: config.maxTrendingSearches,\n          }\"\n        ></ng-template>\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <!--  RECENT SEARCHES-->\n  <ng-template\n    *ngIf=\"config.recentSearches\"\n    [cxOutlet]=\"searchBoxOutlets.RECENT_SEARCHES\"\n    [cxOutletContext]=\"{\n      search: searchInputEl?.nativeElement?.value ?? '',\n      searchBoxActive: searchBoxActive,\n      maxRecentSearches: config.maxRecentSearches,\n    }\"\n  ></ng-template>\n  <!--RESULT  PRODUCTS-->\n  <div class=\"products\">\n    <ng-container\n      *ngIf=\"\n        isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) ||\n        isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <h3 *ngIf=\"result.products?.length\">\n        {{ 'searchBox.products' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <ul\n      *ngIf=\"result.products\"\n      attr.aria-label=\"{{ 'searchBox.ariaLabelProducts' | cxTranslate }}\"\n      role=\"listbox\"\n      [class.hidden]=\"hasSearchBoxV2\"\n    >\n      <li *ngFor=\"let product of result.products\" role=\"option\">\n        <a\n          role=\"option\"\n          [routerLink]=\"\n            {\n              cxRoute: 'product',\n              params: product,\n            } | cxUrl\n          \"\n          [class.has-media]=\"config.displayProductImages\"\n          (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n          (keydown.arrowdown)=\"focusNextChild($any($event))\"\n          (keydown.arrowleft)=\"focusPreviousGroup($any($event))\"\n          (keydown.arrowright)=\"focusNextGroup($any($event))\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (blur)=\"close()\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchProductEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              productCode: product.code,\n            })\n          \"\n        >\n          <cx-media\n            *ngIf=\"config.displayProductImages\"\n            [container]=\"product.images?.PRIMARY\"\n            format=\"thumbnail\"\n            role=\"presentation\"\n          ></cx-media>\n          <div class=\"name\" [innerHTML]=\"product.nameHtml\"></div>\n          <span class=\"price\">{{ product.price?.formattedValue }}</span>\n        </a>\n      </li>\n    </ul>\n    <ng-container *ngIf=\"items$ | async as items\">\n      <cx-carousel\n        role=\"region\"\n        [attr.aria-label]=\"'searchBox.ariaLabelProducts' | cxTranslate\"\n        [items]=\"items\"\n        [template]=\"carouselItem\"\n        itemWidth=\"160px\"\n        (keybordEvent)=\"carouselEventPropagator($event)\"\n      >\n      </cx-carousel>\n\n      <ng-template #carouselItem let-product=\"item\">\n        <a\n          tabindex=\"0\"\n          [routerLink]=\"\n            {\n              cxRoute: 'product',\n              params: product,\n            } | cxUrl\n          \"\n          [class.has-media]=\"config.displayProductImages\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (keydown.arrowleft)=\"carouselEventPropagator($any($event))\"\n          (keydown.arrowright)=\"carouselEventPropagator($any($event))\"\n          (keydown.arrowup)=\"carouselEventPropagator($any($event))\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchProductEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              productCode: product.code,\n            })\n          \"\n        >\n          <cx-media\n            tabindex=\"0\"\n            [container]=\"product.images?.PRIMARY\"\n            format=\"product\"\n            [alt]=\"product.name ?? ''\"\n          ></cx-media>\n          <h3 class=\"cx-product-name\" [innerHtml]=\"product.nameHtml\"></h3>\n          <div class=\"price\">\n            {{ product.price?.formattedValue }}\n          </div>\n        </a>\n        <div class=\"actions\">\n          <ng-container cxInnerComponentsHost></ng-container>\n        </div>\n      </ng-template>\n    </ng-container>\n  </div>\n\n  <div\n    [class.d-none]=\"!hasSearchBoxV2\"\n    class=\"search-panel-header\"\n    [class.header-panel-divider]=\"!result.message\"\n    *ngIf=\"isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\"\n  >\n    <h3\n      class=\"search-panel-message\"\n      *ngIf=\"result.message\"\n      [innerHTML]=\"result.message\"\n    ></h3>\n    <ng-container *ngIf=\"!result.message\">\n      <h3 class=\"suggestions-header\">\n        {{ 'searchBox.suggestions' | cxTranslate }}\n      </h3>\n      <h3\n        class=\"trendingSearches-header\"\n        *ngIf=\"searchInputEl?.nativeElement?.value?.length === 0\"\n      >\n        {{ 'searchBox.trendingSearches' | cxTranslate }}\n      </h3>\n      <h3 class=\"recentSearches-header\">\n        {{ 'searchBox.recentSearches' | cxTranslate }}\n      </h3>\n      <h3 class=\"products-header\" *ngIf=\"result.products?.length\">\n        {{ 'searchBox.products' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <button\n      class=\"btn btn-tertiary search-panel-close-btn\"\n      (keydown.arrowdown)=\"focusPreviousGroup($any($event))\"\n      (click)=\"close()\"\n    >\n      {{ 'searchBox.closeSearchPanel' | cxTranslate }}\n    </button>\n  </div>\n\n  <span id=\"initialDescription\" class=\"cx-visually-hidden\">\n    {{ 'searchBox.initialDescription' | cxTranslate }}\n  </span>\n  <div\n    *ngIf=\"result.suggestions?.length || result.products?.length\"\n    aria-live=\"assertive\"\n    class=\"cx-visually-hidden\"\n  >\n    {{\n      'searchBox.suggestionsResult'\n        | cxTranslate: { count: result.suggestions?.length }\n    }}\n    {{\n      'searchBox.productsResult'\n        | cxTranslate: { count: result.products?.length }\n    }}\n    <ng-container *cxFeature=\"'!a11ySearchboxAssistiveMessage'\">\n      {{ 'searchBox.initialDescription' | cxTranslate }}\n    </ng-container>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: MediaComponent, selector: "cx-media", inputs: ["container", "format", "alt", "role", "loading", "fetchPriority", "elementType", "sizesForImgElement"], outputs: ["loaded"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "component", type: CarouselComponent, selector: "cx-carousel", inputs: ["title", "items", "template", "itemWidth", "hideIndicators", "indicatorIcon", "previousIcon", "nextIcon", "trackByFn"], outputs: ["keybordEvent"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.UrlPipe, name: "cxUrl" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: HighlightPipe, name: "cxHighlight" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-searchbox', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div\n  *cxFeature=\"'!a11ySearchboxLabel'\"\n  [attr.aria-label]=\"'searchBox.productSearch' | cxTranslate\"\n  role=\"search\"\n>\n  <label class=\"searchbox\" [class.dirty]=\"!!searchInput.value\">\n    <input\n      #searchInput\n      [placeholder]=\"'searchBox.placeholder' | cxTranslate\"\n      autocomplete=\"off\"\n      aria-describedby=\"initialDescription\"\n      aria-controls=\"results\"\n      [attr.tabindex]=\"getTabIndex(isMobile | async)\"\n      [attr.aria-label]=\"'searchBox.placeholder' | cxTranslate\"\n      (click)=\"search(searchInput.value)\"\n      (input)=\"search(searchInput.value)\"\n      (blur)=\"close()\"\n      (keydown.tab)=\"close()\"\n      (keydown.escape)=\"close()\"\n      (keydown.enter)=\"\n        close(true);\n        launchSearchResult(searchInput.value);\n        updateChosenWord(searchInput.value)\n      \"\n      (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n      (keydown.arrowdown)=\"focusNextChild($any($event))\"\n      value=\"{{ chosenWord }}\"\n    />\n\n    <button\n      [attr.aria-label]=\"'common.reset' | cxTranslate\"\n      [title]=\"'common.reset' | cxTranslate\"\n      (click)=\"clear(searchInput)\"\n      class=\"reset\"\n    >\n      <cx-icon [type]=\"iconTypes.RESET\"></cx-icon>\n    </button>\n\n    <div\n      role=\"presentation\"\n      class=\"search-icon\"\n      [title]=\"'common.search' | cxTranslate\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </div>\n\n    <button\n      #searchButton\n      [attr.aria-label]=\"'common.search' | cxTranslate\"\n      [title]=\"'common.search' | cxTranslate\"\n      class=\"search\"\n      (click)=\"open()\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </button>\n  </label>\n</div>\n<div\n  *cxFeature=\"'a11ySearchboxLabel'\"\n  [attr.aria-label]=\"'searchBox.productSearch' | cxTranslate\"\n  role=\"search\"\n  class=\"cx-searchbox-container\"\n>\n  <label\n    class=\"searchbox cxFeat_a11ySearchboxLabel\"\n    [class.dirty]=\"!!searchInput?.value\"\n  >\n    <span class=\"cx-input-label\">{{ 'common.search' | cxTranslate }}</span>\n    <div class=\"cx-label-inner-container\">\n      <input\n        #searchInput\n        [placeholder]=\"'searchBox.placeholder' | cxTranslate\"\n        autocomplete=\"off\"\n        aria-describedby=\"initialDescription\"\n        aria-controls=\"results\"\n        [attr.tabindex]=\"getTabIndex(isMobile | async)\"\n        (click)=\"open()\"\n        (input)=\"search(searchInput.value)\"\n        (blur)=\"close()\"\n        (keydown.tab)=\"close()\"\n        (keydown.escape)=\"close()\"\n        (keydown.enter)=\"\n          close(true);\n          launchSearchResult(searchInput.value);\n          updateChosenWord(searchInput.value)\n        \"\n        (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n        (keydown.arrowdown)=\"focusNextChild($any($event))\"\n        value=\"{{ chosenWord }}\"\n      />\n\n      <button\n        [attr.aria-label]=\"'common.reset' | cxTranslate\"\n        [title]=\"'common.reset' | cxTranslate\"\n        (click)=\"clear(searchInput)\"\n        class=\"reset\"\n      >\n        <cx-icon [type]=\"iconTypes.RESET\"></cx-icon>\n      </button>\n\n      <div\n        role=\"presentation\"\n        class=\"search-icon\"\n        [title]=\"'common.search' | cxTranslate\"\n      >\n        <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n      </div>\n    </div>\n    <button\n      #searchButton\n      [attr.aria-label]=\"'common.search' | cxTranslate\"\n      [title]=\"'common.search' | cxTranslate\"\n      class=\"search\"\n      (click)=\"open()\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </button>\n  </label>\n</div>\n\n<div\n  *ngIf=\"results$ | async as result\"\n  class=\"results\"\n  id=\"results\"\n  (click)=\"close(true)\"\n  [class.no-headers]=\"\n    !isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) &&\n    !isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n  \"\n>\n  <button\n    *ngIf=\"isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\"\n    class=\"btn btn-tertiary search-panel-close-btn\"\n    (keydown.arrowdown)=\"focusPreviousGroup($any($event))\"\n    (click)=\"close()\"\n  >\n    {{ 'searchBox.closeSearchPanel' | cxTranslate }}\n  </button>\n  <h3 *ngIf=\"result.message\" [innerHTML]=\"result.message\"></h3>\n  <!--RESULT SUGGESTIONS-->\n  <div\n    class=\"suggestions\"\n    *ngIf=\"(searchInputEl?.nativeElement?.value ?? '').length > 0\"\n  >\n    <ng-container\n      *ngIf=\"\n        isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) ||\n        isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <h3>\n        {{ 'searchBox.suggestions' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <ul\n      tabindex=\"0\"\n      attr.aria-label=\"{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}\"\n      role=\"listbox\"\n      [class.no-headers]=\"\n        !isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) &&\n        !isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <li *ngFor=\"let suggestion of result.suggestions\" role=\"option\">\n        <a\n          role=\"option\"\n          [innerHTML]=\"\n            suggestion | cxHighlight: searchInputEl?.nativeElement?.value\n          \"\n          [routerLink]=\"\n            {\n              cxRoute: 'search',\n              params: { query: suggestion },\n            } | cxUrl\n          \"\n          (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n          (keydown.arrowdown)=\"focusNextChild($any($event))\"\n          (keydown.arrowleft)=\"focusPreviousGroup($any($event))\"\n          (keydown.arrowright)=\"focusNextGroup($any($event))\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (blur)=\"close()\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchSuggestionEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              selectedSuggestion: suggestion,\n              searchSuggestions: result.suggestions ?? [],\n            });\n            updateChosenWord(suggestion)\n          \"\n        >\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <!--  TRENDING SEARCHES-->\n  <div\n    class=\"trending-searches-container\"\n    [class.d-block]=\"searchInputEl?.nativeElement?.value?.length === 0\"\n  >\n    <ng-container *ngIf=\"searchBoxFeatures.TRENDING_SEARCHES_FEATURE\">\n      <ng-container *cxFeature=\"searchBoxFeatures.TRENDING_SEARCHES_FEATURE\">\n        <ng-template\n          [cxOutlet]=\"searchBoxOutlets.TRENDING_SEARCHES\"\n          [cxOutletContext]=\"{\n            maxTrendingSearches: config.maxTrendingSearches,\n          }\"\n        ></ng-template>\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <!--  RECENT SEARCHES-->\n  <ng-template\n    *ngIf=\"config.recentSearches\"\n    [cxOutlet]=\"searchBoxOutlets.RECENT_SEARCHES\"\n    [cxOutletContext]=\"{\n      search: searchInputEl?.nativeElement?.value ?? '',\n      searchBoxActive: searchBoxActive,\n      maxRecentSearches: config.maxRecentSearches,\n    }\"\n  ></ng-template>\n  <!--RESULT  PRODUCTS-->\n  <div class=\"products\">\n    <ng-container\n      *ngIf=\"\n        isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) ||\n        isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <h3 *ngIf=\"result.products?.length\">\n        {{ 'searchBox.products' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <ul\n      *ngIf=\"result.products\"\n      attr.aria-label=\"{{ 'searchBox.ariaLabelProducts' | cxTranslate }}\"\n      role=\"listbox\"\n      [class.hidden]=\"hasSearchBoxV2\"\n    >\n      <li *ngFor=\"let product of result.products\" role=\"option\">\n        <a\n          role=\"option\"\n          [routerLink]=\"\n            {\n              cxRoute: 'product',\n              params: product,\n            } | cxUrl\n          \"\n          [class.has-media]=\"config.displayProductImages\"\n          (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n          (keydown.arrowdown)=\"focusNextChild($any($event))\"\n          (keydown.arrowleft)=\"focusPreviousGroup($any($event))\"\n          (keydown.arrowright)=\"focusNextGroup($any($event))\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (blur)=\"close()\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchProductEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              productCode: product.code,\n            })\n          \"\n        >\n          <cx-media\n            *ngIf=\"config.displayProductImages\"\n            [container]=\"product.images?.PRIMARY\"\n            format=\"thumbnail\"\n            role=\"presentation\"\n          ></cx-media>\n          <div class=\"name\" [innerHTML]=\"product.nameHtml\"></div>\n          <span class=\"price\">{{ product.price?.formattedValue }}</span>\n        </a>\n      </li>\n    </ul>\n    <ng-container *ngIf=\"items$ | async as items\">\n      <cx-carousel\n        role=\"region\"\n        [attr.aria-label]=\"'searchBox.ariaLabelProducts' | cxTranslate\"\n        [items]=\"items\"\n        [template]=\"carouselItem\"\n        itemWidth=\"160px\"\n        (keybordEvent)=\"carouselEventPropagator($event)\"\n      >\n      </cx-carousel>\n\n      <ng-template #carouselItem let-product=\"item\">\n        <a\n          tabindex=\"0\"\n          [routerLink]=\"\n            {\n              cxRoute: 'product',\n              params: product,\n            } | cxUrl\n          \"\n          [class.has-media]=\"config.displayProductImages\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (keydown.arrowleft)=\"carouselEventPropagator($any($event))\"\n          (keydown.arrowright)=\"carouselEventPropagator($any($event))\"\n          (keydown.arrowup)=\"carouselEventPropagator($any($event))\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchProductEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              productCode: product.code,\n            })\n          \"\n        >\n          <cx-media\n            tabindex=\"0\"\n            [container]=\"product.images?.PRIMARY\"\n            format=\"product\"\n            [alt]=\"product.name ?? ''\"\n          ></cx-media>\n          <h3 class=\"cx-product-name\" [innerHtml]=\"product.nameHtml\"></h3>\n          <div class=\"price\">\n            {{ product.price?.formattedValue }}\n          </div>\n        </a>\n        <div class=\"actions\">\n          <ng-container cxInnerComponentsHost></ng-container>\n        </div>\n      </ng-template>\n    </ng-container>\n  </div>\n\n  <div\n    [class.d-none]=\"!hasSearchBoxV2\"\n    class=\"search-panel-header\"\n    [class.header-panel-divider]=\"!result.message\"\n    *ngIf=\"isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\"\n  >\n    <h3\n      class=\"search-panel-message\"\n      *ngIf=\"result.message\"\n      [innerHTML]=\"result.message\"\n    ></h3>\n    <ng-container *ngIf=\"!result.message\">\n      <h3 class=\"suggestions-header\">\n        {{ 'searchBox.suggestions' | cxTranslate }}\n      </h3>\n      <h3\n        class=\"trendingSearches-header\"\n        *ngIf=\"searchInputEl?.nativeElement?.value?.length === 0\"\n      >\n        {{ 'searchBox.trendingSearches' | cxTranslate }}\n      </h3>\n      <h3 class=\"recentSearches-header\">\n        {{ 'searchBox.recentSearches' | cxTranslate }}\n      </h3>\n      <h3 class=\"products-header\" *ngIf=\"result.products?.length\">\n        {{ 'searchBox.products' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <button\n      class=\"btn btn-tertiary search-panel-close-btn\"\n      (keydown.arrowdown)=\"focusPreviousGroup($any($event))\"\n      (click)=\"close()\"\n    >\n      {{ 'searchBox.closeSearchPanel' | cxTranslate }}\n    </button>\n  </div>\n\n  <span id=\"initialDescription\" class=\"cx-visually-hidden\">\n    {{ 'searchBox.initialDescription' | cxTranslate }}\n  </span>\n  <div\n    *ngIf=\"result.suggestions?.length || result.products?.length\"\n    aria-live=\"assertive\"\n    class=\"cx-visually-hidden\"\n  >\n    {{\n      'searchBox.suggestionsResult'\n        | cxTranslate: { count: result.suggestions?.length }\n    }}\n    {{\n      'searchBox.productsResult'\n        | cxTranslate: { count: result.products?.length }\n    }}\n    <ng-container *cxFeature=\"'!a11ySearchboxAssistiveMessage'\">\n      {{ 'searchBox.initialDescription' | cxTranslate }}\n    </ng-container>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: SearchBoxComponentService }, { type: CmsComponentData, decorators: [{
                    type: Optional
                }] }, { type: i1.WindowRef }, { type: i1.RoutingService }], propDecorators: { config: [{
                type: Input
            }], queryText: [{
                type: Input,
                args: ['queryText']
            }], searchBoxV2: [{
                type: HostBinding,
                args: ['class.search-box-v2']
            }], clickout: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }], searchInputEl: [{
                type: ViewChild,
                args: ['searchInput']
            }], searchButton: [{
                type: ViewChild,
                args: ['searchButton']
            }], onEscape: [{
                type: HostListener,
                args: ['keydown.escape']
            }], changeDetecorRef: [{
                type: Optional
            }], breakpointService: [{
                type: Optional
            }], featureConfigService: [{
                type: Optional
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ViewConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ViewConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ViewConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ViewConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that provides the information whether the template contains
 * the LCP (Largest Contentful Paint) element.
 *
 * For CMS components, it's already defined by the `[cxComponentWrapper]` directive,
 * based on the dynamic CMS component data.
 */
class ProvideLcpPresenceDirective {
    constructor() {
        this._lcpPresence$ = new ReplaySubject(1);
        this.lcpPresence$ = this._lcpPresence$.pipe(distinctUntilChanged$1(), shareReplay({ bufferSize: 1, refCount: true }));
    }
    ngOnChanges() {
        const value = this.cxProvideLcpPresence ?? LcpPresence.NO_LCP;
        this._lcpPresence$.next(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProvideLcpPresenceDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.3", type: ProvideLcpPresenceDirective, isStandalone: false, selector: "[cxProvideLcpPresence]", inputs: { cxProvideLcpPresence: "cxProvideLcpPresence" }, providers: [
            {
                provide: LCP_PRESENCE,
                useFactory: () => inject(ProvideLcpPresenceDirective).lcpPresence$,
            },
        ], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProvideLcpPresenceDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cxProvideLcpPresence]',
                    providers: [
                        {
                            provide: LCP_PRESENCE,
                            useFactory: () => inject(ProvideLcpPresenceDirective).lcpPresence$,
                        },
                    ],
                    standalone: false,
                }]
        }], propDecorators: { cxProvideLcpPresence: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProvideLcpPresenceDirectiveModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProvideLcpPresenceDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProvideLcpPresenceDirectiveModule, declarations: [ProvideLcpPresenceDirective], exports: [ProvideLcpPresenceDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProvideLcpPresenceDirectiveModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProvideLcpPresenceDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ProvideLcpPresenceDirective],
                    exports: [ProvideLcpPresenceDirective],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FileDownloadService {
    /**
     * Triggers the browser downloading of the file from the given URL.
     *
     * @param {string} url URL to file.
     * @param {string} [fileName] The optional parameter for defining filename
     * (including the extension) when saving the file.
     */
    download(url, fileName) {
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `${fileName}`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileDownloadService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileDownloadService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileDownloadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ExportCsvFileService {
    constructor(fileDownloadService) {
        this.fileDownloadService = fileDownloadService;
    }
    /**
     * Converts array of objects into CSV data structure.
     *
     * @param objectsArray Array of objects which should be converted to CSV.
     * @param separator Separator for CSV data.
     * @returns Processed string ready to be saved into file.
     */
    convert(objectsArray, separator) {
        return objectsArray.reduce((csvString, row) => {
            const line = row.reduce((currentLine, column) => {
                currentLine += currentLine !== '' ? separator : '';
                const cell = column.includes(separator) ? `"${column}"` : column;
                return `${currentLine}${cell}`;
            }, '');
            return `${csvString}${line}\r\n`;
        }, '');
    }
    /**
     * Creates and download CSV file.
     *
     * @param objectsArray Array of objects which should be converted to CSV.
     * @param separator Separator for CSV data.
     * @param fileOptions Exported file options.
     */
    download(objectsArray, separator, fileOptions) {
        const { fileName, type, extension } = fileOptions;
        const fileContent = this.convert(objectsArray, separator);
        const blob = new Blob([fileContent], { type });
        const url = URL.createObjectURL(blob);
        this.fileDownloadService.download(url, `${fileName}.${extension}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ExportCsvFileService, deps: [{ token: FileDownloadService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ExportCsvFileService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ExportCsvFileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: FileDownloadService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FileReaderService {
    /**
     * Load text file
     *
     * @param file text file to extract the data
     * @returns Observable from file reader
     */
    loadTextFile(file) {
        return new Observable((observer) => {
            const fileReader = new FileReader();
            fileReader.readAsText(file);
            fileReader.onload = () => {
                observer.next(fileReader.result);
                observer.complete();
            };
            fileReader.onerror = (error) => {
                fileReader.abort();
                observer.error(error);
            };
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileReaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileReaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FileReaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportCsvFileService {
    constructor(fileReaderService) {
        this.fileReaderService = fileReaderService;
    }
    /**
     * Load CSV file.
     *
     * @param file File we want to load as CSV.
     * @param separator Separator for CSV data.
     * @return {Observable<string[][]>} Imported file
     */
    loadFile(file, separator) {
        return this.fileReaderService
            .loadTextFile(file)
            .pipe(map((res) => this.parse(res, separator)));
    }
    /**
     * Combined csv validation
     *
     * @param file File we want to load as CSV.
     * @param separator Separator for CSV data.
     * @param isDataParsable (optional) Callback for verify that structure type is proper.
     * @param maxEntries (optional) Limitation for maximum entries count.
     * @return {Observable<CsvFileValidationErrors | null>} Result of validation
     */
    validateFile(file, { separator, isDataParsable, maxEntries, }) {
        const validationErrors = {};
        return this.fileReaderService.loadTextFile(file).pipe(tap((data) => {
            this.validateEmpty(data, validationErrors);
        }), map((res) => this.parse(res, separator)), tap((data) => {
            this.validateNotParsable(data, validationErrors, isDataParsable);
            this.validateTooManyEntries(data, validationErrors, maxEntries);
        }), catchError((errors) => of(errors)), map(() => Object.keys(validationErrors).length === 0 ? null : validationErrors));
    }
    /**
     * Processes the CSV data
     *
     * @param csvString raw extracted data from CSV
     * @param separator for csv data
     * @param ignoreHeader (optional) flag allows for ignore headers row while reading
     * @returns {string[][]} Parsed file
     */
    parse(csvString, separator, ignoreHeader = true) {
        return csvString
            .split('\n')
            .map((row) => row.split(separator).map((cell) => cell.replace(/"/g, '')))
            .filter((value, index) => !(ignoreHeader && index === 0) && value[0] !== '');
    }
    validateEmpty(data, errors) {
        if (data.toString().length === 0) {
            errors.empty = true;
            throw errors;
        }
    }
    validateTooManyEntries(data, errors, maxEntries) {
        if (maxEntries && data.length > maxEntries) {
            errors.tooManyEntries = { maxEntries };
            throw errors;
        }
    }
    validateNotParsable(data, errors, isDataParsable) {
        if (isDataParsable && !isDataParsable(data)) {
            errors.notParsable = true;
            throw errors;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ImportCsvFileService, deps: [{ token: FileReaderService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ImportCsvFileService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ImportCsvFileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: FileReaderService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CustomFormValidators {
    /**
     * Checks control's value with predefined email regexp
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxInvalidEmail' validator error
     * @memberof CustomFormValidators
     */
    static emailValidator(control) {
        const email = control.value;
        return email && (!email.length || email.match(EMAIL_PATTERN))
            ? null
            : { cxInvalidEmail: true };
    }
    static securePasswordValidator(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(SECURE_PASSWORD_PATTERN))
            ? null
            : { cxInvalidPassword: true };
    }
    // TODO: (CXSPA-7567) Remove after removing formErrorsDescriptiveMessages feature toggle
    /**
     * Checks control's value with predefined password regexp
     *
     * NOTE: Use it as a control validator
     *
     * @deprecated Use passwordValidators instead
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxInvalidPassword' validator error
     * @memberof CustomFormValidators
     */
    static strongPasswordValidator(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(STRONG_PASSWORD_PATTERN))
            ? null
            : { cxInvalidPassword: true };
    }
    /**
     * Checks control's value with predefined  at least one upper case character regexp
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxMinOneUpperCaseCharacter' validator error
     * @memberof CustomFormValidators
     */
    static minOneUpperCaseCharacterValidator(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(MIN_ONE_UPPER_CASE_CHARACTER_PATTERN))
            ? null
            : { cxMinOneUpperCaseCharacter: true };
    }
    /**
     * Checks control's value with predefined  at least one upper case character regexp
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxMinOneDigit' validator error
     * @memberof CustomFormValidators
     */
    static minOneDigitValidator(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(MIN_ONE_DIGIT_PATTERN))
            ? null
            : { cxMinOneDigit: true };
    }
    /**
     * Checks control's value with predefined  at least one upper case character regexp
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxMinOneSpecialCharacter' validator error
     * @memberof CustomFormValidators
     */
    static minOneSpecialCharacterValidator(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(MIN_ONE_SPECIAL_CHARACTER_PATTERN))
            ? null
            : { cxMinOneSpecialCharacter: true };
    }
    /**
     * Checks control's value with predefined  at least one upper case character regexp
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxMinSixCharactersLength' validator error
     * @memberof CustomFormValidators
     */
    static minSixCharactersLengthValidator(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(MIN_SIX_CHARACTERS_PATTERN))
            ? null
            : { cxMinSixCharactersLength: true };
    }
    /**
     * Checks control's value with predefined  at least one upper case character regexp
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxMinEightCharactersLength' validator error
     * @memberof CustomFormValidators
     */
    static minEightCharactersLengthValidator(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(MIN_EIGHT_CHARACTERS_PATTERN))
            ? null
            : { cxMinEightCharactersLength: true };
    }
    static maxCharactersLengthValidator(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(MAX_CHARACTERS_PATTERN))
            ? null
            : { cxMaxCharactersLength: true };
    }
    /**
     * Validates that the control's value does not contain consecutive identical characters.
     *
     * NOTE: Use this as a control validator.
     *
     * @static
     * @param {AbstractControl} control The form control to validate.
     * @returns {(ValidationErrors | null)} Returns an error object with the key 'cxNoConsecutiveCharacters'
     * if the value contains consecutive characters, or null if the validation passes.
     * @memberof CustomFormValidators
     */
    static noConsecutiveCharacters(control) {
        const password = control.value;
        return password &&
            (!password.length || password.match(CONSECUTIVE_CHARACTERS))
            ? { cxNoConsecutiveCharacters: true }
            : null;
    }
    /**
     * Pack of predefined password validators:
     * - at least one upper case character
     * - at least one digit
     * - at least one special character
     * - at least six characters length
     *
     * @memberof CustomFormValidators
     */
    static { this.passwordValidators = [
        this.minOneDigitValidator,
        this.minOneUpperCaseCharacterValidator,
        this.minOneSpecialCharacterValidator,
        this.minSixCharactersLengthValidator,
    ]; }
    static { this.securePasswordValidators = [
        this.minOneDigitValidator,
        this.minOneUpperCaseCharacterValidator,
        this.minOneSpecialCharacterValidator,
        this.minEightCharactersLengthValidator,
        this.maxCharactersLengthValidator,
        this.noConsecutiveCharacters,
    ]; }
    /**
     * Checks if control's value is between 1 and 5
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxStarRatingEmpty' validator error
     * @memberof CustomFormValidators
     */
    static starRatingEmpty(control) {
        const rating = control.value;
        return rating >= 1 && rating <= 5 ? null : { cxStarRatingEmpty: true };
    }
    /**
     * Checks if two password controls match
     *
     * NOTE: Use it as a form validator and pass password control names as parameters
     *
     * @static
     * @param {string} password First password control name
     * @param {string} passwordConfirmation Second password control name
     * @returns Uses 'cxPasswordsMustMatch' validator error
     * @memberof CustomFormValidators
     */
    static passwordsMustMatch(password, passwordConfirmation) {
        const validator = (formGroup) => controlsMustMatch(formGroup, password, passwordConfirmation, 'cxPasswordsMustMatch');
        return validator;
    }
    /**
     * Checks if two password controls don't match
     *
     * NOTE: Use it as a form validator and pass password control names as parameters
     *
     * @static
     * @param {string} password First password control name
     * @param {string} passwordConfirmation Second password control name
     * @returns Uses 'cxPasswordsCannotMatch' validator error
     * @memberof CustomFormValidators
     */
    static passwordsCannotMatch(password, passwordConfirmation) {
        const validator = (formGroup) => controlsMustMatch(formGroup, password, passwordConfirmation, 'cxPasswordsCannotMatch', true);
        return validator;
    }
    /**
     * Checks if two email controls match
     *
     * NOTE: Use it as a form validator and pass email control names as parameters
     *
     * @static
     * @param {string} email First email control name
     * @param {string} emailConfirmation Second email control name
     * @returns Uses 'cxEmailsMustMatch' validator error
     * @memberof CustomFormValidators
     */
    static emailsMustMatch(email, emailConfirmation) {
        const validator = (formGroup) => controlsMustMatch(formGroup, email, emailConfirmation, 'cxEmailsMustMatch');
        return validator;
    }
    /**
     * Checks if control's value is euqal or greater than 0
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxNegativeAmount' validator error
     * @memberof CustomFormValidators
     */
    static mustBePositive(control) {
        const amount = control.value;
        return amount >= 0 ? null : { cxNegativeAmount: true };
    }
    /**
     * Checks if control's value does not contain any special characters
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {AbstractControl} control
     * @returns {(ValidationErrors | null)} Uses 'cxContainsSpecialCharacters' validator error
     * @memberof CustomFormValidators
     */
    static noSpecialCharacters(control) {
        const forbiddenChars = ['/'];
        const str = String(control.value);
        const containsSpecialChars = forbiddenChars.some((char) => str.includes(char));
        return !containsSpecialChars ? null : { cxContainsSpecialCharacters: true };
    }
    /**
     * Checks if control's value passes pattern
     *
     * NOTE: Use it as a control validator
     *
     * @static
     * @param {(date: string) => boolean} isValidFormat Pattern verification function
     * @returns {(control: AbstractControl): ValidationErrors | null} Uses 'pattern' validator error
     * @memberof CustomFormValidators
     */
    static patternValidation(isValidFormat) {
        const validator = (control) => {
            const errors = {};
            if (control.value &&
                control.value !== '' &&
                !isValidFormat(control.value)) {
                errors.pattern = true;
            }
            return Object.keys(errors).length === 0 ? null : errors;
        };
        return validator;
    }
    /**
     * Checks if two email controls match
     *
     * NOTE: Use it as a form validator and pass dates for range
     *
     * @static
     * @param {string} startDateKey First date control name
     * @param {string} endDateKey Second date control name
     * @param {(value: string) => Date} getDate Converting function
     * @returns Uses 'min' and 'max validator error
     * @memberof CustomFormValidators
     */
    static dateRange(startDateKey, endDateKey, getDate) {
        return (formGroup) => {
            const startDateControl = formGroup.controls[startDateKey];
            const endDateControl = formGroup.controls[endDateKey];
            const startDate = getDate(startDateControl.value);
            const endDate = getDate(endDateControl.value);
            if (startDate && endDate) {
                if (!startDateControl.errors?.pattern) {
                    if (startDate > endDate) {
                        startDateControl.setErrors({ max: true });
                    }
                }
                if (!endDateControl.errors?.pattern) {
                    if (endDate < startDate) {
                        endDateControl.setErrors({ min: true });
                    }
                }
            }
            return null;
        };
    }
}
/**
 * Generic function for validators, which checks if two passed controls match.
 *
 * @param formGroup
 * @param firstControlName First control to check
 * @param secondControlName Second control to check
 * @param errorName Error which will be returned by validator
 * @param cannotMatch Reverse check
 */
function controlsMustMatch(formGroup, firstControlName, secondControlName, errorName, cannotMatch = false) {
    const firstControl = formGroup.controls[firstControlName];
    const secondControl = formGroup.controls[secondControlName];
    if (secondControl.errors && !secondControl.errors[errorName]) {
        return;
    }
    const shouldSetError = cannotMatch
        ? firstControl.value === secondControl.value
        : firstControl.value !== secondControl.value;
    secondControl.setErrors(shouldSetError ? { [errorName]: true } : null);
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const titleScores = {
    mr: 1,
    mrs: 2,
    miss: 3,
    ms: 4,
    dr: 5,
    rev: 6,
};
function sortTitles(title1, title2) {
    if (title1.code && title2.code) {
        if (!titleScores[title1.code] || !titleScores[title2.code]) {
            return 1;
        }
        else {
            return titleScores[title1.code] - titleScores[title2.code];
        }
    }
    return 1;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SearchBoxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxModule, declarations: [SearchBoxComponent, HighlightPipe], imports: [CommonModule,
            RouterModule,
            MediaModule,
            IconModule,
            UrlModule,
            I18nModule,
            OutletModule,
            FeaturesConfigModule,
            CarouselModule,
            KeyboardFocusModule], exports: [SearchBoxComponent, HighlightPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    SearchBoxComponent: {
                        component: SearchBoxComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            RouterModule,
            MediaModule,
            IconModule,
            UrlModule,
            I18nModule,
            OutletModule,
            FeaturesConfigModule,
            CarouselModule,
            KeyboardFocusModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: SearchBoxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        MediaModule,
                        IconModule,
                        UrlModule,
                        I18nModule,
                        OutletModule,
                        FeaturesConfigModule,
                        CarouselModule,
                        KeyboardFocusModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                SearchBoxComponent: {
                                    component: SearchBoxComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [SearchBoxComponent, HighlightPipe],
                    exports: [SearchBoxComponent, HighlightPipe],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ScrollToTopComponent {
    constructor(winRef, componentData, selectFocusUtility) {
        this.winRef = winRef;
        this.componentData = componentData;
        this.selectFocusUtility = selectFocusUtility;
        this.iconTypes = ICON_TYPE;
        this.window = this.winRef.nativeWindow;
        this.scrollBehavior = ScrollBehavior.SMOOTH;
        this.displayThreshold = (this.window?.innerHeight ?? 400) / 2;
        this.triggedByKeypress = false;
    }
    ngOnInit() {
        this.setConfig();
    }
    onScroll() {
        this.switchDisplay();
    }
    /**
     * Scroll back to the top of the page, and recognize if triggerd by keyboard.
     */
    scrollToTop(event) {
        this.window?.scrollTo({
            top: 0,
            behavior: this.scrollBehavior,
        });
        this.triggedByKeypress = event?.detail === 0;
    }
    onFocusOut() {
        if (this.display) {
            this.switchDisplay();
        }
    }
    /**
     * After scrolling to top, pressing Tab should focus first focusable element within body.
     */
    onTab(event) {
        const tabEvent = event;
        const scrollToTopHasFocus = document.activeElement === this.button.nativeElement;
        const isAtTopOfPage = this.window?.scrollY === 0;
        if (scrollToTopHasFocus &&
            isAtTopOfPage &&
            tabEvent.key === 'Tab' &&
            !tabEvent.shiftKey) {
            event.preventDefault();
            this.selectFocusUtility
                .findFirstFocusable(this.winRef.document.body, { autofocus: '' })
                ?.focus();
        }
    }
    setConfig() {
        this.componentData.data$.pipe(take(1)).subscribe((data) => {
            this.scrollBehavior = data.scrollBehavior ?? this.scrollBehavior;
            this.displayThreshold = data.displayThreshold ?? this.displayThreshold;
        });
    }
    /**
     * This methods decides when the ScrollToTop button should be displayed.
     */
    switchDisplay() {
        const isPastThreshold = this.window && this.window.scrollY > this.displayThreshold;
        const buttonHasFocus = this.button.nativeElement === document.activeElement;
        this.display =
            isPastThreshold || (this.triggedByKeypress && buttonHasFocus);
        if (!this.display) {
            this.triggedByKeypress = false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ScrollToTopComponent, deps: [{ token: i1.WindowRef }, { token: CmsComponentData }, { token: SelectFocusUtility }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ScrollToTopComponent, isStandalone: false, selector: "cx-scroll-to-top", host: { listeners: { "window:scroll": "onScroll($event)" }, properties: { "class.display": "this.display" } }, viewQueries: [{ propertyName: "button", first: true, predicate: ["button"], descendants: true }], ngImport: i0, template: "<button\n  #button\n  [attr.aria-label]=\"'navigation.scrollToTop' | cxTranslate\"\n  [title]=\"'navigation.scrollToTop' | cxTranslate\"\n  class=\"cx-scroll-to-top-btn\"\n  (click)=\"scrollToTop($event)\"\n  (focusout)=\"onFocusOut()\"\n  (keydown.Tab)=\"onTab($event)\"\n>\n  <span aria-hidden=\"true\">\n    <cx-icon class=\"caret-up-icon\" [type]=\"iconTypes.CARET_UP\"></cx-icon>\n  </span>\n</button>\n", dependencies: [{ kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ScrollToTopComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-scroll-to-top', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<button\n  #button\n  [attr.aria-label]=\"'navigation.scrollToTop' | cxTranslate\"\n  [title]=\"'navigation.scrollToTop' | cxTranslate\"\n  class=\"cx-scroll-to-top-btn\"\n  (click)=\"scrollToTop($event)\"\n  (focusout)=\"onFocusOut()\"\n  (keydown.Tab)=\"onTab($event)\"\n>\n  <span aria-hidden=\"true\">\n    <cx-icon class=\"caret-up-icon\" [type]=\"iconTypes.CARET_UP\"></cx-icon>\n  </span>\n</button>\n" }]
        }], ctorParameters: () => [{ type: i1.WindowRef }, { type: CmsComponentData }, { type: SelectFocusUtility }], propDecorators: { display: [{
                type: HostBinding,
                args: ['class.display']
            }], button: [{
                type: ViewChild,
                args: ['button']
            }], onScroll: [{
                type: HostListener,
                args: ['window:scroll', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ScrollToTopModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ScrollToTopModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ScrollToTopModule, declarations: [ScrollToTopComponent], imports: [CommonModule, IconModule, I18nModule], exports: [ScrollToTopComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ScrollToTopModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ScrollToTopComponent: {
                        component: ScrollToTopComponent,
                    },
                },
            }),
        ], imports: [CommonModule, IconModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ScrollToTopModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule, I18nModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ScrollToTopComponent: {
                                    component: ScrollToTopComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ScrollToTopComponent],
                    exports: [ScrollToTopComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2NavigationComponent extends NavigationComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NavigationComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MyAccountV2NavigationComponent, isStandalone: false, selector: "cx-my-account-v2-navigation", usesInheritance: true, ngImport: i0, template: "<cx-navigation-ui\n  *ngIf=\"node$ | async as node\"\n  [node]=\"node\"\n  [flyout]=\"false\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"name$ | async\"\n  [focusableNodeTitles]=\"true\"\n></cx-navigation-ui>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: NavigationUIComponent, selector: "cx-navigation-ui", inputs: ["node", "wrapAfter", "resetMenuOnClose", "focusableNodeTitles", "navAriaLabel", "flyout", "isOpen"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-my-account-v2-navigation', standalone: false, template: "<cx-navigation-ui\n  *ngIf=\"node$ | async as node\"\n  [node]=\"node\"\n  [flyout]=\"false\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"name$ | async\"\n  [focusableNodeTitles]=\"true\"\n></cx-navigation-ui>\n" }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2NavigationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NavigationModule, declarations: [MyAccountV2NavigationComponent], imports: [CommonModule, NavigationModule, I18nModule], exports: [MyAccountV2NavigationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NavigationModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    MyAccountSideNavigationComponent: {
                        component: MyAccountV2NavigationComponent,
                        guards: [AuthGuard],
                    },
                },
            }),
        ], imports: [CommonModule, NavigationModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                MyAccountSideNavigationComponent: {
                                    component: MyAccountV2NavigationComponent,
                                    guards: [AuthGuard],
                                },
                            },
                        }),
                    ],
                    declarations: [MyAccountV2NavigationComponent],
                    exports: [MyAccountV2NavigationComponent],
                    imports: [CommonModule, NavigationModule, I18nModule],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2Module {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2Module, imports: [MyAccountV2NavigationModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2Module, imports: [MyAccountV2NavigationModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2Module, decorators: [{
            type: NgModule,
            args: [{
                    imports: [MyAccountV2NavigationModule],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2NotificationPreferenceComponent extends NotificationPreferenceComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NotificationPreferenceComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: MyAccountV2NotificationPreferenceComponent, isStandalone: false, selector: "cx-my-account-v2-notification-preference", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"preferences$ | async as preferences\">\n  <div *ngIf=\"preferences.length > 0; else loading\">\n    <div class=\"np-row np-flex np-content-center\">\n      <div class=\"col-md-8\">\n        <div class=\"header\">\n          {{ 'myAccountV2NotificationPreference.header' | cxTranslate }}\n        </div>\n        <div class=\"pref-info\">\n          {{ 'myAccountV2NotificationPreference.message' | cxTranslate }}\n        </div>\n        <div class=\"form-check cx-notification-channels\">\n          <ng-container *ngFor=\"let preference of preferences\">\n            <label *ngIf=\"preference.visible\" class=\"pref-channel\">\n              <input\n                class=\"form-check-input cx-np-checkbox\"\n                role=\"checkbox\"\n                type=\"checkbox\"\n                [checked]=\"preference.enabled\"\n                (change)=\"updatePreference(preference)\"\n                [disabled]=\"isLoading$ | async\"\n              />\n              <span class=\"form-check-label\">\n                {{\n                  'myAccountV2NotificationPreference.' + preference.channel\n                    | cxTranslate\n                }}\n                {{ preference.value }}\n              </span>\n            </label>\n          </ng-container>\n        </div>\n        <label\n          ><strong>{{\n            'myAccountV2NotificationPreference.note' | cxTranslate\n          }}</strong\n          >{{ 'myAccountV2NotificationPreference.noteMessage' | cxTranslate }}\n        </label>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NotificationPreferenceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-my-account-v2-notification-preference', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"preferences$ | async as preferences\">\n  <div *ngIf=\"preferences.length > 0; else loading\">\n    <div class=\"np-row np-flex np-content-center\">\n      <div class=\"col-md-8\">\n        <div class=\"header\">\n          {{ 'myAccountV2NotificationPreference.header' | cxTranslate }}\n        </div>\n        <div class=\"pref-info\">\n          {{ 'myAccountV2NotificationPreference.message' | cxTranslate }}\n        </div>\n        <div class=\"form-check cx-notification-channels\">\n          <ng-container *ngFor=\"let preference of preferences\">\n            <label *ngIf=\"preference.visible\" class=\"pref-channel\">\n              <input\n                class=\"form-check-input cx-np-checkbox\"\n                role=\"checkbox\"\n                type=\"checkbox\"\n                [checked]=\"preference.enabled\"\n                (change)=\"updatePreference(preference)\"\n                [disabled]=\"isLoading$ | async\"\n              />\n              <span class=\"form-check-label\">\n                {{\n                  'myAccountV2NotificationPreference.' + preference.channel\n                    | cxTranslate\n                }}\n                {{ preference.value }}\n              </span>\n            </label>\n          </ng-container>\n        </div>\n        <label\n          ><strong>{{\n            'myAccountV2NotificationPreference.note' | cxTranslate\n          }}</strong\n          >{{ 'myAccountV2NotificationPreference.noteMessage' | cxTranslate }}\n        </label>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</ng-container>\n" }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2NotificationPreferenceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NotificationPreferenceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NotificationPreferenceModule, declarations: [MyAccountV2NotificationPreferenceComponent], imports: [CommonModule,
            SpinnerModule,
            I18nModule, i1$2.RouterModule, FeaturesConfigModule], exports: [MyAccountV2NotificationPreferenceComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NotificationPreferenceModule, imports: [CommonModule,
            SpinnerModule,
            I18nModule,
            RouterModule.forChild([
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [AuthGuard, CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'notificationPreference' },
                },
            ]),
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: MyAccountV2NotificationPreferenceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MyAccountV2NotificationPreferenceComponent],
                    imports: [
                        CommonModule,
                        SpinnerModule,
                        I18nModule,
                        RouterModule.forChild([
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [AuthGuard, CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'notificationPreference' },
                            },
                        ]),
                        FeaturesConfigModule,
                    ],
                    exports: [MyAccountV2NotificationPreferenceComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2CmsMapping = {
    cmsComponents: {
        NotificationPreferenceComponent: {
            component: MyAccountV2NotificationPreferenceComponent,
            //guards: inherited from standard config,
        },
    },
};
class NotificationPreferenceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NotificationPreferenceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: NotificationPreferenceModule, declarations: [NotificationPreferenceComponent], imports: [CommonModule,
            SpinnerModule,
            I18nModule,
            FeaturesConfigModule, i1$2.RouterModule], exports: [NotificationPreferenceComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NotificationPreferenceModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    NotificationPreferenceComponent: {
                        component: NotificationPreferenceComponent,
                        guards: [AuthGuard],
                    },
                },
            }),
            provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_NOTIFICATION_PREFERENCE)
                ? myAccountV2CmsMapping
                : {}),
        ], imports: [CommonModule,
            SpinnerModule,
            I18nModule,
            FeaturesConfigModule,
            RouterModule.forChild([
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [AuthGuard, CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'notificationPreference' },
                },
            ])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NotificationPreferenceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NotificationPreferenceComponent],
                    imports: [
                        CommonModule,
                        SpinnerModule,
                        I18nModule,
                        FeaturesConfigModule,
                        RouterModule.forChild([
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [AuthGuard, CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'notificationPreference' },
                            },
                        ]),
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                NotificationPreferenceComponent: {
                                    component: NotificationPreferenceComponent,
                                    guards: [AuthGuard],
                                },
                            },
                        }),
                        provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_NOTIFICATION_PREFERENCE)
                            ? myAccountV2CmsMapping
                            : {}),
                    ],
                    exports: [NotificationPreferenceComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PaymentMethodsComponent {
    constructor(userPaymentService, translation, globalMessageService) {
        this.userPaymentService = userPaymentService;
        this.translation = translation;
        this.globalMessageService = globalMessageService;
        this.iconTypes = ICON_TYPE;
    }
    ngOnInit() {
        this.paymentMethods$ = this.userPaymentService.getPaymentMethods().pipe(tap((paymentDetails) => {
            // Set first payment method to DEFAULT if none is set
            if (paymentDetails.length > 0 &&
                !paymentDetails.find((paymentDetail) => paymentDetail.defaultPayment)) {
                this.setDefaultPaymentMethod(paymentDetails[0]);
            }
        }));
        this.editCard = undefined;
        this.loading$ = this.userPaymentService.getPaymentMethodsLoading();
        this.userPaymentService.loadPaymentMethods();
    }
    getCardContent({ defaultPayment, accountHolderName, expiryMonth, expiryYear, cardNumber, cardType, }) {
        return combineLatest([
            this.translation.translate('paymentCard.setAsDefault'),
            this.translation.translate('common.delete'),
            this.translation.translate('paymentCard.deleteConfirmation'),
            this.translation.translate('paymentCard.expires', {
                month: expiryMonth,
                year: expiryYear,
            }),
            this.translation.translate('paymentCard.defaultPaymentMethod'),
        ]).pipe(map(([textSetAsDefault, textDelete, textDeleteConfirmation, textExpires, textDefaultPaymentMethod,]) => {
            const actions = [];
            if (!defaultPayment) {
                actions.push({ name: textSetAsDefault, event: 'default' });
            }
            actions.push({ name: textDelete, event: 'edit' });
            const card = {
                role: 'application',
                header: defaultPayment ? textDefaultPaymentMethod : undefined,
                textBold: accountHolderName,
                text: [cardNumber ?? '', textExpires],
                actions,
                deleteMsg: textDeleteConfirmation,
                img: this.getCardIcon(cardType?.code ?? ''),
                imgLabel: this.getCardIconLabel(cardType?.code),
                label: defaultPayment
                    ? 'paymentCard.defaultPaymentLabel'
                    : 'paymentCard.additionalPaymentLabel',
            };
            return card;
        }));
    }
    deletePaymentMethod(paymentMethod) {
        if (paymentMethod.id) {
            this.userPaymentService.deletePaymentMethod(paymentMethod.id);
            this.editCard = undefined;
        }
    }
    setEdit(paymentMethod) {
        this.editCard = paymentMethod.id;
    }
    cancelCard() {
        this.editCard = undefined;
    }
    setDefaultPaymentMethod(paymentMethod) {
        this.userPaymentService.setPaymentMethodAsDefault(paymentMethod.id ?? '');
        this.globalMessageService?.add({ key: 'paymentMessages.setAsDefaultSuccessfully' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
    getCardIcon(code) {
        let ccIcon;
        if (code === 'visa') {
            ccIcon = this.iconTypes.VISA;
        }
        else if (code === 'master' || code === 'mastercard_eurocard') {
            ccIcon = this.iconTypes.MASTER_CARD;
        }
        else if (code === 'diners') {
            ccIcon = this.iconTypes.DINERS_CLUB;
        }
        else if (code === 'amex') {
            ccIcon = this.iconTypes.AMEX;
        }
        else {
            ccIcon = this.iconTypes.CREDIT_CARD;
        }
        return ccIcon;
    }
    getCardIconLabel(code) {
        let ccIconLabel;
        if (code === 'visa') {
            ccIconLabel = 'paymentCard.visa';
        }
        else if (code === 'master') {
            ccIconLabel = 'paymentCard.master';
        }
        else if (code === 'mastercard_eurocard') {
            ccIconLabel = 'paymentCard.masterEuro';
        }
        else if (code === 'diners') {
            ccIconLabel = 'paymentCard.dinersClub';
        }
        else if (code === 'amex') {
            ccIconLabel = 'paymentCard.amex';
        }
        else if (code === 'switch') {
            ccIconLabel = 'paymentCard.switch';
        }
        else if (code === 'maestro') {
            ccIconLabel = 'paymentCard.maestro';
        }
        else {
            ccIconLabel = 'paymentCard.credit';
        }
        return ccIconLabel;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaymentMethodsComponent, deps: [{ token: i1.UserPaymentService }, { token: i1.TranslationService }, { token: i1.GlobalMessageService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: PaymentMethodsComponent, isStandalone: false, selector: "cx-payment-methods", ngImport: i0, template: "<ng-container *ngIf=\"paymentMethods$ | async as paymentMethods\">\n  <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n  <cx-form-required-legend />\n  <div class=\"cx-payment container\">\n    <div class=\"cx-header\">\n      <h2>\n        {{ 'paymentMethods.paymentMethods' | cxTranslate }}\n      </h2>\n    </div>\n\n    <div class=\"cx-body\">\n      <div class=\"cx-msg\">\n        {{\n          'paymentMethods.newPaymentMethodsAreAddedDuringCheckout' | cxTranslate\n        }}\n      </div>\n      <div *ngIf=\"loading$ | async; else cards\"><cx-spinner></cx-spinner></div>\n      <ng-template #cards>\n        <div class=\"cx-existing row\">\n          <div\n            class=\"cx-payment-card col-sm-12 col-md-12 col-lg-6\"\n            *ngFor=\"let paymentMethod of paymentMethods; let i = index\"\n          >\n            <div class=\"cx-payment-inner\">\n              <cx-card\n                [index]=\"i\"\n                [border]=\"true\"\n                [fitToContainer]=\"true\"\n                [content]=\"getCardContent(paymentMethod) | async\"\n                (deleteCard)=\"deletePaymentMethod(paymentMethod)\"\n                (setDefaultCard)=\"setDefaultPaymentMethod(paymentMethod)\"\n                (editCard)=\"setEdit(paymentMethod)\"\n                [editMode]=\"editCard === paymentMethod.id\"\n                (cancelCard)=\"cancelCard()\"\n              ></cx-card>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CardComponent, selector: "cx-card", inputs: ["border", "editMode", "isDefault", "content", "fitToContainer", "truncateText", "truncateParagraphText", "charactersLimit", "index", "role"], outputs: ["deleteCard", "setDefaultCard", "sendCard", "editCard", "cancelCard"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "component", type: FormRequiredLegendComponent, selector: "cx-form-required-legend", inputs: ["formLegendTranslation"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaymentMethodsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-payment-methods', standalone: false, template: "<ng-container *ngIf=\"paymentMethods$ | async as paymentMethods\">\n  <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n  <cx-form-required-legend />\n  <div class=\"cx-payment container\">\n    <div class=\"cx-header\">\n      <h2>\n        {{ 'paymentMethods.paymentMethods' | cxTranslate }}\n      </h2>\n    </div>\n\n    <div class=\"cx-body\">\n      <div class=\"cx-msg\">\n        {{\n          'paymentMethods.newPaymentMethodsAreAddedDuringCheckout' | cxTranslate\n        }}\n      </div>\n      <div *ngIf=\"loading$ | async; else cards\"><cx-spinner></cx-spinner></div>\n      <ng-template #cards>\n        <div class=\"cx-existing row\">\n          <div\n            class=\"cx-payment-card col-sm-12 col-md-12 col-lg-6\"\n            *ngFor=\"let paymentMethod of paymentMethods; let i = index\"\n          >\n            <div class=\"cx-payment-inner\">\n              <cx-card\n                [index]=\"i\"\n                [border]=\"true\"\n                [fitToContainer]=\"true\"\n                [content]=\"getCardContent(paymentMethod) | async\"\n                (deleteCard)=\"deletePaymentMethod(paymentMethod)\"\n                (setDefaultCard)=\"setDefaultPaymentMethod(paymentMethod)\"\n                (editCard)=\"setEdit(paymentMethod)\"\n                [editMode]=\"editCard === paymentMethod.id\"\n                (cancelCard)=\"cancelCard()\"\n              ></cx-card>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i1.UserPaymentService }, { type: i1.TranslationService }, { type: i1.GlobalMessageService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PaymentMethodsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaymentMethodsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: PaymentMethodsModule, declarations: [PaymentMethodsComponent], imports: [CommonModule,
            CardModule,
            SpinnerModule,
            I18nModule,
            FeaturesConfigModule,
            FormRequiredLegendComponent], exports: [PaymentMethodsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaymentMethodsModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    AccountPaymentDetailsComponent: {
                        component: PaymentMethodsComponent,
                        guards: [AuthGuard],
                    },
                },
            }),
        ], imports: [CommonModule,
            CardModule,
            SpinnerModule,
            I18nModule,
            FeaturesConfigModule,
            FormRequiredLegendComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: PaymentMethodsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CardModule,
                        SpinnerModule,
                        I18nModule,
                        FeaturesConfigModule,
                        FormRequiredLegendComponent,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                AccountPaymentDetailsComponent: {
                                    component: PaymentMethodsComponent,
                                    guards: [AuthGuard],
                                },
                            },
                        }),
                    ],
                    declarations: [PaymentMethodsComponent],
                    exports: [PaymentMethodsComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductCarouselService {
    constructor(productService, semanticPathService) {
        this.productService = productService;
        this.semanticPathService = semanticPathService;
    }
    /**
     * Loads the product data and converts it `CarouselItem`.
     */
    loadProduct(code) {
        return this.productService.get(code).pipe(filter(isNotUndefined), map((product) => this.convertProduct(product)));
    }
    /**
     * Converts the product to a generic CarouselItem
     */
    convertProduct(source, displayTitle = true, displayProductPrices = true) {
        const item = {};
        if (displayTitle) {
            item.title = source.name;
        }
        if (displayProductPrices && source.price && source.price.formattedValue) {
            item.price = source.price.formattedValue;
        }
        if (source.images && source.images.PRIMARY) {
            item.media = {
                container: source.images.PRIMARY,
                format: 'product',
            };
        }
        item.route = this.semanticPathService.transform({
            cxRoute: 'product',
            params: source,
        });
        return item;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselService, deps: [{ token: i1.ProductService }, { token: i1.SemanticPathService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.ProductService }, { type: i1.SemanticPathService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `ProductListComponentService` is used to search products. The service is used
 * on the Product Listing Page, for listing products and the facet navigation.
 *
 * The service exposes the product search results based on the category and search
 * route parameters. The route parameters are used to query products by the help of
 * the `ProductSearchService`.
 */
class ProductListComponentService {
    constructor(productSearchService, routing, activatedRoute, currencyService, languageService, router, config) {
        this.productSearchService = productSearchService;
        this.routing = routing;
        this.activatedRoute = activatedRoute;
        this.currencyService = currencyService;
        this.languageService = languageService;
        this.router = router;
        this.config = config;
        this.RELEVANCE_ALLCATEGORIES = ':relevance:allCategories:';
        /**
         * Emits the search results for the current search query.
         *
         * The `searchResults$` is _not_ concerned with querying, it only observes the
         * `productSearchService.getResults()`
         */
        this.searchResults$ = this.productSearchService
            .getResults()
            .pipe(filter((searchResult) => Object.keys(searchResult).length > 0));
        /**
         * Observes the route and performs a search on each route change.
         *
         * Context changes, such as language and currencies are also taken
         * into account, so that the search is performed again.
         */
        this.searchByRouting$ = combineLatest([
            this.routing.getRouterState().pipe(distinctUntilChanged((x, y) => {
                // router emits new value also when the anticipated `nextState` changes
                // but we want to perform search only when current url changes
                return x.state.url === y.state.url;
            })),
            ...this.siteContext,
        ]).pipe(debounceTime$1(0), map(([routerState, ..._context]) => routerState.state), tap((state) => {
            const criteria = this.getCriteriaFromRoute(state.params, state.queryParams);
            this.searchIfCriteriaHasChanged(criteria);
        }));
        /**
         * This stream is used for the Product Listing and Product Facets.
         *
         * It not only emits search results, but also performs a search on every change
         * of the route (i.e. route params or query params).
         *
         * When a user leaves the PLP route, the PLP component unsubscribes from this stream
         * so no longer the search is performed on route change.
         */
        this.model$ = using(() => this.searchByRouting$.subscribe(), () => this.searchResults$).pipe(shareReplay$1({ bufferSize: 1, refCount: true }));
    }
    /**
     * Search only if the previous search criteria does NOT match the new one.
     * This prevents repeating product search calls for queries that already have loaded data.
     */
    searchIfCriteriaHasChanged(criteria) {
        this.productSearchService
            .getResults()
            .pipe(take(1))
            .subscribe((results) => {
            const previous = {
                query: results?.currentQuery?.query?.value,
                currentPage: results?.pagination?.currentPage,
                pageSize: results?.pagination?.pageSize,
                sortCode: results?.pagination?.sort,
            };
            if (checkQueriesDiffer() ||
                checkCurrentPagesDiffer() ||
                checkPageSizesDiffer() ||
                checkSortCodesDiffer()) {
                this.search(criteria);
            }
            function checkQueriesDiffer() {
                const previousQuery = sanitizeQuery(previous.query, previous.sortCode);
                const currentQuery = sanitizeQuery(criteria.query, criteria.sortCode);
                return previousQuery !== currentQuery;
                // Remove sortCode portion from queries.
                function sanitizeQuery(query, sortCode) {
                    const DEFAULT_SORT_CODE = 'relevance';
                    query = query
                        ?.replace(':' + DEFAULT_SORT_CODE, '')
                        .replace(DEFAULT_SORT_CODE, '');
                    if (sortCode) {
                        query = query?.replace(':' + sortCode, '').replace(sortCode, '');
                    }
                    return query;
                }
            }
            function checkCurrentPagesDiffer() {
                // Can be stored as zero for previousCriteria but undefined as new criteria.
                // We need to set these to the zero-values to perform the equivalency check.
                const previousPage = previous.currentPage && previous.currentPage > 0
                    ? previous.currentPage
                    : undefined;
                return previousPage?.toString() !== criteria.currentPage?.toString();
            }
            function checkPageSizesDiffer() {
                return (previous.pageSize?.toString() !== criteria.pageSize?.toString());
            }
            function checkSortCodesDiffer() {
                // Only check "sortCode" if it is defined in criteria as sortCode is often an undefined queryParam
                // but it will always get defined as a string in previousCriteria if a search was made.
                const previousCode = criteria.sortCode
                    ? previous?.sortCode
                    : undefined;
                return previousCode?.toString() !== criteria.sortCode?.toString();
            }
        });
    }
    /**
     * Expose the `SearchCriteria`. The search criteria are driven by the route parameters.
     *
     * This search route configuration is not yet configurable
     * (see https://github.com/SAP/spartacus/issues/7191).
     */
    getCriteriaFromRoute(routeParams, queryParams) {
        return {
            query: queryParams.query || this.getQueryFromRouteParams(routeParams),
            pageSize: queryParams.pageSize || this.config.view?.defaultPageSize,
            currentPage: queryParams.currentPage,
            sortCode: queryParams.sortCode,
        };
    }
    /**
     * Resolves the search query from the given `ProductListRouteParams`.
     */
    getQueryFromRouteParams({ query, categoryCode, brandCode, }) {
        if (query) {
            return query;
        }
        if (categoryCode) {
            return this.RELEVANCE_ALLCATEGORIES + categoryCode;
        }
        // TODO: drop support for brands as they should be treated
        // similarly as any category.
        if (brandCode) {
            return this.RELEVANCE_ALLCATEGORIES + brandCode;
        }
    }
    /**
     * Performs a search based on the given search criteria.
     *
     * The search is delegated to the `ProductSearchService`.
     */
    search(criteria) {
        const currentPage = criteria.currentPage;
        const pageSize = criteria.pageSize;
        const sort = criteria.sortCode;
        this.productSearchService.search(criteria.query, 
        // TODO: consider dropping this complex passing of cleaned object
        Object.assign({}, currentPage && { currentPage }, pageSize && { pageSize }, sort && { sort }));
    }
    /**
     * Get items from a given page without using navigation
     */
    getPageItems(pageNumber) {
        this.routing
            .getRouterState()
            .subscribe((route) => {
            const routeCriteria = this.getCriteriaFromRoute(route.state.params, route.state.queryParams);
            const criteria = {
                ...routeCriteria,
                currentPage: pageNumber,
            };
            this.search(criteria);
        })
            .unsubscribe();
    }
    /**
     * Sort the search results by the given sort code.
     */
    sort(sortCode) {
        this.route({ sortCode });
    }
    /**
     * Routes to the next product listing page, using the given `queryParams`. The
     * `queryParams` support sorting, pagination and querying.
     *
     * The `queryParams` are delegated to the Angular router `NavigationExtras`.
     */
    route(queryParams) {
        this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge',
            relativeTo: this.activatedRoute,
        });
    }
    /**
     * The site context is used to update the search query in case of a
     * changing context. The context will typically influence the search data.
     *
     * We keep this private for now, as we're likely refactoring this in the next
     * major version.
     */
    get siteContext() {
        // TODO: we should refactor this so that custom context will be taken
        // into account automatically. Ideally, we drop the specific context
        // from the constructor, and query a ContextService for all contexts.
        return [this.languageService.getActive(), this.currencyService.getActive()];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListComponentService, deps: [{ token: i1.ProductSearchService }, { token: i1.RoutingService }, { token: i1$2.ActivatedRoute }, { token: i1.CurrencyService }, { token: i1.LanguageService }, { token: i1$2.Router }, { token: ViewConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListComponentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListComponentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.ProductSearchService }, { type: i1.RoutingService }, { type: i1$2.ActivatedRoute }, { type: i1.CurrencyService }, { type: i1.LanguageService }, { type: i1$2.Router }, { type: ViewConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var ViewModes;
(function (ViewModes) {
    ViewModes["Grid"] = "grid";
    ViewModes["List"] = "list";
})(ViewModes || (ViewModes = {}));
class ProductViewComponent {
    constructor() {
        this.iconTypes = ICON_TYPE;
        this.modeChange = new EventEmitter();
    }
    get buttonClass() {
        const viewName = this.viewMode?.toLowerCase();
        return `cx-product-${viewName}`;
    }
    /**
     *   Display icons inversely to allow users
     *   to see the view they will navigate to
     */
    get viewMode() {
        if (this.mode === 'list') {
            return this.iconTypes.GRID;
        }
        return this.iconTypes.LIST;
    }
    changeMode() {
        const newMode = this.mode === ViewModes.Grid ? ViewModes.List : ViewModes.Grid;
        this.modeChange.emit(newMode);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductViewComponent, isStandalone: false, selector: "cx-product-view", inputs: { mode: "mode" }, outputs: { modeChange: "modeChange" }, ngImport: i0, template: "<button\n  class=\"btn cx-product-layout\"\n  [ngClass]=\"buttonClass\"\n  (click)=\"changeMode()\"\n  tabindex=\"0\"\n  attr.aria-label=\"{{\n    viewMode === iconTypes.GRID\n      ? ('productView.gridView' | cxTranslate)\n      : viewMode === iconTypes.LIST\n        ? ('productView.listView' | cxTranslate)\n        : null\n  }}\"\n  attr.title=\"{{\n    viewMode === iconTypes.GRID\n      ? ('productView.gridView' | cxTranslate)\n      : viewMode === iconTypes.LIST\n        ? ('productView.listView' | cxTranslate)\n        : null\n  }}\"\n>\n  <cx-icon\n    *ngIf=\"viewMode === iconTypes.GRID\"\n    [type]=\"iconTypes.GRID\"\n  ></cx-icon>\n  <cx-icon\n    *ngIf=\"viewMode === iconTypes.LIST\"\n    [type]=\"iconTypes.LIST\"\n  ></cx-icon>\n</button>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-view', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<button\n  class=\"btn cx-product-layout\"\n  [ngClass]=\"buttonClass\"\n  (click)=\"changeMode()\"\n  tabindex=\"0\"\n  attr.aria-label=\"{{\n    viewMode === iconTypes.GRID\n      ? ('productView.gridView' | cxTranslate)\n      : viewMode === iconTypes.LIST\n        ? ('productView.listView' | cxTranslate)\n        : null\n  }}\"\n  attr.title=\"{{\n    viewMode === iconTypes.GRID\n      ? ('productView.gridView' | cxTranslate)\n      : viewMode === iconTypes.LIST\n        ? ('productView.listView' | cxTranslate)\n        : null\n  }}\"\n>\n  <cx-icon\n    *ngIf=\"viewMode === iconTypes.GRID\"\n    [type]=\"iconTypes.GRID\"\n  ></cx-icon>\n  <cx-icon\n    *ngIf=\"viewMode === iconTypes.LIST\"\n    [type]=\"iconTypes.LIST\"\n  ></cx-icon>\n</button>\n" }]
        }], propDecorators: { mode: [{
                type: Input
            }], modeChange: [{
                type: Output
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var ProductDetailOutlets;
(function (ProductDetailOutlets) {
    ProductDetailOutlets["INTRO"] = "PDP.INTRO";
    ProductDetailOutlets["PRICE"] = "PDP.PRICE";
    ProductDetailOutlets["SHARE"] = "PDP.SHARE";
    ProductDetailOutlets["SUMMARY"] = "PDP.SUMMARY";
})(ProductDetailOutlets || (ProductDetailOutlets = {}));
var ProductListOutlets;
(function (ProductListOutlets) {
    ProductListOutlets["ITEM_ACTIONS"] = "cx-product-list-item.actions";
    ProductListOutlets["ITEM_DETAILS"] = "cx-product-list-item.details";
})(ProductListOutlets || (ProductListOutlets = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Context for `ProductListItemComponent`.
 */
class ProductListItemContext {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListItemContext, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListItemContext }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListItemContext, decorators: [{
            type: Injectable
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Context source for `ProductListItemComponent`.
 *
 * `ProductListItemContext` should be injected instead in child components.
 */
class ProductListItemContextSource extends ProductListItemContext {
    constructor() {
        super(...arguments);
        this.product$ = new ReplaySubject(1);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListItemContextSource, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListItemContextSource }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListItemContextSource, decorators: [{
            type: Injectable
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListService {
    shouldHideAddToCartButton(product) {
        return !product.price || product.purchasable === false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListItemComponent {
    constructor(productListItemContextSource) {
        this.productListItemContextSource = productListItemContextSource;
        this.productListService = inject(ProductListService);
        this.hideAddToCartButton = false;
        this.ProductListOutlets = ProductListOutlets;
        useFeatureStyles('consistentSizeProductCards');
    }
    ngOnChanges(changes) {
        if (changes?.product) {
            this.hideAddToCartButton = this.hideAddToCartButton =
                this.productListService.shouldHideAddToCartButton(this.product);
            this.productListItemContextSource.product$.next(this.product);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListItemComponent, deps: [{ token: ProductListItemContextSource }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductListItemComponent, isStandalone: false, selector: "cx-product-list-item", inputs: { product: "product", itemIndex: "itemIndex" }, providers: [
            ProductListItemContextSource,
            {
                provide: ProductListItemContext,
                useExisting: ProductListItemContextSource,
            },
        ], usesOnChanges: true, ngImport: i0, template: "<div class=\"row\">\n  <div class=\"col-12 col-md-4\">\n    <a\n      [attr.aria-label]=\"\n        !product.images?.hasOwnProperty('PRIMARY')\n          ? ('productDetails.noProductImage'\n            | cxTranslate: { product: product.name })\n          : undefined\n      \"\n      [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n      class=\"cx-product-image-container\"\n    >\n      <cx-media\n        class=\"cx-product-image\"\n        [container]=\"product.images?.PRIMARY\"\n        format=\"product\"\n        [alt]=\"product.name || product.summary\"\n        *cxLcpContext=\"let lcpContext\"\n        [fetchPriority]=\"\n          itemIndex === 0 ? (lcpContext.fetchPriority$ | async) : undefined\n        \"\n      ></cx-media>\n    </a>\n  </div>\n  <div class=\"col-12 col-md-8\">\n    <h2 class=\"cx-product-name\">\n      <a\n        [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n        [innerHTML]=\"product.nameHtml\"\n      ></a>\n    </h2>\n\n    <ng-template [cxOutlet]=\"ProductListOutlets.ITEM_DETAILS\">\n      <cx-star-rating\n        *ngIf=\"product.averageRating\"\n        [rating]=\"product?.averageRating\"\n      ></cx-star-rating>\n      <div *ngIf=\"!product.averageRating\" class=\"cx-product-no-review\">\n        {{ 'productDetails.noReviews' | cxTranslate }}\n      </div>\n      <div\n        class=\"cx-product-price\"\n        [attr.aria-label]=\"'productDetails.productPrice' | cxTranslate\"\n      >\n        {{ product.price?.formattedValue }}\n      </div>\n    </ng-template>\n\n    <div class=\"row\">\n      <div class=\"col-12 col-md-7 col-xl-7\">\n        <p class=\"cx-product-summary\" [innerHTML]=\"product.summary\"></p>\n      </div>\n      <div class=\"col-12 col-md-5 col-xl-5\">\n        <ng-template [cxOutlet]=\"ProductListOutlets.ITEM_ACTIONS\">\n          <ng-container *ngIf=\"!hideAddToCartButton\">\n            <ng-container cxInnerComponentsHost></ng-container>\n          </ng-container>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MediaComponent, selector: "cx-media", inputs: ["container", "format", "alt", "role", "loading", "fetchPriority", "elementType", "sizesForImgElement"], outputs: ["loaded"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "directive", type: InnerComponentsHostDirective, selector: "[cxInnerComponentsHost]" }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: StarRatingComponent, selector: "cx-star-rating", inputs: ["disabled", "rating"], outputs: ["change"] }, { kind: "directive", type: LcpContextDirective, selector: "[cxLcpContext]" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.UrlPipe, name: "cxUrl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-list-item', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        ProductListItemContextSource,
                        {
                            provide: ProductListItemContext,
                            useExisting: ProductListItemContextSource,
                        },
                    ], standalone: false, template: "<div class=\"row\">\n  <div class=\"col-12 col-md-4\">\n    <a\n      [attr.aria-label]=\"\n        !product.images?.hasOwnProperty('PRIMARY')\n          ? ('productDetails.noProductImage'\n            | cxTranslate: { product: product.name })\n          : undefined\n      \"\n      [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n      class=\"cx-product-image-container\"\n    >\n      <cx-media\n        class=\"cx-product-image\"\n        [container]=\"product.images?.PRIMARY\"\n        format=\"product\"\n        [alt]=\"product.name || product.summary\"\n        *cxLcpContext=\"let lcpContext\"\n        [fetchPriority]=\"\n          itemIndex === 0 ? (lcpContext.fetchPriority$ | async) : undefined\n        \"\n      ></cx-media>\n    </a>\n  </div>\n  <div class=\"col-12 col-md-8\">\n    <h2 class=\"cx-product-name\">\n      <a\n        [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n        [innerHTML]=\"product.nameHtml\"\n      ></a>\n    </h2>\n\n    <ng-template [cxOutlet]=\"ProductListOutlets.ITEM_DETAILS\">\n      <cx-star-rating\n        *ngIf=\"product.averageRating\"\n        [rating]=\"product?.averageRating\"\n      ></cx-star-rating>\n      <div *ngIf=\"!product.averageRating\" class=\"cx-product-no-review\">\n        {{ 'productDetails.noReviews' | cxTranslate }}\n      </div>\n      <div\n        class=\"cx-product-price\"\n        [attr.aria-label]=\"'productDetails.productPrice' | cxTranslate\"\n      >\n        {{ product.price?.formattedValue }}\n      </div>\n    </ng-template>\n\n    <div class=\"row\">\n      <div class=\"col-12 col-md-7 col-xl-7\">\n        <p class=\"cx-product-summary\" [innerHTML]=\"product.summary\"></p>\n      </div>\n      <div class=\"col-12 col-md-5 col-xl-5\">\n        <ng-template [cxOutlet]=\"ProductListOutlets.ITEM_ACTIONS\">\n          <ng-container *ngIf=\"!hideAddToCartButton\">\n            <ng-container cxInnerComponentsHost></ng-container>\n          </ng-container>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: ProductListItemContextSource }], propDecorators: { product: [{
                type: Input
            }], itemIndex: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductGridItemComponent {
    constructor(productListItemContextSource) {
        this.productListItemContextSource = productListItemContextSource;
        this.productListService = inject(ProductListService);
        this.hideAddToCartButton = false;
        this.ProductListOutlets = ProductListOutlets;
        useFeatureStyles('consistentSizeProductCards');
    }
    ngOnChanges(changes) {
        if (changes?.product) {
            this.hideAddToCartButton =
                this.productListService.shouldHideAddToCartButton(this.product);
            this.productListItemContextSource.product$.next(this.product);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductGridItemComponent, deps: [{ token: ProductListItemContextSource }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductGridItemComponent, isStandalone: false, selector: "cx-product-grid-item", inputs: { product: "product", itemIndex: "itemIndex" }, providers: [
            ProductListItemContextSource,
            {
                provide: ProductListItemContext,
                useExisting: ProductListItemContextSource,
            },
        ], usesOnChanges: true, ngImport: i0, template: "<a\n  [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n  class=\"cx-product-image-container\"\n  tabindex=\"-1\"\n>\n  <cx-media\n    class=\"cx-product-image\"\n    [container]=\"product.images?.PRIMARY\"\n    format=\"product\"\n    [alt]=\"product.name || product.summary\"\n    *cxLcpContext=\"let lcpContext\"\n    [fetchPriority]=\"\n      itemIndex === 0 ? (lcpContext.fetchPriority$ | async) : undefined\n    \"\n  ></cx-media>\n</a>\n<a\n  [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n  class=\"cx-product-name\"\n  [innerHTML]=\"product.nameHtml\"\n></a>\n\n<ng-template [cxOutlet]=\"ProductListOutlets.ITEM_DETAILS\">\n  <div class=\"cx-product-rating\">\n    <cx-star-rating\n      *ngIf=\"product.averageRating\"\n      [rating]=\"product?.averageRating\"\n    ></cx-star-rating>\n    <div *ngIf=\"!product.averageRating\">\n      {{ 'productDetails.noReviews' | cxTranslate }}\n    </div>\n  </div>\n  <div class=\"cx-product-price-container\">\n    <div\n      class=\"cx-product-price\"\n      [attr.aria-label]=\"'productDetails.productPrice' | cxTranslate\"\n    >\n      {{ product.price?.formattedValue }}\n    </div>\n  </div>\n</ng-template>\n\n<ng-template [cxOutlet]=\"ProductListOutlets.ITEM_ACTIONS\">\n  <ng-container *ngIf=\"!hideAddToCartButton\">\n    <ng-container cxInnerComponentsHost></ng-container>\n  </ng-container>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MediaComponent, selector: "cx-media", inputs: ["container", "format", "alt", "role", "loading", "fetchPriority", "elementType", "sizesForImgElement"], outputs: ["loaded"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "directive", type: InnerComponentsHostDirective, selector: "[cxInnerComponentsHost]" }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: StarRatingComponent, selector: "cx-star-rating", inputs: ["disabled", "rating"], outputs: ["change"] }, { kind: "directive", type: LcpContextDirective, selector: "[cxLcpContext]" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.UrlPipe, name: "cxUrl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductGridItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-grid-item', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        ProductListItemContextSource,
                        {
                            provide: ProductListItemContext,
                            useExisting: ProductListItemContextSource,
                        },
                    ], standalone: false, template: "<a\n  [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n  class=\"cx-product-image-container\"\n  tabindex=\"-1\"\n>\n  <cx-media\n    class=\"cx-product-image\"\n    [container]=\"product.images?.PRIMARY\"\n    format=\"product\"\n    [alt]=\"product.name || product.summary\"\n    *cxLcpContext=\"let lcpContext\"\n    [fetchPriority]=\"\n      itemIndex === 0 ? (lcpContext.fetchPriority$ | async) : undefined\n    \"\n  ></cx-media>\n</a>\n<a\n  [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n  class=\"cx-product-name\"\n  [innerHTML]=\"product.nameHtml\"\n></a>\n\n<ng-template [cxOutlet]=\"ProductListOutlets.ITEM_DETAILS\">\n  <div class=\"cx-product-rating\">\n    <cx-star-rating\n      *ngIf=\"product.averageRating\"\n      [rating]=\"product?.averageRating\"\n    ></cx-star-rating>\n    <div *ngIf=\"!product.averageRating\">\n      {{ 'productDetails.noReviews' | cxTranslate }}\n    </div>\n  </div>\n  <div class=\"cx-product-price-container\">\n    <div\n      class=\"cx-product-price\"\n      [attr.aria-label]=\"'productDetails.productPrice' | cxTranslate\"\n    >\n      {{ product.price?.formattedValue }}\n    </div>\n  </div>\n</ng-template>\n\n<ng-template [cxOutlet]=\"ProductListOutlets.ITEM_ACTIONS\">\n  <ng-container *ngIf=\"!hideAddToCartButton\">\n    <ng-container cxInnerComponentsHost></ng-container>\n  </ng-container>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: ProductListItemContextSource }], propDecorators: { product: [{
                type: Input
            }], itemIndex: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductScrollComponent {
    set setConfig(inputConfig) {
        this.setComponentConfigurations(inputConfig);
    }
    set setModel(inputModel) {
        this.infiniteScrollOperations(inputModel);
    }
    set setViewMode(inputViewMode) {
        this.inputViewMode = inputViewMode;
        //If viewMode is already set (meaning it is not the first load)
        //Reset the product list
        if (this.viewMode) {
            this.resetListOnViewModeChange();
        }
        else {
            //If viewMode is not set (meaning it is the first load)
            //Set the viewMode
            this.viewMode = inputViewMode;
        }
    }
    constructor(productListComponentService, ref) {
        this.productListComponentService = productListComponentService;
        this.ref = ref;
        this.subscription = new Subscription();
        this.ViewModes = ViewModes;
        this.appendProducts = false;
        this.resetList = false;
        this.isMaxProducts = false;
        this.isLastPage = false;
        this.isEmpty = false;
    }
    scrollPage(pageNumber) {
        this.appendProducts = true;
        this.ref.markForCheck();
        this.productListComponentService.getPageItems(pageNumber);
    }
    loadNextPage(pageNumber) {
        this.isMaxProducts = false;
        this.scrollPage(pageNumber);
    }
    scrollToTop() {
        window.scroll(0, 0);
    }
    setComponentConfigurations(scrollConfig) {
        const isButton = scrollConfig.view?.infiniteScroll?.showMoreButton;
        const configProductLimit = scrollConfig.view?.infiniteScroll?.productLimit;
        //Display "show more" button every time when button configuration is true
        //Otherwise, only display "show more" when the configuration product limit is reached
        this.productLimit = isButton ? 1 : configProductLimit;
    }
    infiniteScrollOperations(inputModel) {
        if (this.appendProducts) {
            this.model = {
                ...inputModel,
                products: this.model.products?.concat(inputModel.products ?? []),
            };
        }
        else {
            this.model = inputModel;
            this.maxProducts = this.productLimit;
        }
        this.setConditions();
        this.ref.markForCheck();
    }
    resetListOnViewModeChange() {
        this.scrollToTop();
        this.resetList = true;
        this.productListComponentService.getPageItems(0);
    }
    //Set booleans after model has been retrieved
    setConditions() {
        this.isEmpty = !this.model.products || this.model.products.length === 0;
        this.isLastPage =
            this.model.pagination?.currentPage ===
                (this.model.pagination?.totalPages ?? 0) - 1;
        if (this.model.products) {
            this.isMaxProducts =
                this.productLimit !== undefined &&
                    this.productLimit !== 0 &&
                    this.model.products.length >= (this.maxProducts ?? 0);
            //Add the productLimit to the current number of products to determine the next max number of products
            if (this.isMaxProducts) {
                this.maxProducts =
                    this.model.products.length + (this.productLimit ?? 0);
            }
        }
        //Only change viewMode once the new model is set
        //This prevents flickering issues
        if (this.viewMode !== this.inputViewMode) {
            this.viewMode = this.inputViewMode;
        }
        this.resetList = false;
        this.appendProducts = false;
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductScrollComponent, deps: [{ token: ProductListComponentService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductScrollComponent, isStandalone: false, selector: "cx-product-scroll", inputs: { setConfig: ["scrollConfig", "setConfig"], setModel: ["model", "setModel"], setViewMode: ["inputViewMode", "setViewMode"] }, ngImport: i0, template: "<ng-container *ngIf=\"viewMode === ViewModes.Grid\">\n  <div\n    infiniteScroll\n    [infiniteScrollDistance]=\"5\"\n    [infiniteScrollThrottle]=\"50\"\n    [infiniteScrollDisabled]=\"isMaxProducts || isLastPage || isEmpty\"\n    (scrolled)=\"scrollPage((model?.pagination?.currentPage ?? 0) + 1)\"\n  >\n    <div class=\"row\">\n      <cx-product-grid-item\n        *ngFor=\"let product of model?.products; let i = index\"\n        [product]=\"product\"\n        [itemIndex]=\"i\"\n        class=\"col-12 col-sm-6 col-md-4\"\n      ></cx-product-grid-item>\n    </div>\n    <div\n      [className]=\"\n        !isLastPage && (model?.pagination?.currentPage ?? 0) > 0\n          ? 'cx-double-btn-container grid-btn-padding'\n          : 'cx-single-btn-container grid-btn-padding'\n      \"\n    >\n      <div\n        *ngIf=\"\n          (isMaxProducts || isLastPage) &&\n          (model?.pagination?.currentPage ?? 0) > 0\n        \"\n        (click)=\"scrollToTop()\"\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'productList.backToTopBtn' | cxTranslate }}\n      </div>\n      <div\n        *ngIf=\"isMaxProducts && !isLastPage\"\n        (click)=\"loadNextPage((model?.pagination?.currentPage ?? 0) + 1)\"\n        class=\"btn btn-block btn-secondary align-btn\"\n      >\n        {{ 'productList.showMoreBtn' | cxTranslate }}\n      </div>\n    </div>\n    <div *ngIf=\"appendProducts\" class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"viewMode === ViewModes.List\">\n  <div\n    infiniteScroll\n    [infiniteScrollDistance]=\"3\"\n    [infiniteScrollThrottle]=\"50\"\n    [infiniteScrollDisabled]=\"isMaxProducts || isLastPage || isEmpty\"\n    (scrolled)=\"scrollPage((model?.pagination?.currentPage ?? 0) + 1)\"\n  >\n    <cx-product-list-item\n      *ngFor=\"let product of model?.products; let i = index\"\n      [product]=\"product\"\n      [itemIndex]=\"i\"\n      class=\"cx-product-search-list\"\n    ></cx-product-list-item>\n    <div\n      [className]=\"\n        !isLastPage && (model?.pagination?.currentPage ?? 0) > 0\n          ? 'cx-double-btn-container'\n          : 'cx-single-btn-container'\n      \"\n    >\n      <div\n        *ngIf=\"\n          (isMaxProducts || isLastPage) &&\n          (model?.pagination?.currentPage ?? 0) > 0\n        \"\n        (click)=\"scrollToTop()\"\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'productList.backToTopBtn' | cxTranslate }}\n      </div>\n      <div\n        *ngIf=\"isMaxProducts && !isLastPage\"\n        (click)=\"loadNextPage((model?.pagination?.currentPage ?? 0) + 1)\"\n        class=\"btn btn-block btn-secondary align-btn\"\n      >\n        {{ 'productList.showMoreBtn' | cxTranslate }}\n      </div>\n    </div>\n    <div *ngIf=\"appendProducts\" class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.InfiniteScrollDirective, selector: "[infiniteScroll], [infinite-scroll], [data-infinite-scroll]", inputs: ["infiniteScrollDistance", "infiniteScrollUpDistance", "infiniteScrollThrottle", "infiniteScrollDisabled", "infiniteScrollContainer", "scrollWindow", "immediateCheck", "horizontal", "alwaysCallback", "fromRoot"], outputs: ["scrolled", "scrolledUp"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "component", type: ProductListItemComponent, selector: "cx-product-list-item", inputs: ["product", "itemIndex"] }, { kind: "component", type: ProductGridItemComponent, selector: "cx-product-grid-item", inputs: ["product", "itemIndex"] }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductScrollComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-scroll', standalone: false, template: "<ng-container *ngIf=\"viewMode === ViewModes.Grid\">\n  <div\n    infiniteScroll\n    [infiniteScrollDistance]=\"5\"\n    [infiniteScrollThrottle]=\"50\"\n    [infiniteScrollDisabled]=\"isMaxProducts || isLastPage || isEmpty\"\n    (scrolled)=\"scrollPage((model?.pagination?.currentPage ?? 0) + 1)\"\n  >\n    <div class=\"row\">\n      <cx-product-grid-item\n        *ngFor=\"let product of model?.products; let i = index\"\n        [product]=\"product\"\n        [itemIndex]=\"i\"\n        class=\"col-12 col-sm-6 col-md-4\"\n      ></cx-product-grid-item>\n    </div>\n    <div\n      [className]=\"\n        !isLastPage && (model?.pagination?.currentPage ?? 0) > 0\n          ? 'cx-double-btn-container grid-btn-padding'\n          : 'cx-single-btn-container grid-btn-padding'\n      \"\n    >\n      <div\n        *ngIf=\"\n          (isMaxProducts || isLastPage) &&\n          (model?.pagination?.currentPage ?? 0) > 0\n        \"\n        (click)=\"scrollToTop()\"\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'productList.backToTopBtn' | cxTranslate }}\n      </div>\n      <div\n        *ngIf=\"isMaxProducts && !isLastPage\"\n        (click)=\"loadNextPage((model?.pagination?.currentPage ?? 0) + 1)\"\n        class=\"btn btn-block btn-secondary align-btn\"\n      >\n        {{ 'productList.showMoreBtn' | cxTranslate }}\n      </div>\n    </div>\n    <div *ngIf=\"appendProducts\" class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"viewMode === ViewModes.List\">\n  <div\n    infiniteScroll\n    [infiniteScrollDistance]=\"3\"\n    [infiniteScrollThrottle]=\"50\"\n    [infiniteScrollDisabled]=\"isMaxProducts || isLastPage || isEmpty\"\n    (scrolled)=\"scrollPage((model?.pagination?.currentPage ?? 0) + 1)\"\n  >\n    <cx-product-list-item\n      *ngFor=\"let product of model?.products; let i = index\"\n      [product]=\"product\"\n      [itemIndex]=\"i\"\n      class=\"cx-product-search-list\"\n    ></cx-product-list-item>\n    <div\n      [className]=\"\n        !isLastPage && (model?.pagination?.currentPage ?? 0) > 0\n          ? 'cx-double-btn-container'\n          : 'cx-single-btn-container'\n      \"\n    >\n      <div\n        *ngIf=\"\n          (isMaxProducts || isLastPage) &&\n          (model?.pagination?.currentPage ?? 0) > 0\n        \"\n        (click)=\"scrollToTop()\"\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'productList.backToTopBtn' | cxTranslate }}\n      </div>\n      <div\n        *ngIf=\"isMaxProducts && !isLastPage\"\n        (click)=\"loadNextPage((model?.pagination?.currentPage ?? 0) + 1)\"\n        class=\"btn btn-block btn-secondary align-btn\"\n      >\n        {{ 'productList.showMoreBtn' | cxTranslate }}\n      </div>\n    </div>\n    <div *ngIf=\"appendProducts\" class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: ProductListComponentService }, { type: i0.ChangeDetectorRef }], propDecorators: { setConfig: [{
                type: Input,
                args: ['scrollConfig']
            }], setModel: [{
                type: Input,
                args: ['model']
            }], setViewMode: [{
                type: Input,
                args: ['inputViewMode']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListComponent {
    constructor(pageLayoutService, productListComponentService, globalMessageService, scrollConfig) {
        this.pageLayoutService = pageLayoutService;
        this.productListComponentService = productListComponentService;
        this.globalMessageService = globalMessageService;
        this.scrollConfig = scrollConfig;
        this.subscription = new Subscription();
        this.model$ = this.productListComponentService.model$;
        this.viewMode$ = new BehaviorSubject(ViewModes.Grid);
        this.ViewModes = ViewModes;
        useFeatureStyles('reserveSpaceForImagesOnPdpAndPlp');
    }
    ngOnInit() {
        this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;
        this.subscription.add(this.pageLayoutService.templateName$
            .pipe(take(1))
            .subscribe((template) => {
            this.viewMode$.next(template === 'ProductGridPageTemplate'
                ? ViewModes.Grid
                : ViewModes.List);
        }));
        this.subscription.add(combineLatest([this.model$, this.viewMode$])
            .pipe(skip(1), filter(([model, mode]) => !!model && !!mode))
            .subscribe(() => this.globalMessageService.add({ key: 'sorting.pageViewUpdated' }, GlobalMessageType.MSG_TYPE_ASSISTIVE, 500)));
    }
    sortList(sortCode) {
        this.productListComponentService.sort(sortCode);
    }
    setViewMode(mode) {
        this.viewMode$.next(mode);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListComponent, deps: [{ token: PageLayoutService }, { token: ProductListComponentService }, { token: i1.GlobalMessageService }, { token: ViewConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductListComponent, isStandalone: false, selector: "cx-product-list", ngImport: i0, template: "<div class=\"cx-page\" *ngIf=\"model$ | async as model\">\n  <section\n    tabindex=\"-1\"\n    class=\"cx-page-section\"\n    [attr.aria-label]=\"'productList.productListResults' | cxTranslate\"\n  >\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-12 col-lg-12\" *ngIf=\"viewMode$ | async as viewMode\">\n          <div class=\"cx-sorting top\">\n            <div class=\"row\">\n              <label\n                class=\"form-group cx-sort-dropdown col-12 col-lg-4 mr-auto\"\n              >\n                <span>{{ 'productList.sortBy' | cxTranslate }}</span>\n                <cx-sorting\n                  [sortOptions]=\"model.sorts\"\n                  (sortListEvent)=\"sortList($event)\"\n                  [selectedOption]=\"model.pagination?.sort\"\n                  [ariaLabel]=\"'productList.sortResults' | cxTranslate\"\n                  ariaControls=\"product-results-list\"\n                  placeholder=\"{{ 'productList.sortBy' | cxTranslate }}\"\n                ></cx-sorting>\n              </label>\n              <div *ngIf=\"!isInfiniteScroll\" class=\"col-auto\">\n                <div\n                  class=\"cx-pagination\"\n                  [attr.aria-label]=\"\n                    'productList.productSearchPagination' | cxTranslate\n                  \"\n                >\n                  <cx-pagination\n                    [pagination]=\"model.pagination\"\n                    queryParam=\"currentPage\"\n                    [defaultPage]=\"0\"\n                    paginationID=\"pagination-top\"\n                  ></cx-pagination>\n                </div>\n              </div>\n              <div class=\"col-auto ml-auto ml-lg-0\">\n                <cx-product-view\n                  (modeChange)=\"setViewMode($event)\"\n                  [mode]=\"viewMode\"\n                ></cx-product-view>\n              </div>\n            </div>\n          </div>\n          <div id=\"product-results-list\" class=\"cx-product-container\">\n            <!-- Product list when using pagination -->\n            <ng-container *ngIf=\"!isInfiniteScroll; else infiniteScroll\">\n              <ng-container *ngIf=\"viewMode === ViewModes.Grid\">\n                <div class=\"row\">\n                  <cx-product-grid-item\n                    *ngFor=\"let product of model?.products; let i = index\"\n                    [product]=\"product\"\n                    [itemIndex]=\"i\"\n                    class=\"col-12 col-sm-6 col-md-4\"\n                  ></cx-product-grid-item>\n                </div>\n              </ng-container>\n\n              <ng-container *ngIf=\"viewMode === ViewModes.List\">\n                <cx-product-list-item\n                  *ngFor=\"let product of model?.products; let i = index\"\n                  [product]=\"product\"\n                  [itemIndex]=\"i\"\n                  class=\"cx-product-search-list\"\n                ></cx-product-list-item>\n              </ng-container>\n            </ng-container>\n\n            <!-- Product list when using infinite scroll -->\n            <ng-template #infiniteScroll>\n              <cx-product-scroll\n                [scrollConfig]=\"scrollConfig\"\n                [model]=\"model\"\n                [inputViewMode]=\"viewMode\"\n              ></cx-product-scroll>\n            </ng-template>\n          </div>\n          <div class=\"cx-sorting bottom\">\n            <div class=\"row\">\n              <label\n                class=\"form-group cx-sort-dropdown col-12 col-lg-4 mr-auto\"\n              >\n                <span>{{ 'productList.sortBy' | cxTranslate }}</span>\n                <cx-sorting\n                  [sortOptions]=\"model.sorts\"\n                  (sortListEvent)=\"sortList($event)\"\n                  [selectedOption]=\"model.pagination?.sort\"\n                  [ariaLabel]=\"'productList.sortResults' | cxTranslate\"\n                  ariaControls=\"product-results-list\"\n                  placeholder=\"{{ 'productList.sortBy' | cxTranslate }}\"\n                ></cx-sorting>\n              </label>\n              <div\n                *ngIf=\"!isInfiniteScroll\"\n                class=\"col-auto\"\n                [attr.aria-label]=\"\n                  'productList.productSearchPagination' | cxTranslate\n                \"\n              >\n                <div class=\"cx-pagination\">\n                  <cx-pagination\n                    [pagination]=\"model.pagination\"\n                    queryParam=\"currentPage\"\n                    [defaultPage]=\"0\"\n                    paginationID=\"pagination-bottom\"\n                  ></cx-pagination>\n                </div>\n              </div>\n              <div class=\"col-auto ml-auto ml-lg-0\">\n                <cx-product-view\n                  (modeChange)=\"setViewMode($event)\"\n                  [mode]=\"viewMode\"\n                ></cx-product-view>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SortingComponent, selector: "cx-sorting", inputs: ["sortOptions", "ariaControls", "ariaLabel", "selectedOption", "placeholder", "sortLabels"], outputs: ["sortListEvent"] }, { kind: "component", type: PaginationComponent, selector: "cx-pagination", inputs: ["pageRoute", "queryParam", "defaultPage", "pagination", "paginationID"], outputs: ["viewPageEvent"] }, { kind: "component", type: ProductListItemComponent, selector: "cx-product-list-item", inputs: ["product", "itemIndex"] }, { kind: "component", type: ProductGridItemComponent, selector: "cx-product-grid-item", inputs: ["product", "itemIndex"] }, { kind: "component", type: ProductViewComponent, selector: "cx-product-view", inputs: ["mode"], outputs: ["modeChange"] }, { kind: "component", type: ProductScrollComponent, selector: "cx-product-scroll", inputs: ["scrollConfig", "model", "inputViewMode"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-list', standalone: false, template: "<div class=\"cx-page\" *ngIf=\"model$ | async as model\">\n  <section\n    tabindex=\"-1\"\n    class=\"cx-page-section\"\n    [attr.aria-label]=\"'productList.productListResults' | cxTranslate\"\n  >\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-12 col-lg-12\" *ngIf=\"viewMode$ | async as viewMode\">\n          <div class=\"cx-sorting top\">\n            <div class=\"row\">\n              <label\n                class=\"form-group cx-sort-dropdown col-12 col-lg-4 mr-auto\"\n              >\n                <span>{{ 'productList.sortBy' | cxTranslate }}</span>\n                <cx-sorting\n                  [sortOptions]=\"model.sorts\"\n                  (sortListEvent)=\"sortList($event)\"\n                  [selectedOption]=\"model.pagination?.sort\"\n                  [ariaLabel]=\"'productList.sortResults' | cxTranslate\"\n                  ariaControls=\"product-results-list\"\n                  placeholder=\"{{ 'productList.sortBy' | cxTranslate }}\"\n                ></cx-sorting>\n              </label>\n              <div *ngIf=\"!isInfiniteScroll\" class=\"col-auto\">\n                <div\n                  class=\"cx-pagination\"\n                  [attr.aria-label]=\"\n                    'productList.productSearchPagination' | cxTranslate\n                  \"\n                >\n                  <cx-pagination\n                    [pagination]=\"model.pagination\"\n                    queryParam=\"currentPage\"\n                    [defaultPage]=\"0\"\n                    paginationID=\"pagination-top\"\n                  ></cx-pagination>\n                </div>\n              </div>\n              <div class=\"col-auto ml-auto ml-lg-0\">\n                <cx-product-view\n                  (modeChange)=\"setViewMode($event)\"\n                  [mode]=\"viewMode\"\n                ></cx-product-view>\n              </div>\n            </div>\n          </div>\n          <div id=\"product-results-list\" class=\"cx-product-container\">\n            <!-- Product list when using pagination -->\n            <ng-container *ngIf=\"!isInfiniteScroll; else infiniteScroll\">\n              <ng-container *ngIf=\"viewMode === ViewModes.Grid\">\n                <div class=\"row\">\n                  <cx-product-grid-item\n                    *ngFor=\"let product of model?.products; let i = index\"\n                    [product]=\"product\"\n                    [itemIndex]=\"i\"\n                    class=\"col-12 col-sm-6 col-md-4\"\n                  ></cx-product-grid-item>\n                </div>\n              </ng-container>\n\n              <ng-container *ngIf=\"viewMode === ViewModes.List\">\n                <cx-product-list-item\n                  *ngFor=\"let product of model?.products; let i = index\"\n                  [product]=\"product\"\n                  [itemIndex]=\"i\"\n                  class=\"cx-product-search-list\"\n                ></cx-product-list-item>\n              </ng-container>\n            </ng-container>\n\n            <!-- Product list when using infinite scroll -->\n            <ng-template #infiniteScroll>\n              <cx-product-scroll\n                [scrollConfig]=\"scrollConfig\"\n                [model]=\"model\"\n                [inputViewMode]=\"viewMode\"\n              ></cx-product-scroll>\n            </ng-template>\n          </div>\n          <div class=\"cx-sorting bottom\">\n            <div class=\"row\">\n              <label\n                class=\"form-group cx-sort-dropdown col-12 col-lg-4 mr-auto\"\n              >\n                <span>{{ 'productList.sortBy' | cxTranslate }}</span>\n                <cx-sorting\n                  [sortOptions]=\"model.sorts\"\n                  (sortListEvent)=\"sortList($event)\"\n                  [selectedOption]=\"model.pagination?.sort\"\n                  [ariaLabel]=\"'productList.sortResults' | cxTranslate\"\n                  ariaControls=\"product-results-list\"\n                  placeholder=\"{{ 'productList.sortBy' | cxTranslate }}\"\n                ></cx-sorting>\n              </label>\n              <div\n                *ngIf=\"!isInfiniteScroll\"\n                class=\"col-auto\"\n                [attr.aria-label]=\"\n                  'productList.productSearchPagination' | cxTranslate\n                \"\n              >\n                <div class=\"cx-pagination\">\n                  <cx-pagination\n                    [pagination]=\"model.pagination\"\n                    queryParam=\"currentPage\"\n                    [defaultPage]=\"0\"\n                    paginationID=\"pagination-bottom\"\n                  ></cx-pagination>\n                </div>\n              </div>\n              <div class=\"col-auto ml-auto ml-lg-0\">\n                <cx-product-view\n                  (modeChange)=\"setViewMode($event)\"\n                  [mode]=\"viewMode\"\n                ></cx-product-view>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n" }]
        }], ctorParameters: () => [{ type: PageLayoutService }, { type: ProductListComponentService }, { type: i1.GlobalMessageService }, { type: ViewConfig }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var FacetGroupCollapsedState;
(function (FacetGroupCollapsedState) {
    FacetGroupCollapsedState["EXPANDED"] = "EXPANDED";
    FacetGroupCollapsedState["COLLAPSED"] = "COLLAPSED";
})(FacetGroupCollapsedState || (FacetGroupCollapsedState = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides access to all the facets and active facets for the Product Listing Page.
 */
class ProductFacetService {
    constructor(routing, productListComponentService) {
        this.routing = routing;
        this.productListComponentService = productListComponentService;
        this.routeState$ = this.routing
            .getRouterState()
            .pipe(map((routerState) => routerState.state));
        /**
         * Returns the search results for the current page.
         */
        this.searchResult$ = this.routeState$.pipe(switchMap$1((state) => this.productListComponentService.model$.pipe(filter((page) => this.filterForPage(state, page)), map((page) => ({
            ...page,
            breadcrumbs: this.filterBreadcrumbs(page?.breadcrumbs ?? [], state.params),
        })))));
        /**
         * Observes the facets and active facets for the given page. The facet data
         * is provided in a `FacetList`.
         */
        this.facetList$ = this.searchResult$.pipe(map((result) => ({
            facets: result.facets,
            activeFacets: result.breadcrumbs,
        })));
    }
    /**
     * Filters the current result by verifying if the result is related to the page.
     * This is done to avoid a combination of the next page and the current search results.
     */
    filterForPage(state, page) {
        if (!page.currentQuery?.query?.value) {
            return false;
        }
        if (state.context.type === PageType.CATEGORY_PAGE) {
            return (page.currentQuery.query.value.indexOf(`allCategories:${state.context.id}`) > -1);
        }
        if (state.context.type === PageType.CONTENT_PAGE &&
            state.context.id === 'search') {
            return page.freeTextSearch === state.params.query.split(':')[0];
        }
        return false;
    }
    /**
     * Filter breadcrumbs which are not actively selected but coming from
     * the route navigation.
     *
     * The breadcrumbs might include the active category page code, which is not actively
     * selected by the user.
     */
    filterBreadcrumbs(breadcrumbs, params) {
        return breadcrumbs
            ? breadcrumbs.filter((breadcrumb) => !(breadcrumb.facetCode === 'allCategories' &&
                (breadcrumb.facetValueCode === params.categoryCode ||
                    breadcrumb.facetValueCode === params.brandCode)))
            : [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetService, deps: [{ token: i1.RoutingService }, { token: ProductListComponentService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RoutingService }, { type: ProductListComponentService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides access to the facets as well as their UI state. The UI state
 * represents user related changes on the facets, such as expanding or
 * collapsing a facet group or expanding the number of _visible_ facet values.
 */
class FacetService {
    constructor(productFacetService) {
        this.productFacetService = productFacetService;
        /**
         * An internal map where we keep the UI state of the facets.
         */
        this.facetState = new Map();
        this.codec = new HttpUrlEncodingCodec();
        /**
         * Observes the facets for the given page and configures the initial UI state.
         *
         * Facets are configured on each emission so that we keep the facet UI state.
         * This is mainly done to keep the state during usage of the facet, but also
         * benefitial when the facets are rebuild while using them.
         */
        this.facetList$ = this.productFacetService.facetList$.pipe(tap((facetList) => {
            facetList.facets?.forEach((facet) => this.initialize(facet));
        }));
    }
    /**
     * Returns the observed UI state for the facet.
     *
     * The state is initialized using the `initialize` method.
     */
    getState(facet) {
        this.initialize(facet);
        return facet.name ? (this.facetState.get(facet.name) ?? of({})) : of({});
    }
    /**
     * Returns the UI state for the facet.
     *
     * The state is initialized using the `initialize` method.
     */
    getStateSnapshot(facet) {
        return this.getState(facet).value;
    }
    /**
     * Toggles the facet expanded state. If the expanded state becomes false,
     * the visible values will decrease to the top values only.
     *
     * If the optional value argument is provided the expanded state will be set
     * to this value, regardless of the current `expanded` state.
     */
    toggle(facet, isExpanded) {
        const state = this.getStateSnapshot(facet);
        const toggledState = {
            toggled: isExpanded
                ? FacetGroupCollapsedState.COLLAPSED
                : FacetGroupCollapsedState.EXPANDED,
        };
        if (toggledState.toggled === FacetGroupCollapsedState.COLLAPSED) {
            toggledState.maxVisible = state.topVisible;
        }
        this.updateState(facet, toggledState);
    }
    /**
     * Increases the visible values to the maximum values of the facet.
     */
    increaseVisibleValues(facet) {
        this.updateState(facet, { maxVisible: facet.values?.length });
    }
    /**
     * Decreases the visible values to the topValueCount.
     *
     * The topValueCount defaults to 6, but can be controlled in
     * the backend as well.
     */
    decreaseVisibleValues(facet) {
        this.updateState(facet, { maxVisible: facet.topValueCount });
    }
    /**
     * Persists the facet state and initializes the default values for the top
     * and max visible values.
     */
    initialize(facet) {
        const topFacets = facet.topValueCount && facet.topValueCount > 0
            ? facet.topValueCount
            : facet.values?.length || 0;
        if (facet.name && !this.hasState(facet)) {
            this.facetState.set(facet.name, new BehaviorSubject({
                topVisible: topFacets,
                maxVisible: topFacets,
            }));
        }
    }
    /**
     * Updates the state of the facet in the local facet map.
     */
    updateState(facet, property) {
        const state = { ...this.getStateSnapshot(facet), ...property };
        if (facet.name) {
            this.facetState.get(facet.name)?.next(state);
        }
    }
    hasState(facet) {
        if (facet.name) {
            return this.facetState.has(facet.name);
        }
        return false;
    }
    getLinkParams(query) {
        return {
            // to avoid encoding issues with facets that have space (' ') in their name,
            // we replace the decoded '+' back to empty space ' '.
            // For more, see https://github.com/SAP/spartacus/issues/7348
            query: this.codec
                .decodeValue(this.decodeUriComponentSafe(query))
                .replace(/\+/g, ' '),
        };
    }
    decodeUriComponentSafe(query) {
        return query.replace(/%(?![0-9a-fA-F]{2})/g, '%25');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetService, deps: [{ token: ProductFacetService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ProductFacetService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Active facets render the applied facet values as a list of focusable buttons
 * which can be used to remove the applied facet value.
 */
class ActiveFacetsComponent {
    constructor(facetService) {
        this.facetService = facetService;
        this.role = 'group';
        this.labelledby = 'cx-active-facets-groupName';
        /** Active facets which are applied to the product results. */
        this.facetList$ = this.facetService.facetList$;
        /** Configurable icon which is used for the active facet close button */
        this.closeIcon = ICON_TYPE.CLOSE;
    }
    getLinkParams(facet) {
        return this.facetService.getLinkParams(facet.removeQuery?.query?.value ?? '');
    }
    /**
     * The focus key is used to persist the focus on the facet when the DOM is being
     * recreated. We only apply the focus key for the given _active_ facet when there
     * the original facets is not available. This happens for non multi-valued facets.
     *
     * With this approach, the we keep the focus, either at the facet list or on the
     * active facets.
     */
    getFocusKey(facetList, facet) {
        return facetList.facets?.find((f) => f.values?.find((val) => val.name === facet.facetValueName))
            ? ''
            : facet.facetValueName;
    }
    /**
     * Purpose of this function is to allow keyboard users to click on a filter they
     * wish to remove by pressing spacebar. Event not handled natively by <a> elements.
     *
     * @param event spacebar keydown
     */
    removeFilterWithSpacebar(event) {
        event?.preventDefault(); // Avoid spacebar scroll
        event?.target?.dispatchEvent(new MouseEvent('click', { cancelable: true }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ActiveFacetsComponent, deps: [{ token: FacetService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ActiveFacetsComponent, isStandalone: false, selector: "cx-active-facets", inputs: { closeIcon: "closeIcon" }, host: { properties: { "attr.role": "this.role", "attr.aria-labelledby": "this.labelledby" } }, ngImport: i0, template: "<ng-container *ngIf=\"facetList$ | async as facetList\">\n  <div\n    id=\"cx-active-facets-groupName\"\n    *ngIf=\"facetList.activeFacets && facetList.activeFacets.length > 0\"\n  >\n    {{ 'productList.appliedFilter' | cxTranslate }}\n  </div>\n\n  <a\n    *ngFor=\"let facet of facetList?.activeFacets\"\n    routerLink=\"./\"\n    [queryParams]=\"getLinkParams(facet)\"\n    [cxFocus]=\"{ key: getFocusKey(facetList, facet) }\"\n    role=\"button\"\n    (keydown.space)=\"removeFilterWithSpacebar($event)\"\n    [attr.aria-label]=\"\n      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }\n    \"\n    [attr.title]=\"\n      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }\n    \"\n  >\n    <span>{{ facet.facetValueName }}</span>\n    <cx-icon aria-hidden=\"true\" [type]=\"closeIcon\"></cx-icon>\n  </a>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.Default }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ActiveFacetsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-active-facets', changeDetection: ChangeDetectionStrategy.Default, standalone: false, template: "<ng-container *ngIf=\"facetList$ | async as facetList\">\n  <div\n    id=\"cx-active-facets-groupName\"\n    *ngIf=\"facetList.activeFacets && facetList.activeFacets.length > 0\"\n  >\n    {{ 'productList.appliedFilter' | cxTranslate }}\n  </div>\n\n  <a\n    *ngFor=\"let facet of facetList?.activeFacets\"\n    routerLink=\"./\"\n    [queryParams]=\"getLinkParams(facet)\"\n    [cxFocus]=\"{ key: getFocusKey(facetList, facet) }\"\n    role=\"button\"\n    (keydown.space)=\"removeFilterWithSpacebar($event)\"\n    [attr.aria-label]=\"\n      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }\n    \"\n    [attr.title]=\"\n      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }\n    \"\n  >\n    <span>{{ facet.facetValueName }}</span>\n    <cx-icon aria-hidden=\"true\" [type]=\"closeIcon\"></cx-icon>\n  </a>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: FacetService }], propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], labelledby: [{
                type: HostBinding,
                args: ['attr.aria-labelledby']
            }], closeIcon: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ActiveFacetsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ActiveFacetsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ActiveFacetsModule, declarations: [ActiveFacetsComponent], imports: [CommonModule,
            RouterModule,
            I18nModule,
            IconModule,
            KeyboardFocusModule], exports: [ActiveFacetsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ActiveFacetsModule, imports: [CommonModule,
            RouterModule,
            I18nModule,
            IconModule,
            KeyboardFocusModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ActiveFacetsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        I18nModule,
                        IconModule,
                        KeyboardFocusModule,
                    ],
                    declarations: [ActiveFacetsComponent],
                    exports: [ActiveFacetsComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FacetComponent {
    set facet(value) {
        this._facet = value;
        this.isMultiSelect = !!value.multiSelect;
        this.state$ = this.facetService.getState(value);
    }
    get facet() {
        return this._facet;
    }
    constructor(facetService, elementRef, cd) {
        this.facetService = facetService;
        this.elementRef = elementRef;
        this.cd = cd;
        /** configurable icon that is used to collapse the facet group  */
        this.expandIcon = ICON_TYPE.EXPAND;
        this.collapseIcon = ICON_TYPE.COLLAPSE;
        this.featureConfigService = inject(FeatureConfigService, {
            optional: true,
        });
    }
    ngAfterViewInit() {
        // Update the value of `this.isExpanded` after `this.values` was initialized
        this.cd.detectChanges();
    }
    /**
     * @deprecated: Header will no longer be used in favour of TabComponent headers.
     *
     * Handles clicking the heading of the facet group, which means toggling
     * the visibility of the group (collapse / expand) and optionally focusing
     * the group.
     */
    toggleGroup(event) {
        const host = this.elementRef.nativeElement;
        const isLocked = this.keyboardFocus?.isLocked;
        this.facetService.toggle(this.facet, this.isExpanded);
        if (!isLocked || this.isExpanded) {
            host.focus();
            // we stop propagating the event as otherwise the focus on the host will trigger
            // an unlock event from the LockFocus directive.
            event.stopPropagation();
        }
    }
    get isExpanded() {
        return this.values?.first?.nativeElement.offsetParent !== null;
    }
    openLink(event) {
        event.target.click();
        event.preventDefault();
    }
    /**
     * Increases the number of visible values for the facet. This is delegated
     * to `facetService.increaseVisibleValues`.
     */
    increaseVisibleValues() {
        this.facetService.increaseVisibleValues(this.facet);
    }
    /**
     * Decreases the number of visible values for the facet. This is delegated
     * to `facetService.decreaseVisibleValues`.
     */
    decreaseVisibleValues() {
        this.facetService.decreaseVisibleValues(this.facet);
    }
    getLinkParams(value) {
        return this.facetService.getLinkParams(value.query?.query?.value ?? '');
    }
    onKeydown(event) {
        const targetIndex = this.values.toArray().findIndex((el) => {
            return el.nativeElement === event.target;
        });
        // TODO: Left and Right arrow keys are disabled when setting a11yTabComponent.
        // We can remove these in the future.
        switch (event.key) {
            case 'ArrowLeft':
                this.onArrowLeft(event);
                break;
            case 'ArrowRight':
                this.onArrowRight(event);
                break;
            case 'ArrowDown':
                this.onArrowDown(event, targetIndex);
                break;
            case 'ArrowUp':
                this.onArrowUp(event, targetIndex);
                break;
            case 'Tab':
                this.onTabNavigation();
                break;
        }
    }
    /**
     * If a11yTabComponent is enabled, we temporarily disable tabbing for the facet values.
     * This is to use proper keyboard navigation keys(ArrowUp/ArrowDown) for navigating through the facet values.
     */
    onTabNavigation() {
        if (!this.featureConfigService?.isEnabled('a11yTabComponent')) {
            return;
        }
        disableTabbingForTick(this.values.map((el) => el.nativeElement));
    }
    /**
     * @deprecated: Arrow key functions will be removed in favour of using the TabComponent.
     */
    onArrowRight(event) {
        if (this.featureConfigService?.isEnabled('a11yTabComponent')) {
            return;
        }
        if (!this.isExpanded) {
            this.toggleGroup(event);
        }
    }
    /**
     * @deprecated: Arrow key functions will be removed in favour of using the TabComponent.
     */
    onArrowLeft(event) {
        // Navigate to tab buttons when tab component enabled
        if (this.featureConfigService?.isEnabled('a11yTabComponent')) {
            return;
        }
        if (this.isExpanded) {
            this.toggleGroup(event);
            this.facetHeader.nativeElement.focus();
        }
    }
    onArrowDown(event, targetIndex) {
        if (this.featureConfigService?.isEnabled('a11yTabComponent')) {
            event.preventDefault();
            this.values.get(targetIndex + 1)?.nativeElement.focus();
            return;
        }
        if (this.isExpanded) {
            event.preventDefault();
            if (event.target === this.facetHeader.nativeElement) {
                this.values?.first?.nativeElement.focus();
                return;
            }
            this.values.get(targetIndex + 1)?.nativeElement.focus();
        }
    }
    onArrowUp(event, targetIndex) {
        if (this.featureConfigService?.isEnabled('a11yTabComponent')) {
            event.preventDefault();
            this.values.get(targetIndex - 1)?.nativeElement.focus();
            return;
        }
        if (this.isExpanded) {
            event.preventDefault();
            this.values.get(targetIndex - 1)?.nativeElement.focus();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetComponent, deps: [{ token: FacetService }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: FacetComponent, isStandalone: false, selector: "cx-facet", inputs: { expandIcon: "expandIcon", collapseIcon: "collapseIcon", facet: "facet" }, host: { properties: { "class.multi-select": "this.isMultiSelect" } }, viewQueries: [{ propertyName: "keyboardFocus", first: true, predicate: FocusDirective, descendants: true }, { propertyName: "facetHeader", first: true, predicate: ["facetHeader"], descendants: true }, { propertyName: "values", predicate: ["facetValue"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <button\n    class=\"heading\"\n    #facetHeader\n    (click)=\"toggleGroup($event)\"\n    (keydown)=\"onKeydown($event)\"\n    [attr.aria-expanded]=\"isExpanded\"\n    [attr.aria-label]=\"\n      'productFacetNavigation.filterBy.name' | cxTranslate: { name: facet.name }\n    \"\n    [cxFocus]=\"{ key: facet.name }\"\n    *cxFeature=\"'!a11yTabComponent'\"\n  >\n    {{ facet.name }}\n    <cx-icon\n      title=\"{{ 'common.collapse' | cxTranslate }}\"\n      class=\"collapse-icon\"\n      [type]=\"collapseIcon\"\n    ></cx-icon>\n    <cx-icon\n      title=\"{{ 'common.expand' | cxTranslate }}\"\n      class=\"expand-icon\"\n      [type]=\"expandIcon\"\n    ></cx-icon>\n  </button>\n\n  <div>\n    <!-- TODO: (CXSPA-6892) - Remove feature flag next major release. -->\n    <a\n      *ngFor=\"let value of facet.values | slice: 0 : state.topVisible\"\n      #facetValue\n      routerLink=\"./\"\n      [queryParams]=\"getLinkParams(value)\"\n      class=\"value\"\n      [class.selected]=\"value.selected\"\n      [cxFocus]=\"{ key: value.name }\"\n      (keydown)=\"onKeydown($event)\"\n      (keydown.space)=\"openLink($any($event))\"\n      [attr.role]=\"facet.multiSelect ? 'checkbox' : null\"\n      [attr.aria-checked]=\"facet.multiSelect ? value.selected : null\"\n      attr.aria-label=\"{{\n        'productFacetNavigation.ariaLabelItemsAvailable'\n          | cxTranslate: { name: value.name, count: value.count }\n      }}\"\n    >\n      <span aria-hidden=\"true\"\n        >{{ value.name\n        }}<span aria-hidden=\"true\" class=\"count\">{{ value.count }}</span></span\n      >\n    </a>\n\n    <div class=\"more\">\n      <a\n        *ngFor=\"\n          let value of facet.values\n            | slice: state.topVisible ?? 0 : state.maxVisible\n        \"\n        #facetValue\n        routerLink=\"./\"\n        [queryParams]=\"getLinkParams(value)\"\n        class=\"value\"\n        [class.selected]=\"value.selected\"\n        [cxFocus]=\"{ key: value.name }\"\n        (keydown)=\"onKeydown($event)\"\n        (keydown.space)=\"openLink($any($event))\"\n      >\n        <span\n          >{{ value.name }}<span class=\"count\">{{ value.count }}</span></span\n        >\n      </a>\n\n      <button\n        *ngIf=\"\n          state.maxVisible &&\n          state.topVisible &&\n          state.maxVisible > state.topVisible\n        \"\n        (click)=\"decreaseVisibleValues()\"\n        [cxAtMessage]=\"\n          'productFacetNavigation.decreaseOptionsVisibility' | cxTranslate\n        \"\n        aria-expanded=\"true\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelShowLess' | cxTranslate\n        }}\"\n        class=\"cx-action-link\"\n        [cxFocus]=\"{ key: 'moreorless' }\"\n      >\n        {{ 'productList.showLess' | cxTranslate }}\n      </button>\n\n      <button\n        *ngIf=\"\n          state.maxVisible &&\n          facet.values &&\n          state.maxVisible > 0 &&\n          state.maxVisible < facet.values.length\n        \"\n        (click)=\"increaseVisibleValues()\"\n        [cxAtMessage]=\"\n          'productFacetNavigation.increaseOptionsVisibility' | cxTranslate\n        \"\n        aria-expanded=\"false\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelShowMore' | cxTranslate\n        }}\"\n        class=\"cx-action-link\"\n        [cxFocus]=\"{ key: 'moreorless' }\"\n      >\n        {{ 'productList.showMore' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: AtMessageDirective, selector: "[cxAtMessage]", inputs: ["cxAtMessage"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.SlicePipe, name: "slice" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-facet', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <button\n    class=\"heading\"\n    #facetHeader\n    (click)=\"toggleGroup($event)\"\n    (keydown)=\"onKeydown($event)\"\n    [attr.aria-expanded]=\"isExpanded\"\n    [attr.aria-label]=\"\n      'productFacetNavigation.filterBy.name' | cxTranslate: { name: facet.name }\n    \"\n    [cxFocus]=\"{ key: facet.name }\"\n    *cxFeature=\"'!a11yTabComponent'\"\n  >\n    {{ facet.name }}\n    <cx-icon\n      title=\"{{ 'common.collapse' | cxTranslate }}\"\n      class=\"collapse-icon\"\n      [type]=\"collapseIcon\"\n    ></cx-icon>\n    <cx-icon\n      title=\"{{ 'common.expand' | cxTranslate }}\"\n      class=\"expand-icon\"\n      [type]=\"expandIcon\"\n    ></cx-icon>\n  </button>\n\n  <div>\n    <!-- TODO: (CXSPA-6892) - Remove feature flag next major release. -->\n    <a\n      *ngFor=\"let value of facet.values | slice: 0 : state.topVisible\"\n      #facetValue\n      routerLink=\"./\"\n      [queryParams]=\"getLinkParams(value)\"\n      class=\"value\"\n      [class.selected]=\"value.selected\"\n      [cxFocus]=\"{ key: value.name }\"\n      (keydown)=\"onKeydown($event)\"\n      (keydown.space)=\"openLink($any($event))\"\n      [attr.role]=\"facet.multiSelect ? 'checkbox' : null\"\n      [attr.aria-checked]=\"facet.multiSelect ? value.selected : null\"\n      attr.aria-label=\"{{\n        'productFacetNavigation.ariaLabelItemsAvailable'\n          | cxTranslate: { name: value.name, count: value.count }\n      }}\"\n    >\n      <span aria-hidden=\"true\"\n        >{{ value.name\n        }}<span aria-hidden=\"true\" class=\"count\">{{ value.count }}</span></span\n      >\n    </a>\n\n    <div class=\"more\">\n      <a\n        *ngFor=\"\n          let value of facet.values\n            | slice: state.topVisible ?? 0 : state.maxVisible\n        \"\n        #facetValue\n        routerLink=\"./\"\n        [queryParams]=\"getLinkParams(value)\"\n        class=\"value\"\n        [class.selected]=\"value.selected\"\n        [cxFocus]=\"{ key: value.name }\"\n        (keydown)=\"onKeydown($event)\"\n        (keydown.space)=\"openLink($any($event))\"\n      >\n        <span\n          >{{ value.name }}<span class=\"count\">{{ value.count }}</span></span\n        >\n      </a>\n\n      <button\n        *ngIf=\"\n          state.maxVisible &&\n          state.topVisible &&\n          state.maxVisible > state.topVisible\n        \"\n        (click)=\"decreaseVisibleValues()\"\n        [cxAtMessage]=\"\n          'productFacetNavigation.decreaseOptionsVisibility' | cxTranslate\n        \"\n        aria-expanded=\"true\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelShowLess' | cxTranslate\n        }}\"\n        class=\"cx-action-link\"\n        [cxFocus]=\"{ key: 'moreorless' }\"\n      >\n        {{ 'productList.showLess' | cxTranslate }}\n      </button>\n\n      <button\n        *ngIf=\"\n          state.maxVisible &&\n          facet.values &&\n          state.maxVisible > 0 &&\n          state.maxVisible < facet.values.length\n        \"\n        (click)=\"increaseVisibleValues()\"\n        [cxAtMessage]=\"\n          'productFacetNavigation.increaseOptionsVisibility' | cxTranslate\n        \"\n        aria-expanded=\"false\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelShowMore' | cxTranslate\n        }}\"\n        class=\"cx-action-link\"\n        [cxFocus]=\"{ key: 'moreorless' }\"\n      >\n        {{ 'productList.showMore' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: FacetService }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { expandIcon: [{
                type: Input
            }], collapseIcon: [{
                type: Input
            }], isMultiSelect: [{
                type: HostBinding,
                args: ['class.multi-select']
            }], values: [{
                type: ViewChildren,
                args: ['facetValue']
            }], keyboardFocus: [{
                type: ViewChild,
                args: [FocusDirective]
            }], facetHeader: [{
                type: ViewChild,
                args: ['facetHeader']
            }], facet: [{
                type: Input
            }], featureConfigService: [{
                type: Optional
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FacetListComponent {
    /**
     * Indicates that the facet navigation is rendered in dialog.
     */
    set isDialog(value) {
        this._isDialog = value;
        if (value) {
            this.renderer.addClass(document.body, 'modal-open');
        }
    }
    get isDialog() {
        return this._isDialog;
    }
    handleClick() {
        this.close();
    }
    constructor(facetService, elementRef, renderer) {
        this.facetService = facetService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.subscriptions = new Subscription();
        /** Emits when the list must close */
        this.closeList = new EventEmitter();
        /** The list of all facet and values related to the products in the list */
        this.facetList$ = this.facetService.facetList$;
        this.iconTypes = ICON_TYPE;
        this.dialogFocusConfig = {
            trap: true,
            block: true,
            focusOnEscape: true,
            autofocus: 'cx-facet > button',
        };
        this.tabConfig = {
            label: 'productFacetNavigation.productFacets',
            mode: TAB_MODE.ACCORDIAN,
            openTabs: [0],
            restrictDirectionKeys: true,
        };
        this.tabs$ = new BehaviorSubject([]);
        this.focusService = inject(KeyboardFocusService, { optional: true });
        this.featureConfigService = inject(FeatureConfigService, {
            optional: true,
        });
        useFeatureStyles('a11yTabComponent');
    }
    ngOnInit() {
        this.enableFocusHandlingOnFacetListChanges();
        // Required to load facets when initial load in side panel.
        this.updateTabs();
    }
    ngAfterViewInit() {
        // Required to render facets when opening filters dialog.
        this.updateTabs();
        // Required to render facet changes (ie. select facet, etc)
        this.subscriptions.add(this.facetsRef.changes
            .pipe(filter((changes) => !!changes))
            .subscribe(() => {
            this.updateTabs();
        }));
    }
    updateTabs() {
        this.facetList$.pipe(take(1)).subscribe((list) => {
            const facets = list.facets;
            const tabs = facets.map((facet, i) => ({
                header: facet.name,
                content: this.facetsRef?.get(i),
                disableBorderFocus: true,
                id: i,
            }));
            this.tabs$.next(tabs);
        });
    }
    /**
     * Toggles the facet group in case it is not expanded.
     */
    expandFacetGroup(facet, ref) {
        if (!ref.isExpanded) {
            this.facetService.toggle(facet, ref.isExpanded);
        }
    }
    /**
     * Indicates that the facet group has been expanded.
     */
    isExpanded(facet) {
        return this.facetService
            .getState(facet)
            .pipe(map((value) => value.toggled === FacetGroupCollapsedState.EXPANDED));
    }
    /**
     * Indicates that the facet group has been collapsed.
     */
    isCollapsed(facet) {
        return this.facetService
            .getState(facet)
            .pipe(map((value) => value.toggled === FacetGroupCollapsedState.COLLAPSED));
    }
    close(event) {
        this.renderer.removeClass(document.body, 'modal-open');
        this.closeList.emit(event);
    }
    block(event) {
        event?.stopPropagation();
    }
    enableFocusHandlingOnFacetListChanges() {
        this.subscriptions.add(this.facetService.facetList$.subscribe((facetList) => this.handleDialogFocus(facetList.facets)));
    }
    handleDialogFocus(facets) {
        // Only apply new focus for the dialog view
        if (!this.isDialog) {
            return;
        }
        const focusKey = this.focusService?.get();
        if (!focusKey) {
            return;
        }
        const focusedFacet = facets.find((facet) => facet.values?.some((value) => {
            return value.name === focusKey;
        }));
        if (focusedFacet) {
            return;
        }
        if (!facets?.length) {
            // If there are no facets to display then focus on the "Back To Results" button
            this.backToResultsBtn?.nativeElement.focus();
            this.focusService?.clear();
            return;
        }
        const firstAvailableFacet = facets[0];
        this.focusService?.set(firstAvailableFacet.name);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetListComponent, deps: [{ token: FacetService }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: FacetListComponent, isStandalone: false, selector: "cx-facet-list", inputs: { isDialog: "isDialog" }, outputs: { closeList: "closeList" }, host: { listeners: { "click": "handleClick()" } }, viewQueries: [{ propertyName: "backToResultsBtn", first: true, predicate: ["backToResultsBtn"], descendants: true }, { propertyName: "facetsRef", predicate: ["facetsRef"], descendants: true }], ngImport: i0, template: "<section\n  class=\"inner\"\n  *ngIf=\"(facetList$ | async)?.facets as facets\"\n  [attr.aria-label]=\"'productFacetNavigation.filterBy.facet' | cxTranslate\"\n  [cxFocus]=\"isDialog ? dialogFocusConfig : {}\"\n  [tabindex]=\"-1\"\n  (esc)=\"close($event)\"\n  (click)=\"block($event)\"\n>\n  <div class=\"list-header\">\n    <h4>{{ 'productList.filterBy.label' | cxTranslate }}</h4>\n    <button\n      type=\"button\"\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      [attr.aria-label]=\"'common.close' | cxTranslate\"\n      (click)=\"close()\"\n    >\n      <cx-icon aria-hidden=\"true\" [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n\n  <!--\n      Here we'd like to introduce configurable facet components,\n      either by using specific configuration or generic sproutlets\n  -->\n  <ng-container *cxFeature=\"'a11yTabComponent'\">\n    <cx-tab [tabs$]=\"tabs$\" [config]=\"tabConfig\"></cx-tab>\n\n    <ng-template #facetsRef *ngFor=\"let facet of facets\">\n      <cx-facet\n        [facet]=\"facet\"\n        role=\"group\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelItemsAvailable'\n            | cxTranslate\n              : {\n                  name: facet.name,\n                  count: facet?.values?.length,\n                }\n        }}\"\n      ></cx-facet>\n    </ng-template>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!a11yTabComponent'\">\n    <cx-facet\n      *ngFor=\"let facet of facets\"\n      #facetRef\n      [facet]=\"facet\"\n      [class.expanded]=\"isExpanded(facet) | async\"\n      [class.collapsed]=\"isCollapsed(facet) | async\"\n      role=\"group\"\n      attr.aria-label=\"{{\n        'productFacetNavigation.ariaLabelItemsAvailable'\n          | cxTranslate\n            : {\n                name: facet.name,\n                count: facet?.values?.length,\n              }\n      }}\"\n    ></cx-facet>\n  </ng-container>\n\n  <div *ngIf=\"isDialog\" class=\"cx-facet-list-footer\">\n    <button\n      #backToResultsBtn\n      class=\"btn btn-primary\"\n      (click)=\"close()\"\n      cxAutoFocus\n    >\n      {{ 'productFacetNavigation.backToResults' | cxTranslate }}\n    </button>\n  </div>\n</section>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "component", type: FacetComponent, selector: "cx-facet", inputs: ["expandIcon", "collapseIcon", "facet"] }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "component", type: TabComponent, selector: "cx-tab", inputs: ["tabs$", "tabs", "config", "disabled"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-facet-list', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<section\n  class=\"inner\"\n  *ngIf=\"(facetList$ | async)?.facets as facets\"\n  [attr.aria-label]=\"'productFacetNavigation.filterBy.facet' | cxTranslate\"\n  [cxFocus]=\"isDialog ? dialogFocusConfig : {}\"\n  [tabindex]=\"-1\"\n  (esc)=\"close($event)\"\n  (click)=\"block($event)\"\n>\n  <div class=\"list-header\">\n    <h4>{{ 'productList.filterBy.label' | cxTranslate }}</h4>\n    <button\n      type=\"button\"\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      [attr.aria-label]=\"'common.close' | cxTranslate\"\n      (click)=\"close()\"\n    >\n      <cx-icon aria-hidden=\"true\" [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n\n  <!--\n      Here we'd like to introduce configurable facet components,\n      either by using specific configuration or generic sproutlets\n  -->\n  <ng-container *cxFeature=\"'a11yTabComponent'\">\n    <cx-tab [tabs$]=\"tabs$\" [config]=\"tabConfig\"></cx-tab>\n\n    <ng-template #facetsRef *ngFor=\"let facet of facets\">\n      <cx-facet\n        [facet]=\"facet\"\n        role=\"group\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelItemsAvailable'\n            | cxTranslate\n              : {\n                  name: facet.name,\n                  count: facet?.values?.length,\n                }\n        }}\"\n      ></cx-facet>\n    </ng-template>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!a11yTabComponent'\">\n    <cx-facet\n      *ngFor=\"let facet of facets\"\n      #facetRef\n      [facet]=\"facet\"\n      [class.expanded]=\"isExpanded(facet) | async\"\n      [class.collapsed]=\"isCollapsed(facet) | async\"\n      role=\"group\"\n      attr.aria-label=\"{{\n        'productFacetNavigation.ariaLabelItemsAvailable'\n          | cxTranslate\n            : {\n                name: facet.name,\n                count: facet?.values?.length,\n              }\n      }}\"\n    ></cx-facet>\n  </ng-container>\n\n  <div *ngIf=\"isDialog\" class=\"cx-facet-list-footer\">\n    <button\n      #backToResultsBtn\n      class=\"btn btn-primary\"\n      (click)=\"close()\"\n      cxAutoFocus\n    >\n      {{ 'productFacetNavigation.backToResults' | cxTranslate }}\n    </button>\n  </div>\n</section>\n" }]
        }], ctorParameters: () => [{ type: FacetService }, { type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { backToResultsBtn: [{
                type: ViewChild,
                args: ['backToResultsBtn']
            }], isDialog: [{
                type: Input
            }], closeList: [{
                type: Output
            }], facetsRef: [{
                type: ViewChildren,
                args: ['facetsRef']
            }], handleClick: [{
                type: HostListener,
                args: ['click']
            }], focusService: [{
                type: Optional
            }], featureConfigService: [{
                type: Optional
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FacetModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: FacetModule, declarations: [FacetComponent], imports: [AtMessageModule,
            CommonModule,
            I18nModule,
            IconModule,
            KeyboardFocusModule,
            RouterModule,
            UrlModule,
            FeaturesConfigModule], exports: [FacetComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetModule, imports: [AtMessageModule,
            CommonModule,
            I18nModule,
            IconModule,
            KeyboardFocusModule,
            RouterModule,
            UrlModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        AtMessageModule,
                        CommonModule,
                        I18nModule,
                        IconModule,
                        KeyboardFocusModule,
                        RouterModule,
                        UrlModule,
                        FeaturesConfigModule,
                    ],
                    declarations: [FacetComponent],
                    exports: [FacetComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FacetListModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: FacetListModule, declarations: [FacetListComponent], imports: [CommonModule,
            I18nModule,
            IconModule,
            FacetModule,
            KeyboardFocusModule,
            FeaturesConfigModule,
            TabModule], exports: [FacetListComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetListModule, imports: [CommonModule,
            I18nModule,
            IconModule,
            FacetModule,
            KeyboardFocusModule,
            FeaturesConfigModule,
            TabModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: FacetListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        I18nModule,
                        IconModule,
                        FacetModule,
                        KeyboardFocusModule,
                        FeaturesConfigModule,
                        TabModule,
                    ],
                    declarations: [FacetListComponent],
                    exports: [FacetListComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductFacetNavigationComponent {
    constructor(breakpointService) {
        this.breakpointService = breakpointService;
        this.iconTypes = ICON_TYPE;
        /**
         * We delay the removal of DOM so that animations can finish playing before the
         * DOM is removed. Removing the DOM, as hidding is not enough to stop elements
         * to be focused.
         */
        this.CLOSE_DELAY = 300;
        this.open$ = new BehaviorSubject(false);
        /**
         * Emits the open state that indicates whether the facet list should be rendered.
         * This is either done instantly, or after the user triggers this by using the trigger
         * button. This driven by the visiibility of the trigger, so that the CSS drives
         * the behaviour. This can differ per breakpoint.
         *
         * There's a configurable delay for the closed state, so that the DOM is not removed
         * before some CSS animations are done.
         */
        this.isOpen$ = this.breakpointService.breakpoint$.pipe(
        // deffer emitting a new value to the next micro-task to ensure that the `hasTrigger`
        // method represents the actual UI state.
        observeOn(asapScheduler), switchMap$1(() => (this.hasTrigger ? this.open$ : of(true))), delayWhen((launched) => interval(launched ? 0 : this.CLOSE_DELAY)));
        /**
         * Emits the active state that indicates whether the facet list is activated. Activation
         * is related to the css, so that a animation or transition can visualize opening/closing
         * the list (i.e. dialog).
         */
        this.isActive$ = this.open$.pipe(
        // deffer emitting a new value to the next micro-task to ensure the active class is
        //  applied after the DOM is created
        observeOn(asapScheduler));
    }
    launch() {
        this.open$.next(true);
    }
    close() {
        this.open$.next(false);
        this.trigger.nativeElement.focus();
    }
    /**
     * Indicates that the facet navigation should be open explicitely by a trigger.
     * This is fully controlled by CSS, where the trigger button can be hidden
     * (display:none) for certain screen sizes.
     */
    get hasTrigger() {
        return this.trigger.nativeElement.offsetParent !== null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetNavigationComponent, deps: [{ token: BreakpointService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductFacetNavigationComponent, isStandalone: false, selector: "cx-product-facet-navigation", viewQueries: [{ propertyName: "trigger", first: true, predicate: ["trigger"], descendants: true }], ngImport: i0, template: "<button\n  #trigger\n  class=\"btn btn-secondary btn-block dialog-trigger\"\n  (click)=\"launch()\"\n>\n  <cx-icon [type]=\"iconTypes.FILTER\"></cx-icon>\n  {{ 'productList.filterBy.label' | cxTranslate }}\n</button>\n\n<cx-active-facets></cx-active-facets>\n\n<cx-facet-list\n  *ngIf=\"isOpen$ | async\"\n  [isDialog]=\"hasTrigger\"\n  (closeList)=\"close()\"\n  [class.active]=\"isActive$ | async\"\n  [class.dialog]=\"hasTrigger\"\n></cx-facet-list>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FacetListComponent, selector: "cx-facet-list", inputs: ["isDialog"], outputs: ["closeList"] }, { kind: "component", type: ActiveFacetsComponent, selector: "cx-active-facets", inputs: ["closeIcon"] }, { kind: "component", type: IconComponent, selector: "cx-icon,[cxIcon]", inputs: ["cxIcon", "type"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-facet-navigation', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<button\n  #trigger\n  class=\"btn btn-secondary btn-block dialog-trigger\"\n  (click)=\"launch()\"\n>\n  <cx-icon [type]=\"iconTypes.FILTER\"></cx-icon>\n  {{ 'productList.filterBy.label' | cxTranslate }}\n</button>\n\n<cx-active-facets></cx-active-facets>\n\n<cx-facet-list\n  *ngIf=\"isOpen$ | async\"\n  [isDialog]=\"hasTrigger\"\n  (closeList)=\"close()\"\n  [class.active]=\"isActive$ | async\"\n  [class.dialog]=\"hasTrigger\"\n></cx-facet-list>\n" }]
        }], ctorParameters: () => [{ type: BreakpointService }], propDecorators: { trigger: [{
                type: ViewChild,
                args: ['trigger']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductFacetNavigationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetNavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetNavigationModule, declarations: [ProductFacetNavigationComponent], imports: [CommonModule,
            FacetListModule,
            ActiveFacetsModule,
            IconModule,
            I18nModule, i1.ConfigModule], exports: [ProductFacetNavigationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetNavigationModule, imports: [CommonModule,
            FacetListModule,
            ActiveFacetsModule,
            IconModule,
            I18nModule,
            ConfigModule.withConfig({
                cmsComponents: {
                    ProductRefinementComponent: {
                        component: ProductFacetNavigationComponent,
                    },
                },
            })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductFacetNavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FacetListModule,
                        ActiveFacetsModule,
                        IconModule,
                        I18nModule,
                        ConfigModule.withConfig({
                            cmsComponents: {
                                ProductRefinementComponent: {
                                    component: ProductFacetNavigationComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductFacetNavigationComponent],
                    exports: [ProductFacetNavigationComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultViewConfig = {
    view: {
        defaultPageSize: 12,
        infiniteScroll: {
            active: false,
            productLimit: 0,
            showMoreButton: false,
        },
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductListModule, declarations: [ProductListComponent,
            ProductListItemComponent,
            ProductGridItemComponent,
            ProductViewComponent,
            ProductScrollComponent], imports: [AtMessageModule,
            CommonModule,
            I18nModule,
            IconModule,
            InfiniteScrollModule,
            ItemCounterModule,
            ListNavigationModule,
            MediaModule,
            OutletModule,
            PageComponentModule,
            RouterModule,
            SpinnerModule,
            StarRatingModule,
            UrlModule,
            FeaturesConfigModule,
            LcpContextDirectiveModule], exports: [ProductListComponent,
            ProductListItemComponent,
            ProductGridItemComponent,
            ProductViewComponent,
            ProductScrollComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListModule, providers: [
            ProductListService,
            provideDefaultConfig(defaultViewConfig),
            provideDefaultConfig({
                cmsComponents: {
                    CMSProductListComponent: {
                        component: ProductListComponent,
                        data: {
                            composition: {
                                inner: ['ProductAddToCartComponent'],
                            },
                        },
                    },
                    ProductGridComponent: {
                        component: ProductListComponent,
                        data: {
                            composition: {
                                inner: ['ProductAddToCartComponent'],
                            },
                        },
                    },
                    SearchResultsListComponent: {
                        component: ProductListComponent,
                        data: {
                            composition: {
                                inner: ['ProductAddToCartComponent'],
                            },
                        },
                    },
                },
            }),
        ], imports: [AtMessageModule,
            CommonModule,
            I18nModule,
            IconModule,
            InfiniteScrollModule,
            ItemCounterModule,
            ListNavigationModule,
            MediaModule,
            OutletModule,
            PageComponentModule,
            RouterModule,
            SpinnerModule,
            StarRatingModule,
            UrlModule,
            FeaturesConfigModule,
            LcpContextDirectiveModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        AtMessageModule,
                        CommonModule,
                        I18nModule,
                        IconModule,
                        InfiniteScrollModule,
                        ItemCounterModule,
                        ListNavigationModule,
                        MediaModule,
                        OutletModule,
                        PageComponentModule,
                        RouterModule,
                        SpinnerModule,
                        StarRatingModule,
                        UrlModule,
                        FeaturesConfigModule,
                        LcpContextDirectiveModule,
                    ],
                    providers: [
                        ProductListService,
                        provideDefaultConfig(defaultViewConfig),
                        provideDefaultConfig({
                            cmsComponents: {
                                CMSProductListComponent: {
                                    component: ProductListComponent,
                                    data: {
                                        composition: {
                                            inner: ['ProductAddToCartComponent'],
                                        },
                                    },
                                },
                                ProductGridComponent: {
                                    component: ProductListComponent,
                                    data: {
                                        composition: {
                                            inner: ['ProductAddToCartComponent'],
                                        },
                                    },
                                },
                                SearchResultsListComponent: {
                                    component: ProductListComponent,
                                    data: {
                                        composition: {
                                            inner: ['ProductAddToCartComponent'],
                                        },
                                    },
                                },
                            },
                        }),
                    ],
                    declarations: [
                        ProductListComponent,
                        ProductListItemComponent,
                        ProductGridItemComponent,
                        ProductViewComponent,
                        ProductScrollComponent,
                    ],
                    exports: [
                        ProductListComponent,
                        ProductListItemComponent,
                        ProductGridItemComponent,
                        ProductViewComponent,
                        ProductScrollComponent,
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductCarouselItemComponent {
    constructor(productListItemContextSource) {
        this.productListItemContextSource = productListItemContextSource;
    }
    ngOnChanges(changes) {
        if (changes?.item) {
            this.productListItemContextSource.product$.next(this.item);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselItemComponent, deps: [{ token: ProductListItemContextSource }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductCarouselItemComponent, isStandalone: false, selector: "cx-product-carousel-item", inputs: { item: "item", itemIndex: "itemIndex" }, providers: [
            ProductListItemContextSource,
            {
                provide: ProductListItemContext,
                useExisting: ProductListItemContextSource,
            },
        ], usesOnChanges: true, ngImport: i0, template: "<a tabindex=\"0\" [routerLink]=\"{ cxRoute: 'product', params: item } | cxUrl\">\n  <ng-container *cxLcpContext=\"let lcpContext\">\n    <cx-media\n      [container]=\"item.images?.PRIMARY\"\n      format=\"product\"\n      [alt]=\"item.name ?? ''\"\n      [fetchPriority]=\"\n        itemIndex === 0 ? (lcpContext.fetchPriority$ | async) : undefined\n      \"\n    ></cx-media>\n  </ng-container>\n  <h3 class=\"cx-product-name\">\n    {{ item.name }}\n  </h3>\n  <div class=\"price\">\n    {{ item.price?.formattedValue }}\n  </div>\n</a>\n<div class=\"actions\">\n  <ng-container cxInnerComponentsHost></ng-container>\n</div>\n", dependencies: [{ kind: "component", type: MediaComponent, selector: "cx-media", inputs: ["container", "format", "alt", "role", "loading", "fetchPriority", "elementType", "sizesForImgElement"], outputs: ["loaded"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: InnerComponentsHostDirective, selector: "[cxInnerComponentsHost]" }, { kind: "directive", type: LcpContextDirective, selector: "[cxLcpContext]" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.UrlPipe, name: "cxUrl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-carousel-item', providers: [
                        ProductListItemContextSource,
                        {
                            provide: ProductListItemContext,
                            useExisting: ProductListItemContextSource,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<a tabindex=\"0\" [routerLink]=\"{ cxRoute: 'product', params: item } | cxUrl\">\n  <ng-container *cxLcpContext=\"let lcpContext\">\n    <cx-media\n      [container]=\"item.images?.PRIMARY\"\n      format=\"product\"\n      [alt]=\"item.name ?? ''\"\n      [fetchPriority]=\"\n        itemIndex === 0 ? (lcpContext.fetchPriority$ | async) : undefined\n      \"\n    ></cx-media>\n  </ng-container>\n  <h3 class=\"cx-product-name\">\n    {{ item.name }}\n  </h3>\n  <div class=\"price\">\n    {{ item.price?.formattedValue }}\n  </div>\n</a>\n<div class=\"actions\">\n  <ng-container cxInnerComponentsHost></ng-container>\n</div>\n" }]
        }], ctorParameters: () => [{ type: ProductListItemContextSource }], propDecorators: { item: [{
                type: Input
            }], itemIndex: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductCarouselComponent {
    constructor(componentData, productService) {
        this.componentData = componentData;
        this.productService = productService;
        this.featureConfigService = inject(FeatureConfigService);
        this.productSearchByCodeService = inject(ProductSearchByCodeService);
        this.productSearchByCategoryService = inject(ProductSearchByCategoryService);
        this.PRODUCT_SCOPE = [ProductScope.LIST, ProductScope.STOCK];
        this.PRODUCT_SCOPE_ITEM = [ProductScope.LIST_ITEM];
        this.componentData$ = this.componentData.data$.pipe(filter((data) => Boolean(data)));
        /**
         * returns an Observable string for the title.
         */
        this.title$ = this.componentData$.pipe(map((data) => data.title));
        /**
         * Observable that holds an Array of Observables. This is done, so that
         * the component UI could consider to lazy load the UI components when they're
         * in the viewpoint.
         * If the inner component mapping exists (e.g. ProductAddToCartComponent), we aim to leverage the full scope;
         * otherwise, we prefer to minimize the scope for better performance.
         */
        this.items$ = this.componentData$.pipe(switchMap((data) => this.handleCategoryCodes(data)), map((data) => {
            const componentMappingExist = !!data.composition?.inner?.length;
            const codes = data.productCodes?.trim().split(' ') ?? [];
            return { componentMappingExist, codes };
        }), map(({ componentMappingExist, codes }) => {
            const scope = componentMappingExist ? 'carousel' : 'carouselMinimal';
            return codes.map((code) => this.productSearchByCodeService.get({ code, scope }));
        }));
        this.trackByFn = (_index, item) => item?.code;
        useFeatureStyles('productCarouselScrolling');
    }
    handleCategoryCodes(data) {
        const categoryCodes = data?.categoryCodes?.split(' ');
        // Try to add category codes to the carousel product codes
        if (categoryCodes &&
            this.featureConfigService.isEnabled('enableCarouselCategoryProducts')) {
            return zip(categoryCodes.map((categoryCode) => this.productSearchByCategoryService.get({
                categoryCode,
                scope: ProductScope.CODE,
            }))).pipe(map((results) => {
                const codes = results
                    .flat()
                    .map((product) => product?.code)
                    .join(' ');
                return {
                    ...data,
                    productCodes: data.productCodes + ' ' + codes,
                };
            }));
        }
        return of(data);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselComponent, deps: [{ token: CmsComponentData }, { token: i1.ProductService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductCarouselComponent, isStandalone: false, selector: "cx-product-carousel", ngImport: i0, template: "<ng-container *cxFeature=\"'productCarouselScrolling'\">\n  <cx-carousel-scrolling\n    *ngIf=\"items$ | async as items\"\n    role=\"region\"\n    [attr.aria-label]=\"\n      'productCarousel.carouselLabel' | cxTranslate: { title: title$ | async }\n    \"\n    [items]=\"items\"\n    [title]=\"title$ | async\"\n    [template]=\"carouselItem\"\n    [trackByFn]=\"trackByFn\"\n  >\n  </cx-carousel-scrolling>\n</ng-container>\n<ng-container *cxFeature=\"'!productCarouselScrolling'\">\n  <cx-carousel\n    *ngIf=\"items$ | async as items\"\n    role=\"region\"\n    [attr.aria-label]=\"\n      'productCarousel.carouselLabel' | cxTranslate: { title: title$ | async }\n    \"\n    [items]=\"items\"\n    [title]=\"title$ | async\"\n    [template]=\"carouselItem\"\n    itemWidth=\"285px\"\n    [trackByFn]=\"trackByFn\"\n  >\n  </cx-carousel>\n</ng-container>\n\n<ng-template #carouselItem let-item=\"item\" let-itemIndex=\"itemIndex\">\n  <cx-product-carousel-item\n    [item]=\"item\"\n    [itemIndex]=\"itemIndex\"\n  ></cx-product-carousel-item>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CarouselComponent, selector: "cx-carousel", inputs: ["title", "items", "template", "itemWidth", "hideIndicators", "indicatorIcon", "previousIcon", "nextIcon", "trackByFn"], outputs: ["keybordEvent"] }, { kind: "component", type: CarouselScrollingComponent, selector: "cx-carousel-scrolling", inputs: ["title", "items", "template", "previousIcon", "nextIcon", "trackByFn"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "component", type: ProductCarouselItemComponent, selector: "cx-product-carousel-item", inputs: ["item", "itemIndex"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-carousel', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *cxFeature=\"'productCarouselScrolling'\">\n  <cx-carousel-scrolling\n    *ngIf=\"items$ | async as items\"\n    role=\"region\"\n    [attr.aria-label]=\"\n      'productCarousel.carouselLabel' | cxTranslate: { title: title$ | async }\n    \"\n    [items]=\"items\"\n    [title]=\"title$ | async\"\n    [template]=\"carouselItem\"\n    [trackByFn]=\"trackByFn\"\n  >\n  </cx-carousel-scrolling>\n</ng-container>\n<ng-container *cxFeature=\"'!productCarouselScrolling'\">\n  <cx-carousel\n    *ngIf=\"items$ | async as items\"\n    role=\"region\"\n    [attr.aria-label]=\"\n      'productCarousel.carouselLabel' | cxTranslate: { title: title$ | async }\n    \"\n    [items]=\"items\"\n    [title]=\"title$ | async\"\n    [template]=\"carouselItem\"\n    itemWidth=\"285px\"\n    [trackByFn]=\"trackByFn\"\n  >\n  </cx-carousel>\n</ng-container>\n\n<ng-template #carouselItem let-item=\"item\" let-itemIndex=\"itemIndex\">\n  <cx-product-carousel-item\n    [item]=\"item\"\n    [itemIndex]=\"itemIndex\"\n  ></cx-product-carousel-item>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: i1.ProductService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductCarouselModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselModule, declarations: [ProductCarouselComponent, ProductCarouselItemComponent], imports: [CommonModule,
            CarouselModule,
            CarouselScrollingModule,
            MediaModule,
            RouterModule,
            UrlModule,
            I18nModule,
            PageComponentModule,
            FeaturesConfigModule,
            LcpContextDirectiveModule], exports: [ProductCarouselComponent, ProductCarouselItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ProductCarouselComponent: {
                        component: ProductCarouselComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            CarouselModule,
            CarouselScrollingModule,
            MediaModule,
            RouterModule,
            UrlModule,
            I18nModule,
            PageComponentModule,
            FeaturesConfigModule,
            LcpContextDirectiveModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductCarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CarouselModule,
                        CarouselScrollingModule,
                        MediaModule,
                        RouterModule,
                        UrlModule,
                        I18nModule,
                        PageComponentModule,
                        FeaturesConfigModule,
                        LcpContextDirectiveModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ProductCarouselComponent: {
                                    component: ProductCarouselComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductCarouselComponent, ProductCarouselItemComponent],
                    exports: [ProductCarouselComponent, ProductCarouselItemComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductReferencesComponent {
    constructor(cmsComponentData, currentProductService, productReferenceService) {
        this.cmsComponentData = cmsComponentData;
        this.currentProductService = currentProductService;
        this.productReferenceService = productReferenceService;
        /**
         * Observable with an Array of Observables. This is done so that
         * the component UI could consider to lazy load the UI components when they're
         * in the viewpoint.
         */
        this.items$ = this.productCode$.pipe(withLatestFrom(this.componentData$), tap(([productCode, data]) => this.productReferenceService.loadProductReferences(productCode, data.productReferenceTypes)), switchMap$1(([productCode, data]) => this.getProductReferences(productCode, data.productReferenceTypes ?? '')));
        this.trackByFn = (_index, item) => item?.code;
        useFeatureStyles('productCarouselScrolling');
    }
    get componentData$() {
        return this.cmsComponentData.data$.pipe(filter((data) => Boolean(data)));
    }
    /**
     * Returns an Observable String for the product code
     */
    get productCode$() {
        return this.currentProductService.getProduct().pipe(filter(isNotNullable), map((product) => product.code ?? ''), tap((_) => this.productReferenceService.cleanReferences()));
    }
    /**
     * Returns an Observable String for the title
     */
    get title$() {
        return this.componentData$.pipe(map((data) => data?.title));
    }
    /**
     * Returns an observable for product references
     */
    getProductReferences(code, referenceType) {
        return this.productReferenceService
            .getProductReferences(code, referenceType)
            .pipe(filter((references) => Boolean(references)), map((references) => references.map((reference) => of(reference.target))));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReferencesComponent, deps: [{ token: CmsComponentData }, { token: CurrentProductService }, { token: i1.ProductReferenceService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductReferencesComponent, isStandalone: false, selector: "cx-product-references", ngImport: i0, template: "<ng-container *cxFeature=\"'productCarouselScrolling'\">\n  <ng-container *ngIf=\"items$ | async as items\">\n    <cx-carousel-scrolling\n      *ngIf=\"items.length\"\n      [title]=\"title$ | async\"\n      [items]=\"items\"\n      [template]=\"carouselItem\"\n      [trackByFn]=\"trackByFn\"\n    >\n    </cx-carousel-scrolling>\n  </ng-container>\n</ng-container>\n<ng-container *cxFeature=\"'!productCarouselScrolling'\">\n  <ng-container *ngIf=\"items$ | async as items\">\n    <cx-carousel\n      *ngIf=\"items$ | async as items\"\n      [title]=\"title$ | async\"\n      [items]=\"items\"\n      [template]=\"carouselItem\"\n      [trackByFn]=\"trackByFn\"\n    >\n    </cx-carousel>\n  </ng-container>\n</ng-container>\n\n<ng-template #carouselItem let-item=\"item\">\n  <a tabindex=\"0\" [routerLink]=\"{ cxRoute: 'product', params: item } | cxUrl\">\n    <cx-media [container]=\"item.images?.PRIMARY\" format=\"product\"></cx-media>\n    <h4>{{ item.name }}</h4>\n    <div class=\"price\">{{ item.price?.formattedValue }}</div>\n  </a>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CarouselComponent, selector: "cx-carousel", inputs: ["title", "items", "template", "itemWidth", "hideIndicators", "indicatorIcon", "previousIcon", "nextIcon", "trackByFn"], outputs: ["keybordEvent"] }, { kind: "component", type: CarouselScrollingComponent, selector: "cx-carousel-scrolling", inputs: ["title", "items", "template", "previousIcon", "nextIcon", "trackByFn"] }, { kind: "component", type: MediaComponent, selector: "cx-media", inputs: ["container", "format", "alt", "role", "loading", "fetchPriority", "elementType", "sizesForImgElement"], outputs: ["loaded"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.UrlPipe, name: "cxUrl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReferencesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-references', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *cxFeature=\"'productCarouselScrolling'\">\n  <ng-container *ngIf=\"items$ | async as items\">\n    <cx-carousel-scrolling\n      *ngIf=\"items.length\"\n      [title]=\"title$ | async\"\n      [items]=\"items\"\n      [template]=\"carouselItem\"\n      [trackByFn]=\"trackByFn\"\n    >\n    </cx-carousel-scrolling>\n  </ng-container>\n</ng-container>\n<ng-container *cxFeature=\"'!productCarouselScrolling'\">\n  <ng-container *ngIf=\"items$ | async as items\">\n    <cx-carousel\n      *ngIf=\"items$ | async as items\"\n      [title]=\"title$ | async\"\n      [items]=\"items\"\n      [template]=\"carouselItem\"\n      [trackByFn]=\"trackByFn\"\n    >\n    </cx-carousel>\n  </ng-container>\n</ng-container>\n\n<ng-template #carouselItem let-item=\"item\">\n  <a tabindex=\"0\" [routerLink]=\"{ cxRoute: 'product', params: item } | cxUrl\">\n    <cx-media [container]=\"item.images?.PRIMARY\" format=\"product\"></cx-media>\n    <h4>{{ item.name }}</h4>\n    <div class=\"price\">{{ item.price?.formattedValue }}</div>\n  </a>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: CmsComponentData }, { type: CurrentProductService }, { type: i1.ProductReferenceService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductReferencesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReferencesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductReferencesModule, declarations: [ProductReferencesComponent], imports: [CommonModule,
            CarouselModule,
            CarouselScrollingModule,
            MediaModule,
            RouterModule,
            UrlModule,
            FeaturesConfigModule], exports: [ProductReferencesComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReferencesModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ProductReferencesComponent: {
                        component: ProductReferencesComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            CarouselModule,
            CarouselScrollingModule,
            MediaModule,
            RouterModule,
            UrlModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReferencesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CarouselModule,
                        CarouselScrollingModule,
                        MediaModule,
                        RouterModule,
                        UrlModule,
                        FeaturesConfigModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ProductReferencesComponent: {
                                    component: ProductReferencesComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductReferencesComponent],
                    exports: [ProductReferencesComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductImagesComponent {
    constructor(currentProductService) {
        this.currentProductService = currentProductService;
        this.mainMediaContainer = new BehaviorSubject(null);
        this.product$ = this.currentProductService
            .getProduct()
            .pipe(filter(isNotNullable), distinctUntilChanged(), tap((p) => {
            this.mainMediaContainer.next(p.images?.PRIMARY ? p.images.PRIMARY : {});
        }));
        this.thumbs$ = this.product$.pipe(map((p) => this.createThumbs(p)));
        this.mainImage$ = combineLatest([
            this.product$,
            this.mainMediaContainer,
        ]).pipe(map(([, container]) => container));
        this.trackByFn = (_index, item) => item?.code;
        useFeatureStyles('a11yDifferentiateFocusedAndSelected');
        useFeatureStyles('reserveSpaceForImagesOnPdpAndPlp');
        useFeatureStyles('productCarouselScrolling');
    }
    openImage(item) {
        this.mainMediaContainer.next(item);
    }
    isActive(thumbnail) {
        return this.mainMediaContainer.pipe(filter(Boolean), map((container) => {
            return (container.zoom &&
                container.zoom.url &&
                thumbnail.zoom &&
                thumbnail.zoom.url &&
                container.zoom.url === thumbnail.zoom.url);
        }));
    }
    /** find the index of the main media in the list of media */
    getActive(thumbs) {
        return this.mainMediaContainer.pipe(filter(Boolean), map((container) => {
            const current = thumbs.find((t) => t.media &&
                container.zoom &&
                t.media.container &&
                t.media.container.zoom &&
                t.media.container.zoom.url === container.zoom.url);
            return thumbs.indexOf(current);
        }));
    }
    /**
     * Return an array of CarouselItems for the product thumbnails.
     * In case there are less then 2 thumbs, we return null.
     */
    createThumbs(product) {
        if (!product.images ||
            !product.images.GALLERY ||
            (Array.isArray(product.images.GALLERY) &&
                product.images.GALLERY.length < 2)) {
            return [];
        }
        return product.images.GALLERY.map((c) => of({ container: c }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductImagesComponent, deps: [{ token: CurrentProductService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductImagesComponent, isStandalone: false, selector: "cx-product-images", ngImport: i0, template: "<ng-container *ngIf=\"mainImage$ | async as main\">\n  <cx-media\n    [container]=\"main\"\n    *cxLcpContext=\"let lcpContext\"\n    [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n  ></cx-media>\n</ng-container>\n\n<ng-container *ngIf=\"thumbs$ | async as thumbs\">\n  <ng-container *cxFeature=\"'productCarouselScrolling'\">\n    <cx-carousel-scrolling\n      *ngIf=\"thumbs.length\"\n      class=\"thumbs\"\n      [items]=\"thumbs\"\n      [template]=\"thumb\"\n      [trackByFn]=\"trackByFn\"\n    ></cx-carousel-scrolling>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!productCarouselScrolling'\">\n    <cx-carousel\n      *ngIf=\"thumbs.length\"\n      class=\"thumbs\"\n      [items]=\"thumbs\"\n      itemWidth=\"120px\"\n      [hideIndicators]=\"false\"\n      [template]=\"thumb\"\n    ></cx-carousel>\n  </ng-container>\n</ng-container>\n\n<ng-template #thumb let-item=\"item\">\n  <cx-media\n    [container]=\"item.container\"\n    tabindex=\"0\"\n    (focus)=\"openImage(item.container)\"\n    [class.is-active]=\"isActive(item.container) | async\"\n    format=\"product\"\n  >\n  </cx-media>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MediaComponent, selector: "cx-media", inputs: ["container", "format", "alt", "role", "loading", "fetchPriority", "elementType", "sizesForImgElement"], outputs: ["loaded"] }, { kind: "component", type: CarouselComponent, selector: "cx-carousel", inputs: ["title", "items", "template", "itemWidth", "hideIndicators", "indicatorIcon", "previousIcon", "nextIcon", "trackByFn"], outputs: ["keybordEvent"] }, { kind: "component", type: CarouselScrollingComponent, selector: "cx-carousel-scrolling", inputs: ["title", "items", "template", "previousIcon", "nextIcon", "trackByFn"] }, { kind: "directive", type: LcpContextDirective, selector: "[cxLcpContext]" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductImagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-images', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"mainImage$ | async as main\">\n  <cx-media\n    [container]=\"main\"\n    *cxLcpContext=\"let lcpContext\"\n    [fetchPriority]=\"lcpContext.fetchPriority$ | async\"\n  ></cx-media>\n</ng-container>\n\n<ng-container *ngIf=\"thumbs$ | async as thumbs\">\n  <ng-container *cxFeature=\"'productCarouselScrolling'\">\n    <cx-carousel-scrolling\n      *ngIf=\"thumbs.length\"\n      class=\"thumbs\"\n      [items]=\"thumbs\"\n      [template]=\"thumb\"\n      [trackByFn]=\"trackByFn\"\n    ></cx-carousel-scrolling>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!productCarouselScrolling'\">\n    <cx-carousel\n      *ngIf=\"thumbs.length\"\n      class=\"thumbs\"\n      [items]=\"thumbs\"\n      itemWidth=\"120px\"\n      [hideIndicators]=\"false\"\n      [template]=\"thumb\"\n    ></cx-carousel>\n  </ng-container>\n</ng-container>\n\n<ng-template #thumb let-item=\"item\">\n  <cx-media\n    [container]=\"item.container\"\n    tabindex=\"0\"\n    (focus)=\"openImage(item.container)\"\n    [class.is-active]=\"isActive(item.container) | async\"\n    format=\"product\"\n  >\n  </cx-media>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: CurrentProductService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductImagesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductImagesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductImagesModule, declarations: [ProductImagesComponent], imports: [CommonModule,
            RouterModule,
            MediaModule,
            OutletModule,
            CarouselModule,
            CarouselScrollingModule,
            LcpContextDirectiveModule], exports: [ProductImagesComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductImagesModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ProductImagesComponent: {
                        component: ProductImagesComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            RouterModule,
            MediaModule,
            OutletModule,
            CarouselModule,
            CarouselScrollingModule,
            LcpContextDirectiveModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductImagesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        MediaModule,
                        OutletModule,
                        CarouselModule,
                        CarouselScrollingModule,
                        LcpContextDirectiveModule,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ProductImagesComponent: {
                                    component: ProductImagesComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductImagesComponent],
                    exports: [ProductImagesComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductIntroComponent {
    constructor(currentProductService, translationService, winRef, eventService) {
        this.currentProductService = currentProductService;
        this.translationService = translationService;
        this.winRef = winRef;
        this.eventService = eventService;
        this.product$ = this.currentProductService.getProduct();
        this.featureConfigService = inject(FeatureConfigService);
        /**
         * Observable that checks the reviews component availability on the page.
         *
         * @deprecated This observable controlled whether we should show reviews based
         * on the review component's existence. Instead, we are now using the "product.averageRating"
         * to check whether reviews should exist. This observable with therefore be removed.
         */
        this.areReviewsAvailable$ = merge(
        // Check if reviews component is already defined:
        defer(() => of(!!this.getReviewsComponent())), 
        // Observe EventService for reviews availability:
        this.eventService.get(ComponentCreateEvent).pipe(filter((event) => event.id === this.reviewsComponentId), map(() => true)), this.eventService.get(ComponentDestroyEvent).pipe(filter((event) => event.id === this.reviewsComponentId), map(() => false)));
        this.reviewsComponentId = 'ProductReviewsTabComponent';
        this.reviewsTranslationKey = `TabPanelContainer.tabs.${this.reviewsComponentId}`;
    }
    /**
     * Scroll to views component on page and click "Reviews" tab
     */
    showReviews() {
        // Use translated label for Reviews tab reference
        this.translationService
            .translate(this.reviewsTranslationKey)
            .subscribe((reviewsTabLabel) => {
            const tabsComponent = this.getTabsComponent();
            const reviewsTab = tabsComponent && this.getTabByLabel(reviewsTabLabel, tabsComponent);
            if (reviewsTab) {
                this.clickTabIfInactive(reviewsTab);
                setTimeout(() => {
                    if (this.featureConfigService?.isEnabled('a11yScrollToReviewByShowReview')) {
                        requestAnimationFrame(() => {
                            reviewsTab.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            });
                            reviewsTab.focus({ preventScroll: true });
                        });
                    }
                    else {
                        reviewsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        reviewsTab.focus({ preventScroll: true });
                    }
                });
            }
        })
            .unsubscribe();
    }
    // NOTE: Does not currently exists as its own component
    // but part of tabs component. This is likely to change in refactor.
    /**
     * Get Reviews Component if exists on page
     */
    getReviewsComponent() {
        return this.winRef.document.querySelector('cx-product-reviews');
    }
    /**
     * Get Tabs Component if exists on page
     */
    getTabsComponent() {
        return this.winRef.document.querySelector('cx-tab-paragraph-container');
    }
    /**
     * Click to activate tab if not already active
     *
     * @param tab tab to click if needed
     */
    clickTabIfInactive(tab) {
        if (!tab.classList.contains('active') ||
            tab.classList.contains('toggled')) {
            tab.click();
        }
    }
    /**
     * Get Tab by label if exists on page
     *
     * @param label label of searched tab
     * @param tabsComponent component containing tabs
     */
    getTabByLabel(label, tabsComponent) {
        // NOTE: Reads through button tags to click on correct tab
        // There may be a better way of doing this now/after refactor
        const tabElements = tabsComponent.getElementsByTagName('button');
        // Look through button tab elements until finding tab with label
        return Array.from(tabElements).find((buttonElement) => buttonElement.innerHTML.includes(label));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductIntroComponent, deps: [{ token: CurrentProductService }, { token: i1.TranslationService }, { token: i1.WindowRef }, { token: i1.EventService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductIntroComponent, isStandalone: false, selector: "cx-product-intro", ngImport: i0, template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"rating\" *ngIf=\"product?.averageRating\">\n    <cx-star-rating [rating]=\"product?.averageRating ?? 0\"></cx-star-rating>\n\n    <div class=\"count\">({{ product?.numberOfReviews }})</div>\n    <!-- TODO: (CXSPA-7603) - Remove feature flag next major release. -->\n    <ng-container *cxFeature=\"'a11yLinkBtnsToTertiaryBtns'\">\n      <button\n        *ngIf=\"product?.averageRating\"\n        class=\"btn btn-tertiary\"\n        (click)=\"showReviews()\"\n        [attr.aria-label]=\"\n          'productSummary.showReviewsDetailed'\n            | cxTranslate\n              : {\n                  rating: product?.averageRating | number: '1.0-1',\n                  count: product?.numberOfReviews,\n                }\n        \"\n      >\n        {{ 'productSummary.showReviews' | cxTranslate }}\n      </button>\n    </ng-container>\n    <ng-container *cxFeature=\"'!a11yLinkBtnsToTertiaryBtns'\">\n      <button\n        *ngIf=\"areReviewsAvailable$ | async\"\n        class=\"btn btn-link cx-action-link\"\n        (click)=\"showReviews()\"\n        [attr.aria-label]=\"\n          'productSummary.showReviewsDetailed'\n            | cxTranslate\n              : {\n                  rating: product?.averageRating | number: '1.0-1',\n                  count: product?.numberOfReviews,\n                }\n        \"\n      >\n        {{ 'productSummary.showReviews' | cxTranslate }}\n      </button>\n    </ng-container>\n  </div>\n  <div class=\"rating\" *ngIf=\"!product?.averageRating\">\n    {{ 'productDetails.noReviews' | cxTranslate }}\n  </div>\n  <div class=\"code\">\n    {{ 'productSummary.id' | cxTranslate }} {{ product?.code }}\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: StarRatingComponent, selector: "cx-star-rating", inputs: ["disabled", "rating"], outputs: ["change"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.DecimalPipe, name: "number" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductIntroComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-intro', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"rating\" *ngIf=\"product?.averageRating\">\n    <cx-star-rating [rating]=\"product?.averageRating ?? 0\"></cx-star-rating>\n\n    <div class=\"count\">({{ product?.numberOfReviews }})</div>\n    <!-- TODO: (CXSPA-7603) - Remove feature flag next major release. -->\n    <ng-container *cxFeature=\"'a11yLinkBtnsToTertiaryBtns'\">\n      <button\n        *ngIf=\"product?.averageRating\"\n        class=\"btn btn-tertiary\"\n        (click)=\"showReviews()\"\n        [attr.aria-label]=\"\n          'productSummary.showReviewsDetailed'\n            | cxTranslate\n              : {\n                  rating: product?.averageRating | number: '1.0-1',\n                  count: product?.numberOfReviews,\n                }\n        \"\n      >\n        {{ 'productSummary.showReviews' | cxTranslate }}\n      </button>\n    </ng-container>\n    <ng-container *cxFeature=\"'!a11yLinkBtnsToTertiaryBtns'\">\n      <button\n        *ngIf=\"areReviewsAvailable$ | async\"\n        class=\"btn btn-link cx-action-link\"\n        (click)=\"showReviews()\"\n        [attr.aria-label]=\"\n          'productSummary.showReviewsDetailed'\n            | cxTranslate\n              : {\n                  rating: product?.averageRating | number: '1.0-1',\n                  count: product?.numberOfReviews,\n                }\n        \"\n      >\n        {{ 'productSummary.showReviews' | cxTranslate }}\n      </button>\n    </ng-container>\n  </div>\n  <div class=\"rating\" *ngIf=\"!product?.averageRating\">\n    {{ 'productDetails.noReviews' | cxTranslate }}\n  </div>\n  <div class=\"code\">\n    {{ 'productSummary.id' | cxTranslate }} {{ product?.code }}\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: CurrentProductService }, { type: i1.TranslationService }, { type: i1.WindowRef }, { type: i1.EventService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductIntroModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductIntroModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductIntroModule, declarations: [ProductIntroComponent], imports: [CommonModule, I18nModule, StarRatingModule, FeaturesConfigModule], exports: [ProductIntroComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductIntroModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ProductIntroComponent: {
                        component: ProductIntroComponent,
                    },
                },
            }),
        ], imports: [CommonModule, I18nModule, StarRatingModule, FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductIntroModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule, StarRatingModule, FeaturesConfigModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ProductIntroComponent: {
                                    component: ProductIntroComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductIntroComponent],
                    exports: [ProductIntroComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductSummaryComponent {
    getProduct() {
        const productScopes = [
            ProductScope.DETAILS,
            ProductScope.PRICE,
            ProductScope.PROMOTIONS,
        ];
        return this.currentProductService.getProduct(productScopes);
    }
    constructor(currentProductService) {
        this.currentProductService = currentProductService;
        this.outlets = ProductDetailOutlets;
        this.product$ = this.getProduct();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductSummaryComponent, deps: [{ token: CurrentProductService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductSummaryComponent, isStandalone: false, selector: "cx-product-summary", ngImport: i0, template: "<ng-container *ngIf=\"product$ | async as product\">\n  <ng-container *ngIf=\"product.potentialPromotions\">\n    <cx-promotions [promotions]=\"product.potentialPromotions\"></cx-promotions>\n  </ng-container>\n\n  <ng-template\n    [cxOutlet]=\"outlets.PRICE\"\n    [cxOutletContext]=\"{ product: product }\"\n  >\n    <div\n      [attr.aria-label]=\"'productSummary.newItemPrice' | cxTranslate\"\n      class=\"price\"\n    >\n      {{ product?.price?.formattedValue }}\n    </div>\n  </ng-template>\n\n  <ng-template\n    [cxOutlet]=\"outlets.SUMMARY\"\n    [cxOutletContext]=\"{ product: product }\"\n  >\n    <p [innerHTML]=\"product?.summary\" class=\"summary\"></p>\n  </ng-template>\n\n  <!-- @TODO: Temp. Comment out share link while not in use by CMS -->\n  <!-- <ng-container *cxOutlet=\"outlets.SHARE\">\n        <div>\n          <a href=\"#\" class=\"share btn-link\">\n            {{ 'productSummary.share' | cxTranslate }}\n          </a>\n        </div>\n      </ng-container> -->\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "component", type: PromotionsComponent, selector: "cx-promotions", inputs: ["promotions"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-summary', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"product$ | async as product\">\n  <ng-container *ngIf=\"product.potentialPromotions\">\n    <cx-promotions [promotions]=\"product.potentialPromotions\"></cx-promotions>\n  </ng-container>\n\n  <ng-template\n    [cxOutlet]=\"outlets.PRICE\"\n    [cxOutletContext]=\"{ product: product }\"\n  >\n    <div\n      [attr.aria-label]=\"'productSummary.newItemPrice' | cxTranslate\"\n      class=\"price\"\n    >\n      {{ product?.price?.formattedValue }}\n    </div>\n  </ng-template>\n\n  <ng-template\n    [cxOutlet]=\"outlets.SUMMARY\"\n    [cxOutletContext]=\"{ product: product }\"\n  >\n    <p [innerHTML]=\"product?.summary\" class=\"summary\"></p>\n  </ng-template>\n\n  <!-- @TODO: Temp. Comment out share link while not in use by CMS -->\n  <!-- <ng-container *cxOutlet=\"outlets.SHARE\">\n        <div>\n          <a href=\"#\" class=\"share btn-link\">\n            {{ 'productSummary.share' | cxTranslate }}\n          </a>\n        </div>\n      </ng-container> -->\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: CurrentProductService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductSummaryModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductSummaryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductSummaryModule, declarations: [ProductSummaryComponent], imports: [CommonModule,
            OutletModule,
            I18nModule,
            PromotionsModule,
            FeaturesConfigModule], exports: [ProductSummaryComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductSummaryModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ProductSummaryComponent: {
                        component: ProductSummaryComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            OutletModule,
            I18nModule,
            PromotionsModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductSummaryModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ProductSummaryComponent: {
                                    component: ProductSummaryComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductSummaryComponent],
                    exports: [ProductSummaryComponent],
                    imports: [
                        CommonModule,
                        OutletModule,
                        I18nModule,
                        PromotionsModule,
                        FeaturesConfigModule,
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductAttributesComponent {
    constructor(currentProductService) {
        this.currentProductService = currentProductService;
        this.product$ = this.currentProductService.getProduct(ProductScope.ATTRIBUTES);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductAttributesComponent, deps: [{ token: CurrentProductService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductAttributesComponent, isStandalone: false, selector: "cx-product-attributes", ngImport: i0, template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"container\">\n    <h2>{{ 'productDetails.specification' | cxTranslate }}</h2>\n    <table *ngFor=\"let class of product?.classifications\">\n      <th>\n        <h2>{{ class.name }}</h2>\n      </th>\n      <tr *ngFor=\"let feature of class.features\">\n        <td>{{ feature.name }}</td>\n        <td>\n          <ul>\n            <li *ngFor=\"let featureValue of feature?.featureValues\">\n              {{ featureValue?.value }}\n              <span\n                *ngIf=\"\n                  feature.featureUnit &&\n                  feature.featureUnit.symbol &&\n                  feature.featureUnit.symbol.length > 0 &&\n                  feature.featureUnit?.unitType !== '300'\n                \"\n              >\n                {{ feature.featureUnit?.symbol }}\n              </span>\n            </li>\n          </ul>\n        </td>\n      </tr>\n    </table>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductAttributesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-attributes', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"container\">\n    <h2>{{ 'productDetails.specification' | cxTranslate }}</h2>\n    <table *ngFor=\"let class of product?.classifications\">\n      <th>\n        <h2>{{ class.name }}</h2>\n      </th>\n      <tr *ngFor=\"let feature of class.features\">\n        <td>{{ feature.name }}</td>\n        <td>\n          <ul>\n            <li *ngFor=\"let featureValue of feature?.featureValues\">\n              {{ featureValue?.value }}\n              <span\n                *ngIf=\"\n                  feature.featureUnit &&\n                  feature.featureUnit.symbol &&\n                  feature.featureUnit.symbol.length > 0 &&\n                  feature.featureUnit?.unitType !== '300'\n                \"\n              >\n                {{ feature.featureUnit?.symbol }}\n              </span>\n            </li>\n          </ul>\n        </td>\n      </tr>\n    </table>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: CurrentProductService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductAttributesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductAttributesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductAttributesModule, declarations: [ProductAttributesComponent], imports: [CommonModule, I18nModule], exports: [ProductAttributesComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductAttributesModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ProductSpecsTabComponent: {
                        component: ProductAttributesComponent,
                    },
                },
            }),
        ], imports: [CommonModule, I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductAttributesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, I18nModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ProductSpecsTabComponent: {
                                    component: ProductAttributesComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductAttributesComponent],
                    exports: [ProductAttributesComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductDetailsTabComponent {
    constructor(currentProductService, componentData, cmsService) {
        this.currentProductService = currentProductService;
        this.componentData = componentData;
        this.cmsService = cmsService;
        this.children$ = this.componentData.data$.pipe(switchMap$1((data) => combineLatest((data?.children ?? '').split(' ').map((component) => this.cmsService.getComponentData(component).pipe(distinctUntilChanged(), map((child) => {
            if (!child) {
                return undefined;
            }
            if (!child.flexType) {
                child = {
                    ...child,
                    flexType: child.typeCode,
                };
            }
            return child;
        }))))));
    }
    ngOnInit() {
        this.product$ = this.currentProductService.getProduct();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsTabComponent, deps: [{ token: CurrentProductService }, { token: CmsComponentData }, { token: i1.CmsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductDetailsTabComponent, isStandalone: false, selector: "cx-product-details-tab", ngImport: i0, template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"container\" [innerHTML]=\"product?.description\"></div>\n</ng-container>\n<ng-container *ngIf=\"children$ | async as children\">\n  <ng-container *ngFor=\"let child of children\">\n    <ng-container *ngIf=\"child\">\n      <ng-template [cxOutlet]=\"child.flexType\" [cxOutletContext]=\"{}\">\n        <div class=\"container\">\n          <ng-container [cxComponentWrapper]=\"child\"></ng-container>\n        </div>\n      </ng-template>\n    </ng-container>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ComponentWrapperDirective, selector: "[cxComponentWrapper]", inputs: ["cxComponentWrapper"], outputs: ["cxComponentRef"] }, { kind: "directive", type: OutletDirective, selector: "[cxOutlet]", inputs: ["cxOutlet", "cxOutletContext", "cxOutletDefer", "cxComponentRef"], outputs: ["loaded", "cxComponentRefChange"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-details-tab', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"container\" [innerHTML]=\"product?.description\"></div>\n</ng-container>\n<ng-container *ngIf=\"children$ | async as children\">\n  <ng-container *ngFor=\"let child of children\">\n    <ng-container *ngIf=\"child\">\n      <ng-template [cxOutlet]=\"child.flexType\" [cxOutletContext]=\"{}\">\n        <div class=\"container\">\n          <ng-container [cxComponentWrapper]=\"child\"></ng-container>\n        </div>\n      </ng-template>\n    </ng-container>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: CurrentProductService }, { type: CmsComponentData }, { type: i1.CmsService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductDetailsTabModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsTabModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsTabModule, declarations: [ProductDetailsTabComponent], imports: [CommonModule, PageComponentModule, OutletModule], exports: [ProductDetailsTabComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsTabModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ProductDetailsTabComponent: {
                        component: ProductDetailsTabComponent,
                    },
                },
            }),
        ], imports: [CommonModule, PageComponentModule, OutletModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsTabModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PageComponentModule, OutletModule],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ProductDetailsTabComponent: {
                                    component: ProductDetailsTabComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductDetailsTabComponent],
                    exports: [ProductDetailsTabComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductReviewsComponent {
    constructor(reviewService, currentProductService, fb, cd) {
        this.reviewService = reviewService;
        this.currentProductService = currentProductService;
        this.fb = fb;
        this.cd = cd;
        this.maxLengthReviewTitle = 255;
        this.maxLengthReviewComment = 2200;
        this.maxLengthReviewerName = 64;
        this.isWritingReview = false;
        // TODO: configurable
        this.initialMaxListItems = 5;
        this.featureConfigService = inject(FeatureConfigService);
        this.product$ = this.currentProductService.getProduct();
        this.reviews$ = this.product$.pipe(filter(isNotNullable), map((p) => p.code ?? ''), distinctUntilChanged(), switchMap$1((productCode) => this.reviewService.getByProductCode(productCode)), tap(() => {
            this.resetReviewForm();
            this.maxListItems = this.initialMaxListItems;
        }));
    }
    initiateWriteReview() {
        this.isWritingReview = true;
        this.cd.detectChanges();
        if (this.titleInput && this.titleInput.nativeElement) {
            this.titleInput.nativeElement.focus();
        }
    }
    cancelWriteReview() {
        this.isWritingReview = false;
        this.resetReviewForm();
        this.cd.detectChanges();
        if (this.writeReviewButton && this.writeReviewButton.nativeElement) {
            this.writeReviewButton.nativeElement.focus();
        }
    }
    setRating(rating) {
        this.reviewForm.controls.rating.setValue(rating);
    }
    submitReview(product) {
        if (this.reviewForm.valid) {
            this.addReview(product);
        }
        else {
            this.reviewForm.markAllAsTouched();
        }
    }
    addReview(product) {
        const reviewFormControls = this.reviewForm.controls;
        const review = {
            headline: reviewFormControls.title.value,
            comment: reviewFormControls.comment.value,
            rating: reviewFormControls.rating.value,
            alias: reviewFormControls.reviewerName.value,
        };
        this.reviewService.add(product.code ?? '', review);
        this.isWritingReview = false;
        this.resetReviewForm();
        this.cd.detectChanges();
        if (this.writeReviewButton && this.writeReviewButton.nativeElement) {
            this.writeReviewButton.nativeElement.focus();
        }
    }
    resetReviewForm() {
        const isProductReviewCharactersLeftEnabled = this.featureConfigService.isEnabled('productReviewCharactersLeft');
        this.reviewForm = this.fb.group({
            title: [
                '',
                !isProductReviewCharactersLeftEnabled
                    ? Validators.required
                    : [
                        Validators.required,
                        Validators.maxLength(this.maxLengthReviewTitle),
                    ],
            ],
            comment: [
                '',
                !isProductReviewCharactersLeftEnabled
                    ? Validators.required
                    : [
                        Validators.required,
                        Validators.maxLength(this.maxLengthReviewComment),
                    ],
            ],
            rating: [null, Validators.required],
            reviewerName: !isProductReviewCharactersLeftEnabled
                ? ''
                : ['', Validators.maxLength(this.maxLengthReviewerName)],
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReviewsComponent, deps: [{ token: i1.ProductReviewService }, { token: CurrentProductService }, { token: i1$4.UntypedFormBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: ProductReviewsComponent, isStandalone: false, selector: "cx-product-reviews", inputs: { maxLengthReviewTitle: "maxLengthReviewTitle", maxLengthReviewComment: "maxLengthReviewComment", maxLengthReviewerName: "maxLengthReviewerName" }, viewQueries: [{ propertyName: "titleInput", first: true, predicate: ["titleInput"], descendants: true }, { propertyName: "writeReviewButton", first: true, predicate: ["writeReviewButton"], descendants: true }], ngImport: i0, template: "<div class=\"container\" *ngIf=\"product$ | async as product\">\n  <h2>\n    {{ 'productDetails.reviews' | cxTranslate }} ({{ product.numberOfReviews }})\n  </h2>\n  <ng-container *ngIf=\"!isWritingReview; else writeReview\">\n    <div class=\"header\">\n      <h3>{{ 'productReview.overallRating' | cxTranslate }}</h3>\n      <button\n        #writeReviewButton\n        class=\"btn btn-primary\"\n        (click)=\"initiateWriteReview()\"\n      >\n        {{ 'productReview.writeReview' | cxTranslate }}\n      </button>\n      <cx-star-rating\n        *ngIf=\"product.averageRating\"\n        class=\"rating\"\n        [rating]=\"product.averageRating\"\n      ></cx-star-rating>\n      <div class=\"rating\" *ngIf=\"!product.averageRating\">\n        {{ 'productDetails.noReviews' | cxTranslate }}\n      </div>\n    </div>\n\n    <ng-container *ngIf=\"!isWritingReview; else writeReview\">\n      <ng-container *ngIf=\"reviews$ | async as reviews\">\n        <div\n          class=\"review\"\n          tabindex=\"0\"\n          *ngFor=\"let review of reviews | slice: 0 : maxListItems\"\n        >\n          <div class=\"title\">{{ review.headline }}</div>\n          <cx-star-rating [rating]=\"review.rating ?? 0\"></cx-star-rating>\n          <div class=\"name\">\n            {{ review.alias ? review.alias : review.principal?.name }}\n          </div>\n          <div class=\"date\">{{ review.date | cxDate }}</div>\n          <div *cxFeature=\"'!readMoreDirective'\" class=\"text\">\n            {{ review.comment }}\n          </div>\n          <cx-read-more\n            *cxFeature=\"'readMoreDirective'\"\n            class=\"text\"\n            [text]=\"review.comment!\"\n          ></cx-read-more>\n        </div>\n        <div *ngIf=\"reviews.length > initialMaxListItems\">\n          <button\n            *cxFeature=\"'a11yShowMoreReviewsBtnFocus'\"\n            aria-live=\"polite\"\n            class=\"btn btn-primary\"\n            (click)=\"\n              maxListItems === initialMaxListItems\n                ? (maxListItems = reviews.length)\n                : (maxListItems = initialMaxListItems)\n            \"\n          >\n            {{\n              (maxListItems === initialMaxListItems\n                ? 'productReview.more'\n                : 'productReview.less'\n              ) | cxTranslate\n            }}\n          </button>\n          <ng-container *cxFeature=\"'!a11yShowMoreReviewsBtnFocus'\">\n            <button\n              class=\"btn btn-primary\"\n              (click)=\"maxListItems = reviews.length\"\n              *ngIf=\"maxListItems === initialMaxListItems\"\n            >\n              {{ 'productReview.more' | cxTranslate }}\n            </button>\n            <button\n              class=\"btn btn-primary\"\n              (click)=\"maxListItems = initialMaxListItems\"\n              *ngIf=\"maxListItems !== initialMaxListItems\"\n            >\n              {{ 'productReview.less' | cxTranslate }}\n            </button>\n          </ng-container>\n        </div>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n\n  <ng-template #writeReview>\n    <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n    <cx-form-required-legend />\n    <form (ngSubmit)=\"submitReview(product)\" [formGroup]=\"reviewForm\">\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.reviewTitle' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            *cxFeature=\"'!productReviewCharactersLeft'\"\n            required=\"true\"\n            #titleInput\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"title\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('title')?.touched &&\n              reviewForm.get('title')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'titleError'\"\n          />\n          <input\n            *cxFeature=\"'productReviewCharactersLeft'\"\n            required=\"true\"\n            #titleInput\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"title\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('title')?.touched &&\n              reviewForm.get('title')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'titleError'\"\n            [maxLength]=\"maxLengthReviewTitle\"\n          />\n\n          <cx-form-errors\n            id=\"titleError\"\n            [translationParams]=\"{\n              label: 'productReview.reviewTitle' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('title')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.writeYourComments' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <textarea\n            *cxFeature=\"'!productReviewCharactersLeft'\"\n            required=\"true\"\n            class=\"form-control\"\n            rows=\"3\"\n            formControlName=\"comment\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('comment')?.touched &&\n              reviewForm.get('comment')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'commentError'\"\n          ></textarea>\n          <textarea\n            *cxFeature=\"'productReviewCharactersLeft'\"\n            required=\"true\"\n            class=\"form-control\"\n            rows=\"3\"\n            [placeholder]=\"'productReview.commentPlaceholder' | cxTranslate\"\n            formControlName=\"comment\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('comment')?.touched &&\n              reviewForm.get('comment')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'commentError'\"\n            [maxLength]=\"maxLengthReviewComment\"\n          ></textarea>\n\n          <cx-form-errors\n            id=\"commentError\"\n            [translationParams]=\"{\n              label: 'productReview.writeYourComments' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('comment')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.rating' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            type=\"number\"\n            formControlName=\"rating\"\n            class=\"rating-input\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('rating')?.touched &&\n              reviewForm.get('rating')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'ratingError'\"\n          />\n          <cx-star-rating\n            tabindex=\"0\"\n            [attr.aria-label]=\"'productReview.ratingRequired' | cxTranslate\"\n            (change)=\"setRating($event)\"\n            [disabled]=\"false\"\n          ></cx-star-rating>\n\n          <cx-form-errors\n            id=\"ratingError\"\n            [translationParams]=\"{\n              label: 'productReview.rating' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('rating')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.reviewerName' | cxTranslate }}\n          </span>\n          <input\n            *cxFeature=\"'!productReviewCharactersLeft'\"\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"reviewerName\"\n          />\n          <input\n            *cxFeature=\"'productReviewCharactersLeft'\"\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"reviewerName\"\n            [maxLength]=\"maxLengthReviewerName\"\n          />\n          <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n          <cx-form-errors\n            *cxFeature=\"'formErrorsDescriptiveMessages'\"\n            id=\"titleError\"\n            [translationParams]=\"{\n              label: 'productReview.reviewerName' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('reviewerName')\"\n          ></cx-form-errors>\n\n          <cx-form-errors\n            *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n            [control]=\"reviewForm.get('reviewerName')\"\n          ></cx-form-errors>\n          <p\n            *cxFeature=\"'productReviewCharactersLeft'\"\n            class=\"cx-customer-ticket-input-hint text-right\"\n          >\n            {{\n              'productReview.charactersLeft'\n                | cxTranslate\n                  : {\n                      count:\n                        maxLengthReviewerName -\n                        (reviewForm.get('reviewerName')?.value?.length ?? 0),\n                    }\n            }}\n          </p>\n        </label>\n      </div>\n      <div class=\"form-group row justify-content-md-end\">\n        <div class=\"col-12 col-md-4\">\n          <button\n            type=\"button\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelWriteReview()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-12 col-md-4\">\n          <button type=\"submit\" class=\"btn btn-block btn-primary\">\n            {{ 'common.submit' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </form>\n  </ng-template>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: StarRatingComponent, selector: "cx-star-rating", inputs: ["disabled", "rating"], outputs: ["change"] }, { kind: "component", type: FormErrorsComponent, selector: "cx-form-errors", inputs: ["prefix", "fallbackPrefix", "translationParams", "control"] }, { kind: "directive", type: i1.FeatureDirective, selector: "[cxFeature]", inputs: ["cxFeature"] }, { kind: "component", type: FormRequiredAsterisksComponent, selector: "cx-form-required-asterisks", inputs: ["titleTranslation"] }, { kind: "component", type: FormRequiredLegendComponent, selector: "cx-form-required-legend", inputs: ["formLegendTranslation"] }, { kind: "component", type: ReadMoreComponent, selector: "cx-read-more", inputs: ["readMoreI18nKey", "readLessI18nKey", "maxLength", "text"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.SlicePipe, name: "slice" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.CxDatePipe, name: "cxDate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReviewsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-product-reviews', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div class=\"container\" *ngIf=\"product$ | async as product\">\n  <h2>\n    {{ 'productDetails.reviews' | cxTranslate }} ({{ product.numberOfReviews }})\n  </h2>\n  <ng-container *ngIf=\"!isWritingReview; else writeReview\">\n    <div class=\"header\">\n      <h3>{{ 'productReview.overallRating' | cxTranslate }}</h3>\n      <button\n        #writeReviewButton\n        class=\"btn btn-primary\"\n        (click)=\"initiateWriteReview()\"\n      >\n        {{ 'productReview.writeReview' | cxTranslate }}\n      </button>\n      <cx-star-rating\n        *ngIf=\"product.averageRating\"\n        class=\"rating\"\n        [rating]=\"product.averageRating\"\n      ></cx-star-rating>\n      <div class=\"rating\" *ngIf=\"!product.averageRating\">\n        {{ 'productDetails.noReviews' | cxTranslate }}\n      </div>\n    </div>\n\n    <ng-container *ngIf=\"!isWritingReview; else writeReview\">\n      <ng-container *ngIf=\"reviews$ | async as reviews\">\n        <div\n          class=\"review\"\n          tabindex=\"0\"\n          *ngFor=\"let review of reviews | slice: 0 : maxListItems\"\n        >\n          <div class=\"title\">{{ review.headline }}</div>\n          <cx-star-rating [rating]=\"review.rating ?? 0\"></cx-star-rating>\n          <div class=\"name\">\n            {{ review.alias ? review.alias : review.principal?.name }}\n          </div>\n          <div class=\"date\">{{ review.date | cxDate }}</div>\n          <div *cxFeature=\"'!readMoreDirective'\" class=\"text\">\n            {{ review.comment }}\n          </div>\n          <cx-read-more\n            *cxFeature=\"'readMoreDirective'\"\n            class=\"text\"\n            [text]=\"review.comment!\"\n          ></cx-read-more>\n        </div>\n        <div *ngIf=\"reviews.length > initialMaxListItems\">\n          <button\n            *cxFeature=\"'a11yShowMoreReviewsBtnFocus'\"\n            aria-live=\"polite\"\n            class=\"btn btn-primary\"\n            (click)=\"\n              maxListItems === initialMaxListItems\n                ? (maxListItems = reviews.length)\n                : (maxListItems = initialMaxListItems)\n            \"\n          >\n            {{\n              (maxListItems === initialMaxListItems\n                ? 'productReview.more'\n                : 'productReview.less'\n              ) | cxTranslate\n            }}\n          </button>\n          <ng-container *cxFeature=\"'!a11yShowMoreReviewsBtnFocus'\">\n            <button\n              class=\"btn btn-primary\"\n              (click)=\"maxListItems = reviews.length\"\n              *ngIf=\"maxListItems === initialMaxListItems\"\n            >\n              {{ 'productReview.more' | cxTranslate }}\n            </button>\n            <button\n              class=\"btn btn-primary\"\n              (click)=\"maxListItems = initialMaxListItems\"\n              *ngIf=\"maxListItems !== initialMaxListItems\"\n            >\n              {{ 'productReview.less' | cxTranslate }}\n            </button>\n          </ng-container>\n        </div>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n\n  <ng-template #writeReview>\n    <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n    <cx-form-required-legend />\n    <form (ngSubmit)=\"submitReview(product)\" [formGroup]=\"reviewForm\">\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.reviewTitle' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            *cxFeature=\"'!productReviewCharactersLeft'\"\n            required=\"true\"\n            #titleInput\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"title\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('title')?.touched &&\n              reviewForm.get('title')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'titleError'\"\n          />\n          <input\n            *cxFeature=\"'productReviewCharactersLeft'\"\n            required=\"true\"\n            #titleInput\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"title\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('title')?.touched &&\n              reviewForm.get('title')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'titleError'\"\n            [maxLength]=\"maxLengthReviewTitle\"\n          />\n\n          <cx-form-errors\n            id=\"titleError\"\n            [translationParams]=\"{\n              label: 'productReview.reviewTitle' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('title')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.writeYourComments' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <textarea\n            *cxFeature=\"'!productReviewCharactersLeft'\"\n            required=\"true\"\n            class=\"form-control\"\n            rows=\"3\"\n            formControlName=\"comment\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('comment')?.touched &&\n              reviewForm.get('comment')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'commentError'\"\n          ></textarea>\n          <textarea\n            *cxFeature=\"'productReviewCharactersLeft'\"\n            required=\"true\"\n            class=\"form-control\"\n            rows=\"3\"\n            [placeholder]=\"'productReview.commentPlaceholder' | cxTranslate\"\n            formControlName=\"comment\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('comment')?.touched &&\n              reviewForm.get('comment')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'commentError'\"\n            [maxLength]=\"maxLengthReviewComment\"\n          ></textarea>\n\n          <cx-form-errors\n            id=\"commentError\"\n            [translationParams]=\"{\n              label: 'productReview.writeYourComments' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('comment')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.rating' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            type=\"number\"\n            formControlName=\"rating\"\n            class=\"rating-input\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('rating')?.touched &&\n              reviewForm.get('rating')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'ratingError'\"\n          />\n          <cx-star-rating\n            tabindex=\"0\"\n            [attr.aria-label]=\"'productReview.ratingRequired' | cxTranslate\"\n            (change)=\"setRating($event)\"\n            [disabled]=\"false\"\n          ></cx-star-rating>\n\n          <cx-form-errors\n            id=\"ratingError\"\n            [translationParams]=\"{\n              label: 'productReview.rating' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('rating')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.reviewerName' | cxTranslate }}\n          </span>\n          <input\n            *cxFeature=\"'!productReviewCharactersLeft'\"\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"reviewerName\"\n          />\n          <input\n            *cxFeature=\"'productReviewCharactersLeft'\"\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"reviewerName\"\n            [maxLength]=\"maxLengthReviewerName\"\n          />\n          <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n          <cx-form-errors\n            *cxFeature=\"'formErrorsDescriptiveMessages'\"\n            id=\"titleError\"\n            [translationParams]=\"{\n              label: 'productReview.reviewerName' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('reviewerName')\"\n          ></cx-form-errors>\n\n          <cx-form-errors\n            *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n            [control]=\"reviewForm.get('reviewerName')\"\n          ></cx-form-errors>\n          <p\n            *cxFeature=\"'productReviewCharactersLeft'\"\n            class=\"cx-customer-ticket-input-hint text-right\"\n          >\n            {{\n              'productReview.charactersLeft'\n                | cxTranslate\n                  : {\n                      count:\n                        maxLengthReviewerName -\n                        (reviewForm.get('reviewerName')?.value?.length ?? 0),\n                    }\n            }}\n          </p>\n        </label>\n      </div>\n      <div class=\"form-group row justify-content-md-end\">\n        <div class=\"col-12 col-md-4\">\n          <button\n            type=\"button\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelWriteReview()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-12 col-md-4\">\n          <button type=\"submit\" class=\"btn btn-block btn-primary\">\n            {{ 'common.submit' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </form>\n  </ng-template>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.ProductReviewService }, { type: CurrentProductService }, { type: i1$4.UntypedFormBuilder }, { type: i0.ChangeDetectorRef }], propDecorators: { titleInput: [{
                type: ViewChild,
                args: ['titleInput', { static: false }]
            }], writeReviewButton: [{
                type: ViewChild,
                args: ['writeReviewButton', { static: false }]
            }], maxLengthReviewTitle: [{
                type: Input
            }], maxLengthReviewComment: [{
                type: Input
            }], maxLengthReviewerName: [{
                type: Input
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductReviewsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReviewsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductReviewsModule, declarations: [ProductReviewsComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            I18nModule,
            StarRatingModule,
            FormErrorsModule,
            FeaturesConfigModule,
            FormRequiredAsterisksComponent,
            FormRequiredLegendComponent,
            ReadMoreComponent], exports: [ProductReviewsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReviewsModule, providers: [
            provideDefaultConfig({
                cmsComponents: {
                    ProductReviewsTabComponent: {
                        component: ProductReviewsComponent,
                    },
                },
            }),
        ], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            I18nModule,
            StarRatingModule,
            FormErrorsModule,
            FeaturesConfigModule,
            FormRequiredAsterisksComponent,
            FormRequiredLegendComponent,
            ReadMoreComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductReviewsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        I18nModule,
                        StarRatingModule,
                        FormErrorsModule,
                        FeaturesConfigModule,
                        FormRequiredAsterisksComponent,
                        FormRequiredLegendComponent,
                        ReadMoreComponent,
                    ],
                    providers: [
                        provideDefaultConfig({
                            cmsComponents: {
                                ProductReviewsTabComponent: {
                                    component: ProductReviewsComponent,
                                },
                            },
                        }),
                    ],
                    declarations: [ProductReviewsComponent],
                    exports: [ProductReviewsComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductTabsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductTabsModule, imports: [ProductAttributesModule,
            ProductDetailsTabModule,
            ProductReviewsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductTabsModule, imports: [ProductAttributesModule,
            ProductDetailsTabModule,
            ProductReviewsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        ProductAttributesModule,
                        ProductDetailsTabModule,
                        ProductReviewsModule,
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StockNotificationDialogComponent {
    handleClick(event) {
        if (event.target.tagName === this.el.nativeElement.tagName) {
            this.close('Cross click');
        }
    }
    constructor(interestsService, launchDialogService, el) {
        this.interestsService = interestsService;
        this.launchDialogService = launchDialogService;
        this.el = el;
        this.subscription = new Subscription();
        this.enabledPrefs = [];
        this.focusConfig = {
            trap: true,
            block: true,
            autofocus: 'button',
            focusOnEscape: true,
        };
    }
    close(reason) {
        this.launchDialogService.closeDialog(reason);
    }
    ngOnInit() {
        this.subscription.add(this.launchDialogService.data$.subscribe((data) => {
            if (data) {
                this.init(data.subscribeSuccess$, data.enabledPrefs);
            }
        }));
    }
    init(subscribeSuccess$, enabledPrefs) {
        this.subscribeSuccess$ = subscribeSuccess$;
        this.enabledPrefs = enabledPrefs;
    }
    ngOnDestroy() {
        if (this.subscribeSuccess$) {
            this.subscribeSuccess$
                .subscribe((success) => {
                if (success) {
                    this.interestsService.resetAddInterestState();
                }
            })
                .unsubscribe();
        }
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StockNotificationDialogComponent, deps: [{ token: i1.UserInterestsService }, { token: LaunchDialogService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: StockNotificationDialogComponent, isStandalone: false, selector: "cx-stock-notification-dialog", host: { listeners: { "click": "handleClick($event)" } }, ngImport: i0, template: "<div\n  class=\"modal-dialog modal-dialog-centered modal-lg\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content\">\n    <div class=\"cx-dialog-header cx-modal-header\">\n      <h3 id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n        {{ 'stockNotification.subscriptionDialog.header' | cxTranslate }}\n      </h3>\n      <button\n        type=\"button\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        class=\"close\"\n        tabindex=\"-1\"\n        (click)=\"close('Button clicked')\"\n      >\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n\n    <ng-container *ngIf=\"subscribeSuccess$ | async; else loading\">\n      <div class=\"cx-dialog-body modal-body\">\n        <div class=\"cx-stock-notification-content\">\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.notifiedPrefix'\n                | cxTranslate\n            }}\n          </p>\n          <p *ngFor=\"let preference of enabledPrefs\" class=\"channels\">\n            <span>{{ preference.channel }}</span\n            ><span *ngIf=\"preference.value\">{{ ': ' + preference.value }}</span>\n          </p>\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.notifiedSuffix'\n                | cxTranslate\n            }}\n          </p>\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.manageChannelsPrefix'\n                | cxTranslate\n            }}\n            <a\n              (click)=\"close('Link clicked')\"\n              [routerLink]=\"{ cxRoute: 'notificationPreference' } | cxUrl\"\n              class=\"link-prefs cx-stock-notification-link\"\n            >\n              {{\n                'stockNotification.subscriptionDialog.manageChannelsLink'\n                  | cxTranslate\n              }}</a\n            >\n            {{\n              'stockNotification.subscriptionDialog.manageChannelsSuffix'\n                | cxTranslate\n            }}\n          </p>\n\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.manageSubscriptionsPrefix'\n                | cxTranslate\n            }}\n            <a\n              (click)=\"close('Link clicked')\"\n              [routerLink]=\"{ cxRoute: 'myInterests' } | cxUrl\"\n              class=\"link-interests cx-stock-notification-link\"\n            >\n              {{\n                'stockNotification.subscriptionDialog.manageSubscriptionsLink'\n                  | cxTranslate\n              }}</a\n            >\n            {{\n              'stockNotification.subscriptionDialog.manageSubscriptionsSuffix'\n                | cxTranslate\n            }}\n          </p>\n        </div>\n      </div>\n      <div class=\"cx-modal-footer\">\n        <div class=\"row\">\n          <div\n            class=\"cx-dialog-actions col-sm-12 col-md-4 offset-md-8 col-lg-3 offset-lg-9\"\n          >\n            <button\n              class=\"btn btn-primary btn-block btn-ok\"\n              type=\"button\"\n              (click)=\"close('Button clicked')\"\n            >\n              {{ 'stockNotification.subscriptionDialog.okBtn' | cxTranslate }}\n            </button>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-dialog-body modal-body\">\n      <p>\n        {{ 'stockNotification.subscriptionDialog.subscribing' | cxTranslate }}\n      </p>\n      <div class=\"cx-dialog-row\">\n        <div class=\"col-sm-12\">\n          <cx-spinner></cx-spinner>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "directive", type: FocusDirective, selector: "[cxFocus]", inputs: ["cxFocus"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.UrlPipe, name: "cxUrl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StockNotificationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-stock-notification-dialog', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div\n  class=\"modal-dialog modal-dialog-centered modal-lg\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content\">\n    <div class=\"cx-dialog-header cx-modal-header\">\n      <h3 id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n        {{ 'stockNotification.subscriptionDialog.header' | cxTranslate }}\n      </h3>\n      <button\n        type=\"button\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        class=\"close\"\n        tabindex=\"-1\"\n        (click)=\"close('Button clicked')\"\n      >\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n\n    <ng-container *ngIf=\"subscribeSuccess$ | async; else loading\">\n      <div class=\"cx-dialog-body modal-body\">\n        <div class=\"cx-stock-notification-content\">\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.notifiedPrefix'\n                | cxTranslate\n            }}\n          </p>\n          <p *ngFor=\"let preference of enabledPrefs\" class=\"channels\">\n            <span>{{ preference.channel }}</span\n            ><span *ngIf=\"preference.value\">{{ ': ' + preference.value }}</span>\n          </p>\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.notifiedSuffix'\n                | cxTranslate\n            }}\n          </p>\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.manageChannelsPrefix'\n                | cxTranslate\n            }}\n            <a\n              (click)=\"close('Link clicked')\"\n              [routerLink]=\"{ cxRoute: 'notificationPreference' } | cxUrl\"\n              class=\"link-prefs cx-stock-notification-link\"\n            >\n              {{\n                'stockNotification.subscriptionDialog.manageChannelsLink'\n                  | cxTranslate\n              }}</a\n            >\n            {{\n              'stockNotification.subscriptionDialog.manageChannelsSuffix'\n                | cxTranslate\n            }}\n          </p>\n\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.manageSubscriptionsPrefix'\n                | cxTranslate\n            }}\n            <a\n              (click)=\"close('Link clicked')\"\n              [routerLink]=\"{ cxRoute: 'myInterests' } | cxUrl\"\n              class=\"link-interests cx-stock-notification-link\"\n            >\n              {{\n                'stockNotification.subscriptionDialog.manageSubscriptionsLink'\n                  | cxTranslate\n              }}</a\n            >\n            {{\n              'stockNotification.subscriptionDialog.manageSubscriptionsSuffix'\n                | cxTranslate\n            }}\n          </p>\n        </div>\n      </div>\n      <div class=\"cx-modal-footer\">\n        <div class=\"row\">\n          <div\n            class=\"cx-dialog-actions col-sm-12 col-md-4 offset-md-8 col-lg-3 offset-lg-9\"\n          >\n            <button\n              class=\"btn btn-primary btn-block btn-ok\"\n              type=\"button\"\n              (click)=\"close('Button clicked')\"\n            >\n              {{ 'stockNotification.subscriptionDialog.okBtn' | cxTranslate }}\n            </button>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-dialog-body modal-body\">\n      <p>\n        {{ 'stockNotification.subscriptionDialog.subscribing' | cxTranslate }}\n      </p>\n      <div class=\"cx-dialog-row\">\n        <div class=\"col-sm-12\">\n          <cx-spinner></cx-spinner>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.UserInterestsService }, { type: LaunchDialogService }, { type: i0.ElementRef }], propDecorators: { handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StockNotificationComponent {
    constructor(currentProductService, globalMessageService, translationService, interestsService, notificationPrefService, userIdService, launchDialogService, vcr) {
        this.currentProductService = currentProductService;
        this.globalMessageService = globalMessageService;
        this.translationService = translationService;
        this.interestsService = interestsService;
        this.notificationPrefService = notificationPrefService;
        this.userIdService = userIdService;
        this.launchDialogService = launchDialogService;
        this.vcr = vcr;
        this.anonymous = true;
        this.enabledPrefs = [];
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.outOfStock$ = combineLatest([
            this.currentProductService.getProduct().pipe(filter(isNotNullable)),
            this.userIdService.getUserId(),
        ]).pipe(tap(([product, userId]) => {
            this.productCode = product.code ?? '';
            if (userId !== OCC_USER_ID_ANONYMOUS) {
                this.anonymous = false;
                this.notificationPrefService.loadPreferences();
                this.interestsService.loadProductInterests(undefined, undefined, undefined, product.code, NotificationType.BACK_IN_STOCK);
            }
        }), map(([product]) => !!product.stock && product.stock.stockLevelStatus === 'outOfStock'));
        this.hasProductInterests$ = this.interestsService
            .getProductInterests()
            .pipe(map((interests) => !!interests.results && interests.results.length === 1));
        this.subscribeSuccess$ =
            this.interestsService.getAddProductInterestSuccess();
        this.isRemoveInterestLoading$ =
            this.interestsService.getRemoveProdutInterestLoading();
        this.prefsEnabled$ = this.notificationPrefService
            .getEnabledPreferences()
            .pipe(tap((prefs) => (this.enabledPrefs = prefs)), map((prefs) => prefs.length > 0));
        this.subscriptions.add(this.interestsService.getAddProductInterestError().subscribe((error) => {
            if (error) {
                this.onInterestAddingError();
            }
        }));
        this.subscriptions.add(this.interestsService
            .getRemoveProdutInterestSuccess()
            .subscribe((success) => {
            if (success) {
                this.onInterestRemovingSuccess();
            }
        }));
    }
    subscribe() {
        this.openDialog();
        this.interestsService.addProductInterest(this.productCode, NotificationType.BACK_IN_STOCK);
    }
    unsubscribe() {
        this.interestsService.removeProdutInterest({
            product: {
                code: this.productCode,
            },
            productInterestEntry: [
                {
                    interestType: NotificationType.BACK_IN_STOCK,
                },
            ],
        }, true);
    }
    onInterestRemovingSuccess() {
        this.subscriptions.add(this.translationService
            .translate('stockNotification.unsubscribeSuccess')
            .pipe(first())
            .subscribe((text) => this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_INFO)));
        this.interestsService.resetRemoveInterestState();
    }
    onInterestAddingError() {
        this.launchDialogService.closeDialog('Interests error');
        this.interestsService.resetAddInterestState();
    }
    openDialog() {
        const modalInstanceData = {
            subscribeSuccess$: this.subscribeSuccess$,
            enabledPrefs: this.enabledPrefs,
        };
        const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.STOCK_NOTIFICATION, this.element, this.vcr, modalInstanceData);
        if (dialog) {
            dialog.pipe(take(1)).subscribe();
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.interestsService.clearProductInterests();
        this.notificationPrefService.clearPreferences();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StockNotificationComponent, deps: [{ token: CurrentProductService }, { token: i1.GlobalMessageService }, { token: i1.TranslationService }, { token: i1.UserInterestsService }, { token: i1.UserNotificationPreferenceService }, { token: i1.UserIdService }, { token: LaunchDialogService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.3", type: StockNotificationComponent, isStandalone: false, selector: "cx-stock-notification", viewQueries: [{ propertyName: "element", first: true, predicate: ["element"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"outOfStock$ | async\">\n  <ng-container *ngIf=\"!(hasProductInterests$ | async); else stopNotify\">\n    <ng-container *ngIf=\"prefsEnabled$ | async; else disableNotify\">\n      <div class=\"stock-notification-notes\">\n        <p>{{ 'stockNotification.getNotified' | cxTranslate }}</p>\n      </div>\n      <button\n        class=\"btn btn-primary btn-block btn-notify\"\n        type=\"button\"\n        (click)=\"subscribe()\"\n      >\n        {{ 'stockNotification.notifyMe' | cxTranslate }}\n      </button>\n    </ng-container>\n  </ng-container>\n</ng-container>\n\n<ng-template #disableNotify>\n  <div class=\"stock-notification-notes\" id=\"outOfStockMessage\">\n    <p>\n      <ng-container *ngIf=\"anonymous; else loggedIn\">\n        <a [routerLink]=\"{ cxRoute: 'login' } | cxUrl\">\n          {{ 'miniLogin.signInRegister' | cxTranslate }}</a\n        >\n        {{ 'stockNotification.getNotifySuffix' | cxTranslate }}<br />\n      </ng-container>\n      <ng-template #loggedIn>\n        {{ 'stockNotification.getNotify' | cxTranslate }}<br />\n        {{ 'stockNotification.activateChannelsPrefix' | cxTranslate }}\n        <a [routerLink]=\"{ cxRoute: 'notificationPreference' } | cxUrl\">{{\n          'stockNotification.channelsLink' | cxTranslate\n        }}</a\n        >{{ 'stockNotification.activateChannelsSuffix' | cxTranslate }}\n      </ng-template>\n    </p>\n  </div>\n  <button\n    class=\"btn btn-primary btn-block btn-notify\"\n    type=\"button\"\n    [attr.disabled]=\"anonymous ? true : null\"\n    aria-describedby=\"outOfStockMessage\"\n    (click)=\"subscribe()\"\n  >\n    {{ 'stockNotification.notifyMe' | cxTranslate }}\n  </button>\n</ng-template>\n\n<ng-template #stopNotify>\n  <ng-container *ngIf=\"!(isRemoveInterestLoading$ | async); else loading\">\n    <div class=\"stock-notification-notes\">\n      <p>{{ 'stockNotification.notified' | cxTranslate }}</p>\n    </div>\n    <button\n      class=\"btn btn-primary btn-block btn-stop-notify\"\n      type=\"button\"\n      (click)=\"unsubscribe()\"\n    >\n      {{ 'stockNotification.stopNotify' | cxTranslate }}\n    </button>\n  </ng-container>\n</ng-template>\n\n<ng-template #loading>\n  <div class=\"cx-dialog-body modal-body\">\n    <div class=\"cx-dialog-row\">\n      <div class=\"col-sm-12\">\n        <cx-spinner></cx-spinner>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: SpinnerComponent, selector: "cx-spinner" }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "cxTranslate" }, { kind: "pipe", type: i1.UrlPipe, name: "cxUrl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StockNotificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cx-stock-notification', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<ng-container *ngIf=\"outOfStock$ | async\">\n  <ng-container *ngIf=\"!(hasProductInterests$ | async); else stopNotify\">\n    <ng-container *ngIf=\"prefsEnabled$ | async; else disableNotify\">\n      <div class=\"stock-notification-notes\">\n        <p>{{ 'stockNotification.getNotified' | cxTranslate }}</p>\n      </div>\n      <button\n        class=\"btn btn-primary btn-block btn-notify\"\n        type=\"button\"\n        (click)=\"subscribe()\"\n      >\n        {{ 'stockNotification.notifyMe' | cxTranslate }}\n      </button>\n    </ng-container>\n  </ng-container>\n</ng-container>\n\n<ng-template #disableNotify>\n  <div class=\"stock-notification-notes\" id=\"outOfStockMessage\">\n    <p>\n      <ng-container *ngIf=\"anonymous; else loggedIn\">\n        <a [routerLink]=\"{ cxRoute: 'login' } | cxUrl\">\n          {{ 'miniLogin.signInRegister' | cxTranslate }}</a\n        >\n        {{ 'stockNotification.getNotifySuffix' | cxTranslate }}<br />\n      </ng-container>\n      <ng-template #loggedIn>\n        {{ 'stockNotification.getNotify' | cxTranslate }}<br />\n        {{ 'stockNotification.activateChannelsPrefix' | cxTranslate }}\n        <a [routerLink]=\"{ cxRoute: 'notificationPreference' } | cxUrl\">{{\n          'stockNotification.channelsLink' | cxTranslate\n        }}</a\n        >{{ 'stockNotification.activateChannelsSuffix' | cxTranslate }}\n      </ng-template>\n    </p>\n  </div>\n  <button\n    class=\"btn btn-primary btn-block btn-notify\"\n    type=\"button\"\n    [attr.disabled]=\"anonymous ? true : null\"\n    aria-describedby=\"outOfStockMessage\"\n    (click)=\"subscribe()\"\n  >\n    {{ 'stockNotification.notifyMe' | cxTranslate }}\n  </button>\n</ng-template>\n\n<ng-template #stopNotify>\n  <ng-container *ngIf=\"!(isRemoveInterestLoading$ | async); else loading\">\n    <div class=\"stock-notification-notes\">\n      <p>{{ 'stockNotification.notified' | cxTranslate }}</p>\n    </div>\n    <button\n      class=\"btn btn-primary btn-block btn-stop-notify\"\n      type=\"button\"\n      (click)=\"unsubscribe()\"\n    >\n      {{ 'stockNotification.stopNotify' | cxTranslate }}\n    </button>\n  </ng-container>\n</ng-template>\n\n<ng-template #loading>\n  <div class=\"cx-dialog-body modal-body\">\n    <div class=\"cx-dialog-row\">\n      <div class=\"col-sm-12\">\n        <cx-spinner></cx-spinner>\n      </div>\n    </div>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: CurrentProductService }, { type: i1.GlobalMessageService }, { type: i1.TranslationService }, { type: i1.UserInterestsService }, { type: i1.UserNotificationPreferenceService }, { type: i1.UserIdService }, { type: LaunchDialogService }, { type: i0.ViewContainerRef }], propDecorators: { element: [{
                type: ViewChild,
                args: ['element']
            }] } });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultStockNotificationLayoutConfig = {
    launch: {
        STOCK_NOTIFICATION: {
            inlineRoot: true,
            component: StockNotificationDialogComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StockNotificationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StockNotificationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: StockNotificationModule, declarations: [StockNotificationComponent, StockNotificationDialogComponent], imports: [CommonModule,
            RouterModule,
            I18nModule,
            SpinnerModule,
            UrlModule,
            KeyboardFocusModule,
            FeaturesConfigModule], exports: [StockNotificationComponent, StockNotificationDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StockNotificationModule, providers: [
            provideDefaultConfig(defaultStockNotificationLayoutConfig),
            provideDefaultConfig({
                cmsComponents: {
                    StockNotificationComponent: {
                        component: StockNotificationComponent,
                    },
                },
            }),
            FeaturesConfigModule,
        ], imports: [CommonModule,
            RouterModule,
            I18nModule,
            SpinnerModule,
            UrlModule,
            KeyboardFocusModule,
            FeaturesConfigModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: StockNotificationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [StockNotificationComponent, StockNotificationDialogComponent],
                    imports: [
                        CommonModule,
                        RouterModule,
                        I18nModule,
                        SpinnerModule,
                        UrlModule,
                        KeyboardFocusModule,
                        FeaturesConfigModule,
                    ],
                    providers: [
                        provideDefaultConfig(defaultStockNotificationLayoutConfig),
                        provideDefaultConfig({
                            cmsComponents: {
                                StockNotificationComponent: {
                                    component: StockNotificationComponent,
                                },
                            },
                        }),
                        FeaturesConfigModule,
                    ],
                    exports: [StockNotificationComponent, StockNotificationDialogComponent],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Guards the _login_ route.
 *
 * Takes care of routing the user to a auth server login page (if implicit or code flow is used).
 * In case of Resource Owner Password Flow just renders the page as normal CMS page.
 */
class LoginGuard {
    constructor(authService, authConfigService, cmsPageGuard) {
        this.authService = authService;
        this.authConfigService = authConfigService;
        this.cmsPageGuard = cmsPageGuard;
    }
    canActivate(route, state) {
        return this.shouldRenderCMSPage().pipe(take(1), switchMap$1((shouldRenderCMSPage) => {
            if (shouldRenderCMSPage) {
                return this.cmsPageGuard.canActivate(route, state);
            }
            else {
                // This method can trigger redirect to OAuth server that's why we don't return anything in this case
                const redirected = this.authService.loginWithRedirect();
                if (!redirected) {
                    return of(false);
                }
                return EMPTY;
            }
        }));
    }
    shouldRenderCMSPage() {
        return this.authService.isUserLoggedIn().pipe(take(1), map((isUserLoggedIn) => {
            return (this.authConfigService.getOAuthFlow() ===
                OAuthFlow.ResourceOwnerPasswordFlow || isUserLoggedIn);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LoginGuard, deps: [{ token: i1.AuthService }, { token: i1.AuthConfigService }, { token: CmsPageGuard }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LoginGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LoginGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.AuthService }, { type: i1.AuthConfigService }, { type: CmsPageGuard }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * This module enables to quickly switch from Resource Owner Password Flow
 * to Implicit Flow or Authorization Code Flow. The `login` route in this case will be
 * responsible for initalizing the redirect to OAuth server to login.
 *
 * Instead of manually invoking OAuth redirect you only have to redirect to `login` page.
 */
class LoginRouteModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LoginRouteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: LoginRouteModule, imports: [PageLayoutModule, i1$2.RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LoginRouteModule, imports: [PageLayoutModule,
            RouterModule.forChild([
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [LoginGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'login' },
                },
            ])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LoginRouteModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        PageLayoutModule,
                        RouterModule.forChild([
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [LoginGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'login' },
                            },
                        ]),
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Guards the _logout_ route.
 *
 * Takes care of routing the user to a logout page (if available) or redirects to
 * the homepage. If the homepage is protected, the user is redirected
 * to the login route instead.
 */
class LogoutGuard {
    constructor(auth, cms, semanticPathService, protectedRoutes, router) {
        this.auth = auth;
        this.cms = cms;
        this.semanticPathService = semanticPathService;
        this.protectedRoutes = protectedRoutes;
        this.router = router;
    }
    canActivate() {
        /**
         * First we want to complete logout process before redirecting to logout page
         * We want to avoid errors like `token is no longer valid`
         */
        return from(this.logout()).pipe(switchMap$1(() => {
            return this.cms
                .hasPage({
                id: this.semanticPathService.get('logout') ?? '',
                type: PageType.CONTENT_PAGE,
            })
                .pipe(map((hasPage) => {
                if (!hasPage) {
                    return this.getRedirectUrl();
                }
                // TODO(#9385): Use CMS page guard here.
                return hasPage;
            }));
        }));
    }
    logout() {
        return this.auth.coreLogout();
    }
    /**
     * Whenever there is no specific "logout" page configured in the CMS,
     * we redirect after the user is logged out.
     *
     * The user gets redirected to the homepage, unless the homepage is protected
     * (in case of a closed shop). We'll redirect to the login page instead.
     */
    getRedirectUrl() {
        const cxRoute = this.protectedRoutes.shouldProtect ? 'login' : 'home';
        return this.router.parseUrl(this.semanticPathService.get(cxRoute) ?? '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LogoutGuard, deps: [{ token: i1.AuthService }, { token: i1.CmsService }, { token: i1.SemanticPathService }, { token: i1.ProtectedRoutesService }, { token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LogoutGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LogoutGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.AuthService }, { type: i1.CmsService }, { type: i1.SemanticPathService }, { type: i1.ProtectedRoutesService }, { type: i1$2.Router }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LogoutModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LogoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: LogoutModule, imports: [PageLayoutModule, i1$2.RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LogoutModule, imports: [PageLayoutModule,
            RouterModule.forChild([
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [LogoutGuard, CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'logout' },
                },
            ])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: LogoutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        PageLayoutModule,
                        RouterModule.forChild([
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [LogoutGuard, CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'logout' },
                            },
                        ]),
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserComponentModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: UserComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: UserComponentModule, imports: [LogoutModule,
            LoginRouteModule,
            ReactiveFormsModule,
            RouterModule,
            UrlModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: UserComponentModule, imports: [LogoutModule,
            LoginRouteModule,
            ReactiveFormsModule,
            RouterModule,
            UrlModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: UserComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        LogoutModule,
                        LoginRouteModule,
                        ReactiveFormsModule,
                        RouterModule,
                        UrlModule,
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const IS_GUEST_USER_CHECKOUT_KEY = 'isGuestUserCheckout';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function getProductDetailsUrlMatcherFactory(service, defaultMatcherFactory) {
    const factory = (route) => {
        const defaultMatcher = defaultMatcherFactory(route);
        const suffixPDPMatcher = getSuffixUrlMatcher({
            marker: 'p',
            paramName: 'productCode',
        });
        return service.getCombined([defaultMatcher, suffixPDPMatcher]);
    };
    return factory;
}
/**
 * Injection token with url matcher factory for PDP.
 * The provided url matcher matches both:
 * - the configured `paths` from routing config and
 * - custom pattern  `** / p / :productCode`
 *
 * If the this matcher doesn't fit the requirements, it can be replaced with the DEFAULT_URL_MATCHER
 * or additional matchers can be added for a specific route.
 *
 * Note: Matchers will "match" a route, but do not contribute to the creation of the route, nor do they guard routes.
 */
const PRODUCT_DETAILS_URL_MATCHER = new InjectionToken('PRODUCT_DETAILS_URL_MATCHER', {
    providedIn: 'root',
    factory: () => getProductDetailsUrlMatcherFactory(inject(UrlMatcherService), inject(DEFAULT_URL_MATCHER)),
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductDetailsPageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsPageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsPageModule, imports: [i1$2.RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsPageModule, providers: [
            provideDefaultConfig({
                routing: {
                    routes: {
                        product: {
                            matchers: [PRODUCT_DETAILS_URL_MATCHER],
                        },
                    },
                },
            }),
        ], imports: [RouterModule.forChild([
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'product' },
                },
            ])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductDetailsPageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        RouterModule.forChild([
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'product' },
                            },
                        ]),
                    ],
                    providers: [
                        provideDefaultConfig({
                            routing: {
                                routes: {
                                    product: {
                                        matchers: [PRODUCT_DETAILS_URL_MATCHER],
                                    },
                                },
                            },
                        }),
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function getProductListingUrlMatcherFactory(service, defaultMatcherFactory) {
    const factory = (route) => {
        const defaultMatcher = defaultMatcherFactory(route);
        const suffixPLPMatcher = getSuffixUrlMatcher({
            marker: 'c',
            paramName: 'categoryCode',
        });
        return service.getCombined([defaultMatcher, suffixPLPMatcher]);
    };
    return factory;
}
/**
 * Injection token with url matcher factory for PLP.
 * The provided url matcher matches both:
 * - the configured `paths` from routing config and
 * - custom pattern  `** / c / :categoryCode`
 *
 * If the this matcher doesn't fit the requirements, it can be replaced with the DEFAULT_URL_MATCHER
 * or additional matchers can be added for a specific route.
 *
 * Note: Matchers will "match" a route, but do not contribute to the creation of the route, nor do they guard routes.
 */
const PRODUCT_LISTING_URL_MATCHER = new InjectionToken('PRODUCT_LISTING_URL_MATCHER', {
    providedIn: 'root',
    factory: () => getProductListingUrlMatcherFactory(inject(UrlMatcherService), inject(DEFAULT_URL_MATCHER)),
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListingPageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListingPageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductListingPageModule, imports: [i1$2.RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListingPageModule, providers: [
            provideDefaultConfig({
                routing: {
                    routes: {
                        category: {
                            matchers: [PRODUCT_LISTING_URL_MATCHER],
                        },
                    },
                },
            }),
        ], imports: [RouterModule.forChild([
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { pageLabel: 'search', cxRoute: 'search' },
                },
                {
                    // @ts-ignore
                    path: null,
                    canActivate: [CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'brand' },
                },
                {
                    // The 'category' route  may include a greedy suffix url matcher '**/c/:categoryCode'
                    // So not to shadow the specific 'brand' route, the 'category' is the last route in the sequence.
                    // @ts-ignore
                    path: null,
                    canActivate: [CmsPageGuard],
                    component: PageLayoutComponent,
                    data: { cxRoute: 'category' },
                },
            ])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductListingPageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        RouterModule.forChild([
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { pageLabel: 'search', cxRoute: 'search' },
                            },
                            {
                                // @ts-ignore
                                path: null,
                                canActivate: [CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'brand' },
                            },
                            {
                                // The 'category' route  may include a greedy suffix url matcher '**/c/:categoryCode'
                                // So not to shadow the specific 'brand' route, the 'category' is the last route in the sequence.
                                // @ts-ignore
                                path: null,
                                canActivate: [CmsPageGuard],
                                component: PageLayoutComponent,
                                data: { cxRoute: 'category' },
                            },
                        ]),
                    ],
                    providers: [
                        provideDefaultConfig({
                            routing: {
                                routes: {
                                    category: {
                                        matchers: [PRODUCT_LISTING_URL_MATCHER],
                                    },
                                },
                            },
                        }),
                    ],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Resolves the context for the specific route, based on the property `data.cxContext`
 * defined in the Angular Route.
 */
class RoutingContextService {
    constructor(activatedRoutesService, injector) {
        this.activatedRoutesService = activatedRoutesService;
        this.injector = injector;
        /**
         * Combined context token mapping consisting of all mappings defined in currently
         * Activated Angular Routes.
         *
         * The context token mapping is read from each Route's property `data.cxContext`.
         */
        this.contextTokenMapping$ = this.activatedRoutesService.routes$.pipe(map((routes) => this.getRoutesContextTokenMapping(routes)), shareReplay$1({ refCount: true, bufferSize: 1 }));
    }
    /**
     * Returns the merged context token mapping, consisting of mappings
     * defined in all Activated Angular Routes.
     */
    getRoutesContextTokenMapping(routes) {
        return Object.assign({}, ...routes.map((route) => route?.data?.cxContext));
    }
    /**
     * Resolves the specified `contextToken` from `cxContext` data parameter of the activated Angular Routes.
     * @param contextToken
     *
     * @returns instance from the root injector if defined, otherwise `undefined`.
     */
    get(contextToken) {
        return this.contextTokenMapping$.pipe(switchMap$1((contextMapping) => {
            const providerToken = contextMapping?.[contextToken];
            return !!providerToken
                ? this.injector.get(providerToken)
                : of(undefined);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingContextService, deps: [{ token: i1.ActivatedRoutesService }, { token: i1.UnifiedInjector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingContextService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: RoutingContextService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.ActivatedRoutesService }, { type: i1.UnifiedInjector }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Generic service for resolving the context for the UI components.
 */
class ContextService {
    constructor(routingContextService) {
        this.routingContextService = routingContextService;
    }
    /**
     * Returns the context for the given token.
     */
    get(contextToken) {
        return this.resolveContext(contextToken).pipe(distinctUntilChanged(), shareReplay$1({ refCount: true, bufferSize: 1 }));
    }
    /**
     * Resolves the context for the given token.
     */
    resolveContext(contextToken) {
        return this.routingContextService.get(contextToken);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ContextService, deps: [{ token: RoutingContextService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ContextService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ContextService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RoutingContextService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that a user navigated to an arbitrary page.
 */
class NavigationEvent extends CxEvent {
    /**
     * Event's type
     */
    static { this.type = 'NavigationEvent'; }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that a user visited an arbitrary page.
 */
class PageEvent extends CxEvent {
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that a user visited a home page.
 */
class HomePageEvent extends PageEvent {
    /** event's type */
    static { this.type = 'HomePageEvent'; }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HomePageEventBuilder {
    constructor(eventService) {
        this.eventService = eventService;
        this.register();
    }
    register() {
        this.eventService.register(HomePageEvent, this.buildHomePageEvent());
    }
    buildHomePageEvent() {
        return this.eventService.get(NavigationEvent).pipe(filter((navigationEvent) => navigationEvent.semanticRoute === 'home'), map((navigationEvent) => createFrom(HomePageEvent, {
            navigation: navigationEvent,
        })));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HomePageEventBuilder, deps: [{ token: i1.EventService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HomePageEventBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HomePageEventBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.EventService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HomePageEventModule {
    constructor(_homePageEventBuilder) {
        // Intentional empty constructor
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HomePageEventModule, deps: [{ token: HomePageEventBuilder }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: HomePageEventModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HomePageEventModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: HomePageEventModule, decorators: [{
            type: NgModule,
            args: [{}]
        }], ctorParameters: () => [{ type: HomePageEventBuilder }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A builder for the NavigationEvent
 */
class NavigationEventBuilder {
    constructor(actions, eventService) {
        this.actions = actions;
        this.eventService = eventService;
        this.register();
    }
    /**
     * Registers events
     */
    register() {
        this.eventService.register(NavigationEvent, this.buildNavigationEvent());
    }
    /**
     * Builds the navigation events
     */
    buildNavigationEvent() {
        return this.getNavigatedEvent().pipe(map((state) => createFrom(NavigationEvent, {
            context: state.context,
            semanticRoute: state.semanticRoute,
            url: state.url,
            params: state.params,
        })));
    }
    getNavigatedEvent() {
        return this.actions.pipe(ofType(ROUTER_NAVIGATED), map((event) => event.payload.routerState));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationEventBuilder, deps: [{ token: i1$5.ActionsSubject }, { token: i1.EventService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationEventBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationEventBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$5.ActionsSubject }, { type: i1.EventService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NavigationEventModule {
    constructor(_navigationEventBuilder) {
        // Intentional empty constructor
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationEventModule, deps: [{ token: NavigationEventBuilder }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: NavigationEventModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationEventModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: NavigationEventModule, decorators: [{
            type: NgModule,
            args: [{}]
        }], ctorParameters: () => [{ type: NavigationEventBuilder }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that a user visited a product details page.
 */
class ProductDetailsPageEvent extends PageEvent {
    /** event's type */
    static { this.type = 'ProductDetailsPageEvent'; }
}
/**
 * Indicates that a user visited a category page.
 */
class CategoryPageResultsEvent extends PageEvent {
    /** event's type */
    static { this.type = 'CategoryPageResultsEvent'; }
}
/**
 * Indicates that the a user visited the search results page,
 * and that the search results have been retrieved.
 */
class SearchPageResultsEvent extends PageEvent {
    /** event's type */
    static { this.type = 'SearchPageResultsEvent'; }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductPageEventBuilder {
    constructor(eventService, productService, productSearchService) {
        this.eventService = eventService;
        this.productService = productService;
        this.productSearchService = productSearchService;
        this.register();
    }
    register() {
        this.eventService.register(SearchPageResultsEvent, this.buildSearchPageResultsEvent());
        this.eventService.register(ProductDetailsPageEvent, this.buildProductDetailsPageEvent());
        this.eventService.register(CategoryPageResultsEvent, this.buildCategoryResultsPageEvent());
    }
    buildProductDetailsPageEvent() {
        return this.eventService.get(NavigationEvent).pipe(filter((navigationEvent) => navigationEvent.semanticRoute === 'product'), switchMap$1((navigationEvent) => this.productService.get(navigationEvent.context.id).pipe(filter((product) => Boolean(product)), take(1), map((product) => createFrom(ProductDetailsPageEvent, {
            navigation: navigationEvent,
            categories: product?.categories,
            code: product?.code,
            name: product?.name,
            price: product?.price,
        })))));
    }
    buildCategoryResultsPageEvent() {
        const searchResults$ = this.productSearchService.getResults().pipe(
        // skipping the initial value, and preventing emission of the previous search state
        skip(1));
        return this.eventService.get(NavigationEvent).pipe(switchMap$1((navigationEvent) => {
            if (navigationEvent?.semanticRoute !== 'category') {
                return EMPTY;
            }
            return searchResults$.pipe(map((searchResults) => createFrom(CategoryPageResultsEvent, {
                navigation: navigationEvent,
                ...{
                    categoryCode: navigationEvent?.context?.id,
                    numberOfResults: searchResults?.pagination?.totalResults ?? 0,
                    categoryName: searchResults.breadcrumbs?.[0].facetValueName,
                },
            })));
        }));
    }
    buildSearchPageResultsEvent() {
        const searchResults$ = this.productSearchService.getResults().pipe(
        // skipping the initial value, and preventing emission of the previous search state
        skip(1));
        return this.eventService.get(NavigationEvent).pipe(switchMap$1((navigationEvent) => {
            if (navigationEvent?.semanticRoute !== 'search') {
                return EMPTY;
            }
            return searchResults$.pipe(map((searchResults) => createFrom(SearchPageResultsEvent, {
                navigation: navigationEvent,
                ...{
                    searchTerm: searchResults?.freeTextSearch ?? '',
                    numberOfResults: searchResults?.pagination?.totalResults ?? 0,
                },
            })));
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductPageEventBuilder, deps: [{ token: i1.EventService }, { token: i1.ProductService }, { token: i1.ProductSearchService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductPageEventBuilder, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductPageEventBuilder, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.EventService }, { type: i1.ProductService }, { type: i1.ProductSearchService }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductPageEventModule {
    constructor(_productPageEventBuilder) {
        // Intentional empty constructor
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductPageEventModule, deps: [{ token: ProductPageEventBuilder }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: ProductPageEventModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductPageEventModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: ProductPageEventModule, decorators: [{
            type: NgModule,
            args: [{}]
        }], ctorParameters: () => [{ type: ProductPageEventBuilder }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const mediaConfig = {
    mediaFormats: {
        mobile: { width: 400 },
        tablet: { width: 770 },
        desktop: { width: 1140 },
        widescreen: { width: 1400 },
        // product media
        cartIcon: { width: 65 },
        thumbnail: { width: 96 },
        product: { width: 284 },
        zoom: { width: 515 },
    },
    media: {
        pictureElementFormats: {
            mobile: {
                mediaQueries: '(max-width: 480px)',
            },
            tablet: {
                mediaQueries: '(max-width: 770px)',
            },
            desktop: {
                mediaQueries: '(max-width: 960px)',
            },
            widescreen: {
                mediaQueries: '(min-width: 961px)',
            },
        },
        pictureFormatsOrder: ['mobile', 'tablet', 'desktop', 'widescreen'],
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The layout configuration is used to define the overall layout of the storefront.
 * The configuration includes the following aspects:
 * - breakpoint layout (AKA screen layout)
 * - Page sections slot configuration (i.e. header vs footer)
 * - page template slot configuration (i.e. landing page template vs PDP page template)
 * - deferred loading configuration
 *
 * The page slot configurations is directly related to the data in the backend. If you use the
 * Spartacus sample-data, you will have an aligned setup. However, if you introduce custom page
 * templates and/or slots, you most likely need to further adjust or replace this configuration.
 *
 *@deprecated Use `layoutConfigFactory` and `provideConfigFactory(layoutConfigFactory)` instead.
 */
const layoutConfig = {
    // deferredLoading: {
    //   strategy: DeferLoadingStrategy.DEFER,
    //   intersectionMargin: '50px',
    // },
    layoutSlots: {
        header: {
            lg: {
                slots: [
                    'PreHeader',
                    'SiteContext',
                    'SiteLinks',
                    'SiteLogo',
                    'SearchBox',
                    'SiteLogin',
                    'MiniCart',
                    'NavigationBar',
                ],
            },
            slots: ['PreHeader', 'SiteLogo', 'SearchBox', 'MiniCart'],
        },
        navigation: {
            lg: { slots: [] },
            slots: ['SiteLogin', 'NavigationBar', 'SiteContext', 'SiteLinks'],
        },
        footer: {
            slots: ['Footer'],
        },
        LandingPage2Template: {
            pageFold: 'Section2B',
            slots: [
                'Section1',
                'Section2A',
                'Section2B',
                'Section2C',
                'Section3',
                'Section4',
                'Section5',
            ],
        },
        ContentPage1Template: {
            slots: ['Section2A', 'Section2B'],
        },
        CategoryPageTemplate: {
            pageFold: 'Section2',
            slots: ['Section1', 'Section2', 'Section3'],
        },
        ProductListPageTemplate: {
            slots: ['ProductLeftRefinements', 'ProductListSlot'],
        },
        ProductGridPageTemplate: {
            slots: ['ProductLeftRefinements', 'ProductGridSlot'],
        },
        SearchResultsListPageTemplate: {
            slots: [
                'Section2',
                'ProductLeftRefinements',
                'SearchResultsListSlot',
                'Section4',
            ],
        },
        SearchResultsGridPageTemplate: {
            slots: [
                'Section2',
                'ProductLeftRefinements',
                'SearchResultsGridSlot',
                'Section4',
            ],
        },
        ProductDetailsPageTemplate: {
            lg: {
                pageFold: 'UpSelling',
            },
            pageFold: 'Summary',
            slots: [
                'Summary',
                'UpSelling',
                'CrossSelling',
                'Tabs',
                'PlaceholderContentSlot',
            ],
        },
        CartPageTemplate: {
            slots: ['TopContent', 'CenterRightContentSlot', 'EmptyCartMiddleContent'],
        },
        AccountPageTemplate: {
            slots: ['BodyContent', 'SideContent'],
        },
        LoginPageTemplate: {
            slots: ['LeftContentSlot', 'RightContentSlot'],
        },
        ErrorPageTemplate: {
            slots: ['TopContent', 'MiddleContent', 'BottomContent'],
        },
        OrderConfirmationPageTemplate: {
            slots: ['BodyContent', 'SideContent'],
        },
        MultiStepCheckoutSummaryPageTemplate: {
            slots: ['TopContent', 'BodyContent', 'SideContent', 'BottomContent'],
        },
        CheckoutLoginPageTemplate: {
            slots: ['RightContentSlot'],
        },
        MyAccountViewPageTemplate: {
            slots: ['LeftContentSlot', 'RightContentSlot'],
        },
    },
};
/**
 * Factory for layout configuration.
 */
function layoutConfigFactory() {
    const config = JSON.parse(JSON.stringify(layoutConfig));
    const featureToggles = inject(FeatureToggles);
    if (featureToggles.unifiedDefaultHeaderSlotsAcrossBreakpoints &&
        config.layoutSlots &&
        config.layoutSlots.header &&
        'slots' in config.layoutSlots.header) {
        if ('lg' in config.layoutSlots.header) {
            delete config.layoutSlots.header.lg;
        }
        config.layoutSlots.header.slots = [
            'PreHeader',
            'SiteContext',
            'SiteLinks',
            'SiteLogo',
            'SearchBox',
            'SiteLogin',
            'MiniCart',
            'NavigationBar',
        ];
    }
    if (featureToggles.defaultLayoutConfigWithoutPageFold) {
        const homepageConfig = config?.layoutSlots?.LandingPage2Template ?? {};
        delete homepageConfig.pageFold;
        const categoryPageConfig = config?.layoutSlots?.CategoryPageTemplate ?? {};
        delete categoryPageConfig.pageFold;
        const productDetailsPageConfig = config?.layoutSlots?.ProductDetailsPageTemplate ?? {};
        delete productDetailsPageConfig.pageFold;
        delete (productDetailsPageConfig.lg ?? {}).pageFold;
    }
    return config;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCmsContentProviders = [
    provideCmsStructure({
        componentId: 'HamburgerMenuComponent',
        pageSlotPosition: 'PreHeader',
    }),
    provideCmsStructure({
        componentId: 'LoginComponent',
        pageSlotPosition: 'SiteLogin',
    }),
];

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultOnNavigateConfig = {
    enableResetViewOnNavigate: {
        active: true,
        ignoreQueryString: false,
        ignoreRoutes: [],
        selectedHostElement: 'body',
    },
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OnNavigateConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OnNavigateConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OnNavigateConfig, providedIn: 'root', useExisting: Config }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OnNavigateConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                    useExisting: Config,
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OnNavigateService {
    get hostComponent() {
        return this.injector.get(ApplicationRef)?.components?.[0];
    }
    get selectedHostElement() {
        const toSelect = this.config?.enableResetViewOnNavigate?.selectedHostElement;
        return toSelect
            ? (this.injector.get(DOCUMENT)?.getElementsByTagName?.(toSelect)?.[0])
            : undefined;
    }
    constructor(config, router, viewportScroller, injector) {
        this.config = config;
        this.router = router;
        this.viewportScroller = viewportScroller;
        this.injector = injector;
        this.routerConfiguration = inject(ROUTER_CONFIGURATION, { optional: true }) || {};
    }
    /**
     * Reads configuration and enables features based on flags set.
     */
    initializeWithConfig() {
        if (this.config?.enableResetViewOnNavigate?.active) {
            this.setResetViewOnNavigate(this.config.enableResetViewOnNavigate.active);
        }
    }
    /**
     * Resets view back to the original position when performing a back navigation and to the top when performing a front navigation
     * and sets the focus back to the top of the page before skiplinks for any type of navigation
     * @param enable Enable or disable this feature
     */
    setResetViewOnNavigate(enable) {
        this.subscription?.unsubscribe();
        if (enable) {
            // Disable automatic scroll restoration to avoid race conditions
            this.viewportScroller.setHistoryScrollRestoration('manual');
            this.subscription = this.router.events
                .pipe(filter((event) => event instanceof Scroll), pairwise())
                .subscribe((event) => {
                const previousRoute = event[0];
                const currentRoute = event[1];
                const position = currentRoute.position;
                if (position) {
                    // allow the pages to be repainted before scrolling to proper position
                    this.scrollToPosition(currentRoute, position);
                }
                else {
                    if (this.config.enableResetViewOnNavigate?.ignoreQueryString &&
                        this.isPathEqual(previousRoute, currentRoute)) {
                        return;
                    }
                    if (this.isChildRoute(currentRoute)) {
                        return;
                    }
                    this.scrollToPosition(currentRoute, position);
                }
                this.focusOnHostElement();
            });
        }
    }
    /**
     * Focus on selectedHostElement if set in config.
     * Otherwise, focuses on hostComponent.
     */
    focusOnHostElement() {
        if (this.selectedHostElement) {
            this.selectedHostElement?.focus();
        }
        else {
            this.hostComponent?.location?.nativeElement.focus();
        }
    }
    /**
     * Scrolls to a specified position or anchor based on the current route and configuration.
     * @param currentRoute The current route containing scroll information.
     * @param position The target scroll position as [x, y] coordinates, or null.
     */
    scrollToPosition(currentRoute, position) {
        const scrollTo = (anchor, scrollPosition) => {
            if (anchor && this.routerConfiguration.anchorScrolling === 'enabled') {
                this.viewportScroller.scrollToAnchor(anchor);
            }
            else {
                this.viewportScroller.scrollToPosition(scrollPosition);
            }
        };
        const defaultPosition = [0, 0];
        setTimeout(() => {
            const anchor = currentRoute.anchor;
            const positionToScroll = position || defaultPosition;
            scrollTo(anchor, positionToScroll);
        }, position ? 0 : 100);
    }
    /**
     * Verifies if the current route is a child route from the given ignore config route
     *
     * @param route
     * @returns boolean whether the route is a child route
     */
    isChildRoute(route) {
        return (this.config.enableResetViewOnNavigate?.ignoreRoutes?.some((configRoute) => this.isNavigationEnd(route.routerEvent) &&
            route.routerEvent.urlAfterRedirects.split('/').includes(configRoute)) ?? false);
    }
    /**
     * Verifies if the previous and current route are the same without the query string
     *
     * @param previousRoute
     * @param currentRoute
     * @returns boolean depending on the previous and current route are equal without the query strings
     */
    isPathEqual(previousRoute, currentRoute) {
        if (!this.isNavigationEnd(previousRoute.routerEvent) ||
            !this.isNavigationEnd(currentRoute.routerEvent)) {
            return false;
        }
        return (previousRoute.routerEvent.urlAfterRedirects.split('?')[0] ===
            currentRoute.routerEvent.urlAfterRedirects.split('?')[0]);
    }
    /**
     * Verifies if router event is a navigation end event
     * @private
     */
    isNavigationEnd(event) {
        return event.type === EventType.NavigationEnd;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OnNavigateService, deps: [{ token: OnNavigateConfig }, { token: i1$2.Router }, { token: i3.ViewportScroller }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OnNavigateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: OnNavigateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: OnNavigateConfig }, { type: i1$2.Router }, { type: i3.ViewportScroller }, { type: i0.Injector }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AppRoutingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AppRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: AppRoutingModule, imports: [i1$2.RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AppRoutingModule, providers: [
            provideDefaultConfig(defaultOnNavigateConfig),
            {
                provide: APP_INITIALIZER,
                useFactory: onNavigateFactory,
                deps: [OnNavigateService],
                multi: true,
            },
        ], imports: [RouterModule.forRoot([], {
                anchorScrolling: 'enabled',
                initialNavigation: 'enabledBlocking',
            })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: AppRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        RouterModule.forRoot([], {
                            anchorScrolling: 'enabled',
                            initialNavigation: 'enabledBlocking',
                        }),
                    ],
                    providers: [
                        provideDefaultConfig(defaultOnNavigateConfig),
                        {
                            provide: APP_INITIALIZER,
                            useFactory: onNavigateFactory,
                            deps: [OnNavigateService],
                            multi: true,
                        },
                    ],
                }]
        }] });
function onNavigateFactory(onNavigateService) {
    const isReady = () => onNavigateService.initializeWithConfig();
    return isReady;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Utils for Angular forms
 */
var FormUtils;
(function (FormUtils) {
    /**
     * Calls the native Angular method `#updateValueAndValidity` for the given from control
     * and all its descendants (in case when it's `FormGroup` or `FormArray`).
     *
     * In particular it's useful for triggering re-emission of observables
     * `valueChanges` and `statusChanges` for all descendant form controls.
     *
     * _Note: Dropping this function may be considered, when it's implemented natively
     * by Angular. See https://github.com/angular/angular/issues/6170_
     *
     * @param control form control
     * @param options additional options
     * * `emitEvent`: When true or not given (the default), the `statusChanges` and
     * `valueChanges` observables emit the latest status and value. When false,
     * it doesn't trigger observables emission.
     */
    function deepUpdateValueAndValidity(control, options = {}) {
        if (control instanceof UntypedFormGroup ||
            control instanceof UntypedFormArray) {
            Object.values(control.controls).forEach((childControl) => {
                deepUpdateValueAndValidity(childControl, options);
            });
        }
        control.updateValueAndValidity({
            onlySelf: true, // avoid calling `#updateValueAndValidity` for all ancestors
            emitEvent: options.emitEvent,
        });
    }
    FormUtils.deepUpdateValueAndValidity = deepUpdateValueAndValidity;
})(FormUtils || (FormUtils = {}));

/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Get strings for phone and mobile numbers
 */
function getAddressNumbers(address, textPhone, textMobile) {
    if (address.cellphone && address.phone) {
        if (address.cellphone === address.phone) {
            return textMobile + ': ' + address.cellphone;
        }
        return `${textPhone}: ${address.phone}\n${textMobile}: ${address.cellphone}`;
    }
    if (address.cellphone) {
        return textMobile + ': ' + address.cellphone;
    }
    if (address.phone) {
        return textPhone + ': ' + address.phone;
    }
    return undefined;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BaseStorefrontModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BaseStorefrontModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.3", ngImport: i0, type: BaseStorefrontModule, imports: [i1.BaseCoreModule, RouterModule,
            GlobalMessageComponentModule,
            OutletModule,
            OutletRefModule,
            PwaModule,
            PageLayoutModule,
            SeoModule, PageComponentModule, PageSlotModule,
            SkipLinkModule,
            KeyboardFocusModule,
            LayoutModule, RoutingModule, MediaModule, OutletModule, CmsLcpModule, StorefrontComponentModule], exports: [LayoutModule, StorefrontComponentModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BaseStorefrontModule, imports: [BaseCoreModule.forRoot(),
            RouterModule,
            GlobalMessageComponentModule,
            OutletModule,
            OutletRefModule,
            PwaModule,
            PageLayoutModule,
            SeoModule,
            PageComponentModule.forRoot(),
            PageSlotModule,
            SkipLinkModule,
            KeyboardFocusModule,
            LayoutModule,
            RoutingModule.forRoot(),
            MediaModule.forRoot(),
            OutletModule.forRoot(),
            CmsLcpModule.forRoot(),
            StorefrontComponentModule, LayoutModule, StorefrontComponentModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.3", ngImport: i0, type: BaseStorefrontModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        BaseCoreModule.forRoot(),
                        RouterModule,
                        GlobalMessageComponentModule,
                        OutletModule,
                        OutletRefModule,
                        PwaModule,
                        PageLayoutModule,
                        SeoModule,
                        PageComponentModule.forRoot(),
                        PageSlotModule,
                        SkipLinkModule,
                        KeyboardFocusModule,
                        LayoutModule,
                        RoutingModule.forRoot(),
                        MediaModule.forRoot(),
                        OutletModule.forRoot(),
                        CmsLcpModule.forRoot(),
                        StorefrontComponentModule,
                    ],
                    exports: [LayoutModule, StorefrontComponentModule],
                }]
        }] });

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Public API Surface of storefrontlib
 */
/** AUGMENTABLE_TYPES_END */

/**
 * Generated bundle index. Do not edit.
 */

export { AVOID_STACKED_OUTLETS, ActiveFacetsComponent, ActiveFacetsModule, AddToHomeScreenBannerComponent, AddToHomeScreenBtnComponent, AddToHomeScreenComponent, AddToHomeScreenService, AnonymousConsentDialogComponent, AnonymousConsentManagementBannerComponent, AnonymousConsentManagementBannerModule, AnonymousConsentOpenDialogComponent, AnonymousConsentsDialogModule, AppRoutingModule, AtMessageDirective, AtMessageModule, AvatarComponent, BEFORE_CMS_PAGE_GUARD, BREAKPOINT, BannerCarouselComponent, BannerCarouselModule, BannerComponent, BannerModule, BaseStorefrontModule, BeforeCmsPageGuardService, BreadcrumbComponent, BreadcrumbModule, BreadcrumbSchemaBuilder, BreakpointService, BtnLikeLinkDirective, BtnLikeLinkModule, CaptchaApiConfig, CaptchaComponent, CaptchaModule, CaptchaService, CardComponent, CardModule, CarouselComponent, CarouselModule, CarouselScrollingComponent, CarouselScrollingModule, CarouselService, CategoryNavigationComponent, CategoryNavigationModule, CategoryPageResultsEvent, ChatMessagingModule, ClaimDialogComponent, CmsComponentData, CmsComponentsService, CmsFeaturesService, CmsGuardsService, CmsI18nService, CmsInjectorService, CmsLcpModule, CmsLcpService, CmsPageGuard, CmsPageGuardService, CmsParagraphModule, CmsRouteModule, CmsRoutesService, ComponentCreateEvent, ComponentDestroyEvent, ComponentEvent, ComponentHandler, ComponentHandlerService, ComponentWrapperDirective, ConsentManagementComponent, ConsentManagementComponentService, ConsentManagementFormComponent, ConsentManagementModule, ContextService, CouponCardComponent, CouponClaimComponent, CouponDialogComponent, CurrentProductService, CustomFormValidators, DIALOG_TYPE, DatePickerComponent, DatePickerModule, DatePickerService, DefaultComponentHandler, DeferLoaderService, DirectionConfig, DirectionMode, DirectionModule, DirectionService, DomChangeDirective, DomChangeModule, ExportCsvFileService, FacetComponent, FacetGroupCollapsedState, FacetListComponent, FacetListModule, FacetModule, FacetService, FileDownloadService, FileReaderService, FileUploadComponent, FileUploadModule, FilesFormValidators, FocusDirective, FocusableCarouselItemDirective, FooterNavigationComponent, FooterNavigationModule, FormConfig, FormErrorsComponent, FormErrorsModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, FormUtils, GenericLinkComponent, GenericLinkComponentService, GenericLinkModule, GlobalMessageComponent, GlobalMessageComponentModule, HamburgerMenuComponent, HamburgerMenuModule, HamburgerMenuService, HighlightPipe, HomePageEvent, HomePageEventBuilder, HomePageEventModule, HorizontalScrollingPositionDirective, HorizontalScrollingPositionDirectiveModule, ICON_TYPE, IS_GUEST_USER_CHECKOUT_KEY, IconComponent, IconConfig, IconLoaderService, IconModule, IconResourceType, IconTestingModule, ImageFetchPriority, ImageLoadingStrategy, ImportCsvFileService, InlineRenderStrategy, InlineRootRenderStrategy, InnerComponentsHostDirective, IntersectionService, ItemCounterComponent, ItemCounterModule, JSONLD_PRODUCT_BUILDER, JsonLdBaseProductBuilder, JsonLdBuilderModule, JsonLdDirective, JsonLdProductOfferBuilder, JsonLdProductReviewBuilder, JsonLdScriptFactory, KeyboardFocusModule, KeyboardFocusService, KeyboardFocusTestingModule, LAUNCH_CALLER, LCP_PRESENCE, LanguageCurrencyComponent, LaunchDialogModule, LaunchDialogService, LaunchRenderStrategy, LayoutConfig, LayoutModule, LazyComponentHandler, LcpCmsComponentsConfig, LcpContextDirective, LcpContextDirectiveModule, LcpPresence, LcpPresenceMappingService, LinkComponent, LinkModule, ListNavigationModule, LoginGuard, LoginRouteModule, LogoutGuard, LogoutModule, MediaComponent, MediaConfig, MediaModule, MediaPreconnectService, MediaService, MediaSourcesPipe, MessageComponent, MessageComponentModule, MessagingComponent, MockIconComponent, MockIconLoaderService, MockKeyboardFocusDirective, MyAccountV2ConsentManagementComponent, MyAccountV2ConsentManagementFormComponent, MyAccountV2ConsentManagementModule, MyAccountV2Module, MyAccountV2NavigationComponent, MyAccountV2NavigationModule, MyAccountV2NotificationPreferenceComponent, MyAccountV2NotificationPreferenceModule, MyCouponsComponent, MyCouponsComponentService, MyCouponsModule, MyInterestsComponent, MyInterestsModule, NavigationComponent, NavigationEvent, NavigationEventBuilder, NavigationEventModule, NavigationModule, NavigationService, NavigationUIComponent, NgSelectA11yDirective, NgSelectA11yModule, NotificationPreferenceComponent, NotificationPreferenceModule, OnNavigateConfig, OnNavigateService, OutletContextData, OutletDirective, OutletModule, OutletPosition, OutletRefDirective, OutletRefModule, OutletRenderStrategy, OutletRendererService, OutletService, PAGE_LAYOUT_HANDLER, PDFComponent, PDFModule, PRODUCT_DETAILS_URL_MATCHER, PRODUCT_LISTING_URL_MATCHER, PWAModuleConfig, PageComponentModule, PageEvent, PageLayoutComponent, PageLayoutModule, PageLayoutService, PageMetaLinkService, PageSection, PageSlotComponent, PageSlotModule, PageSlotService, PageTemplateDirective, PageTitleComponent, PageTitleModule, PaginationBuilder, PaginationComponent, PaginationConfig, PaginationItemType, PaginationModule, PaginationNavigationPosition, ParagraphComponent, PasswordVisibilityToggleComponent, PasswordVisibilityToggleDirective, PasswordVisibilityToggleModule, PaymentMethodsComponent, PaymentMethodsModule, PopoverComponent, PopoverDirective, PopoverEvent, PopoverModule, PopoverService, PositioningService, ProductAttributesComponent, ProductAttributesModule, ProductCarouselComponent, ProductCarouselItemComponent, ProductCarouselModule, ProductCarouselService, ProductDetailOutlets, ProductDetailsPageEvent, ProductDetailsPageModule, ProductDetailsTabComponent, ProductDetailsTabModule, ProductFacetNavigationComponent, ProductFacetNavigationModule, ProductFacetService, ProductGridItemComponent, ProductImagesComponent, ProductImagesModule, ProductIntroComponent, ProductIntroModule, ProductListComponent, ProductListComponentService, ProductListItemComponent, ProductListItemContext, ProductListItemContextSource, ProductListModule, ProductListOutlets, ProductListingPageModule, ProductPageEventBuilder, ProductPageEventModule, ProductReferencesComponent, ProductReferencesModule, ProductReviewsComponent, ProductReviewsModule, ProductSchemaBuilder, ProductScrollComponent, ProductSummaryComponent, ProductSummaryModule, ProductTabsModule, ProductViewComponent, ProgressButtonComponent, ProgressButtonModule, PromotionsComponent, PromotionsModule, ProvideLcpPresenceDirective, ProvideLcpPresenceDirectiveModule, PwaModule, ReadMoreComponent, RoutingContextService, RoutingModule, RoutingRenderStrategy, SCHEMA_BUILDER, ScrollToTopComponent, ScrollToTopModule, SearchBoxComponent, SearchBoxComponentService, SearchBoxModule, SearchBoxOutlets, SearchBoxProductSelectedEvent, SearchBoxSuggestionSelectedEvent, SearchPageResultsEvent, SelectFocusUtility, SeoConfig, SeoMetaService, SeoModule, SiteContextComponentService, SiteContextSelectorComponent, SiteContextSelectorModule, SiteContextType, SiteThemeSwitcherComponent, SiteThemeSwitcherModule, SkipFocusDirective, SkipLink, SkipLinkComponent, SkipLinkConfig, SkipLinkDirective, SkipLinkModule, SkipLinkScrollPosition, SkipLinkService, SortingComponent, SortingModule, SpinnerComponent, SpinnerModule, SplitViewComponent, SplitViewModule, SplitViewService, StarRatingComponent, StarRatingModule, StockNotificationComponent, StockNotificationDialogComponent, StockNotificationModule, StorefrontComponent, StorefrontComponentModule, StorefrontOutlets, StructuredDataModule, SupplementHashAnchorsModule, SupplementHashAnchorsPipe, TAB_MODE, TabComponent, TabModule, TabPanelComponent, TabParagraphContainerComponent, TabParagraphContainerModule, TableComponent, TableConfig, TableDataCellComponent, TableDataCellModule, TableHeaderCellComponent, TableHeaderCellModule, TableLayout, TableModule, TableRendererService, TableService, ThemeModule, ThemeService, TotalComponent, TotalModule, TrapFocus, TruncatePipe, TruncateTextPopoverComponent, TruncateTextPopoverModule, USE_LEGACY_MEDIA_COMPONENT, USE_MY_ACCOUNT_V2_CONSENT, USE_MY_ACCOUNT_V2_NOTIFICATION_PREFERENCE, USE_STACKED_OUTLETS, UserComponentModule, VideoComponent, VideoModule, ViewComponent, ViewConfig, ViewModes, controlsMustMatch, defaultCmsContentProviders, defaultLayoutConfig, defaultOnNavigateConfig, defaultPWAModuleConfig, defaultPaginationConfig, defaultSeoConfig, defaultSkipLinkConfig, defaultTableConfig, defaultViewConfig, disableTabbingForTick, fontawesomeIconConfig, getAddressNumbers, getSuffixUrlMatcher, initSeoService, layoutConfig, layoutConfigFactory, mediaConfig, mediaPreconnectInitializer, onNavigateFactory, provideCmsStructure, provideLcpPresenceForCmsComponent, provideOutlet, sortTitles, titleScores };
